var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/airports.ts
import _ from "lodash";
var airports = {
  AAA: {
    iata: "AAA",
    name: "Anaa Airport",
    city: "Anaa",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -17.355648,
    longitude: -145.50913,
    icao: "NTGA"
  },
  AAB: {
    iata: "AAB",
    name: "Arrabury Airport",
    city: "Arrabury",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -26.691196,
    longitude: 141.047509,
    icao: "YARY"
  },
  AAC: {
    iata: "AAC",
    name: "El Arish International Airport",
    city: "El Arish",
    countryId: "EG",
    timeZoneRegionName: "Africa/Cairo",
    latitude: 31.076415,
    longitude: 33.832288,
    icao: "HEAR"
  },
  AAE: {
    iata: "AAE",
    name: "Rabah Bitat Airport",
    city: "Annaba",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 36.821392,
    longitude: 7.811857,
    icao: "DABB"
  },
  AAF: {
    iata: "AAF",
    name: "Apalachicola Municipal Airport",
    city: "Apalachicola",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 29.733333,
    longitude: -84.983333,
    icao: "KAAF"
  },
  AAH: {
    iata: "AAH",
    name: "Aachen/Merzbruck Airport",
    city: "Aachen",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 50.823055,
    longitude: 6.186389,
    icao: "EDKA"
  },
  AAI: {
    iata: "AAI",
    name: "Arraias Airport",
    city: "Arraias",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -12.916667,
    longitude: -46.933333,
    icao: "SWRA"
  },
  AAK: {
    iata: "AAK",
    name: "Aranuka Airport",
    city: "Aranuka",
    countryId: "KI",
    timeZoneRegionName: "Pacific/Tarawa",
    latitude: 0.166667,
    longitude: 173.583333,
    icao: "NGUK"
  },
  AAL: {
    iata: "AAL",
    name: "Aalborg Airport",
    city: "Aalborg",
    countryId: "DK",
    timeZoneRegionName: "Europe/Copenhagen",
    latitude: 57.086551,
    longitude: 9.872241,
    icao: "EKYT"
  },
  AAM: {
    iata: "AAM",
    name: "Mala Mala Airport",
    city: "Mala Mala",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -24.8,
    longitude: 31.533333,
    icao: "FAMD"
  },
  AAN: {
    iata: "AAN",
    name: "Al Ain Airport",
    city: "Al Ain",
    countryId: "AE",
    timeZoneRegionName: "Asia/Dubai",
    latitude: 24.260231,
    longitude: 55.616626,
    icao: "OMAL"
  },
  AAO: {
    iata: "AAO",
    name: "Anaco Airport",
    city: "Anaco",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 9.431944,
    longitude: -64.463889,
    icao: "SVAN"
  },
  AAP: {
    iata: "AAP",
    name: "Aji Pangeran Tumenggung Pranoto Airport",
    city: "Samarinda",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -0.484531,
    longitude: 117.157,
    icao: "WALS"
  },
  AAQ: {
    iata: "AAQ",
    name: "Anapa Airport",
    city: "Anapa",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 45.001659,
    longitude: 37.346599,
    icao: "URKA"
  },
  AAR: {
    iata: "AAR",
    name: "Aarhus Airport",
    city: "Aarhus",
    countryId: "DK",
    timeZoneRegionName: "Europe/Copenhagen",
    latitude: 56.30823,
    longitude: 10.626351,
    icao: "EKAH"
  },
  AAT: {
    iata: "AAT",
    name: "Altay Airport",
    city: "Altay",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 47.750361,
    longitude: 88.084444,
    icao: "ZWAT"
  },
  AAV: {
    iata: "AAV",
    name: "Allah Valley Airport",
    city: "Surallah",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 6.367314,
    longitude: 124.752781,
    icao: "RPMA"
  },
  AAX: {
    iata: "AAX",
    name: "Araxa Airport",
    city: "Araxa",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -19.568056,
    longitude: -46.929167,
    icao: "SBAX"
  },
  AAY: {
    iata: "AAY",
    name: "Al Ghaydah Airport",
    city: "Al Ghaydah",
    countryId: "YE",
    timeZoneRegionName: "Asia/Aden",
    latitude: 16.195959,
    longitude: 52.173255,
    icao: "OYGD"
  },
  ABA: {
    iata: "ABA",
    name: "Abakan Airport",
    city: "Abakan",
    countryId: "RU",
    timeZoneRegionName: "Asia/Krasnoyarsk",
    latitude: 53.740002,
    longitude: 91.385002,
    icao: "UNAA"
  },
  ABB: {
    iata: "ABB",
    name: "Asaba International Airport",
    city: "Asaba",
    countryId: "NG",
    timeZoneRegionName: "Africa/Lagos",
    latitude: 6.203055,
    longitude: 6.667222,
    icao: "DNAS"
  },
  ABC: {
    iata: "ABC",
    name: "Albacete Airport",
    city: "Albacete",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 38.948333,
    longitude: -1.863333,
    icao: "LEAB"
  },
  ABD: {
    iata: "ABD",
    name: "Abadan Airport",
    city: "Abadan",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 30.363905,
    longitude: 48.226598,
    icao: "OIAA"
  },
  ABE: {
    iata: "ABE",
    name: "Lehigh Valley International Airport",
    city: "Allentown",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.651573,
    longitude: -75.434366,
    icao: "KABE"
  },
  ABF: {
    iata: "ABF",
    name: "Abaiang Airport",
    city: "Abaiang",
    countryId: "KI",
    timeZoneRegionName: "Pacific/Tarawa",
    latitude: 1.670833,
    longitude: 173.304167,
    icao: "NGAB"
  },
  ABH: {
    iata: "ABH",
    name: "Alpha Airport",
    city: "Alpha",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -23.65,
    longitude: 146.633333,
    icao: "YAPH"
  },
  ABI: {
    iata: "ABI",
    name: "Abilene Regional Airport",
    city: "Abilene",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.412843,
    longitude: -99.680052,
    icao: "KABI"
  },
  ABJ: {
    iata: "ABJ",
    name: "Felix Houphouet Boigny Airport",
    city: "Abidjan",
    countryId: "CI",
    timeZoneRegionName: "Africa/Abidjan",
    latitude: 5.254879,
    longitude: -3.933015,
    icao: "DIAP"
  },
  ABK: {
    iata: "ABK",
    name: "Kabri Dar Airport",
    city: "Kabri Dar",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 6.733207,
    longitude: 44.249676,
    icao: "HAKD"
  },
  ABL: {
    iata: "ABL",
    name: "Ambler Airport",
    city: "Ambler",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 67.0875,
    longitude: -157.845833,
    icao: "PAFM"
  },
  ABM: {
    iata: "ABM",
    name: "Northern Peninsula Airport",
    city: "Bamaga",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -10.942619,
    longitude: 142.450334,
    icao: "YNEP"
  },
  ABO: {
    iata: "ABO",
    name: "Aboisso Airport",
    city: "Aboisso",
    countryId: "CI",
    timeZoneRegionName: "Africa/Abidjan",
    latitude: 5.433333,
    longitude: -3.216667,
    icao: "DIAO"
  },
  ABQ: {
    iata: "ABQ",
    name: "Albuquerque International Sunport",
    city: "Albuquerque",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 35.049625,
    longitude: -106.617193,
    icao: "KABQ"
  },
  ABR: {
    iata: "ABR",
    name: "Aberdeen Regional Airport",
    city: "Aberdeen",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 45.44906,
    longitude: -98.421829,
    icao: "KABR"
  },
  ABS: {
    iata: "ABS",
    name: "Abu Simbel Airport",
    city: "Abu Simbel",
    countryId: "EG",
    timeZoneRegionName: "Africa/Cairo",
    latitude: 22.367567,
    longitude: 31.609773,
    icao: "HEBL"
  },
  ABT: {
    iata: "ABT",
    name: "Al-Aqiq Airport",
    city: "Al-Baha",
    countryId: "SA",
    timeZoneRegionName: "Asia/Riyadh",
    latitude: 20.294011,
    longitude: 41.64002,
    icao: "OEBA"
  },
  ABU: {
    iata: "ABU",
    name: "Haliwen Airport",
    city: "Atambua",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -9.075208,
    longitude: 124.906972,
    icao: "WATA"
  },
  ABV: {
    iata: "ABV",
    name: "Nnamdi Azikiwe International Airport",
    city: "Abuja",
    countryId: "NG",
    timeZoneRegionName: "Africa/Lagos",
    latitude: 9.004614,
    longitude: 7.270447,
    icao: "DNAA"
  },
  ABX: {
    iata: "ABX",
    name: "Albury Airport",
    city: "Albury",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -36.069625,
    longitude: 146.954531,
    icao: "YMAY"
  },
  ABY: {
    iata: "ABY",
    name: "Southwest Georgia Regional Airport",
    city: "Albany",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 31.532222,
    longitude: -84.196111,
    icao: "KABY"
  },
  ABZ: {
    iata: "ABZ",
    name: "Aberdeen International Airport",
    city: "Aberdeen",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 57.200253,
    longitude: -2.204186,
    icao: "EGPD"
  },
  ACA: {
    iata: "ACA",
    name: "Acapulco International Airport",
    city: "Acapulco",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 16.762403,
    longitude: -99.754592,
    icao: "MMAA"
  },
  ACB: {
    iata: "ACB",
    name: "Antrim County Airport",
    city: "Bellaire",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 44.983333,
    longitude: -85.216667,
    icao: "KACB"
  },
  ACC: {
    iata: "ACC",
    name: "Kotoka International Airport",
    city: "Accra",
    countryId: "GH",
    timeZoneRegionName: "Africa/Accra",
    latitude: 5.60737,
    longitude: -0.171769,
    icao: "DGAA"
  },
  ACD: {
    iata: "ACD",
    name: "Alcides Fernandez Airport",
    city: "Acandi",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 8.516667,
    longitude: -77.3,
    icao: "SKAD"
  },
  ACE: {
    iata: "ACE",
    name: "Lanzarote Airport",
    city: "Lanzarote",
    countryId: "ES",
    timeZoneRegionName: "Atlantic/Canary",
    latitude: 28.950668,
    longitude: -13.609059,
    icao: "GCRR"
  },
  ACF: {
    iata: "ACF",
    name: "Alaer Talimu Airport",
    city: "Alaer",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 40.435556,
    longitude: 81.263889,
    icao: ""
  },
  ACH: {
    iata: "ACH",
    name: "Altenrhein Airport",
    city: "Altenrhein",
    countryId: "CH",
    timeZoneRegionName: "Europe/Zurich",
    latitude: 47.483333,
    longitude: 9.566667,
    icao: "LSZR"
  },
  ACI: {
    iata: "ACI",
    name: "Alderney Airport",
    city: "Alderney",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 49.706717,
    longitude: -2.21531,
    icao: "EGJA"
  },
  ACK: {
    iata: "ACK",
    name: "Nantucket Memorial Airport",
    city: "Nantucket",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.256667,
    longitude: -70.059722,
    icao: "KACK"
  },
  ACN: {
    iata: "ACN",
    name: "Ciudad Acuna International Airport",
    city: "Ciudad Acuna",
    countryId: "MX",
    timeZoneRegionName: "America/Matamoros",
    latitude: 29.332855,
    longitude: -101.099371,
    icao: "MMCC"
  },
  ACO: {
    iata: "ACO",
    name: "Cobano Airport",
    city: "Cobano",
    countryId: "CR",
    timeZoneRegionName: "America/Costa_Rica",
    latitude: 9.6919,
    longitude: -85.0964,
    icao: ""
  },
  ACR: {
    iata: "ACR",
    name: "Araracuara Airport",
    city: "Araracuara",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: -0.600268,
    longitude: -72.399498,
    icao: "SKAC"
  },
  ACT: {
    iata: "ACT",
    name: "Waco Municipal Airport",
    city: "Waco",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 31.609132,
    longitude: -97.223217,
    icao: "KACT"
  },
  ACV: {
    iata: "ACV",
    name: "Arcata-Eureka Airport",
    city: "Arcata",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 40.970912,
    longitude: -124.106929,
    icao: "KACV"
  },
  ACX: {
    iata: "ACX",
    name: "Xingyi Wanfenglin Airport",
    city: "Xingyi",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 25.085556,
    longitude: 104.959444,
    icao: "ZUYI"
  },
  ACY: {
    iata: "ACY",
    name: "Atlantic City International Airport",
    city: "Atlantic City",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.450701,
    longitude: -74.572233,
    icao: "KACY"
  },
  ACZ: {
    iata: "ACZ",
    name: "Zabol Airport",
    city: "Zabol",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 31.087694,
    longitude: 61.542245,
    icao: "OIZB"
  },
  ADA: {
    iata: "ADA",
    name: "Adana Sakirpasa Airport",
    city: "Adana",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 36.982185,
    longitude: 35.280391,
    icao: "LTAF"
  },
  ADB: {
    iata: "ADB",
    name: "Izmir Adnan Menderes Airport",
    city: "Izmir",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 38.294403,
    longitude: 27.147594,
    icao: "LTBJ"
  },
  ADD: {
    iata: "ADD",
    name: "Addis Ababa Bole International Airport",
    city: "Addis Ababa",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 8.983759,
    longitude: 38.795899,
    icao: "HAAB"
  },
  ADE: {
    iata: "ADE",
    name: "Aden International Airport",
    city: "Aden",
    countryId: "YE",
    timeZoneRegionName: "Asia/Aden",
    latitude: 12.826116,
    longitude: 45.037535,
    icao: "OYAA"
  },
  ADF: {
    iata: "ADF",
    name: "Adiyaman Airport",
    city: "Adiyaman",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 37.75,
    longitude: 38.266667,
    icao: "LTCP"
  },
  ADG: {
    iata: "ADG",
    name: "Lenawee County Airport",
    city: "Adrian",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.9,
    longitude: -84.033333,
    icao: "KADG"
  },
  ADI: {
    iata: "ADI",
    name: "Arandis Airport",
    city: "Arandis",
    countryId: "NA",
    timeZoneRegionName: "Africa/Windhoek",
    latitude: -22.4,
    longitude: 15,
    icao: "FYAR"
  },
  ADJ: {
    iata: "ADJ",
    name: "Marka International Airport",
    city: "Amman",
    countryId: "JO",
    timeZoneRegionName: "Asia/Amman",
    latitude: 31.97533,
    longitude: 35.98277,
    icao: "OJAM"
  },
  ADK: {
    iata: "ADK",
    name: "Adak Island Naval Station",
    city: "Adak Island",
    countryId: "US",
    timeZoneRegionName: "America/Adak",
    latitude: 51.882778,
    longitude: -176.644722,
    icao: "PADK"
  },
  ADL: {
    iata: "ADL",
    name: "Adelaide Airport",
    city: "Adelaide",
    countryId: "AU",
    timeZoneRegionName: "Australia/Adelaide",
    latitude: -34.938176,
    longitude: 138.537351,
    icao: "YPAD"
  },
  ADM: {
    iata: "ADM",
    name: "Ardmore Municipal Airport",
    city: "Ardmore",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 34.303056,
    longitude: -97.019444,
    icao: "KADM"
  },
  ADO: {
    iata: "ADO",
    name: "Andamooka Airport",
    city: "Andamooka",
    countryId: "AU",
    timeZoneRegionName: "Australia/Adelaide",
    latitude: -31.016667,
    longitude: 137.15,
    icao: "YAMK"
  },
  ADP: {
    iata: "ADP",
    name: "Ampara Airport",
    city: "Gal Oya",
    countryId: "LK",
    timeZoneRegionName: "Asia/Colombo",
    latitude: 7.338118,
    longitude: 81.626701,
    icao: "VCCG"
  },
  ADQ: {
    iata: "ADQ",
    name: "Kodiak Benny Benson State Airport",
    city: "Kodiak",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 57.753887,
    longitude: -152.514408,
    icao: "PADQ"
  },
  ADR: {
    iata: "ADR",
    name: "Andrews Airport",
    city: "Andrews",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 33.45,
    longitude: -79.566667,
    icao: "KPHH"
  },
  ADS: {
    iata: "ADS",
    name: "Addison Airport",
    city: "Dallas",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.966626,
    longitude: -96.842922,
    icao: "KADS"
  },
  ADT: {
    iata: "ADT",
    name: "Ada Airport",
    city: "Ada",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 34.8,
    longitude: -96.666667,
    icao: "KADH"
  },
  ADU: {
    iata: "ADU",
    name: "Ardabil Airport",
    city: "Ardabil",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 38.323826,
    longitude: 48.42125,
    icao: "OITL"
  },
  ADW: {
    iata: "ADW",
    name: "Andrews Air Force Base",
    city: "Camp Springs",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 38.816667,
    longitude: -76.866667,
    icao: "KADW"
  },
  ADX: {
    iata: "ADX",
    name: "Leuchars Airport",
    city: "Saint Andrews",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 56.366667,
    longitude: -2.866667,
    icao: "EGQL"
  },
  ADZ: {
    iata: "ADZ",
    name: "Gustavo Rojas Pinilla Airport",
    city: "San Andres Island",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 12.586047,
    longitude: -81.702208,
    icao: "SKSP"
  },
  AEA: {
    iata: "AEA",
    name: "Abemama Airport",
    city: "Abemama Atoll",
    countryId: "KI",
    timeZoneRegionName: "Pacific/Tarawa",
    latitude: 0.483333,
    longitude: 173.85,
    icao: "NGTB"
  },
  AEB: {
    iata: "AEB",
    name: "Baise Bama Airport",
    city: "Baise",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 23.719469,
    longitude: 106.967772,
    icao: "ZGBS"
  },
  AEG: {
    iata: "AEG",
    name: "Aek Godang Airport",
    city: "South Tapanuli Regency",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: 1.400148,
    longitude: 99.430407,
    icao: "WIME"
  },
  AEH: {
    iata: "AEH",
    name: "Abecher Airport",
    city: "Abecher",
    countryId: "TD",
    timeZoneRegionName: "Africa/Ndjamena",
    latitude: 13.851389,
    longitude: 20.850833,
    icao: "FTTC"
  },
  AEL: {
    iata: "AEL",
    name: "Albert Lea Airport",
    city: "Albert Lea",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 43.65,
    longitude: -93.366667,
    icao: "KAEL"
  },
  AEM: {
    iata: "AEM",
    name: "Amgu Airport",
    city: "Amgu",
    countryId: "RU",
    timeZoneRegionName: "Asia/Vladivostok",
    latitude: 45.841667,
    longitude: 137.678333,
    icao: ""
  },
  AEO: {
    iata: "AEO",
    name: "Aioun El Atrouss Airport",
    city: "Aioun El Atrouss",
    countryId: "MR",
    timeZoneRegionName: "Africa/Nouakchott",
    latitude: 16.709167,
    longitude: -9.635556,
    icao: "GQNA"
  },
  AEP: {
    iata: "AEP",
    name: "Jorge Newbery Airport",
    city: "Buenos Aires",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -34.556221,
    longitude: -58.41667,
    icao: "SABE"
  },
  AER: {
    iata: "AER",
    name: "Sochi International Airport",
    city: "Adler/Sochi",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 43.44884,
    longitude: 39.941106,
    icao: "URSS"
  },
  AES: {
    iata: "AES",
    name: "Vigra Alesund Airport",
    city: "Aalesund",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 62.559644,
    longitude: 6.116605,
    icao: "ENAL"
  },
  AET: {
    iata: "AET",
    name: "Allakaket Airport",
    city: "Allakaket",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 66.553651,
    longitude: -152.610527,
    icao: ""
  },
  AEU: {
    iata: "AEU",
    name: "Abu Musa Airport",
    city: "Abu Musa",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 25.875475,
    longitude: 55.033913,
    icao: "OIBA"
  },
  AEX: {
    iata: "AEX",
    name: "Alexandria International Airport",
    city: "Alexandria",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 31.322573,
    longitude: -92.542568,
    icao: "KAEX"
  },
  AEY: {
    iata: "AEY",
    name: "Akureyri Airport",
    city: "Akureyri",
    countryId: "IS",
    timeZoneRegionName: "Atlantic/Reykjavik",
    latitude: 65.654567,
    longitude: -18.075068,
    icao: "BIAR"
  },
  AFA: {
    iata: "AFA",
    name: "San Rafael Airport",
    city: "San Rafael",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -34.589167,
    longitude: -68.400556,
    icao: "SAMR"
  },
  AFD: {
    iata: "AFD",
    name: "Port Alfred Airport",
    city: "Port Alfred",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -33.583333,
    longitude: 26.883333,
    icao: "FAPA"
  },
  AFF: {
    iata: "AFF",
    name: "United States Air Force Academy Airport",
    city: "Colorado Springs",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 38.972,
    longitude: -104.822,
    icao: "KAFF"
  },
  AFL: {
    iata: "AFL",
    name: "Alta Floresta Airport",
    city: "Alta Floresta",
    countryId: "BR",
    timeZoneRegionName: "America/Campo_Grande",
    latitude: -9.872456,
    longitude: -56.104768,
    icao: "SBAT"
  },
  AFN: {
    iata: "AFN",
    name: "Jaffrey Municipal Airport",
    city: "Jaffrey",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.833333,
    longitude: -72.066667,
    icao: "KAFN"
  },
  AFO: {
    iata: "AFO",
    name: "Afton Municipal Airport",
    city: "Afton",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 42.733333,
    longitude: -110.933333,
    icao: "KAFO"
  },
  AFW: {
    iata: "AFW",
    name: "Fort Worth Alliance Airport",
    city: "Fort Worth",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.985651,
    longitude: -97.315295,
    icao: "KAFW"
  },
  AFY: {
    iata: "AFY",
    name: "Afyon Airport",
    city: "Afyon",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 38.733333,
    longitude: 30.6,
    icao: "LTAH"
  },
  AGA: {
    iata: "AGA",
    name: "Agadir Al Massira Airport",
    city: "Agadir",
    countryId: "MA",
    timeZoneRegionName: "Africa/Casablanca",
    latitude: 30.328562,
    longitude: -9.410592,
    icao: "GMAD"
  },
  AGB: {
    iata: "AGB",
    name: "Augsburg Airport",
    city: "Augsburg",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 48.425278,
    longitude: 10.931667,
    icao: "EDMA"
  },
  AGC: {
    iata: "AGC",
    name: "Allegheny County Airport",
    city: "Pittsburgh",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.354722,
    longitude: -79.93,
    icao: "KAGC"
  },
  AGE: {
    iata: "AGE",
    name: "Flugplatz Airport",
    city: "Wangerooge",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 53.783333,
    longitude: 7.916667,
    icao: "EDWG"
  },
  AGF: {
    iata: "AGF",
    name: "La Garenne Airport",
    city: "Agen",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 44.173611,
    longitude: 0.598611,
    icao: "LFBA"
  },
  AGH: {
    iata: "AGH",
    name: "Angelholm Helsingborg Airport",
    city: "Angelholm/Helsingborg",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 56.287066,
    longitude: 12.867092,
    icao: "ESDB"
  },
  AGJ: {
    iata: "AGJ",
    name: "Aguni Airport",
    city: "Aguni",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 26.589722,
    longitude: 127.238056,
    icao: "RORA"
  },
  AGM: {
    iata: "AGM",
    name: "Ammassalik Heliport",
    city: "Tasiilaq",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 65.612256,
    longitude: -37.61831,
    icao: "BGAM"
  },
  AGO: {
    iata: "AGO",
    name: "Magnolia Municipal Airport",
    city: "Magnolia",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 33.266667,
    longitude: -93.233333,
    icao: "KAGO"
  },
  AGP: {
    iata: "AGP",
    name: "Malaga Airport",
    city: "Malaga",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 36.675181,
    longitude: -4.489616,
    icao: "LEMG"
  },
  AGQ: {
    iata: "AGQ",
    name: "Agrinion Airport",
    city: "Agrinion",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 38.604167,
    longitude: 21.351944,
    icao: "LGAG"
  },
  AGR: {
    iata: "AGR",
    name: "Kheria Airport",
    city: "Agra",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 27.158333,
    longitude: 77.962778,
    icao: "VIAG"
  },
  AGS: {
    iata: "AGS",
    name: "Augusta Regional Airport",
    city: "Augusta",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 33.373666,
    longitude: -81.973438,
    icao: "KAGS"
  },
  AGT: {
    iata: "AGT",
    name: "Guarani International Airport",
    city: "Ciudad del Este",
    countryId: "PY",
    timeZoneRegionName: "America/Asuncion",
    latitude: -25.455507,
    longitude: -54.843581,
    icao: "SGES"
  },
  AGU: {
    iata: "AGU",
    name: "Jesus Teran Peredo International Airport",
    city: "Aguascalientes",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 21.705535,
    longitude: -102.317818,
    icao: "MMAS"
  },
  AGV: {
    iata: "AGV",
    name: "Acarigua Airport",
    city: "Acarigua",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 9.552222,
    longitude: -69.233333,
    icao: "SVAC"
  },
  AGX: {
    iata: "AGX",
    name: "Agatti Island Airport",
    city: "Agatti Island",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 10.828967,
    longitude: 72.179874,
    icao: "VOAT"
  },
  AHB: {
    iata: "AHB",
    name: "Abha Regional Airport",
    city: "Abha",
    countryId: "SA",
    timeZoneRegionName: "Asia/Riyadh",
    latitude: 18.23429,
    longitude: 42.657575,
    icao: "OEAB"
  },
  AHC: {
    iata: "AHC",
    name: "Amedee Army Air Field",
    city: "Herlong",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 40.15,
    longitude: -120.133333,
    icao: "KAHC"
  },
  AHE: {
    iata: "AHE",
    name: "Ahe Airport",
    city: "Ahe",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -14.428056,
    longitude: -146.256944,
    icao: "NTHE"
  },
  AHH: {
    iata: "AHH",
    name: "Amery Municipal Airport",
    city: "Amery",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 45.3,
    longitude: -92.35,
    icao: "KAHH"
  },
  AHJ: {
    iata: "AHJ",
    name: "Aba Hongyuan Airport",
    city: "Hongyuan",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 32.527401,
    longitude: 102.357396,
    icao: ""
  },
  AHL: {
    iata: "AHL",
    name: "Aishalton Airport",
    city: "Aishalton",
    countryId: "GY",
    timeZoneRegionName: "America/Guyana",
    latitude: 2.483333,
    longitude: -59.316667,
    icao: "SYAH"
  },
  AHN: {
    iata: "AHN",
    name: "Athens-Ben Epps Airport",
    city: "Athens",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 33.951951,
    longitude: -83.324725,
    icao: "KAHN"
  },
  AHO: {
    iata: "AHO",
    name: "Alghero-Fertilia Airport",
    city: "Alghero",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 40.630405,
    longitude: 8.295891,
    icao: "LIEA"
  },
  AHU: {
    iata: "AHU",
    name: "Charif Al Idrissi Airport",
    city: "Al Hoceima",
    countryId: "MA",
    timeZoneRegionName: "Africa/Casablanca",
    latitude: 35.179722,
    longitude: -3.836944,
    icao: "GMTA"
  },
  AIA: {
    iata: "AIA",
    name: "Alliance Airport",
    city: "Alliance",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 42.051667,
    longitude: -102.806667,
    icao: "KAIA"
  },
  AID: {
    iata: "AID",
    name: "Anderson Municipal Airport",
    city: "Anderson",
    countryId: "US",
    timeZoneRegionName: "America/Indiana/Indianapolis",
    latitude: 40.166667,
    longitude: -85.683333,
    icao: "KAID"
  },
  AIF: {
    iata: "AIF",
    name: "Assis Airport",
    city: "Assis",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -22.666667,
    longitude: -50.416667,
    icao: "SBAS"
  },
  AIG: {
    iata: "AIG",
    name: "Yalinga Airport",
    city: "Yalinga",
    countryId: "CF",
    timeZoneRegionName: "Africa/Bangui",
    latitude: 6.516667,
    longitude: 23.25,
    icao: "FEFY"
  },
  AIK: {
    iata: "AIK",
    name: "Aiken Municipal Airport",
    city: "Aiken",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 33.649014,
    longitude: -81.684066,
    icao: "KAIK"
  },
  AIN: {
    iata: "AIN",
    name: "Wainwright Airport",
    city: "Wainwright",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 70.633333,
    longitude: -160.033333,
    icao: "PAWT"
  },
  AIO: {
    iata: "AIO",
    name: "Atlantic Municipal Airport",
    city: "Atlantic",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.4,
    longitude: -95.016667,
    icao: "KAIO"
  },
  AIP: {
    iata: "AIP",
    name: "Adampur Airport",
    city: "Adampur",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 31.4338,
    longitude: 75.7588,
    icao: "VIAX"
  },
  AIR: {
    iata: "AIR",
    name: "Aripuana Airport",
    city: "Aripuana",
    countryId: "BR",
    timeZoneRegionName: "America/Campo_Grande",
    latitude: -10.25,
    longitude: -59.383333,
    icao: ""
  },
  AIS: {
    iata: "AIS",
    name: "Arorae Airport",
    city: "Arorae Island",
    countryId: "KI",
    timeZoneRegionName: "Pacific/Tarawa",
    latitude: -2.65,
    longitude: 176.833333,
    icao: "NGTR"
  },
  AIT: {
    iata: "AIT",
    name: "Aitutaki Airport",
    city: "Aitutaki",
    countryId: "CK",
    timeZoneRegionName: "Pacific/Rarotonga",
    latitude: -18.829443,
    longitude: -159.766992,
    icao: "NCAI"
  },
  AIU: {
    iata: "AIU",
    name: "Atiu Island Airport",
    city: "Atiu Island",
    countryId: "CK",
    timeZoneRegionName: "Pacific/Rarotonga",
    latitude: -19.967872,
    longitude: -158.119014,
    icao: "NCAT"
  },
  AIV: {
    iata: "AIV",
    name: "George Downer Airport",
    city: "Aliceville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 33.133333,
    longitude: -88.15,
    icao: "KAIV"
  },
  AIY: {
    iata: "AIY",
    name: "Bader Field",
    city: "Atlantic City",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.36,
    longitude: -74.457222,
    icao: "KAIY"
  },
  AIZ: {
    iata: "AIZ",
    name: "Lee C Fine Memorial Airport",
    city: "Kaiser/Lake Ozark",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 38.098333,
    longitude: -92.547222,
    icao: "KAIZ"
  },
  AJA: {
    iata: "AJA",
    name: "Ajaccio Napoleon Bonaparte Airport",
    city: "Ajaccio",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 41.919867,
    longitude: 8.794013,
    icao: "LFKJ"
  },
  AJF: {
    iata: "AJF",
    name: "Jouf Airport",
    city: "Jouf",
    countryId: "SA",
    timeZoneRegionName: "Asia/Riyadh",
    latitude: 29.788668,
    longitude: 40.101486,
    icao: "OESK"
  },
  AJI: {
    iata: "AJI",
    name: "Agri Airport",
    city: "Agri",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 39.65,
    longitude: 43.025,
    icao: "LTCO"
  },
  AJJ: {
    iata: "AJJ",
    name: "Akjoujt Airport",
    city: "Akjoujt",
    countryId: "MR",
    timeZoneRegionName: "Africa/Nouakchott",
    latitude: 19.730556,
    longitude: -14.374444,
    icao: "GQNJ"
  },
  AJK: {
    iata: "AJK",
    name: "Arak Airport",
    city: "Arak",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 34.134875,
    longitude: 49.842483,
    icao: "OIHR"
  },
  AJL: {
    iata: "AJL",
    name: "Aizawl Airport",
    city: "Aizawl",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 23.838986,
    longitude: 92.624815,
    icao: "VEAZ"
  },
  AJN: {
    iata: "AJN",
    name: "Ouani Airport",
    city: "Anjouan",
    countryId: "KM",
    timeZoneRegionName: "Indian/Comoro",
    latitude: -12.131109,
    longitude: 44.430473,
    icao: "FMCV"
  },
  AJR: {
    iata: "AJR",
    name: "Arvidsjaur Airport",
    city: "Arvidsjaur",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 65.591389,
    longitude: 19.285556,
    icao: "ESNX"
  },
  AJU: {
    iata: "AJU",
    name: "Aracaju Airport",
    city: "Aracaju",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -10.987206,
    longitude: -37.072791,
    icao: "SBAR"
  },
  AJY: {
    iata: "AJY",
    name: "Manu Dayak International Airport",
    city: "Agades",
    countryId: "NE",
    timeZoneRegionName: "Africa/Niamey",
    latitude: 16.964167,
    longitude: 7.993056,
    icao: "DRZA"
  },
  AKA: {
    iata: "AKA",
    name: "Ankang Fuqiang Airport",
    city: "Ankang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 32.756944,
    longitude: 108.872222,
    icao: ""
  },
  AKB: {
    iata: "AKB",
    name: "Atka Airport",
    city: "Atka",
    countryId: "US",
    timeZoneRegionName: "America/Adak",
    latitude: 52.220583,
    longitude: -174.206194,
    icao: "PAAK"
  },
  AKC: {
    iata: "AKC",
    name: "Akron Fulton International Airport",
    city: "Akron",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.035899,
    longitude: -81.468098,
    icao: "KAKR"
  },
  AKD: {
    iata: "AKD",
    name: "Akola Airport",
    city: "Akola",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 20.666667,
    longitude: 77.083333,
    icao: "VAAK"
  },
  AKF: {
    iata: "AKF",
    name: "Kufra Airport",
    city: "Kufra",
    countryId: "LY",
    timeZoneRegionName: "Africa/Tripoli",
    latitude: 24.183924,
    longitude: 23.320841,
    icao: "HLKF"
  },
  AKH: {
    iata: "AKH",
    name: "Prince Sultan Air Base",
    city: "Al Kharj",
    countryId: "SA",
    timeZoneRegionName: "Asia/Riyadh",
    latitude: 24.063333,
    longitude: 47.580556,
    icao: "OEKJ"
  },
  AKJ: {
    iata: "AKJ",
    name: "Asahikawa Airport",
    city: "Asahikawa",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 43.671091,
    longitude: 142.454546,
    icao: "RJEC"
  },
  AKL: {
    iata: "AKL",
    name: "Auckland Airport",
    city: "Auckland",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -37.004786,
    longitude: 174.783524,
    icao: "NZAA"
  },
  AKN: {
    iata: "AKN",
    name: "King Salmon Airport",
    city: "King Salmon",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 58.682741,
    longitude: -156.669016,
    icao: "PAKN"
  },
  AKO: {
    iata: "AKO",
    name: "Washington County Airport",
    city: "Akron",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 40.166667,
    longitude: -103.216667,
    icao: "KAKO"
  },
  AKP: {
    iata: "AKP",
    name: "Anaktuvuk Airport",
    city: "Anaktuvuk",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 68.1375,
    longitude: -151.74,
    icao: "PAKP"
  },
  AKR: {
    iata: "AKR",
    name: "Akure Airport",
    city: "Akure",
    countryId: "NG",
    timeZoneRegionName: "Africa/Lagos",
    latitude: 7.250303,
    longitude: 5.300223,
    icao: "DNAK"
  },
  AKS: {
    iata: "AKS",
    name: "Gwaunaru'u Airport",
    city: "Auki",
    countryId: "SB",
    timeZoneRegionName: "Pacific/Guadalcanal",
    latitude: -8.70428,
    longitude: 160.681469,
    icao: "AGGA"
  },
  AKT: {
    iata: "AKT",
    name: "Akrotiri RAF Station",
    city: "Akrotiri",
    countryId: "CY",
    timeZoneRegionName: "Asia/Nicosia",
    latitude: 34.590395,
    longitude: 32.987887,
    icao: "LCRA"
  },
  AKU: {
    iata: "AKU",
    name: "Aksu Airport",
    city: "Aksu",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 41.259984,
    longitude: 80.292618,
    icao: "ZWAK"
  },
  AKV: {
    iata: "AKV",
    name: "Akulivik Airport",
    city: "Akulivik",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 60.733333,
    longitude: -78.583333,
    icao: "CYKO"
  },
  AKW: {
    iata: "AKW",
    name: "Aghajari Airport",
    city: "Aghajari",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 30.75,
    longitude: 49.683333,
    icao: "OIAG"
  },
  AKX: {
    iata: "AKX",
    name: "Aktyubinsk Airport",
    city: "Aktyubinsk",
    countryId: "KZ",
    timeZoneRegionName: "Asia/Aqtobe",
    latitude: 50.249336,
    longitude: 57.211403,
    icao: "UATT"
  },
  AKY: {
    iata: "AKY",
    name: "Civil Airport",
    city: "Sittwe",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 20.130278,
    longitude: 92.880278,
    icao: "VYSW"
  },
  ALA: {
    iata: "ALA",
    name: "Almaty Airport",
    city: "Almaty",
    countryId: "KZ",
    timeZoneRegionName: "Asia/Almaty",
    latitude: 43.346652,
    longitude: 77.011455,
    icao: "UAAA"
  },
  ALB: {
    iata: "ALB",
    name: "Albany International Airport",
    city: "Albany",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.745279,
    longitude: -73.809556,
    icao: "KALB"
  },
  ALC: {
    iata: "ALC",
    name: "Alicante-Elche Airport",
    city: "Alicante",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 38.287098,
    longitude: -0.557381,
    icao: "LEAL"
  },
  ALD: {
    iata: "ALD",
    name: "Alerta Airport",
    city: "Alerta",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -11.683333,
    longitude: -69.333333,
    icao: "SPAR"
  },
  ALF: {
    iata: "ALF",
    name: "Alta Airport",
    city: "Alta",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 69.977167,
    longitude: 23.355809,
    icao: "ENAT"
  },
  ALG: {
    iata: "ALG",
    name: "Houari Boumediene Airport",
    city: "Algiers",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 36.697892,
    longitude: 3.207136,
    icao: "DAAG"
  },
  ALH: {
    iata: "ALH",
    name: "Albany Airport",
    city: "Albany",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -34.944997,
    longitude: 117.804001,
    icao: "YABA"
  },
  ALI: {
    iata: "ALI",
    name: "Alice International Airport",
    city: "Alice",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 27.7409,
    longitude: -98.026901,
    icao: "KALI"
  },
  ALJ: {
    iata: "ALJ",
    name: "Alexander Bay Airport",
    city: "Alexander Bay",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -28.574996,
    longitude: 16.53333,
    icao: "FAAB"
  },
  ALL: {
    iata: "ALL",
    name: "Albenga Airport",
    city: "Albenga",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 44.05,
    longitude: 8.216667,
    icao: "LIMG"
  },
  ALM: {
    iata: "ALM",
    name: "Alamogordo Municipal Airport",
    city: "Alamogordo",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 32.845833,
    longitude: -105.985278,
    icao: "KALM"
  },
  ALN: {
    iata: "ALN",
    name: "St. Louis Regional Airport",
    city: "Alton",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 38.891667,
    longitude: -90.048333,
    icao: "KALN"
  },
  ALO: {
    iata: "ALO",
    name: "Waterloo Airport",
    city: "Waterloo",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 42.556111,
    longitude: -92.399722,
    icao: "KALO"
  },
  ALP: {
    iata: "ALP",
    name: "Aleppo International Airport",
    city: "Aleppo",
    countryId: "SY",
    timeZoneRegionName: "Asia/Damascus",
    latitude: 36.185351,
    longitude: 37.227073,
    icao: "OSAP"
  },
  ALQ: {
    iata: "ALQ",
    name: "Federal Airport",
    city: "Alegrete",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -29.799722,
    longitude: -55.763333,
    icao: "SSAL"
  },
  ALR: {
    iata: "ALR",
    name: "Alexandra Airport",
    city: "Alexandra",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -45.213889,
    longitude: 169.369444,
    icao: "NZLX"
  },
  ALS: {
    iata: "ALS",
    name: "Alamosa Municipal Airport",
    city: "Alamosa",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 37.436667,
    longitude: -105.866667,
    icao: "KALS"
  },
  ALU: {
    iata: "ALU",
    name: "Alula Airport",
    city: "Alula",
    countryId: "SO",
    timeZoneRegionName: "Africa/Mogadishu",
    latitude: 11.966667,
    longitude: 50.8,
    icao: "HCMA"
  },
  ALW: {
    iata: "ALW",
    name: "Walla Walla Airport",
    city: "Walla Walla",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 46.094722,
    longitude: -118.291111,
    icao: "KALW"
  },
  ALX: {
    iata: "ALX",
    name: "Thomas C Russell Field",
    city: "Alexander City",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.933333,
    longitude: -85.95,
    icao: "KALX"
  },
  ALY: {
    iata: "ALY",
    name: "El Nohza Airport",
    city: "Alexandria",
    countryId: "EG",
    timeZoneRegionName: "Africa/Cairo",
    latitude: 31.192545,
    longitude: 29.953059,
    icao: "HEAX"
  },
  AMA: {
    iata: "AMA",
    name: "Rick Husband Amarillo International Airport",
    city: "Amarillo",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.218274,
    longitude: -101.705134,
    icao: "KAMA"
  },
  AMB: {
    iata: "AMB",
    name: "Ambilobe Airport",
    city: "Ambilobe",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -13.183333,
    longitude: 48.983333,
    icao: "FMNE"
  },
  AMC: {
    iata: "AMC",
    name: "Am Timan Airport",
    city: "Am Timan",
    countryId: "TD",
    timeZoneRegionName: "Africa/Ndjamena",
    latitude: 11.033333,
    longitude: 20.283333,
    icao: "FTTN"
  },
  AMD: {
    iata: "AMD",
    name: "Ahmedabad Airport",
    city: "Ahmedabad",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 23.066389,
    longitude: 72.624167,
    icao: "VAAH"
  },
  AMH: {
    iata: "AMH",
    name: "Arba Mintch Airport",
    city: "Arba Mintch",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 6.036111,
    longitude: 37.576944,
    icao: "HAAM"
  },
  AMI: {
    iata: "AMI",
    name: "Selaparang Airport",
    city: "Mataram",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -8.563165,
    longitude: 116.102375,
    icao: "WRRA"
  },
  AMJ: {
    iata: "AMJ",
    name: "Almenara Airport",
    city: "Almenara",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -16.183333,
    longitude: -40.683333,
    icao: "SNAR"
  },
  AMM: {
    iata: "AMM",
    name: "Queen Alia International Airport",
    city: "Amman",
    countryId: "JO",
    timeZoneRegionName: "Asia/Amman",
    latitude: 31.722535,
    longitude: 35.989318,
    icao: "OJAI"
  },
  AMN: {
    iata: "AMN",
    name: "Gratiot Community Airport",
    city: "Alma",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 43.383333,
    longitude: -84.65,
    icao: "KAMN"
  },
  AMO: {
    iata: "AMO",
    name: "Mao Airport",
    city: "Mao",
    countryId: "TD",
    timeZoneRegionName: "Africa/Ndjamena",
    latitude: 14.116667,
    longitude: 15.316667,
    icao: "FTTU"
  },
  AMP: {
    iata: "AMP",
    name: "Ampanihy Airport",
    city: "Ampanihy",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -24.7,
    longitude: 44.733333,
    icao: "FMSY"
  },
  AMQ: {
    iata: "AMQ",
    name: "Pattimura Airport",
    city: "Ambon",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jayapura",
    latitude: -3.704996,
    longitude: 128.088876,
    icao: "WAPP"
  },
  AMS: {
    iata: "AMS",
    name: "Amsterdam Airport Schiphol",
    city: "Amsterdam",
    countryId: "NL",
    timeZoneRegionName: "Europe/Amsterdam",
    latitude: 52.309069,
    longitude: 4.763385,
    icao: "EHAM"
  },
  AMV: {
    iata: "AMV",
    name: "Amderma Airport",
    city: "Amderma",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 69.761503,
    longitude: 61.574462,
    icao: "ULDD"
  },
  AMW: {
    iata: "AMW",
    name: "Ames Airport",
    city: "Ames",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.994167,
    longitude: -93.618333,
    icao: "KAMW"
  },
  AMZ: {
    iata: "AMZ",
    name: "Ardmore Airport",
    city: "Ardmore",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -37.029957,
    longitude: 174.975362,
    icao: "NZAR"
  },
  ANA: {
    iata: "ANA",
    name: "Maasai Mara Angama Airport",
    city: "Maasai Mara",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: -1.271581,
    longitude: 34.955333,
    icao: ""
  },
  ANB: {
    iata: "ANB",
    name: "Anniston Regional Airport",
    city: "Anniston",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 33.588193,
    longitude: -85.8581,
    icao: "KANB"
  },
  ANC: {
    iata: "ANC",
    name: "Ted Stevens Anchorage International Airport",
    city: "Anchorage",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 61.174444,
    longitude: -149.996389,
    icao: "PANC"
  },
  AND: {
    iata: "AND",
    name: "Anderson Airport",
    city: "Anderson",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 34.493611,
    longitude: -82.71,
    icao: "KAND"
  },
  ANE: {
    iata: "ANE",
    name: "Angers-Marce Airport",
    city: "Angers",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 47.560351,
    longitude: -0.312245,
    icao: "LFJR"
  },
  ANF: {
    iata: "ANF",
    name: "Cerro Moreno International Airport",
    city: "Antofagasta",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -23.449,
    longitude: -70.440789,
    icao: "SCFA"
  },
  ANG: {
    iata: "ANG",
    name: "Brie-Champniers Airport",
    city: "Angouleme",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 45.727359,
    longitude: 0.218923,
    icao: "LFBU"
  },
  ANI: {
    iata: "ANI",
    name: "Aniak Airport",
    city: "Aniak",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 61.574399,
    longitude: -159.536971,
    icao: "PANI"
  },
  ANJ: {
    iata: "ANJ",
    name: "Zanaga Airport",
    city: "Zanaga",
    countryId: "CG",
    timeZoneRegionName: "Africa/Brazzaville",
    latitude: -2.85,
    longitude: 13.833333,
    icao: "FCBZ"
  },
  ANK: {
    iata: "ANK",
    name: "Etimesgut Airport",
    city: "Ankara",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 39.950283,
    longitude: 32.689136,
    icao: "LTAD"
  },
  ANM: {
    iata: "ANM",
    name: "Antsirabato Airport",
    city: "Antalaha",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -14.999396,
    longitude: 50.320257,
    icao: "FMNH"
  },
  ANO: {
    iata: "ANO",
    name: "Angoche Airport",
    city: "Angoche",
    countryId: "MZ",
    timeZoneRegionName: "Africa/Maputo",
    latitude: -16.177778,
    longitude: 39.936944,
    icao: "FQAG"
  },
  ANP: {
    iata: "ANP",
    name: "Lee Airport",
    city: "Annapolis",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 38.983333,
    longitude: -76.5,
    icao: "KANP"
  },
  ANQ: {
    iata: "ANQ",
    name: "Tri-State Steuben County Airport",
    city: "Angola",
    countryId: "US",
    timeZoneRegionName: "America/Indiana/Indianapolis",
    latitude: 41.633333,
    longitude: -85,
    icao: "KANQ"
  },
  ANR: {
    iata: "ANR",
    name: "Antwerp International Airport",
    city: "Antwerp",
    countryId: "BE",
    timeZoneRegionName: "Europe/Brussels",
    latitude: 51.18916,
    longitude: 4.450672,
    icao: "EBAW"
  },
  ANS: {
    iata: "ANS",
    name: "Andahuaylas Airport",
    city: "Andahuaylas",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -13.716667,
    longitude: -73.355833,
    icao: "SPHY"
  },
  ANU: {
    iata: "ANU",
    name: "V.C. Bird International Airport",
    city: "Antigua",
    countryId: "AG",
    timeZoneRegionName: "America/Antigua",
    latitude: 17.139383,
    longitude: -61.791717,
    icao: "TAPA"
  },
  ANV: {
    iata: "ANV",
    name: "Anvik Airport",
    city: "Anvik",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 62.647778,
    longitude: -160.188889,
    icao: "PANV"
  },
  ANW: {
    iata: "ANW",
    name: "Ainsworth Airport",
    city: "Ainsworth",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 42.55,
    longitude: -99.866667,
    icao: "KANW"
  },
  ANX: {
    iata: "ANX",
    name: "Andoya Airport",
    city: "Andenes",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 69.292486,
    longitude: 16.144184,
    icao: "ENAN"
  },
  ANY: {
    iata: "ANY",
    name: "Anthony Airport",
    city: "Anthony",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 37.15,
    longitude: -98.033333,
    icao: "KANY"
  },
  AOC: {
    iata: "AOC",
    name: "Altenburg Nobitz Airport",
    city: "Altenburg",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 50.981945,
    longitude: 12.506389,
    icao: "EDAC"
  },
  AOE: {
    iata: "AOE",
    name: "Anadolu Airport",
    city: "Eskisehir",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 39.81,
    longitude: 30.519444,
    icao: "LTBY"
  },
  AOG: {
    iata: "AOG",
    name: "Anshan Teng'ao Airport",
    city: "Anshan",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 41.105975,
    longitude: 122.853926,
    icao: "ZYAS"
  },
  AOH: {
    iata: "AOH",
    name: "Allen County Airport",
    city: "Lima",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.766667,
    longitude: -84.1,
    icao: "KAOH"
  },
  AOI: {
    iata: "AOI",
    name: "Ancona Falconara Airport",
    city: "Ancona",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 43.606911,
    longitude: 13.355723,
    icao: "LIPY"
  },
  AOJ: {
    iata: "AOJ",
    name: "Aomori Airport",
    city: "Aomori",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 40.738757,
    longitude: 140.689224,
    icao: "RJSA"
  },
  AOK: {
    iata: "AOK",
    name: "Karpathos Airport",
    city: "Karpathos",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 35.420683,
    longitude: 27.146728,
    icao: "LGKP"
  },
  AOL: {
    iata: "AOL",
    name: "Paso de los Libres Airport",
    city: "Paso de los Libres",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -29.683333,
    longitude: -57.15,
    icao: "SARL"
  },
  AOO: {
    iata: "AOO",
    name: "Altoona Airport",
    city: "Altoona",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.297222,
    longitude: -78.32,
    icao: "KAOO"
  },
  AOP: {
    iata: "AOP",
    name: "Alfredo V. Sara Bauer Airport",
    city: "Andoas",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -2.791389,
    longitude: -76.474722,
    icao: "SPAS"
  },
  AOQ: {
    iata: "AOQ",
    name: "Aappilattoq-Upernanik Heliport",
    city: "Aappilattoq",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 72.887041,
    longitude: -55.596145,
    icao: "BGAG"
  },
  AOR: {
    iata: "AOR",
    name: "Sultan Abdul Halim Airport",
    city: "Alor Setar",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 6.191186,
    longitude: 100.396629,
    icao: "WMKA"
  },
  AOT: {
    iata: "AOT",
    name: "Corrado Gex Airport",
    city: "Aosta",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 45.738611,
    longitude: 7.3625,
    icao: "LIMW"
  },
  AOU: {
    iata: "AOU",
    name: "Attopeu Airport",
    city: "Attopeu",
    countryId: "LA",
    timeZoneRegionName: "Asia/Vientiane",
    latitude: 14.8,
    longitude: 106.833333,
    icao: "VLAP"
  },
  APA: {
    iata: "APA",
    name: "Centennial Airport",
    city: "Denver",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 39.572123,
    longitude: -104.848713,
    icao: "KAPA"
  },
  APB: {
    iata: "APB",
    name: "Apolo Airport",
    city: "Apolo",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -14.716667,
    longitude: -68.516667,
    icao: "SLAP"
  },
  APC: {
    iata: "APC",
    name: "Napa County Airport",
    city: "Napa",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 38.212222,
    longitude: -122.28,
    icao: "KAPC"
  },
  APD: {
    iata: "APD",
    name: "Arung Palakka Airport",
    city: "Bone",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -4.458333,
    longitude: 120.3075,
    icao: ""
  },
  APF: {
    iata: "APF",
    name: "Naples Municipal Airport",
    city: "Naples",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 26.152778,
    longitude: -81.775278,
    icao: "KAPF"
  },
  APG: {
    iata: "APG",
    name: "Phillips Army Air Field",
    city: "Aberdeen",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.5,
    longitude: -76.166667,
    icao: "KAPG"
  },
  API: {
    iata: "API",
    name: "Luis F. Gomez Nino Air Base",
    city: "Apiay",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 4.076085,
    longitude: -73.562834,
    icao: "SKAP"
  },
  APJ: {
    iata: "APJ",
    name: "Ali Pulan Airport",
    city: "Pulan",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 30.39861111,
    longitude: 81.1325,
    icao: ""
  },
  APK: {
    iata: "APK",
    name: "Apataki Airport",
    city: "Apataki",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -15.572857,
    longitude: -146.414129,
    icao: "NTGD"
  },
  APL: {
    iata: "APL",
    name: "Nampula Airport",
    city: "Nampula",
    countryId: "MZ",
    timeZoneRegionName: "Africa/Maputo",
    latitude: -15.101667,
    longitude: 39.287222,
    icao: "FQNP"
  },
  APN: {
    iata: "APN",
    name: "Alpena County Regional Airport",
    city: "Alpena",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 45.081667,
    longitude: -83.555833,
    icao: "KAPN"
  },
  APO: {
    iata: "APO",
    name: "Apartado Airport",
    city: "Apartado",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 7.817678,
    longitude: -76.71766,
    icao: "SKLC"
  },
  APQ: {
    iata: "APQ",
    name: "Arapiraca Airport",
    city: "Arapiraca",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -9.75,
    longitude: -36.65,
    icao: "SNAL"
  },
  APS: {
    iata: "APS",
    name: "Anapolis Airport",
    city: "Anapolis",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -16.360671,
    longitude: -48.924353,
    icao: "SWNS"
  },
  APT: {
    iata: "APT",
    name: "Marion County Airport",
    city: "Jasper",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.066667,
    longitude: -85.5,
    icao: "KAPT"
  },
  APU: {
    iata: "APU",
    name: "Apucarana Airport",
    city: "Apucarana",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -23.55,
    longitude: -51.483333,
    icao: "SSAP"
  },
  APV: {
    iata: "APV",
    name: "Apple Valley Airport",
    city: "Apple Valley",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 34.579105,
    longitude: -117.185485,
    icao: "KAPV"
  },
  APW: {
    iata: "APW",
    name: "Faleolo Airport",
    city: "Apia",
    countryId: "WS",
    timeZoneRegionName: "Pacific/Apia",
    latitude: -13.832793,
    longitude: -171.997244,
    icao: "NSFA"
  },
  APX: {
    iata: "APX",
    name: "Arapongas Airport",
    city: "Arapongas",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -23.3529,
    longitude: -51.491699,
    icao: "SSOG"
  },
  APY: {
    iata: "APY",
    name: "Alto Parnaiba Airport",
    city: "Alto Parnaiba",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -9.133333,
    longitude: -45.933333,
    icao: "SNAI"
  },
  AQA: {
    iata: "AQA",
    name: "Araraquara Airport",
    city: "Araraquara",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -21.806642,
    longitude: -48.136911,
    icao: "SBAQ"
  },
  AQG: {
    iata: "AQG",
    name: "Anqing Tianzhushan Airport",
    city: "Anqing",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 30.5825,
    longitude: 117.0509,
    icao: "ZSAQ"
  },
  AQI: {
    iata: "AQI",
    name: "Qaisumah Airport",
    city: "Qaisumah",
    countryId: "SA",
    timeZoneRegionName: "Asia/Riyadh",
    latitude: 28.334408,
    longitude: 46.121316,
    icao: "OEPA"
  },
  AQJ: {
    iata: "AQJ",
    name: "King Hussein International Airport",
    city: "Aqaba",
    countryId: "JO",
    timeZoneRegionName: "Asia/Amman",
    latitude: 29.610074,
    longitude: 35.021511,
    icao: "OJAQ"
  },
  AQM: {
    iata: "AQM",
    name: "Ariquemes Airport",
    city: "Ariquemes",
    countryId: "BR",
    timeZoneRegionName: "America/Porto_Velho",
    latitude: -9.933333,
    longitude: -63.066667,
    icao: "SWNI"
  },
  AQP: {
    iata: "AQP",
    name: "Rodriguez Ballon International Airport",
    city: "Arequipa",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -16.344812,
    longitude: -71.567993,
    icao: "SPQU"
  },
  ARA: {
    iata: "ARA",
    name: "Acadiana Regional Airport",
    city: "New Iberia",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.037778,
    longitude: -91.883889,
    icao: "KARA"
  },
  ARB: {
    iata: "ARB",
    name: "Ann Arbor Municipal Airport",
    city: "Ann Arbor",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.224912,
    longitude: -83.74559,
    icao: "KARB"
  },
  ARC: {
    iata: "ARC",
    name: "Arctic Village Airport",
    city: "Arctic Village",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 68.1375,
    longitude: -145.524444,
    icao: "PARC"
  },
  ARD: {
    iata: "ARD",
    name: "Alor Island Airport",
    city: "Alor Island",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -8.132639,
    longitude: 124.598106,
    icao: "WATM"
  },
  ARG: {
    iata: "ARG",
    name: "Walnut Ridge Airport",
    city: "Walnut Ridge",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.066667,
    longitude: -90.95,
    icao: "KARG"
  },
  ARH: {
    iata: "ARH",
    name: "Talagi Airport",
    city: "Arkhangelsk",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 64.597581,
    longitude: 40.713989,
    icao: "ULAA"
  },
  ARI: {
    iata: "ARI",
    name: "Chacalluta Airport",
    city: "Arica",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -18.349765,
    longitude: -70.335559,
    icao: "SCAR"
  },
  ARK: {
    iata: "ARK",
    name: "Arusha Airport",
    city: "Arusha",
    countryId: "TZ",
    timeZoneRegionName: "Africa/Dar_es_Salaam",
    latitude: -3.366667,
    longitude: 36.683333,
    icao: "HTAR"
  },
  ARL: {
    iata: "ARL",
    name: "Arly Airport",
    city: "Arly",
    countryId: "BF",
    timeZoneRegionName: "Africa/Ouagadougou",
    latitude: 11.597078,
    longitude: 1.482278,
    icao: "DFER"
  },
  ARM: {
    iata: "ARM",
    name: "Armidale Airport",
    city: "Armidale",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -30.532297,
    longitude: 151.61493,
    icao: "YARM"
  },
  ARN: {
    iata: "ARN",
    name: "Stockholm Arlanda Airport",
    city: "Stockholm",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 59.649818,
    longitude: 17.930364,
    icao: "ESSA"
  },
  ARR: {
    iata: "ARR",
    name: "Alto Rio Senguerr Airport",
    city: "Alto Rio Senguerr",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -45.033333,
    longitude: -70.833333,
    icao: "SAVR"
  },
  ARS: {
    iata: "ARS",
    name: "Aragarcas Airport",
    city: "Aragarcas",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -15.9,
    longitude: -52.233333,
    icao: "SWAC"
  },
  ART: {
    iata: "ART",
    name: "Watertown Airport",
    city: "Watertown",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 43.990833,
    longitude: -76.021389,
    icao: "KART"
  },
  ARU: {
    iata: "ARU",
    name: "Aracatuba Airport",
    city: "Aracatuba",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -21.143611,
    longitude: -50.426111,
    icao: "SBAU"
  },
  ARV: {
    iata: "ARV",
    name: "Noble F. Lee Airport",
    city: "Minocqua",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 45.924167,
    longitude: -89.732222,
    icao: "KARV"
  },
  ARW: {
    iata: "ARW",
    name: "Arad International Airport",
    city: "Arad",
    countryId: "RO",
    timeZoneRegionName: "Europe/Bucharest",
    latitude: 46.17201,
    longitude: 21.276296,
    icao: "LRAR"
  },
  ARX: {
    iata: "ARX",
    name: "Aracati",
    city: "Aracati",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -4.56861,
    longitude: -37.80472,
    icao: "SNAT"
  },
  ARY: {
    iata: "ARY",
    name: "Ararat Airport",
    city: "Ararat",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -37.316667,
    longitude: 143,
    icao: "YARA"
  },
  ARZ: {
    iata: "ARZ",
    name: "N'Zeto Airport",
    city: "N'Zeto",
    countryId: "AO",
    timeZoneRegionName: "Africa/Luanda",
    latitude: -7.5,
    longitude: 13.5,
    icao: "FNZE"
  },
  ASA: {
    iata: "ASA",
    name: "Assab Airport",
    city: "Assab",
    countryId: "ER",
    timeZoneRegionName: "Africa/Asmara",
    latitude: 13.07,
    longitude: 42.638333,
    icao: "HHSB"
  },
  ASB: {
    iata: "ASB",
    name: "Ashgabat Airport",
    city: "Ashgabat",
    countryId: "TM",
    timeZoneRegionName: "Asia/Ashgabat",
    latitude: 37.984183,
    longitude: 58.366978,
    icao: "UTAA"
  },
  ASD: {
    iata: "ASD",
    name: "Andros Town Airport",
    city: "Andros Town",
    countryId: "BS",
    timeZoneRegionName: "America/Nassau",
    latitude: 24.697778,
    longitude: -77.796111,
    icao: "MYAF"
  },
  ASE: {
    iata: "ASE",
    name: "Aspen Airport",
    city: "Aspen",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 39.219685,
    longitude: -106.864688,
    icao: "KASE"
  },
  ASF: {
    iata: "ASF",
    name: "Astrakhan Airport",
    city: "Astrakhan",
    countryId: "RU",
    timeZoneRegionName: "Europe/Astrakhan",
    latitude: 46.287699,
    longitude: 47.999979,
    icao: "URWA"
  },
  ASG: {
    iata: "ASG",
    name: "Ashburton Airport",
    city: "Ashburton",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -43.9,
    longitude: 171.783333,
    icao: "NZAS"
  },
  ASH: {
    iata: "ASH",
    name: "Boire Field",
    city: "Nashua",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.7817,
    longitude: -71.514801,
    icao: "KASH"
  },
  ASI: {
    iata: "ASI",
    name: "Ascension Island RAF Station",
    city: "Ascension Island",
    countryId: "SH",
    timeZoneRegionName: "Atlantic/St_Helena",
    latitude: -7.969604,
    longitude: -14.393682,
    icao: "FHAW"
  },
  ASJ: {
    iata: "ASJ",
    name: "Amami Airport",
    city: "Amami O Shima",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 28.431522,
    longitude: 129.707933,
    icao: "RJKA"
  },
  ASK: {
    iata: "ASK",
    name: "Yamoussoukro Airport",
    city: "Yamoussoukro",
    countryId: "CI",
    timeZoneRegionName: "Africa/Abidjan",
    latitude: 6.816667,
    longitude: -5.283333,
    icao: "DIYO"
  },
  ASL: {
    iata: "ASL",
    name: "Harrison County Airport",
    city: "Marshall",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.55,
    longitude: -94.383333,
    icao: "KASL"
  },
  ASM: {
    iata: "ASM",
    name: "Asmara International Airport",
    city: "Asmara",
    countryId: "ER",
    timeZoneRegionName: "Africa/Asmara",
    latitude: 15.291111,
    longitude: 38.910278,
    icao: "HHAS"
  },
  ASN: {
    iata: "ASN",
    name: "Talladega Municipal Airport",
    city: "Talladega",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 33.571351,
    longitude: -86.05219,
    icao: "KASN"
  },
  ASO: {
    iata: "ASO",
    name: "Asosa Airport",
    city: "Asosa",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 10.047222,
    longitude: 34.536667,
    icao: "HASO"
  },
  ASP: {
    iata: "ASP",
    name: "Alice Springs Airport",
    city: "Alice Springs",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -23.801389,
    longitude: 133.903384,
    icao: "YBAS"
  },
  ASR: {
    iata: "ASR",
    name: "Kayseri Airport",
    city: "Kayseri",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 38.770293,
    longitude: 35.494891,
    icao: "LTAU"
  },
  ASS: {
    iata: "ASS",
    name: "Arathusa Safari Lodge Airport",
    city: "Chitwa Chitwa",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -24.736469,
    longitude: 31.514126,
    icao: "FACC"
  },
  AST: {
    iata: "AST",
    name: "Astoria Regional Airport",
    city: "Astoria",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 46.159722,
    longitude: -123.88,
    icao: "KAST"
  },
  ASU: {
    iata: "ASU",
    name: "Silvio Pettirossi International Airport",
    city: "Asuncion",
    countryId: "PY",
    timeZoneRegionName: "America/Asuncion",
    latitude: -25.241795,
    longitude: -57.513795,
    icao: "SGAS"
  },
  ASV: {
    iata: "ASV",
    name: "Amboseli Airport",
    city: "Amboseli",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: -2.633333,
    longitude: 37.25,
    icao: "HKAM"
  },
  ASW: {
    iata: "ASW",
    name: "Aswan International Airport",
    city: "Aswan",
    countryId: "EG",
    timeZoneRegionName: "Africa/Cairo",
    latitude: 23.968022,
    longitude: 32.824818,
    icao: "HESN"
  },
  ASX: {
    iata: "ASX",
    name: "Ashland Airport",
    city: "Ashland",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 46.55,
    longitude: -90.916667,
    icao: "KASX"
  },
  ASY: {
    iata: "ASY",
    name: "Ashley Airport",
    city: "Ashley",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 46.033333,
    longitude: -99.366667,
    icao: "KASY"
  },
  ATA: {
    iata: "ATA",
    name: "Comandante FAP German Arias Graziani Airport",
    city: "Anta",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -9.347222,
    longitude: -77.6,
    icao: "SPHZ"
  },
  ATB: {
    iata: "ATB",
    name: "Atbara Airport",
    city: "Atbara",
    countryId: "SD",
    timeZoneRegionName: "Africa/Khartoum",
    latitude: 17.716667,
    longitude: 34.016667,
    icao: "HSAT"
  },
  ATC: {
    iata: "ATC",
    name: "Arthur's Town Airport",
    city: "'Arthur's Town",
    countryId: "BS",
    timeZoneRegionName: "America/Nassau",
    latitude: 24.628611,
    longitude: -75.671389,
    icao: "MYCA"
  },
  ATF: {
    iata: "ATF",
    name: "Chachoan Airport",
    city: "Ambato",
    countryId: "EC",
    timeZoneRegionName: "America/Guayaquil",
    latitude: -1.083333,
    longitude: -78.7,
    icao: "SEAM"
  },
  ATH: {
    iata: "ATH",
    name: "Eleftherios Venizelos International Airport",
    city: "Athens",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 37.93635,
    longitude: 23.946486,
    icao: "LGAV"
  },
  ATI: {
    iata: "ATI",
    name: "Artigas Airport",
    city: "Artigas",
    countryId: "UY",
    timeZoneRegionName: "America/Montevideo",
    latitude: -30.4,
    longitude: -56.508333,
    icao: "SUAG"
  },
  ATJ: {
    iata: "ATJ",
    name: "Antsirabe Airport",
    city: "Antsirabe",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -19.835319,
    longitude: 47.066926,
    icao: "FMME"
  },
  ATK: {
    iata: "ATK",
    name: "Atqasuk Airport",
    city: "Atqasuk",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 70.5,
    longitude: -157.333333,
    icao: "PATQ"
  },
  ATL: {
    iata: "ATL",
    name: "Hartsfield-Jackson Atlanta International Airport",
    city: "Atlanta",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 33.640067,
    longitude: -84.44403,
    icao: "KATL"
  },
  ATM: {
    iata: "ATM",
    name: "Altamira Airport",
    city: "Altamira",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -3.2,
    longitude: -52.216667,
    icao: "SBHT"
  },
  ATO: {
    iata: "ATO",
    name: "Ohio University Airport",
    city: "Athens",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.333333,
    longitude: -82.1,
    icao: "KUNI"
  },
  ATQ: {
    iata: "ATQ",
    name: "Sri Guru Ram Dass Jee International Airport",
    city: "Amritsar",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 31.705398,
    longitude: 74.806739,
    icao: "VIAR"
  },
  ATR: {
    iata: "ATR",
    name: "Atar International Airport",
    city: "Atar",
    countryId: "MR",
    timeZoneRegionName: "Africa/Nouakchott",
    latitude: 20.499444,
    longitude: -13.046389,
    icao: "GQPA"
  },
  ATS: {
    iata: "ATS",
    name: "Artesia Airport",
    city: "Artesia",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 32.848333,
    longitude: -104.466944,
    icao: "KATS"
  },
  ATT: {
    iata: "ATT",
    name: "Atmautluak Airport",
    city: "Atmautluak",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 60.866594,
    longitude: -162.273678,
    icao: ""
  },
  ATV: {
    iata: "ATV",
    name: "Ati Airport",
    city: "Ati",
    countryId: "TD",
    timeZoneRegionName: "Africa/Ndjamena",
    latitude: 13.242222,
    longitude: 18.3075,
    icao: "FTTI"
  },
  ATW: {
    iata: "ATW",
    name: "Appleton International Airport",
    city: "Appleton",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 44.26011,
    longitude: -88.509943,
    icao: "KATW"
  },
  ATY: {
    iata: "ATY",
    name: "Watertown Airport",
    city: "Watertown",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 44.908889,
    longitude: -97.154167,
    icao: "KATY"
  },
  ATZ: {
    iata: "ATZ",
    name: "Asyut Airport",
    city: "Asyut",
    countryId: "EG",
    timeZoneRegionName: "Africa/Cairo",
    latitude: 27.052679,
    longitude: 31.011268,
    icao: "HEAT"
  },
  AUA: {
    iata: "AUA",
    name: "Reina Beatrix International Airport",
    city: "Aruba",
    countryId: "AW",
    timeZoneRegionName: "America/Aruba",
    latitude: 12.502222,
    longitude: -70.013889,
    icao: "TNCA"
  },
  AUC: {
    iata: "AUC",
    name: "Arauca Airport",
    city: "Arauca",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 7.071667,
    longitude: -70.7425,
    icao: "SKUC"
  },
  AUD: {
    iata: "AUD",
    name: "Augustus Downs Airport",
    city: "Augustus Downs",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -18.506944,
    longitude: 139.881667,
    icao: "YAGD"
  },
  AUF: {
    iata: "AUF",
    name: "Aeroport Auxerre Branches",
    city: "Auxerre",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 47.85,
    longitude: 3.5,
    icao: "LFLA"
  },
  AUG: {
    iata: "AUG",
    name: "Augusta Airport",
    city: "Augusta",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 44.318056,
    longitude: -69.796667,
    icao: "KAUG"
  },
  AUH: {
    iata: "AUH",
    name: "Abu Dhabi International Airport",
    city: "Abu Dhabi",
    countryId: "AE",
    timeZoneRegionName: "Asia/Dubai",
    latitude: 24.426912,
    longitude: 54.645974,
    icao: "OMAA"
  },
  AUK: {
    iata: "AUK",
    name: "Alakanuk Airport",
    city: "Alakanuk",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 62.689167,
    longitude: -164.610833,
    icao: "PAUK"
  },
  AUM: {
    iata: "AUM",
    name: "Austin Airport",
    city: "Austin",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 43.666667,
    longitude: -92.983333,
    icao: "KAUM"
  },
  AUN: {
    iata: "AUN",
    name: "Auburn Airport",
    city: "Auburn",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 38.9,
    longitude: -121.066667,
    icao: "KAUN"
  },
  AUO: {
    iata: "AUO",
    name: "Auburn University Regional Airport",
    city: "Auburn",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.615046,
    longitude: -85.433875,
    icao: "KAUO"
  },
  AUQ: {
    iata: "AUQ",
    name: "Hiva Oa Airport",
    city: "Atuona",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Marquesas",
    latitude: -9.768596,
    longitude: -139.009944,
    icao: "NTMN"
  },
  AUR: {
    iata: "AUR",
    name: "Aurillac Airport",
    city: "Aurillac",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 44.8975,
    longitude: 2.418056,
    icao: "LFLW"
  },
  AUS: {
    iata: "AUS",
    name: "Austin-Bergstrom International Airport",
    city: "Austin",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.202545,
    longitude: -97.667064,
    icao: "KAUS"
  },
  AUU: {
    iata: "AUU",
    name: "Aurukun Airport",
    city: "Aurukun",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -13.356451,
    longitude: 141.721917,
    icao: "YAUR"
  },
  AUW: {
    iata: "AUW",
    name: "Wausau Downtown Airport",
    city: "Wausau",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 44.926188,
    longitude: -89.626599,
    icao: "KAUW"
  },
  AUX: {
    iata: "AUX",
    name: "Araguaina Airport",
    city: "Araguaina",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -7.2,
    longitude: -48.2,
    icao: "SWGN"
  },
  AUZ: {
    iata: "AUZ",
    name: "Aurora Municipal Airport",
    city: "Aurora",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.770365,
    longitude: -88.471194,
    icao: "KARR"
  },
  AVA: {
    iata: "AVA",
    name: "Anshun Huangguoshu Airport",
    city: "An Shun",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 26.260049,
    longitude: 105.872814,
    icao: ""
  },
  AVB: {
    iata: "AVB",
    name: "Aviano Air Base",
    city: "Aviano",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 46.033333,
    longitude: 12.6,
    icao: "LIPA"
  },
  AVI: {
    iata: "AVI",
    name: "Maximo Gomez Airport",
    city: "Ciego De Avila",
    countryId: "CU",
    timeZoneRegionName: "America/Havana",
    latitude: 22.025,
    longitude: -78.791389,
    icao: "MUCA"
  },
  AVK: {
    iata: "AVK",
    name: "Arvaikheer Airport",
    city: "Arvaikheer",
    countryId: "MN",
    timeZoneRegionName: "Asia/Ulaanbaatar",
    latitude: 46.266667,
    longitude: 102.783333,
    icao: "ZMAH"
  },
  AVL: {
    iata: "AVL",
    name: "Asheville Regional Airport",
    city: "Asheville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 35.43508,
    longitude: -82.537314,
    icao: "KAVL"
  },
  AVN: {
    iata: "AVN",
    name: "Caumont Airport",
    city: "Avignon",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 43.906542,
    longitude: 4.902082,
    icao: "LFMV"
  },
  AVO: {
    iata: "AVO",
    name: "Avon Park Municipal Airport",
    city: "Avon Park",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 27.6,
    longitude: -81.516667,
    icao: "KAVO"
  },
  AVP: {
    iata: "AVP",
    name: "Wilkes-Barre/Scranton International Airport",
    city: "Wilkes-Barre",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.336698,
    longitude: -75.730643,
    icao: "KAVP"
  },
  AVR: {
    iata: "AVR",
    name: "Alverca Airport",
    city: "Alverca",
    countryId: "PT",
    timeZoneRegionName: "Europe/Lisbon",
    latitude: 38.885271,
    longitude: -9.033106,
    icao: "LPAR"
  },
  AVV: {
    iata: "AVV",
    name: "Avalon Airport",
    city: "Avalon",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -38.026372,
    longitude: 144.473084,
    icao: "YMAV"
  },
  AVW: {
    iata: "AVW",
    name: "Marana Regional Airport",
    city: "Tucson",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 32.407605,
    longitude: -111.215615,
    icao: "KAVQ"
  },
  AVX: {
    iata: "AVX",
    name: "Catalina Airport",
    city: "Avalon",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 33.4049,
    longitude: -118.416,
    icao: "KAVX"
  },
  AWA: {
    iata: "AWA",
    name: "Awasa Airport",
    city: "Awasa",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 7.062777,
    longitude: 38.490802,
    icao: "HALA"
  },
  AWD: {
    iata: "AWD",
    name: "Aniwa Airport",
    city: "Aniwa",
    countryId: "VU",
    timeZoneRegionName: "Pacific/Efate",
    latitude: -19.25,
    longitude: 169.5,
    icao: "NVVB"
  },
  AWK: {
    iata: "AWK",
    name: "Wake Island Airport",
    city: "Wake Island",
    countryId: "UM",
    timeZoneRegionName: "Pacific/Wake",
    latitude: 19.283333,
    longitude: 166.633333,
    icao: "PWAK"
  },
  AWM: {
    iata: "AWM",
    name: "West Memphis Municipal Airport",
    city: "West Memphis",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.137882,
    longitude: -90.231974,
    icao: "KAWM"
  },
  AWT: {
    iata: "AWT",
    name: "Awantipur Air Force Station",
    city: "Awantipur",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 33.876628,
    longitude: 74.975681,
    icao: "VIAW"
  },
  AWZ: {
    iata: "AWZ",
    name: "Ahwaz Airport",
    city: "Ahwaz",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 31.342921,
    longitude: 48.746682,
    icao: "OIAW"
  },
  AXA: {
    iata: "AXA",
    name: "Clayton J. Lloyd International Airport",
    city: "Anguilla",
    countryId: "AI",
    timeZoneRegionName: "America/Anguilla",
    latitude: 18.205944,
    longitude: -63.051754,
    icao: "TQPF"
  },
  AXC: {
    iata: "AXC",
    name: "Aramac Airport",
    city: "Aramac",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -22.958056,
    longitude: 145.2425,
    icao: "YAMC"
  },
  AXD: {
    iata: "AXD",
    name: "Demokritos Airport",
    city: "Alexandroupolis",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 40.856784,
    longitude: 25.944893,
    icao: "LGAL"
  },
  AXF: {
    iata: "AXF",
    name: "Alxa Left Banner Airport",
    city: "Alxa Left Banner",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 38.823318,
    longitude: 105.630964,
    icao: ""
  },
  AXG: {
    iata: "AXG",
    name: "Algona Airport",
    city: "Algona",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 43.066667,
    longitude: -94.233333,
    icao: "KAXA"
  },
  AXJ: {
    iata: "AXJ",
    name: "Amakusa Airport",
    city: "Amakusa",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 32.483262,
    longitude: 130.155645,
    icao: "RJDA"
  },
  AXK: {
    iata: "AXK",
    name: "Ataq Airport",
    city: "Ataq",
    countryId: "YE",
    timeZoneRegionName: "Asia/Aden",
    latitude: 13.866667,
    longitude: 46.3,
    icao: "ODAT"
  },
  AXM: {
    iata: "AXM",
    name: "El Eden Airport",
    city: "Armenia",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 4.452869,
    longitude: -75.768045,
    icao: "SKAR"
  },
  AXN: {
    iata: "AXN",
    name: "Chandler Field",
    city: "Alexandria",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 45.867222,
    longitude: -95.394167,
    icao: "KAXN"
  },
  AXP: {
    iata: "AXP",
    name: "Springpoint Airport",
    city: "Spring Point",
    countryId: "BS",
    timeZoneRegionName: "America/Nassau",
    latitude: 22.45,
    longitude: -73.966667,
    icao: "MYAP"
  },
  AXR: {
    iata: "AXR",
    name: "Arutua Airport",
    city: "Arutua",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -15.25,
    longitude: -146.75,
    icao: "NTGU"
  },
  AXS: {
    iata: "AXS",
    name: "Altus Municipal Airport",
    city: "Altus",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 34.696667,
    longitude: -99.338056,
    icao: "KAXS"
  },
  AXT: {
    iata: "AXT",
    name: "Akita Airport",
    city: "Akita",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 39.611771,
    longitude: 140.220147,
    icao: "RJSK"
  },
  AXU: {
    iata: "AXU",
    name: "Axum Airport",
    city: "Axum",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 14.120833,
    longitude: 38.716667,
    icao: "HAAX"
  },
  AXV: {
    iata: "AXV",
    name: "Neil Armstrong Airport",
    city: "Wapakoneta",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.566667,
    longitude: -84.2,
    icao: "KAXV"
  },
  AXX: {
    iata: "AXX",
    name: "Angel Fire Airport",
    city: "Angel Fire",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 36.419646,
    longitude: -105.290381,
    icao: "KAXX"
  },
  AYJ: {
    iata: "AYJ",
    name: "Ayodhya Airport",
    city: "Ayodhya",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 26.7525,
    longitude: 82.1572,
    icao: "VEAY"
  },
  AYP: {
    iata: "AYP",
    name: "Yanamilla Airport",
    city: "Ayacucho",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -13.197222,
    longitude: -74.247222,
    icao: "SPHO"
  },
  AYQ: {
    iata: "AYQ",
    name: "Connellan Airport",
    city: "Ayers Rock",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -25.190877,
    longitude: 130.976578,
    icao: "YAYE"
  },
  AYR: {
    iata: "AYR",
    name: "Ayr Airport",
    city: "Ayr",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -19.596667,
    longitude: 147.324444,
    icao: "YAYR"
  },
  AYS: {
    iata: "AYS",
    name: "Ware County Airport",
    city: "Waycross",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 31.248611,
    longitude: -82.396667,
    icao: "KAYS"
  },
  AYT: {
    iata: "AYT",
    name: "Antalya Airport",
    city: "Antalya",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 36.899282,
    longitude: 30.801349,
    icao: "LTAI"
  },
  AYX: {
    iata: "AYX",
    name: "Gerardo Perez Pinedo Airport",
    city: "Atalaya",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -10.73056,
    longitude: -73.768,
    icao: "SPAY"
  },
  AZA: {
    iata: "AZA",
    name: "Phoenix-Mesa Gateway Airport",
    city: "Mesa",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 33.307778,
    longitude: -111.655556,
    icao: "KIWA"
  },
  AZD: {
    iata: "AZD",
    name: "Yazd Airport",
    city: "Yazd",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 31.903602,
    longitude: 54.283264,
    icao: "OIYY"
  },
  AZI: {
    iata: "AZI",
    name: "Bateen Airport",
    city: "Abu Dhabi",
    countryId: "AE",
    timeZoneRegionName: "Asia/Dubai",
    latitude: 24.428429,
    longitude: 54.45961,
    icao: "OMAD"
  },
  AZN: {
    iata: "AZN",
    name: "Andizhan Airport",
    city: "Andizhan",
    countryId: "UZ",
    timeZoneRegionName: "Asia/Tashkent",
    latitude: 40.733333,
    longitude: 72.3,
    icao: "UZFA"
  },
  AZO: {
    iata: "AZO",
    name: "Kalamazoo/Battle Creek International Airport",
    city: "Kalamazoo",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.239962,
    longitude: -85.556553,
    icao: "KAZO"
  },
  AZR: {
    iata: "AZR",
    name: "Adrar Airport",
    city: "Adrar",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 27.883333,
    longitude: -0.283333,
    icao: "DAUA"
  },
  AZS: {
    iata: "AZS",
    name: "Samana El Catey Airport",
    city: "El Catey/Samana",
    countryId: "DO",
    timeZoneRegionName: "America/Santo_Domingo",
    latitude: 19.270555,
    longitude: -69.736944,
    icao: "MDCY"
  },
  AZZ: {
    iata: "AZZ",
    name: "Ambriz Airport",
    city: "Ambriz",
    countryId: "AO",
    timeZoneRegionName: "Africa/Luanda",
    latitude: -7.883333,
    longitude: 13.15,
    icao: "FNAM"
  },
  BAB: {
    iata: "BAB",
    name: "Beale Air Force Base",
    city: "Marysville",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 39.136103,
    longitude: -121.436957,
    icao: "KBAB"
  },
  BAD: {
    iata: "BAD",
    name: "Barksdale Air Force Base",
    city: "Shreveport",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.5,
    longitude: -93.666667,
    icao: "KBAD"
  },
  BAE: {
    iata: "BAE",
    name: "St-Pons Airport",
    city: "Barcelonnette",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 44.387189,
    longitude: 6.609135,
    icao: "LFMR"
  },
  BAF: {
    iata: "BAF",
    name: "Westfield-Barnes Regional Airport",
    city: "Springfield",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.157954,
    longitude: -72.715624,
    icao: "KBAF"
  },
  BAG: {
    iata: "BAG",
    name: "Loakan Airport",
    city: "Baguio",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 16.376667,
    longitude: 120.617778,
    icao: "RPUB"
  },
  BAH: {
    iata: "BAH",
    name: "Bahrain International Airport",
    city: "Bahrain",
    countryId: "BH",
    timeZoneRegionName: "Asia/Bahrain",
    latitude: 26.269181,
    longitude: 50.62605,
    icao: "OBBI"
  },
  BAI: {
    iata: "BAI",
    name: "Buenos Aires Airport",
    city: "Buenos Aires",
    countryId: "CR",
    timeZoneRegionName: "America/Costa_Rica",
    latitude: 9.166667,
    longitude: -83.333333,
    icao: "MRBA"
  },
  BAL: {
    iata: "BAL",
    name: "Batman Airport",
    city: "Batman",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 37.916667,
    longitude: 41.083333,
    icao: "LTCJ"
  },
  BAM: {
    iata: "BAM",
    name: "Lander County Airport",
    city: "Battle Mountain",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 40.633333,
    longitude: -116.933333,
    icao: "KBAM"
  },
  BAN: {
    iata: "BAN",
    name: "Basongo Airport",
    city: "Basongo",
    countryId: "CD",
    timeZoneRegionName: "Africa/Lubumbashi",
    latitude: -4.313333,
    longitude: 20.428056,
    icao: "FZVR"
  },
  BAQ: {
    iata: "BAQ",
    name: "Ernesto Cortissoz International Airport",
    city: "Barranquilla",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 10.889594,
    longitude: -74.780818,
    icao: "SKBQ"
  },
  BAR: {
    iata: "BAR",
    name: "Qionghai Bo'ao Airport",
    city: "Qionghai",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 19.139421,
    longitude: 110.456806,
    icao: ""
  },
  BAS: {
    iata: "BAS",
    name: "Balalae Airport",
    city: "Balalae",
    countryId: "SB",
    timeZoneRegionName: "Pacific/Guadalcanal",
    latitude: -6.993418,
    longitude: 155.883276,
    icao: "AGGE"
  },
  BAT: {
    iata: "BAT",
    name: "Barretos Airport",
    city: "Barretos",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -20.55,
    longitude: -48.55,
    icao: "SBBT"
  },
  BAV: {
    iata: "BAV",
    name: "Baotou Airport",
    city: "Baotou",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 40.563442,
    longitude: 109.998495,
    icao: "ZBOW"
  },
  BAX: {
    iata: "BAX",
    name: "Barnaul Airport",
    city: "Barnaul",
    countryId: "RU",
    timeZoneRegionName: "Asia/Barnaul",
    latitude: 53.361086,
    longitude: 83.547643,
    icao: "UNBB"
  },
  BAY: {
    iata: "BAY",
    name: "Baia Mare Airport",
    city: "Baia Mare",
    countryId: "RO",
    timeZoneRegionName: "Europe/Bucharest",
    latitude: 47.658213,
    longitude: 23.466204,
    icao: "LRBM"
  },
  BAZ: {
    iata: "BAZ",
    name: "Barbelos Airport",
    city: "Barbelos",
    countryId: "BR",
    timeZoneRegionName: "America/Porto_Velho",
    latitude: -0.966944,
    longitude: -62.933611,
    icao: "SWBC"
  },
  BBA: {
    iata: "BBA",
    name: "Teniente Vidal Airport",
    city: "Balmaceda",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -45.916667,
    longitude: -71.695,
    icao: "SCBA"
  },
  BBB: {
    iata: "BBB",
    name: "Benson Municipal Airport",
    city: "Benson",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 45.316667,
    longitude: -95.6,
    icao: "KBBB"
  },
  BBC: {
    iata: "BBC",
    name: "Bay City Airport",
    city: "Bay City",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 28.983333,
    longitude: -95.966667,
    icao: "KBYY"
  },
  BBD: {
    iata: "BBD",
    name: "Curtis Field",
    city: "Brady",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 31.133333,
    longitude: -99.333333,
    icao: "KBBD"
  },
  BBG: {
    iata: "BBG",
    name: "Butaritari Airport",
    city: "Butaritari",
    countryId: "KI",
    timeZoneRegionName: "Pacific/Tarawa",
    latitude: 3.166667,
    longitude: 172.75,
    icao: "NGTU"
  },
  BBH: {
    iata: "BBH",
    name: "Barth Airport",
    city: "Barth",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 54.339722,
    longitude: 12.711667,
    icao: "EDBH"
  },
  BBI: {
    iata: "BBI",
    name: "Biju Patnaik International Airport",
    city: "Bhubaneswar",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 20.252853,
    longitude: 85.817385,
    icao: "VEBS"
  },
  BBK: {
    iata: "BBK",
    name: "Kasane Airport",
    city: "Kasane",
    countryId: "BW",
    timeZoneRegionName: "Africa/Gaborone",
    latitude: -17.816667,
    longitude: 25.15,
    icao: "FBKE"
  },
  BBL: {
    iata: "BBL",
    name: "Ballera Airport",
    city: "Ballera",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -27.405497,
    longitude: 141.80998,
    icao: "YLLE"
  },
  BBM: {
    iata: "BBM",
    name: "Battambang Airport",
    city: "Battambang",
    countryId: "KH",
    timeZoneRegionName: "Asia/Phnom_Penh",
    latitude: 13.116667,
    longitude: 103.2,
    icao: "VDGB"
  },
  BBN: {
    iata: "BBN",
    name: "Bario Airport",
    city: "Bario",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 3.683333,
    longitude: 115.466667,
    icao: "WBGZ"
  },
  BBO: {
    iata: "BBO",
    name: "Berbera Airport",
    city: "Berbera",
    countryId: "SO",
    timeZoneRegionName: "Africa/Mogadishu",
    latitude: 10.419444,
    longitude: 45.006389,
    icao: "HCMI"
  },
  BBP: {
    iata: "BBP",
    name: "Bembridge Airport",
    city: "Bembridge",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 50.683333,
    longitude: -1.083333,
    icao: "EGHJ"
  },
  BBQ: {
    iata: "BBQ",
    name: "Barbuda Codrington Airport",
    city: "Barbuda",
    countryId: "AG",
    timeZoneRegionName: "America/Antigua",
    latitude: 17.636433,
    longitude: -61.826681,
    icao: "TAPH"
  },
  BBR: {
    iata: "BBR",
    name: "Baillif Airport",
    city: "Basse Terre",
    countryId: "GP",
    timeZoneRegionName: "America/Guadeloupe",
    latitude: 16.016389,
    longitude: -61.739444,
    icao: "TFFB"
  },
  BBS: {
    iata: "BBS",
    name: "Blackbush Airport",
    city: "Blackbush",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.333333,
    longitude: -0.85,
    icao: "EGLK"
  },
  BBT: {
    iata: "BBT",
    name: "Berberati Airport",
    city: "Berberati",
    countryId: "CF",
    timeZoneRegionName: "Africa/Bangui",
    latitude: 4.219167,
    longitude: 15.788056,
    icao: "FEFT"
  },
  BBU: {
    iata: "BBU",
    name: "Baneasa Airport",
    city: "Bucharest",
    countryId: "RO",
    timeZoneRegionName: "Europe/Bucharest",
    latitude: 44.495932,
    longitude: 26.080995,
    icao: "LRBS"
  },
  BBV: {
    iata: "BBV",
    name: "Bereby Airport",
    city: "Bereby",
    countryId: "CI",
    timeZoneRegionName: "Africa/Abidjan",
    latitude: 4.666667,
    longitude: -6.95,
    icao: "DIGN"
  },
  BBW: {
    iata: "BBW",
    name: "Broken Bow Municipal Airport",
    city: "Broken Bow",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.431867,
    longitude: -99.638354,
    icao: "KBBW"
  },
  BBX: {
    iata: "BBX",
    name: "Wings Field",
    city: "Blue Bell",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.136667,
    longitude: -75.2675,
    icao: "KLOM"
  },
  BBY: {
    iata: "BBY",
    name: "Bambari Airport",
    city: "Bambari",
    countryId: "CF",
    timeZoneRegionName: "Africa/Bangui",
    latitude: 5.845833,
    longitude: 20.649722,
    icao: "FEFM"
  },
  BBZ: {
    iata: "BBZ",
    name: "Zambezi Airport",
    city: "Zambezi",
    countryId: "ZM",
    timeZoneRegionName: "Africa/Lusaka",
    latitude: -13.537222,
    longitude: 23.11,
    icao: "FLZB"
  },
  BCA: {
    iata: "BCA",
    name: "Baracoa Airport",
    city: "Baracoa",
    countryId: "CU",
    timeZoneRegionName: "America/Havana",
    latitude: 20.35,
    longitude: -74.5,
    icao: "MUBA"
  },
  BCB: {
    iata: "BCB",
    name: "Virginia Tech Airport",
    city: "Blacksburg",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 37.233333,
    longitude: -80.416667,
    icao: "KBCB"
  },
  BCD: {
    iata: "BCD",
    name: "Silay International Airport",
    city: "Bacolod",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 10.7764,
    longitude: 123.014999,
    icao: "RPVB"
  },
  BCE: {
    iata: "BCE",
    name: "Bryce Airport",
    city: "Bryce",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 37.701111,
    longitude: -112.135278,
    icao: "KBCE"
  },
  BCH: {
    iata: "BCH",
    name: "Baucau Airport",
    city: "Baucau",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jayapura",
    latitude: -8.480239,
    longitude: 126.396437,
    icao: "WPEC"
  },
  BCI: {
    iata: "BCI",
    name: "Barcaldine Airport",
    city: "Barcaldine",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -23.559167,
    longitude: 145.301944,
    icao: "YBAR"
  },
  BCL: {
    iata: "BCL",
    name: "Barra del Colorado Airport",
    city: "Barra del Colorado",
    countryId: "CR",
    timeZoneRegionName: "America/Costa_Rica",
    latitude: 10.771923,
    longitude: -83.586633,
    icao: "MRBC"
  },
  BCM: {
    iata: "BCM",
    name: "Bacau Airport",
    city: "Bacau",
    countryId: "RO",
    timeZoneRegionName: "Europe/Bucharest",
    latitude: 46.5219,
    longitude: 26.910299,
    icao: "LRBC"
  },
  BCN: {
    iata: "BCN",
    name: "Barcelona-El Prat Airport",
    city: "Barcelona",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 41.303027,
    longitude: 2.07593,
    icao: "LEBL"
  },
  BCO: {
    iata: "BCO",
    name: "Bako Airport",
    city: "Jinka",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 5.783127,
    longitude: 36.562038,
    icao: "HABC"
  },
  BCT: {
    iata: "BCT",
    name: "Boca Raton Airport",
    city: "Boca Raton",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 26.379022,
    longitude: -80.107981,
    icao: "KBCT"
  },
  BCU: {
    iata: "BCU",
    name: "Bauchi Airport",
    city: "Bauchi",
    countryId: "NG",
    timeZoneRegionName: "Africa/Lagos",
    latitude: 10.299222,
    longitude: 9.817992,
    icao: "DNBA"
  },
  BDA: {
    iata: "BDA",
    name: "L.F. Wade International Airport",
    city: "Bermuda",
    countryId: "BM",
    timeZoneRegionName: "Atlantic/Bermuda",
    latitude: 32.35994,
    longitude: -64.701148,
    icao: "TXKF"
  },
  BDB: {
    iata: "BDB",
    name: "Bundaberg Airport",
    city: "Bundaberg",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -24.898709,
    longitude: 152.321873,
    icao: "YBUD"
  },
  BDC: {
    iata: "BDC",
    name: "Barra Do Corda Airport",
    city: "Barra Do Corda",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -5.466667,
    longitude: -45.266667,
    icao: "SNBC"
  },
  BDD: {
    iata: "BDD",
    name: "Badu Island Airport",
    city: "Badu Island",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -10.149247,
    longitude: 142.173303,
    icao: "YBAU"
  },
  BDE: {
    iata: "BDE",
    name: "Baudette Airport",
    city: "Baudette",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 48.722778,
    longitude: -94.606944,
    icao: "KBDE"
  },
  BDG: {
    iata: "BDG",
    name: "Blanding Airport",
    city: "Blanding",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 37.616667,
    longitude: -109.483333,
    icao: "KBDG"
  },
  BDH: {
    iata: "BDH",
    name: "Bandar Lengeh Airport",
    city: "Bandar Lengeh",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 26.529485,
    longitude: 54.829146,
    icao: "OIBL"
  },
  BDI: {
    iata: "BDI",
    name: "Bird Island Airport",
    city: "Bird Island",
    countryId: "SC",
    timeZoneRegionName: "Indian/Mahe",
    latitude: -3.716667,
    longitude: 55.216667,
    icao: "FSSB"
  },
  BDJ: {
    iata: "BDJ",
    name: "Syamsudin Noor International Airport",
    city: "Banjarmasin",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -3.43804,
    longitude: 114.754253,
    icao: "WAOO"
  },
  BDK: {
    iata: "BDK",
    name: "Bondoukou Airport",
    city: "Bondoukou",
    countryId: "CI",
    timeZoneRegionName: "Africa/Abidjan",
    latitude: 8.033333,
    longitude: -2.8,
    icao: "DIBU"
  },
  BDL: {
    iata: "BDL",
    name: "Bradley International Airport",
    city: "Hartford",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.92953,
    longitude: -72.684701,
    icao: "KBDL"
  },
  BDM: {
    iata: "BDM",
    name: "Bandirma Airport",
    city: "Bandirma",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 40.318333,
    longitude: 27.977222,
    icao: "LTBG"
  },
  BDO: {
    iata: "BDO",
    name: "Husein Sastranegara Airport",
    city: "Bandung",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: -6.904648,
    longitude: 107.581779,
    icao: "WICC"
  },
  BDP: {
    iata: "BDP",
    name: "Chandragadhi Airport",
    city: "Bhadrapur",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 26.533333,
    longitude: 88.083333,
    icao: ""
  },
  BDQ: {
    iata: "BDQ",
    name: "Vadodara Airport",
    city: "Vadodara",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 22.329077,
    longitude: 73.215701,
    icao: "VABO"
  },
  BDR: {
    iata: "BDR",
    name: "Igor I. Sikorsky Memorial Airport",
    city: "Bridgeport",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.164167,
    longitude: -73.124444,
    icao: "KBDR"
  },
  BDS: {
    iata: "BDS",
    name: "Brindisi - Salento Airport",
    city: "Brindisi",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 40.657995,
    longitude: 17.939053,
    icao: "LIBR"
  },
  BDT: {
    iata: "BDT",
    name: "Gbadolite Airport",
    city: "Gbadolite",
    countryId: "CD",
    timeZoneRegionName: "Africa/Kinshasa",
    latitude: 4.083333,
    longitude: 22.45,
    icao: "FZFD"
  },
  BDU: {
    iata: "BDU",
    name: "Bardufoss Airport",
    city: "Bardufoss",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 69.056111,
    longitude: 18.54,
    icao: "ENDU"
  },
  BDV: {
    iata: "BDV",
    name: "Moba Airport",
    city: "Moba",
    countryId: "CD",
    timeZoneRegionName: "Africa/Lubumbashi",
    latitude: -7,
    longitude: 29.8,
    icao: "FZRB"
  },
  BDX: {
    iata: "BDX",
    name: "Broadus Airport",
    city: "Broadus",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 45.466667,
    longitude: -105.366667,
    icao: "KBDX"
  },
  BEB: {
    iata: "BEB",
    name: "Benbecula Airport",
    city: "Benbecula",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 57.473414,
    longitude: -7.376028,
    icao: "EGPL"
  },
  BEC: {
    iata: "BEC",
    name: "Beech Airport",
    city: "Wichita",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 37.683333,
    longitude: -97.333333,
    icao: "KBEC"
  },
  BED: {
    iata: "BED",
    name: "Laurence G. Hanscom Field",
    city: "Bedford/Hanscom",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.470833,
    longitude: -71.29,
    icao: "KBED"
  },
  BEF: {
    iata: "BEF",
    name: "Bluefields Airport",
    city: "Bluefields",
    countryId: "NI",
    timeZoneRegionName: "America/Managua",
    latitude: 11.990889,
    longitude: -83.773942,
    icao: "MNBL"
  },
  BEG: {
    iata: "BEG",
    name: "Belgrad Nikola Tesla Airport",
    city: "Belgrade",
    countryId: "RS",
    timeZoneRegionName: "Europe/Belgrade",
    latitude: 44.819444,
    longitude: 20.306944,
    icao: "LYBE"
  },
  BEH: {
    iata: "BEH",
    name: "Southwest Michigan Regional Airport",
    city: "Benton Harbor",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.127778,
    longitude: -86.428333,
    icao: "KBEH"
  },
  BEI: {
    iata: "BEI",
    name: "Beica Airport",
    city: "Beica",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 9.391667,
    longitude: 34.533333,
    icao: "HABE"
  },
  BEJ: {
    iata: "BEJ",
    name: "Kalimarau Airport",
    city: "Berau",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: 2.155327,
    longitude: 117.433488,
    icao: "WALK"
  },
  BEK: {
    iata: "BEK",
    name: "Bareilly Airport",
    city: "Bareilly",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 28.423379,
    longitude: 79.447575,
    icao: "VIBY"
  },
  BEL: {
    iata: "BEL",
    name: "Val De Cans International Airport",
    city: "Belem",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -1.389865,
    longitude: -48.480003,
    icao: "SBBE"
  },
  BEM: {
    iata: "BEM",
    name: "Beni Mellal National Airport",
    city: "Beni Mellal",
    countryId: "MA",
    timeZoneRegionName: "Africa/Casablanca",
    latitude: 32.400744,
    longitude: -6.317363,
    icao: "GMMD"
  },
  BEN: {
    iata: "BEN",
    name: "Benina International Airport",
    city: "Benghazi",
    countryId: "LY",
    timeZoneRegionName: "Africa/Tripoli",
    latitude: 32.085423,
    longitude: 20.264891,
    icao: "HLLB"
  },
  BER: {
    iata: "BER",
    name: "Berlin Brandenburg Airport",
    city: "Berlin",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 52.366667,
    longitude: 13.503333,
    icao: "EDDB"
  },
  BES: {
    iata: "BES",
    name: "Brest Bretagne Airport",
    city: "Brest",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 48.443377,
    longitude: -4.420175,
    icao: "LFRB"
  },
  BET: {
    iata: "BET",
    name: "Bethel Airport",
    city: "Bethel",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 60.784444,
    longitude: -161.831389,
    icao: "PABE"
  },
  BEU: {
    iata: "BEU",
    name: "Bedourie Airport",
    city: "Bedourie",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -24.23,
    longitude: 139.445,
    icao: "YBIE"
  },
  BEV: {
    iata: "BEV",
    name: "Beer Sheba Airport",
    city: "Beer Sheba",
    countryId: "IL",
    timeZoneRegionName: "Asia/Jerusalem",
    latitude: 31.25,
    longitude: 34.8,
    icao: "LLBS"
  },
  BEW: {
    iata: "BEW",
    name: "Beira Airport",
    city: "Beira",
    countryId: "MZ",
    timeZoneRegionName: "Africa/Maputo",
    latitude: -19.798806,
    longitude: 34.901919,
    icao: "FQBR"
  },
  BEX: {
    iata: "BEX",
    name: "Benson RAF Station",
    city: "Benson",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.616115,
    longitude: -1.095776,
    icao: "EGUB"
  },
  BEY: {
    iata: "BEY",
    name: "Beirut-Rafic Hariri International Airport",
    city: "Beirut",
    countryId: "LB",
    timeZoneRegionName: "Asia/Beirut",
    latitude: 33.826073,
    longitude: 35.493082,
    icao: "OLBA"
  },
  BEZ: {
    iata: "BEZ",
    name: "Beru Airport",
    city: "Beru",
    countryId: "KI",
    timeZoneRegionName: "Pacific/Tarawa",
    latitude: -1.333333,
    longitude: 176,
    icao: "NGBR"
  },
  BFB: {
    iata: "BFB",
    name: "Bilbao Bus Station",
    city: "Bilbao",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 43.260921,
    longitude: -2.949244,
    icao: ""
  },
  BFD: {
    iata: "BFD",
    name: "Bradford Airport",
    city: "Bradford",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.802222,
    longitude: -78.639444,
    icao: "KBFD"
  },
  BFE: {
    iata: "BFE",
    name: "Bielefeld Airport",
    city: "Bielefeld",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 52.016667,
    longitude: 8.55,
    icao: "EDLI"
  },
  BFF: {
    iata: "BFF",
    name: "Western Nebraska Regional Airport",
    city: "Scottsbluff",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 41.873989,
    longitude: -103.595968,
    icao: "KBFF"
  },
  BFH: {
    iata: "BFH",
    name: "Bacacheri Airport",
    city: "Curitiba",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -25.4025,
    longitude: -49.233889,
    icao: "SBBI"
  },
  BFI: {
    iata: "BFI",
    name: "Boeing Field International Airport",
    city: "Seattle",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 47.530204,
    longitude: -122.302253,
    icao: "KBFI"
  },
  BFJ: {
    iata: "BFJ",
    name: "Bijie Feixiong Airport",
    city: "Bijie",
    countryId: "CN",
    timeZoneRegionName: "Asia/Chongqing",
    latitude: 27.2667,
    longitude: 105.4792,
    icao: "ZUBJ"
  },
  BFK: {
    iata: "BFK",
    name: "Buckley Air National Guard Base",
    city: "Denver",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 39.707224,
    longitude: -104.765732,
    icao: "KBKF"
  },
  BFL: {
    iata: "BFL",
    name: "Meadows Field Airport",
    city: "Bakersfield",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 35.437466,
    longitude: -119.055263,
    icao: "KBFL"
  },
  BFM: {
    iata: "BFM",
    name: "Mobile Downtown Airport",
    city: "Mobile",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.636651,
    longitude: -88.075247,
    icao: "KBFM"
  },
  BFN: {
    iata: "BFN",
    name: "Bram Fischer International Airport",
    city: "Bloemfontein",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -29.095853,
    longitude: 26.297516,
    icao: "FABL"
  },
  BFO: {
    iata: "BFO",
    name: "Buffalo Range Airport",
    city: "Buffalo Range",
    countryId: "ZW",
    timeZoneRegionName: "Africa/Harare",
    latitude: -21.009167,
    longitude: 31.579167,
    icao: "FVCZ"
  },
  BFP: {
    iata: "BFP",
    name: "Beaver Falls Airport",
    city: "Beaver Falls",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.766667,
    longitude: -80.4,
    icao: "KBVI"
  },
  BFR: {
    iata: "BFR",
    name: "Virgil I Grissom Municipal Airport",
    city: "Bedford",
    countryId: "US",
    timeZoneRegionName: "America/Indiana/Indianapolis",
    latitude: 38.866667,
    longitude: -86.483333,
    icao: "KBFR"
  },
  BFS: {
    iata: "BFS",
    name: "Belfast International Airport",
    city: "Belfast",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 54.662397,
    longitude: -6.217616,
    icao: "EGAA"
  },
  BFT: {
    iata: "BFT",
    name: "Beaufort County Airport",
    city: "Beaufort",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 32.410833,
    longitude: -80.635,
    icao: "KARW"
  },
  BFU: {
    iata: "BFU",
    name: "Bengbu Airport",
    city: "Bengbu",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 32.8475,
    longitude: 117.320278,
    icao: "ZSBB"
  },
  BFV: {
    iata: "BFV",
    name: "Buriram Airport",
    city: "Buriram",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 15.229444,
    longitude: 103.251111,
    icao: "VTUO"
  },
  BFX: {
    iata: "BFX",
    name: "Bafoussam Airport",
    city: "Bafoussam",
    countryId: "CM",
    timeZoneRegionName: "Africa/Douala",
    latitude: 5.531431,
    longitude: 10.355854,
    icao: "FKKU"
  },
  BGA: {
    iata: "BGA",
    name: "Palonegro International Airport",
    city: "Bucaramanga",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 7.128045,
    longitude: -73.181394,
    icao: "SKBG"
  },
  BGB: {
    iata: "BGB",
    name: "Booue Airport",
    city: "Booue",
    countryId: "GA",
    timeZoneRegionName: "Africa/Libreville",
    latitude: -0.106667,
    longitude: 11.938889,
    icao: "FOGB"
  },
  BGC: {
    iata: "BGC",
    name: "Braganca Airport",
    city: "Braganca",
    countryId: "PT",
    timeZoneRegionName: "Europe/Lisbon",
    latitude: 41.856158,
    longitude: -6.706141,
    icao: "LPBG"
  },
  BGD: {
    iata: "BGD",
    name: "Borger Airport",
    city: "Borger",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.65,
    longitude: -101.4,
    icao: "KBGD"
  },
  BGE: {
    iata: "BGE",
    name: "Decatur County Airport",
    city: "Bainbridge",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 30.916667,
    longitude: -84.583333,
    icao: "KBGE"
  },
  BGF: {
    iata: "BGF",
    name: "M'poko International Airport",
    city: "Bangui",
    countryId: "CF",
    timeZoneRegionName: "Africa/Bangui",
    latitude: 4.396111,
    longitude: 18.520278,
    icao: "FEFF"
  },
  BGG: {
    iata: "BGG",
    name: "Bingol Airport",
    city: "Bingol",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 38.86,
    longitude: 40.593889,
    icao: "LTCU"
  },
  BGH: {
    iata: "BGH",
    name: "Abbaye Airport",
    city: "Boghe",
    countryId: "MR",
    timeZoneRegionName: "Africa/Nouakchott",
    latitude: 16.633333,
    longitude: -14.2,
    icao: "GQNE"
  },
  BGI: {
    iata: "BGI",
    name: "Grantley Adams International Airport",
    city: "Bridgetown",
    countryId: "BB",
    timeZoneRegionName: "America/Barbados",
    latitude: 13.080732,
    longitude: -59.487835,
    icao: "TBPB"
  },
  BGL: {
    iata: "BGL",
    name: "Baglung Airport",
    city: "Baglung",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 28.215278,
    longitude: 83.683333,
    icao: "VNBL"
  },
  BGM: {
    iata: "BGM",
    name: "Greater Binghamton Airport",
    city: "Binghamton",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.208533,
    longitude: -75.982944,
    icao: "KBGM"
  },
  BGN: {
    iata: "BGN",
    name: "Belaya Gora Airport",
    city: "Belaya Gora",
    countryId: "RU",
    timeZoneRegionName: "Asia/Srednekolymsk",
    latitude: 68.555771,
    longitude: 146.22973,
    icao: "UESG"
  },
  BGO: {
    iata: "BGO",
    name: "Bergen Airport",
    city: "Bergen",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 60.289064,
    longitude: 5.228169,
    icao: "ENBR"
  },
  BGR: {
    iata: "BGR",
    name: "Bangor International Airport",
    city: "Bangor",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 44.808699,
    longitude: -68.817799,
    icao: "KBGR"
  },
  BGS: {
    iata: "BGS",
    name: "Boguchany Airport",
    city: "Boguchany",
    countryId: "RU",
    timeZoneRegionName: "Asia/Krasnoyarsk",
    latitude: 58.380615,
    longitude: 97.472336,
    icao: ""
  },
  BGU: {
    iata: "BGU",
    name: "Bangassou Airport",
    city: "Bangassou",
    countryId: "CF",
    timeZoneRegionName: "Africa/Bangui",
    latitude: 4.786667,
    longitude: 22.784444,
    icao: "FEFG"
  },
  BGW: {
    iata: "BGW",
    name: "Baghdad International Airport",
    city: "Baghdad",
    countryId: "IQ",
    timeZoneRegionName: "Asia/Baghdad",
    latitude: 33.2625,
    longitude: 44.234444,
    icao: "ORBI"
  },
  BGX: {
    iata: "BGX",
    name: "Bage Airport",
    city: "Bage",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -31.398611,
    longitude: -54.1125,
    icao: "SBBG"
  },
  BGY: {
    iata: "BGY",
    name: "Orio al Serio International Airport",
    city: "Milan",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 45.665315,
    longitude: 9.698713,
    icao: "LIME"
  },
  BGZ: {
    iata: "BGZ",
    name: "Braga Airport",
    city: "Braga",
    countryId: "PT",
    timeZoneRegionName: "Europe/Lisbon",
    latitude: 41.55,
    longitude: -8.433333,
    icao: "LPBR"
  },
  BHA: {
    iata: "BHA",
    name: "Bahia De Caraquez Airport",
    city: "Bahia De Caraquez",
    countryId: "EC",
    timeZoneRegionName: "America/Guayaquil",
    latitude: -0.6,
    longitude: -80.416667,
    icao: "SESV"
  },
  BHB: {
    iata: "BHB",
    name: "Bar Harbor Airport",
    city: "Bar Harbor",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 44.448889,
    longitude: -68.361667,
    icao: "KBHB"
  },
  BHD: {
    iata: "BHD",
    name: "George Best Belfast City Airport",
    city: "Belfast",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 54.61452,
    longitude: -5.870215,
    icao: "EGAC"
  },
  BHE: {
    iata: "BHE",
    name: "Woodbourne Airport",
    city: "Blenheim",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -41.51779,
    longitude: 173.871084,
    icao: "NZWB"
  },
  BHH: {
    iata: "BHH",
    name: "Bisha Airport",
    city: "Bisha",
    countryId: "SA",
    timeZoneRegionName: "Asia/Riyadh",
    latitude: 19.994509,
    longitude: 42.618485,
    icao: "OEBH"
  },
  BHI: {
    iata: "BHI",
    name: "Comandante Espora Airport",
    city: "Bahia Blanca",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -38.730556,
    longitude: -62.150556,
    icao: "SAZB"
  },
  BHJ: {
    iata: "BHJ",
    name: "Rudra Mata Airport",
    city: "Bhuj",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 23.2875,
    longitude: 69.670556,
    icao: "VABJ"
  },
  BHK: {
    iata: "BHK",
    name: "Bukhara Airport",
    city: "Bukhara",
    countryId: "UZ",
    timeZoneRegionName: "Asia/Tashkent",
    latitude: 39.760369,
    longitude: 64.474792,
    icao: "UTSB"
  },
  BHM: {
    iata: "BHM",
    name: "Birmingham-Shuttlesworth International Airport",
    city: "Birmingham",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 33.560834,
    longitude: -86.752189,
    icao: "KBHM"
  },
  BHN: {
    iata: "BHN",
    name: "Beihan Airport",
    city: "Beihan",
    countryId: "YE",
    timeZoneRegionName: "Asia/Aden",
    latitude: 14.783333,
    longitude: 45.733333,
    icao: "OYBN"
  },
  BHO: {
    iata: "BHO",
    name: "Raja Bhoj Airport",
    city: "Bhopal",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 23.290623,
    longitude: 77.335531,
    icao: "VABP"
  },
  BHP: {
    iata: "BHP",
    name: "Bhojpur Airport",
    city: "Bhojpur",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 27.1478,
    longitude: 87.051044,
    icao: "VNBJ"
  },
  BHQ: {
    iata: "BHQ",
    name: "Broken Hill Airport",
    city: "Broken Hill",
    countryId: "AU",
    timeZoneRegionName: "Australia/Adelaide",
    latitude: -32.000589,
    longitude: 141.468921,
    icao: "YBHI"
  },
  BHR: {
    iata: "BHR",
    name: "Bharatpur Airport",
    city: "Bharatpur",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 27.676389,
    longitude: 84.4325,
    icao: "VNBP"
  },
  BHS: {
    iata: "BHS",
    name: "Raglan Airport",
    city: "Bathurst",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -33.413872,
    longitude: 149.655181,
    icao: "YBTH"
  },
  BHU: {
    iata: "BHU",
    name: "Bhavnagar Airport",
    city: "Bhavnagar",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 21.755,
    longitude: 72.184444,
    icao: "VABV"
  },
  BHV: {
    iata: "BHV",
    name: "Bahawalpur Airport",
    city: "Bahawalpur",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 29.4,
    longitude: 71.683333,
    icao: "OPBW"
  },
  BHX: {
    iata: "BHX",
    name: "Birmingham International Airport",
    city: "Birmingham",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 52.452518,
    longitude: -1.733256,
    icao: "EGBB"
  },
  BHY: {
    iata: "BHY",
    name: "Beihai Fucheng Airport",
    city: "Beihai",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 21.5431,
    longitude: 109.288702,
    icao: "ZGBH"
  },
  BIA: {
    iata: "BIA",
    name: "Bastia Poretta Airport",
    city: "Bastia",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 42.547616,
    longitude: 9.480124,
    icao: "LFKB"
  },
  BIB: {
    iata: "BIB",
    name: "Baidoa Airport",
    city: "Baidoa",
    countryId: "SO",
    timeZoneRegionName: "Africa/Mogadishu",
    latitude: 3.10504,
    longitude: 43.630635,
    icao: "HCMB"
  },
  BID: {
    iata: "BID",
    name: "Block Island Airport",
    city: "Block Island",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.169432,
    longitude: -71.579613,
    icao: "KBID"
  },
  BIE: {
    iata: "BIE",
    name: "Beatrice Municipal Airport",
    city: "Beatrice",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 40.3,
    longitude: -96.75,
    icao: "KBIE"
  },
  BIF: {
    iata: "BIF",
    name: "Biggs Army Air Field",
    city: "El Paso",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 31.854273,
    longitude: -106.375514,
    icao: "KBIF"
  },
  BIH: {
    iata: "BIH",
    name: "Eastern Sierra Regional Airport",
    city: "Bishop",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 37.373333,
    longitude: -118.365,
    icao: "KBIH"
  },
  BIK: {
    iata: "BIK",
    name: "Frans Kaisiepo Airport",
    city: "Biak",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jayapura",
    latitude: -1.189503,
    longitude: 136.107301,
    icao: "WABB"
  },
  BIL: {
    iata: "BIL",
    name: "Billings Logan International Airport",
    city: "Billings",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 45.803419,
    longitude: -108.537229,
    icao: "KBIL"
  },
  BIM: {
    iata: "BIM",
    name: "Bimini International Airport",
    city: "Bimini",
    countryId: "BS",
    timeZoneRegionName: "America/Nassau",
    latitude: 25.700065,
    longitude: -79.26399,
    icao: "MYBS"
  },
  BIN: {
    iata: "BIN",
    name: "Bamiyan Airport",
    city: "Bamiyan",
    countryId: "AF",
    timeZoneRegionName: "Asia/Kabul",
    latitude: 34.813272,
    longitude: 67.830777,
    icao: "OABN"
  },
  BIO: {
    iata: "BIO",
    name: "Bilbao Airport",
    city: "Bilbao",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 43.305535,
    longitude: -2.905808,
    icao: "LEBB"
  },
  BIQ: {
    iata: "BIQ",
    name: "Biarritz Pays Basque Airport",
    city: "Biarritz",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 43.466478,
    longitude: -1.521784,
    icao: "LFBZ"
  },
  BIR: {
    iata: "BIR",
    name: "Biratnagar Airport",
    city: "Biratnagar",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 26.483439,
    longitude: 87.266187,
    icao: "VNVT"
  },
  BIS: {
    iata: "BIS",
    name: "Bismarck Airport",
    city: "Bismarck",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 46.77448,
    longitude: -100.758211,
    icao: "KBIS"
  },
  BIT: {
    iata: "BIT",
    name: "Patan Airport",
    city: "Baitadi",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 29.465284,
    longitude: 80.546758,
    icao: "VNBT"
  },
  BIU: {
    iata: "BIU",
    name: "Bildudalur Airport",
    city: "Bildudalur",
    countryId: "IS",
    timeZoneRegionName: "Atlantic/Reykjavik",
    latitude: 65.833333,
    longitude: -23.983333,
    icao: "BIBD"
  },
  BIV: {
    iata: "BIV",
    name: "Bria Airport",
    city: "Bria",
    countryId: "CF",
    timeZoneRegionName: "Africa/Bangui",
    latitude: 6.533333,
    longitude: 21.983333,
    icao: "FEFR"
  },
  BIX: {
    iata: "BIX",
    name: "Keesler Air Force Base",
    city: "Biloxi",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.41129,
    longitude: -88.923622,
    icao: "KBIX"
  },
  BIY: {
    iata: "BIY",
    name: "Bisho Airport",
    city: "Bisho",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -35.883333,
    longitude: 27.283333,
    icao: "FABE"
  },
  BJA: {
    iata: "BJA",
    name: "Bejaia Airport",
    city: "Bejaia",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 36.75,
    longitude: 5.083333,
    icao: "DAAE"
  },
  BJB: {
    iata: "BJB",
    name: "Bojnord Airport",
    city: "Bojnord",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 37.489719,
    longitude: 57.308849,
    icao: "OIMN"
  },
  BJC: {
    iata: "BJC",
    name: "Rocky Mountain Metropolitan Airport",
    city: "Broomfield",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 39.910441,
    longitude: -105.117236,
    icao: "KBJC"
  },
  BJF: {
    iata: "BJF",
    name: "Batsfjord Airport",
    city: "Batsfjord",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 70.6,
    longitude: 29.666667,
    icao: "ENBS"
  },
  BJH: {
    iata: "BJH",
    name: "Bajhang Airport",
    city: "Bajhang",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 29.55,
    longitude: 81.25,
    icao: "VNBG"
  },
  BJI: {
    iata: "BJI",
    name: "Bemidji Airport",
    city: "Bemidji",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 47.509722,
    longitude: -94.934722,
    icao: "KBJI"
  },
  BJJ: {
    iata: "BJJ",
    name: "Wayne County Airport",
    city: "Wooster",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.8,
    longitude: -81.933333,
    icao: "KBJJ"
  },
  BJL: {
    iata: "BJL",
    name: "Banjul International Airport",
    city: "Banjul",
    countryId: "GM",
    timeZoneRegionName: "Africa/Banjul",
    latitude: 13.34406,
    longitude: -16.6522,
    icao: "GBYD"
  },
  BJM: {
    iata: "BJM",
    name: "Bujumbura International Airport",
    city: "Bujumbura",
    countryId: "BI",
    timeZoneRegionName: "Africa/Bujumbura",
    latitude: -3.320557,
    longitude: 29.320148,
    icao: "HBBA"
  },
  BJO: {
    iata: "BJO",
    name: "Bermejo Airport",
    city: "Bermejo",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -22.866667,
    longitude: -64.333333,
    icao: "SLBJ"
  },
  BJP: {
    iata: "BJP",
    name: "Arthur Siqueira State Airport",
    city: "Braganca Paulista",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -22.974502,
    longitude: -46.521832,
    icao: "SDBP"
  },
  BJR: {
    iata: "BJR",
    name: "Bahar Dar Airport",
    city: "Bahar Dar",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 11.603292,
    longitude: 37.32324,
    icao: "HABD"
  },
  BJU: {
    iata: "BJU",
    name: "Bajura Airport",
    city: "Bajura",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 29.366667,
    longitude: 81.333333,
    icao: "VNBR"
  },
  BJV: {
    iata: "BJV",
    name: "Milas-Bodrum Airport",
    city: "Bodrum",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 37.243952,
    longitude: 27.672781,
    icao: "LTFE"
  },
  BJW: {
    iata: "BJW",
    name: "Bajawa Soa Airport",
    city: "Bajawa",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -8.813029,
    longitude: 120.998515,
    icao: "WATB"
  },
  BJX: {
    iata: "BJX",
    name: "Del Bajio International Airport",
    city: "Leon/Guanajuato",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 20.9935,
    longitude: -101.481003,
    icao: "MMLO"
  },
  BJY: {
    iata: "BJY",
    name: "Batajnica Airbase",
    city: "Belgrade",
    countryId: "RS",
    timeZoneRegionName: "Europe/Belgrade",
    latitude: 44.935278,
    longitude: 20.2575,
    icao: "LYBT"
  },
  BJZ: {
    iata: "BJZ",
    name: "Badajoz Airport",
    city: "Badajoz",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 38.893312,
    longitude: -6.819564,
    icao: "LEBZ"
  },
  BKA: {
    iata: "BKA",
    name: "Baykit Airport",
    city: "Baykit",
    countryId: "RU",
    timeZoneRegionName: "Asia/Krasnoyarsk",
    latitude: 61.677768,
    longitude: 96.354265,
    icao: "UNIB"
  },
  BKB: {
    iata: "BKB",
    name: "Nal Airport",
    city: "Bikaner",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 28.070601,
    longitude: 73.207199,
    icao: "VIBK"
  },
  BKC: {
    iata: "BKC",
    name: "Buckland Airport",
    city: "Buckland",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 65.978889,
    longitude: -161.126667,
    icao: "PABL"
  },
  BKD: {
    iata: "BKD",
    name: "Stephens County Airport",
    city: "Breckenridge",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.75,
    longitude: -98.9,
    icao: "KBKD"
  },
  BKE: {
    iata: "BKE",
    name: "Baker Airport",
    city: "Baker",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 44.838333,
    longitude: -117.81,
    icao: "KBKE"
  },
  BKG: {
    iata: "BKG",
    name: "Branson Airport",
    city: "Hollister",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.532082,
    longitude: -93.200544,
    icao: "KBBG"
  },
  BKH: {
    iata: "BKH",
    name: "Barking Sands Airport",
    city: "Kekaha",
    countryId: "US",
    timeZoneRegionName: "Pacific/Honolulu",
    latitude: 22.017555,
    longitude: -159.765001,
    icao: "PHBK"
  },
  BKI: {
    iata: "BKI",
    name: "Kota Kinabalu International Airport",
    city: "Kota Kinabalu",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 5.923961,
    longitude: 116.050753,
    icao: "WBKK"
  },
  BKJ: {
    iata: "BKJ",
    name: "Baralande Airport",
    city: "Boke",
    countryId: "GN",
    timeZoneRegionName: "Africa/Conakry",
    latitude: 10.965816,
    longitude: -14.281276,
    icao: "GUOK"
  },
  BKK: {
    iata: "BKK",
    name: "Suvarnabhumi Airport",
    city: "Bangkok",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 13.693062,
    longitude: 100.752044,
    icao: "VTBS"
  },
  BKL: {
    iata: "BKL",
    name: "Burke Lakefront Airport",
    city: "Cleveland",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.516944,
    longitude: -81.683333,
    icao: "KBKL"
  },
  BKM: {
    iata: "BKM",
    name: "Bakelalan Airport",
    city: "Bakalalan",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 3.966667,
    longitude: 115.616667,
    icao: "WBGQ"
  },
  BKN: {
    iata: "BKN",
    name: "Balkanabat Airport",
    city: "Balkanabat",
    countryId: "TM",
    timeZoneRegionName: "Asia/Ashgabat",
    latitude: 39.480701,
    longitude: 54.366503,
    icao: ""
  },
  BKO: {
    iata: "BKO",
    name: "Bamako-Senou International Airport",
    city: "Bamako",
    countryId: "ML",
    timeZoneRegionName: "Africa/Bamako",
    latitude: 12.540926,
    longitude: -7.947951,
    icao: "GABS"
  },
  BKQ: {
    iata: "BKQ",
    name: "Blackall Airport",
    city: "Blackall",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -24.434167,
    longitude: 145.428333,
    icao: "YBCK"
  },
  BKR: {
    iata: "BKR",
    name: "Bokoro Airport",
    city: "Bokoro",
    countryId: "TD",
    timeZoneRegionName: "Africa/Ndjamena",
    latitude: 12.416667,
    longitude: 17.233333,
    icao: "FTTK"
  },
  BKS: {
    iata: "BKS",
    name: "Fatmawati Soekarno Airport",
    city: "Bengkulu",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: -3.860561,
    longitude: 102.338273,
    icao: "WIPL"
  },
  BKT: {
    iata: "BKT",
    name: "Blackstone Army Air Field",
    city: "Blackstone",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 37.066667,
    longitude: -78,
    icao: "KBKT"
  },
  BKW: {
    iata: "BKW",
    name: "Raleigh County Memorial Airport",
    city: "Beckley",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 37.781944,
    longitude: -81.124167,
    icao: "KBKW"
  },
  BKX: {
    iata: "BKX",
    name: "Brookings Airport",
    city: "Brookings",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 44.303333,
    longitude: -96.811111,
    icao: "KBKX"
  },
  BKY: {
    iata: "BKY",
    name: "Kavumu Airport",
    city: "Bukavu",
    countryId: "CD",
    timeZoneRegionName: "Africa/Lubumbashi",
    latitude: -2.308978,
    longitude: 28.808803,
    icao: "FZMA"
  },
  BKZ: {
    iata: "BKZ",
    name: "Bukoba Airport",
    city: "Bukoba",
    countryId: "TZ",
    timeZoneRegionName: "Africa/Dar_es_Salaam",
    latitude: -1.331923,
    longitude: 31.82253,
    icao: "HTBU"
  },
  BLA: {
    iata: "BLA",
    name: "General Jose Antonio Anzoategui International Airport",
    city: "Barcelona",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 10.107936,
    longitude: -64.685894,
    icao: "SVBC"
  },
  BLB: {
    iata: "BLB",
    name: "Panama Pacifico Airport",
    city: "Balboa",
    countryId: "PA",
    timeZoneRegionName: "America/Panama",
    latitude: 8.914011,
    longitude: -79.598088,
    icao: "MPPA"
  },
  BLD: {
    iata: "BLD",
    name: "Boulder City Municipal Airport",
    city: "Boulder City",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 35.946778,
    longitude: -114.856374,
    icao: ""
  },
  BLE: {
    iata: "BLE",
    name: "Dala Airport",
    city: "Borlange/Falun",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 60.429731,
    longitude: 15.50826,
    icao: "ESSD"
  },
  BLF: {
    iata: "BLF",
    name: "Mercer County Airport",
    city: "Bluefield",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 37.295833,
    longitude: -81.208056,
    icao: "KBLF"
  },
  BLH: {
    iata: "BLH",
    name: "Blythe Airport",
    city: "Blythe",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 33.620833,
    longitude: -114.718889,
    icao: "KBLH"
  },
  BLI: {
    iata: "BLI",
    name: "Bellingham International Airport",
    city: "Bellingham",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 48.795733,
    longitude: -122.532672,
    icao: "KBLI"
  },
  BLJ: {
    iata: "BLJ",
    name: "Mostepha Ben Boulaid Airport",
    city: "Batna",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 35.752548,
    longitude: 6.310521,
    icao: "DABT"
  },
  BLK: {
    iata: "BLK",
    name: "Blackpool Airport",
    city: "Blackpool",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 53.778387,
    longitude: -3.041985,
    icao: "EGNH"
  },
  BLL: {
    iata: "BLL",
    name: "Billund Airport",
    city: "Billund",
    countryId: "DK",
    timeZoneRegionName: "Europe/Copenhagen",
    latitude: 55.747382,
    longitude: 9.147874,
    icao: "EKBI"
  },
  BLM: {
    iata: "BLM",
    name: "Monmouth Executive Airport",
    city: "Belmar",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.184548,
    longitude: -74.122223,
    icao: "KBLM"
  },
  BLN: {
    iata: "BLN",
    name: "Benalla Airport",
    city: "Benalla",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -36.55,
    longitude: 145.983333,
    icao: "YBLA"
  },
  BLO: {
    iata: "BLO",
    name: "Blonduos Airport",
    city: "Blonduos",
    countryId: "IS",
    timeZoneRegionName: "Atlantic/Reykjavik",
    latitude: 65.666667,
    longitude: -20.3,
    icao: "BIBL"
  },
  BLP: {
    iata: "BLP",
    name: "Bellavista Airport",
    city: "Bellavista",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -16.583333,
    longitude: -69.416667,
    icao: "SPBL"
  },
  BLQ: {
    iata: "BLQ",
    name: "Guglielmo Marconi Airport",
    city: "Bologna",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 44.529268,
    longitude: 11.293289,
    icao: "LIPE"
  },
  BLR: {
    iata: "BLR",
    name: "Kempegowda International Airport",
    city: "Bengaluru",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 13.200771,
    longitude: 77.710228,
    icao: "VOBL"
  },
  BLS: {
    iata: "BLS",
    name: "Bollon Airport",
    city: "Bollon",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -28.05,
    longitude: 147.483333,
    icao: "YBLL"
  },
  BLT: {
    iata: "BLT",
    name: "Blackwater Airport",
    city: "Blackwater",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -23.602184,
    longitude: 148.808401,
    icao: "YBTR"
  },
  BLU: {
    iata: "BLU",
    name: "Blue Canyon Airport",
    city: "Blue Canyon",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 39.25,
    longitude: -120.716667,
    icao: "KBLU"
  },
  BLV: {
    iata: "BLV",
    name: "MidAmerica St. Louis Airport / Scott AFB",
    city: "Belleville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 38.547326,
    longitude: -89.815909,
    icao: "KBLV"
  },
  BLW: {
    iata: "BLW",
    name: "Beletwene Airport",
    city: "Beletwene",
    countryId: "SO",
    timeZoneRegionName: "Africa/Mogadishu",
    latitude: 4.766305,
    longitude: 45.238472,
    icao: "HCMN"
  },
  BLX: {
    iata: "BLX",
    name: "Belluno Airport",
    city: "Belluno",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 46.15,
    longitude: 12.216667,
    icao: "LIDB"
  },
  BLY: {
    iata: "BLY",
    name: "Belmullet Airport",
    city: "Belmullet",
    countryId: "IE",
    timeZoneRegionName: "Europe/Dublin",
    latitude: 54.233333,
    longitude: -10,
    icao: "EIBT"
  },
  BLZ: {
    iata: "BLZ",
    name: "Chileka Airport",
    city: "Blantyre",
    countryId: "MW",
    timeZoneRegionName: "Africa/Blantyre",
    latitude: -15.674722,
    longitude: 34.970833,
    icao: "FWCL"
  },
  BMA: {
    iata: "BMA",
    name: "Bromma Airport",
    city: "Stockholm",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 59.35566,
    longitude: 17.946079,
    icao: "ESSB"
  },
  BMB: {
    iata: "BMB",
    name: "Bumba Airport",
    city: "Bumba",
    countryId: "CD",
    timeZoneRegionName: "Africa/Kinshasa",
    latitude: 2.182778,
    longitude: 22.481667,
    icao: "FZFU"
  },
  BMC: {
    iata: "BMC",
    name: "Brigham City Airport",
    city: "Brigham City",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 41.549167,
    longitude: -112.062222,
    icao: "KBMC"
  },
  BMD: {
    iata: "BMD",
    name: "Belo sur Tsiribihina Airport",
    city: "Belo sur Tsiribihina",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -19.689339,
    longitude: 44.544843,
    icao: "FMML"
  },
  BME: {
    iata: "BME",
    name: "Broome Airport",
    city: "Broome",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -17.952641,
    longitude: 122.23429,
    icao: "YBRM"
  },
  BMG: {
    iata: "BMG",
    name: "Monroe County Airport",
    city: "Bloomington",
    countryId: "US",
    timeZoneRegionName: "America/Indiana/Indianapolis",
    latitude: 39.14,
    longitude: -86.614722,
    icao: "KBMG"
  },
  BMI: {
    iata: "BMI",
    name: "Central Illinois Regional Airport",
    city: "Bloomington",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 40.48401,
    longitude: -88.914834,
    icao: "KBMI"
  },
  BMK: {
    iata: "BMK",
    name: "Borkum Airport",
    city: "Borkum",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 53.59639,
    longitude: 6.709167,
    icao: "EDWR"
  },
  BML: {
    iata: "BML",
    name: "Berlin Airport",
    city: "Berlin",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 44.574722,
    longitude: -71.176389,
    icao: "KBML"
  },
  BMM: {
    iata: "BMM",
    name: "Bitam Airport",
    city: "Bitam",
    countryId: "GA",
    timeZoneRegionName: "Africa/Libreville",
    latitude: 2.075833,
    longitude: 11.490833,
    icao: "FOOB"
  },
  BMO: {
    iata: "BMO",
    name: "Banmaw Airport",
    city: "Bhamo",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 24.268355,
    longitude: 97.249057,
    icao: "VYBM"
  },
  BMP: {
    iata: "BMP",
    name: "Brampton Island Airport",
    city: "Brampton Island",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -20.783333,
    longitude: 149.233333,
    icao: "YBPI"
  },
  BMR: {
    iata: "BMR",
    name: "Baltrum Airport",
    city: "Baltrum",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 53.716667,
    longitude: 7.4,
    icao: "EDWZ"
  },
  BMT: {
    iata: "BMT",
    name: "Beaumont Municipal Airport",
    city: "Beaumont",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.0707,
    longitude: -94.215797,
    icao: "KBMT"
  },
  BMU: {
    iata: "BMU",
    name: "Sultan Muhammad Salahuddin Airport",
    city: "Bima",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -8.542521,
    longitude: 118.691765,
    icao: "WADB"
  },
  BMV: {
    iata: "BMV",
    name: "Phung-Duc Airport",
    city: "Banmethuot",
    countryId: "VN",
    timeZoneRegionName: "Asia/Ho_Chi_Minh",
    latitude: 12.666667,
    longitude: 108.05,
    icao: "VVBM"
  },
  BMW: {
    iata: "BMW",
    name: "Bordj Badji Mokhtar Airport",
    city: "Bordj Badji Mokhtar",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 21.375816,
    longitude: 0.926334,
    icao: "DATM"
  },
  BMY: {
    iata: "BMY",
    name: "Belep Island Airport",
    city: "Belep Island",
    countryId: "NC",
    timeZoneRegionName: "Pacific/Noumea",
    latitude: -19.75,
    longitude: 163.666667,
    icao: "NWWC"
  },
  BNA: {
    iata: "BNA",
    name: "Nashville International Airport",
    city: "Nashville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.13174,
    longitude: -86.668945,
    icao: "KBNA"
  },
  BNB: {
    iata: "BNB",
    name: "Boende Airport",
    city: "Boende",
    countryId: "CD",
    timeZoneRegionName: "Africa/Kinshasa",
    latitude: -0.286845,
    longitude: 20.883973,
    icao: "FZGN"
  },
  BNC: {
    iata: "BNC",
    name: "Beni Airport",
    city: "Beni",
    countryId: "CD",
    timeZoneRegionName: "Africa/Lubumbashi",
    latitude: 0.577121,
    longitude: 29.470181,
    icao: "FZNP"
  },
  BND: {
    iata: "BND",
    name: "Bandar Abbas International Airport",
    city: "Bandar Abbas",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 27.21059,
    longitude: 56.368384,
    icao: "OIKB"
  },
  BNE: {
    iata: "BNE",
    name: "Brisbane Airport",
    city: "Brisbane",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -27.403031,
    longitude: 153.109058,
    icao: "YBBN"
  },
  BNG: {
    iata: "BNG",
    name: "Banning Airport",
    city: "Banning",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 33.933333,
    longitude: -116.866667,
    icao: "KBNG"
  },
  BNI: {
    iata: "BNI",
    name: "Benin City Airport",
    city: "Benin City",
    countryId: "NG",
    timeZoneRegionName: "Africa/Lagos",
    latitude: 6.316943,
    longitude: 5.603863,
    icao: "DNBE"
  },
  BNJ: {
    iata: "BNJ",
    name: "Bonn Hbf Railway Station",
    city: "Bonn",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 50.9406645,
    longitude: 6.9599115,
    icao: ""
  },
  BNK: {
    iata: "BNK",
    name: "Ballina Byron Airport",
    city: "Ballina",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -28.837606,
    longitude: 153.556396,
    icao: "YBNA"
  },
  BNL: {
    iata: "BNL",
    name: "Barnwell County Airport",
    city: "Barnwell",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 33.25,
    longitude: -81.383333,
    icao: "KBNL"
  },
  BNN: {
    iata: "BNN",
    name: "Bronnoysund Airport, Bronnoy",
    city: "Bronnoysund",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 65.459439,
    longitude: 12.209954,
    icao: "ENBN"
  },
  BNO: {
    iata: "BNO",
    name: "Burns Municipal Airport",
    city: "Burns",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 43.590557,
    longitude: -118.955192,
    icao: "KBNO"
  },
  BNP: {
    iata: "BNP",
    name: "Bannu Airport",
    city: "Bannu",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 33,
    longitude: 70.666667,
    icao: "OPBN"
  },
  BNR: {
    iata: "BNR",
    name: "Banfora Airport",
    city: "Banfora",
    countryId: "BF",
    timeZoneRegionName: "Africa/Ouagadougou",
    latitude: 10.666667,
    longitude: -4.666667,
    icao: "DFOB"
  },
  BNS: {
    iata: "BNS",
    name: "Barinas Airport",
    city: "Barinas",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 8.618056,
    longitude: -70.221111,
    icao: "SVBI"
  },
  BNU: {
    iata: "BNU",
    name: "Blumenau Airport",
    city: "Blumenau",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -26.830601,
    longitude: -49.090302,
    icao: "SSBL"
  },
  BNW: {
    iata: "BNW",
    name: "Boone Airport",
    city: "Boone",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 42.066667,
    longitude: -93.883333,
    icao: "KBNW"
  },
  BNX: {
    iata: "BNX",
    name: "Banja Luka Airport",
    city: "Banja Luka",
    countryId: "BA",
    timeZoneRegionName: "Europe/Sarajevo",
    latitude: 44.933333,
    longitude: 17.3,
    icao: "LQBK"
  },
  BNY: {
    iata: "BNY",
    name: "Bellona Anua Airport",
    city: "Bellona",
    countryId: "SB",
    timeZoneRegionName: "Pacific/Guadalcanal",
    latitude: -11.3,
    longitude: 159.816667,
    icao: "AGGB"
  },
  BOA: {
    iata: "BOA",
    name: "Boma Airport",
    city: "Boma",
    countryId: "CD",
    timeZoneRegionName: "Africa/Kinshasa",
    latitude: -5.866667,
    longitude: 13.066667,
    icao: "FZAJ"
  },
  BOB: {
    iata: "BOB",
    name: "Motu Mute Airport",
    city: "Bora Bora",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -16.446207,
    longitude: -151.754476,
    icao: "NTTB"
  },
  BOC: {
    iata: "BOC",
    name: "Bocas Del Toro Airport",
    city: "Bocas Del Toro",
    countryId: "PA",
    timeZoneRegionName: "America/Panama",
    latitude: 9.34,
    longitude: -82.251944,
    icao: "MPBO"
  },
  BOD: {
    iata: "BOD",
    name: "Bordeaux Airport",
    city: "Bordeaux",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 44.83102,
    longitude: -0.70217,
    icao: "LFBD"
  },
  BOE: {
    iata: "BOE",
    name: "Boundji Airport",
    city: "Boundji",
    countryId: "CG",
    timeZoneRegionName: "Africa/Brazzaville",
    latitude: -1.033333,
    longitude: 15.383333,
    icao: "FCOB"
  },
  BOG: {
    iata: "BOG",
    name: "El Dorado International Airport",
    city: "Bogota",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 4.698602,
    longitude: -74.143136,
    icao: "SKBO"
  },
  BOH: {
    iata: "BOH",
    name: "Bournemouth Airport",
    city: "Bournemouth",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 50.778269,
    longitude: -1.832476,
    icao: "EGHH"
  },
  BOI: {
    iata: "BOI",
    name: "Boise Air Terminal (Gowen Field)",
    city: "Boise",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 43.569263,
    longitude: -116.221934,
    icao: "KBOI"
  },
  BOJ: {
    iata: "BOJ",
    name: "Bourgas Airport",
    city: "Bourgas",
    countryId: "BG",
    timeZoneRegionName: "Europe/Sofia",
    latitude: 42.56745,
    longitude: 27.515544,
    icao: "LBBG"
  },
  BOK: {
    iata: "BOK",
    name: "Brookings State Airport",
    city: "Brookings",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 42.05,
    longitude: -124.283333,
    icao: "KBOK"
  },
  BOM: {
    iata: "BOM",
    name: "Chhatrapati Shivaji International Airport",
    city: "Mumbai",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 19.089891,
    longitude: 72.868047,
    icao: "VABB"
  },
  BON: {
    iata: "BON",
    name: "Flamingo International Airport",
    city: "Bonaire",
    countryId: "BQ",
    timeZoneRegionName: "America/Curacao",
    latitude: 12.133403,
    longitude: -68.276873,
    icao: "TNCB"
  },
  BOO: {
    iata: "BOO",
    name: "Bodo Airport",
    city: "Bodo",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 67.27262,
    longitude: 14.367839,
    icao: "ENBO"
  },
  BOP: {
    iata: "BOP",
    name: "Bouar Airport",
    city: "Bouar",
    countryId: "CF",
    timeZoneRegionName: "Africa/Bangui",
    latitude: 6,
    longitude: 15.666667,
    icao: "FEFO"
  },
  BOR: {
    iata: "BOR",
    name: "Bokeo International Airport",
    city: "Muang Ton Pheung",
    countryId: "LA",
    timeZoneRegionName: "Asia/Vientiane",
    latitude: 20.31889,
    longitude: 100.15778,
    icao: "VLBK"
  },
  BOS: {
    iata: "BOS",
    name: "Logan International Airport",
    city: "Boston",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.36646,
    longitude: -71.020176,
    icao: "KBOS"
  },
  BOU: {
    iata: "BOU",
    name: "Bourges Airport",
    city: "Bourges",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 47.058102,
    longitude: 2.37028,
    icao: "LFLD"
  },
  BOW: {
    iata: "BOW",
    name: "Bartow Airport",
    city: "Bartow",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 27.9,
    longitude: -81.833333,
    icao: "KBOW"
  },
  BOX: {
    iata: "BOX",
    name: "Borroloola Airport",
    city: "Borroloola",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -16.066667,
    longitude: 136.283333,
    icao: "YBRL"
  },
  BOY: {
    iata: "BOY",
    name: "Borgo Airport",
    city: "Bobo Dioulasso",
    countryId: "BF",
    timeZoneRegionName: "Africa/Ouagadougou",
    latitude: 11.163611,
    longitude: -4.324444,
    icao: "DFOO"
  },
  BOZ: {
    iata: "BOZ",
    name: "Bozoum Airport",
    city: "Bozoum",
    countryId: "CF",
    timeZoneRegionName: "Africa/Bangui",
    latitude: 6.416667,
    longitude: 16.583333,
    icao: "FEGZ"
  },
  BPA: {
    iata: "BPA",
    name: "Borongan Airport",
    city: "Borongan",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 11.67583,
    longitude: 125.47833,
    icao: "RPVW"
  },
  BPC: {
    iata: "BPC",
    name: "Bamenda Airport",
    city: "Bamenda",
    countryId: "CM",
    timeZoneRegionName: "Africa/Douala",
    latitude: 5.916667,
    longitude: 10.15,
    icao: "FKKV"
  },
  BPE: {
    iata: "BPE",
    name: "Qinhuangdao Beidaihe Airport",
    city: "Qinhuangdao",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 39.666389,
    longitude: 119.058889,
    icao: "ZBDH"
  },
  BPG: {
    iata: "BPG",
    name: "Barra Do Garcas Airport",
    city: "Barra Do Garcas",
    countryId: "BR",
    timeZoneRegionName: "America/Campo_Grande",
    latitude: -15.861337,
    longitude: -52.388965,
    icao: "SBBW"
  },
  BPH: {
    iata: "BPH",
    name: "Bislig Airport",
    city: "Bislig",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 8.196667,
    longitude: 126.321111,
    icao: "RPMF"
  },
  BPI: {
    iata: "BPI",
    name: "Miley Memorial Field",
    city: "Big Piney",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 42.585029,
    longitude: -110.111064,
    icao: "KBPI"
  },
  BPL: {
    iata: "BPL",
    name: "Bole Alashankou Airport",
    city: "Bole",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 44.895,
    longitude: 82.299722,
    icao: ""
  },
  BPN: {
    iata: "BPN",
    name: "Sultan Aji Muhamad Sulaiman Airport",
    city: "Balikpapan",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -1.260623,
    longitude: 116.900817,
    icao: "WALL"
  },
  BPS: {
    iata: "BPS",
    name: "Porto Seguro Airport",
    city: "Porto Seguro",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -16.441158,
    longitude: -39.081095,
    icao: "SBPS"
  },
  BPT: {
    iata: "BPT",
    name: "Jefferson County Airport",
    city: "Beaumont",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 29.950833,
    longitude: -94.02,
    icao: "KBPT"
  },
  BPX: {
    iata: "BPX",
    name: "Qamdo Bamda Airport",
    city: "Bangda",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 30.555833,
    longitude: 97.106667,
    icao: "ZUBD"
  },
  BPY: {
    iata: "BPY",
    name: "Besalampy Airport",
    city: "Besalampy",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -16.75,
    longitude: 44.483333,
    icao: "FMNQ"
  },
  BQA: {
    iata: "BQA",
    name: "Dr. Juan C. Angara Airport",
    city: "Baler",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 15.732205,
    longitude: 121.502761,
    icao: "RPUR"
  },
  BQB: {
    iata: "BQB",
    name: "Busselton Airport",
    city: "Busselton",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -33.686879,
    longitude: 115.402035,
    icao: "YBLN"
  },
  BQG: {
    iata: "BQG",
    name: "Bogorodskoye Airport",
    city: "Bogorodskoye",
    countryId: "RU",
    timeZoneRegionName: "Asia/Vladivostok",
    latitude: 52.378334,
    longitude: 140.44833,
    icao: "UHNB"
  },
  BQH: {
    iata: "BQH",
    name: "Biggin Hill Airport",
    city: "London",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.333333,
    longitude: 0.033333,
    icao: "EGKB"
  },
  BQJ: {
    iata: "BQJ",
    name: "Batagay Airport",
    city: "Batagay",
    countryId: "RU",
    timeZoneRegionName: "Asia/Vladivostok",
    latitude: 67.648889,
    longitude: 134.695,
    icao: "UEBB"
  },
  BQK: {
    iata: "BQK",
    name: "Glynco Jetport",
    city: "Brunswick",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 31.166667,
    longitude: -81.483333,
    icao: "KBQK"
  },
  BQL: {
    iata: "BQL",
    name: "Boulia Airport",
    city: "Boulia",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -22.9,
    longitude: 139.9,
    icao: "YBOU"
  },
  BQN: {
    iata: "BQN",
    name: "Rafael Hernandez Airport",
    city: "Aguadilla",
    countryId: "PR",
    timeZoneRegionName: "America/Puerto_Rico",
    latitude: 18.495347,
    longitude: -67.134133,
    icao: "TJBQ"
  },
  BQO: {
    iata: "BQO",
    name: "Bouna Airport",
    city: "Bouna",
    countryId: "CI",
    timeZoneRegionName: "Africa/Abidjan",
    latitude: 9.266667,
    longitude: -3,
    icao: "DIBN"
  },
  BQQ: {
    iata: "BQQ",
    name: "Barra Airport",
    city: "Barra",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -11.083333,
    longitude: -43.133333,
    icao: "SNBX"
  },
  BQS: {
    iata: "BQS",
    name: "Blagoveschensk Airport",
    city: "Blagoveschensk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yakutsk",
    latitude: 50.416667,
    longitude: 127.4,
    icao: "UHBB"
  },
  BQT: {
    iata: "BQT",
    name: "Brest Airport",
    city: "Brest",
    countryId: "BY",
    timeZoneRegionName: "Europe/Minsk",
    latitude: 52.110065,
    longitude: 23.898222,
    icao: "UMBB"
  },
  BQW: {
    iata: "BQW",
    name: "Balgo Hills Airport",
    city: "Balgo Hills",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -20.183333,
    longitude: 127.8,
    icao: "YBGO"
  },
  BRA: {
    iata: "BRA",
    name: "Barreiras Airport",
    city: "Barreiras",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -12.073056,
    longitude: -45.008333,
    icao: "SNBR"
  },
  BRB: {
    iata: "BRB",
    name: "Barreirinhas Airport",
    city: "Barreirinhas",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -2.755616,
    longitude: -42.817098,
    icao: "SBRR"
  },
  BRC: {
    iata: "BRC",
    name: "San Carlos de Bariloche International Airport",
    city: "San Carlos de Bariloche",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -41.145965,
    longitude: -71.161085,
    icao: "SAZS"
  },
  BRD: {
    iata: "BRD",
    name: "Crow Wing County Airport",
    city: "Brainerd",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 46.397222,
    longitude: -94.1375,
    icao: "KBRD"
  },
  BRE: {
    iata: "BRE",
    name: "Bremen Airport",
    city: "Bremen",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 53.052971,
    longitude: 8.785352,
    icao: "EDDW"
  },
  BRI: {
    iata: "BRI",
    name: "Palese Airport",
    city: "Bari",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 41.133881,
    longitude: 16.76391,
    icao: "LIBD"
  },
  BRK: {
    iata: "BRK",
    name: "Bourke Airport",
    city: "Bourke",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -30.083333,
    longitude: 145.933333,
    icao: "YBKE"
  },
  BRL: {
    iata: "BRL",
    name: "Burlington Airport",
    city: "Burlington",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 40.786111,
    longitude: -91.123333,
    icao: "KBRL"
  },
  BRM: {
    iata: "BRM",
    name: "Barquisimeto Airport",
    city: "Barquisimeto",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 10.046267,
    longitude: -69.359844,
    icao: "SVBM"
  },
  BRN: {
    iata: "BRN",
    name: "Bern Airport",
    city: "Berne",
    countryId: "CH",
    timeZoneRegionName: "Europe/Zurich",
    latitude: 46.911728,
    longitude: 7.50356,
    icao: "LSZB"
  },
  BRO: {
    iata: "BRO",
    name: "South Padre Island International Airport",
    city: "Brownsville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 25.908889,
    longitude: -97.423333,
    icao: "KBRO"
  },
  BRQ: {
    iata: "BRQ",
    name: "Turany Airport",
    city: "Brno",
    countryId: "CZ",
    timeZoneRegionName: "Europe/Prague",
    latitude: 49.15,
    longitude: 16.7,
    icao: "LKTB"
  },
  BRR: {
    iata: "BRR",
    name: "North Bay Airport",
    city: "Barra",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 57.025237,
    longitude: -7.449343,
    icao: "EGPR"
  },
  BRS: {
    iata: "BRS",
    name: "Bristol Airport",
    city: "Bristol",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.386756,
    longitude: -2.710659,
    icao: "EGGD"
  },
  BRT: {
    iata: "BRT",
    name: "Bathurst Island Airport",
    city: "Bathurst Island",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -11.766667,
    longitude: 130.633333,
    icao: "YBTI"
  },
  BRU: {
    iata: "BRU",
    name: "Brussels Airport",
    city: "Brussels",
    countryId: "BE",
    timeZoneRegionName: "Europe/Brussels",
    latitude: 50.89717,
    longitude: 4.483602,
    icao: "EBBR"
  },
  BRV: {
    iata: "BRV",
    name: "Bremerhaven Airport",
    city: "Bremerhaven",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 53.503156,
    longitude: 8.572528,
    icao: "EDWB"
  },
  BRW: {
    iata: "BRW",
    name: "Wiley Post-Will Rogers Memorial Airport",
    city: "Barrow",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 71.287223,
    longitude: -156.770252,
    icao: "PABR"
  },
  BRX: {
    iata: "BRX",
    name: "Barahona Airport",
    city: "Barahona",
    countryId: "DO",
    timeZoneRegionName: "America/Santo_Domingo",
    latitude: 18.216667,
    longitude: -71.116667,
    icao: "MDBH"
  },
  BRY: {
    iata: "BRY",
    name: "Samuels Field",
    city: "Bardstown",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 37.822034,
    longitude: -85.484178,
    icao: "KBRY"
  },
  BSA: {
    iata: "BSA",
    name: "Bossaso Airport",
    city: "Bossaso",
    countryId: "SO",
    timeZoneRegionName: "Africa/Mogadishu",
    latitude: 11.283333,
    longitude: 49.15,
    icao: "HCMF"
  },
  BSB: {
    iata: "BSB",
    name: "Brasilia International Airport",
    city: "Brasilia",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -15.869807,
    longitude: -47.921486,
    icao: "SBBR"
  },
  BSC: {
    iata: "BSC",
    name: "Bahia Solano Airport",
    city: "Bahia Solano",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 6.183333,
    longitude: -77.4,
    icao: "SKBS"
  },
  BSD: {
    iata: "BSD",
    name: "Baoshan Airport",
    city: "Baoshan",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 25.055181,
    longitude: 99.161427,
    icao: "ZPBS"
  },
  BSF: {
    iata: "BSF",
    name: "Bradshaw Army Air Field",
    city: "Pohakuloa",
    countryId: "US",
    timeZoneRegionName: "Pacific/Honolulu",
    latitude: 19.758207,
    longitude: -155.549427,
    icao: "PHSF"
  },
  BSG: {
    iata: "BSG",
    name: "Bata Airport",
    city: "Bata",
    countryId: "GQ",
    timeZoneRegionName: "Africa/Malabo",
    latitude: 1.906667,
    longitude: 9.802222,
    icao: "FGBT"
  },
  BSJ: {
    iata: "BSJ",
    name: "Bairnsdale Airport",
    city: "Bairnsdale",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -37.887501,
    longitude: 147.567993,
    icao: "YBNS"
  },
  BSK: {
    iata: "BSK",
    name: "Mohamed Khider Airport",
    city: "Biskra",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 34.793333,
    longitude: 5.738056,
    icao: "DAUB"
  },
  BSL: {
    iata: "BSL",
    name: "EuroAirport Basel-Mulhouse-Freiburg",
    city: "Basel",
    countryId: "CH",
    timeZoneRegionName: "Europe/Zurich",
    latitude: 47.599324,
    longitude: 7.532864,
    icao: "LFSB"
  },
  BSM: {
    iata: "BSM",
    name: "Bishe Kola Air Base",
    city: "Amol",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 36.65551,
    longitude: 52.350462,
    icao: "OINJ"
  },
  BSN: {
    iata: "BSN",
    name: "Bossangoa Airport",
    city: "Bossangoa",
    countryId: "CF",
    timeZoneRegionName: "Africa/Bangui",
    latitude: 6.583333,
    longitude: 17.5,
    icao: "FEFS"
  },
  BSO: {
    iata: "BSO",
    name: "Basco Airport",
    city: "Basco",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 20.453056,
    longitude: 121.977778,
    icao: "RPUO"
  },
  BSR: {
    iata: "BSR",
    name: "Basra International Airport",
    city: "Basra",
    countryId: "IQ",
    timeZoneRegionName: "Asia/Baghdad",
    latitude: 30.552695,
    longitude: 47.666865,
    icao: "ORMM"
  },
  BSS: {
    iata: "BSS",
    name: "Balsas Airport",
    city: "Balsas",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -7.516667,
    longitude: -46.05,
    icao: "SNBS"
  },
  BST: {
    iata: "BST",
    name: "Bost Airport",
    city: "Bost",
    countryId: "AF",
    timeZoneRegionName: "Asia/Kabul",
    latitude: 31.55,
    longitude: 64.366667,
    icao: "OABT"
  },
  BSU: {
    iata: "BSU",
    name: "Basankusu Airport",
    city: "Basankusu",
    countryId: "CD",
    timeZoneRegionName: "Africa/Kinshasa",
    latitude: 1.221667,
    longitude: 19.788889,
    icao: "FZEN"
  },
  BSX: {
    iata: "BSX",
    name: "Pathein Airport",
    city: "Pathein",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 16.812453,
    longitude: 94.774901,
    icao: "VYPN"
  },
  BSZ: {
    iata: "BSZ",
    name: "Manas International Airport",
    city: "Bishkek",
    countryId: "KG",
    timeZoneRegionName: "Asia/Bishkek",
    latitude: 43.0613,
    longitude: 74.4775,
    icao: "UCFM"
  },
  BTA: {
    iata: "BTA",
    name: "Bertoua Airport",
    city: "Bertoua",
    countryId: "CM",
    timeZoneRegionName: "Africa/Douala",
    latitude: 4.548878,
    longitude: 13.72602,
    icao: "FKKO"
  },
  BTB: {
    iata: "BTB",
    name: "Betou Airport",
    city: "Betou",
    countryId: "CG",
    timeZoneRegionName: "Africa/Brazzaville",
    latitude: 3.05,
    longitude: 18.5,
    icao: "FCOT"
  },
  BTC: {
    iata: "BTC",
    name: "Batticaloa Airport",
    city: "Batticaloa",
    countryId: "LK",
    timeZoneRegionName: "Asia/Colombo",
    latitude: 7.704878,
    longitude: 81.678544,
    icao: "VCCB"
  },
  BTE: {
    iata: "BTE",
    name: "Bonthe Airport",
    city: "Bonthe",
    countryId: "SL",
    timeZoneRegionName: "Africa/Freetown",
    latitude: 7,
    longitude: -12.008333,
    icao: "GFBN"
  },
  BTF: {
    iata: "BTF",
    name: "Bountiful Skypark",
    city: "Bountiful",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 40.869432,
    longitude: -111.927485,
    icao: "KBTF"
  },
  BTH: {
    iata: "BTH",
    name: "Hang Nadim International Airport",
    city: "Batam",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: 1.123627,
    longitude: 104.115279,
    icao: "WIDD"
  },
  BTI: {
    iata: "BTI",
    name: "Barter Island Airport",
    city: "Barter Island",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 70.134722,
    longitude: -143.578333,
    icao: "PABA"
  },
  BTJ: {
    iata: "BTJ",
    name: "Sultan Iskandar Muda International Airport",
    city: "Banda Aceh",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: 5.518021,
    longitude: 95.418329,
    icao: "WITT"
  },
  BTK: {
    iata: "BTK",
    name: "Bratsk Airport",
    city: "Bratsk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Irkutsk",
    latitude: 56.370602,
    longitude: 101.697998,
    icao: "UIBB"
  },
  BTL: {
    iata: "BTL",
    name: "WK Kellogg Regional Airport",
    city: "Battle Creek",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.305036,
    longitude: -85.252674,
    icao: "KBTL"
  },
  BTM: {
    iata: "BTM",
    name: "Butte Airport",
    city: "Butte",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 45.951111,
    longitude: -112.493889,
    icao: "KBTM"
  },
  BTN: {
    iata: "BTN",
    name: "Bennettsville Airport",
    city: "Bennettsville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 34.616667,
    longitude: -79.683333,
    icao: "KBBP"
  },
  BTP: {
    iata: "BTP",
    name: "Graham Field",
    city: "Butler",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.85,
    longitude: -79.916667,
    icao: "KBTP"
  },
  BTQ: {
    iata: "BTQ",
    name: "Butare Airport",
    city: "Butare",
    countryId: "RW",
    timeZoneRegionName: "Africa/Kigali",
    latitude: -2.6,
    longitude: 29.733333,
    icao: "HRYI"
  },
  BTR: {
    iata: "BTR",
    name: "Baton Rouge Metropolitan Airport",
    city: "Baton Rouge",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.532537,
    longitude: -91.156907,
    icao: "KBTR"
  },
  BTS: {
    iata: "BTS",
    name: "M.R. Stefanik Airport",
    city: "Bratislava",
    countryId: "SK",
    timeZoneRegionName: "Europe/Bratislava",
    latitude: 48.170125,
    longitude: 17.212665,
    icao: "LZIB"
  },
  BTT: {
    iata: "BTT",
    name: "Bettles Airport",
    city: "Bettles",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 66.915278,
    longitude: -151.526389,
    icao: "PABT"
  },
  BTU: {
    iata: "BTU",
    name: "Bintulu Airport",
    city: "Bintulu",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 3.123505,
    longitude: 113.023112,
    icao: "WBGB"
  },
  BTV: {
    iata: "BTV",
    name: "Burlington International Airport",
    city: "Burlington",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 44.469014,
    longitude: -73.155277,
    icao: "KBTV"
  },
  BTW: {
    iata: "BTW",
    name: "Batu Licin Airport",
    city: "Batulicin",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -3.41194,
    longitude: 116.000082,
    icao: "WAOC"
  },
  BTX: {
    iata: "BTX",
    name: "Betoota Airport",
    city: "Betoota",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -25.7,
    longitude: 140.733333,
    icao: "YBEO"
  },
  BTY: {
    iata: "BTY",
    name: "Beatty Airport",
    city: "Beatty",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 36.9,
    longitude: -116.766667,
    icao: "KBTY"
  },
  BUA: {
    iata: "BUA",
    name: "Buka Airport",
    city: "Buka",
    countryId: "PG",
    timeZoneRegionName: "Pacific/Bougainville",
    latitude: -5.422443,
    longitude: 154.672885,
    icao: "AYBK"
  },
  BUB: {
    iata: "BUB",
    name: "Cram Field",
    city: "Burwell",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.775599,
    longitude: -99.147158,
    icao: "KBUB"
  },
  BUC: {
    iata: "BUC",
    name: "Burketown Airport",
    city: "Burketown",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -17.75,
    longitude: 139.533333,
    icao: "YBKT"
  },
  BUD: {
    iata: "BUD",
    name: "Budapest Ferenc Liszt International Airport",
    city: "Budapest",
    countryId: "HU",
    timeZoneRegionName: "Europe/Budapest",
    latitude: 47.433037,
    longitude: 19.261621,
    icao: "LHBP"
  },
  BUF: {
    iata: "BUF",
    name: "Buffalo Niagara International Airport",
    city: "Buffalo",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.933828,
    longitude: -78.731804,
    icao: "KBUF"
  },
  BUG: {
    iata: "BUG",
    name: "17 de Setembro Airport",
    city: "Benguela",
    countryId: "AO",
    timeZoneRegionName: "Africa/Luanda",
    latitude: -12.609024,
    longitude: 13.403714,
    icao: "FNBG"
  },
  BUJ: {
    iata: "BUJ",
    name: "Ain Eddis Airport",
    city: "Boussaada",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 35.166667,
    longitude: 4.15,
    icao: "DAAD"
  },
  BUK: {
    iata: "BUK",
    name: "Albuq Airport",
    city: "Albuq",
    countryId: "YE",
    timeZoneRegionName: "Asia/Aden",
    latitude: 15.833333,
    longitude: 43.766667,
    icao: "OYBQ"
  },
  BUM: {
    iata: "BUM",
    name: "Butler Airport",
    city: "Butler",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 38.266667,
    longitude: -94.333333,
    icao: "KBUM"
  },
  BUN: {
    iata: "BUN",
    name: "Buenaventura Airport",
    city: "Buenaventura",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 3.825,
    longitude: -76.995833,
    icao: "SKBU"
  },
  BUO: {
    iata: "BUO",
    name: "Burao Airport",
    city: "Burao",
    countryId: "SO",
    timeZoneRegionName: "Africa/Mogadishu",
    latitude: 9.5225,
    longitude: 45.554167,
    icao: "HCMV"
  },
  BUP: {
    iata: "BUP",
    name: "Bathinda Airport",
    city: "Bathinda",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 30.270092,
    longitude: 74.755809,
    icao: "VIBT"
  },
  BUQ: {
    iata: "BUQ",
    name: "Bulawayo Airport",
    city: "Bulawayo",
    countryId: "ZW",
    timeZoneRegionName: "Africa/Harare",
    latitude: -20.014933,
    longitude: 28.622616,
    icao: "FVBU"
  },
  BUR: {
    iata: "BUR",
    name: "Bob Hope Airport",
    city: "Burbank",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 34.196188,
    longitude: -118.354113,
    icao: "KBUR"
  },
  BUS: {
    iata: "BUS",
    name: "Batumi International Airport",
    city: "Batumi",
    countryId: "GE",
    timeZoneRegionName: "Asia/Tbilisi",
    latitude: 41.610278,
    longitude: 41.599444,
    icao: "UGSB"
  },
  BUT: {
    iata: "BUT",
    name: "Bathpalathang Airport",
    city: "Jakar",
    countryId: "BT",
    timeZoneRegionName: "Asia/Thimphu",
    latitude: 27.562955,
    longitude: 90.746101,
    icao: "VQBT"
  },
  BUU: {
    iata: "BUU",
    name: "Muara Bungo Airport",
    city: "Muara Bungo",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: -1.540169,
    longitude: 102.179283,
    icao: "WIJB"
  },
  BUW: {
    iata: "BUW",
    name: "Bau-Bau Betoambari Airport",
    city: "Baubau",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -5.48688,
    longitude: 122.569,
    icao: "WAWB"
  },
  BUX: {
    iata: "BUX",
    name: "Bunia Airport",
    city: "Bunia",
    countryId: "CD",
    timeZoneRegionName: "Africa/Lubumbashi",
    latitude: 1.565833,
    longitude: 30.220833,
    icao: "FZKA"
  },
  BUY: {
    iata: "BUY",
    name: "Bunbury Airport",
    city: "Bunbury",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -33.377824,
    longitude: 115.678948,
    icao: "YBUN"
  },
  BUZ: {
    iata: "BUZ",
    name: "Bushehr Airport",
    city: "Bushehr",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 28.958285,
    longitude: 50.825425,
    icao: "OIBB"
  },
  BVA: {
    iata: "BVA",
    name: "Beauvais-Tille Airport",
    city: "Paris",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 49.459488,
    longitude: 2.110815,
    icao: "LFOB"
  },
  BVB: {
    iata: "BVB",
    name: "Boa Vista Airport",
    city: "Boa Vista",
    countryId: "BR",
    timeZoneRegionName: "America/Porto_Velho",
    latitude: 2.833333,
    longitude: -60.666667,
    icao: "SBBV"
  },
  BVC: {
    iata: "BVC",
    name: "Rabil Airport",
    city: "Boa Vista",
    countryId: "CV",
    timeZoneRegionName: "Atlantic/Cape_Verde",
    latitude: 16.136499,
    longitude: -22.888901,
    icao: "GVBA"
  },
  BVE: {
    iata: "BVE",
    name: "Vallee de la Dordogne Airport",
    city: "Brive-La-Gaillarde",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 45.039722,
    longitude: 1.485556,
    icao: "LFSL"
  },
  BVG: {
    iata: "BVG",
    name: "Berlevag Airport",
    city: "Berlevag",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 70.866667,
    longitude: 29,
    icao: "ENBV"
  },
  BVH: {
    iata: "BVH",
    name: "Vilhena Airport",
    city: "Vilhena",
    countryId: "BR",
    timeZoneRegionName: "America/Porto_Velho",
    latitude: -12.716667,
    longitude: -60.116667,
    icao: "SBVH"
  },
  BVI: {
    iata: "BVI",
    name: "Birdsville Airport",
    city: "Birdsville",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -25.898333,
    longitude: 139.343333,
    icao: "YBDV"
  },
  BVJ: {
    iata: "BVJ",
    name: "Bovanenkovo Airport",
    city: "Bovanenkovo",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yekaterinburg",
    latitude: 70.31669,
    longitude: 68.326746,
    icao: ""
  },
  BVM: {
    iata: "BVM",
    name: "Belmonte Airport",
    city: "Belmonte",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -15.833333,
    longitude: -38.916667,
    icao: "SNBL"
  },
  BVO: {
    iata: "BVO",
    name: "Bartlesville Municipal Airport",
    city: "Bartlesville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.7625,
    longitude: -96.010833,
    icao: "KBVO"
  },
  BVS: {
    iata: "BVS",
    name: "Breves Airport",
    city: "Breves",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -1.666667,
    longitude: -50.466667,
    icao: "SNVS"
  },
  BVU: {
    iata: "BVU",
    name: "Beluga Airport",
    city: "Beluga",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 61.169444,
    longitude: -151.036111,
    icao: "PABG"
  },
  BVV: {
    iata: "BVV",
    name: "Burevestnik Airport",
    city: "Burevestnik",
    countryId: "RU",
    timeZoneRegionName: "Asia/Ust-Nera",
    latitude: 44.928645,
    longitude: 147.613366,
    icao: "UHSB"
  },
  BVX: {
    iata: "BVX",
    name: "Batesville Regional Airport",
    city: "Batesville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.766667,
    longitude: -91.65,
    icao: "KBVX"
  },
  BVY: {
    iata: "BVY",
    name: "Beverly Municipal Airport",
    city: "Beverly",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.585167,
    longitude: -70.915335,
    icao: "KBVY"
  },
  BWA: {
    iata: "BWA",
    name: "Bhairawa Airport",
    city: "Bhairawa",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 27.504167,
    longitude: 83.42,
    icao: "VNBW"
  },
  BWB: {
    iata: "BWB",
    name: "Barrow Island Airport",
    city: "Barrow Island",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -20.864401,
    longitude: 115.405998,
    icao: "YBWX"
  },
  BWC: {
    iata: "BWC",
    name: "Brawley Municipal Airport",
    city: "Brawley",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 32.992865,
    longitude: -115.516875,
    icao: "KBWC"
  },
  BWD: {
    iata: "BWD",
    name: "Brownwood Regional Airport",
    city: "Brownwood",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 31.794722,
    longitude: -98.956667,
    icao: "KBWD"
  },
  BWE: {
    iata: "BWE",
    name: "Braunschweig-Wolfsburg Airport",
    city: "Braunschweig",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 52.318095,
    longitude: 10.557137,
    icao: "EDVE"
  },
  BWF: {
    iata: "BWF",
    name: "Walney Island Airport",
    city: "Barrow-In-Furness",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 54.116667,
    longitude: -3.233333,
    icao: "EGNL"
  },
  BWG: {
    iata: "BWG",
    name: "Warren County Airport",
    city: "Bowling Green",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.962222,
    longitude: -86.422222,
    icao: "KBWG"
  },
  BWH: {
    iata: "BWH",
    name: "Butterworth Airport",
    city: "Butterworth",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 5.466667,
    longitude: 100.3925,
    icao: "WMKB"
  },
  BWI: {
    iata: "BWI",
    name: "Baltimore/Wash International Thurgood Marshall Airport",
    city: "Baltimore",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.179526,
    longitude: -76.668941,
    icao: "KBWI"
  },
  BWK: {
    iata: "BWK",
    name: "Bra\u010D Airport",
    city: "Bra\u010D",
    countryId: "HR",
    timeZoneRegionName: "Europe/Zagreb",
    latitude: 43.285833,
    longitude: 16.679722,
    icao: "LDSB"
  },
  BWL: {
    iata: "BWL",
    name: "Bra\u010D Airport",
    city: "Bra\u010D",
    countryId: "HR",
    timeZoneRegionName: "Europe/Zagreb",
    latitude: 43.285833,
    longitude: 16.679722,
    icao: "LDSB"
  },
  BWM: {
    iata: "BWM",
    name: "Bowman Airport",
    city: "Bowman",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 46.183333,
    longitude: -103.4,
    icao: "KBPP"
  },
  BWN: {
    iata: "BWN",
    name: "Brunei International Airport",
    city: "Bandar Seri Begawan",
    countryId: "BN",
    timeZoneRegionName: "Asia/Brunei",
    latitude: 4.945197,
    longitude: 114.93375,
    icao: "WBSB"
  },
  BWQ: {
    iata: "BWQ",
    name: "Brewarrina Airport",
    city: "Brewarrina",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -29.95,
    longitude: 146.866667,
    icao: "YBRW"
  },
  BWT: {
    iata: "BWT",
    name: "Burnie Wynyard Airport",
    city: "Burnie",
    countryId: "AU",
    timeZoneRegionName: "Australia/Hobart",
    latitude: -40.993145,
    longitude: 145.725074,
    icao: "YBUI"
  },
  BWX: {
    iata: "BWX",
    name: "Banyuwangi Airport",
    city: "Banyuwangi",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: -8.31015,
    longitude: 114.3401,
    icao: "WADY"
  },
  BXA: {
    iata: "BXA",
    name: "George R. Carr Airport",
    city: "Bogalusa",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.933333,
    longitude: -89.883333,
    icao: "KBXA"
  },
  BXB: {
    iata: "BXB",
    name: "Babo Airport",
    city: "Babo",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jayapura",
    latitude: -2.532486,
    longitude: 133.441147,
    icao: "WASO"
  },
  BXE: {
    iata: "BXE",
    name: "Bakel Airport",
    city: "Bakel",
    countryId: "SN",
    timeZoneRegionName: "Africa/Dakar",
    latitude: 14.841667,
    longitude: -12.467778,
    icao: "GOTB"
  },
  BXG: {
    iata: "BXG",
    name: "Bendigo Airport",
    city: "Bendigo",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -36.737608,
    longitude: 144.327227,
    icao: "YBDG"
  },
  BXH: {
    iata: "BXH",
    name: "Balhash Airport",
    city: "Balhash",
    countryId: "KZ",
    timeZoneRegionName: "Asia/Almaty",
    latitude: 46.894216,
    longitude: 75.004381,
    icao: "UAAH"
  },
  BXI: {
    iata: "BXI",
    name: "Boundiali Airport",
    city: "Boundiali",
    countryId: "CI",
    timeZoneRegionName: "Africa/Abidjan",
    latitude: 8.75,
    longitude: -6.5,
    icao: "DIBI"
  },
  BXJ: {
    iata: "BXJ",
    name: "Borolday Airport",
    city: "Almaty",
    countryId: "KZ",
    timeZoneRegionName: "Asia/Almaty",
    latitude: 43.351471,
    longitude: 76.882627,
    icao: "UAAR"
  },
  BXK: {
    iata: "BXK",
    name: "Buckeye Airport",
    city: "Buckeye",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 33.366667,
    longitude: -112.583333,
    icao: "KBXK"
  },
  BXN: {
    iata: "BXN",
    name: "Imsik Airport",
    city: "Bodrum",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 37.138353,
    longitude: 27.664951,
    icao: "LTBV"
  },
  BXR: {
    iata: "BXR",
    name: "Bam Airport",
    city: "Bam",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 29.080082,
    longitude: 58.449356,
    icao: "OIKM"
  },
  BXU: {
    iata: "BXU",
    name: "Butuan Airport",
    city: "Butuan",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 8.947999,
    longitude: 125.481228,
    icao: "RPWE"
  },
  BXY: {
    iata: "BXY",
    name: "Baikonur Krayniy Airport",
    city: "Baykonur",
    countryId: "KZ",
    timeZoneRegionName: "Asia/Qyzylorda",
    latitude: 45.622002,
    longitude: 63.215,
    icao: ""
  },
  BYC: {
    iata: "BYC",
    name: "Yacuiba Airport",
    city: "Yacuiba",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -21.95,
    longitude: -63.65,
    icao: "SLYA"
  },
  BYF: {
    iata: "BYF",
    name: "Albert Bray Airport",
    city: "Albert",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 49.970389,
    longitude: 2.699448,
    icao: "LFAQ"
  },
  BYG: {
    iata: "BYG",
    name: "Buffalo Municipal Airport",
    city: "Buffalo",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 44.35,
    longitude: -106.7,
    icao: "KBYG"
  },
  BYH: {
    iata: "BYH",
    name: "Arkansas International Airport",
    city: "Blytheville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.960897,
    longitude: -89.945216,
    icao: "KBYH"
  },
  BYI: {
    iata: "BYI",
    name: "Burley Municipal Airport",
    city: "Burley",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 42.541389,
    longitude: -113.774167,
    icao: "KBYI"
  },
  BYJ: {
    iata: "BYJ",
    name: "Beja International Airport",
    city: "Beja",
    countryId: "PT",
    timeZoneRegionName: "Europe/Lisbon",
    latitude: 38.090242,
    longitude: -7.926813,
    icao: "LPBJ"
  },
  BYK: {
    iata: "BYK",
    name: "Bouake Airport",
    city: "Bouake",
    countryId: "CI",
    timeZoneRegionName: "Africa/Abidjan",
    latitude: 7.736606,
    longitude: -5.069469,
    icao: "DIBK"
  },
  BYM: {
    iata: "BYM",
    name: "C.M. de Cespedes Airport",
    city: "Bayamo",
    countryId: "CU",
    timeZoneRegionName: "America/Havana",
    latitude: 20.383333,
    longitude: -76.65,
    icao: "MUBY"
  },
  BYN: {
    iata: "BYN",
    name: "Bayankhongor Airport",
    city: "Bayankhongor",
    countryId: "MN",
    timeZoneRegionName: "Asia/Ulaanbaatar",
    latitude: 46.1,
    longitude: 100.683333,
    icao: "ZMBH"
  },
  BYO: {
    iata: "BYO",
    name: "Bonito Airport",
    city: "Bonito",
    countryId: "BR",
    timeZoneRegionName: "America/Campo_Grande",
    latitude: -21.243866,
    longitude: -56.45085,
    icao: "SBDB"
  },
  BYP: {
    iata: "BYP",
    name: "Barimunya Airport",
    city: "Barimunya",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -22.673889,
    longitude: 119.166111,
    icao: "YBRY"
  },
  BYR: {
    iata: "BYR",
    name: "Laeso Airport",
    city: "Laeso Island",
    countryId: "DK",
    timeZoneRegionName: "Europe/Copenhagen",
    latitude: 57.277563,
    longitude: 11.005083,
    icao: "EKLS"
  },
  BYT: {
    iata: "BYT",
    name: "Bantry Airport",
    city: "Bantry",
    countryId: "IE",
    timeZoneRegionName: "Europe/Dublin",
    latitude: 51.683333,
    longitude: -9.45,
    icao: "EIBN"
  },
  BYU: {
    iata: "BYU",
    name: "Bindlacher-Berg Airport",
    city: "Bayreuth",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 49.985556,
    longitude: 11.64,
    icao: "EDQD"
  },
  BZD: {
    iata: "BZD",
    name: "Balranald Airport",
    city: "Balranald",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -34.616667,
    longitude: 143.616667,
    icao: "YBRN"
  },
  BZE: {
    iata: "BZE",
    name: "Philip S.W. Goldson International Airport",
    city: "Belize City",
    countryId: "BZ",
    timeZoneRegionName: "America/Belize",
    latitude: 17.539167,
    longitude: -88.308333,
    icao: "MZBZ"
  },
  BZG: {
    iata: "BZG",
    name: "Ignacy Jan Paderewski Airport",
    city: "Bydgoszcz",
    countryId: "PL",
    timeZoneRegionName: "Europe/Warsaw",
    latitude: 53.096667,
    longitude: 17.978611,
    icao: "EPBY"
  },
  BZH: {
    iata: "BZH",
    name: "Bumi Hills Airport",
    city: "Bumi Hills",
    countryId: "ZW",
    timeZoneRegionName: "Africa/Harare",
    latitude: -16.816667,
    longitude: 28.35,
    icao: "FVBM"
  },
  BZI: {
    iata: "BZI",
    name: "Balikesir Airport",
    city: "Balikesir",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 39.617222,
    longitude: 27.927778,
    icao: "LTBF"
  },
  BZJ: {
    iata: "BZJ",
    name: "Bozhou Airport",
    city: "Bozhou",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 33.560777,
    longitude: 115.911859,
    icao: ""
  },
  BZK: {
    iata: "BZK",
    name: "Bryansk International Airport",
    city: "Bryansk",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 53.213911,
    longitude: 34.176383,
    icao: "UUBP"
  },
  BZL: {
    iata: "BZL",
    name: "Barisal Airport",
    city: "Barisal",
    countryId: "BD",
    timeZoneRegionName: "Asia/Dhaka",
    latitude: 22.798942,
    longitude: 90.301446,
    icao: "VGBR"
  },
  BZN: {
    iata: "BZN",
    name: "Bozeman Yellowstone International Airport",
    city: "Belgrade",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 45.777687,
    longitude: -111.160334,
    icao: "KBZN"
  },
  BZO: {
    iata: "BZO",
    name: "Bolzano Airport",
    city: "Bolzano",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 46.462444,
    longitude: 11.330511,
    icao: "LIPB"
  },
  BZR: {
    iata: "BZR",
    name: "Beziers Vias Airport",
    city: "Beziers",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 43.321186,
    longitude: 3.353485,
    icao: "LFMU"
  },
  BZU: {
    iata: "BZU",
    name: "Buta Airport",
    city: "Buta",
    countryId: "CD",
    timeZoneRegionName: "Africa/Lubumbashi",
    latitude: 2.8,
    longitude: 24.733333,
    icao: "FZKJ"
  },
  BZV: {
    iata: "BZV",
    name: "Maya Maya Airport",
    city: "Brazzaville",
    countryId: "CG",
    timeZoneRegionName: "Africa/Brazzaville",
    latitude: -4.258899,
    longitude: 15.251139,
    icao: "FCBB"
  },
  BZX: {
    iata: "BZX",
    name: "Bazhong Enyang Airport",
    city: "Bazhong",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 31.738056,
    longitude: 106.643889,
    icao: ""
  },
  BZY: {
    iata: "BZY",
    name: "Balti International Airport",
    city: "Balti",
    countryId: "MD",
    timeZoneRegionName: "Europe/Chisinau",
    latitude: 47.841868,
    longitude: 27.778148,
    icao: "LUBL"
  },
  BZZ: {
    iata: "BZZ",
    name: "RAF Brize Norton",
    city: "Brize Norton",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.75,
    longitude: -1.587093,
    icao: "EGVN"
  },
  CAA: {
    iata: "CAA",
    name: "Catacamas Airport",
    city: "Catacamas",
    countryId: "HN",
    timeZoneRegionName: "America/Tegucigalpa",
    latitude: 14.830556,
    longitude: -85.894444,
    icao: "MHCA"
  },
  CAB: {
    iata: "CAB",
    name: "Cabinda Airport",
    city: "Cabinda",
    countryId: "AO",
    timeZoneRegionName: "Africa/Luanda",
    latitude: -5.583333,
    longitude: 12.2,
    icao: "FNCA"
  },
  CAC: {
    iata: "CAC",
    name: "Cascavel Airport",
    city: "Cascavel",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -25.001606,
    longitude: -53.501565,
    icao: "SBCA"
  },
  CAD: {
    iata: "CAD",
    name: "Wexford County Airport",
    city: "Cadillac",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 44.275833,
    longitude: -85.422222,
    icao: "KCAD"
  },
  CAE: {
    iata: "CAE",
    name: "Columbia Metropolitan Airport",
    city: "Columbia",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 33.938804,
    longitude: -81.119497,
    icao: "KCAE"
  },
  CAF: {
    iata: "CAF",
    name: "Carauari Airport",
    city: "Carauari",
    countryId: "BR",
    timeZoneRegionName: "America/Porto_Velho",
    latitude: -4.9,
    longitude: -66.916667,
    icao: "SWCA"
  },
  CAG: {
    iata: "CAG",
    name: "Cagliari Elmas Airport",
    city: "Cagliari",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 39.254333,
    longitude: 9.060673,
    icao: "LIEE"
  },
  CAI: {
    iata: "CAI",
    name: "Cairo International Airport",
    city: "Cairo",
    countryId: "EG",
    timeZoneRegionName: "Africa/Cairo",
    latitude: 30.120106,
    longitude: 31.406469,
    icao: "HECA"
  },
  CAJ: {
    iata: "CAJ",
    name: "Canaima Airport",
    city: "Canaima",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 6.240634,
    longitude: -62.853511,
    icao: "SVCN"
  },
  CAK: {
    iata: "CAK",
    name: "Akron-Canton Airport",
    city: "Akron",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.914962,
    longitude: -81.435831,
    icao: "KCAK"
  },
  CAL: {
    iata: "CAL",
    name: "Machrihanish Airport",
    city: "Campbeltown",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 55.436389,
    longitude: -5.686667,
    icao: "EGEC"
  },
  CAM: {
    iata: "CAM",
    name: "Camiri Airport",
    city: "Camiri",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -20.011111,
    longitude: -63.561111,
    icao: "SLCA"
  },
  CAN: {
    iata: "CAN",
    name: "Guangzhou Baiyun International Airport",
    city: "Guangzhou",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 23.387862,
    longitude: 113.29734,
    icao: "ZGGG"
  },
  CAO: {
    iata: "CAO",
    name: "Clayton Municipal Airpark",
    city: "Clayton",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 36.446061,
    longitude: -103.153654,
    icao: "KCAO"
  },
  CAP: {
    iata: "CAP",
    name: "Hugo Chavez International Airport",
    city: "Cap Haitien",
    countryId: "HT",
    timeZoneRegionName: "America/Port-au-Prince",
    latitude: 19.732778,
    longitude: -72.195,
    icao: "MTCH"
  },
  CAQ: {
    iata: "CAQ",
    name: "Juan H. White Airport",
    city: "Caucasia",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 7.967905,
    longitude: -75.197183,
    icao: "SKCU"
  },
  CAR: {
    iata: "CAR",
    name: "Caribou Municipal Airport",
    city: "Caribou",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 46.866667,
    longitude: -68.016667,
    icao: "KCAR"
  },
  CAT: {
    iata: "CAT",
    name: "Cascais Municipal Aerodrome",
    city: "Tires",
    countryId: "PT",
    timeZoneRegionName: "Europe/Lisbon",
    latitude: 38.725556,
    longitude: -9.355278,
    icao: "LPCS"
  },
  CAU: {
    iata: "CAU",
    name: "Caruaru Airport",
    city: "Caruaru",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -8.25,
    longitude: -35.916667,
    icao: "SNRU"
  },
  CAW: {
    iata: "CAW",
    name: "Bartolomeu Lisandro Airport",
    city: "Campos",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -21.700159,
    longitude: -41.303481,
    icao: "SBCP"
  },
  CAX: {
    iata: "CAX",
    name: "Carlisle Airport",
    city: "Carlisle",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 54.936667,
    longitude: -2.809444,
    icao: "EGNC"
  },
  CAY: {
    iata: "CAY",
    name: "Felix Eboue Airport",
    city: "Cayenne",
    countryId: "GF",
    timeZoneRegionName: "America/Cayenne",
    latitude: 4.816667,
    longitude: -52.366667,
    icao: "SOCA"
  },
  CAZ: {
    iata: "CAZ",
    name: "Cobar Airport",
    city: "Cobar",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -31.536796,
    longitude: 145.796588,
    icao: "YCBA"
  },
  CBB: {
    iata: "CBB",
    name: "J Wilsterman Airport",
    city: "Cochabamba",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -17.413954,
    longitude: -66.178896,
    icao: "SLCB"
  },
  CBD: {
    iata: "CBD",
    name: "Car Nicobar Air Force Base",
    city: "Car Nicobar",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 9.156177,
    longitude: 92.821031,
    icao: "VOCX"
  },
  CBE: {
    iata: "CBE",
    name: "Wiley Ford Airport",
    city: "Cumberland",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.614444,
    longitude: -78.766111,
    icao: "KCBE"
  },
  CBF: {
    iata: "CBF",
    name: "Council Bluffs Municipal Airport",
    city: "Council Bluffs",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.259926,
    longitude: -95.757689,
    icao: "KCBF"
  },
  CBG: {
    iata: "CBG",
    name: "Cambridge Airport",
    city: "Cambridge",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 52.208044,
    longitude: 0.177738,
    icao: "EGSC"
  },
  CBH: {
    iata: "CBH",
    name: "Leger Airport",
    city: "Bechar",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 31.647778,
    longitude: -2.259722,
    icao: "DAOR"
  },
  CBJ: {
    iata: "CBJ",
    name: "Cabo Rojo Airport",
    city: "Cabo Rojo",
    countryId: "DO",
    timeZoneRegionName: "America/Santo_Domingo",
    latitude: 17.933333,
    longitude: -71.65,
    icao: "MDCR"
  },
  CBK: {
    iata: "CBK",
    name: "Colby Municipal Airport",
    city: "Colby",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 39.426141,
    longitude: -101.050303,
    icao: "KCBK"
  },
  CBL: {
    iata: "CBL",
    name: "Tomas de Heres Airport",
    city: "Ciudad Bolivar",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 8.122381,
    longitude: -63.534656,
    icao: "SVCB"
  },
  CBM: {
    iata: "CBM",
    name: "Columbus Air Force Base",
    city: "Columbus",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 33.64384,
    longitude: -88.444666,
    icao: "KCBM"
  },
  CBO: {
    iata: "CBO",
    name: "Awang Airport",
    city: "Cotabato",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 7.161412,
    longitude: 124.214639,
    icao: "RPMC"
  },
  CBP: {
    iata: "CBP",
    name: "Coimbra Airport",
    city: "Coimbra",
    countryId: "PT",
    timeZoneRegionName: "Europe/Lisbon",
    latitude: 40.2,
    longitude: -8.416667,
    icao: "LPCO"
  },
  CBQ: {
    iata: "CBQ",
    name: "Calabar Airport",
    city: "Calabar",
    countryId: "NG",
    timeZoneRegionName: "Africa/Lagos",
    latitude: 4.96889,
    longitude: 8.347415,
    icao: "DNCA"
  },
  CBR: {
    iata: "CBR",
    name: "Canberra Airport",
    city: "Canberra",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -35.30735,
    longitude: 149.190528,
    icao: "YSCB"
  },
  CBT: {
    iata: "CBT",
    name: "Catumbela Airport",
    city: "Catumbela",
    countryId: "AO",
    timeZoneRegionName: "Africa/Luanda",
    latitude: -12.483333,
    longitude: 13.483333,
    icao: "FNCM"
  },
  CBU: {
    iata: "CBU",
    name: "Cottbus Airport",
    city: "Cottbus",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 51.770278,
    longitude: 14.299167,
    icao: "ETHT"
  },
  CBX: {
    iata: "CBX",
    name: "Condobolin Airport",
    city: "Condobolin",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -33.866667,
    longitude: 148.25,
    icao: "YCDO"
  },
  CCB: {
    iata: "CCB",
    name: "Cable Airport",
    city: "Upland",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 34.111563,
    longitude: -117.687638,
    icao: "KCCB"
  },
  CCC: {
    iata: "CCC",
    name: "Jardines del Rey Airport",
    city: "Cayo Coco",
    countryId: "CU",
    timeZoneRegionName: "America/Havana",
    latitude: 22.461111,
    longitude: -78.328611,
    icao: "MUCC"
  },
  CCE: {
    iata: "CCE",
    name: "Cairo Capital International Airport",
    city: "Cairo",
    countryId: "EG",
    timeZoneRegionName: "Africa/Cairo",
    latitude: 30.07222,
    longitude: 31.83333,
    icao: "HECP"
  },
  CCF: {
    iata: "CCF",
    name: "Carcassonne Airport",
    city: "Carcassonne",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 43.215476,
    longitude: 2.308594,
    icao: "LFMK"
  },
  CCH: {
    iata: "CCH",
    name: "Chile Chico Airport",
    city: "Chile Chico",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -46.55,
    longitude: -71.7,
    icao: "SCCC"
  },
  CCI: {
    iata: "CCI",
    name: "Concordia Airport",
    city: "Concordia",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -27.181389,
    longitude: -52.050556,
    icao: "SSCK"
  },
  CCJ: {
    iata: "CCJ",
    name: "Calicut International Airport",
    city: "Kozhikode",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 11.138782,
    longitude: 75.949976,
    icao: "VOCL"
  },
  CCK: {
    iata: "CCK",
    name: "Cocos Islands Airport",
    city: "Cocos Islands",
    countryId: "CC",
    timeZoneRegionName: "Indian/Cocos",
    latitude: -12.1883,
    longitude: 96.8339,
    icao: "YPCC"
  },
  CCL: {
    iata: "CCL",
    name: "Chinchilla Airport",
    city: "Chinchilla",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -26.772339,
    longitude: 150.61823,
    icao: "YCCA"
  },
  CCM: {
    iata: "CCM",
    name: "Criciuma Airport",
    city: "Criciuma",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -28.7,
    longitude: -49.366667,
    icao: "SBCM"
  },
  CCN: {
    iata: "CCN",
    name: "Chaghcharan Airport",
    city: "Chaghcharan",
    countryId: "AF",
    timeZoneRegionName: "Asia/Kabul",
    latitude: 34.524826,
    longitude: 65.265506,
    icao: "OACC"
  },
  CCP: {
    iata: "CCP",
    name: "Carriel Sur Airport",
    city: "Concepcion",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -36.777121,
    longitude: -73.059444,
    icao: "SCIE"
  },
  CCR: {
    iata: "CCR",
    name: "Buchanan Field",
    city: "Concord",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 37.988889,
    longitude: -122.055556,
    icao: "KCCR"
  },
  CCS: {
    iata: "CCS",
    name: "Simon Bolivar International Airport",
    city: "Caracas",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 10.596942,
    longitude: -67.005511,
    icao: "SVMI"
  },
  CCU: {
    iata: "CCU",
    name: "Netaji Subhas Chandra Bose Airport",
    city: "Kolkata",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 22.64531,
    longitude: 88.439306,
    icao: "VECC"
  },
  CCV: {
    iata: "CCV",
    name: "Craig Cove Airport",
    city: "Craig Cove",
    countryId: "VU",
    timeZoneRegionName: "Pacific/Efate",
    latitude: -16.2,
    longitude: 167.5,
    icao: "NVSF"
  },
  CCW: {
    iata: "CCW",
    name: "Cowell Airport",
    city: "Cowell",
    countryId: "AU",
    timeZoneRegionName: "Australia/Adelaide",
    latitude: -33.633333,
    longitude: 136.833333,
    icao: "YCWL"
  },
  CCX: {
    iata: "CCX",
    name: "Caceres Airport",
    city: "Caceres",
    countryId: "BR",
    timeZoneRegionName: "America/Campo_Grande",
    latitude: -16.066667,
    longitude: -57.7,
    icao: "SWKC"
  },
  CCY: {
    iata: "CCY",
    name: "Charles City Municipal Airport",
    city: "Charles City",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 43.066667,
    longitude: -92.683333,
    icao: "KCCY"
  },
  CCZ: {
    iata: "CCZ",
    name: "Chub Cay Airport",
    city: "Chub Cay",
    countryId: "BS",
    timeZoneRegionName: "America/Nassau",
    latitude: 25.4175,
    longitude: -77.881389,
    icao: "MYBC"
  },
  CDA: {
    iata: "CDA",
    name: "Cooinda Airport",
    city: "Cooinda",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -12.905278,
    longitude: 132.5225,
    icao: "YCOO"
  },
  CDB: {
    iata: "CDB",
    name: "Cold Bay Airport",
    city: "Cold Bay",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 55.198716,
    longitude: -162.721354,
    icao: "PACD"
  },
  CDC: {
    iata: "CDC",
    name: "Cedar City Airport",
    city: "Cedar City",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 37.7025,
    longitude: -113.096111,
    icao: "KCDC"
  },
  CDE: {
    iata: "CDE",
    name: "Chengde Puning Airport",
    city: "Chengde",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 41.123079,
    longitude: 118.07135,
    icao: ""
  },
  CDG: {
    iata: "CDG",
    name: "Charles de Gaulle Airport",
    city: "Paris",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 49.003196,
    longitude: 2.567023,
    icao: "LFPG"
  },
  CDH: {
    iata: "CDH",
    name: "Harrell Field",
    city: "Camden",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 33.583333,
    longitude: -92.833333,
    icao: "KCDH"
  },
  CDJ: {
    iata: "CDJ",
    name: "Conceicao Do Araguaia Airport",
    city: "Conceicao Do Araguaia",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -8.233333,
    longitude: -49.283333,
    icao: "SBAA"
  },
  CDK: {
    iata: "CDK",
    name: "Lewis Airport",
    city: "Cedar Key",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 29.133333,
    longitude: -83.033333,
    icao: "KCDK"
  },
  CDN: {
    iata: "CDN",
    name: "Woodward Field",
    city: "Camden",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 34.266667,
    longitude: -80.6,
    icao: "KCDN"
  },
  CDP: {
    iata: "CDP",
    name: "Kadapa Airport",
    city: "Kadapa",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 14.514583,
    longitude: 78.76478,
    icao: "VOCP"
  },
  CDQ: {
    iata: "CDQ",
    name: "Croydon Airport",
    city: "Croydon",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -18.3,
    longitude: 142.25,
    icao: "YCRY"
  },
  CDR: {
    iata: "CDR",
    name: "Chadron Airport",
    city: "Chadron",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 42.835,
    longitude: -103.097778,
    icao: "KCDR"
  },
  CDS: {
    iata: "CDS",
    name: "Childress Airport",
    city: "Childress",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 37.416667,
    longitude: -100.216667,
    icao: "KCDS"
  },
  CDT: {
    iata: "CDT",
    name: "Castellon-Costa Azahar Airport",
    city: "Benlloch",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 40.213889,
    longitude: 0.073333,
    icao: "LECH"
  },
  CDU: {
    iata: "CDU",
    name: "Camden Airport",
    city: "Camden",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -34.038161,
    longitude: 150.687016,
    icao: "YSCN"
  },
  CDV: {
    iata: "CDV",
    name: "Mudhole Smith Airport",
    city: "Cordova",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 60.493056,
    longitude: -145.47,
    icao: "PACV"
  },
  CDW: {
    iata: "CDW",
    name: "Essex County Airport",
    city: "Caldwell",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.875005,
    longitude: -74.28021,
    icao: "KCDW"
  },
  CDY: {
    iata: "CDY",
    name: "Cagayan De Sulu Airport",
    city: "Mapun",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 7.013611,
    longitude: 118.495,
    icao: "RPMU"
  },
  CEA: {
    iata: "CEA",
    name: "Cessna Aircraft Field",
    city: "Wichita",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 37.7,
    longitude: -97.333333,
    icao: "KCEA"
  },
  CEB: {
    iata: "CEB",
    name: "Mactan-Cebu International Airport",
    city: "Cebu City",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 10.313333,
    longitude: 123.982778,
    icao: "RPVM"
  },
  CEC: {
    iata: "CEC",
    name: "Del Norte County Regional Airport",
    city: "Crescent City",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 41.78,
    longitude: -124.235833,
    icao: "KCEC"
  },
  CED: {
    iata: "CED",
    name: "Ceduna Airport",
    city: "Ceduna",
    countryId: "AU",
    timeZoneRegionName: "Australia/Adelaide",
    latitude: -32.123779,
    longitude: 133.701218,
    icao: "YCDU"
  },
  CEE: {
    iata: "CEE",
    name: "Cherepovets Airport",
    city: "Cherepovets",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 59.283333,
    longitude: 38.066667,
    icao: "ULWC"
  },
  CEF: {
    iata: "CEF",
    name: "Westover Metropolitan Airport",
    city: "Springfield",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.183377,
    longitude: -72.553834,
    icao: "KCEF"
  },
  CEG: {
    iata: "CEG",
    name: "Hawarden Airport",
    city: "Chester",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 53.178603,
    longitude: -2.970718,
    icao: "EGNR"
  },
  CEH: {
    iata: "CEH",
    name: "Chelinda Airport",
    city: "Chelinda",
    countryId: "MW",
    timeZoneRegionName: "Africa/Blantyre",
    latitude: -10.55,
    longitude: 33.8,
    icao: "FWCD"
  },
  CEI: {
    iata: "CEI",
    name: "Chiang Rai International Airport",
    city: "Chiang Rai",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 19.954608,
    longitude: 99.878811,
    icao: "VTCT"
  },
  CEK: {
    iata: "CEK",
    name: "Chelyabinsk International Airport",
    city: "Chelyabinsk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yekaterinburg",
    latitude: 55.297506,
    longitude: 61.51235,
    icao: "USCC"
  },
  CEL: {
    iata: "CEL",
    name: "Canela Airport",
    city: "Canela",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -29.497222,
    longitude: -50.922222,
    icao: "SSCN"
  },
  CEN: {
    iata: "CEN",
    name: "Ciudad Obregon Airport",
    city: "Ciudad Obregon",
    countryId: "MX",
    timeZoneRegionName: "America/Hermosillo",
    latitude: 27.391944,
    longitude: -109.839167,
    icao: "MMCN"
  },
  CEO: {
    iata: "CEO",
    name: "Wako Kungo Airport",
    city: "Wako Kungo",
    countryId: "AO",
    timeZoneRegionName: "Africa/Luanda",
    latitude: -11.426389,
    longitude: 15.101389,
    icao: "FNWK"
  },
  CEP: {
    iata: "CEP",
    name: "Concepcion Airport",
    city: "Concepcion",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -16.233333,
    longitude: -62.083333,
    icao: "SLCP"
  },
  CEQ: {
    iata: "CEQ",
    name: "Mandelieu Airport",
    city: "Cannes",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 43.546389,
    longitude: 6.954167,
    icao: "LFMD"
  },
  CER: {
    iata: "CER",
    name: "Cherbourg-Maupertus Airport",
    city: "Cherbourg",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 49.650812,
    longitude: -1.475198,
    icao: "LFRC"
  },
  CES: {
    iata: "CES",
    name: "Cessnock Airport",
    city: "Cessnock",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -32.833333,
    longitude: 151.35,
    icao: "YCNK"
  },
  CET: {
    iata: "CET",
    name: "Le Pontreau Airport",
    city: "Cholet",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 47.066667,
    longitude: -0.866667,
    icao: "LFOU"
  },
  CEU: {
    iata: "CEU",
    name: "Oconee County Regional Airport",
    city: "Clemson",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 34.671263,
    longitude: -82.885251,
    icao: "KCEU"
  },
  CEV: {
    iata: "CEV",
    name: "Mettle Field",
    city: "Connersville",
    countryId: "US",
    timeZoneRegionName: "America/Indiana/Indianapolis",
    latitude: 39.65,
    longitude: -85.133333,
    icao: "KCEV"
  },
  CEW: {
    iata: "CEW",
    name: "Bob Sikes Airport",
    city: "Crestview",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 30.777433,
    longitude: -86.523401,
    icao: "KCEW"
  },
  CEY: {
    iata: "CEY",
    name: "Calloway County Airport",
    city: "Murray",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.616667,
    longitude: -88.316667,
    icao: "KCEY"
  },
  CEZ: {
    iata: "CEZ",
    name: "Montezuma County Airport",
    city: "Cortez",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 37.302778,
    longitude: -108.627222,
    icao: "KCEZ"
  },
  CFB: {
    iata: "CFB",
    name: "Cabo Frio International Airport",
    city: "Cabo Frio",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -22.925,
    longitude: -42.078611,
    icao: "SBCB"
  },
  CFD: {
    iata: "CFD",
    name: "Coulter Field",
    city: "Bryan",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.666667,
    longitude: -96.366667,
    icao: "KCFD"
  },
  CFE: {
    iata: "CFE",
    name: "Auvergne Airport",
    city: "Clermont-Ferrand",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 45.789051,
    longitude: 3.159323,
    icao: "LFLC"
  },
  CFG: {
    iata: "CFG",
    name: "Jaime Gonzalez Airport",
    city: "Cienfuegos",
    countryId: "CU",
    timeZoneRegionName: "America/Havana",
    latitude: 22.15,
    longitude: -80.414167,
    icao: "MUCF"
  },
  CFK: {
    iata: "CFK",
    name: "Aboubakr Belkaid Airport",
    city: "Chlef",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 36.212222,
    longitude: 1.331667,
    icao: "DAOI"
  },
  CFM: {
    iata: "CFM",
    name: "Conklin (Leismer) Airport",
    city: "Conklin",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 55.696437,
    longitude: -111.28084,
    icao: "CET2"
  },
  CFN: {
    iata: "CFN",
    name: "Donegal Airport",
    city: "Donegal",
    countryId: "IE",
    timeZoneRegionName: "Europe/Dublin",
    latitude: 55.041667,
    longitude: -8.340278,
    icao: "EIDL"
  },
  CFQ: {
    iata: "CFQ",
    name: "Creston Airport",
    city: "Creston",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 49.036944,
    longitude: -116.498333,
    icao: "CAJ3"
  },
  CFR: {
    iata: "CFR",
    name: "Carpiquet Airport",
    city: "Caen",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 49.183437,
    longitude: -0.459276,
    icao: "LFRK"
  },
  CFS: {
    iata: "CFS",
    name: "Coffs Harbour Airport",
    city: "Coffs Harbour",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -30.322862,
    longitude: 153.115301,
    icao: "YCFS"
  },
  CFT: {
    iata: "CFT",
    name: "Morenci Airport",
    city: "Clifton",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 32.952801,
    longitude: -109.209999,
    icao: "KCFT"
  },
  CFU: {
    iata: "CFU",
    name: "Ioannis Kapodistrias Airport",
    city: "Kerkyra",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 39.60784,
    longitude: 19.914645,
    icao: "LGKR"
  },
  CFV: {
    iata: "CFV",
    name: "Coffeyville Municipal Airport",
    city: "Coffeyville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 37.033333,
    longitude: -95.616667,
    icao: "KCFV"
  },
  CGB: {
    iata: "CGB",
    name: "Marechal Rondon International Airport",
    city: "Cuiaba",
    countryId: "BR",
    timeZoneRegionName: "America/Campo_Grande",
    latitude: -15.651725,
    longitude: -56.120266,
    icao: "SBCY"
  },
  CGD: {
    iata: "CGD",
    name: "Changde Airport",
    city: "Changde",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 28.924467,
    longitude: 111.638863,
    icao: "ZGCD"
  },
  CGE: {
    iata: "CGE",
    name: "Cambridge Airport",
    city: "Cambridge",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 38.566667,
    longitude: -76.083333,
    icao: "KCGE"
  },
  CGF: {
    iata: "CGF",
    name: "Cuyahoga County Airport",
    city: "Cleveland",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.565181,
    longitude: -81.488049,
    icao: "KCGF"
  },
  CGH: {
    iata: "CGH",
    name: "Sao Paulo/Congonhas Airport",
    city: "Sao Paulo",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -23.626902,
    longitude: -46.659556,
    icao: "SBSP"
  },
  CGI: {
    iata: "CGI",
    name: "Cape Girardeau Airport",
    city: "Cape Girardeau",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 37.223611,
    longitude: -89.571667,
    icao: "KCGI"
  },
  CGK: {
    iata: "CGK",
    name: "Soekarno-Hatta International Airport",
    city: "Jakarta",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: -6.130643,
    longitude: 106.655526,
    icao: "WIII"
  },
  CGM: {
    iata: "CGM",
    name: "Camiguin Airport",
    city: "Mambajao",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 9.253611,
    longitude: 124.706944,
    icao: "RPMH"
  },
  CGN: {
    iata: "CGN",
    name: "Cologne Bonn Airport",
    city: "Cologne",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 50.878363,
    longitude: 7.122224,
    icao: "EDDK"
  },
  CGO: {
    iata: "CGO",
    name: "Zhengzhou Xinzheng Airport",
    city: "Zhengzhou",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 34.527519,
    longitude: 113.840242,
    icao: "ZHCC"
  },
  CGP: {
    iata: "CGP",
    name: "Shah Amanat International Airport",
    city: "Chittagong",
    countryId: "BD",
    timeZoneRegionName: "Asia/Dhaka",
    latitude: 22.245202,
    longitude: 91.815159,
    icao: "VGEG"
  },
  CGQ: {
    iata: "CGQ",
    name: "Changchun Longjia International Airport",
    city: "Changchun",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 43.99611,
    longitude: 125.68528,
    icao: "ZYCC"
  },
  CGR: {
    iata: "CGR",
    name: "Campo Grande International Airport",
    city: "Campo Grande",
    countryId: "BR",
    timeZoneRegionName: "America/Campo_Grande",
    latitude: -20.456992,
    longitude: -54.668872,
    icao: "SBCG"
  },
  CGS: {
    iata: "CGS",
    name: "College Park Airport",
    city: "College Park",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 38.980346,
    longitude: -76.922132,
    icao: "KCGS"
  },
  CGY: {
    iata: "CGY",
    name: "Laguindingan Airport",
    city: "Laguindingan",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 8.6125,
    longitude: 124.457222,
    icao: "RPMY"
  },
  CGZ: {
    iata: "CGZ",
    name: "Casa Grande Municipal Airport",
    city: "Casa Grande",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 32.954899,
    longitude: -111.766998,
    icao: "KCGZ"
  },
  CHA: {
    iata: "CHA",
    name: "Chattanooga Airport",
    city: "Chattanooga",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 35.036925,
    longitude: -85.197784,
    icao: "KCHA"
  },
  CHC: {
    iata: "CHC",
    name: "Christchurch International Airport",
    city: "Christchurch",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -43.488655,
    longitude: 172.538892,
    icao: "NZCH"
  },
  CHF: {
    iata: "CHF",
    name: "Jinhae Airport",
    city: "Jinhae",
    countryId: "KR",
    timeZoneRegionName: "Asia/Seoul",
    latitude: 35.1375,
    longitude: 128.697778,
    icao: "RKPE"
  },
  CHG: {
    iata: "CHG",
    name: "Chaoyang Airport",
    city: "Chaoyang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 41.545081,
    longitude: 120.437203,
    icao: "ZYCY"
  },
  CHH: {
    iata: "CHH",
    name: "Chachapoyas Airport",
    city: "Chachapoyas",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -6.201871,
    longitude: -77.85617,
    icao: "SPPY"
  },
  CHJ: {
    iata: "CHJ",
    name: "Chipinge Airport",
    city: "Chipinge",
    countryId: "ZW",
    timeZoneRegionName: "Africa/Harare",
    latitude: -20.2,
    longitude: 32.65,
    icao: "FVCH"
  },
  CHK: {
    iata: "CHK",
    name: "Chickasha Municipal Airport",
    city: "Chickasha",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.05,
    longitude: -97.966667,
    icao: "KCHK"
  },
  CHL: {
    iata: "CHL",
    name: "Challis Airport",
    city: "Challis",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 44.5,
    longitude: -114.25,
    icao: "KLLJ"
  },
  CHM: {
    iata: "CHM",
    name: "Chimbote Airport",
    city: "Chimbote",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -9.150556,
    longitude: -78.531111,
    icao: "SPEO"
  },
  CHO: {
    iata: "CHO",
    name: "Charlottesville Albemarle Airport",
    city: "Charlottesville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 38.139415,
    longitude: -78.449279,
    icao: "KCHO"
  },
  CHQ: {
    iata: "CHQ",
    name: "Chania International Airport",
    city: "Chania",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 35.5402,
    longitude: 24.140374,
    icao: "LGSA"
  },
  CHR: {
    iata: "CHR",
    name: "Deols Airport",
    city: "Chateauroux",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 46.861953,
    longitude: 1.728128,
    icao: "LFLX"
  },
  CHS: {
    iata: "CHS",
    name: "Charleston International Airport",
    city: "Charleston",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 32.884355,
    longitude: -80.037157,
    icao: "KCHS"
  },
  CHT: {
    iata: "CHT",
    name: "Karewa Airport",
    city: "Chatham Island",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Chatham",
    latitude: -43.811551,
    longitude: -176.463877,
    icao: "NZCI"
  },
  CHU: {
    iata: "CHU",
    name: "Chuathbaluk Airport",
    city: "Chuathbaluk",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 61.583436,
    longitude: -159.238821,
    icao: ""
  },
  CHV: {
    iata: "CHV",
    name: "Chaves Airport",
    city: "Chaves",
    countryId: "PT",
    timeZoneRegionName: "Europe/Lisbon",
    latitude: 41.733333,
    longitude: -7.466667,
    icao: "LPCH"
  },
  CHX: {
    iata: "CHX",
    name: "Changuinola Airport",
    city: "Changuinola",
    countryId: "PA",
    timeZoneRegionName: "America/Panama",
    latitude: 9.45,
    longitude: -82.45,
    icao: "MPCH"
  },
  CHY: {
    iata: "CHY",
    name: "Choiseul Bay Airport",
    city: "Choiseul Bay",
    countryId: "SB",
    timeZoneRegionName: "Pacific/Guadalcanal",
    latitude: -6.713787,
    longitude: 156.39856,
    icao: "AGGC"
  },
  CIA: {
    iata: "CIA",
    name: "Ciampino-G. B. Pastine International Airport",
    city: "Rome",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 41.799065,
    longitude: 12.590987,
    icao: "LIRA"
  },
  CIC: {
    iata: "CIC",
    name: "Chico Municipal Airport",
    city: "Chico",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 39.798178,
    longitude: -121.856046,
    icao: "KCIC"
  },
  CID: {
    iata: "CID",
    name: "The Eastern Iowa Airport",
    city: "Cedar Rapids",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.889423,
    longitude: -91.700305,
    icao: "KCID"
  },
  CIF: {
    iata: "CIF",
    name: "Yulong Airport",
    city: "Chifeng",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 42.154523,
    longitude: 118.833173,
    icao: "ZBCF"
  },
  CIG: {
    iata: "CIG",
    name: "Craig-Moffat Airport",
    city: "Craig",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 40.495556,
    longitude: -107.525,
    icao: "KCAG"
  },
  CIH: {
    iata: "CIH",
    name: "Changzhi Wangcun Airport",
    city: "Changzhi",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 36.245881,
    longitude: 113.121585,
    icao: "ZBCZ"
  },
  CIJ: {
    iata: "CIJ",
    name: "E. Beltram Airport",
    city: "Cobija",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -11.026389,
    longitude: -68.752778,
    icao: "SLCO"
  },
  CIK: {
    iata: "CIK",
    name: "Chalkyitsik Airport",
    city: "Chalkyitsik",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 66.648056,
    longitude: -143.729167,
    icao: "PACI"
  },
  CIM: {
    iata: "CIM",
    name: "Cimitarra Airport",
    city: "Cimitarra",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 6.483333,
    longitude: -74.116667,
    icao: "SKCM"
  },
  CIN: {
    iata: "CIN",
    name: "Carroll Airport",
    city: "Carroll",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 42.066667,
    longitude: -94.866667,
    icao: "KCIN"
  },
  CIP: {
    iata: "CIP",
    name: "Chipata Airport",
    city: "Chipata",
    countryId: "ZM",
    timeZoneRegionName: "Africa/Lusaka",
    latitude: -13.556944,
    longitude: 32.587222,
    icao: "FLCP"
  },
  CIR: {
    iata: "CIR",
    name: "Cairo Airport",
    city: "Cairo",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 37.064499,
    longitude: -89.219597,
    icao: "KCIR"
  },
  CIS: {
    iata: "CIS",
    name: "Canton Island Airport",
    city: "Canton Island",
    countryId: "KI",
    timeZoneRegionName: "Pacific/Enderbury",
    latitude: -2.833333,
    longitude: -171.666667,
    icao: "PCIS"
  },
  CIT: {
    iata: "CIT",
    name: "Shymkent Airport",
    city: "Shymkent",
    countryId: "KZ",
    timeZoneRegionName: "Asia/Almaty",
    latitude: 42.364842,
    longitude: 69.492845,
    icao: "UAII"
  },
  CIU: {
    iata: "CIU",
    name: "Chippewa County Airport",
    city: "Sault Ste. Marie",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 46.250598,
    longitude: -84.473192,
    icao: "KCIU"
  },
  CIW: {
    iata: "CIW",
    name: "Canouan Island Airport",
    city: "Canouan Island",
    countryId: "VC",
    timeZoneRegionName: "America/St_Vincent",
    latitude: 12.7,
    longitude: -61.316667,
    icao: "TVSC"
  },
  CIX: {
    iata: "CIX",
    name: "Cornel Ruiz Airport",
    city: "Chiclayo",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -6.789722,
    longitude: -79.832222,
    icao: "SPHI"
  },
  CIY: {
    iata: "CIY",
    name: "Comiso Airport",
    city: "Comiso",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 36.996209,
    longitude: 14.609152,
    icao: "LICB"
  },
  CIZ: {
    iata: "CIZ",
    name: "Coari Airport",
    city: "Coari",
    countryId: "BR",
    timeZoneRegionName: "America/Porto_Velho",
    latitude: -4.083333,
    longitude: -63.133333,
    icao: "SWKO"
  },
  CJA: {
    iata: "CJA",
    name: "Cajamarca Airport",
    city: "Cajamarca",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -7.133333,
    longitude: -78.5,
    icao: "SPJB"
  },
  CJB: {
    iata: "CJB",
    name: "Coimbatore International Airport",
    city: "Coimbatore",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 11.031026,
    longitude: 77.038931,
    icao: "VOCB"
  },
  CJC: {
    iata: "CJC",
    name: "El Loa Airport",
    city: "Calama",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -22.495084,
    longitude: -68.908435,
    icao: "SCCF"
  },
  CJF: {
    iata: "CJF",
    name: "Coondewanna Airport",
    city: "Coondewanna",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -22.966573,
    longitude: 118.812586,
    icao: "YCWA"
  },
  CJJ: {
    iata: "CJJ",
    name: "Cheongju Airport",
    city: "Cheongju",
    countryId: "KR",
    timeZoneRegionName: "Asia/Seoul",
    latitude: 36.7224,
    longitude: 127.495087,
    icao: "RKTU"
  },
  CJL: {
    iata: "CJL",
    name: "Chitral Airport",
    city: "Chitral",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 35.886111,
    longitude: 71.794444,
    icao: "OPCH"
  },
  CJM: {
    iata: "CJM",
    name: "Chumphon Airport",
    city: "Chumphon",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 10.711122,
    longitude: 99.361376,
    icao: "VTSE"
  },
  CJS: {
    iata: "CJS",
    name: "Abraham Gonzalez International Airport",
    city: "Ciudad Juarez",
    countryId: "MX",
    timeZoneRegionName: "America/Ojinaga",
    latitude: 31.635929,
    longitude: -106.436098,
    icao: "MMCS"
  },
  CJU: {
    iata: "CJU",
    name: "Jeju International Airport",
    city: "Jeju",
    countryId: "KR",
    timeZoneRegionName: "Asia/Seoul",
    latitude: 33.506698,
    longitude: 126.493119,
    icao: "RKPC"
  },
  CJZ: {
    iata: "CJZ",
    name: "Cajazeiras Airport",
    city: "Cajazeiras",
    countryId: "BR",
    timeZoneRegionName: "America/Fortaleza",
    latitude: -6.8811,
    longitude: -38.6181,
    icao: ""
  },
  CKA: {
    iata: "CKA",
    name: "Kegelman Air Field",
    city: "Cherokee",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.75,
    longitude: -98.35,
    icao: "KCKA"
  },
  CKB: {
    iata: "CKB",
    name: "Benedum Airport",
    city: "Clarksburg",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.295556,
    longitude: -80.229444,
    icao: "KCKB"
  },
  CKC: {
    iata: "CKC",
    name: "Cherkassy Airport",
    city: "Cherkassy",
    countryId: "UA",
    timeZoneRegionName: "Europe/Kiev",
    latitude: 49.416667,
    longitude: 32,
    icao: "UKKE"
  },
  CKD: {
    iata: "CKD",
    name: "Crooked Creek Airport",
    city: "Crooked Creek",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 61.870833,
    longitude: -158.100833,
    icao: ""
  },
  CKG: {
    iata: "CKG",
    name: "Chongqing Jiangbei International Airport",
    city: "Chongqing",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 29.7192,
    longitude: 106.641998,
    icao: "ZUCK"
  },
  CKH: {
    iata: "CKH",
    name: "Chokurdakh Airport",
    city: "Chokurdah",
    countryId: "RU",
    timeZoneRegionName: "Asia/Magadan",
    latitude: 70.633333,
    longitude: 147.883333,
    icao: "UESO"
  },
  CKI: {
    iata: "CKI",
    name: "Croker Island Airport",
    city: "Croker Island",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -11.2,
    longitude: 132.533333,
    icao: "YCKI"
  },
  CKM: {
    iata: "CKM",
    name: "Fletcher Field",
    city: "Clarksdale",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 34.2,
    longitude: -90.583333,
    icao: "KCKM"
  },
  CKN: {
    iata: "CKN",
    name: "Crookston Municipal Airport",
    city: "Crookston",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 47.783333,
    longitude: -96.616667,
    icao: "KCKN"
  },
  CKO: {
    iata: "CKO",
    name: "Cornelio Procopio Airport",
    city: "Cornelio Procopio",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -23.116667,
    longitude: -50.666667,
    icao: "SSCP"
  },
  CKS: {
    iata: "CKS",
    name: "Carajas Airport",
    city: "Carajas",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -6.114749,
    longitude: -50.001944,
    icao: "SBCJ"
  },
  CKV: {
    iata: "CKV",
    name: "Outlaw Field",
    city: "Clarksville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.620833,
    longitude: -87.414444,
    icao: "KCKV"
  },
  CKX: {
    iata: "CKX",
    name: "Chicken Airport",
    city: "Chicken",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 64.067778,
    longitude: -141.949167,
    icao: ""
  },
  CKY: {
    iata: "CKY",
    name: "Conakry Airport",
    city: "Conakry",
    countryId: "GN",
    timeZoneRegionName: "Africa/Conakry",
    latitude: 9.575655,
    longitude: -13.62017,
    icao: "GUCY"
  },
  CKZ: {
    iata: "CKZ",
    name: "Canakkale Airport",
    city: "Canakkale",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 40.137422,
    longitude: 26.426943,
    icao: "LTBH"
  },
  CLA: {
    iata: "CLA",
    name: "Comilla Airport",
    city: "Comilla",
    countryId: "BD",
    timeZoneRegionName: "Asia/Dhaka",
    latitude: 23.4375,
    longitude: 91.192222,
    icao: "VGCM"
  },
  CLD: {
    iata: "CLD",
    name: "McClellan-Palomar Airport",
    city: "Carlsbad",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 33.127288,
    longitude: -117.278883,
    icao: "KCRQ"
  },
  CLE: {
    iata: "CLE",
    name: "Cleveland Hopkins International Airport",
    city: "Cleveland",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.410856,
    longitude: -81.83821,
    icao: "KCLE"
  },
  CLF: {
    iata: "CLF",
    name: "Coltishall Ab",
    city: "Coltishall",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 52.8,
    longitude: 1.420935,
    icao: "EGYC"
  },
  CLH: {
    iata: "CLH",
    name: "Coolah Airport",
    city: "Coolah",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -31.833333,
    longitude: 149.7,
    icao: "YCAH"
  },
  CLI: {
    iata: "CLI",
    name: "Clintonville Airport",
    city: "Clintonville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 42.566667,
    longitude: -88.866667,
    icao: "KCLI"
  },
  CLJ: {
    iata: "CLJ",
    name: "Cluj-Napoca International Airport",
    city: "Cluj-Napoca",
    countryId: "RO",
    timeZoneRegionName: "Europe/Bucharest",
    latitude: 46.782061,
    longitude: 23.687014,
    icao: "LRCL"
  },
  CLK: {
    iata: "CLK",
    name: "Clinton Regional Airport",
    city: "Clinton",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.538056,
    longitude: -98.9325,
    icao: "KCLK"
  },
  CLL: {
    iata: "CLL",
    name: "Easterwood Airport",
    city: "College Station",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.593842,
    longitude: -96.366818,
    icao: "KCLL"
  },
  CLM: {
    iata: "CLM",
    name: "William R. Fairchild International Airport",
    city: "Port Angeles",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 48.118658,
    longitude: -123.497237,
    icao: "KCLM"
  },
  CLN: {
    iata: "CLN",
    name: "Carolina Airport",
    city: "Carolina",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -7.333333,
    longitude: -47.45,
    icao: "SBCI"
  },
  CLO: {
    iata: "CLO",
    name: "Alfonso B. Aragon Airport",
    city: "Cali",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 3.543056,
    longitude: -76.381389,
    icao: "SKCL"
  },
  CLP: {
    iata: "CLP",
    name: "Clarks Point Airport",
    city: "Clarks Point",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 58.836903,
    longitude: -158.528192,
    icao: "PFCL"
  },
  CLQ: {
    iata: "CLQ",
    name: "Miguel de la Madrid Airport",
    city: "Colima",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 19.277,
    longitude: -103.577002,
    icao: "MMIA"
  },
  CLR: {
    iata: "CLR",
    name: "Cliff Hatfield Memorial Airport",
    city: "Calipatria",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 33.1315,
    longitude: -115.521004,
    icao: "KCLR"
  },
  CLS: {
    iata: "CLS",
    name: "Centralia Airport",
    city: "Chehalis",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 46.673889,
    longitude: -122.981111,
    icao: "KCLS"
  },
  CLT: {
    iata: "CLT",
    name: "Charlotte Douglas International Airport",
    city: "Charlotte",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 35.219167,
    longitude: -80.935833,
    icao: "KCLT"
  },
  CLU: {
    iata: "CLU",
    name: "Columbus Municipal Airport",
    city: "Columbus",
    countryId: "US",
    timeZoneRegionName: "America/Indiana/Indianapolis",
    latitude: 39.261918,
    longitude: -85.896329,
    icao: "KBAK"
  },
  CLV: {
    iata: "CLV",
    name: "Nelson R. Guimaraes Airport",
    city: "Caldas Novas",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -17.725605,
    longitude: -48.60746,
    icao: "SBCN"
  },
  CLW: {
    iata: "CLW",
    name: "Clearwater Air Park",
    city: "Tampa",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 27.976667,
    longitude: -82.758611,
    icao: "KCLW"
  },
  CLX: {
    iata: "CLX",
    name: "Clorinda Airport",
    city: "Clorinda",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -25.333333,
    longitude: -57.666667,
    icao: "SATC"
  },
  CLY: {
    iata: "CLY",
    name: "Sainte Catherine Airport",
    city: "Calvi",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 42.527778,
    longitude: 8.791667,
    icao: "LFKC"
  },
  CLZ: {
    iata: "CLZ",
    name: "Calabozo Airport",
    city: "Calabozo",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 8.933333,
    longitude: -67.433333,
    icao: "SVCL"
  },
  CMA: {
    iata: "CMA",
    name: "Cunnamulla Airport",
    city: "Cunnamulla",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -28.031389,
    longitude: 145.616111,
    icao: "YCMU"
  },
  CMB: {
    iata: "CMB",
    name: "Bandaranaike International Airport",
    city: "Colombo",
    countryId: "LK",
    timeZoneRegionName: "Asia/Colombo",
    latitude: 7.174112,
    longitude: 79.886494,
    icao: "VCBI"
  },
  CMD: {
    iata: "CMD",
    name: "Cootamundra Airport",
    city: "Cootamundra",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -34.628333,
    longitude: 148.043333,
    icao: "YCTM"
  },
  CME: {
    iata: "CME",
    name: "Ciudad Del Carmen Airport",
    city: "Ciudad Del Carmen",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 18.651029,
    longitude: -91.802734,
    icao: "MMCE"
  },
  CMF: {
    iata: "CMF",
    name: "Chambery Airport",
    city: "Chambery",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 45.637994,
    longitude: 5.88437,
    icao: "LFLB"
  },
  CMG: {
    iata: "CMG",
    name: "Corumba Internacional Airport",
    city: "Corumba",
    countryId: "BR",
    timeZoneRegionName: "America/Campo_Grande",
    latitude: -19.011111,
    longitude: -57.672222,
    icao: "SBCR"
  },
  CMH: {
    iata: "CMH",
    name: "John Glenn Columbus International Airport",
    city: "Columbus",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.998181,
    longitude: -82.884966,
    icao: "KCMH"
  },
  CMI: {
    iata: "CMI",
    name: "University of Illinois Willard Airport",
    city: "Champaign",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 40.039167,
    longitude: -88.278056,
    icao: "KCMI"
  },
  CMK: {
    iata: "CMK",
    name: "Club Makokola Airport",
    city: "Club Makokola",
    countryId: "MW",
    timeZoneRegionName: "Africa/Blantyre",
    latitude: -14.3069,
    longitude: 35.1325,
    icao: "FWCM"
  },
  CMN: {
    iata: "CMN",
    name: "Mohamed V International Airport",
    city: "Casablanca",
    countryId: "MA",
    timeZoneRegionName: "Africa/Casablanca",
    latitude: 33.366667,
    longitude: -7.586667,
    icao: "GMMN"
  },
  CMO: {
    iata: "CMO",
    name: "Obbia Airport",
    city: "Obbia",
    countryId: "SO",
    timeZoneRegionName: "Africa/Mogadishu",
    latitude: 5.366667,
    longitude: 48.516667,
    icao: "HCMO"
  },
  CMP: {
    iata: "CMP",
    name: "Santana do Araguaia Airport",
    city: "Santana do Araguaia",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -9.319973,
    longitude: -50.328492,
    icao: "SNKE"
  },
  CMQ: {
    iata: "CMQ",
    name: "Clermont Airport",
    city: "Clermont",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -22.77181,
    longitude: 147.621888,
    icao: "YCMT"
  },
  CMR: {
    iata: "CMR",
    name: "Colmar-Houssen Airport",
    city: "Colmar",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 48.083333,
    longitude: 7.366667,
    icao: "LFGA"
  },
  CMS: {
    iata: "CMS",
    name: "Scusciuban Airport",
    city: "Scusciuban",
    countryId: "SO",
    timeZoneRegionName: "Africa/Mogadishu",
    latitude: 10.3,
    longitude: 50.233333,
    icao: "HCMS"
  },
  CMV: {
    iata: "CMV",
    name: "Coromandel Airport",
    city: "Coromandel",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -36.791132,
    longitude: 175.508453,
    icao: "NZCX"
  },
  CMW: {
    iata: "CMW",
    name: "Ign Agramonte International Airport",
    city: "Camaguey",
    countryId: "CU",
    timeZoneRegionName: "America/Havana",
    latitude: 21.418611,
    longitude: -77.849722,
    icao: "MUCM"
  },
  CMX: {
    iata: "CMX",
    name: "Houghton County Airport",
    city: "Hancock",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 47.167778,
    longitude: -88.486389,
    icao: "KCMX"
  },
  CMY: {
    iata: "CMY",
    name: "Fort McCoy Army Air Field",
    city: "Sparta",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 44.033472,
    longitude: -90.778972,
    icao: "KCMY"
  },
  CNA: {
    iata: "CNA",
    name: "Cananea Airport",
    city: "Cananea",
    countryId: "MX",
    timeZoneRegionName: "America/Hermosillo",
    latitude: 31,
    longitude: -110.333333,
    icao: "MMCA"
  },
  CNB: {
    iata: "CNB",
    name: "Coonamble Airport",
    city: "Coonamble",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -30.980833,
    longitude: 148.378333,
    icao: "YCNM"
  },
  CNC: {
    iata: "CNC",
    name: "Coconut Island Airport",
    city: "Coconut Island",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -10.049966,
    longitude: 143.070066,
    icao: "YCCT"
  },
  CND: {
    iata: "CND",
    name: "Kogalniceanu Airport",
    city: "Constanta",
    countryId: "RO",
    timeZoneRegionName: "Europe/Bucharest",
    latitude: 44.35,
    longitude: 28.483333,
    icao: "LRCK"
  },
  CNF: {
    iata: "CNF",
    name: "Tancredo Neves International Airport",
    city: "Belo Horizonte",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -19.632417,
    longitude: -43.963213,
    icao: "SBCF"
  },
  CNG: {
    iata: "CNG",
    name: "Chateaubernard Airport",
    city: "Cognac",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 45.683333,
    longitude: -0.333333,
    icao: "LFBG"
  },
  CNH: {
    iata: "CNH",
    name: "Claremont Municipal Airport",
    city: "Claremont",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 43.383333,
    longitude: -72.333333,
    icao: "KCNH"
  },
  CNJ: {
    iata: "CNJ",
    name: "Cloncurry Airport",
    city: "Cloncurry",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -20.668905,
    longitude: 140.508521,
    icao: "YCCY"
  },
  CNK: {
    iata: "CNK",
    name: "Blosser Municipal Airport",
    city: "Concordia",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 39.566667,
    longitude: -97.666667,
    icao: "KCNK"
  },
  CNL: {
    iata: "CNL",
    name: "Sindal Airport",
    city: "Sindal",
    countryId: "DK",
    timeZoneRegionName: "Europe/Copenhagen",
    latitude: 57.483333,
    longitude: 10.216667,
    icao: "EKSN"
  },
  CNM: {
    iata: "CNM",
    name: "Cavern City Air Terminal",
    city: "Carlsbad",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 32.337222,
    longitude: -104.262778,
    icao: "KCNM"
  },
  CNN: {
    iata: "CNN",
    name: "Kannur International Airport",
    city: "Kannur",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 11.914835186,
    longitude: 75.548626709,
    icao: "VOKN"
  },
  CNO: {
    iata: "CNO",
    name: "Chino Airport",
    city: "Chino",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 33.980833,
    longitude: -117.639167,
    icao: "KCNO"
  },
  CNP: {
    iata: "CNP",
    name: "Neerlerit Inaat Airport",
    city: "Neerlerit Inaat",
    countryId: "GL",
    timeZoneRegionName: "America/Scoresbysund",
    latitude: 70.743056,
    longitude: -22.658333,
    icao: "BGCO"
  },
  CNQ: {
    iata: "CNQ",
    name: "Camba Punta Airport",
    city: "Corrientes",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -27.449722,
    longitude: -58.762222,
    icao: "SARC"
  },
  CNR: {
    iata: "CNR",
    name: "Chanaral Airport",
    city: "Chanaral",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -26.329167,
    longitude: -70.604167,
    icao: "SCRA"
  },
  CNS: {
    iata: "CNS",
    name: "Cairns Airport",
    city: "Cairns",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -16.876538,
    longitude: 145.754041,
    icao: "YBCS"
  },
  CNU: {
    iata: "CNU",
    name: "Martin Johnson Airport",
    city: "Chanute",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 37.683333,
    longitude: -95.45,
    icao: "KCNU"
  },
  CNW: {
    iata: "CNW",
    name: "TSTC Waco Airport",
    city: "Waco",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 31.63759,
    longitude: -97.073408,
    icao: "KCNW"
  },
  CNX: {
    iata: "CNX",
    name: "Chiang Mai International Airport",
    city: "Chiang Mai",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 18.769574,
    longitude: 98.968409,
    icao: "VTCC"
  },
  CNY: {
    iata: "CNY",
    name: "Canyonlands Field",
    city: "Moab",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 38.759444,
    longitude: -109.746111,
    icao: "KCNY"
  },
  COC: {
    iata: "COC",
    name: "Comodoro Pierrestegui Airport",
    city: "Concordia",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -31.297222,
    longitude: -57.996389,
    icao: "SAAC"
  },
  COD: {
    iata: "COD",
    name: "Yellowstone Regional Airport",
    city: "Cody",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 44.515833,
    longitude: -109.0275,
    icao: "KCOD"
  },
  COE: {
    iata: "COE",
    name: "Pappy Boyington Field",
    city: "Coeur D'Alene",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 47.774279,
    longitude: -116.819654,
    icao: "KCOE"
  },
  COF: {
    iata: "COF",
    name: "Patrick Air Force Base",
    city: "Cocoa",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 28.241516,
    longitude: -80.609387,
    icao: "KCOF"
  },
  COG: {
    iata: "COG",
    name: "Mandinga Airport",
    city: "Condoto",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 5.071961,
    longitude: -76.676625,
    icao: "SKCD"
  },
  COH: {
    iata: "COH",
    name: "Cooch Behar Airport",
    city: "Cooch Behar",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 26.333333,
    longitude: 89.466667,
    icao: "VECO"
  },
  COI: {
    iata: "COI",
    name: "Merritt Island Airport",
    city: "Cocoa",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 28.342023,
    longitude: -80.68677,
    icao: "KCOI"
  },
  COJ: {
    iata: "COJ",
    name: "Coonabarabran Airport",
    city: "Coonabarabran",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -31.337222,
    longitude: 149.271944,
    icao: "YCBB"
  },
  COK: {
    iata: "COK",
    name: "Cochin International Airport",
    city: "Kochi",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 10.155644,
    longitude: 76.390537,
    icao: "VOCI"
  },
  COL: {
    iata: "COL",
    name: "Coll Island Airport",
    city: "Coll Island",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 56.616667,
    longitude: -6.616667,
    icao: "EGEL"
  },
  COM: {
    iata: "COM",
    name: "Coleman Airport",
    city: "Coleman",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 31.833333,
    longitude: -99.433333,
    icao: "KCOM"
  },
  CON: {
    iata: "CON",
    name: "Concord Municipal Airport",
    city: "Concord",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 43.20463,
    longitude: -71.501789,
    icao: "KCON"
  },
  COO: {
    iata: "COO",
    name: "Cotonou Airport",
    city: "Cotonou",
    countryId: "BJ",
    timeZoneRegionName: "Africa/Porto-Novo",
    latitude: 6.353869,
    longitude: 2.383816,
    icao: "DBBB"
  },
  COQ: {
    iata: "COQ",
    name: "Choibalsan Airport",
    city: "Choibalsan",
    countryId: "MN",
    timeZoneRegionName: "Asia/Ulaanbaatar",
    latitude: 48.135721,
    longitude: 114.646025,
    icao: "ZMCD"
  },
  COR: {
    iata: "COR",
    name: "Ingeniero Aeronautico Ambrosio L.V. Taravella International Airport",
    city: "Cordoba",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -31.315785,
    longitude: -64.211904,
    icao: "SACO"
  },
  COS: {
    iata: "COS",
    name: "Colorado Springs Municipal Airport",
    city: "Colorado Springs",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 38.805778,
    longitude: -104.700747,
    icao: "KCOS"
  },
  COT: {
    iata: "COT",
    name: "Cotulla Airport",
    city: "Cotulla",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 28.433333,
    longitude: -99.233333,
    icao: "KCOT"
  },
  COU: {
    iata: "COU",
    name: "Columbia Regional Airport",
    city: "Columbia",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 38.813611,
    longitude: -92.219167,
    icao: "KCOU"
  },
  COV: {
    iata: "COV",
    name: "\xC7ukurova International Airport",
    city: "Mersin",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 36.89694,
    longitude: 35.0675,
    icao: "LTDB"
  },
  COZ: {
    iata: "COZ",
    name: "Constanza Airport",
    city: "Constanza",
    countryId: "DO",
    timeZoneRegionName: "America/Santo_Domingo",
    latitude: 18.9,
    longitude: -70.716667,
    icao: "MDCZ"
  },
  CPA: {
    iata: "CPA",
    name: "A. Tubman Airport",
    city: "Cape Palmas",
    countryId: "LR",
    timeZoneRegionName: "Africa/Monrovia",
    latitude: 4.376667,
    longitude: -7.695556,
    icao: "GLCP"
  },
  CPC: {
    iata: "CPC",
    name: "Aviador Carlos Campos Airport",
    city: "San Martin De Los Andes",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -40.075414,
    longitude: -71.137288,
    icao: "SAZY"
  },
  CPD: {
    iata: "CPD",
    name: "Coober Pedy Airport",
    city: "Coober Pedy",
    countryId: "AU",
    timeZoneRegionName: "Australia/Adelaide",
    latitude: -29.044444,
    longitude: 134.752778,
    icao: "YCBP"
  },
  CPE: {
    iata: "CPE",
    name: "Campeche International Airport",
    city: "Campeche",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 19.835,
    longitude: -90.509444,
    icao: "MMCP"
  },
  CPH: {
    iata: "CPH",
    name: "Copenhagen Airport",
    city: "Copenhagen",
    countryId: "DK",
    timeZoneRegionName: "Europe/Copenhagen",
    latitude: 55.629053,
    longitude: 12.647601,
    icao: "EKCH"
  },
  CPL: {
    iata: "CPL",
    name: "Chaparral Airport",
    city: "Chaparral",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 3.716667,
    longitude: -75.466667,
    icao: "SKHA"
  },
  CPM: {
    iata: "CPM",
    name: "Compton Airport",
    city: "Compton",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 33.894444,
    longitude: -118.247778,
    icao: "KCPM"
  },
  CPO: {
    iata: "CPO",
    name: "Chamonate Airport",
    city: "Copiapo",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -27.29892,
    longitude: -70.414407,
    icao: "SCHA"
  },
  CPQ: {
    iata: "CPQ",
    name: "Amarais Airport",
    city: "Campinas",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -22.858381,
    longitude: -47.109435,
    icao: "SDAM"
  },
  CPR: {
    iata: "CPR",
    name: "Casper/Natrona County International Airport",
    city: "Casper",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 42.908611,
    longitude: -106.4625,
    icao: "KCPR"
  },
  CPS: {
    iata: "CPS",
    name: "St. Louis Downtown Airport",
    city: "Saint Louis",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 38.574974,
    longitude: -90.155989,
    icao: "KCPS"
  },
  CPT: {
    iata: "CPT",
    name: "Cape Town International Airport",
    city: "Cape Town",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -33.968906,
    longitude: 18.596489,
    icao: "FACT"
  },
  CPV: {
    iata: "CPV",
    name: "Joao Suassuna Airport",
    city: "Campina Grande",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -7.266667,
    longitude: -35.9,
    icao: "SBKG"
  },
  CPX: {
    iata: "CPX",
    name: "Benjamin Rivera Noriega Airport",
    city: "Culebra",
    countryId: "PR",
    timeZoneRegionName: "America/Puerto_Rico",
    latitude: 18.312074,
    longitude: -65.301716,
    icao: "TJCP"
  },
  CQA: {
    iata: "CQA",
    name: "Canarana Airport",
    city: "Canarana",
    countryId: "BR",
    timeZoneRegionName: "America/Campo_Grande",
    latitude: -13.574167,
    longitude: -52.270278,
    icao: "SWEK"
  },
  CQF: {
    iata: "CQF",
    name: "Calais Airport",
    city: "Calais",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 50.95,
    longitude: 1.933333,
    icao: "LFAC"
  },
  CQS: {
    iata: "CQS",
    name: "Costa Marques Airport",
    city: "Costa Marques",
    countryId: "BR",
    timeZoneRegionName: "America/Porto_Velho",
    latitude: -12.416667,
    longitude: -64.25,
    icao: "SWCQ"
  },
  CQW: {
    iata: "CQW",
    name: "Chongqing Xiannvshan Airport",
    city: "Wulong",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 29.4642,
    longitude: 107.6933,
    icao: ""
  },
  CRA: {
    iata: "CRA",
    name: "Craiova Airport",
    city: "Craiova",
    countryId: "RO",
    timeZoneRegionName: "Europe/Bucharest",
    latitude: 44.318889,
    longitude: 23.886389,
    icao: "LRCV"
  },
  CRB: {
    iata: "CRB",
    name: "Collarenebri Airport",
    city: "Collarenebri",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -29.55,
    longitude: 148.583333,
    icao: "YCBR"
  },
  CRC: {
    iata: "CRC",
    name: "Santa Ana Airport",
    city: "Cartago",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 4.760994,
    longitude: -75.954674,
    icao: "SKGO"
  },
  CRD: {
    iata: "CRD",
    name: "General E. Mosconi International Airport",
    city: "Comodoro Rivadavia",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -45.789323,
    longitude: -67.469738,
    icao: "SAVC"
  },
  CRE: {
    iata: "CRE",
    name: "Grand Strand Airport",
    city: "Myrtle Beach",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 33.811389,
    longitude: -78.724444,
    icao: "KCRE"
  },
  CRG: {
    iata: "CRG",
    name: "Jacksonville Executive at Craig Airport",
    city: "Jacksonville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 30.33631,
    longitude: -81.511856,
    icao: "KCRG"
  },
  CRI: {
    iata: "CRI",
    name: "Crooked Island Airport",
    city: "Crooked Island",
    countryId: "BS",
    timeZoneRegionName: "America/Nassau",
    latitude: 22.75,
    longitude: -74.15,
    icao: "MYCI"
  },
  CRK: {
    iata: "CRK",
    name: "Clark International Airport",
    city: "Angeles",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 15.187696,
    longitude: 120.549789,
    icao: "RPLC"
  },
  CRL: {
    iata: "CRL",
    name: "Brussels S. Charleroi Airport",
    city: "Brussels",
    countryId: "BE",
    timeZoneRegionName: "Europe/Brussels",
    latitude: 50.459206,
    longitude: 4.45382,
    icao: "EBCI"
  },
  CRM: {
    iata: "CRM",
    name: "Catarman National Airport",
    city: "Catarman",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 12.502492,
    longitude: 124.63591,
    icao: "RPVF"
  },
  CRO: {
    iata: "CRO",
    name: "Corcoran Airport",
    city: "Corcoran",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 36.1,
    longitude: -119.55,
    icao: "KCRO"
  },
  CRP: {
    iata: "CRP",
    name: "Corpus Christi International Airport",
    city: "Corpus Christi",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 27.774813,
    longitude: -97.502489,
    icao: "KCRP"
  },
  CRQ: {
    iata: "CRQ",
    name: "Caravelas Airport",
    city: "Caravelas",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -17.75,
    longitude: -39.25,
    icao: "SBCV"
  },
  CRR: {
    iata: "CRR",
    name: "Ceres Airport",
    city: "Ceres",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -29.916667,
    longitude: -61.833333,
    icao: "SANW"
  },
  CRS: {
    iata: "CRS",
    name: "C. David Campbell Field",
    city: "Corsicana",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.028086,
    longitude: -96.400582,
    icao: "KCRS"
  },
  CRT: {
    iata: "CRT",
    name: "Z.M. Jack Stell Field",
    city: "Crossett",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 33.178296,
    longitude: -91.880205,
    icao: "KCRT"
  },
  CRV: {
    iata: "CRV",
    name: "Crotone Airport",
    city: "Crotone",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 38.996305,
    longitude: 17.080778,
    icao: "LIBC"
  },
  CRW: {
    iata: "CRW",
    name: "Yeager Airport",
    city: "Charleston",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 38.370342,
    longitude: -81.596504,
    icao: "KCRW"
  },
  CRX: {
    iata: "CRX",
    name: "Roscoe Turner Airport",
    city: "Corinth",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 34.915001,
    longitude: -88.6035,
    icao: "KCRX"
  },
  CRZ: {
    iata: "CRZ",
    name: "Turkmenabat Airport",
    city: "Chardzhev",
    countryId: "TM",
    timeZoneRegionName: "Asia/Ashgabat",
    latitude: 39.09258,
    longitude: 63.601198,
    icao: "UTAV"
  },
  CSA: {
    iata: "CSA",
    name: "Colonsay Airport",
    city: "Colonsay Island",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 56.083333,
    longitude: -6.2,
    icao: "EGEY"
  },
  CSB: {
    iata: "CSB",
    name: "Caransebes Airport",
    city: "Caransebes",
    countryId: "RO",
    timeZoneRegionName: "Europe/Bucharest",
    latitude: 45.416667,
    longitude: 22.216667,
    icao: "LRCS"
  },
  CSF: {
    iata: "CSF",
    name: "Creil Airport",
    city: "Creil",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 49.25,
    longitude: 2.483333,
    icao: "LFPC"
  },
  CSG: {
    iata: "CSG",
    name: "Columbus Airport",
    city: "Columbus",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 32.513333,
    longitude: -84.941111,
    icao: "KCSG"
  },
  CSH: {
    iata: "CSH",
    name: "Solovky Airport",
    city: "Solovetsky",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 65.029444,
    longitude: 35.733333,
    icao: "ULAS"
  },
  CSI: {
    iata: "CSI",
    name: "Casino Airport",
    city: "Casino",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -28.883333,
    longitude: 153.058333,
    icao: "YCAS"
  },
  CSK: {
    iata: "CSK",
    name: "Cap Skirring Airport",
    city: "Cap Skirring",
    countryId: "SN",
    timeZoneRegionName: "Africa/Dakar",
    latitude: 12.392154,
    longitude: -16.744121,
    icao: "GOGS"
  },
  CSM: {
    iata: "CSM",
    name: "Sherman Airport",
    city: "Clinton",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.539167,
    longitude: -96.933333,
    icao: "KCSM"
  },
  CSN: {
    iata: "CSN",
    name: "Carson City Airport",
    city: "Carson City",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 39.191667,
    longitude: -119.734722,
    icao: "KCXP"
  },
  CSQ: {
    iata: "CSQ",
    name: "Creston Municipal Airport",
    city: "Creston",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.066667,
    longitude: -94.366667,
    icao: "KCSQ"
  },
  CST: {
    iata: "CST",
    name: "Castaway Island Sea Plane Base",
    city: "Castaway",
    countryId: "FJ",
    timeZoneRegionName: "Pacific/Fiji",
    latitude: -17.735775,
    longitude: 177.129061,
    icao: "NFCS"
  },
  CSU: {
    iata: "CSU",
    name: "Santa Cruz Do Sul Airport",
    city: "Santa Cruz Do Sul",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -29.683333,
    longitude: -52.416667,
    icao: "SSSC"
  },
  CSV: {
    iata: "CSV",
    name: "Memorial-Whitson Field",
    city: "Crossville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.951111,
    longitude: -85.084722,
    icao: "KCSV"
  },
  CSX: {
    iata: "CSX",
    name: "Changsha Huanghua Airport",
    city: "Changsha",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 28.193336,
    longitude: 113.214592,
    icao: "ZGHA"
  },
  CSY: {
    iata: "CSY",
    name: "Cheboksary Airport",
    city: "Cheboksary",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 56.090302,
    longitude: 47.347301,
    icao: "UWKS"
  },
  CSZ: {
    iata: "CSZ",
    name: "Brigadier Hector Ruiz",
    city: "Coronel Suarez",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -37.433333,
    longitude: -61.883333,
    icao: "SACZ"
  },
  CTA: {
    iata: "CTA",
    name: "Catania-Fontanarossa Airport",
    city: "Catania",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 37.470663,
    longitude: 15.065877,
    icao: "LICC"
  },
  CTB: {
    iata: "CTB",
    name: "Cut Bank Municipal Airport",
    city: "Cut Bank",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 48.608624,
    longitude: -112.377903,
    icao: "KCTB"
  },
  CTC: {
    iata: "CTC",
    name: "Catamarca Airport",
    city: "Catamarca",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -28.448333,
    longitude: -65.779722,
    icao: "SANC"
  },
  CTD: {
    iata: "CTD",
    name: "Chitre Alonso Valderrama Airport",
    city: "Chitre",
    countryId: "PA",
    timeZoneRegionName: "America/Panama",
    latitude: 7.981562,
    longitude: -80.4107,
    icao: "MPCE"
  },
  CTG: {
    iata: "CTG",
    name: "Rafael Nunez International Airport",
    city: "Cartagena",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 10.445704,
    longitude: -75.516585,
    icao: "SKCG"
  },
  CTH: {
    iata: "CTH",
    name: "Chester County G. O. Carlson Airport",
    city: "Coatesville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.979532,
    longitude: -75.863395,
    icao: "KMQS"
  },
  CTL: {
    iata: "CTL",
    name: "Charleville Airport",
    city: "Charleville",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -26.413333,
    longitude: 146.258428,
    icao: "YBCV"
  },
  CTM: {
    iata: "CTM",
    name: "Chetumal Airport",
    city: "Chetumal",
    countryId: "MX",
    timeZoneRegionName: "America/Cancun",
    latitude: 18.504622,
    longitude: -88.326858,
    icao: "MMCM"
  },
  CTN: {
    iata: "CTN",
    name: "Cooktown Airport",
    city: "Cooktown",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -15.443333,
    longitude: 145.183333,
    icao: "YCKN"
  },
  CTP: {
    iata: "CTP",
    name: "Carutapera Airport",
    city: "Carutapera",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -1.25,
    longitude: -46.016667,
    icao: "SNCP"
  },
  CTS: {
    iata: "CTS",
    name: "New Chitose Airport",
    city: "Sapporo",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 42.787281,
    longitude: 141.681341,
    icao: "RJCC"
  },
  CTT: {
    iata: "CTT",
    name: "Le Castellet Airport",
    city: "Le Castellet",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 43.25,
    longitude: 5.783333,
    icao: "LFMQ"
  },
  CTU: {
    iata: "CTU",
    name: "Chengdu Shuangliu International Airport",
    city: "Chengdu",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 30.581134,
    longitude: 103.956799,
    icao: "ZUUU"
  },
  CTY: {
    iata: "CTY",
    name: "Cross City Airport",
    city: "Cross City",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 29.633333,
    longitude: -83.116667,
    icao: "KCTY"
  },
  CTZ: {
    iata: "CTZ",
    name: "Sampson County Airport",
    city: "Clinton",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 35,
    longitude: -78.366667,
    icao: "KCTZ"
  },
  CUA: {
    iata: "CUA",
    name: "Ciudad Constitucion Airport",
    city: "Ciudad Constitucion",
    countryId: "MX",
    timeZoneRegionName: "America/Mazatlan",
    latitude: 25.050447,
    longitude: -111.612782,
    icao: "MMDA"
  },
  CUB: {
    iata: "CUB",
    name: "J. Hamilton-L.B. Owens Airport",
    city: "Columbia",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 33.970556,
    longitude: -80.995278,
    icao: "KCUB"
  },
  CUC: {
    iata: "CUC",
    name: "Camilo Daza International Airport",
    city: "Cucuta",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 7.927108,
    longitude: -72.508149,
    icao: "SKCC"
  },
  CUD: {
    iata: "CUD",
    name: "Caloundra Airport",
    city: "Caloundra",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -26.8,
    longitude: 153.15,
    icao: "YCDR"
  },
  CUE: {
    iata: "CUE",
    name: "Mariscal Lamar International Airport",
    city: "Cuenca",
    countryId: "EC",
    timeZoneRegionName: "America/Guayaquil",
    latitude: -2.889343,
    longitude: -78.986894,
    icao: "SECU"
  },
  CUF: {
    iata: "CUF",
    name: "Levaldigi Airport",
    city: "Cuneo",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 44.535278,
    longitude: 7.6175,
    icao: "LIMZ"
  },
  CUH: {
    iata: "CUH",
    name: "Cushing Municipal Airport",
    city: "Cushing",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.983333,
    longitude: -96.766667,
    icao: "KCUH"
  },
  CUK: {
    iata: "CUK",
    name: "Caye Caulker airport",
    city: "Caye Caulker",
    countryId: "BZ",
    timeZoneRegionName: "America/Belize",
    latitude: 17.735,
    longitude: -88.0291,
    icao: "MZCK"
  },
  CUL: {
    iata: "CUL",
    name: "Culiacan International Airport",
    city: "Culiacan",
    countryId: "MX",
    timeZoneRegionName: "America/Mazatlan",
    latitude: 24.766429,
    longitude: -107.469585,
    icao: "MMCL"
  },
  CUM: {
    iata: "CUM",
    name: "Antonio Jose de Sucre Airport",
    city: "Cumana",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 10.449879,
    longitude: -64.131742,
    icao: "SVCU"
  },
  CUN: {
    iata: "CUN",
    name: "Cancun International Airport",
    city: "Cancun",
    countryId: "MX",
    timeZoneRegionName: "America/Cancun",
    latitude: 21.040457,
    longitude: -86.874439,
    icao: "MMUN"
  },
  CUO: {
    iata: "CUO",
    name: "Caruru Airport",
    city: "Caruru",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 1.033333,
    longitude: -71.233333,
    icao: "SKCR"
  },
  CUP: {
    iata: "CUP",
    name: "Carupano Airport",
    city: "Carupano",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 10.658889,
    longitude: -63.2625,
    icao: "SVCP"
  },
  CUQ: {
    iata: "CUQ",
    name: "Coen Airport",
    city: "Coen",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -13.765341,
    longitude: 143.119076,
    icao: "YCOE"
  },
  CUR: {
    iata: "CUR",
    name: "Hato International Airport",
    city: "Curacao",
    countryId: "CW",
    timeZoneRegionName: "America/Curacao",
    latitude: 12.188858,
    longitude: -68.959805,
    icao: "TNCC"
  },
  CUT: {
    iata: "CUT",
    name: "Cutral Airport",
    city: "Cutral",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -38.9,
    longitude: -69,
    icao: "SAZW"
  },
  CUU: {
    iata: "CUU",
    name: "Gen Fierro Villalobos Airport",
    city: "Chihuahua",
    countryId: "MX",
    timeZoneRegionName: "America/Mazatlan",
    latitude: 28.704048,
    longitude: -105.969523,
    icao: "MMCU"
  },
  CUY: {
    iata: "CUY",
    name: "Cue Airport",
    city: "Cue",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -27.45,
    longitude: 117.916667,
    icao: "YCUE"
  },
  CUZ: {
    iata: "CUZ",
    name: "Alejandro Velasco Astete International Airport",
    city: "Cuzco",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -13.538429,
    longitude: -71.943714,
    icao: "SPZO"
  },
  CVC: {
    iata: "CVC",
    name: "Cleve Airport",
    city: "Cleve",
    countryId: "AU",
    timeZoneRegionName: "Australia/Adelaide",
    latitude: -33.7,
    longitude: 136.5,
    icao: "YCEE"
  },
  CVE: {
    iata: "CVE",
    name: "Covenas Airport",
    city: "Covenas",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 9.4,
    longitude: -75.733333,
    icao: "SKCV"
  },
  CVF: {
    iata: "CVF",
    name: "Courchevel Airport",
    city: "Courchevel",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 45.396667,
    longitude: 6.634722,
    icao: "LFLJ"
  },
  CVG: {
    iata: "CVG",
    name: "Cincinnati/Northern Kentucky Airport",
    city: "Cincinnati",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.0555,
    longitude: -84.66145,
    icao: "KCVG"
  },
  CVJ: {
    iata: "CVJ",
    name: "General Mariano Matamoros Airport",
    city: "Cuernavaca",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 18.831704,
    longitude: -99.261139,
    icao: "MMCB"
  },
  CVM: {
    iata: "CVM",
    name: "Ciudad Victoria Airport",
    city: "Ciudad Victoria",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 23.713889,
    longitude: -98.965278,
    icao: "MMCV"
  },
  CVN: {
    iata: "CVN",
    name: "Clovis Municipal Airport",
    city: "Clovis",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 34.427222,
    longitude: -103.078889,
    icao: "KCVN"
  },
  CVO: {
    iata: "CVO",
    name: "Corvallis Municipal Airport",
    city: "Corvallis",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 44.501186,
    longitude: -123.2857,
    icao: "KCVO"
  },
  CVQ: {
    iata: "CVQ",
    name: "Carnarvon Airport",
    city: "Carnarvon",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -24.883429,
    longitude: 113.663584,
    icao: "YCAR"
  },
  CVS: {
    iata: "CVS",
    name: "Cannon Air Force Base",
    city: "Clovis",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 34.383889,
    longitude: -103.316667,
    icao: "KCVS"
  },
  CVT: {
    iata: "CVT",
    name: "Coventry Airport",
    city: "Coventry",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 52.369167,
    longitude: -1.478611,
    icao: "EGBE"
  },
  CVU: {
    iata: "CVU",
    name: "Corvo Island (Azores) Airport",
    city: "Corvo Island (Azores)",
    countryId: "PT",
    timeZoneRegionName: "Atlantic/Azores",
    latitude: 39.7,
    longitude: -31.1,
    icao: "LPCR"
  },
  CWA: {
    iata: "CWA",
    name: "Central Wisconsin Airport",
    city: "Wausau",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 44.784209,
    longitude: -89.672437,
    icao: "KCWA"
  },
  CWB: {
    iata: "CWB",
    name: "Afonso Pena International Airport",
    city: "Curitiba",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -25.535763,
    longitude: -49.173298,
    icao: "SBCT"
  },
  CWC: {
    iata: "CWC",
    name: "Chernivtsi International Airport",
    city: "Chernivtsi",
    countryId: "UA",
    timeZoneRegionName: "Europe/Kiev",
    latitude: 48.266973,
    longitude: 25.970101,
    icao: "UKLN"
  },
  CWF: {
    iata: "CWF",
    name: "Chennault International Airport",
    city: "Lake Charles",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.220827,
    longitude: -93.153193,
    icao: "KCWF"
  },
  CWI: {
    iata: "CWI",
    name: "Clinton Airport",
    city: "Clinton",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.829444,
    longitude: -90.331944,
    icao: "KCWI"
  },
  CWJ: {
    iata: "CWJ",
    name: "Cangyuan Washan Airport",
    city: "Cangyuan",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 23.274856,
    longitude: 99.371301,
    icao: ""
  },
  CWL: {
    iata: "CWL",
    name: "Cardiff Airport",
    city: "Cardiff",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.398768,
    longitude: -3.339075,
    icao: "EGFF"
  },
  CWT: {
    iata: "CWT",
    name: "Cowra Airport",
    city: "Cowra",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -33.855,
    longitude: 148.646667,
    icao: "YCWR"
  },
  CWW: {
    iata: "CWW",
    name: "Corowa Airport",
    city: "Corowa",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -35.966667,
    longitude: 146.35,
    icao: "YCOR"
  },
  CXB: {
    iata: "CXB",
    name: "Coxs Bazar Airport",
    city: "Coxs Bazar",
    countryId: "BD",
    timeZoneRegionName: "Asia/Dhaka",
    latitude: 21.45,
    longitude: 91.966667,
    icao: "VGCB"
  },
  CXH: {
    iata: "CXH",
    name: "Vancouver Harbour Sea Plane Base",
    city: "Vancouver",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 49.290827,
    longitude: -123.117966,
    icao: "CYHC"
  },
  CXI: {
    iata: "CXI",
    name: "Christmas Island Airport",
    city: "Christmas Island",
    countryId: "KI",
    timeZoneRegionName: "Pacific/Kiritimati",
    latitude: 1.966667,
    longitude: -157.45,
    icao: "PLCH"
  },
  CXJ: {
    iata: "CXJ",
    name: "Hugo Cantergiani Regional Airport",
    city: "Caxias do Sul",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -29.195077,
    longitude: -51.187466,
    icao: "SBCX"
  },
  CXL: {
    iata: "CXL",
    name: "Calexico International Airport",
    city: "Calexico",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 32.666667,
    longitude: -115.516667,
    icao: "KCXL"
  },
  CXN: {
    iata: "CXN",
    name: "Candala Airport",
    city: "Candala",
    countryId: "SO",
    timeZoneRegionName: "Africa/Mogadishu",
    latitude: 11.5,
    longitude: 49.916667,
    icao: "HCMC"
  },
  CXO: {
    iata: "CXO",
    name: "Lone Star Executive Airport",
    city: "Conroe",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.352968,
    longitude: -95.416957,
    icao: "KCXO"
  },
  CXP: {
    iata: "CXP",
    name: "Tunggul Wulung Airport",
    city: "Cilacap",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: -7.733333,
    longitude: 109,
    icao: "WIIL"
  },
  CXR: {
    iata: "CXR",
    name: "Cam Ranh International Airport",
    city: "Nha Trang",
    countryId: "VN",
    timeZoneRegionName: "Asia/Ho_Chi_Minh",
    latitude: 12.006816,
    longitude: 109.21695,
    icao: "VVCR"
  },
  CXT: {
    iata: "CXT",
    name: "Charters Towers Airport",
    city: "Charters Towers",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -20.046667,
    longitude: 146.269167,
    icao: "YCHT"
  },
  CXY: {
    iata: "CXY",
    name: "Cat Cays Airport",
    city: "Cat Cays",
    countryId: "BS",
    timeZoneRegionName: "America/Nassau",
    latitude: 25.416667,
    longitude: -77.816667,
    icao: "MYCC"
  },
  CYA: {
    iata: "CYA",
    name: "Antoine-Simon Airport",
    city: "Les Cayes",
    countryId: "HT",
    timeZoneRegionName: "America/Port-au-Prince",
    latitude: 18.269722,
    longitude: -73.788333,
    icao: "MTCA"
  },
  CYB: {
    iata: "CYB",
    name: "Charles Kirkconnel International Airport",
    city: "Cayman Brac Island",
    countryId: "KY",
    timeZoneRegionName: "America/Cayman",
    latitude: 19.690192,
    longitude: -79.879407,
    icao: "MWCB"
  },
  CYC: {
    iata: "CYC",
    name: "Caye Chapel Airport",
    city: "Caye Chapel",
    countryId: "BZ",
    timeZoneRegionName: "America/Belize",
    latitude: 17.688098,
    longitude: -88.044552,
    icao: ""
  },
  CYD: {
    iata: "CYD",
    name: "San Ignacio Town Airstrip",
    city: "San Ignacio",
    countryId: "BZ",
    timeZoneRegionName: "America/Belize",
    latitude: 17.104312,
    longitude: -89.104344,
    icao: ""
  },
  CYF: {
    iata: "CYF",
    name: "Chefornak Sea Plane Base",
    city: "Chefornak",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 60.216667,
    longitude: -164.2,
    icao: "PACK"
  },
  CYG: {
    iata: "CYG",
    name: "Corryong Airport",
    city: "Corryong",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -36.25,
    longitude: 147.9,
    icao: "YCRG"
  },
  CYI: {
    iata: "CYI",
    name: "Chiayi Airport",
    city: "Chiayi",
    countryId: "TW",
    timeZoneRegionName: "Asia/Taipei",
    latitude: 23.454241,
    longitude: 120.398265,
    icao: "RCKU"
  },
  CYO: {
    iata: "CYO",
    name: "Cayo Largo Del Sur Airport",
    city: "Cayo Largo Del Sur",
    countryId: "CU",
    timeZoneRegionName: "America/Havana",
    latitude: 21.616667,
    longitude: -81.516667,
    icao: "MUCL"
  },
  CYP: {
    iata: "CYP",
    name: "Calbayog Airport",
    city: "Calbayog",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 12.075833,
    longitude: 124.543056,
    icao: "RPVC"
  },
  CYR: {
    iata: "CYR",
    name: "Laguna de los Patos International Airport",
    city: "Colonia del Sacramento",
    countryId: "UY",
    timeZoneRegionName: "America/Montevideo",
    latitude: -34.455325,
    longitude: -57.767768,
    icao: "SUCA"
  },
  CYS: {
    iata: "CYS",
    name: "Cheyenne Regional Airport",
    city: "Cheyenne",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 41.155833,
    longitude: -104.816667,
    icao: "KCYS"
  },
  CYT: {
    iata: "CYT",
    name: "Yakataga Intermediate Airport",
    city: "Yakataga",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 60.08,
    longitude: -142.494444,
    icao: "PACY"
  },
  CYW: {
    iata: "CYW",
    name: "Celaya",
    city: "Celaya",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 20.55,
    longitude: -100.9,
    icao: "MMCY"
  },
  CYX: {
    iata: "CYX",
    name: "Chersky Airport",
    city: "Cherskiy",
    countryId: "RU",
    timeZoneRegionName: "Asia/Magadan",
    latitude: 68.75,
    longitude: 161.35,
    icao: "UESS"
  },
  CYZ: {
    iata: "CYZ",
    name: "Cauayan Airport",
    city: "Cauayan",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 16.93,
    longitude: 121.755833,
    icao: "RPUY"
  },
  CZE: {
    iata: "CZE",
    name: "Coro Airport",
    city: "Coro",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 11.415833,
    longitude: -69.681944,
    icao: "SVCR"
  },
  CZF: {
    iata: "CZF",
    name: "Cape Romanzof Airport",
    city: "Cape Romanzof",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 61.781111,
    longitude: -166.036389,
    icao: "PACZ"
  },
  CZH: {
    iata: "CZH",
    name: "Corozal Airport",
    city: "Corozal",
    countryId: "BZ",
    timeZoneRegionName: "America/Belize",
    latitude: 18.382333,
    longitude: -88.410674,
    icao: ""
  },
  CZK: {
    iata: "CZK",
    name: "Cascade Locks State Airport",
    city: "Cascade Locks",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 45.676873,
    longitude: -121.879011,
    icao: "KCZK"
  },
  CZL: {
    iata: "CZL",
    name: "Ain El Bey Airport",
    city: "Constantine",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 36.286477,
    longitude: 6.618425,
    icao: "DABC"
  },
  CZM: {
    iata: "CZM",
    name: "Cozumel Airport",
    city: "Cozumel",
    countryId: "MX",
    timeZoneRegionName: "America/Cancun",
    latitude: 20.5112,
    longitude: -86.930462,
    icao: "MMCZ"
  },
  CZN: {
    iata: "CZN",
    name: "Chisana Airport",
    city: "Chisana",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 62.070833,
    longitude: -142.05,
    icao: ""
  },
  CZR: {
    iata: "CZR",
    name: "Chara Airport",
    city: "Chara",
    countryId: "RU",
    timeZoneRegionName: "Asia/Chita",
    latitude: 56.9128,
    longitude: 118.2711,
    icao: ""
  },
  CZS: {
    iata: "CZS",
    name: "Campo Internacional Airport",
    city: "Cruzeiro Do Sul",
    countryId: "BR",
    timeZoneRegionName: "America/Rio_Branco",
    latitude: -7.583333,
    longitude: -72.783333,
    icao: "SBCZ"
  },
  CZT: {
    iata: "CZT",
    name: "Carrizo Springs Airport",
    city: "Carrizo Springs",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 28.516667,
    longitude: -99.866667,
    icao: "KCZT"
  },
  CZU: {
    iata: "CZU",
    name: "Corozal Airport",
    city: "Corozal",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 9.3375,
    longitude: -75.282778,
    icao: "SKCZ"
  },
  CZX: {
    iata: "CZX",
    name: "Changzhou Airport",
    city: "Changzhou",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 31.914116,
    longitude: 119.779762,
    icao: "ZSCG"
  },
  DAA: {
    iata: "DAA",
    name: "Davison Army Air Field",
    city: "Fort Belvoir",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 38.715,
    longitude: -77.181,
    icao: "KDAA"
  },
  DAB: {
    iata: "DAB",
    name: "Daytona Beach International Airport",
    city: "Daytona Beach",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 29.185192,
    longitude: -81.060829,
    icao: "KDAB"
  },
  DAC: {
    iata: "DAC",
    name: "Hazrat Shahjalal International Airport",
    city: "Dhaka",
    countryId: "BD",
    timeZoneRegionName: "Asia/Dhaka",
    latitude: 23.848649,
    longitude: 90.405874,
    icao: "VGHS"
  },
  DAD: {
    iata: "DAD",
    name: "Da Nang International Airport",
    city: "Da Nang",
    countryId: "VN",
    timeZoneRegionName: "Asia/Ho_Chi_Minh",
    latitude: 16.053339,
    longitude: 108.202753,
    icao: "VVDN"
  },
  DAG: {
    iata: "DAG",
    name: "Barstow-Daggett Airport",
    city: "Daggett",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 34.853699,
    longitude: -116.787003,
    icao: "KDAG"
  },
  DAK: {
    iata: "DAK",
    name: "Dakhla Oasis Airport",
    city: "Dakhla Oasis",
    countryId: "EG",
    timeZoneRegionName: "Africa/Cairo",
    latitude: 25.414722,
    longitude: 28.999167,
    icao: "HEDK"
  },
  DAL: {
    iata: "DAL",
    name: "Dallas Love Field",
    city: "Dallas",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.843909,
    longitude: -96.850002,
    icao: "KDAL"
  },
  DAM: {
    iata: "DAM",
    name: "Damascus International Airport",
    city: "Damascus",
    countryId: "SY",
    timeZoneRegionName: "Asia/Damascus",
    latitude: 33.411171,
    longitude: 36.512488,
    icao: "OSDI"
  },
  DAN: {
    iata: "DAN",
    name: "Danville Regional Airport",
    city: "Danville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 36.572899,
    longitude: -79.336098,
    icao: "KDAN"
  },
  DAP: {
    iata: "DAP",
    name: "Darchula Airport",
    city: "Darchula",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 29.666667,
    longitude: 80.5,
    icao: "VNDL"
  },
  DAR: {
    iata: "DAR",
    name: "Julius Nyerere International Airport",
    city: "Dar Es Salaam",
    countryId: "TZ",
    timeZoneRegionName: "Africa/Dar_es_Salaam",
    latitude: -6.873533,
    longitude: 39.20211,
    icao: "HTDA"
  },
  DAT: {
    iata: "DAT",
    name: "Datong Airport",
    city: "Datong",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 40.05554,
    longitude: 113.481362,
    icao: "ZBDT"
  },
  DAU: {
    iata: "DAU",
    name: "Daru Airport",
    city: "Daru",
    countryId: "PG",
    timeZoneRegionName: "Pacific/Port_Moresby",
    latitude: -9.08351,
    longitude: 143.206062,
    icao: "AYDU"
  },
  DAV: {
    iata: "DAV",
    name: "Enrique Malek Airport",
    city: "David",
    countryId: "PA",
    timeZoneRegionName: "America/Panama",
    latitude: 8.383333,
    longitude: -82.433333,
    icao: "MPDA"
  },
  DAX: {
    iata: "DAX",
    name: "Dazhou Heshi Airport",
    city: "Dazhou",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 31.131687,
    longitude: 107.427556,
    icao: "ZUDX"
  },
  DAY: {
    iata: "DAY",
    name: "James M. Cox Dayton International Airport",
    city: "Dayton",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.898007,
    longitude: -84.220767,
    icao: "KDAY"
  },
  DAZ: {
    iata: "DAZ",
    name: "Darwaz Airport",
    city: "Darwaz",
    countryId: "AF",
    timeZoneRegionName: "Asia/Kabul",
    latitude: 38.466667,
    longitude: 70.883333,
    icao: "OADZ"
  },
  DBA: {
    iata: "DBA",
    name: "Dalbandin Airport",
    city: "Dalbandin",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 28.874617,
    longitude: 64.403,
    icao: "OPDB"
  },
  DBB: {
    iata: "DBB",
    name: "Al Alamain International Airport",
    city: "Dabaa",
    countryId: "EG",
    timeZoneRegionName: "Africa/Cairo",
    latitude: 30.924444,
    longitude: 28.461389,
    icao: "HEAL"
  },
  DBC: {
    iata: "DBC",
    name: "Baicheng Chang'an Airport",
    city: "Baicheng",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 45.505011,
    longitude: 123.018851,
    icao: ""
  },
  DBM: {
    iata: "DBM",
    name: "Debra Marcos Airport",
    city: "Debra Marcos",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 10.319444,
    longitude: 37.743056,
    icao: "HADM"
  },
  DBN: {
    iata: "DBN",
    name: "Dublin Municipal Airport",
    city: "Dublin",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 32.561944,
    longitude: -82.986111,
    icao: "KDBN"
  },
  DBO: {
    iata: "DBO",
    name: "Dubbo City Regional Airport",
    city: "Dubbo",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -32.216702,
    longitude: 148.574997,
    icao: "YSDU"
  },
  DBQ: {
    iata: "DBQ",
    name: "Dubuque Municipal Airport",
    city: "Dubuque",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 42.41,
    longitude: -90.710833,
    icao: "KDBQ"
  },
  DBR: {
    iata: "DBR",
    name: "Darbhanga Airport",
    city: "Darbhanga",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 26.1933,
    longitude: 85.9114,
    icao: "VEDH"
  },
  DBT: {
    iata: "DBT",
    name: "Debra Tabor Airport",
    city: "Debra Tabor",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 11.968056,
    longitude: 38.025278,
    icao: "HADT"
  },
  DBV: {
    iata: "DBV",
    name: "Dubrovnik Airport",
    city: "Dubrovnik",
    countryId: "HR",
    timeZoneRegionName: "Europe/Zagreb",
    latitude: 42.560718,
    longitude: 18.260617,
    icao: "LDDU"
  },
  DBY: {
    iata: "DBY",
    name: "Dalby Airport",
    city: "Dalby",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -27.15,
    longitude: 151.266667,
    icao: "YDAY"
  },
  DCA: {
    iata: "DCA",
    name: "Ronald Reagan National Airport",
    city: "Washington",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 38.853434,
    longitude: -77.043457,
    icao: "KDCA"
  },
  DCF: {
    iata: "DCF",
    name: "Canefield Airport",
    city: "Dominica",
    countryId: "DM",
    timeZoneRegionName: "America/Dominica",
    latitude: 15.339047,
    longitude: -61.391779,
    icao: "TDCF"
  },
  DCI: {
    iata: "DCI",
    name: "Decimomannu Air Base",
    city: "Decimomannu",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 39.353408,
    longitude: 8.973867,
    icao: "LIED"
  },
  DCM: {
    iata: "DCM",
    name: "Mazamet Airport",
    city: "Castres",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 43.555833,
    longitude: 2.284167,
    icao: "LFCK"
  },
  DCN: {
    iata: "DCN",
    name: "RAAF Base Curtin",
    city: "Curtin",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -17.580511,
    longitude: 123.828597,
    icao: "YCIN"
  },
  DCR: {
    iata: "DCR",
    name: "Decatur Hi-Way Airport",
    city: "Decatur",
    countryId: "US",
    timeZoneRegionName: "America/Indiana/Indianapolis",
    latitude: 40.833333,
    longitude: -84.933333,
    icao: "KDCR"
  },
  DCT: {
    iata: "DCT",
    name: "Duncan Town Airport",
    city: "Duncan Town",
    countryId: "BS",
    timeZoneRegionName: "America/Nassau",
    latitude: 22.25,
    longitude: -75.75,
    icao: "MYRD"
  },
  DCU: {
    iata: "DCU",
    name: "Pyor Airport",
    city: "Decatur",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 34.6,
    longitude: -86.983333,
    icao: "KDCU"
  },
  DCY: {
    iata: "DCY",
    name: "Daocheng Yading Airport",
    city: "Daocheng",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 29.323056,
    longitude: 100.053333,
    icao: "ZUDC"
  },
  DDC: {
    iata: "DDC",
    name: "Dodge City Regional Airport",
    city: "Dodge City",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 37.761667,
    longitude: -99.965,
    icao: "KDDC"
  },
  DDD: {
    iata: "DDD",
    name: "Dhaalu Atoll Airport",
    city: "Kudahuvadhoo",
    countryId: "MV",
    timeZoneRegionName: "Indian/Maldives",
    latitude: 2.666093,
    longitude: 72.886139,
    icao: ""
  },
  DDG: {
    iata: "DDG",
    name: "Langtou Airport",
    city: "Dandong",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 40.024701,
    longitude: 124.286009,
    icao: "ZYDD"
  },
  DDI: {
    iata: "DDI",
    name: "Daydream Island Airport",
    city: "Daydream Island",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -20.266667,
    longitude: 148.816667,
    icao: "YDDI"
  },
  DDN: {
    iata: "DDN",
    name: "Delta Downs Airport",
    city: "Delta Downs",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -16.916667,
    longitude: 141.3,
    icao: "YDLT"
  },
  DDR: {
    iata: "DDR",
    name: "Xigaze Dingri Airport",
    city: "Xigaze/Rikaze",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 28.605,
    longitude: 86.796944,
    icao: ""
  },
  DEA: {
    iata: "DEA",
    name: "Dera Ghazi Khan Airport",
    city: "Dera Ghazi Khan",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 29.961086,
    longitude: 70.48841,
    icao: "OPDG"
  },
  DEB: {
    iata: "DEB",
    name: "Debrecen Airport",
    city: "Debrecen",
    countryId: "HU",
    timeZoneRegionName: "Europe/Budapest",
    latitude: 47.488086,
    longitude: 21.610472,
    icao: "LHDC"
  },
  DEC: {
    iata: "DEC",
    name: "Decatur Airport",
    city: "Decatur",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 39.834251,
    longitude: -88.876529,
    icao: "KDEC"
  },
  DED: {
    iata: "DED",
    name: "Dehra Dun Airport",
    city: "Dehra Dun",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 30.316667,
    longitude: 78.033333,
    icao: "VIDN"
  },
  DEE: {
    iata: "DEE",
    name: "Mendeleyevo Airport",
    city: "Kunashir Island",
    countryId: "RU",
    timeZoneRegionName: "Asia/Ust-Nera",
    latitude: 43.958401,
    longitude: 145.682999,
    icao: "UHSM"
  },
  DEF: {
    iata: "DEF",
    name: "Dezful Airport",
    city: "Dezful",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 32.438827,
    longitude: 48.384683,
    icao: "OIAD"
  },
  DEH: {
    iata: "DEH",
    name: "Decorah Municipal Airport",
    city: "Decorah",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 43.3,
    longitude: -91.8,
    icao: "KDEH"
  },
  DEI: {
    iata: "DEI",
    name: "Denis Island Airport",
    city: "Denis Island",
    countryId: "SC",
    timeZoneRegionName: "Indian/Mahe",
    latitude: -3.8,
    longitude: 55.666667,
    icao: "FSSD"
  },
  DEL: {
    iata: "DEL",
    name: "Indira Gandhi International Airport",
    city: "Delhi",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 28.556162,
    longitude: 77.099958,
    icao: "VIDP"
  },
  DEM: {
    iata: "DEM",
    name: "Dembidollo Airport",
    city: "Dembidollo",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 8.549306,
    longitude: 34.860451,
    icao: "HADD"
  },
  DEN: {
    iata: "DEN",
    name: "Denver International Airport",
    city: "Denver",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 39.851382,
    longitude: -104.673098,
    icao: "KDEN"
  },
  DES: {
    iata: "DES",
    name: "Desroches Airport",
    city: "Desroches",
    countryId: "SC",
    timeZoneRegionName: "Indian/Mahe",
    latitude: -5.683333,
    longitude: 53.683333,
    icao: "FSDR"
  },
  DET: {
    iata: "DET",
    name: "Coleman A. Young Municipal Airport",
    city: "Detroit",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.409322,
    longitude: -83.005101,
    icao: "KDET"
  },
  DEX: {
    iata: "DEX",
    name: "Yahukimo Nop Goliath Airport",
    city: "Yahukimo",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jayapura",
    latitude: -4.8557,
    longitude: 139.482,
    icao: "WAVD"
  },
  DEZ: {
    iata: "DEZ",
    name: "Al Jafrah Airport",
    city: "Deirezzor",
    countryId: "SY",
    timeZoneRegionName: "Asia/Damascus",
    latitude: 35.287551,
    longitude: 40.186807,
    icao: "OSDZ"
  },
  DFI: {
    iata: "DFI",
    name: "Defiance Memorial Airport",
    city: "Defiance",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.283333,
    longitude: -84.366667,
    icao: "KDFI"
  },
  DFW: {
    iata: "DFW",
    name: "Dallas/Fort Worth International Airport",
    city: "Dallas",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.897462,
    longitude: -97.036128,
    icao: "KDFW"
  },
  DGA: {
    iata: "DGA",
    name: "Dangriga Airport",
    city: "Dangriga",
    countryId: "BZ",
    timeZoneRegionName: "America/Belize",
    latitude: 16.982026,
    longitude: -88.228832,
    icao: ""
  },
  DGE: {
    iata: "DGE",
    name: "Mudgee Airport",
    city: "Mudgee",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -32.563914,
    longitude: 149.615125,
    icao: "YMDG"
  },
  DGF: {
    iata: "DGF",
    name: "Douglas Lake Airport",
    city: "Douglas Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 50.166667,
    longitude: -120.183333,
    icao: "CAL3"
  },
  DGH: {
    iata: "DGH",
    name: "Deoghar International Airport",
    city: "Deoghar",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 24.446842,
    longitude: 86.704955,
    icao: ""
  },
  DGL: {
    iata: "DGL",
    name: "Douglas Municipal Airport",
    city: "Douglas",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 31.35,
    longitude: -109.566667,
    icao: "KDGL"
  },
  DGN: {
    iata: "DGN",
    name: "Naval Air Field",
    city: "Dahlgren",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 38.2,
    longitude: -88.683333,
    icao: "KNDY"
  },
  DGO: {
    iata: "DGO",
    name: "Guadalupe Victoria Airport",
    city: "Durango",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 24.125,
    longitude: -104.525,
    icao: "MMDO"
  },
  DGR: {
    iata: "DGR",
    name: "Dargaville Aerodrome",
    city: "Dargaville",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -35.939455,
    longitude: 173.893383,
    icao: "NZDA"
  },
  DGT: {
    iata: "DGT",
    name: "Dumaguete Airport",
    city: "Dumaguete",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 9.332543,
    longitude: 123.296011,
    icao: "RPVD"
  },
  DGU: {
    iata: "DGU",
    name: "Dedougou Airport",
    city: "Dedougou",
    countryId: "BF",
    timeZoneRegionName: "Africa/Ouagadougou",
    latitude: 12.466667,
    longitude: -3.483333,
    icao: "DFOD"
  },
  DGW: {
    iata: "DGW",
    name: "Converse County Airport",
    city: "Douglas",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 42.75,
    longitude: -105.4,
    icao: "KDGW"
  },
  DHA: {
    iata: "DHA",
    name: "King Abdulaziz Air Base",
    city: "Dhahran",
    countryId: "SA",
    timeZoneRegionName: "Asia/Riyadh",
    latitude: 26.267071,
    longitude: 50.15114,
    icao: "OEDR"
  },
  DHD: {
    iata: "DHD",
    name: "Durham Downs Airport",
    city: "Durham Downs",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -26.1,
    longitude: 149.083333,
    icao: "YDRH"
  },
  DHF: {
    iata: "DHF",
    name: "Al Dhafra Air Base",
    city: "Abu Dhabi",
    countryId: "AE",
    timeZoneRegionName: "Asia/Dubai",
    latitude: 24.250185,
    longitude: 54.549905,
    icao: "OMAM"
  },
  DHG: {
    iata: "DHG",
    name: "Dalnegorsk Airport",
    city: "Dalnegorsk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Vladivostok",
    latitude: 44.558056,
    longitude: 135.490833,
    icao: ""
  },
  DHI: {
    iata: "DHI",
    name: "Dhangarhi Airport",
    city: "Dhangarhi",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 28.7533,
    longitude: 80.581902,
    icao: "VNDH"
  },
  DHM: {
    iata: "DHM",
    name: "Gaggal Airport",
    city: "Dharamsala",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 32.165481,
    longitude: 76.260688,
    icao: "VIGG"
  },
  DHN: {
    iata: "DHN",
    name: "Dothan Regional Airport",
    city: "Dothan",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 31.317943,
    longitude: -85.450241,
    icao: "KDHN"
  },
  DHR: {
    iata: "DHR",
    name: "De Kooy Airport",
    city: "Den Helder",
    countryId: "NL",
    timeZoneRegionName: "Europe/Amsterdam",
    latitude: 52.95,
    longitude: 4.75,
    icao: "EHKD"
  },
  DHT: {
    iata: "DHT",
    name: "Dalhart Airport",
    city: "Dalhart",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.066667,
    longitude: -102.516667,
    icao: "KDHT"
  },
  DHX: {
    iata: "DHX",
    name: "Dhoho International Airport",
    city: "Kediri",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: -7.7606,
    longitude: 111.9506,
    icao: ""
  },
  DIA: {
    iata: "DIA",
    name: "Doha International Airport",
    city: "Doha",
    countryId: "QA",
    timeZoneRegionName: "Asia/Qatar",
    latitude: 25.261058,
    longitude: 51.565094,
    icao: "OTDB"
  },
  DIB: {
    iata: "DIB",
    name: "Dibrugarh Airport",
    city: "Dibrugarh",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 27.483222,
    longitude: 95.016474,
    icao: "VEMN"
  },
  DIE: {
    iata: "DIE",
    name: "Antsiranana/Arrachart Airport",
    city: "Antsiranana",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -12.346111,
    longitude: 49.2925,
    icao: "FMNA"
  },
  DIG: {
    iata: "DIG",
    name: "Diqing Shangri-La Airport",
    city: "Diqing",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 27.795839,
    longitude: 99.680584,
    icao: "ZPDQ"
  },
  DIJ: {
    iata: "DIJ",
    name: "Longvic Airport",
    city: "Dijon",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 47.270833,
    longitude: 5.088889,
    icao: "LFSD"
  },
  DIK: {
    iata: "DIK",
    name: "Dickinson Regional Airport",
    city: "Dickinson",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 46.801471,
    longitude: -102.793204,
    icao: "KDIK"
  },
  DIL: {
    iata: "DIL",
    name: "Comoro Airport",
    city: "Dili",
    countryId: "TL",
    timeZoneRegionName: "Asia/Dili",
    latitude: -8.549616,
    longitude: 125.525003,
    icao: "WPDL"
  },
  DIM: {
    iata: "DIM",
    name: "Dimbokro Airport",
    city: "Dimbokro",
    countryId: "CI",
    timeZoneRegionName: "Africa/Abidjan",
    latitude: 6.75,
    longitude: -4.766667,
    icao: "DIDK"
  },
  DIN: {
    iata: "DIN",
    name: "Dien Bien Phu Airport",
    city: "Dien Bien Phu",
    countryId: "VN",
    timeZoneRegionName: "Asia/Ho_Chi_Minh",
    latitude: 21.383333,
    longitude: 103,
    icao: ""
  },
  DIQ: {
    iata: "DIQ",
    name: "Divinopolis Airport",
    city: "Divinopolis",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -20.174218,
    longitude: -44.872915,
    icao: "SNDV"
  },
  DIR: {
    iata: "DIR",
    name: "Aba Tenna D Yilma Airport",
    city: "Dire Dawa",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 9.61338,
    longitude: 41.857994,
    icao: "HADR"
  },
  DIS: {
    iata: "DIS",
    name: "Ngot Nzoungou Airport",
    city: "Dolisie",
    countryId: "CG",
    timeZoneRegionName: "Africa/Brazzaville",
    latitude: -4.210988,
    longitude: 12.666908,
    icao: "FCPL"
  },
  DIU: {
    iata: "DIU",
    name: "Diu Airport",
    city: "Diu",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 20.716667,
    longitude: 70.916667,
    icao: "VADU"
  },
  DIY: {
    iata: "DIY",
    name: "Diyarbakir Airport",
    city: "Diyarbakir",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 37.910803,
    longitude: 40.197356,
    icao: "LTCC"
  },
  DJB: {
    iata: "DJB",
    name: "Sultan Thaha Airport",
    city: "Jambi",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: -1.631628,
    longitude: 103.638826,
    icao: "WIPA"
  },
  DJE: {
    iata: "DJE",
    name: "Zarsis Airport",
    city: "Djerba",
    countryId: "TN",
    timeZoneRegionName: "Africa/Tunis",
    latitude: 33.87118,
    longitude: 10.775145,
    icao: "DTTJ"
  },
  DJG: {
    iata: "DJG",
    name: "Tiska Airport",
    city: "Djanet",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 24.293056,
    longitude: 9.451944,
    icao: "DAAJ"
  },
  DJJ: {
    iata: "DJJ",
    name: "Sentani Airport",
    city: "Jayapura",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jayapura",
    latitude: -2.569887,
    longitude: 140.51299,
    icao: "WAJJ"
  },
  DJM: {
    iata: "DJM",
    name: "Djambala Airport",
    city: "Djambala",
    countryId: "CG",
    timeZoneRegionName: "Africa/Brazzaville",
    latitude: -2.533333,
    longitude: 14.75,
    icao: "FCBD"
  },
  DJN: {
    iata: "DJN",
    name: "Delta Junction Airport",
    city: "Delta Junction",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 64.049829,
    longitude: -145.725642,
    icao: "PABI"
  },
  DJO: {
    iata: "DJO",
    name: "Daloa Airport",
    city: "Daloa",
    countryId: "CI",
    timeZoneRegionName: "Africa/Abidjan",
    latitude: 6.866944,
    longitude: -6.466667,
    icao: "DIDL"
  },
  DKA: {
    iata: "DKA",
    name: "Katsina Airport",
    city: "Katsina",
    countryId: "NG",
    timeZoneRegionName: "Africa/Lagos",
    latitude: 13.003712,
    longitude: 7.660803,
    icao: "DNKT"
  },
  DKI: {
    iata: "DKI",
    name: "Dunk Island Airport",
    city: "Dunk Island",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -17.941667,
    longitude: 146.136667,
    icao: "YDKI"
  },
  DKK: {
    iata: "DKK",
    name: "Dunkirk Airport",
    city: "Dunkirk",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.483333,
    longitude: -79.333333,
    icao: "KDKK"
  },
  DKR: {
    iata: "DKR",
    name: "Leopold Sedar Senghor International Airport",
    city: "Dakar",
    countryId: "SN",
    timeZoneRegionName: "Africa/Dakar",
    latitude: 14.744975,
    longitude: -17.490194,
    icao: "GOOY"
  },
  DKS: {
    iata: "DKS",
    name: "Dikson Airport",
    city: "Dikson",
    countryId: "RU",
    timeZoneRegionName: "Asia/Krasnoyarsk",
    latitude: 73.515727,
    longitude: 80.38338,
    icao: "UODD"
  },
  DKV: {
    iata: "DKV",
    name: "Docker River Airport",
    city: "Docker River",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -24.866667,
    longitude: 129.083333,
    icao: "YDVR"
  },
  DLA: {
    iata: "DLA",
    name: "Douala Airport",
    city: "Douala",
    countryId: "CM",
    timeZoneRegionName: "Africa/Douala",
    latitude: 4.01346,
    longitude: 9.717018,
    icao: "FKKD"
  },
  DLC: {
    iata: "DLC",
    name: "Dalian Zhoushuizi International Airport",
    city: "Dalian",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 38.96102,
    longitude: 121.539991,
    icao: "ZYTL"
  },
  DLD: {
    iata: "DLD",
    name: "Dagali Airport",
    city: "Geilo",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 60.466667,
    longitude: 8.483333,
    icao: "ENDI"
  },
  DLE: {
    iata: "DLE",
    name: "Dole-Jura Airport",
    city: "Dole",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 47.038254,
    longitude: 5.428719,
    icao: "LFGJ"
  },
  DLF: {
    iata: "DLF",
    name: "Laughlin Air Force Base",
    city: "Del Rio",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 29.359235,
    longitude: -100.778668,
    icao: "KDLF"
  },
  DLG: {
    iata: "DLG",
    name: "Dillingham Airport",
    city: "Dillingham",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 59.04264,
    longitude: -158.511113,
    icao: "PADL"
  },
  DLH: {
    iata: "DLH",
    name: "Duluth International Airport",
    city: "Duluth",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 46.838975,
    longitude: -92.180192,
    icao: "KDLH"
  },
  DLI: {
    iata: "DLI",
    name: "Lien Khuong Airport",
    city: "Dalat",
    countryId: "VN",
    timeZoneRegionName: "Asia/Ho_Chi_Minh",
    latitude: 11.749689,
    longitude: 108.376033,
    icao: "VVDL"
  },
  DLL: {
    iata: "DLL",
    name: "Dillon Airport",
    city: "Dillon",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 34.416667,
    longitude: -79.366667,
    icao: "KDLC"
  },
  DLM: {
    iata: "DLM",
    name: "Dalaman Airport",
    city: "Dalaman",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 36.717336,
    longitude: 28.787155,
    icao: "LTBS"
  },
  DLN: {
    iata: "DLN",
    name: "Dillon Airport",
    city: "Dillon",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 45.255402,
    longitude: -112.553001,
    icao: "KDLN"
  },
  DLS: {
    iata: "DLS",
    name: "The Dalles Airport",
    city: "The Dalles",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 45.6,
    longitude: -121.166667,
    icao: "KDLS"
  },
  DLU: {
    iata: "DLU",
    name: "Dali Airport",
    city: "Dali City",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 25.65135,
    longitude: 100.323158,
    icao: "ZPDL"
  },
  DLV: {
    iata: "DLV",
    name: "Delissaville Airport",
    city: "Delissaville",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -12.566667,
    longitude: 130.633333,
    icao: "YDLV"
  },
  DLY: {
    iata: "DLY",
    name: "Dillons Bay Airport",
    city: "Dillons Bay",
    countryId: "VU",
    timeZoneRegionName: "Pacific/Efate",
    latitude: -18.7,
    longitude: 169.15,
    icao: "NVVD"
  },
  DLZ: {
    iata: "DLZ",
    name: "Gurvan Saikhan Airport",
    city: "Dalanzadgad",
    countryId: "MN",
    timeZoneRegionName: "Asia/Ulaanbaatar",
    latitude: 43.606001,
    longitude: 104.370329,
    icao: "ZMDZ"
  },
  DMA: {
    iata: "DMA",
    name: "Davis Monthan Air Force Base",
    city: "Tucson",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 32.166667,
    longitude: -110.883333,
    icao: "KDMA"
  },
  DMB: {
    iata: "DMB",
    name: "Jambyl Airport",
    city: "Taraz",
    countryId: "KZ",
    timeZoneRegionName: "Asia/Almaty",
    latitude: 42.855372,
    longitude: 71.304595,
    icao: "UADD"
  },
  DMD: {
    iata: "DMD",
    name: "Doomadgee Airport",
    city: "Doomadgee",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -17.939202,
    longitude: 138.821596,
    icao: "YDMG"
  },
  DME: {
    iata: "DME",
    name: "Moscow Domodedovo Airport",
    city: "Moscow",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 55.414566,
    longitude: 37.899494,
    icao: "UUDD"
  },
  DMK: {
    iata: "DMK",
    name: "Don Mueang International Airport",
    city: "Bangkok",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 13.9125,
    longitude: 100.606667,
    icao: "VTBD"
  },
  DMM: {
    iata: "DMM",
    name: "King Fahd International Airport",
    city: "Dammam",
    countryId: "SA",
    timeZoneRegionName: "Asia/Riyadh",
    latitude: 26.471111,
    longitude: 49.797778,
    icao: "OEDF"
  },
  DMN: {
    iata: "DMN",
    name: "Deming Airport",
    city: "Deming",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 32.266667,
    longitude: -107.75,
    icao: "KDMN"
  },
  DMO: {
    iata: "DMO",
    name: "Sedalia Airport",
    city: "Sedalia",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 38.704167,
    longitude: -93.180556,
    icao: "KDMO"
  },
  DMT: {
    iata: "DMT",
    name: "Diamantino Airport",
    city: "Diamantino",
    countryId: "BR",
    timeZoneRegionName: "America/Campo_Grande",
    latitude: -14.5,
    longitude: -56.5,
    icao: "SWDM"
  },
  DMU: {
    iata: "DMU",
    name: "Dimapur Airport",
    city: "Dimapur",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 25.879816,
    longitude: 93.772866,
    icao: "VEMR"
  },
  DNA: {
    iata: "DNA",
    name: "Kadena Air Force Base",
    city: "Okinawa",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 26.35,
    longitude: 127.766667,
    icao: "RODN"
  },
  DND: {
    iata: "DND",
    name: "Dundee Airport",
    city: "Dundee",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 56.454091,
    longitude: -3.014531,
    icao: "EGPN"
  },
  DNH: {
    iata: "DNH",
    name: "Dunhuang Airport",
    city: "Dunhuang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 40.2,
    longitude: 94.683333,
    icao: "ZLDH"
  },
  DNK: {
    iata: "DNK",
    name: "Dnepropetrovsk International Airport",
    city: "Dnepropetrovsk",
    countryId: "UA",
    timeZoneRegionName: "Europe/Kiev",
    latitude: 48.368741,
    longitude: 35.094461,
    icao: "UKDD"
  },
  DNL: {
    iata: "DNL",
    name: "Daniel Field",
    city: "Augusta",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 33.468096,
    longitude: -82.039197,
    icao: "KDNL"
  },
  DNN: {
    iata: "DNN",
    name: "Dalton Municipal Airport",
    city: "Dalton",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 34.766667,
    longitude: -84.966667,
    icao: "KDNN"
  },
  DNO: {
    iata: "DNO",
    name: "Dianopolis Airport",
    city: "Dianopolis",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -11.616667,
    longitude: -46.85,
    icao: "SWDN"
  },
  DNP: {
    iata: "DNP",
    name: "Dang Airport",
    city: "Dang",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 28.116667,
    longitude: 82.316667,
    icao: "VNDG"
  },
  DNQ: {
    iata: "DNQ",
    name: "Deniliquin Airport",
    city: "Deniliquin",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -35.56,
    longitude: 144.951667,
    icao: "YDLQ"
  },
  DNR: {
    iata: "DNR",
    name: "Pleurtuit Airport",
    city: "Dinard",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 48.587778,
    longitude: -2.083611,
    icao: "LFRD"
  },
  DNS: {
    iata: "DNS",
    name: "Denison Municipal Airport",
    city: "Denison",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 42.016667,
    longitude: -95.35,
    icao: "KDNS"
  },
  DNV: {
    iata: "DNV",
    name: "Vermilion Regional Airport",
    city: "Danville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 40.197222,
    longitude: -87.596944,
    icao: "KDNV"
  },
  DNX: {
    iata: "DNX",
    name: "Galegu Airport",
    city: "Dinder",
    countryId: "SD",
    timeZoneRegionName: "Africa/Khartoum",
    latitude: 14.1,
    longitude: 33.066667,
    icao: "HSGG"
  },
  DNZ: {
    iata: "DNZ",
    name: "Cardak Airport",
    city: "Denizli",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 37.787222,
    longitude: 29.703333,
    icao: "LTAY"
  },
  DOB: {
    iata: "DOB",
    name: "Rar Gwamar Airport",
    city: "Dobo",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jayapura",
    latitude: -5.77376,
    longitude: 134.209426,
    icao: "WAPD"
  },
  DOD: {
    iata: "DOD",
    name: "Dodoma Airport",
    city: "Dodoma",
    countryId: "TZ",
    timeZoneRegionName: "Africa/Dar_es_Salaam",
    latitude: -6.17044,
    longitude: 35.752695,
    icao: "HTDO"
  },
  DOG: {
    iata: "DOG",
    name: "Dongola Airport",
    city: "Dongola",
    countryId: "SD",
    timeZoneRegionName: "Africa/Khartoum",
    latitude: 19.151995,
    longitude: 30.431921,
    icao: "HSDN"
  },
  DOH: {
    iata: "DOH",
    name: "Hamad International Airport",
    city: "Doha",
    countryId: "QA",
    timeZoneRegionName: "Asia/Qatar",
    latitude: 25.260988,
    longitude: 51.613594,
    icao: "OTHH"
  },
  DOL: {
    iata: "DOL",
    name: "Saint Gatien Airport",
    city: "Deauville",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 49.362778,
    longitude: 0.164167,
    icao: "LFRG"
  },
  DOM: {
    iata: "DOM",
    name: "Melville Hall Airport",
    city: "Dominica",
    countryId: "DM",
    timeZoneRegionName: "America/Dominica",
    latitude: 15.545895,
    longitude: -61.300542,
    icao: "TDPD"
  },
  DOP: {
    iata: "DOP",
    name: "Dolpa Airport",
    city: "Dolpa",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 28.985086,
    longitude: 82.818987,
    icao: "VNDP"
  },
  DOR: {
    iata: "DOR",
    name: "Dori Airport",
    city: "Dori",
    countryId: "BF",
    timeZoneRegionName: "Africa/Ouagadougou",
    latitude: 14.033333,
    longitude: -0.033333,
    icao: "DFEE"
  },
  DOU: {
    iata: "DOU",
    name: "Dourados Airport",
    city: "Dourados",
    countryId: "BR",
    timeZoneRegionName: "America/Campo_Grande",
    latitude: -22.202778,
    longitude: -54.925556,
    icao: "SSDO"
  },
  DOV: {
    iata: "DOV",
    name: "Dover Air Force Base",
    city: "Dover-Cheswold",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.128611,
    longitude: -75.464167,
    icao: "KDOV"
  },
  DOY: {
    iata: "DOY",
    name: "Dongying Shengli Airport",
    city: "Dongying",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 37.518333,
    longitude: 118.78778,
    icao: "ZSDY"
  },
  DPA: {
    iata: "DPA",
    name: "DuPage Airport",
    city: "Chicago",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.906831,
    longitude: -88.253748,
    icao: "KDPA"
  },
  DPB: {
    iata: "DPB",
    name: "Pampa Guanaco Airport",
    city: "Cameron",
    countryId: "CL",
    timeZoneRegionName: "America/Argentina/Salta",
    latitude: -54.049967,
    longitude: -68.808852,
    icao: "SCBI"
  },
  DPE: {
    iata: "DPE",
    name: "St Aubin Airport",
    city: "Dieppe",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 49.884806,
    longitude: 1.080755,
    icao: "LFAB"
  },
  DPG: {
    iata: "DPG",
    name: "Michael Army Air Field",
    city: "Dugway",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 40.233333,
    longitude: -112.75,
    icao: "KDPG"
  },
  DPL: {
    iata: "DPL",
    name: "Dipolog Airport",
    city: "Dipolog",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 8.599978,
    longitude: 123.344179,
    icao: "RPMG"
  },
  DPO: {
    iata: "DPO",
    name: "Devonport Airport",
    city: "Devonport",
    countryId: "AU",
    timeZoneRegionName: "Australia/Hobart",
    latitude: -41.172056,
    longitude: 146.427535,
    icao: "YDPO"
  },
  DPP: {
    iata: "DPP",
    name: "Datia Airport",
    city: "Madhya Pradesh",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 25.657701,
    longitude: 78.509111,
    icao: ""
  },
  DPS: {
    iata: "DPS",
    name: "Ngurah Rai International Airport",
    city: "Denpasar",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -8.748056,
    longitude: 115.1675,
    icao: "WADD"
  },
  DPT: {
    iata: "DPT",
    name: "Deputatsky Airport",
    city: "Deputatskiy",
    countryId: "RU",
    timeZoneRegionName: "Asia/Vladivostok",
    latitude: 69.392553,
    longitude: 139.895377,
    icao: ""
  },
  DQA: {
    iata: "DQA",
    name: "Daqing Sartu Airport",
    city: "Daqing",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 46.746985,
    longitude: 125.133991,
    icao: ""
  },
  DQM: {
    iata: "DQM",
    name: "Duqm International Airport",
    city: "Duqm",
    countryId: "OM",
    timeZoneRegionName: "Asia/Muscat",
    latitude: 19.502323,
    longitude: 57.6383,
    icao: "OODQ"
  },
  DRB: {
    iata: "DRB",
    name: "Derby Airport",
    city: "Derby",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -17.370488,
    longitude: 123.662804,
    icao: "YDBY"
  },
  DRG: {
    iata: "DRG",
    name: "Deering Airport",
    city: "Deering",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 66.071194,
    longitude: -162.759886,
    icao: "PADE"
  },
  DRI: {
    iata: "DRI",
    name: "Beauregard Parish Airport",
    city: "De Ridder",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.85,
    longitude: -93.283333,
    icao: "KDRI"
  },
  DRK: {
    iata: "DRK",
    name: "Drake Bay Airport",
    city: "Drake Bay",
    countryId: "CR",
    timeZoneRegionName: "America/Costa_Rica",
    latitude: 8.719173,
    longitude: -83.642523,
    icao: "MRDK"
  },
  DRN: {
    iata: "DRN",
    name: "Dirranbandi Airport",
    city: "Dirranbandi",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -28.586667,
    longitude: 148.215278,
    icao: "YDBI"
  },
  DRO: {
    iata: "DRO",
    name: "Durango-La Plata County Airport",
    city: "Durango",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 37.15995,
    longitude: -107.751075,
    icao: "KDRO"
  },
  DRP: {
    iata: "DRP",
    name: "Legazpi Bicol International Airport",
    city: "Daraga",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 13.111389,
    longitude: 123.681111,
    icao: "RPLK"
  },
  DRR: {
    iata: "DRR",
    name: "Durrie Airport",
    city: "Durrie",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -25.616667,
    longitude: 140.216667,
    icao: "YDRI"
  },
  DRS: {
    iata: "DRS",
    name: "Dresden International Airport",
    city: "Dresden",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 51.124333,
    longitude: 13.766082,
    icao: "EDDC"
  },
  DRT: {
    iata: "DRT",
    name: "Del Rio International Airport",
    city: "Del Rio",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 29.374215,
    longitude: -100.927142,
    icao: "KDRT"
  },
  DRU: {
    iata: "DRU",
    name: "Drummond Airport",
    city: "Drummond",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 46.666667,
    longitude: -113.15,
    icao: "KDRU"
  },
  DRV: {
    iata: "DRV",
    name: "Dharavandhoo AIrport",
    city: "Dharavandhoo Island",
    countryId: "MV",
    timeZoneRegionName: "Indian/Maldives",
    latitude: 5.156111,
    longitude: 73.13028,
    icao: "VRMD"
  },
  DRW: {
    iata: "DRW",
    name: "Darwin International Airport",
    city: "Darwin",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -12.407805,
    longitude: 130.877521,
    icao: "YPDN"
  },
  DSA: {
    iata: "DSA",
    name: "Doncaster Sheffield Airport",
    city: "Finningley",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 53.475278,
    longitude: -1.004167,
    icao: "EGCN"
  },
  DSC: {
    iata: "DSC",
    name: "Dschang Airport",
    city: "Dschang",
    countryId: "CM",
    timeZoneRegionName: "Africa/Douala",
    latitude: 5.833333,
    longitude: 10.091667,
    icao: "FKKS"
  },
  DSD: {
    iata: "DSD",
    name: "La Desirade Airport",
    city: "La Desirade",
    countryId: "GP",
    timeZoneRegionName: "America/Guadeloupe",
    latitude: 16.333333,
    longitude: -61.016667,
    icao: "TFFA"
  },
  DSE: {
    iata: "DSE",
    name: "Kombolcha Airport",
    city: "Dessie",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 11.111318,
    longitude: 39.725592,
    icao: "HADC"
  },
  DSI: {
    iata: "DSI",
    name: "Destin-Fort Walton Beach Airport",
    city: "Destin",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.399591,
    longitude: -86.470882,
    icao: "KDTS"
  },
  DSK: {
    iata: "DSK",
    name: "Dera Ismail Khan Airport",
    city: "Dera Ismail Khan",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 31.916667,
    longitude: 70.9,
    icao: "OPDI"
  },
  DSM: {
    iata: "DSM",
    name: "Des Moines International Airport",
    city: "Des Moines",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.532434,
    longitude: -93.648087,
    icao: "KDSM"
  },
  DSN: {
    iata: "DSN",
    name: "Ordos Ejin Horo Airport",
    city: "Dongsheng",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 39.496721,
    longitude: 109.860527,
    icao: "ZBDS"
  },
  DSS: {
    iata: "DSS",
    name: "Blaise Diagne International Airport",
    city: "Dakar",
    countryId: "SN",
    timeZoneRegionName: "Africa/Dakar",
    latitude: 14.671111,
    longitude: -17.066944,
    icao: "GOBD"
  },
  DSV: {
    iata: "DSV",
    name: "Dansville Airport",
    city: "Dansville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.566667,
    longitude: -77.7,
    icao: "KDSV"
  },
  DSX: {
    iata: "DSX",
    name: "Dongsha Island Airport",
    city: "Dongsha Island",
    countryId: "TW",
    timeZoneRegionName: "Asia/Taipei",
    latitude: 20.70452,
    longitude: 116.727367,
    icao: "RCLM"
  },
  DSY: {
    iata: "DSY",
    name: "Dara Sakor International Airport",
    city: "Krong Khemara Phoumin",
    countryId: "KH",
    timeZoneRegionName: "Asia/Phnom_Penh",
    latitude: 10.910995,
    longitude: 103.22659,
    icao: ""
  },
  DTA: {
    iata: "DTA",
    name: "Delta Airport",
    city: "Delta",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 39.383333,
    longitude: -112.5,
    icao: "KDTA"
  },
  DTB: {
    iata: "DTB",
    name: "Silangit Airport",
    city: "Siborong-Borong",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: 2.259722,
    longitude: 98.995278,
    icao: "WIMN"
  },
  DTE: {
    iata: "DTE",
    name: "Camarines Norte Airport",
    city: "Daet",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 14.133333,
    longitude: 122.983333,
    icao: "RPUD"
  },
  DTI: {
    iata: "DTI",
    name: "Diamantina Airport",
    city: "Diamantina",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -18.230804,
    longitude: -43.647848,
    icao: "SNDT"
  },
  DTL: {
    iata: "DTL",
    name: "Wething Field",
    city: "Detroit Lakes",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 46.826389,
    longitude: -95.886111,
    icao: "KDTL"
  },
  DTM: {
    iata: "DTM",
    name: "Dortmund Airport",
    city: "Dortmund",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 51.514826,
    longitude: 7.613139,
    icao: "EDLW"
  },
  DTN: {
    iata: "DTN",
    name: "Shreveport Downtown Airport",
    city: "Shreveport",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.539722,
    longitude: -93.744444,
    icao: "KDTN"
  },
  DTU: {
    iata: "DTU",
    name: "Wudalianchi Dedu Airport",
    city: "Wudalianchi",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 48.440556,
    longitude: 126.127778,
    icao: ""
  },
  DTW: {
    iata: "DTW",
    name: "Detroit Metropolitan Wayne County Airport",
    city: "Detroit",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.207808,
    longitude: -83.356048,
    icao: "KDTW"
  },
  DTZ: {
    iata: "DTZ",
    countryId: "DE",
    city: "Dortmund",
    icao: "",
    name: "Dortmund Railway Station",
    latitude: 51.5175,
    longitude: 7.4589,
    timeZoneRegionName: "Europe/Paris"
  },
  DUA: {
    iata: "DUA",
    name: "Durant Regional Airport - Eaker Field",
    city: "Durant",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 33.94231,
    longitude: -96.394494,
    icao: "KDUA"
  },
  DUB: {
    iata: "DUB",
    name: "Dublin Airport",
    city: "Dublin",
    countryId: "IE",
    timeZoneRegionName: "Europe/Dublin",
    latitude: 53.42728,
    longitude: -6.24357,
    icao: "EIDW"
  },
  DUC: {
    iata: "DUC",
    name: "Halliburton Field",
    city: "Duncan",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 34.472222,
    longitude: -97.959722,
    icao: "KDUC"
  },
  DUD: {
    iata: "DUD",
    name: "Dunedin International Airport",
    city: "Dunedin",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -45.923871,
    longitude: 170.199052,
    icao: "NZDN"
  },
  DUE: {
    iata: "DUE",
    name: "Dundo Airport",
    city: "Dundo",
    countryId: "AO",
    timeZoneRegionName: "Africa/Luanda",
    latitude: -7.400878,
    longitude: 20.818421,
    icao: ""
  },
  DUG: {
    iata: "DUG",
    name: "Bisbee-Douglas International Airport",
    city: "Douglas",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 31.468611,
    longitude: -109.603611,
    icao: "KDUG"
  },
  DUJ: {
    iata: "DUJ",
    name: "Jefferson County Airport",
    city: "Dubois",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.178333,
    longitude: -78.898889,
    icao: "KDUJ"
  },
  DUM: {
    iata: "DUM",
    name: "Pinang Kampai Airport",
    city: "Dumai",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: 1.61172,
    longitude: 101.43373,
    icao: "WIBD"
  },
  DUQ: {
    iata: "DUQ",
    name: "Duncan/Quam Airport",
    city: "Duncan/Quam",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 48.783333,
    longitude: -123.7,
    icao: "CAM3"
  },
  DUR: {
    iata: "DUR",
    name: "King Shaka International Airport",
    city: "Durban",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -29.614444,
    longitude: 31.116389,
    icao: "FALE"
  },
  DUS: {
    iata: "DUS",
    name: "Dusseldorf International Airport",
    city: "Dusseldorf",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 51.278327,
    longitude: 6.76558,
    icao: "EDDL"
  },
  DUT: {
    iata: "DUT",
    name: "Unalaska Airport",
    city: "Dutch Harbor",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 53.894458,
    longitude: -166.542238,
    icao: "PADU"
  },
  DVL: {
    iata: "DVL",
    name: "Devils Lake Airport",
    city: "Devils Lake",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 48.113056,
    longitude: -98.9075,
    icao: "KDVL"
  },
  DVN: {
    iata: "DVN",
    name: "Davenport Airport",
    city: "Davenport",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.610556,
    longitude: -90.588611,
    icao: "KDVN"
  },
  DVO: {
    iata: "DVO",
    name: "Francisco Bangoy Intl Airport",
    city: "Davao",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 7.130696,
    longitude: 125.644698,
    icao: "RPMD"
  },
  DVP: {
    iata: "DVP",
    name: "Davenport Downs Airport",
    city: "Davenport Downs",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -24.133333,
    longitude: 141.116667,
    icao: "YDPD"
  },
  DVT: {
    iata: "DVT",
    name: "Phoenix Deer Valley Airport",
    city: "Phoenix",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 33.688333,
    longitude: -112.0825,
    icao: "KDVT"
  },
  DWA: {
    iata: "DWA",
    name: "Dwamawa Airport",
    city: "Dwamawa",
    countryId: "MW",
    timeZoneRegionName: "Africa/Blantyre",
    latitude: -13,
    longitude: 34.133333,
    icao: "FWDW"
  },
  DWB: {
    iata: "DWB",
    name: "Soalala Airport",
    city: "Soalala",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -16.1,
    longitude: 45.366667,
    icao: "FMNO"
  },
  DWC: {
    iata: "DWC",
    name: "Dubai World Central - Al Maktoum International Airport",
    city: "Dubai",
    countryId: "AE",
    timeZoneRegionName: "Asia/Dubai",
    latitude: 24.892845,
    longitude: 55.162467,
    icao: "OMDW"
  },
  DWD: {
    iata: "DWD",
    name: "Dawadmi Airport",
    city: "Dawadmi",
    countryId: "SA",
    timeZoneRegionName: "Asia/Riyadh",
    latitude: 24.445546,
    longitude: 44.128702,
    icao: "OEDW"
  },
  DWH: {
    iata: "DWH",
    name: "David Wayne Hooks Memorial Airport",
    city: "Houston",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.060468,
    longitude: -95.550861,
    icao: "KDWH"
  },
  DXB: {
    iata: "DXB",
    name: "Dubai Airport",
    city: "Dubai",
    countryId: "AE",
    timeZoneRegionName: "Asia/Dubai",
    latitude: 25.248664,
    longitude: 55.352916,
    icao: "OMDB"
  },
  DXE: {
    iata: "DXE",
    name: "Bruce Campbell Field",
    city: "Madison",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.44107,
    longitude: -90.104127,
    icao: "KMBO"
  },
  DXJ: {
    iata: "DXJ",
    name: "Xiangxi Biancheng Airport",
    city: "Biancheng",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 28.495,
    longitude: 109.5194,
    icao: ""
  },
  DXR: {
    iata: "DXR",
    name: "Danbury Municipal Airport",
    city: "Danbury",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.371782,
    longitude: -73.48999,
    icao: "KDXR"
  },
  DYA: {
    iata: "DYA",
    name: "Dysart Airport",
    city: "Dysart",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -23.5,
    longitude: 148,
    icao: "YDYS"
  },
  DYG: {
    iata: "DYG",
    name: "Zhangjiajie Hehua Airport",
    city: "Dayong",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 29.10712,
    longitude: 110.445685,
    icao: "ZGDY"
  },
  DYL: {
    iata: "DYL",
    name: "Doylestown Airport",
    city: "Doylestown",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.316667,
    longitude: -75.133333,
    icao: "KDYL"
  },
  DYN: {
    iata: "DYN",
    name: "Danyang Railway Station",
    city: "Yunyang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 32.003333,
    longitude: 119.5875,
    icao: ""
  },
  DYR: {
    iata: "DYR",
    name: "Anadyr Airport",
    city: "Anadyr",
    countryId: "RU",
    timeZoneRegionName: "Asia/Anadyr",
    latitude: 64.733333,
    longitude: 177.75,
    icao: "UHMA"
  },
  DYS: {
    iata: "DYS",
    name: "Dyess Air Force Base",
    city: "Abilene",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.419703,
    longitude: -99.848551,
    icao: "KDYS"
  },
  DYU: {
    iata: "DYU",
    name: "Dushanbe Airport",
    city: "Dushanbe",
    countryId: "TJ",
    timeZoneRegionName: "Asia/Dushanbe",
    latitude: 38.54894,
    longitude: 68.817287,
    icao: "UTDD"
  },
  DZA: {
    iata: "DZA",
    name: "Dzaoudzi Airport",
    city: "Dzaoudzi",
    countryId: "YT",
    timeZoneRegionName: "Indian/Mayotte",
    latitude: -12.804901,
    longitude: 45.282099,
    icao: "FMCZ"
  },
  DZH: {
    iata: "DZH",
    name: "Dazhou Jinya Airport",
    city: "Dazhou",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 31.048611,
    longitude: 107.435556,
    icao: ""
  },
  DZN: {
    iata: "DZN",
    name: "Zhezhazgan Airport",
    city: "Zhezkazgan",
    countryId: "KZ",
    timeZoneRegionName: "Asia/Almaty",
    latitude: 47.7,
    longitude: 67.733333,
    icao: "UAKD"
  },
  DZO: {
    iata: "DZO",
    name: "Durazno Airport",
    city: "Durazno",
    countryId: "UY",
    timeZoneRegionName: "America/Montevideo",
    latitude: -33.416667,
    longitude: -56.516667,
    icao: "SUDU"
  },
  EAA: {
    iata: "EAA",
    name: "Eagle Airport",
    city: "Eagle",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 64.776667,
    longitude: -141.148611,
    icao: "PAEA"
  },
  EAB: {
    iata: "EAB",
    name: "Abbse Airport",
    city: "Abbse",
    countryId: "YE",
    timeZoneRegionName: "Asia/Aden",
    latitude: 14.583333,
    longitude: 43.5,
    icao: "OYAB"
  },
  EAE: {
    iata: "EAE",
    name: "Emae Airport",
    city: "Emae",
    countryId: "VU",
    timeZoneRegionName: "Pacific/Efate",
    latitude: -17.166667,
    longitude: 168.416667,
    icao: "NVSE"
  },
  EAM: {
    iata: "EAM",
    name: "Nejran Airport",
    city: "Nejran",
    countryId: "SA",
    timeZoneRegionName: "Asia/Riyadh",
    latitude: 17.613282,
    longitude: 44.414646,
    icao: "OENG"
  },
  EAN: {
    iata: "EAN",
    name: "Phifer Field",
    city: "Wheatland",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 42.05,
    longitude: -104.966667,
    icao: "KEAN"
  },
  EAP: {
    iata: "EAP",
    name: "EuroAirport Basel-Mulhouse-Freiburg",
    city: "Freiburg im Breisgau",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 47.599324,
    longitude: 7.532864,
    icao: "LFSB"
  },
  EAR: {
    iata: "EAR",
    name: "Kearney Regional Airport",
    city: "Kearney",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 40.728458,
    longitude: -99.008451,
    icao: "KEAR"
  },
  EAS: {
    iata: "EAS",
    name: "San Sebastian Airport",
    city: "San Sebastian",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 43.356401,
    longitude: -1.793538,
    icao: "LESO"
  },
  EAT: {
    iata: "EAT",
    name: "Pangborn Field",
    city: "Wenatchee",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 47.399722,
    longitude: -120.207778,
    icao: "KEAT"
  },
  EAU: {
    iata: "EAU",
    name: "Eau Claire Airport",
    city: "Eau Claire",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 44.864444,
    longitude: -91.487222,
    icao: "KEAU"
  },
  EBA: {
    iata: "EBA",
    name: "Marina Di Campo Airport",
    city: "Elba Island",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 42.763104,
    longitude: 10.240409,
    icao: "LIRJ"
  },
  EBB: {
    iata: "EBB",
    name: "Entebbe International Airport",
    city: "Entebbe",
    countryId: "UG",
    timeZoneRegionName: "Africa/Kampala",
    latitude: 0.045111,
    longitude: 32.443183,
    icao: "HUEN"
  },
  EBD: {
    iata: "EBD",
    name: "El Obeid Airport",
    city: "El Obeid",
    countryId: "SD",
    timeZoneRegionName: "Africa/Khartoum",
    latitude: 13.159722,
    longitude: 30.234167,
    icao: "HSOB"
  },
  EBG: {
    iata: "EBG",
    name: "El Bagre Airport",
    city: "El Bagre",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 7.596527,
    longitude: -74.808952,
    icao: "SKEB"
  },
  EBH: {
    iata: "EBH",
    name: "El Bayadh Airport",
    city: "El Bayadh",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 33.717803,
    longitude: 1.094105,
    icao: "DAOY"
  },
  EBJ: {
    iata: "EBJ",
    name: "Esbjerg Airport",
    city: "Esbjerg",
    countryId: "DK",
    timeZoneRegionName: "Europe/Copenhagen",
    latitude: 55.521431,
    longitude: 8.549062,
    icao: "EKEB"
  },
  EBL: {
    iata: "EBL",
    name: "Erbil International Airport",
    city: "Erbil",
    countryId: "IQ",
    timeZoneRegionName: "Asia/Baghdad",
    latitude: 36.2375,
    longitude: 43.963056,
    icao: "ORER"
  },
  EBM: {
    iata: "EBM",
    name: "El Borma Airport",
    city: "El Borma",
    countryId: "TN",
    timeZoneRegionName: "Africa/Tunis",
    latitude: 31.716667,
    longitude: 9.266667,
    icao: "DTTR"
  },
  EBS: {
    iata: "EBS",
    name: "Webster City Municipal Airport",
    city: "Webster City",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 42.466667,
    longitude: -93.816667,
    icao: "KEBS"
  },
  EBU: {
    iata: "EBU",
    name: "Boutheon Airport",
    city: "Saint Etienne",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 45.541389,
    longitude: 4.296944,
    icao: "LFMH"
  },
  EBW: {
    iata: "EBW",
    name: "Ebolowa Airport",
    city: "Ebolowa",
    countryId: "CM",
    timeZoneRegionName: "Africa/Douala",
    latitude: 2.916667,
    longitude: 11.166667,
    icao: "FKKW"
  },
  ECG: {
    iata: "ECG",
    name: "Elizabeth City Airport",
    city: "Elizabeth City",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 36.259167,
    longitude: -76.173056,
    icao: "KECG"
  },
  ECH: {
    iata: "ECH",
    name: "Echuca Airport",
    city: "Echuca",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -36.15,
    longitude: 144.75,
    icao: "YECH"
  },
  ECN: {
    iata: "ECN",
    name: "Ercan Airport",
    city: "Ercan",
    countryId: "CY",
    timeZoneRegionName: "Asia/Famagusta",
    latitude: 35.158118,
    longitude: 33.50307,
    icao: "LCEN"
  },
  ECP: {
    iata: "ECP",
    name: "Northwest Florida Beaches International Airport",
    city: "Panama City",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.355819,
    longitude: -85.798847,
    icao: "KECP"
  },
  ECS: {
    iata: "ECS",
    name: "Mondell Field",
    city: "Newcastle",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 43.885385,
    longitude: -104.318011,
    icao: "KECS"
  },
  EDC: {
    iata: "EDC",
    name: "Austin Executive Airport",
    city: "Austin",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.3999,
    longitude: -97.5735,
    icao: "KEDC"
  },
  EDE: {
    iata: "EDE",
    name: "Northeastern Regional Airport",
    city: "Edenton",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 36.020711,
    longitude: -76.568691,
    icao: "KEDE"
  },
  EDF: {
    iata: "EDF",
    name: "Elmendorf Air Force Base",
    city: "Anchorage",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 61.250403,
    longitude: -149.802833,
    icao: "PAED"
  },
  EDG: {
    iata: "EDG",
    name: "Weide Army Air Field",
    city: "Edgewood Arsenal",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.465667,
    longitude: -76.360917,
    icao: "KEDG"
  },
  EDI: {
    iata: "EDI",
    name: "Edinburgh Airport",
    city: "Edinburgh",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 55.948143,
    longitude: -3.364177,
    icao: "EGPH"
  },
  EDK: {
    iata: "EDK",
    name: "El Dorado Airport",
    city: "El Dorado",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 37.816667,
    longitude: -96.866667,
    icao: "KEQA"
  },
  EDL: {
    iata: "EDL",
    name: "Eldoret Airport",
    city: "Eldoret",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: 0.4054,
    longitude: 35.223599,
    icao: "HKED"
  },
  EDM: {
    iata: "EDM",
    name: "Les Ajoncs Airport",
    city: "La Roche",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 46.7,
    longitude: -1.383333,
    icao: "LFRI"
  },
  EDN: {
    iata: "EDN",
    name: "Yedinka Airport",
    city: "Yedinka",
    countryId: "RU",
    timeZoneRegionName: "Asia/Vladivostok",
    latitude: 47.18,
    longitude: 138.648333,
    icao: ""
  },
  EDO: {
    iata: "EDO",
    name: "Balikesir Koca Seyit Airport",
    city: "Edremit",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 39.549267,
    longitude: 27.011319,
    icao: "LTFD"
  },
  EDR: {
    iata: "EDR",
    name: "Pormpuraaw Edward River Airport",
    city: "Edward River",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -14.9,
    longitude: 141.616667,
    icao: ""
  },
  EDW: {
    iata: "EDW",
    name: "Edwards Air Force Base",
    city: "Edwards Air Force Base",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 34.908862,
    longitude: -117.881232,
    icao: "KEDW"
  },
  EEA: {
    iata: "EEA",
    name: "Reg do Planalto Serrano Airport",
    city: "Correia",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: 27.63416667,
    longitude: -50.35833333,
    icao: "SNCP"
  },
  EED: {
    iata: "EED",
    name: "Needles Airport",
    city: "Needles",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 34.85,
    longitude: -114.616667,
    icao: "KEED"
  },
  EEK: {
    iata: "EEK",
    name: "Eek Airport",
    city: "Eek",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 60.213694,
    longitude: -162.043889,
    icao: "PAEE"
  },
  EEN: {
    iata: "EEN",
    name: "Dillant-Hopkins Airport",
    city: "Keene",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.900833,
    longitude: -72.270833,
    icao: "KEEN"
  },
  EEP: {
    iata: "EEP",
    name: "Pamplona Railway Station",
    city: "Pamplona",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 58.418888,
    longitude: 24.472778,
    icao: ""
  },
  EFD: {
    iata: "EFD",
    name: "Ellington Field",
    city: "Houston",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 29.609583,
    longitude: -95.159708,
    icao: "KEFD"
  },
  EFK: {
    iata: "EFK",
    name: "Newport State Airport",
    city: "Newport",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 44.889444,
    longitude: -72.23,
    icao: "KEFK"
  },
  EFL: {
    iata: "EFL",
    name: "Kefallinia Airport",
    city: "Kefallinia",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 38.118056,
    longitude: 20.505556,
    icao: "LGKF"
  },
  EFW: {
    iata: "EFW",
    name: "Jefferson Municipal Airport",
    city: "Jefferson",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 42.016667,
    longitude: -94.383333,
    icao: "KEFW"
  },
  EGC: {
    iata: "EGC",
    name: "Roumanieres Airport",
    city: "Bergerac",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 44.85,
    longitude: 0.483333,
    icao: "LFBE"
  },
  EGE: {
    iata: "EGE",
    name: "Eagle County Airport",
    city: "Vail",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 39.639882,
    longitude: -106.913471,
    icao: "KEGE"
  },
  EGI: {
    iata: "EGI",
    name: "Duke Field",
    city: "Crestview",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.650388,
    longitude: -86.522905,
    icao: "KEGI"
  },
  EGL: {
    iata: "EGL",
    name: "Negele Airport",
    city: "Neghelli",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 5.283333,
    longitude: 39.716667,
    icao: "HANG"
  },
  EGM: {
    iata: "EGM",
    name: "Seghe Airport",
    city: "Sege",
    countryId: "SB",
    timeZoneRegionName: "Pacific/Guadalcanal",
    latitude: -8.577956,
    longitude: 157.875066,
    icao: "AGGS"
  },
  EGN: {
    iata: "EGN",
    name: "Geneina Airport",
    city: "Geneina",
    countryId: "SD",
    timeZoneRegionName: "Africa/Khartoum",
    latitude: 13.4875,
    longitude: 22.469444,
    icao: "HSGN"
  },
  EGO: {
    iata: "EGO",
    name: "Belgorod Airport",
    city: "Belgorod",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 50.644713,
    longitude: 36.582226,
    icao: "UUOB"
  },
  EGS: {
    iata: "EGS",
    name: "Egilsstadir Airport",
    city: "Egilsstadir",
    countryId: "IS",
    timeZoneRegionName: "Atlantic/Reykjavik",
    latitude: 65.277778,
    longitude: -14.402778,
    icao: "BIEG"
  },
  EGV: {
    iata: "EGV",
    name: "Eagle River Airport",
    city: "Eagle River",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 45.929167,
    longitude: -89.265833,
    icao: "KEGV"
  },
  EGX: {
    iata: "EGX",
    name: "Egegik Airport",
    city: "Egegik",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 58.207778,
    longitude: -157.370278,
    icao: "PAII"
  },
  EHL: {
    iata: "EHL",
    name: "El Bolson Airport",
    city: "El Bolson",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -42,
    longitude: -71.75,
    icao: "SAVB"
  },
  EHM: {
    iata: "EHM",
    name: "Cape Newenham Airport",
    city: "Cape Newenham",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 58.647222,
    longitude: -162.060556,
    icao: "PAEH"
  },
  EHU: {
    iata: "EHU",
    name: "Ezhou Huahu Airport",
    city: "Ezhou",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 30.3427,
    longitude: 115.0297,
    icao: ""
  },
  EIL: {
    iata: "EIL",
    name: "Eielson Air Force Base",
    city: "Fairbanks",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 64.667753,
    longitude: -147.103194,
    icao: "PAEI"
  },
  EIN: {
    iata: "EIN",
    name: "Eindhoven Airport",
    city: "Eindhoven",
    countryId: "NL",
    timeZoneRegionName: "Europe/Amsterdam",
    latitude: 51.457953,
    longitude: 5.391795,
    icao: "EHEH"
  },
  EIS: {
    iata: "EIS",
    name: "Terrance B. Lettsome International Airport",
    city: "Beef Island",
    countryId: "VG",
    timeZoneRegionName: "America/Tortola",
    latitude: 18.444401,
    longitude: -64.537146,
    icao: "TUPJ"
  },
  EJA: {
    iata: "EJA",
    name: "Variguies Airport",
    city: "Barrancabermeja",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 7.015833,
    longitude: -73.799167,
    icao: "SKEJ"
  },
  EJH: {
    iata: "EJH",
    name: "Wedjh Airport",
    city: "Wedjh",
    countryId: "SA",
    timeZoneRegionName: "Asia/Riyadh",
    latitude: 26.207716,
    longitude: 36.474813,
    icao: "OEWJ"
  },
  EKA: {
    iata: "EKA",
    name: "Murray Field",
    city: "Eureka",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 40.805,
    longitude: -124.115,
    icao: "KEKA"
  },
  EKB: {
    iata: "EKB",
    name: "Ekibastuz Airport",
    city: "Ekibastuz",
    countryId: "KZ",
    timeZoneRegionName: "Asia/Almaty",
    latitude: 51.595408,
    longitude: 75.212221,
    icao: "UASB"
  },
  EKI: {
    iata: "EKI",
    name: "Elkhart Municipal Airport",
    city: "Elkhart",
    countryId: "US",
    timeZoneRegionName: "America/Indiana/Indianapolis",
    latitude: 41.722222,
    longitude: -85.992222,
    icao: "KEKM"
  },
  EKN: {
    iata: "EKN",
    name: "Randolph County Airport",
    city: "Elkins",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 38.889444,
    longitude: -79.857778,
    icao: "KEKN"
  },
  EKO: {
    iata: "EKO",
    name: "Elko Airport",
    city: "Elko",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 40.823889,
    longitude: -115.789722,
    icao: "KEKO"
  },
  EKS: {
    iata: "EKS",
    name: "Shakhtyorsk Airport",
    city: "Shakhtyorsk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Sakhalin",
    latitude: 49.1896,
    longitude: 142.085469,
    icao: "UHSK"
  },
  EKT: {
    iata: "EKT",
    name: "Eskilstuna Airport",
    city: "Eskilstuna",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 59.351101,
    longitude: 16.708401,
    icao: "ESSU"
  },
  EKX: {
    iata: "EKX",
    name: "Elizabethtown Regional Airport - Addington Field",
    city: "Elizabethtown",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 37.686001,
    longitude: -85.925014,
    icao: "KEKX"
  },
  ELA: {
    iata: "ELA",
    name: "Eagle Lake Airport",
    city: "Eagle Lake",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 29.583333,
    longitude: -96.333333,
    icao: "KELA"
  },
  ELB: {
    iata: "ELB",
    name: "San Bernado Airport",
    city: "El Banco",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 9.048889,
    longitude: -73.974167,
    icao: "SKBC"
  },
  ELC: {
    iata: "ELC",
    name: "Elcho Island Airport",
    city: "Elcho Island",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -12.019817,
    longitude: 135.5698,
    icao: "YELD"
  },
  ELD: {
    iata: "ELD",
    name: "South Arkansas Regional Airport",
    city: "El Dorado",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 33.217963,
    longitude: -92.811188,
    icao: "KELD"
  },
  ELF: {
    iata: "ELF",
    name: "El Fasher Airport",
    city: "El Fasher",
    countryId: "SD",
    timeZoneRegionName: "Africa/Khartoum",
    latitude: 13.616667,
    longitude: 25.316667,
    icao: "HSFS"
  },
  ELG: {
    iata: "ELG",
    name: "El Golea Airport",
    city: "El Golea",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 30.5675,
    longitude: 2.864722,
    icao: "DAUE"
  },
  ELH: {
    iata: "ELH",
    name: "North Eleuthera International Airport",
    city: "North Eleuthera",
    countryId: "BS",
    timeZoneRegionName: "America/Nassau",
    latitude: 25.476917,
    longitude: -76.681926,
    icao: "MYEH"
  },
  ELI: {
    iata: "ELI",
    name: "Elim Airport",
    city: "Elim",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 64.613611,
    longitude: -162.270278,
    icao: "PFEL"
  },
  ELK: {
    iata: "ELK",
    name: "Elk City Regional Business Airport",
    city: "Elk City",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.432404,
    longitude: -99.394289,
    icao: "KELK"
  },
  ELM: {
    iata: "ELM",
    name: "Elmira Corning Regional Airport",
    city: "Elmira",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.163042,
    longitude: -76.89586,
    icao: "KELM"
  },
  ELN: {
    iata: "ELN",
    name: "Bowers Field",
    city: "Ellensburg",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 47.033774,
    longitude: -120.531969,
    icao: "KELN"
  },
  ELO: {
    iata: "ELO",
    name: "Eldorado Airport",
    city: "Eldorado",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -26.5,
    longitude: -54.733333,
    icao: "SATD"
  },
  ELP: {
    iata: "ELP",
    name: "El Paso International Airport",
    city: "El Paso",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 31.798949,
    longitude: -106.396003,
    icao: "KELP"
  },
  ELQ: {
    iata: "ELQ",
    name: "Prince Nayef bin Abdulaziz Regional Airport",
    city: "Gassim",
    countryId: "SA",
    timeZoneRegionName: "Asia/Riyadh",
    latitude: 26.305029,
    longitude: 43.768178,
    icao: "OEGS"
  },
  ELS: {
    iata: "ELS",
    name: "East London Airport",
    city: "East London",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -33.038438,
    longitude: 27.82892,
    icao: "FAEL"
  },
  ELT: {
    iata: "ELT",
    name: "Tour Sinai City Airport",
    city: "Tour Sinai City",
    countryId: "EG",
    timeZoneRegionName: "Africa/Cairo",
    latitude: 28.216667,
    longitude: 33.633333,
    icao: "HETR"
  },
  ELU: {
    iata: "ELU",
    name: "Guemar Airport",
    city: "El Oued",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 33.509497,
    longitude: 6.784614,
    icao: "DAUO"
  },
  ELY: {
    iata: "ELY",
    name: "Yelland Field",
    city: "Ely",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 39.301944,
    longitude: -114.841944,
    icao: "KELY"
  },
  ELZ: {
    iata: "ELZ",
    name: "Wellsville Municipal Airport",
    city: "Wellsville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.116667,
    longitude: -77.95,
    icao: "KELZ"
  },
  EMA: {
    iata: "EMA",
    name: "East Midlands Airport",
    city: "Leicestershire",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 52.825872,
    longitude: -1.330595,
    icao: "EGNX"
  },
  EMD: {
    iata: "EMD",
    name: "Emerald Airport",
    city: "Emerald",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -23.568609,
    longitude: 148.174393,
    icao: "YEML"
  },
  EME: {
    iata: "EME",
    name: "Emden Airport",
    city: "Emden",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 53.389291,
    longitude: 7.227536,
    icao: "EDWE"
  },
  EMG: {
    iata: "EMG",
    name: "Empangeni Airport",
    city: "Empangeni",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -28.75,
    longitude: 31.9,
    icao: "FAEM"
  },
  EMK: {
    iata: "EMK",
    name: "Emmonak Airport",
    city: "Emmonak",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 62.784856,
    longitude: -164.490537,
    icao: "PAEM"
  },
  EML: {
    iata: "EML",
    name: "Emmen Airport",
    city: "Emmen",
    countryId: "CH",
    timeZoneRegionName: "Europe/Zurich",
    latitude: 47.0925,
    longitude: 8.304722,
    icao: "LSME"
  },
  EMM: {
    iata: "EMM",
    name: "Kemmerer Airport",
    city: "Kemmerer",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 41.783333,
    longitude: -110.55,
    icao: "KEMM"
  },
  EMN: {
    iata: "EMN",
    name: "Nema Airport",
    city: "Nema",
    countryId: "MR",
    timeZoneRegionName: "Africa/Nouakchott",
    latitude: 16.6,
    longitude: -7.283333,
    icao: "GQNI"
  },
  EMP: {
    iata: "EMP",
    name: "Emporia Airport",
    city: "Emporia",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 38.3325,
    longitude: -96.190833,
    icao: "KEMP"
  },
  EMT: {
    iata: "EMT",
    name: "El Monte Airport",
    city: "El Monte",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 34.083333,
    longitude: -118.033333,
    icao: "KEMT"
  },
  EMX: {
    iata: "EMX",
    name: "El Maiten Airport",
    city: "El Maiten",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -42.033333,
    longitude: -71.15,
    icao: "SAVD"
  },
  ENA: {
    iata: "ENA",
    name: "Kenai Municipal Airport",
    city: "Kenai",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 60.565207,
    longitude: -151.246448,
    icao: "PAEN"
  },
  ENC: {
    iata: "ENC",
    name: "Essey Airport",
    city: "Nancy",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 48.691667,
    longitude: 6.231667,
    icao: "LFSN"
  },
  END: {
    iata: "END",
    name: "Vance Air Force Base",
    city: "Enid",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.340058,
    longitude: -97.914614,
    icao: "KEND"
  },
  ENE: {
    iata: "ENE",
    name: "H. Hasan Aroeboesman Airport",
    city: "Ende",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -8.848239,
    longitude: 121.664653,
    icao: "WATE"
  },
  ENF: {
    iata: "ENF",
    name: "Enontekio Airport",
    city: "Enontekio",
    countryId: "FI",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 68.360381,
    longitude: 23.421202,
    icao: "EFET"
  },
  ENH: {
    iata: "ENH",
    name: "Enshi Xujiaping Airport",
    city: "Enshi",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 30.321934,
    longitude: 109.482012,
    icao: "ZHES"
  },
  ENI: {
    iata: "ENI",
    name: "El Nido Airport",
    city: "El Nido",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 11.201944,
    longitude: 119.416944,
    icao: "RPEN"
  },
  ENK: {
    iata: "ENK",
    name: "Saint Angelo Airport",
    city: "Enniskillen",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 54.35,
    longitude: -7.633333,
    icao: "EGAB"
  },
  ENL: {
    iata: "ENL",
    name: "Centralia Municipal Airport",
    city: "Centralia",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 38.516667,
    longitude: -89.133333,
    icao: "KENL"
  },
  ENN: {
    iata: "ENN",
    name: "Nenana Municipal Airport",
    city: "Nenana",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 64.566667,
    longitude: -149.116667,
    icao: "PANN"
  },
  ENO: {
    iata: "ENO",
    name: "Teniente Amin Ayub Gonzalez Airport",
    city: "Encarnacion",
    countryId: "PY",
    timeZoneRegionName: "America/Asuncion",
    latitude: -27.221493,
    longitude: -55.834276,
    icao: "SGEN"
  },
  ENS: {
    iata: "ENS",
    name: "Twente Airport",
    city: "Enschede",
    countryId: "NL",
    timeZoneRegionName: "Europe/Amsterdam",
    latitude: 52.271667,
    longitude: 6.878333,
    icao: "EHTW"
  },
  ENT: {
    iata: "ENT",
    name: "Enewetak Island Airport",
    city: "Enewetak Island",
    countryId: "MH",
    timeZoneRegionName: "Pacific/Majuro",
    latitude: 11.5,
    longitude: 162.25,
    icao: "PKMA"
  },
  ENU: {
    iata: "ENU",
    name: "Akanu Ibiam International Airport",
    city: "Enugu",
    countryId: "NG",
    timeZoneRegionName: "Africa/Lagos",
    latitude: 6.474094,
    longitude: 7.562007,
    icao: "DNEN"
  },
  ENV: {
    iata: "ENV",
    name: "Wendover Airport",
    city: "Wendover",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 40.733333,
    longitude: -114.033333,
    icao: "KENV"
  },
  ENW: {
    iata: "ENW",
    name: "Kenosha Regional Airport",
    city: "Kenosha",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 42.595699,
    longitude: -87.927803,
    icao: "KENW"
  },
  ENY: {
    iata: "ENY",
    name: "Yan'an Nanniwan Airport",
    city: "Yan'an",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 36.479722,
    longitude: 109.463889,
    icao: "ZLYA"
  },
  EOH: {
    iata: "EOH",
    name: "Enrique Olaya Herrera Airport",
    city: "Medellin",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 6.218666,
    longitude: -75.586403,
    icao: "SKMD"
  },
  EOI: {
    iata: "EOI",
    name: "Eday Airport",
    city: "Eday",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 59.190596,
    longitude: -2.772223,
    icao: "EGED"
  },
  EOK: {
    iata: "EOK",
    name: "Keokuk Airport",
    city: "Keokuk",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 40.458333,
    longitude: -91.43,
    icao: "KEOK"
  },
  EOR: {
    iata: "EOR",
    name: "El Dorado Airporr",
    city: "El Dorado",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 6.733333,
    longitude: -61.883333,
    icao: "SVED"
  },
  EOS: {
    iata: "EOS",
    name: "Neosho Airport",
    city: "Neosho",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.866667,
    longitude: -94.366667,
    icao: "KEOS"
  },
  EOZ: {
    iata: "EOZ",
    name: "Elorza Airport",
    city: "Elorza",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 7.166667,
    longitude: -69.533333,
    icao: "SVEZ"
  },
  EPA: {
    iata: "EPA",
    name: "El Palomar Airport",
    city: "El Palomar",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -34.608333,
    longitude: -58.6125,
    icao: "SADP"
  },
  EPG: {
    iata: "EPG",
    name: "Browns Airport",
    city: "Weeping Water",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 40.866667,
    longitude: -96.133333,
    icao: "KEPG"
  },
  EPH: {
    iata: "EPH",
    name: "Ephrata Airport",
    city: "Ephrata",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 47.304167,
    longitude: -119.5125,
    icao: "KEPH"
  },
  EPL: {
    iata: "EPL",
    name: "Mirecourt Airport",
    city: "Epinal",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 48.325833,
    longitude: 6.069444,
    icao: "LFSG"
  },
  EPR: {
    iata: "EPR",
    name: "Esperance Airport",
    city: "Esperance",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -33.682479,
    longitude: 121.830389,
    icao: "YESP"
  },
  EPS: {
    iata: "EPS",
    name: "El Portillo Airport",
    city: "El Portillo/Samana",
    countryId: "DO",
    timeZoneRegionName: "America/Santo_Domingo",
    latitude: 19.25,
    longitude: -69.5,
    icao: "MDPO"
  },
  EPU: {
    iata: "EPU",
    name: "Parnu Airport",
    city: "Parnu",
    countryId: "EE",
    timeZoneRegionName: "Europe/Tallinn",
    latitude: 58.418889,
    longitude: 24.472778,
    icao: "EEPU"
  },
  EQS: {
    iata: "EQS",
    name: "Esquel Airport",
    city: "Esquel",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -42.909722,
    longitude: -71.1425,
    icao: "SAVE"
  },
  ERA: {
    iata: "ERA",
    name: "Erigavo Airport",
    city: "Erigavo",
    countryId: "SO",
    timeZoneRegionName: "Africa/Mogadishu",
    latitude: 10.616667,
    longitude: 47.4,
    icao: "HCMU"
  },
  ERB: {
    iata: "ERB",
    name: "Ernabella Airport",
    city: "Ernabella",
    countryId: "AU",
    timeZoneRegionName: "Australia/Adelaide",
    latitude: -26.283333,
    longitude: 132.116667,
    icao: "YERN"
  },
  ERC: {
    iata: "ERC",
    name: "Erzincan Airport",
    city: "Erzincan",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 39.711667,
    longitude: 39.516944,
    icao: "LTCD"
  },
  ERF: {
    iata: "ERF",
    name: "Erfurt Airport",
    city: "Erfurt",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 50.974914,
    longitude: 10.961163,
    icao: "EDDE"
  },
  ERG: {
    iata: "ERG",
    name: "Erbogachen Airport",
    city: "Erbogachen",
    countryId: "RU",
    timeZoneRegionName: "Asia/Irkutsk",
    latitude: 61.275,
    longitude: 108.03,
    icao: "UIKE"
  },
  ERH: {
    iata: "ERH",
    name: "Moulay Ali Cherif Airport",
    city: "Errachidia",
    countryId: "MA",
    timeZoneRegionName: "Africa/Casablanca",
    latitude: 31.946956,
    longitude: -4.400324,
    icao: "GMFK"
  },
  ERI: {
    iata: "ERI",
    name: "Erie International Airport",
    city: "Erie",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.083142,
    longitude: -80.18203,
    icao: "KERI"
  },
  ERL: {
    iata: "ERL",
    name: "Erenhot Saiwusu International Airport",
    city: "Eren Hot",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 43.426673,
    longitude: 112.09845,
    icao: ""
  },
  ERM: {
    iata: "ERM",
    name: "Comandante Kraemer Airport",
    city: "Erechim",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -27.641667,
    longitude: -52.275556,
    icao: "SSER"
  },
  ERN: {
    iata: "ERN",
    name: "Eirunepe Airport",
    city: "Eirunepe",
    countryId: "BR",
    timeZoneRegionName: "America/Eirunepe",
    latitude: -6.639462,
    longitude: -69.879657,
    icao: "SWEI"
  },
  ERQ: {
    iata: "ERQ",
    name: "Elrose Mine Airport",
    city: "Elrose Mine",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -20.976667,
    longitude: 141.0086,
    icao: "YESE"
  },
  ERR: {
    iata: "ERR",
    name: "Errol Airport",
    city: "Errol",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 44.783333,
    longitude: -71.133333,
    icao: "KERR"
  },
  ERS: {
    iata: "ERS",
    name: "Eros Airport",
    city: "Windhoek",
    countryId: "NA",
    timeZoneRegionName: "Africa/Windhoek",
    latitude: -22.616667,
    longitude: 17.083333,
    icao: "FYWE"
  },
  ERV: {
    iata: "ERV",
    name: "Kerrville Airport",
    city: "Kerrville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.05,
    longitude: -99.133333,
    icao: "KERV"
  },
  ERZ: {
    iata: "ERZ",
    name: "Erzurum Airport",
    city: "Erzurum",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 39.961346,
    longitude: 41.179378,
    icao: "LTCE"
  },
  ESB: {
    iata: "ESB",
    name: "Esenboga International Airport",
    city: "Ankara",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 40.114941,
    longitude: 32.993145,
    icao: "LTAC"
  },
  ESC: {
    iata: "ESC",
    name: "Delta County Airport",
    city: "Escanaba",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 45.720556,
    longitude: -87.086667,
    icao: "KESC"
  },
  ESD: {
    iata: "ESD",
    name: "Orcas Island Airport",
    city: "Eastsound",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 48.708333,
    longitude: -122.9125,
    icao: "KORS"
  },
  ESE: {
    iata: "ESE",
    name: "Ensenada Airport",
    city: "Ensenada",
    countryId: "MX",
    timeZoneRegionName: "America/Tijuana",
    latitude: 31.7953,
    longitude: -116.602997,
    icao: "MMES"
  },
  ESF: {
    iata: "ESF",
    name: "Esler Field",
    city: "Alexandria",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 31.395,
    longitude: -92.296944,
    icao: "KESF"
  },
  ESH: {
    iata: "ESH",
    name: "Shoreham Airport",
    city: "Shoreham By Sea",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 50.833333,
    longitude: -0.3,
    icao: "EGKA"
  },
  ESK: {
    iata: "ESK",
    name: "Eskisehir Airport",
    city: "Eskisehir",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 39.784138,
    longitude: 30.582111,
    icao: "LTBI"
  },
  ESL: {
    iata: "ESL",
    name: "Elista Airport",
    city: "Elista",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 46.370593,
    longitude: 44.332967,
    icao: "URWI"
  },
  ESM: {
    iata: "ESM",
    name: "Esmeraldas Airport",
    city: "Esmeraldas",
    countryId: "EC",
    timeZoneRegionName: "America/Guayaquil",
    latitude: 0.966667,
    longitude: -79.625,
    icao: "SEES"
  },
  ESN: {
    iata: "ESN",
    name: "Newnam Field",
    city: "Easton",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 38.802778,
    longitude: -76.067778,
    icao: "KESN"
  },
  ESR: {
    iata: "ESR",
    name: "El Salvador Airport",
    city: "El Salvador",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -26.315278,
    longitude: -69.765278,
    icao: "SCES"
  },
  ESS: {
    iata: "ESS",
    name: "Essen Airport",
    city: "Essen",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 51.403889,
    longitude: 6.941667,
    icao: "EDLE"
  },
  EST: {
    iata: "EST",
    name: "Estherville Municipal Airport",
    city: "Estherville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 43.4,
    longitude: -94.833333,
    icao: "KEST"
  },
  ESU: {
    iata: "ESU",
    name: "Essaouira Airport",
    city: "Essaouira",
    countryId: "MA",
    timeZoneRegionName: "Africa/Casablanca",
    latitude: 31.3975,
    longitude: -9.681667,
    icao: "GMMI"
  },
  ESW: {
    iata: "ESW",
    name: "Easton State Airport",
    city: "Easton",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 47.254211,
    longitude: -121.185989,
    icao: "KESW"
  },
  ETB: {
    iata: "ETB",
    name: "West Bend Airport",
    city: "West Bend",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 43.416667,
    longitude: -88.183333,
    icao: "KETB"
  },
  ETE: {
    iata: "ETE",
    name: "Genda Wuha Airport",
    city: "Genda Wuha",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 12.933333,
    longitude: 36.166667,
    icao: "HAMM"
  },
  ETH: {
    iata: "ETH",
    name: "Eilat Airport",
    city: "Elat",
    countryId: "IL",
    timeZoneRegionName: "Asia/Jerusalem",
    latitude: 29.55625,
    longitude: 34.957443,
    icao: "LLET"
  },
  ETL: {
    iata: "ETL",
    name: "Svetlaya Airport",
    city: "Svetlaya",
    countryId: "RU",
    timeZoneRegionName: "Asia/Vladivostok",
    latitude: 46.541111,
    longitude: 138.318333,
    icao: ""
  },
  ETM: {
    iata: "ETM",
    name: "Ramon Airport",
    city: "Eilat",
    countryId: "IL",
    timeZoneRegionName: "Asia/Jerusalem",
    latitude: 29.723694,
    longitude: 35.011417,
    icao: "LLER"
  },
  ETN: {
    iata: "ETN",
    name: "Eastland Municipal Airport",
    city: "Eastland",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.383333,
    longitude: -98.833333,
    icao: "KETN"
  },
  ETR: {
    iata: "ETR",
    name: "Coronel Artilleria Victor Larrea Airport",
    city: "Santa Rosa",
    countryId: "EC",
    timeZoneRegionName: "America/Guayaquil",
    latitude: -3.452222,
    longitude: -79.96167,
    icao: "SERO"
  },
  ETS: {
    iata: "ETS",
    name: "Enterprise Municipal Airport",
    city: "Enterprise",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 31.316667,
    longitude: -85.85,
    icao: "KEDN"
  },
  ETZ: {
    iata: "ETZ",
    name: "Metz-Nancy-Lorraine Airport",
    city: "Metz/Nancy",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 48.981653,
    longitude: 6.243003,
    icao: "LFJL"
  },
  EUA: {
    iata: "EUA",
    name: "Kaufana Airport",
    city: "Eua",
    countryId: "TO",
    timeZoneRegionName: "Pacific/Tongatapu",
    latitude: -21.377013,
    longitude: -174.956989,
    icao: "NFTE"
  },
  EUF: {
    iata: "EUF",
    name: "Weedon Field",
    city: "Eufaula",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 31.9,
    longitude: -85.15,
    icao: "KEUF"
  },
  EUG: {
    iata: "EUG",
    name: "Mahlon Sweet Field",
    city: "Eugene",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 44.124591,
    longitude: -123.211974,
    icao: "KEUG"
  },
  EUM: {
    iata: "EUM",
    name: "Neumuenster Airport",
    city: "Neumuenster",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 54.066667,
    longitude: 9.966667,
    icao: "EDHN"
  },
  EUN: {
    iata: "EUN",
    name: "Hassan I Airport",
    city: "Laayoune",
    countryId: "MA",
    timeZoneRegionName: "Africa/Casablanca",
    latitude: 27.133333,
    longitude: -13.216667,
    icao: "GMML"
  },
  EUQ: {
    iata: "EUQ",
    name: "Evelio Javier Airport",
    city: "Antique",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 10.767873,
    longitude: 121.932971,
    icao: "RPVS"
  },
  EUX: {
    iata: "EUX",
    name: "F D Roosevelt Airport",
    city: "Saint Eustatius",
    countryId: "BQ",
    timeZoneRegionName: "America/Curacao",
    latitude: 17.493056,
    longitude: -62.977778,
    icao: "TNCE"
  },
  EVE: {
    iata: "EVE",
    name: "Harstad/Narvik Airport, Evenes",
    city: "Harstad-Narvik",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 68.489956,
    longitude: 16.683194,
    icao: "ENEV"
  },
  EVG: {
    iata: "EVG",
    name: "Sveg Airport",
    city: "Sveg",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 62.047076,
    longitude: 14.419593,
    icao: "ESND"
  },
  EVM: {
    iata: "EVM",
    name: "Eveleth Airport",
    city: "Eveleth",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 47.426389,
    longitude: -92.495833,
    icao: "KEVM"
  },
  EVN: {
    iata: "EVN",
    name: "Zvartnots International Airport",
    city: "Yerevan",
    countryId: "AM",
    timeZoneRegionName: "Asia/Yerevan",
    latitude: 40.15272,
    longitude: 44.39805,
    icao: "UDYZ"
  },
  EVV: {
    iata: "EVV",
    name: "Evansville Regional Airport",
    city: "Evansville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 38.046164,
    longitude: -87.527965,
    icao: "KEVV"
  },
  EVW: {
    iata: "EVW",
    name: "Evanston Airport",
    city: "Evanston",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 41.266667,
    longitude: -110.966667,
    icao: "KEVW"
  },
  EVX: {
    iata: "EVX",
    name: "Evreux Airport",
    city: "Evreux",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 49.016667,
    longitude: 1.15,
    icao: "LFOE"
  },
  EWB: {
    iata: "EWB",
    name: "New Bedford Airport",
    city: "New Bedford",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.676944,
    longitude: -70.959167,
    icao: "KEWB"
  },
  EWE: {
    iata: "EWE",
    name: "Ewer Airport",
    city: "Ewer",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jayapura",
    latitude: -5.483333,
    longitude: 138.083333,
    icao: "WAKG"
  },
  EWK: {
    iata: "EWK",
    name: "Newton City-County Airport",
    city: "Newton",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 38.058201,
    longitude: -97.274498,
    icao: "KEWK"
  },
  EWN: {
    iata: "EWN",
    name: "Coastal Carolina Regional Airport",
    city: "New Bern",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 35.078344,
    longitude: -77.034622,
    icao: "KEWN"
  },
  EWO: {
    iata: "EWO",
    name: "Ewo Airport",
    city: "Ewo",
    countryId: "CG",
    timeZoneRegionName: "Africa/Brazzaville",
    latitude: -0.883333,
    longitude: 14.8,
    icao: "FCOE"
  },
  EWR: {
    iata: "EWR",
    name: "Newark Liberty International Airport",
    city: "Newark",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.689071,
    longitude: -74.178753,
    icao: "KEWR"
  },
  EXT: {
    iata: "EXT",
    name: "Exeter International Airport",
    city: "Exeter",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 50.731109,
    longitude: -3.410968,
    icao: "EGTE"
  },
  EYA: {
    iata: "EYA",
    name: "Zeya Airport",
    city: "Zeya",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yakutsk",
    latitude: 53.6883,
    longitude: 127.0911,
    icao: ""
  },
  EYK: {
    iata: "EYK",
    name: "Beloyarsky Airport",
    city: "Beloyarsky",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yekaterinburg",
    latitude: 63.696682,
    longitude: 66.701207,
    icao: "USHQ"
  },
  EYL: {
    iata: "EYL",
    name: "Yelimane Airport",
    city: "Yelimane",
    countryId: "ML",
    timeZoneRegionName: "Africa/Bamako",
    latitude: 15.133333,
    longitude: -10.566667,
    icao: "GAYE"
  },
  EYP: {
    iata: "EYP",
    name: "El Yopal Airport",
    city: "El Yopal",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 5.320729,
    longitude: -72.386282,
    icao: "SKYP"
  },
  EYS: {
    iata: "EYS",
    name: "Elive Springs Airport",
    city: "Elive Springs",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: 3.25,
    longitude: 35.966667,
    icao: "HKES"
  },
  EYW: {
    iata: "EYW",
    name: "Key West International Airport",
    city: "Key West",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 24.553574,
    longitude: -81.75501,
    icao: "KEYW"
  },
  EZE: {
    iata: "EZE",
    name: "Ministro Pistarini Airport",
    city: "Buenos Aires",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -34.81273,
    longitude: -58.539834,
    icao: "SAEZ"
  },
  EZS: {
    iata: "EZS",
    name: "Elazig Airport",
    city: "Elazig",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 38.599326,
    longitude: 39.26829,
    icao: "LTCA"
  },
  EZV: {
    iata: "EZV",
    name: "Beryozovo Airport",
    city: "Beryozovo",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yekaterinburg",
    latitude: 63.924582,
    longitude: 65.044853,
    icao: "USHB"
  },
  FAA: {
    iata: "FAA",
    name: "Faranah Airport",
    city: "Faranah",
    countryId: "GN",
    timeZoneRegionName: "Africa/Conakry",
    latitude: 10.033333,
    longitude: -10.75,
    icao: "GUFH"
  },
  FAB: {
    iata: "FAB",
    name: "Farnborough Airport",
    city: "Farnborough",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.278754,
    longitude: -0.770607,
    icao: "EGLF"
  },
  FAC: {
    iata: "FAC",
    name: "Faaite Airport",
    city: "Faaite",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -16.687222,
    longitude: -145.332572,
    icao: "NTKF"
  },
  FAE: {
    iata: "FAE",
    name: "Vagar Airport",
    city: "Faroe Islands",
    countryId: "FO",
    timeZoneRegionName: "Atlantic/Faroe",
    latitude: 62.066667,
    longitude: -7.266667,
    icao: "EKVG"
  },
  FAF: {
    iata: "FAF",
    name: "Felker Army Air Field",
    city: "Fort Eustis",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 37.132548,
    longitude: -76.608832,
    icao: "KFAF"
  },
  FAH: {
    iata: "FAH",
    name: "Farah Airport",
    city: "Farah",
    countryId: "AF",
    timeZoneRegionName: "Asia/Kabul",
    latitude: 32.369019,
    longitude: 62.163694,
    icao: "OAFR"
  },
  FAI: {
    iata: "FAI",
    name: "Fairbanks International Airport",
    city: "Fairbanks",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 64.818214,
    longitude: -147.866805,
    icao: "PAFA"
  },
  FAJ: {
    iata: "FAJ",
    name: "Diego Jimenez Torres Airport",
    city: "Fajardo",
    countryId: "PR",
    timeZoneRegionName: "America/Puerto_Rico",
    latitude: 18.31237,
    longitude: -65.65819,
    icao: "TJFA"
  },
  FAM: {
    iata: "FAM",
    name: "Farmington Regional Airport",
    city: "Farmington",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 37.780833,
    longitude: -90.421667,
    icao: "KFAM"
  },
  FAN: {
    iata: "FAN",
    name: "Lista Airport",
    city: "Farsund",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 58.101667,
    longitude: 6.625556,
    icao: "ENLI"
  },
  FAO: {
    iata: "FAO",
    name: "Faro Airport",
    city: "Faro",
    countryId: "PT",
    timeZoneRegionName: "Europe/Lisbon",
    latitude: 37.020646,
    longitude: -7.968545,
    icao: "LPFR"
  },
  FAR: {
    iata: "FAR",
    name: "Hector International Airport",
    city: "Fargo",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 46.919529,
    longitude: -96.825508,
    icao: "KFAR"
  },
  FAT: {
    iata: "FAT",
    name: "Fresno Yosemite International Airport",
    city: "Fresno",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 36.769624,
    longitude: -119.720236,
    icao: "KFAT"
  },
  FAU: {
    iata: "FAU",
    name: "Fahud Airport",
    city: "Fahud",
    countryId: "OM",
    timeZoneRegionName: "Asia/Muscat",
    latitude: 22.348871,
    longitude: 56.489113,
    icao: "OOFD"
  },
  FAV: {
    iata: "FAV",
    name: "Fakarava Airport",
    city: "Fakarava",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -16.053485,
    longitude: -145.652245,
    icao: "NTGF"
  },
  FAY: {
    iata: "FAY",
    name: "Fayetteville Regional Airport",
    city: "Fayetteville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 34.99132,
    longitude: -78.887221,
    icao: "KFAY"
  },
  FBA: {
    iata: "FBA",
    name: "Fonte Boa Airport",
    city: "Fonte Boa",
    countryId: "BR",
    timeZoneRegionName: "America/Porto_Velho",
    latitude: -2.531212,
    longitude: -66.084539,
    icao: "SWOB"
  },
  FBD: {
    iata: "FBD",
    name: "Faizabad Airport",
    city: "Faizabad",
    countryId: "AF",
    timeZoneRegionName: "Asia/Kabul",
    latitude: 37.121236,
    longitude: 70.518136,
    icao: "OAFZ"
  },
  FBE: {
    iata: "FBE",
    name: "Francisco Beltrao Airport",
    city: "Francisco Beltrao",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -26.083333,
    longitude: -53.066667,
    icao: "SSFB"
  },
  FBG: {
    iata: "FBG",
    name: "Simmons Army Airfield",
    city: "Fort Bragg",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 35.131944,
    longitude: -78.936389,
    icao: "KFBG"
  },
  FBL: {
    iata: "FBL",
    name: "Faribault Municipal Airport",
    city: "Faribault",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 44.3,
    longitude: -93.266667,
    icao: "KFBL"
  },
  FBM: {
    iata: "FBM",
    name: "Lubumbashi International Airport",
    city: "Lubumbashi",
    countryId: "CD",
    timeZoneRegionName: "Africa/Lubumbashi",
    latitude: -11.58971,
    longitude: 27.528487,
    icao: "FZQA"
  },
  FBR: {
    iata: "FBR",
    name: "Fort Bridger Airport",
    city: "Fort Bridger",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 41.316667,
    longitude: -110.383333,
    icao: "KFBR"
  },
  FBY: {
    iata: "FBY",
    name: "Fairbury Municipal Airport",
    city: "Fairbury",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 40.133333,
    longitude: -97.183333,
    icao: "KFBY"
  },
  FCA: {
    iata: "FCA",
    name: "Glacier Park International Airport",
    city: "Kalispell",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 48.307304,
    longitude: -114.253152,
    icao: "KGPI"
  },
  FCB: {
    iata: "FCB",
    name: "Ficksburg Sentra Oes Airport",
    city: "Ficksburg",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -28.825,
    longitude: 27.908333,
    icao: "FAFB"
  },
  FCH: {
    iata: "FCH",
    name: "Fresno-Chandler Airport",
    city: "Fresno",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 36.733333,
    longitude: -119.783333,
    icao: "KFCH"
  },
  FCM: {
    iata: "FCM",
    name: "Flying Cloud Airport",
    city: "Minneapolis",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 44.827096,
    longitude: -93.456769,
    icao: "KFCM"
  },
  FCN: {
    iata: "FCN",
    name: "Nordholz Airport",
    city: "Cuxhaven",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 53.768526,
    longitude: 8.665585,
    icao: "ETMN"
  },
  FCO: {
    iata: "FCO",
    name: "Leonardo da Vinci-Fiumicino Airport",
    city: "Rome",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 41.794594,
    longitude: 12.250346,
    icao: "LIRF"
  },
  FCS: {
    iata: "FCS",
    name: "Butts Army Air Field",
    city: "Colorado Springs",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 38.833333,
    longitude: -104.816667,
    icao: "KFCS"
  },
  FCT: {
    iata: "FCT",
    name: "Firing Center Army Air Field",
    city: "Yakima",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 46.6,
    longitude: -120.516667,
    icao: "KFCT"
  },
  FCY: {
    iata: "FCY",
    name: "Forrest City Municipal Airport",
    city: "Forrest City",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 34.95,
    longitude: -90.766667,
    icao: "KFCY"
  },
  FDE: {
    iata: "FDE",
    name: "Bringeland Airport",
    city: "Forde",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 61.39178,
    longitude: 5.762073,
    icao: "ENBL"
  },
  FDF: {
    iata: "FDF",
    name: "Martinique Aime Cesaire International Airport",
    city: "Fort De France",
    countryId: "MQ",
    timeZoneRegionName: "America/Martinique",
    latitude: 14.596061,
    longitude: -60.999948,
    icao: "TFFF"
  },
  FDH: {
    iata: "FDH",
    name: "Friedrichshafen Airport",
    city: "Friedrichshafen",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 47.672775,
    longitude: 9.523482,
    icao: "EDNY"
  },
  FDK: {
    iata: "FDK",
    name: "Frederick Municipal Airport",
    city: "Frederick",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.416667,
    longitude: -77.416667,
    icao: "KFDK"
  },
  FDR: {
    iata: "FDR",
    name: "Frederick Municipal Airport",
    city: "Frederick",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 34.383333,
    longitude: -99.016667,
    icao: "KFDR"
  },
  FDU: {
    iata: "FDU",
    name: "Bandundu Airport",
    city: "Bandundu",
    countryId: "CD",
    timeZoneRegionName: "Africa/Kinshasa",
    latitude: -3.305556,
    longitude: 17.383333,
    icao: "FZBO"
  },
  FDY: {
    iata: "FDY",
    name: "Findlay Airport",
    city: "Findlay",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.0135,
    longitude: -83.668701,
    icao: "KFDY"
  },
  FEB: {
    iata: "FEB",
    name: "Sanfebagar Airport",
    city: "Sanfebagar",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 29.233333,
    longitude: 81.216667,
    icao: "VNSR"
  },
  FEC: {
    iata: "FEC",
    name: "Joao Durval Carneiro Airport",
    city: "Feira De Santana",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -12.2025,
    longitude: -38.906111,
    icao: "SNJD"
  },
  FEG: {
    iata: "FEG",
    name: "Fergana International Airport",
    city: "Fergana",
    countryId: "UZ",
    timeZoneRegionName: "Asia/Tashkent",
    latitude: 40.358889,
    longitude: 71.745,
    icao: "UTFF"
  },
  FEJ: {
    iata: "FEJ",
    name: "Feijo Airport",
    city: "Feijo",
    countryId: "BR",
    timeZoneRegionName: "America/Rio_Branco",
    latitude: -8.15,
    longitude: -70.35,
    icao: "SWFJ"
  },
  FEK: {
    iata: "FEK",
    name: "Ferkessedougou Airport",
    city: "Ferkessedougou",
    countryId: "CI",
    timeZoneRegionName: "Africa/Abidjan",
    latitude: 9.6,
    longitude: -5.2,
    icao: "DIFK"
  },
  FEL: {
    iata: "FEL",
    name: "Fuerstenfeldbruck Airport",
    city: "Fuerstenfeldbruck",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 48.2,
    longitude: 11.266667,
    icao: "ETSF"
  },
  FEN: {
    iata: "FEN",
    name: "Fernando De Noronha Airport",
    city: "Fernando De Noronha",
    countryId: "BR",
    timeZoneRegionName: "America/Noronha",
    latitude: -3.85,
    longitude: -32.416667,
    icao: "SBFN"
  },
  FEP: {
    iata: "FEP",
    name: "Albertus Airport",
    city: "Freeport",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 42.283333,
    longitude: -89.6,
    icao: "KFEP"
  },
  FET: {
    iata: "FET",
    name: "Fremont Municipal Airport",
    city: "Fremont",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.449989,
    longitude: -96.519759,
    icao: "KFET"
  },
  FEZ: {
    iata: "FEZ",
    name: "Fes-Saiss Airport",
    city: "Fez",
    countryId: "MA",
    timeZoneRegionName: "Africa/Casablanca",
    latitude: 33.930791,
    longitude: -4.982138,
    icao: "GMFF"
  },
  FFA: {
    iata: "FFA",
    name: "First Flight Airport",
    city: "Kill Devil Hills",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 36.016667,
    longitude: -75.666667,
    icao: "KFFA"
  },
  FFL: {
    iata: "FFL",
    name: "Fairfield Municipal Airport",
    city: "Fairfield",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 40.933333,
    longitude: -91.95,
    icao: "KFFL"
  },
  FFM: {
    iata: "FFM",
    name: "Fergus Falls Municipal Airport",
    city: "Fergus Falls",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 46.285618,
    longitude: -96.151373,
    icao: "KFFM"
  },
  FFO: {
    iata: "FFO",
    name: "Wright-Patterson Air Force Base",
    city: "Dayton",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.826093,
    longitude: -84.048289,
    icao: "KFFO"
  },
  FFT: {
    iata: "FFT",
    name: "Frankfort Capital City Airport",
    city: "Frankfort",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 38.182222,
    longitude: -84.905,
    icao: "KFFT"
  },
  FFU: {
    iata: "FFU",
    name: "Futaleufu Airport",
    city: "Futaleufu",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -43.2,
    longitude: -71.816667,
    icao: "SCFT"
  },
  FGD: {
    iata: "FGD",
    name: "Fderik Airport",
    city: "Fderik",
    countryId: "MR",
    timeZoneRegionName: "Africa/Nouakchott",
    latitude: 22.675,
    longitude: -12.731944,
    icao: "GQPF"
  },
  FGI: {
    iata: "FGI",
    name: "Fagali I Airport",
    city: "Apia",
    countryId: "WS",
    timeZoneRegionName: "Pacific/Apia",
    latitude: -13.849282,
    longitude: -171.739422,
    icao: "NSAP"
  },
  FGU: {
    iata: "FGU",
    name: "Fangatau Airport",
    city: "Fangatau, Tuamoto Island",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -16.05,
    longitude: -141.833333,
    icao: "NTGB"
  },
  FHU: {
    iata: "FHU",
    name: "Fort Huachuca/Sierra Vista Municipal Airport",
    city: "Sierra Vista",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 31.588889,
    longitude: -110.343056,
    icao: "KFHU"
  },
  FHZ: {
    iata: "FHZ",
    name: "Fakahina Airport",
    city: "Fakahina",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -15.99095,
    longitude: -140.164452,
    icao: "NTKH"
  },
  FIE: {
    iata: "FIE",
    name: "Fair Isle Airport",
    city: "Fair Isle",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 59.534301,
    longitude: -1.62911,
    icao: "EGEF"
  },
  FIG: {
    iata: "FIG",
    name: "Katourou Airport",
    city: "Fria",
    countryId: "GN",
    timeZoneRegionName: "Africa/Conakry",
    latitude: 10.350565,
    longitude: -13.569165,
    icao: "GUFA"
  },
  FIH: {
    iata: "FIH",
    name: "N'djili Airport",
    city: "Kinshasa",
    countryId: "CD",
    timeZoneRegionName: "Africa/Kinshasa",
    latitude: -4.387155,
    longitude: 15.442285,
    icao: "FZAA"
  },
  FIZ: {
    iata: "FIZ",
    name: "Fitzroy Crossing Airport",
    city: "Fitzroy Crossing",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -18.181014,
    longitude: 125.560794,
    icao: "YFTZ"
  },
  FJR: {
    iata: "FJR",
    name: "Fujairah International Airport",
    city: "Al-Fujairah",
    countryId: "AE",
    timeZoneRegionName: "Asia/Dubai",
    latitude: 25.109444,
    longitude: 56.330556,
    icao: "OMFJ"
  },
  FKB: {
    iata: "FKB",
    name: "Baden-Airpark",
    city: "Karlsruhe/Baden Baden",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 48.781031,
    longitude: 8.089752,
    icao: "EDSB"
  },
  FKI: {
    iata: "FKI",
    name: "Bangoka International Airport",
    city: "Kisangani",
    countryId: "CD",
    timeZoneRegionName: "Africa/Lubumbashi",
    latitude: 0.481667,
    longitude: 25.338056,
    icao: "FZIC"
  },
  FKJ: {
    iata: "FKJ",
    name: "Fukui Airport",
    city: "Fukui",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 36.139722,
    longitude: 136.226667,
    icao: "RJNF"
  },
  FKL: {
    iata: "FKL",
    name: "Venango Regional Airport",
    city: "Franklin",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.379167,
    longitude: -79.859722,
    icao: "KFKL"
  },
  FKN: {
    iata: "FKN",
    name: "Franklin Municipal Airport",
    city: "Franklin",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 36.683333,
    longitude: -76.933333,
    icao: "KFKN"
  },
  FKQ: {
    iata: "FKQ",
    name: "Fakfak Torea Airport",
    city: "Fak Fak",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jayapura",
    latitude: -2.916667,
    longitude: 132.3,
    icao: "WASF"
  },
  FKS: {
    iata: "FKS",
    name: "Fukushima Airport",
    city: "Fukushima",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 37.226667,
    longitude: 140.432778,
    icao: "RJSF"
  },
  FLA: {
    iata: "FLA",
    name: "Capitolio Airport",
    city: "Florencia",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 1.588889,
    longitude: -75.558889,
    icao: "SKFL"
  },
  FLB: {
    iata: "FLB",
    name: "Cangapara Airport",
    city: "Floriano",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -6.8,
    longitude: -43.033333,
    icao: "SNQG"
  },
  FLD: {
    iata: "FLD",
    name: "Fond Du Lac County Airport",
    city: "Fond Du Lac",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 43.771198,
    longitude: -88.488403,
    icao: "KFLD"
  },
  FLF: {
    iata: "FLF",
    name: "Schaferhaus Airport",
    city: "Flensburg",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 54.772222,
    longitude: 9.383333,
    icao: "EDXF"
  },
  FLG: {
    iata: "FLG",
    name: "Flagstaff Pulliam Airport",
    city: "Flagstaff",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 35.137778,
    longitude: -111.671667,
    icao: "KFLG"
  },
  FLL: {
    iata: "FLL",
    name: "Fort Lauderdale-Hollywood International Airport",
    city: "Fort Lauderdale",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 26.071492,
    longitude: -80.144908,
    icao: "KFLL"
  },
  FLN: {
    iata: "FLN",
    name: "Hercilio Luz International Airport",
    city: "Florianopolis",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -27.664445,
    longitude: -48.5452,
    icao: "SBFL"
  },
  FLO: {
    iata: "FLO",
    name: "Florence Airport",
    city: "Florence",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 34.188889,
    longitude: -79.724444,
    icao: "KFLO"
  },
  FLP: {
    iata: "FLP",
    name: "Flippin Airport",
    city: "Flippin",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.3,
    longitude: -92.583333,
    icao: "KFLP"
  },
  FLR: {
    iata: "FLR",
    name: "Firenze-Peretola Airport",
    city: "Florence",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 43.802126,
    longitude: 11.201989,
    icao: "LIRQ"
  },
  FLS: {
    iata: "FLS",
    name: "Flinders Island Airport",
    city: "Flinders Island",
    countryId: "AU",
    timeZoneRegionName: "Australia/Hobart",
    latitude: -40.0917,
    longitude: 147.993001,
    icao: "YFLI"
  },
  FLV: {
    iata: "FLV",
    name: "Sherman Army Air Field",
    city: "Fort Leavenworth",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 39.368307,
    longitude: -94.914695,
    icao: "KFLV"
  },
  FLW: {
    iata: "FLW",
    name: "Santa Cruz Airport",
    city: "Flores Island (Azores)",
    countryId: "PT",
    timeZoneRegionName: "Atlantic/Azores",
    latitude: 39.466667,
    longitude: -31.15,
    icao: "LPFL"
  },
  FLX: {
    iata: "FLX",
    name: "Fallon Municipal Airport",
    city: "Fallon",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 39.500678,
    longitude: -118.746038,
    icao: "KFLX"
  },
  FLZ: {
    iata: "FLZ",
    name: "Ferdinand Lumban Tobing Airport",
    city: "Sibolga",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: 1.555833,
    longitude: 98.888889,
    icao: "WIMS"
  },
  FMA: {
    iata: "FMA",
    name: "El Pucu Airport",
    city: "Formosa",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -26.212778,
    longitude: -58.235,
    icao: "SARF"
  },
  FME: {
    iata: "FME",
    name: "Tipton Airport",
    city: "Fort Meade",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.0854,
    longitude: -76.759399,
    icao: "KFME"
  },
  FMH: {
    iata: "FMH",
    name: "Otis Air Force Base",
    city: "Falmouth",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.666667,
    longitude: -70.55,
    icao: "KFMH"
  },
  FMI: {
    iata: "FMI",
    name: "Kalemie Airport",
    city: "Kalemie",
    countryId: "CD",
    timeZoneRegionName: "Africa/Lubumbashi",
    latitude: -5.875556,
    longitude: 29.25,
    icao: "FZRF"
  },
  FMM: {
    iata: "FMM",
    name: "Memmingen Allgau Airport",
    city: "Memmingen",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 47.988611,
    longitude: 10.239444,
    icao: "EDJA"
  },
  FMN: {
    iata: "FMN",
    name: "Four Corners Regional Airport",
    city: "Farmington",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 36.741111,
    longitude: -108.229167,
    icao: "KFMN"
  },
  FMO: {
    iata: "FMO",
    name: "Munster Osnabruck International Airport",
    city: "Muenster",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 52.130053,
    longitude: 7.694928,
    icao: "EDDG"
  },
  FMS: {
    iata: "FMS",
    name: "Fort Madison Municipal Airport",
    city: "Fort Madison",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 40.658889,
    longitude: -91.3275,
    icao: "KFSW"
  },
  FMT: {
    iata: "FMT",
    name: "Faresmaathoda Airport",
    city: "Faresmathoda",
    countryId: "MV",
    timeZoneRegionName: "Indian/Maldives",
    latitude: 0.1925,
    longitude: 73.1964,
    icao: ""
  },
  FMY: {
    iata: "FMY",
    name: "Page Field",
    city: "Fort Myers",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 26.587888,
    longitude: -81.860809,
    icao: "KFMY"
  },
  FNA: {
    iata: "FNA",
    name: "Lungi International Airport",
    city: "Freetown",
    countryId: "SL",
    timeZoneRegionName: "Africa/Freetown",
    latitude: 8.616062,
    longitude: -13.199209,
    icao: "GFLL"
  },
  FNB: {
    iata: "FNB",
    name: "Neubrandenburg Airport",
    city: "Neubrandenburg",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 53.602778,
    longitude: 13.307222,
    icao: "ETNU"
  },
  FNC: {
    iata: "FNC",
    name: "Madeira Airport",
    city: "Funchal",
    countryId: "PT",
    timeZoneRegionName: "Europe/Lisbon",
    latitude: 32.693121,
    longitude: -16.775635,
    icao: "LPMA"
  },
  FND: {
    iata: "FND",
    name: "Funadhoo Airport",
    city: "Funadhoo",
    countryId: "MV",
    timeZoneRegionName: "Indian/Maldives",
    latitude: 6.157778,
    longitude: 73.286667,
    icao: ""
  },
  FNG: {
    iata: "FNG",
    name: "Fada Ngourma Airport",
    city: "Fada Ngourma",
    countryId: "BF",
    timeZoneRegionName: "Africa/Ouagadougou",
    latitude: 12.066667,
    longitude: 0.35,
    icao: "DFEF"
  },
  FNH: {
    iata: "FNH",
    name: "Fincha Airport",
    city: "Fincha",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 9.583333,
    longitude: 37.433333,
    icao: "HAFN"
  },
  FNI: {
    iata: "FNI",
    name: "Garons Airport",
    city: "Nimes",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 43.75,
    longitude: 4.416667,
    icao: "LFTW"
  },
  FNJ: {
    iata: "FNJ",
    name: "Pyongyang Sunan International Airport",
    city: "Pyongyang",
    countryId: "KP",
    timeZoneRegionName: "Asia/Pyongyang",
    latitude: 39.200649,
    longitude: 125.675368,
    icao: "ZKPY"
  },
  FNL: {
    iata: "FNL",
    name: "Fort Collins/Loveland Municipal Airport",
    city: "Fort Collins/Loveland",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 40.448322,
    longitude: -105.008459,
    icao: "KFNL"
  },
  FNT: {
    iata: "FNT",
    name: "Bishop International Airport",
    city: "Flint",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.973812,
    longitude: -83.738904,
    icao: "KFNT"
  },
  FOC: {
    iata: "FOC",
    name: "Changle International Airport",
    city: "Fuzhou",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 25.931231,
    longitude: 119.66923,
    icao: "ZSFZ"
  },
  FOD: {
    iata: "FOD",
    name: "Fort Dodge Airport",
    city: "Fort Dodge",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 42.5525,
    longitude: -94.189722,
    icao: "KFOD"
  },
  FOE: {
    iata: "FOE",
    name: "Forbes Field",
    city: "Topeka",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 38.9525,
    longitude: -95.6625,
    icao: "KFOE"
  },
  FOG: {
    iata: "FOG",
    name: "Gino Lisa Airport",
    city: "Foggia",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 41.433991,
    longitude: 15.544367,
    icao: "LIBF"
  },
  FOK: {
    iata: "FOK",
    name: "Francis S. Gabreski Airport",
    city: "Westhampton Beach",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.841888,
    longitude: -72.631994,
    icao: "KFOK"
  },
  FOM: {
    iata: "FOM",
    name: "Foumban Airport",
    city: "Foumban",
    countryId: "CM",
    timeZoneRegionName: "Africa/Douala",
    latitude: 5.75,
    longitude: 10.833333,
    icao: "FKKM"
  },
  FON: {
    iata: "FON",
    name: "La Fortuna Arenal Airport",
    city: "Fortuna",
    countryId: "CR",
    timeZoneRegionName: "America/Costa_Rica",
    latitude: 10.469482,
    longitude: -84.57882,
    icao: "MRAN"
  },
  FOO: {
    iata: "FOO",
    name: "Kornasoren Airfield",
    city: "Noemfoor",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jayapura",
    latitude: -0.936162,
    longitude: 134.865261,
    icao: "WABF"
  },
  FOR: {
    iata: "FOR",
    name: "Pinto Martins Airport",
    city: "Fortaleza",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -3.779073,
    longitude: -38.540835,
    icao: "SBFZ"
  },
  FOS: {
    iata: "FOS",
    name: "Forrest Airport",
    city: "Forrest",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -30.816667,
    longitude: 128.05,
    icao: "YFRT"
  },
  FOU: {
    iata: "FOU",
    name: "Fougamou Airport",
    city: "Fougamou",
    countryId: "GA",
    timeZoneRegionName: "Africa/Libreville",
    latitude: -1.2,
    longitude: 10.783333,
    icao: "FOGF"
  },
  FPO: {
    iata: "FPO",
    name: "Grand Bahama International Airport",
    city: "Freeport",
    countryId: "BS",
    timeZoneRegionName: "America/Nassau",
    latitude: 26.547292,
    longitude: -78.705197,
    icao: "MYGF"
  },
  FPR: {
    iata: "FPR",
    name: "Saint Lucie County Airport",
    city: "Fort Pierce",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 27.4951,
    longitude: -80.368301,
    icao: "KFPR"
  },
  FRA: {
    iata: "FRA",
    name: "Frankfurt Airport",
    city: "Frankfurt",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 50.048952,
    longitude: 8.573678,
    icao: "EDDF"
  },
  FRB: {
    iata: "FRB",
    name: "Forbes Airport",
    city: "Forbes",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -33.4,
    longitude: 148.05,
    icao: "YFBS"
  },
  FRC: {
    iata: "FRC",
    name: "Franca Airport",
    city: "Franca",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -20.551944,
    longitude: -47.4375,
    icao: "SBFC"
  },
  FRD: {
    iata: "FRD",
    name: "Friday Harbor Airport",
    city: "Friday Harbor",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 48.524807,
    longitude: -123.026499,
    icao: "KFHR"
  },
  FRE: {
    iata: "FRE",
    name: "Fera Island Airport",
    city: "Fera Island",
    countryId: "SB",
    timeZoneRegionName: "Pacific/Guadalcanal",
    latitude: -8.1,
    longitude: 159.583333,
    icao: "AGGF"
  },
  FRG: {
    iata: "FRG",
    name: "Republic Airport",
    city: "Farmingdale",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.728802,
    longitude: -73.413399,
    icao: "KFRG"
  },
  FRH: {
    iata: "FRH",
    name: "French Lick Municipal Airport",
    city: "French Lick",
    countryId: "US",
    timeZoneRegionName: "America/Indiana/Indianapolis",
    latitude: 38.55,
    longitude: -86.616667,
    icao: "KFRH"
  },
  FRI: {
    iata: "FRI",
    name: "Marshall Army Air Field",
    city: "Fort Riley",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 39.053192,
    longitude: -96.764195,
    icao: "KFRI"
  },
  FRK: {
    iata: "FRK",
    name: "Fregate Island Airport",
    city: "Fregate Island",
    countryId: "SC",
    timeZoneRegionName: "Indian/Mahe",
    latitude: -4.583333,
    longitude: 55.966667,
    icao: "FSSF"
  },
  FRL: {
    iata: "FRL",
    name: "Luigi Ridolfi Airport",
    city: "Forli",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 44.19857,
    longitude: 12.07076,
    icao: "LIPK"
  },
  FRM: {
    iata: "FRM",
    name: "Fairmont Airport",
    city: "Fairmont",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 43.647222,
    longitude: -94.423611,
    icao: "KFRM"
  },
  FRO: {
    iata: "FRO",
    name: "Flora Airport",
    city: "Floro",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 61.585302,
    longitude: 5.023999,
    icao: "ENFL"
  },
  FRR: {
    iata: "FRR",
    name: "Front Royal-Warren County Airport",
    city: "Front Royal",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 38.918174,
    longitude: -78.2541,
    icao: "KFRR"
  },
  FRS: {
    iata: "FRS",
    name: "Santa Elena Airport",
    city: "Flores",
    countryId: "GT",
    timeZoneRegionName: "America/Guatemala",
    latitude: 16.916667,
    longitude: -89.883333,
    icao: "MGTK"
  },
  FRU: {
    iata: "FRU",
    name: "Manas International Airport",
    city: "Bishkek",
    countryId: "KG",
    timeZoneRegionName: "Asia/Bishkek",
    latitude: 43.053581,
    longitude: 74.469449,
    icao: "UAFM"
  },
  FRW: {
    iata: "FRW",
    name: "Francistown Airport",
    city: "Francistown",
    countryId: "BW",
    timeZoneRegionName: "Africa/Gaborone",
    latitude: -21.16,
    longitude: 27.4825,
    icao: "FBFT"
  },
  FRY: {
    iata: "FRY",
    name: "Eastern Slopes Regional Airport",
    city: "Fryeburg",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 43.992982,
    longitude: -70.941378,
    icao: "KIZG"
  },
  FRZ: {
    iata: "FRZ",
    name: "Fritzlar Air Base",
    city: "Fritzlar",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 51.114276,
    longitude: 9.286667,
    icao: "ETHF"
  },
  FSC: {
    iata: "FSC",
    name: "Sud Corse Airport",
    city: "Figari",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 41.498633,
    longitude: 9.098223,
    icao: "LFKF"
  },
  FSD: {
    iata: "FSD",
    name: "Joe Foss Field",
    city: "Sioux Falls",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 43.58201,
    longitude: -96.741849,
    icao: "KFSD"
  },
  FSI: {
    iata: "FSI",
    name: "Post Aaf",
    city: "Ft Sill",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 34.650722,
    longitude: -98.419972,
    icao: "KFSI"
  },
  FSK: {
    iata: "FSK",
    name: "Fort Scott Municipal Airport",
    city: "Fort Scott",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 37.833333,
    longitude: -94.7,
    icao: "KFSK"
  },
  FSM: {
    iata: "FSM",
    name: "Fort Smith Regional Airport",
    city: "Fort Smith",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.34124,
    longitude: -94.3589,
    icao: "KFSM"
  },
  FSP: {
    iata: "FSP",
    name: "Saint Pierre Airport",
    city: "Saint Pierre",
    countryId: "PM",
    timeZoneRegionName: "America/Miquelon",
    latitude: 46.916667,
    longitude: -56.166667,
    icao: "LFVP"
  },
  FSS: {
    iata: "FSS",
    name: "Kinloss Airport",
    city: "Forres",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 57.65,
    longitude: -3.566667,
    icao: "EGQK"
  },
  FST: {
    iata: "FST",
    name: "Pecos County Airport",
    city: "Fort Stockton",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.893889,
    longitude: -102.878889,
    icao: "KFST"
  },
  FSU: {
    iata: "FSU",
    name: "Fort Sumner Airport",
    city: "Fort Sumner",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 34.466667,
    longitude: -104.25,
    icao: "KFSU"
  },
  FSZ: {
    iata: "FSZ",
    name: "Shizuoka Airport",
    city: "Shizuoka",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 34.796111,
    longitude: 138.189444,
    icao: "RJNS"
  },
  FTA: {
    iata: "FTA",
    name: "Futuna Airport",
    city: "Futuna Island",
    countryId: "VU",
    timeZoneRegionName: "Pacific/Efate",
    latitude: -19.416667,
    longitude: 170.25,
    icao: "NVVF"
  },
  FTE: {
    iata: "FTE",
    name: "El Calafate International Airport",
    city: "El Calafate",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Rio_Gallegos",
    latitude: -50.28025,
    longitude: -72.053194,
    icao: "SAWC"
  },
  FTI: {
    iata: "FTI",
    name: "Fitiuta Airport",
    city: "Fitiuta",
    countryId: "AS",
    timeZoneRegionName: "Pacific/Pago_Pago",
    latitude: -14.214877,
    longitude: -169.425963,
    icao: "NSFQ"
  },
  FTK: {
    iata: "FTK",
    name: "Godman Army Air Field",
    city: "Fort Knox",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 37.927708,
    longitude: -85.949045,
    icao: "KFTK"
  },
  FTU: {
    iata: "FTU",
    name: "Marillac Airport",
    city: "Fort Dauphin",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -25.038056,
    longitude: 46.955556,
    icao: "FMSD"
  },
  FTW: {
    iata: "FTW",
    name: "Fort Worth Meacham International Airport",
    city: "Fort Worth",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.816769,
    longitude: -97.356687,
    icao: "KFTW"
  },
  FTX: {
    iata: "FTX",
    name: "Owando Airport",
    city: "Owando",
    countryId: "CG",
    timeZoneRegionName: "Africa/Brazzaville",
    latitude: -0.983333,
    longitude: 16.008333,
    icao: "FCOO"
  },
  FTY: {
    iata: "FTY",
    name: "Fulton County Airport",
    city: "Atlanta",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 33.777196,
    longitude: -84.521143,
    icao: "KFTY"
  },
  FUE: {
    iata: "FUE",
    name: "Fuerteventura Airport",
    city: "Puerto del Rosario",
    countryId: "ES",
    timeZoneRegionName: "Atlantic/Canary",
    latitude: 28.450605,
    longitude: -13.869893,
    icao: "GCFV"
  },
  FUG: {
    iata: "FUG",
    name: "Fuyang Xiguan Airport",
    city: "Fuyang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 32.866667,
    longitude: 115.7,
    icao: "ZSFY"
  },
  FUJ: {
    iata: "FUJ",
    name: "Fukue Airport",
    city: "Fukue",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 32.667826,
    longitude: 128.837611,
    icao: "RJFE"
  },
  FUK: {
    iata: "FUK",
    name: "Fukuoka Airport",
    city: "Fukuoka",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 33.584286,
    longitude: 130.443891,
    icao: "RJFF"
  },
  FUL: {
    iata: "FUL",
    name: "Fullerton Municipal Airport",
    city: "Fullerton",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 33.872626,
    longitude: -117.974253,
    icao: "KFUL"
  },
  FUN: {
    iata: "FUN",
    name: "Funafuti Atol International Airport",
    city: "Funafuti Atol",
    countryId: "TV",
    timeZoneRegionName: "Pacific/Funafuti",
    latitude: -8.516667,
    longitude: 179.208333,
    icao: "NGFU"
  },
  FUO: {
    iata: "FUO",
    name: "Foshan Shadi Airport",
    city: "Fuoshan",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 23.081156,
    longitude: 113.071443,
    icao: "ZGFS"
  },
  FUP: {
    iata: "FUP",
    name: "Satenas Air Base",
    city: "Satenas",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 58.43803,
    longitude: 12.696428,
    icao: "ESIB"
  },
  FUT: {
    iata: "FUT",
    name: "Futuna Island Airport",
    city: "Futuna Island",
    countryId: "WF",
    timeZoneRegionName: "Pacific/Wallis",
    latitude: -14.25,
    longitude: -178.15,
    icao: "NLWF"
  },
  FVM: {
    iata: "FVM",
    name: "Fuvahmulaku Island Airport",
    city: "Fuvahmulah Island",
    countryId: "MV",
    timeZoneRegionName: "Indian/Maldives",
    latitude: -0.309444,
    longitude: 73.43278,
    icao: "VRMF"
  },
  FVS: {
    iata: "FVS",
    name: "Finland Station",
    city: "Finlyandskiy",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 59.955556,
    longitude: 30.356667,
    icao: ""
  },
  FWA: {
    iata: "FWA",
    name: "Fort Wayne International Airport",
    city: "Fort Wayne",
    countryId: "US",
    timeZoneRegionName: "America/Indiana/Indianapolis",
    latitude: 40.98666,
    longitude: -85.187715,
    icao: "KFWA"
  },
  FWH: {
    iata: "FWH",
    name: "Fort Worth Naval Air Station Joint Reserve Base",
    city: "Fort Worth",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.771494,
    longitude: -97.427781,
    icao: "KNFW"
  },
  FWL: {
    iata: "FWL",
    name: "Farewell Airport",
    city: "Farewell",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 62.509722,
    longitude: -153.889444,
    icao: "PAFW"
  },
  FXE: {
    iata: "FXE",
    name: "Fort Lauderdale Executive Airport",
    city: "Fort Lauderdale",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 26.19659,
    longitude: -80.171517,
    icao: "KFXE"
  },
  FXO: {
    iata: "FXO",
    name: "Cuamba Airport",
    city: "Cuamba",
    countryId: "MZ",
    timeZoneRegionName: "Africa/Maputo",
    latitude: -14.805278,
    longitude: 36.526944,
    icao: "FQCB"
  },
  FXY: {
    iata: "FXY",
    name: "Forest City Municipal Airport",
    city: "Forest City",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 43.266667,
    longitude: -93.65,
    icao: "KFXY"
  },
  FYJ: {
    iata: "FYJ",
    name: "Fuyuan Dongji Airport",
    city: "Fuyuan County",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 48.19722,
    longitude: 134.36333,
    icao: ""
  },
  FYM: {
    iata: "FYM",
    name: "Fayetteville Municipal Airport",
    city: "Fayetteville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.15,
    longitude: -86.566667,
    icao: "KFYM"
  },
  FYN: {
    iata: "FYN",
    name: "Fuyun Koktokay Airport",
    city: "Fuyun",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 46.801111,
    longitude: 89.538333,
    icao: "ZWFY"
  },
  FYT: {
    iata: "FYT",
    name: "Faya Airport",
    city: "Faya",
    countryId: "TD",
    timeZoneRegionName: "Africa/Ndjamena",
    latitude: 17.916667,
    longitude: 19.116667,
    icao: "FTTY"
  },
  FYU: {
    iata: "FYU",
    name: "Fort Yukon Airport",
    city: "Fort Yukon",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 66.567918,
    longitude: -145.258136,
    icao: "PFYU"
  },
  FYV: {
    iata: "FYV",
    name: "Drake Field",
    city: "Fayetteville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.003611,
    longitude: -94.17,
    icao: "KFYV"
  },
  FZO: {
    iata: "FZO",
    name: "Filton Airport",
    city: "Filton",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.516667,
    longitude: -2.583333,
    icao: "EGTG"
  },
  GAB: {
    iata: "GAB",
    name: "Gabbs Airport",
    city: "Gabbs",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 38.866667,
    longitude: -117.916667,
    icao: "KGAB"
  },
  GAD: {
    iata: "GAD",
    name: "Gadsden Municipal Airport",
    city: "Gadsden",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 33.973611,
    longitude: -86.087222,
    icao: "KGAD"
  },
  GAE: {
    iata: "GAE",
    name: "Gabes - Matmata Airport",
    city: "Gabes",
    countryId: "TN",
    timeZoneRegionName: "Africa/Tunis",
    latitude: 33.735691,
    longitude: 9.919377,
    icao: "DTTG"
  },
  GAF: {
    iata: "GAF",
    name: "Gafsa Airport",
    city: "Gafsa",
    countryId: "TN",
    timeZoneRegionName: "Africa/Tunis",
    latitude: 34.416667,
    longitude: 8.816667,
    icao: "DTTF"
  },
  GAG: {
    iata: "GAG",
    name: "Gage Airport",
    city: "Gage",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.35,
    longitude: -99.883333,
    icao: "KGAG"
  },
  GAH: {
    iata: "GAH",
    name: "Gayndah Airport",
    city: "Gayndah",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -25.433333,
    longitude: 151.483333,
    icao: "YGAY"
  },
  GAI: {
    iata: "GAI",
    name: "Montgomery County Airpark",
    city: "Gaithersburg",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.168301,
    longitude: -77.166,
    icao: "KGAI"
  },
  GAJ: {
    iata: "GAJ",
    name: "Yamagata Airport",
    city: "Yamagata",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 38.411944,
    longitude: 140.371111,
    icao: "RJSC"
  },
  GAL: {
    iata: "GAL",
    name: "Edward G. Pitka Sr. Airport",
    city: "Galena",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 64.73609,
    longitude: -156.936112,
    icao: "PAGA"
  },
  GAM: {
    iata: "GAM",
    name: "Gambell Airport",
    city: "Gambell",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 63.776596,
    longitude: -171.713546,
    icao: "PAGM"
  },
  GAN: {
    iata: "GAN",
    name: "Gan/Seenu Airport",
    city: "Gan Island",
    countryId: "MV",
    timeZoneRegionName: "Indian/Maldives",
    latitude: -0.690003,
    longitude: 73.156538,
    icao: "VRMG"
  },
  GAO: {
    iata: "GAO",
    name: "Mariana Grajales Airport",
    city: "Guantanamo",
    countryId: "CU",
    timeZoneRegionName: "America/Havana",
    latitude: 20.084722,
    longitude: -75.158611,
    icao: "MUGT"
  },
  GAQ: {
    iata: "GAQ",
    name: "Gao Airport",
    city: "Gao",
    countryId: "ML",
    timeZoneRegionName: "Africa/Bamako",
    latitude: 16.248611,
    longitude: -1389e-6,
    icao: "GAGO"
  },
  GAS: {
    iata: "GAS",
    name: "Garissa Airport",
    city: "Garissa",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: -0.46351,
    longitude: 39.648285,
    icao: "HKGA"
  },
  GAT: {
    iata: "GAT",
    name: "Tallard Airport",
    city: "Gap",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 44.455002,
    longitude: 6.03778,
    icao: "LFNA"
  },
  GAU: {
    iata: "GAU",
    name: "Lokpriya Gopinath Bordoloi International Airport",
    city: "Guwahati",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 26.105185,
    longitude: 91.588427,
    icao: "VEGT"
  },
  GAW: {
    iata: "GAW",
    name: "Gangaw Airport",
    city: "Gangaw",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 22.166667,
    longitude: 94.133333,
    icao: "VYGG"
  },
  GAX: {
    iata: "GAX",
    name: "Gamba Yenzi Airport",
    city: "Gamba",
    countryId: "GA",
    timeZoneRegionName: "Africa/Libreville",
    latitude: -2.766667,
    longitude: 9.983333,
    icao: ""
  },
  GAY: {
    iata: "GAY",
    name: "Gaya Airport",
    city: "Gaya",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 24.746667,
    longitude: 84.945833,
    icao: "VEGY"
  },
  GBB: {
    iata: "GBB",
    name: "Gabala International Airport",
    city: "Gabala",
    countryId: "AZ",
    timeZoneRegionName: "Asia/Baku",
    latitude: 40.821159,
    longitude: 47.719046,
    icao: "UBBQ"
  },
  GBD: {
    iata: "GBD",
    name: "Great Bend Airport",
    city: "Great Bend",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 38.347222,
    longitude: -98.864167,
    icao: "KGBD"
  },
  GBE: {
    iata: "GBE",
    name: "Sir Seretse Khama International Airport",
    city: "Gaborone",
    countryId: "BW",
    timeZoneRegionName: "Africa/Gaborone",
    latitude: -24.557982,
    longitude: 25.924509,
    icao: "FBSK"
  },
  GBG: {
    iata: "GBG",
    name: "Galesburg Airport",
    city: "Galesburg",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 40.938611,
    longitude: -90.428889,
    icao: "KGBG"
  },
  GBH: {
    iata: "GBH",
    name: "Galbraith Lake Airport",
    city: "Galbraith Lake",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 68.466667,
    longitude: -149.483333,
    icao: "PAGB"
  },
  GBI: {
    iata: "GBI",
    name: "Kalaburagi Airport",
    city: "Gulbarga",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 17.307642,
    longitude: 76.956805,
    icao: ""
  },
  GBJ: {
    iata: "GBJ",
    name: "Les Bases Airport",
    city: "Marie Galante",
    countryId: "GP",
    timeZoneRegionName: "America/Guadeloupe",
    latitude: 15.869166,
    longitude: -61.272155,
    icao: "TFFM"
  },
  GBK: {
    iata: "GBK",
    name: "Gbangbatok Airport",
    city: "Gbangbatok",
    countryId: "SL",
    timeZoneRegionName: "Africa/Freetown",
    latitude: 7.8,
    longitude: -12.366667,
    icao: "GFGK"
  },
  GBR: {
    iata: "GBR",
    name: "Great Barrington Airport",
    city: "Great Barrington",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.2,
    longitude: -73.366667,
    icao: "KGBR"
  },
  GBT: {
    iata: "GBT",
    name: "Gorgon Airport",
    city: "Gorgon",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 36.908509,
    longitude: 54.410516,
    icao: "OING"
  },
  GBV: {
    iata: "GBV",
    name: "Gibb River Airport",
    city: "Gibb River",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -15.65,
    longitude: 126.633333,
    icao: "YGIB"
  },
  GBW: {
    iata: "GBW",
    name: "Ginbata Airport",
    city: "Ginbatta",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -22.5816,
    longitude: 120.036254,
    icao: "YGIA"
  },
  GBZ: {
    iata: "GBZ",
    name: "Great Barrier Aerodrome",
    city: "Great Barrier Island",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -36.240003,
    longitude: 175.468799,
    icao: "NZGB"
  },
  GCC: {
    iata: "GCC",
    name: "Campbell County Airport",
    city: "Gillette",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 44.346356,
    longitude: -105.532684,
    icao: "KGCC"
  },
  GCH: {
    iata: "GCH",
    name: "Gachsaran Airport",
    city: "Gachsaran",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 30.3364,
    longitude: 50.831656,
    icao: "OIAH"
  },
  GCI: {
    iata: "GCI",
    name: "Guernsey Airport",
    city: "Guernsey",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 49.432756,
    longitude: -2.595044,
    icao: "EGJB"
  },
  GCJ: {
    iata: "GCJ",
    name: "Johannesburg-Grand Central Airport",
    city: "Johannesburg",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -25.987298,
    longitude: 28.143794,
    icao: "FAGC"
  },
  GCK: {
    iata: "GCK",
    name: "Garden City Municipal Airport",
    city: "Garden City",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 37.928611,
    longitude: -100.729722,
    icao: "KGCK"
  },
  GCM: {
    iata: "GCM",
    name: "Owen Roberts International Airport",
    city: "Grand Cayman Island",
    countryId: "KY",
    timeZoneRegionName: "America/Cayman",
    latitude: 19.296369,
    longitude: -81.357786,
    icao: "MWCR"
  },
  GCN: {
    iata: "GCN",
    name: "Grand Canyon National Park Airport",
    city: "Grand Canyon",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 35.951944,
    longitude: -112.1475,
    icao: "KGCN"
  },
  GCW: {
    iata: "GCW",
    name: "Grand Canyon West Airport",
    city: "Peach Springs",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 35.988802,
    longitude: -113.815671,
    icao: ""
  },
  GCY: {
    iata: "GCY",
    name: "Greene County Municipal Airport",
    city: "Greeneville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.192986,
    longitude: -82.815047,
    icao: "KGCY"
  },
  GDB: {
    iata: "GDB",
    name: "Gondia Birsi Airport",
    city: "Gondia",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 21.5227,
    longitude: 80.2905,
    icao: ""
  },
  GDC: {
    iata: "GDC",
    name: "Donaldson Field",
    city: "Greenville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 34.758311,
    longitude: -82.376428,
    icao: "KGYH"
  },
  GDE: {
    iata: "GDE",
    name: "Gode/Iddidole Airport",
    city: "Gode/Iddidole",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 5.902222,
    longitude: 43.628333,
    icao: "HAGO"
  },
  GDJ: {
    iata: "GDJ",
    name: "Gandajika Airport",
    city: "Gandajika",
    countryId: "CD",
    timeZoneRegionName: "Africa/Kinshasa",
    latitude: -6.766667,
    longitude: 23.966667,
    icao: "FZWC"
  },
  GDL: {
    iata: "GDL",
    name: "Miguel Hidalgo y Costilla International Airport",
    city: "Guadalajara",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 20.52181,
    longitude: -103.311163,
    icao: "MMGL"
  },
  GDM: {
    iata: "GDM",
    name: "Gardner Municipal Airport",
    city: "Gardner",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.566667,
    longitude: -71.983333,
    icao: "KGDM"
  },
  GDN: {
    iata: "GDN",
    name: "Gdansk Lech Walesa Airport",
    city: "Gdansk",
    countryId: "PL",
    timeZoneRegionName: "Europe/Warsaw",
    latitude: 54.380979,
    longitude: 18.468654,
    icao: "EPGD"
  },
  GDO: {
    iata: "GDO",
    name: "Vare Maria Airport",
    city: "Guasdualito",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 7.233333,
    longitude: -70.8,
    icao: "SVGD"
  },
  GDP: {
    iata: "GDP",
    name: "Guadalupe Airport",
    city: "Guadalupe",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -6.781944,
    longitude: -43.581667,
    icao: "SNGD"
  },
  GDQ: {
    iata: "GDQ",
    name: "Gondar Airport",
    city: "Gondar",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 12.514444,
    longitude: 37.445556,
    icao: "HAGN"
  },
  GDT: {
    iata: "GDT",
    name: "JAGS McCartney International Airport",
    city: "Grand Turk Island",
    countryId: "TC",
    timeZoneRegionName: "America/Grand_Turk",
    latitude: 21.444914,
    longitude: -71.143583,
    icao: "MBGT"
  },
  GDV: {
    iata: "GDV",
    name: "Dawson Community Airport",
    city: "Glendive",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 47.138889,
    longitude: -104.806944,
    icao: "KGDV"
  },
  GDW: {
    iata: "GDW",
    name: "Gladwin Airport",
    city: "Gladwin",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 43.983333,
    longitude: -84.483333,
    icao: "KGDW"
  },
  GDX: {
    iata: "GDX",
    name: "Magadan Airport",
    city: "Magadan",
    countryId: "RU",
    timeZoneRegionName: "Asia/Magadan",
    latitude: 59.916667,
    longitude: 150.716667,
    icao: "UHMM"
  },
  GDZ: {
    iata: "GDZ",
    name: "Gelendzhik Airport",
    city: "Gelendzik",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 44.566667,
    longitude: 38.016667,
    icao: ""
  },
  GEA: {
    iata: "GEA",
    name: "Noumea Magenta Airport",
    city: "Noumea",
    countryId: "NC",
    timeZoneRegionName: "Pacific/Noumea",
    latitude: -22.260536,
    longitude: 166.470783,
    icao: "NWWM"
  },
  GED: {
    iata: "GED",
    name: "Sussex County Airport",
    city: "Georgetown",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 38.688333,
    longitude: -75.3575,
    icao: "KGED"
  },
  GEG: {
    iata: "GEG",
    name: "Spokane International Airport",
    city: "Spokane",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 47.625147,
    longitude: -117.537638,
    icao: "KGEG"
  },
  GEL: {
    iata: "GEL",
    name: "Sepe Tiaraju Airport",
    city: "Santo Angelo",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -28.281111,
    longitude: -54.168056,
    icao: "SBNM"
  },
  GEM: {
    iata: "GEM",
    name: "Mongomo Mongomeyen Airport",
    city: "Mongomo",
    countryId: "GQ",
    timeZoneRegionName: "Africa/Malabo",
    latitude: 1.685334,
    longitude: 11.024394,
    icao: ""
  },
  GEO: {
    iata: "GEO",
    name: "Cheddi Jagan International Airport",
    city: "Georgetown",
    countryId: "GY",
    timeZoneRegionName: "America/Guyana",
    latitude: 6.503833,
    longitude: -58.253078,
    icao: "SYCJ"
  },
  GER: {
    iata: "GER",
    name: "Rafael Cabrera Airport",
    city: "Nueva Gerona",
    countryId: "CU",
    timeZoneRegionName: "America/Havana",
    latitude: 21.8375,
    longitude: -82.78,
    icao: "MUNG"
  },
  GES: {
    iata: "GES",
    name: "General Santos International Airport",
    city: "General Santos City",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 6.057778,
    longitude: 125.095833,
    icao: "RPMR"
  },
  GET: {
    iata: "GET",
    name: "Geraldton Airport",
    city: "Geraldton",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -28.796077,
    longitude: 114.70205,
    icao: "YGEL"
  },
  GEV: {
    iata: "GEV",
    name: "Gallivare Airport",
    city: "Gallivare",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 67.134444,
    longitude: 20.816667,
    icao: "ESNG"
  },
  GEY: {
    iata: "GEY",
    name: "South Big Horn County Airport",
    city: "Greybull",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 44.5,
    longitude: -108.05,
    icao: "KGEY"
  },
  GFD: {
    iata: "GFD",
    name: "Pope Field",
    city: "Greenfield",
    countryId: "US",
    timeZoneRegionName: "America/Indiana/Indianapolis",
    latitude: 39.783333,
    longitude: -85.766667,
    icao: "KGFD"
  },
  GFF: {
    iata: "GFF",
    name: "Griffith Airport",
    city: "Griffith",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -34.255434,
    longitude: 146.062694,
    icao: "YGTH"
  },
  GFK: {
    iata: "GFK",
    name: "Grand Forks International Airport",
    city: "Grand Forks",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 47.949786,
    longitude: -97.177132,
    icao: "KGFK"
  },
  GFL: {
    iata: "GFL",
    name: "Floyd Bennett Memorial Airport",
    city: "Glens Falls",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 43.341388,
    longitude: -73.608812,
    icao: "KGFL"
  },
  GFN: {
    iata: "GFN",
    name: "Grafton Airport",
    city: "Grafton",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -29.759522,
    longitude: 153.028334,
    icao: "YGFN"
  },
  GFR: {
    iata: "GFR",
    name: "Granville Airport",
    city: "Granville",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 48.883333,
    longitude: -1.566667,
    icao: "LFRF"
  },
  GFY: {
    iata: "GFY",
    name: "Grootfontein Airport",
    city: "Grootfontein",
    countryId: "NA",
    timeZoneRegionName: "Africa/Windhoek",
    latitude: -19.6,
    longitude: 18.133333,
    icao: "FYGF"
  },
  GGD: {
    iata: "GGD",
    name: "Gregory Downs Airport",
    city: "Gregory Downs",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -18.633333,
    longitude: 139.233333,
    icao: "YGDS"
  },
  GGE: {
    iata: "GGE",
    name: "Georgetown Airport",
    city: "Georgetown",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 33.383333,
    longitude: -79.283333,
    icao: "KGGE"
  },
  GGG: {
    iata: "GGG",
    name: "Gregg County Airport",
    city: "Longview",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.386667,
    longitude: -94.715278,
    icao: "KGGG"
  },
  GGH: {
    iata: "GGH",
    name: "Cianorte Airport",
    city: "Cianorte",
    countryId: "BR",
    timeZoneRegionName: "America/Campo_Grande",
    latitude: -23.691667,
    longitude: -52.642222,
    icao: "SSCT"
  },
  GGJ: {
    iata: "GGJ",
    name: "Guaira Airport",
    city: "Guaira",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -24.0797,
    longitude: -54.1881,
    icao: ""
  },
  GGM: {
    iata: "GGM",
    name: "Kakamega Airport",
    city: "Kakamega",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: 0.271239,
    longitude: 34.784689,
    icao: "HKKG"
  },
  GGO: {
    iata: "GGO",
    name: "Guilo Airport",
    city: "Guilo",
    countryId: "CI",
    timeZoneRegionName: "Africa/Abidjan",
    latitude: 6.333333,
    longitude: -7.75,
    icao: "DIGL"
  },
  GGR: {
    iata: "GGR",
    name: "Garowe Airport",
    city: "Garowe",
    countryId: "SO",
    timeZoneRegionName: "Africa/Mogadishu",
    latitude: 8.460833,
    longitude: 48.572222,
    icao: ""
  },
  GGS: {
    iata: "GGS",
    name: "Gobernador Gregores Airport",
    city: "Gobernador Gregores",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -48.766667,
    longitude: -70.25,
    icao: "SAWR"
  },
  GGT: {
    iata: "GGT",
    name: "Exuma International Airport",
    city: "George Town",
    countryId: "BS",
    timeZoneRegionName: "America/Nassau",
    latitude: 23.564018,
    longitude: -75.872475,
    icao: "MYEF"
  },
  GGW: {
    iata: "GGW",
    name: "Glasgow International Airport",
    city: "Glasgow",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 48.212778,
    longitude: -106.615556,
    icao: "KGGW"
  },
  GHA: {
    iata: "GHA",
    name: "Noumerate Airport",
    city: "Ghardaia",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 32.382222,
    longitude: 3.800556,
    icao: "DAUG"
  },
  GHB: {
    iata: "GHB",
    name: "Governor's Harbour Airport",
    city: "Governor's Harbour",
    countryId: "BS",
    timeZoneRegionName: "America/Nassau",
    latitude: 25.277398,
    longitude: -76.326771,
    icao: "MYEM"
  },
  GHC: {
    iata: "GHC",
    name: "Great Harbour Airport",
    city: "Great Harbour",
    countryId: "BS",
    timeZoneRegionName: "America/Nassau",
    latitude: 25.738056,
    longitude: -77.840278,
    icao: "MYBG"
  },
  GHF: {
    iata: "GHF",
    name: "Giebelstadt Airport",
    city: "Giebelstadt",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 49.65,
    longitude: 9.966667,
    icao: "ETEU"
  },
  GHK: {
    iata: "GHK",
    name: "Gush Katif Airport",
    city: "Gush Katif",
    countryId: "IL",
    timeZoneRegionName: "Asia/Jerusalem",
    latitude: 31.36705,
    longitude: 34.29451,
    icao: "LLAZ"
  },
  GHM: {
    iata: "GHM",
    name: "Centerville Municipal Airport",
    city: "Centerville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.836367,
    longitude: -87.444471,
    icao: "KGHM"
  },
  GHS: {
    iata: "GHS",
    name: "Melalan Airport",
    city: "West Kutai",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -0.203889,
    longitude: 115.759722,
    icao: "WALE"
  },
  GHT: {
    iata: "GHT",
    name: "Ghat Airport",
    city: "Ghat",
    countryId: "LY",
    timeZoneRegionName: "Africa/Tripoli",
    latitude: 25.135068,
    longitude: 10.147592,
    icao: "HLGT"
  },
  GHU: {
    iata: "GHU",
    name: "Gualeguaychu Airport",
    city: "Gualeguaychu",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -33.004167,
    longitude: -58.612222,
    icao: "SAAG"
  },
  GHV: {
    iata: "GHV",
    name: "Brasov-Ghimbav International Airport",
    city: "Ghimbav",
    countryId: "RO",
    timeZoneRegionName: "Europe/Bucharest",
    latitude: 45.701667,
    longitude: 25.52,
    icao: "LRBV"
  },
  GIB: {
    iata: "GIB",
    name: "North Front Airport",
    city: "Gibraltar",
    countryId: "GI",
    timeZoneRegionName: "Europe/Gibraltar",
    latitude: 36.153763,
    longitude: -5.349271,
    icao: "LXGB"
  },
  GIC: {
    iata: "GIC",
    name: "Boigu Island Airport",
    city: "Boigu Island",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -9.232806,
    longitude: 142.218009,
    icao: "YBOI"
  },
  GID: {
    iata: "GID",
    name: "Gitega Airport",
    city: "Gitega",
    countryId: "BI",
    timeZoneRegionName: "Africa/Bujumbura",
    latitude: -3.416667,
    longitude: 29.916667,
    icao: "HBBE"
  },
  GIF: {
    iata: "GIF",
    name: "Gilbert Field Airport",
    city: "Winter Haven",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 28.066667,
    longitude: -81.75,
    icao: "KGIF"
  },
  GIG: {
    iata: "GIG",
    name: "Galeao Antonio Carlos Jobim International Airport",
    city: "Rio De Janeiro",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -22.814654,
    longitude: -43.24651,
    icao: "SBGL"
  },
  GII: {
    iata: "GII",
    name: "Siguiri Airport",
    city: "Siguiri",
    countryId: "GN",
    timeZoneRegionName: "Africa/Conakry",
    latitude: 11.516667,
    longitude: -9.166667,
    icao: "GUSI"
  },
  GIL: {
    iata: "GIL",
    name: "Gilgit Airport",
    city: "Gilgit",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 35.919721,
    longitude: 74.33224,
    icao: "OPGT"
  },
  GIR: {
    iata: "GIR",
    name: "Girardot Airport",
    city: "Girardot",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 4.3,
    longitude: -74.8,
    icao: "SKGI"
  },
  GIS: {
    iata: "GIS",
    name: "Gisborne Airport",
    city: "Gisborne",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -38.661935,
    longitude: 177.982283,
    icao: "NZGS"
  },
  GIU: {
    iata: "GIU",
    name: "Sigiriya Slaf Base",
    city: "Sigiriya",
    countryId: "LK",
    timeZoneRegionName: "Asia/Colombo",
    latitude: 7.955185,
    longitude: 80.728912,
    icao: "VCCS"
  },
  GIZ: {
    iata: "GIZ",
    name: "Jazan Regional Airport",
    city: "Jazan",
    countryId: "SA",
    timeZoneRegionName: "Asia/Riyadh",
    latitude: 16.898949,
    longitude: 42.582344,
    icao: "OEGN"
  },
  GJA: {
    iata: "GJA",
    name: "Guanaja Airport",
    city: "Guanaja",
    countryId: "HN",
    timeZoneRegionName: "America/Tegucigalpa",
    latitude: 16.445,
    longitude: -85.905833,
    icao: "MHNJ"
  },
  GJL: {
    iata: "GJL",
    name: "Jijel Ferhat Abbas Airport",
    city: "Jijel",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 36.793625,
    longitude: 5.8763,
    icao: "DAAV"
  },
  GJM: {
    iata: "GJM",
    name: "Guajara-Mirim Airport",
    city: "Guajara-Mirim",
    countryId: "BR",
    timeZoneRegionName: "America/Porto_Velho",
    latitude: -10.7864,
    longitude: -65.284798,
    icao: "SBGM"
  },
  GJR: {
    iata: "GJR",
    name: "Gjogur Airport",
    city: "Gjogur",
    countryId: "IS",
    timeZoneRegionName: "Atlantic/Reykjavik",
    latitude: 65.983333,
    longitude: -21.35,
    icao: "BIGJ"
  },
  GJT: {
    iata: "GJT",
    name: "Grand Junction Regional Airport",
    city: "Grand Junction",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 39.122666,
    longitude: -108.528333,
    icao: "KGJT"
  },
  GKA: {
    iata: "GKA",
    name: "Goroka Airport",
    city: "Goroka",
    countryId: "PG",
    timeZoneRegionName: "Pacific/Port_Moresby",
    latitude: -6.075244,
    longitude: 145.392933,
    icao: "AYGA"
  },
  GKE: {
    iata: "GKE",
    name: "Geilenkirchen Air Base",
    city: "Geilenkirchen",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 50.960694,
    longitude: 6.042508,
    icao: "ETNG"
  },
  GKH: {
    iata: "GKH",
    name: "Gorkha Airport",
    city: "Gorkha",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 28,
    longitude: 84.675,
    icao: "VNGK"
  },
  GKK: {
    iata: "GKK",
    name: "Kooddoo Island Airport",
    city: "Kooddoo Island",
    countryId: "MV",
    timeZoneRegionName: "Indian/Maldives",
    latitude: 0.730833,
    longitude: 73.43305,
    icao: "VRMO"
  },
  GKN: {
    iata: "GKN",
    name: "Gulkana Airport",
    city: "Gulkana",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 62.155278,
    longitude: -145.452222,
    icao: "PAGK"
  },
  GKT: {
    iata: "GKT",
    name: "Gatlinburg Airport",
    city: "Gatlinburg",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 35.851389,
    longitude: -83.518611,
    icao: "KGKT"
  },
  GLA: {
    iata: "GLA",
    name: "Glasgow International Airport",
    city: "Glasgow",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 55.864213,
    longitude: -4.431782,
    icao: "EGPF"
  },
  GLD: {
    iata: "GLD",
    name: "Goodland Municipal Airport",
    city: "Goodland",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 39.370278,
    longitude: -101.699444,
    icao: "KGLD"
  },
  GLE: {
    iata: "GLE",
    name: "Gainesville Municipal Airport",
    city: "Gainesville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 33.633333,
    longitude: -97.133333,
    icao: "KGLE"
  },
  GLF: {
    iata: "GLF",
    name: "Golfito Airport",
    city: "Golfito",
    countryId: "CR",
    timeZoneRegionName: "America/Costa_Rica",
    latitude: 8.65409,
    longitude: -83.182097,
    icao: "MRGF"
  },
  GLH: {
    iata: "GLH",
    name: "Greenville Airport",
    city: "Greenville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 33.484444,
    longitude: -90.985,
    icao: "KGLH"
  },
  GLI: {
    iata: "GLI",
    name: "Glen Innes Airport",
    city: "Glen Innes",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -29.676667,
    longitude: 151.690833,
    icao: "YGLI"
  },
  GLK: {
    iata: "GLK",
    name: "Galcaio Airport",
    city: "Galcaio",
    countryId: "SO",
    timeZoneRegionName: "Africa/Mogadishu",
    latitude: 6.766667,
    longitude: 47.433333,
    icao: "HCMR"
  },
  GLN: {
    iata: "GLN",
    name: "Guelmim Airport",
    city: "Goulimime",
    countryId: "MA",
    timeZoneRegionName: "Africa/Casablanca",
    latitude: 29.016667,
    longitude: -10.066667,
    icao: "GMAG"
  },
  GLO: {
    iata: "GLO",
    name: "Gloucestershire Airport",
    city: "Gloucester",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.894228,
    longitude: -2.16576,
    icao: "EGBJ"
  },
  GLR: {
    iata: "GLR",
    name: "Gaylord Regional Airport",
    city: "Gaylord",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 45.014539,
    longitude: -84.701407,
    icao: "KGLR"
  },
  GLS: {
    iata: "GLS",
    name: "Scholes Field",
    city: "Galveston",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 29.2675,
    longitude: -94.860278,
    icao: "KGLS"
  },
  GLT: {
    iata: "GLT",
    name: "Gladstone Airport",
    city: "Gladstone",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -23.871469,
    longitude: 151.223506,
    icao: "YGLA"
  },
  GLU: {
    iata: "GLU",
    name: "Gelephu Airport",
    city: "Gelephu",
    countryId: "BT",
    timeZoneRegionName: "Asia/Thimphu",
    latitude: 26.883481,
    longitude: 90.465966,
    icao: "VQGP"
  },
  GLV: {
    iata: "GLV",
    name: "Golovin Airport",
    city: "Golovin",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 64.550458,
    longitude: -163.007169,
    icao: "PAGL"
  },
  GLW: {
    iata: "GLW",
    name: "Glasgow Municipal Airport",
    city: "Glasgow",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 37,
    longitude: -85.916667,
    icao: "KGLW"
  },
  GLX: {
    iata: "GLX",
    name: "Gamar Malamo Airport",
    city: "Galela",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jayapura",
    latitude: 1.837815,
    longitude: 127.787217,
    icao: "WAMA"
  },
  GLZ: {
    iata: "GLZ",
    name: "Gilze-Rijen Air Base",
    city: "Breda",
    countryId: "NL",
    timeZoneRegionName: "Europe/Amsterdam",
    latitude: 51.567263,
    longitude: 4.932732,
    icao: "EHGR"
  },
  GMA: {
    iata: "GMA",
    name: "Gemena Airport",
    city: "Gemena",
    countryId: "CD",
    timeZoneRegionName: "Africa/Kinshasa",
    latitude: 3.235278,
    longitude: 19.771111,
    icao: "FZFK"
  },
  GMB: {
    iata: "GMB",
    name: "Gambela Airport",
    city: "Gambela",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 8.283333,
    longitude: 34.583333,
    icao: "HAGM"
  },
  GME: {
    iata: "GME",
    name: "Gomel Airport",
    city: "Gomel",
    countryId: "BY",
    timeZoneRegionName: "Europe/Minsk",
    latitude: 52.526073,
    longitude: 31.017895,
    icao: "UMGG"
  },
  GMN: {
    iata: "GMN",
    name: "Greymouth Airport",
    city: "Greymouth",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -42.45,
    longitude: 171.2,
    icao: "NZGM"
  },
  GMO: {
    iata: "GMO",
    name: "Gombe Lawanti International Airport",
    city: "Gombe",
    countryId: "NG",
    timeZoneRegionName: "Africa/Lagos",
    latitude: 10.298056,
    longitude: 10.898889,
    icao: "DNGO"
  },
  GMP: {
    iata: "GMP",
    name: "Gimpo International Airport",
    city: "Seoul",
    countryId: "KR",
    timeZoneRegionName: "Asia/Seoul",
    latitude: 37.559287,
    longitude: 126.803512,
    icao: "RKSS"
  },
  GMQ: {
    iata: "GMQ",
    name: "Golog Maqin Airport",
    city: "Golog",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 34.415833,
    longitude: 100.311111,
    icao: ""
  },
  GMR: {
    iata: "GMR",
    name: "Gambier Island Airport",
    city: "Gambier Island",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Gambier",
    latitude: -23.083999,
    longitude: -134.887575,
    icao: "NTGJ"
  },
  GMS: {
    iata: "GMS",
    name: "Guimaraes Airport",
    city: "Guimaraes",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -2.15,
    longitude: -44.7,
    icao: "SNGM"
  },
  GMU: {
    iata: "GMU",
    name: "Greenville Downtown Airport",
    city: "Greenville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 34.85,
    longitude: -82.383333,
    icao: "KGMU"
  },
  GMZ: {
    iata: "GMZ",
    name: "La Gomera Airport",
    city: "San Sebastian de la Gomera",
    countryId: "ES",
    timeZoneRegionName: "Atlantic/Canary",
    latitude: 28.016667,
    longitude: -17.2,
    icao: "GCGM"
  },
  GNA: {
    iata: "GNA",
    name: "Grodno Airport",
    city: "Grodno",
    countryId: "BY",
    timeZoneRegionName: "Europe/Minsk",
    latitude: 53.605799,
    longitude: 24.053906,
    icao: "UMMG"
  },
  GNB: {
    iata: "GNB",
    name: "Grenoble-Isere Airport",
    city: "Grenoble",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 45.359832,
    longitude: 5.332019,
    icao: "LFLS"
  },
  GND: {
    iata: "GND",
    name: "Maurice Bishop International Airport",
    city: "St. George's",
    countryId: "GD",
    timeZoneRegionName: "America/Grenada",
    latitude: 12.004167,
    longitude: -61.786111,
    icao: "TGPY"
  },
  GNG: {
    iata: "GNG",
    name: "Gooding Airport",
    city: "Gooding",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 42.933333,
    longitude: -114.716667,
    icao: "KGNG"
  },
  GNJ: {
    iata: "GNJ",
    name: "Ganja International Airport",
    city: "Gyandzha",
    countryId: "AZ",
    timeZoneRegionName: "Asia/Baku",
    latitude: 40.733333,
    longitude: 46.316667,
    icao: "UBBG"
  },
  GNM: {
    iata: "GNM",
    name: "Guanambi Airport",
    city: "Guanambi",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -14.2082,
    longitude: -42.746101,
    icao: "SNGI"
  },
  GNN: {
    iata: "GNN",
    name: "Ghinnir Airport",
    city: "Ghinnir",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 7.15,
    longitude: 40.716667,
    icao: "HAGH"
  },
  GNR: {
    iata: "GNR",
    name: "General Roca Airport",
    city: "General Roca",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -39.001659,
    longitude: -67.616068,
    icao: "SAHR"
  },
  GNS: {
    iata: "GNS",
    name: "Gunung Sitoli Binaka Airport",
    city: "Gunungsitoli",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: 1.25,
    longitude: 97.5,
    icao: "WIMB"
  },
  GNT: {
    iata: "GNT",
    name: "Milan Airport",
    city: "Grants",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 35.15,
    longitude: -107.866667,
    icao: "KGNT"
  },
  GNV: {
    iata: "GNV",
    name: "Gainesville Regional Airport",
    city: "Gainesville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 29.686142,
    longitude: -82.276797,
    icao: "KGNV"
  },
  GNY: {
    iata: "GNY",
    name: "Sanliurfa GAP Airport",
    city: "Golgen",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 37.44747,
    longitude: 38.900313,
    icao: "LTCS"
  },
  GNZ: {
    iata: "GNZ",
    name: "Ghanzi Airport",
    city: "Ghanzi",
    countryId: "BW",
    timeZoneRegionName: "Africa/Gaborone",
    latitude: -21.7,
    longitude: 21.666667,
    icao: "FBGZ"
  },
  GOA: {
    iata: "GOA",
    name: "Genoa Cristoforo Colombo Airport",
    city: "Genoa",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 44.415066,
    longitude: 8.85081,
    icao: "LIMJ"
  },
  GOB: {
    iata: "GOB",
    name: "Robe Airport",
    city: "Goba",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 7.117977,
    longitude: 40.044148,
    icao: "HAGB"
  },
  GOG: {
    iata: "GOG",
    name: "Gobabis Airport",
    city: "Gobabis",
    countryId: "NA",
    timeZoneRegionName: "Africa/Windhoek",
    latitude: -22.504722,
    longitude: 18.974722,
    icao: "FYGB"
  },
  GOH: {
    iata: "GOH",
    name: "Nuuk Airport",
    city: "Nuuk",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 64.181944,
    longitude: -51.725,
    icao: "BGGH"
  },
  GOI: {
    iata: "GOI",
    name: "Dabolim Airport",
    city: "Goa",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 15.384534,
    longitude: 73.839825,
    icao: "VOGO"
  },
  GOJ: {
    iata: "GOJ",
    name: "Nizhny Novgorod International Airport",
    city: "Nizhniy Novgorod",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 56.218611,
    longitude: 43.789766,
    icao: "UWGG"
  },
  GOK: {
    iata: "GOK",
    name: "Guthrie Airport",
    city: "Guthrie",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.883333,
    longitude: -97.416667,
    icao: "KGOK"
  },
  GOM: {
    iata: "GOM",
    name: "Goma Airport",
    city: "Goma",
    countryId: "CD",
    timeZoneRegionName: "Africa/Lubumbashi",
    latitude: -1.669921,
    longitude: 29.238349,
    icao: "FZNA"
  },
  GON: {
    iata: "GON",
    name: "Groton-New London Airport",
    city: "New London",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.328889,
    longitude: -72.046389,
    icao: "KGON"
  },
  GOO: {
    iata: "GOO",
    name: "Goondiwindi Airport",
    city: "Goondiwindi",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -28.524444,
    longitude: 150.319444,
    icao: "YGDI"
  },
  GOP: {
    iata: "GOP",
    name: "Gorakhpur Airport",
    city: "Gorakhpur",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 26.746862,
    longitude: 83.443762,
    icao: "VEGK"
  },
  GOQ: {
    iata: "GOQ",
    name: "Golmud Airport",
    city: "Golmud",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 36.404633,
    longitude: 94.789305,
    icao: "ZLGM"
  },
  GOR: {
    iata: "GOR",
    name: "Gore Airport",
    city: "Gore",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 8.155556,
    longitude: 35.538056,
    icao: "HAGR"
  },
  GOT: {
    iata: "GOT",
    name: "Goteborg Landvetter Airport",
    city: "Gothenburg",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 57.666643,
    longitude: 12.294878,
    icao: "ESGG"
  },
  GOU: {
    iata: "GOU",
    name: "Garoua Airport",
    city: "Garoua",
    countryId: "CM",
    timeZoneRegionName: "Africa/Douala",
    latitude: 9.336111,
    longitude: 13.375556,
    icao: "FKKR"
  },
  GOV: {
    iata: "GOV",
    name: "Nhulunbuy Airport",
    city: "Gove",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -12.269595,
    longitude: 136.822653,
    icao: "YPGV"
  },
  GOX: {
    iata: "GOX",
    name: "Manohar International Airport",
    city: "Mopa",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 15.7322,
    longitude: 73.868,
    icao: "VOGA"
  },
  GOY: {
    iata: "GOY",
    name: "Tura Airport",
    city: "Tura",
    countryId: "RU",
    timeZoneRegionName: "Asia/Krasnoyarsk",
    latitude: 64.333333,
    longitude: 100.433333,
    icao: "UNIT"
  },
  GPA: {
    iata: "GPA",
    name: "Araxos Airport",
    city: "Patras",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 38.1511,
    longitude: 21.4256,
    icao: "LGRX"
  },
  GPB: {
    iata: "GPB",
    name: "Tancredo Thomaz Faria Airport",
    city: "Guarapuava",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -25.333333,
    longitude: -51.5,
    icao: "SSUW"
  },
  GPD: {
    iata: "GPD",
    name: "Mount Gordon Mine Airport",
    city: "Mount Gordon",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -19.999445,
    longitude: 139.91777,
    icao: "YGON"
  },
  GPI: {
    iata: "GPI",
    name: "Juan Casiano Airport",
    city: "Guapi",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 2.569998,
    longitude: -77.898022,
    icao: "SKGP"
  },
  GPL: {
    iata: "GPL",
    name: "Guapiles Airport",
    city: "Guapiles",
    countryId: "CR",
    timeZoneRegionName: "America/Costa_Rica",
    latitude: 10.2,
    longitude: -83.8,
    icao: "MRGP"
  },
  GPN: {
    iata: "GPN",
    name: "Garden Point Airport",
    city: "Garden Point",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -11.766667,
    longitude: 130.016667,
    icao: "YGPT"
  },
  GPO: {
    iata: "GPO",
    name: "General Pico Airport",
    city: "General Pico",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -35.633333,
    longitude: -63.766667,
    icao: "SAZG"
  },
  GPS: {
    iata: "GPS",
    name: "Baltra Airport",
    city: "Galapagos Islands",
    countryId: "EC",
    timeZoneRegionName: "Pacific/Galapagos",
    latitude: -0.434722,
    longitude: -90.282778,
    icao: "SEGS"
  },
  GPT: {
    iata: "GPT",
    name: "Gulfport-Biloxi International Airport",
    city: "Gulfport",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.413284,
    longitude: -89.072029,
    icao: "KGPT"
  },
  GPZ: {
    iata: "GPZ",
    name: "Grand Rapids - Itsaca County Airport",
    city: "Grand Rapids",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 47.214444,
    longitude: -93.511111,
    icao: "KGPZ"
  },
  GQQ: {
    iata: "GQQ",
    name: "Galion Airport",
    city: "Galion",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.736667,
    longitude: -82.757222,
    icao: "KGQQ"
  },
  GRB: {
    iata: "GRB",
    name: "Austin Straubel International Airport",
    city: "Green Bay",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 44.492848,
    longitude: -88.121896,
    icao: "KGRB"
  },
  GRD: {
    iata: "GRD",
    name: "Greenwood County Airport",
    city: "Greenwood",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 34.248713,
    longitude: -82.159153,
    icao: "KGRD"
  },
  GRE: {
    iata: "GRE",
    name: "Greenville Municipal Airport",
    city: "Greenville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 38.842235,
    longitude: -89.364941,
    icao: "KGRE"
  },
  GRF: {
    iata: "GRF",
    name: "Gray Army Air Field",
    city: "Tacoma",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 47.079226,
    longitude: -122.58081,
    icao: "KGRF"
  },
  GRI: {
    iata: "GRI",
    name: "Grand Island Airport",
    city: "Grand Island",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 40.967222,
    longitude: -98.306667,
    icao: "KGRI"
  },
  GRJ: {
    iata: "GRJ",
    name: "George Airport",
    city: "George",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -34.00148,
    longitude: 22.382235,
    icao: "FAGG"
  },
  GRK: {
    iata: "GRK",
    name: "Robert Gray Army Airfield",
    city: "Killeen",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 31.061821,
    longitude: -97.820914,
    icao: "KGRK"
  },
  GRM: {
    iata: "GRM",
    name: "Devils Track Airport",
    city: "Grand Marais",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 47.838387,
    longitude: -90.38329,
    icao: "KCKC"
  },
  GRN: {
    iata: "GRN",
    name: "Gordon Airport",
    city: "Gordon",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 42.802229,
    longitude: -102.178694,
    icao: "KGRN"
  },
  GRO: {
    iata: "GRO",
    name: "Girona-Costa Brava Airport",
    city: "Girona",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 41.898041,
    longitude: 2.766383,
    icao: "LEGE"
  },
  GRP: {
    iata: "GRP",
    name: "Gurupi Airport",
    city: "Gurupi",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -11.666667,
    longitude: -49.216667,
    icao: "SWGI"
  },
  GRQ: {
    iata: "GRQ",
    name: "Eelde Airport",
    city: "Groningen",
    countryId: "NL",
    timeZoneRegionName: "Europe/Amsterdam",
    latitude: 53.120278,
    longitude: 6.575556,
    icao: "EHGG"
  },
  GRR: {
    iata: "GRR",
    name: "Gerald R. Ford International Airport",
    city: "Grand Rapids",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.885009,
    longitude: -85.529738,
    icao: "KGRR"
  },
  GRS: {
    iata: "GRS",
    name: "Corrado Baccarini Airport",
    city: "Grosseto",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 42.761944,
    longitude: 11.070556,
    icao: "LIRS"
  },
  GRU: {
    iata: "GRU",
    name: "Sao Paulo-Guarulhos International Airport",
    city: "Sao Paulo",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -23.425668,
    longitude: -46.481926,
    icao: "SBGR"
  },
  GRV: {
    iata: "GRV",
    name: "Grozny Airport",
    city: "Grozny",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 43.3882,
    longitude: 45.699683,
    icao: "URMG"
  },
  GRW: {
    iata: "GRW",
    name: "Graciosa Island Airport",
    city: "Graciosa Island (Azores)",
    countryId: "PT",
    timeZoneRegionName: "Atlantic/Azores",
    latitude: 39.090954,
    longitude: -28.027958,
    icao: "LPGR"
  },
  GRX: {
    iata: "GRX",
    name: "Granada Airport",
    city: "Granada",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 37.184728,
    longitude: -3.776954,
    icao: "LEGR"
  },
  GRY: {
    iata: "GRY",
    name: "Grimsey Airport",
    city: "Grimsey",
    countryId: "IS",
    timeZoneRegionName: "Atlantic/Reykjavik",
    latitude: 66.54799,
    longitude: -18.020378,
    icao: "BIGR"
  },
  GRZ: {
    iata: "GRZ",
    name: "Graz Airport",
    city: "Graz",
    countryId: "AT",
    timeZoneRegionName: "Europe/Vienna",
    latitude: 46.996157,
    longitude: 15.443228,
    icao: "LOWG"
  },
  GSB: {
    iata: "GSB",
    name: "Seymour Johnson Air Force Base",
    city: "Goldsboro",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 35.339393,
    longitude: -77.960579,
    icao: "KGSB"
  },
  GSE: {
    iata: "GSE",
    name: "Goteborg City Airport",
    city: "Gothenburg",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 57.774715,
    longitude: 11.870377,
    icao: "ESGP"
  },
  GSH: {
    iata: "GSH",
    name: "Goshen Municipal Airport",
    city: "Goshen",
    countryId: "US",
    timeZoneRegionName: "America/Indiana/Indianapolis",
    latitude: 41.526402,
    longitude: -85.7929,
    icao: "KGSH"
  },
  GSI: {
    iata: "GSI",
    name: "Grand-Santi Airport",
    city: "Grand-Santi",
    countryId: "GF",
    timeZoneRegionName: "America/Cayenne",
    latitude: 4.283889,
    longitude: -54.380556,
    icao: "SOGS"
  },
  GSJ: {
    iata: "GSJ",
    name: "Puerto San Jose Airport",
    city: "Puerto San Jose",
    countryId: "GT",
    timeZoneRegionName: "America/Guatemala",
    latitude: 13.93622,
    longitude: -90.835896,
    icao: "MGSJ"
  },
  GSL: {
    iata: "GSL",
    name: "Taltheilei Narrows Airport",
    city: "Taltheilei Narrows",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 62.5975,
    longitude: -111.544444,
    icao: "CFA7"
  },
  GSM: {
    iata: "GSM",
    name: "Dayrestan Airport",
    city: "Qeshm Island",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 26.757778,
    longitude: 55.905278,
    icao: "OIKQ"
  },
  GSO: {
    iata: "GSO",
    name: "Piedmont Triad International Airport",
    city: "Greensboro/High Point",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 36.105324,
    longitude: -79.937304,
    icao: "KGSO"
  },
  GSP: {
    iata: "GSP",
    name: "Greenville-Spartanburg International Airport",
    city: "Greenville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 34.890569,
    longitude: -82.217053,
    icao: "KGSP"
  },
  GSQ: {
    iata: "GSQ",
    name: "Shark Elowainat Airport",
    city: "Shark Elowainat",
    countryId: "EG",
    timeZoneRegionName: "Africa/Cairo",
    latitude: 22.583333,
    longitude: 28.716667,
    icao: "HEOW"
  },
  GSR: {
    iata: "GSR",
    name: "Gardo Airport",
    city: "Gardo",
    countryId: "SO",
    timeZoneRegionName: "Africa/Mogadishu",
    latitude: 9.5,
    longitude: 49.05,
    icao: "HCMG"
  },
  GSS: {
    iata: "GSS",
    name: "Sabi Sabi Airport",
    city: "Sabi Sabi",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -24.947375,
    longitude: 31.448848,
    icao: "FASE"
  },
  GST: {
    iata: "GST",
    name: "Gustavus Airport",
    city: "Gustavus",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 58.423275,
    longitude: -135.703687,
    icao: "PAGS"
  },
  GSU: {
    iata: "GSU",
    name: "Gedaref Airport",
    city: "Gedaref",
    countryId: "SD",
    timeZoneRegionName: "Africa/Khartoum",
    latitude: 14.033333,
    longitude: 35.466667,
    icao: "HSGF"
  },
  GSV: {
    iata: "GSV",
    name: "Saratov Gagarin International Airport",
    city: "Saratov",
    countryId: "RU",
    timeZoneRegionName: "Europe/Saratov",
    latitude: 51.712726,
    longitude: 46.170238,
    icao: "UWSG"
  },
  GTE: {
    iata: "GTE",
    name: "Alyangula Airport",
    city: "Groote Island",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -13.973887,
    longitude: 136.460016,
    icao: "YGTE"
  },
  GTF: {
    iata: "GTF",
    name: "Great Falls International Airport",
    city: "Great Falls",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 47.481889,
    longitude: -111.35636,
    icao: "KGTF"
  },
  GTG: {
    iata: "GTG",
    name: "Grantsburg Municipal Airport",
    city: "Grantsburg",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 45.783333,
    longitude: -92.683333,
    icao: "KGTG"
  },
  GTI: {
    iata: "GTI",
    name: "Rugen Airport",
    city: "Dreschvitz",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 54.384003,
    longitude: 13.325393,
    icao: "EDCG"
  },
  GTN: {
    iata: "GTN",
    name: "Glentanner Airport",
    city: "Mount Cook",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -43.908771,
    longitude: 170.129387,
    icao: "NZGT"
  },
  GTO: {
    iata: "GTO",
    name: "Tolotio Airport",
    city: "Gorontalo",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: 0.639039,
    longitude: 122.850876,
    icao: "WAMG"
  },
  GTR: {
    iata: "GTR",
    name: "Golden Triangle Regional Airport",
    city: "Columbus",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 33.45,
    longitude: -88.6,
    icao: "KGTR"
  },
  GTT: {
    iata: "GTT",
    name: "Georgetown Airport",
    city: "Georgetown",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -18.416667,
    longitude: 143.783333,
    icao: "YGTN"
  },
  GTW: {
    iata: "GTW",
    name: "Holesov Airport",
    city: "Zlin",
    countryId: "CZ",
    timeZoneRegionName: "Europe/Prague",
    latitude: 49.2,
    longitude: 17.516667,
    icao: "LKHO"
  },
  GTZ: {
    iata: "GTZ",
    name: "Grumeti Kirawira B Airport",
    city: "Grumeti Game Reserve",
    countryId: "TZ",
    timeZoneRegionName: "Africa/Dar_es_Salaam",
    latitude: -2.160833,
    longitude: 34.225556,
    icao: ""
  },
  GUA: {
    iata: "GUA",
    name: "La Aurora International Airport",
    city: "Guatemala City",
    countryId: "GT",
    timeZoneRegionName: "America/Guatemala",
    latitude: 14.588071,
    longitude: -90.530679,
    icao: "MGGT"
  },
  GUB: {
    iata: "GUB",
    name: "Guerrero Negro Airport",
    city: "Guerrero Negro",
    countryId: "MX",
    timeZoneRegionName: "America/Mazatlan",
    latitude: 28.026022,
    longitude: -114.023947,
    icao: "MMGR"
  },
  GUC: {
    iata: "GUC",
    name: "Gunnison Airport",
    city: "Gunnison",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 38.533889,
    longitude: -106.938889,
    icao: "KGUC"
  },
  GUD: {
    iata: "GUD",
    name: "Goundam Airport",
    city: "Goundam",
    countryId: "ML",
    timeZoneRegionName: "Africa/Bamako",
    latitude: 16.3575,
    longitude: -3.609722,
    icao: "GAGM"
  },
  GUF: {
    iata: "GUF",
    name: "Jack Edwards Airport",
    city: "Gulf Shores",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.28962,
    longitude: -87.672884,
    icao: "KJKA"
  },
  GUH: {
    iata: "GUH",
    name: "Gunnedah Airport",
    city: "Gunnedah",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -30.95,
    longitude: 150.233333,
    icao: "YGDH"
  },
  GUI: {
    iata: "GUI",
    name: "Guiria Airport",
    city: "Guiria",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 10.566667,
    longitude: -62.3,
    icao: "SVGI"
  },
  GUJ: {
    iata: "GUJ",
    name: "Guaratingueta Airport",
    city: "Guaratingueta",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -22.816667,
    longitude: -45.216667,
    icao: "SBGW"
  },
  GUL: {
    iata: "GUL",
    name: "Goulburn Airport",
    city: "Goulburn",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -34.75,
    longitude: 149.716667,
    icao: "YGLB"
  },
  GUM: {
    iata: "GUM",
    name: "A.B. Won Pat International Airport",
    city: "Guam",
    countryId: "GU",
    timeZoneRegionName: "Pacific/Guam",
    latitude: 13.492787,
    longitude: 144.804849,
    icao: "PGUM"
  },
  GUP: {
    iata: "GUP",
    name: "Gallup Municipal Airport",
    city: "Gallup",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 35.511111,
    longitude: -108.786667,
    icao: "KGUP"
  },
  GUQ: {
    iata: "GUQ",
    name: "Guanare Airport",
    city: "Guanare",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 9.025278,
    longitude: -69.75,
    icao: "SVGU"
  },
  GUR: {
    iata: "GUR",
    name: "Gurney Airport",
    city: "Alotau",
    countryId: "PG",
    timeZoneRegionName: "Pacific/Port_Moresby",
    latitude: -10.310833,
    longitude: 150.338611,
    icao: "AYGN"
  },
  GUS: {
    iata: "GUS",
    name: "Grissom Air Force Base",
    city: "Peru",
    countryId: "US",
    timeZoneRegionName: "America/Indiana/Indianapolis",
    latitude: 40.75,
    longitude: -86.066667,
    icao: "KGUS"
  },
  GUW: {
    iata: "GUW",
    name: "Atyrau Airport",
    city: "Atyrau",
    countryId: "KZ",
    timeZoneRegionName: "Asia/Atyrau",
    latitude: 47.122815,
    longitude: 51.829554,
    icao: "UATG"
  },
  GUY: {
    iata: "GUY",
    name: "Guymon Municipal Airport",
    city: "Guymon",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.682778,
    longitude: -101.507778,
    icao: "KGUY"
  },
  GVA: {
    iata: "GVA",
    name: "Geneve Airport",
    city: "Geneva",
    countryId: "CH",
    timeZoneRegionName: "Europe/Zurich",
    latitude: 46.229634,
    longitude: 6.105774,
    icao: "LSGG"
  },
  GVE: {
    iata: "GVE",
    name: "Gordonsville Municipal Airport",
    city: "Gordonsville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 38.133333,
    longitude: -78.2,
    icao: "KGVE"
  },
  GVL: {
    iata: "GVL",
    name: "Lee Gilmer Memorial Airport",
    city: "Gainesville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 34.3,
    longitude: -83.833333,
    icao: "KGVL"
  },
  GVN: {
    iata: "GVN",
    name: "May-Gatka Airport",
    city: "Sovetskaya Gavan",
    countryId: "RU",
    timeZoneRegionName: "Asia/Vladivostok",
    latitude: 48.9253,
    longitude: 140.0367,
    icao: "UHKM"
  },
  GVR: {
    iata: "GVR",
    name: "Governador Valadares Airport",
    city: "Governador Valadares",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -18.850278,
    longitude: -41.933333,
    icao: "SNGV"
  },
  GVT: {
    iata: "GVT",
    name: "Majors Field",
    city: "Greenville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 33.066667,
    longitude: -96.061667,
    icao: "KGVT"
  },
  GVX: {
    iata: "GVX",
    name: "Gestrike Airport",
    city: "Gavle",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 60.593889,
    longitude: 16.954722,
    icao: "ESSK"
  },
  GWA: {
    iata: "GWA",
    name: "Gwa Airport",
    city: "Gwa",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 21,
    longitude: 94,
    icao: "VYGW"
  },
  GWD: {
    iata: "GWD",
    name: "Gwadar Airport",
    city: "Gwadar",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 25.230556,
    longitude: 62.338889,
    icao: "OPGD"
  },
  GWE: {
    iata: "GWE",
    name: "Gweru Airport",
    city: "Gweru",
    countryId: "ZW",
    timeZoneRegionName: "Africa/Harare",
    latitude: -19.435833,
    longitude: 29.861111,
    icao: "FVGW"
  },
  GWL: {
    iata: "GWL",
    name: "Gwalior Airport",
    city: "Gwalior",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 26.293889,
    longitude: 78.23,
    icao: "VIGR"
  },
  GWO: {
    iata: "GWO",
    name: "Leflore Airport",
    city: "Greenwood",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 33.495,
    longitude: -90.088889,
    icao: "KGWO"
  },
  GWS: {
    iata: "GWS",
    name: "Glenwood Springs Municipal",
    city: "Glenwood Springs",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 39.583167,
    longitude: -107.414417,
    icao: "KGWS"
  },
  GWT: {
    iata: "GWT",
    name: "Westerland - Sylt Airport",
    city: "Westerland",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 54.915278,
    longitude: 8.343056,
    icao: "EDXW"
  },
  GWY: {
    iata: "GWY",
    name: "Carnmore Airport",
    city: "Galway",
    countryId: "IE",
    timeZoneRegionName: "Europe/Dublin",
    latitude: 53.283333,
    longitude: -9.033333,
    icao: "EICM"
  },
  GXA: {
    iata: "GXA",
    name: "Beringin Airport",
    city: "Muara Teweh",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: -0.942778,
    longitude: 114.894444,
    icao: "WAOM"
  },
  GXF: {
    iata: "GXF",
    name: "Seiyun Airport",
    city: "Seiyun",
    countryId: "YE",
    timeZoneRegionName: "Asia/Aden",
    latitude: 15.961794,
    longitude: 48.787085,
    icao: "OYSY"
  },
  GXG: {
    iata: "GXG",
    name: "Negage Airport",
    city: "Negage",
    countryId: "AO",
    timeZoneRegionName: "Africa/Luanda",
    latitude: -7.783333,
    longitude: 15.45,
    icao: "FNNG"
  },
  GXH: {
    iata: "GXH",
    name: "Gannan Xiahe Airport",
    city: "Xiahe",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 34.810556,
    longitude: 102.644722,
    icao: ""
  },
  GXQ: {
    iata: "GXQ",
    name: "Ten. Vidal Airport",
    city: "Coyhaique",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -45.588889,
    longitude: -72.098611,
    icao: "SCCY"
  },
  GXY: {
    iata: "GXY",
    name: "Greeley-Weld County Airport",
    city: "Greeley",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 40.427756,
    longitude: -104.636865,
    icao: "KGXY"
  },
  GYA: {
    iata: "GYA",
    name: "Guayaramerin Airport",
    city: "Guayaramerin",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -10.83,
    longitude: -65.361667,
    icao: "SLGY"
  },
  GYD: {
    iata: "GYD",
    name: "Heydar Aliyev International Airport",
    city: "Baku",
    countryId: "AZ",
    timeZoneRegionName: "Asia/Baku",
    latitude: 40.462487,
    longitude: 50.05039,
    icao: "UBBB"
  },
  GYE: {
    iata: "GYE",
    name: "Jose Joaquin de Olmedo Airport",
    city: "Guayaquil",
    countryId: "EC",
    timeZoneRegionName: "America/Guayaquil",
    latitude: -2.142654,
    longitude: -79.880321,
    icao: "SEGU"
  },
  GYG: {
    iata: "GYG",
    name: "Magan Airport",
    city: "Magan",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yakutsk",
    latitude: 62.107222,
    longitude: 129.543333,
    icao: "UEMM"
  },
  GYI: {
    iata: "GYI",
    name: "Gisenyi Airport",
    city: "Gisenyi",
    countryId: "RW",
    timeZoneRegionName: "Africa/Kigali",
    latitude: -1.677985,
    longitude: 29.259062,
    icao: "HRYG"
  },
  GYL: {
    iata: "GYL",
    name: "Argyle Airport",
    city: "Argyle",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -16.638837,
    longitude: 128.449912,
    icao: "YARG"
  },
  GYM: {
    iata: "GYM",
    name: "Gen Jose Maria Yanez International Airport",
    city: "Guaymas",
    countryId: "MX",
    timeZoneRegionName: "America/Hermosillo",
    latitude: 27.969717,
    longitude: -110.92193,
    icao: "MMGM"
  },
  GYN: {
    iata: "GYN",
    name: "Santa Genoveva Airport",
    city: "Goiania",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -16.632631,
    longitude: -49.226624,
    icao: "SBGO"
  },
  GYP: {
    iata: "GYP",
    name: "Gympie Airport",
    city: "Gympie",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -26.282801,
    longitude: 152.701996,
    icao: "YGYM"
  },
  GYR: {
    iata: "GYR",
    name: "Phoenix Goodyear Airport",
    city: "Goodyear",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 33.426837,
    longitude: -112.367078,
    icao: "KGYR"
  },
  GYS: {
    iata: "GYS",
    name: "Panlong Airport",
    city: "Guangyuan",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 32.390572,
    longitude: 105.695681,
    icao: "ZUGU"
  },
  GYU: {
    iata: "GYU",
    name: "Guyuan Liupanshan Airport",
    city: "Guyuan",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 36.078889,
    longitude: 106.216944,
    icao: "ZLGY"
  },
  GZA: {
    iata: "GZA",
    name: "Yasser Arafat International Airport",
    city: "Gaza",
    countryId: "PS",
    timeZoneRegionName: "Asia/Gaza",
    latitude: 31.246389,
    longitude: 34.276111,
    icao: "LVGZ"
  },
  GZG: {
    iata: "GZG",
    name: "Ganzi Gesaer Airport",
    city: "Ganzi",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 31.755835,
    longitude: 99.556669,
    icao: ""
  },
  GZO: {
    iata: "GZO",
    name: "Nusatupe Airport",
    city: "Gizo",
    countryId: "SB",
    timeZoneRegionName: "Pacific/Guadalcanal",
    latitude: -8.097871,
    longitude: 156.863752,
    icao: "AGGN"
  },
  GZP: {
    iata: "GZP",
    name: "Gazipasa Airport",
    city: "Gazipasa",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 36.2993,
    longitude: 32.3014,
    icao: "LTFG"
  },
  GZT: {
    iata: "GZT",
    name: "Oguzeli International Airport",
    city: "Gaziantep",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 36.947182,
    longitude: 37.478682,
    icao: "LTAJ"
  },
  GZW: {
    iata: "GZW",
    name: "Ghazvin Airport",
    city: "Ghazvin",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 36.233333,
    longitude: 50.033333,
    icao: "OIIK"
  },
  HAA: {
    iata: "HAA",
    name: "Hasvik Airport",
    city: "Hasvik",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 70.466667,
    longitude: 22.15,
    icao: "ENHK"
  },
  HAB: {
    iata: "HAB",
    name: "Marion County Airport",
    city: "Hamilton",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 34.15,
    longitude: -88.1,
    icao: "KHAB"
  },
  HAC: {
    iata: "HAC",
    name: "Hachijo Jima Airport",
    city: "Hachijo Jima",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 33.117945,
    longitude: 139.781226,
    icao: "RJTH"
  },
  HAD: {
    iata: "HAD",
    name: "Halmstad Airport",
    city: "Halmstad",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 56.680936,
    longitude: 12.815005,
    icao: "ESMT"
  },
  HAF: {
    iata: "HAF",
    name: "Half Moon Airport",
    city: "Half Moon",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 37.513401,
    longitude: -122.500999,
    icao: "KHAF"
  },
  HAH: {
    iata: "HAH",
    name: "Prince Said Ibrahim Internatonal Airport",
    city: "Moroni",
    countryId: "KM",
    timeZoneRegionName: "Indian/Comoro",
    latitude: -11.535392,
    longitude: 43.273777,
    icao: "FMCH"
  },
  HAI: {
    iata: "HAI",
    name: "Dr. Haines Airport",
    city: "Three Rivers",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.95,
    longitude: -85.633333,
    icao: "KHAI"
  },
  HAJ: {
    iata: "HAJ",
    name: "Hannover Airport",
    city: "Hanover",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 52.459254,
    longitude: 9.694766,
    icao: "EDDV"
  },
  HAK: {
    iata: "HAK",
    name: "Haikou Meilan International Airport",
    city: "Haikou",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 19.934877,
    longitude: 110.45896,
    icao: "ZJHK"
  },
  HAM: {
    iata: "HAM",
    name: "Hamburg Airport",
    city: "Hamburg",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 53.631279,
    longitude: 10.006414,
    icao: "EDDH"
  },
  HAN: {
    iata: "HAN",
    name: "Noi Bai International Airport",
    city: "Hanoi",
    countryId: "VN",
    timeZoneRegionName: "Asia/Ho_Chi_Minh",
    latitude: 21.214184,
    longitude: 105.802827,
    icao: "VVNB"
  },
  HAO: {
    iata: "HAO",
    name: "Butler County Regional Airport",
    city: "Hamilton",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.363777,
    longitude: -84.521987,
    icao: "KHAO"
  },
  HAQ: {
    iata: "HAQ",
    name: "Hanimaadhoo Airport",
    city: "Hanimaadhoo",
    countryId: "MV",
    timeZoneRegionName: "Indian/Maldives",
    latitude: 6.748433,
    longitude: 73.168377,
    icao: "VRMH"
  },
  HAR: {
    iata: "HAR",
    name: "Harrisburg Capital City Airport",
    city: "Harrisburg",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.217089,
    longitude: -76.851483,
    icao: "KCXY"
  },
  HAS: {
    iata: "HAS",
    name: "Hail Airport",
    city: "Hail",
    countryId: "SA",
    timeZoneRegionName: "Asia/Riyadh",
    latitude: 27.438158,
    longitude: 41.690483,
    icao: "OEHL"
  },
  HAU: {
    iata: "HAU",
    name: "Haugesund Airport",
    city: "Haugesund",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 59.344763,
    longitude: 5.215903,
    icao: "ENHD"
  },
  HAV: {
    iata: "HAV",
    name: "Jose Marti International Airport",
    city: "Havana",
    countryId: "CU",
    timeZoneRegionName: "America/Havana",
    latitude: 22.998449,
    longitude: -82.408183,
    icao: "MUHA"
  },
  HAW: {
    iata: "HAW",
    name: "Haverfordwest Airport",
    city: "Haverfordwest",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.8,
    longitude: -4.966667,
    icao: "EGFE"
  },
  HAX: {
    iata: "HAX",
    name: "Hatbox Field",
    city: "Muskogee",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.75,
    longitude: -95.416667,
    icao: "KHAX"
  },
  HAY: {
    iata: "HAY",
    name: "Hacaritama Airport",
    city: "Aguachica",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 8.24556,
    longitude: -73.57861,
    icao: "SKAG"
  },
  HBA: {
    iata: "HBA",
    name: "Hobart International Airport",
    city: "Hobart",
    countryId: "AU",
    timeZoneRegionName: "Australia/Hobart",
    latitude: -42.837257,
    longitude: 147.505185,
    icao: "YMHB"
  },
  HBE: {
    iata: "HBE",
    name: "Borg El Arab Airport",
    city: "Alexandria",
    countryId: "EG",
    timeZoneRegionName: "Africa/Cairo",
    latitude: 30.932481,
    longitude: 29.696462,
    icao: "HEBA"
  },
  HBG: {
    iata: "HBG",
    name: "Bobby L. Chain Municipal Airport",
    city: "Hattiesburg",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 31.316667,
    longitude: -89.266667,
    icao: "KHBG"
  },
  HBQ: {
    iata: "HBQ",
    name: "Haibei Qilian Airport",
    city: "Qilian",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 38.008333,
    longitude: 100.640833,
    icao: ""
  },
  HBR: {
    iata: "HBR",
    name: "Hobart Airport",
    city: "Hobart",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.016667,
    longitude: -99.1,
    icao: "KHBR"
  },
  HBU: {
    iata: "HBU",
    name: "Bulgan Airport, Khovd",
    city: "Bulgan",
    countryId: "MN",
    timeZoneRegionName: "Asia/Ulaanbaatar",
    latitude: 46.102222,
    longitude: 91.58611,
    icao: "ZMBS"
  },
  HBX: {
    iata: "HBX",
    name: "Hubli Airport",
    city: "Hubli",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 15.359573,
    longitude: 75.086305,
    icao: "VOHB"
  },
  HCM: {
    iata: "HCM",
    name: "Eli Airport",
    city: "Eil",
    countryId: "SO",
    timeZoneRegionName: "Africa/Mogadishu",
    latitude: 7.916667,
    longitude: 49.8,
    icao: "HCME"
  },
  HCN: {
    iata: "HCN",
    name: "Hengchun Airport",
    city: "Hengchun",
    countryId: "TW",
    timeZoneRegionName: "Asia/Taipei",
    latitude: 21.039539,
    longitude: 120.733187,
    icao: "RCKW"
  },
  HCQ: {
    iata: "HCQ",
    name: "Halls Creek Airport",
    city: "Halls Creek",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -18.232109,
    longitude: 127.668606,
    icao: "YHLC"
  },
  HCR: {
    iata: "HCR",
    name: "Holy Cross Airport",
    city: "Holy Cross",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 62.190694,
    longitude: -159.773472,
    icao: "PAHC"
  },
  HCZ: {
    iata: "HCZ",
    name: "Chenzhou Beihu Airport",
    city: "Chenzhou",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 25.75333,
    longitude: 112.84444,
    icao: ""
  },
  HDB: {
    iata: "HDB",
    name: "Heidelberg Army Air Field",
    city: "Heidelberg",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 49.393346,
    longitude: 8.651943,
    icao: "ETIE"
  },
  HDD: {
    iata: "HDD",
    name: "Hyderabad Airport",
    city: "Hyderabad",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 25.322222,
    longitude: 68.363889,
    icao: "OPKD"
  },
  HDE: {
    iata: "HDE",
    name: "Brewster Field",
    city: "Holdrege",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 40.433333,
    longitude: -99.383333,
    icao: "KHDE"
  },
  HDF: {
    iata: "HDF",
    name: "Heringsdorf Airport",
    city: "Heringsdorf",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 53.878251,
    longitude: 14.138242,
    icao: "EDAH"
  },
  HDG: {
    iata: "HDG",
    name: "Handan Airport",
    city: "Handan",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 36.525833,
    longitude: 114.425,
    icao: "ZBHD"
  },
  HDH: {
    iata: "HDH",
    name: "Dillingham Airfield",
    city: "Oahu",
    countryId: "US",
    timeZoneRegionName: "Pacific/Honolulu",
    latitude: 21.577203,
    longitude: -158.191203,
    icao: "PHDH"
  },
  HDK: {
    iata: "HDK",
    name: "Kulhudhuffushi Airport",
    city: "Kulhudhuffushi",
    countryId: "MV",
    timeZoneRegionName: "Indian/Maldives",
    latitude: 6.630833,
    longitude: 73.068333,
    icao: ""
  },
  HDM: {
    iata: "HDM",
    name: "Hamadan Airport",
    city: "Hamadan",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 34.867146,
    longitude: 48.537318,
    icao: "OIHH"
  },
  HDN: {
    iata: "HDN",
    name: "Yampa Valley Airport",
    city: "Hayden",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 40.484808,
    longitude: -107.220766,
    icao: "KHDN"
  },
  HDO: {
    iata: "HDO",
    name: "Hindon Airport",
    city: "Ghaziabad",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 28.7077,
    longitude: 77.3589,
    icao: "VIDX"
  },
  HDS: {
    iata: "HDS",
    name: "Hoedspruit Air Force Base",
    city: "Hoedspruit",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -24.347221,
    longitude: 30.94583,
    icao: "FAHS"
  },
  HDY: {
    iata: "HDY",
    name: "Hat Yai International Airport",
    city: "Hat Yai",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 6.936764,
    longitude: 100.393566,
    icao: "VTSS"
  },
  HEA: {
    iata: "HEA",
    name: "Herat International Airport",
    city: "Herat",
    countryId: "AF",
    timeZoneRegionName: "Asia/Kabul",
    latitude: 34.212696,
    longitude: 62.22599,
    icao: "OAHR"
  },
  HEC: {
    iata: "HEC",
    name: "Helsinki Central Station",
    city: "Helsinki",
    countryId: "FI",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 60.171944,
    longitude: 24.941389,
    icao: ""
  },
  HEE: {
    iata: "HEE",
    name: "Thompson-Robbins Airport",
    city: "Helena",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 34.533333,
    longitude: -90.6,
    icao: "KHEE"
  },
  HEH: {
    iata: "HEH",
    name: "Heho Airport",
    city: "Heho",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 20.743863,
    longitude: 96.79341,
    icao: "VYHH"
  },
  HEI: {
    iata: "HEI",
    name: "Heide-Buesum Airport",
    city: "Heide-Buesum",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 54.155556,
    longitude: 8.902778,
    icao: "EDXB"
  },
  HEK: {
    iata: "HEK",
    name: "Heihe Aihui Airport",
    city: "Heihe",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 50.171662,
    longitude: 127.308905,
    icao: "ZYHE"
  },
  HEL: {
    iata: "HEL",
    name: "Helsinki-Vantaa Airport",
    city: "Helsinki",
    countryId: "FI",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 60.317953,
    longitude: 24.966449,
    icao: "EFHK"
  },
  HEM: {
    iata: "HEM",
    name: "Helsinki-Malmi Airport",
    city: "Helsinki",
    countryId: "FI",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 60.25,
    longitude: 25.05,
    icao: "EFHF"
  },
  HER: {
    iata: "HER",
    name: "Heraklion Airport",
    city: "Heraklion",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 35.33663,
    longitude: 25.174193,
    icao: "LGIR"
  },
  HES: {
    iata: "HES",
    name: "State Airport",
    city: "Hermiston",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 45.85,
    longitude: -119.283333,
    icao: "KHRI"
  },
  HET: {
    iata: "HET",
    name: "Hohhot Baita International Airport",
    city: "Hohhot",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 40.854712,
    longitude: 111.814157,
    icao: "ZBHH"
  },
  HEX: {
    iata: "HEX",
    name: "Herrera Airport",
    city: "Santo Domingo",
    countryId: "DO",
    timeZoneRegionName: "America/Santo_Domingo",
    latitude: 18.475,
    longitude: -69.975,
    icao: "MDHE"
  },
  HEZ: {
    iata: "HEZ",
    name: "Hardy-Anders Airport",
    city: "Natchez",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 31.614722,
    longitude: -91.296389,
    icao: "KHEZ"
  },
  HFA: {
    iata: "HFA",
    name: "Haifa Airport",
    city: "Haifa",
    countryId: "IL",
    timeZoneRegionName: "Asia/Jerusalem",
    latitude: 32.811465,
    longitude: 35.044593,
    icao: "LLHA"
  },
  HFD: {
    iata: "HFD",
    name: "Brainard Airport",
    city: "Hartford",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.733056,
    longitude: -72.65,
    icao: "KHFD"
  },
  HFE: {
    iata: "HFE",
    name: "Hefei Xinqiao Airport",
    city: "Hefei",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 31.992778,
    longitude: 116.973333,
    icao: "ZSOF"
  },
  HFF: {
    iata: "HFF",
    name: "Mackall Army Air Field",
    city: "Hoffman",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 35.03628,
    longitude: -79.497712,
    icao: "KHFF"
  },
  HFN: {
    iata: "HFN",
    name: "Hornafjordur Airport",
    city: "Hornafjordur",
    countryId: "IS",
    timeZoneRegionName: "Atlantic/Reykjavik",
    latitude: 64.283333,
    longitude: -15.266667,
    icao: "BIHN"
  },
  HFS: {
    iata: "HFS",
    name: "Hagfors Airport",
    city: "Hagfors",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 60.0175,
    longitude: 13.569167,
    icao: "ESOH"
  },
  HFT: {
    iata: "HFT",
    name: "Hammerfest Airport",
    city: "Hammerfest",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 70.679989,
    longitude: 23.675867,
    icao: "ENHF"
  },
  HGA: {
    iata: "HGA",
    name: "Hargeisa Airport",
    city: "Hargeisa",
    countryId: "SO",
    timeZoneRegionName: "Africa/Mogadishu",
    latitude: 9.515833,
    longitude: 44.091667,
    icao: "HCMH"
  },
  HGD: {
    iata: "HGD",
    name: "Hughenden Airport",
    city: "Hughenden",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -20.818889,
    longitude: 144.224444,
    icao: "YHUG"
  },
  HGE: {
    iata: "HGE",
    name: "Higuerote Airport",
    city: "Higuerote",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 10.463604,
    longitude: -66.095095,
    icao: "SVHG"
  },
  HGI: {
    iata: "HGI",
    name: "Hollongi Airport",
    city: "Itanagar",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 26.96639,
    longitude: 93.65083,
    icao: ""
  },
  HGH: {
    iata: "HGH",
    name: "Hangzhou Xiaoshan International Airport",
    city: "Hangzhou",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 30.236934,
    longitude: 120.432356,
    icao: "ZSHC"
  },
  HGL: {
    iata: "HGL",
    name: "Helgoland Airport",
    city: "Helgoland",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 54.186944,
    longitude: 7.916667,
    icao: "EDXH"
  },
  HGN: {
    iata: "HGN",
    name: "Mae Hong Son Airport",
    city: "Mae Hong Son",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 19.29968,
    longitude: 97.975227,
    icao: "VTCH"
  },
  HGO: {
    iata: "HGO",
    name: "Korhogo Airport",
    city: "Korhogo",
    countryId: "CI",
    timeZoneRegionName: "Africa/Abidjan",
    latitude: 9.389377,
    longitude: -5.554251,
    icao: "DIKO"
  },
  HGR: {
    iata: "HGR",
    name: "Wash. County Regional Airport",
    city: "Hagerstown",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.707778,
    longitude: -77.73,
    icao: "KHGR"
  },
  HGS: {
    iata: "HGS",
    name: "Hastings Airport",
    city: "Freetown",
    countryId: "SL",
    timeZoneRegionName: "Africa/Freetown",
    latitude: 8.393056,
    longitude: -13.13,
    icao: "GFHA"
  },
  HGU: {
    iata: "HGU",
    name: "Mount Hagen Airport",
    city: "Mount Hagen",
    countryId: "PG",
    timeZoneRegionName: "Pacific/Port_Moresby",
    latitude: -5.828767,
    longitude: 144.297376,
    icao: "AYMH"
  },
  HHE: {
    iata: "HHE",
    name: "Hachinohe Air Base",
    city: "Hachinohe",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 40.551947,
    longitude: 141.467219,
    icao: "RJSH"
  },
  HHH: {
    iata: "HHH",
    name: "Hilton Head Airport",
    city: "Hilton Head",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 32.22263,
    longitude: -80.697013,
    icao: "KHXD"
  },
  HHI: {
    iata: "HHI",
    name: "Wheeler Air Force Base",
    city: "Wahiawa",
    countryId: "US",
    timeZoneRegionName: "Pacific/Honolulu",
    latitude: 21.480308,
    longitude: -158.036409,
    icao: "PHHI"
  },
  HHN: {
    iata: "HHN",
    name: "Frankfurt - Hahn Airport",
    city: "Hahn",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 49.948333,
    longitude: 7.264167,
    icao: "EDFH"
  },
  HHQ: {
    iata: "HHQ",
    name: "Hua Hin Airport",
    city: "Hua Hin",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 12.636229,
    longitude: 99.951533,
    icao: "VTPH"
  },
  HHR: {
    iata: "HHR",
    name: "Hawthorne Municipal Airport",
    city: "Hawthorne",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 33.922007,
    longitude: -118.335229,
    icao: "KHHR"
  },
  HHZ: {
    iata: "HHZ",
    name: "Hikueru Airport",
    city: "Hikueru",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -17.533333,
    longitude: -142.533333,
    icao: ""
  },
  HIA: {
    iata: "HIA",
    name: "Huai'an Lianshui Airport",
    city: "Huai'an",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 33.7875,
    longitude: 119.12778,
    icao: "ZSSH"
  },
  HIB: {
    iata: "HIB",
    name: "Chisholm Airport",
    city: "Hibbing",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 47.388611,
    longitude: -92.838611,
    icao: "KHIB"
  },
  HID: {
    iata: "HID",
    name: "Horn Island Airport",
    city: "Horn Island",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -10.583333,
    longitude: 142.283333,
    icao: "YHID"
  },
  HIE: {
    iata: "HIE",
    name: "Mount Washington Regional Airport",
    city: "Whitefield",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 44.365833,
    longitude: -71.548611,
    icao: "KHIE"
  },
  HIF: {
    iata: "HIF",
    name: "Hill Air Force Base",
    city: "Ogden",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 41.123902,
    longitude: -111.973041,
    icao: "KHIF"
  },
  HII: {
    iata: "HII",
    name: "Lake Havasu City Municipal Airport",
    city: "Lake Havasu City",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 34.569693,
    longitude: -114.359729,
    icao: "KHII"
  },
  HIJ: {
    iata: "HIJ",
    name: "Hiroshima Airport",
    city: "Hiroshima",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 34.436111,
    longitude: 132.919444,
    icao: "RJOA"
  },
  HIN: {
    iata: "HIN",
    name: "Sacheon Airport",
    city: "Jinju",
    countryId: "KR",
    timeZoneRegionName: "Asia/Seoul",
    latitude: 35.092629,
    longitude: 128.086765,
    icao: "RKPS"
  },
  HIO: {
    iata: "HIO",
    name: "Portland Hillsboro Airport",
    city: "Hillsboro",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 45.516667,
    longitude: -122.983333,
    icao: "KHIO"
  },
  HIR: {
    iata: "HIR",
    name: "Honiara International Airport",
    city: "Honiara",
    countryId: "SB",
    timeZoneRegionName: "Pacific/Guadalcanal",
    latitude: -9.428592,
    longitude: 160.048182,
    icao: "AGGH"
  },
  HIS: {
    iata: "HIS",
    name: "Hayman Island Airport",
    city: "Hayman Island",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -20.066667,
    longitude: 148.866667,
    icao: "YHYN"
  },
  HIW: {
    iata: "HIW",
    name: "Hiroshima West Airport",
    city: "Hiroshima",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 34.363611,
    longitude: 132.416389,
    icao: "RJBH"
  },
  HJJ: {
    iata: "HJJ",
    name: "Zhijiang Airport",
    city: "Huaihua",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 27.441389,
    longitude: 109.699722,
    icao: "ZGCJ"
  },
  HJR: {
    iata: "HJR",
    name: "Khajuraho Airport",
    city: "Khajuraho",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 24.818746,
    longitude: 79.916417,
    icao: "VAKJ"
  },
  HKA: {
    iata: "HKA",
    name: "Blytheville Municipal Airport",
    city: "Blytheville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.933333,
    longitude: -89.916667,
    icao: "KHKA"
  },
  HKB: {
    iata: "HKB",
    name: "Healy Lake Airport",
    city: "Healy Lake",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 63.866667,
    longitude: -148.966667,
    icao: ""
  },
  HKD: {
    iata: "HKD",
    name: "Hakodate Airport",
    city: "Hakodate",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 41.776125,
    longitude: 140.815817,
    icao: "RJCH"
  },
  HKG: {
    iata: "HKG",
    name: "Hong Kong International Airport",
    city: "Hong Kong",
    countryId: "HK",
    timeZoneRegionName: "Asia/Hong_Kong",
    latitude: 22.315248,
    longitude: 113.93649,
    icao: "VHHH"
  },
  HKK: {
    iata: "HKK",
    name: "Hokitika Airport",
    city: "Hokitika",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -42.714914,
    longitude: 170.983462,
    icao: "NZHK"
  },
  HKN: {
    iata: "HKN",
    name: "Hoskins Airport",
    city: "Hoskins",
    countryId: "PG",
    timeZoneRegionName: "Pacific/Port_Moresby",
    latitude: -5.456876,
    longitude: 150.402996,
    icao: "AYHK"
  },
  HKR: {
    iata: "HKR",
    name: "Maasai Mara North Airstrip Airport",
    city: "Maasai Mara",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: -1.145556,
    longitude: 35.124722,
    icao: ""
  },
  HKS: {
    iata: "HKS",
    name: "Hawkins Field",
    city: "Jackson",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.333676,
    longitude: -90.222295,
    icao: "KHKS"
  },
  HKT: {
    iata: "HKT",
    name: "Phuket International Airport",
    city: "Phuket",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 8.107619,
    longitude: 98.306436,
    icao: "VTSP"
  },
  HKY: {
    iata: "HKY",
    name: "Hickory Airport",
    city: "Hickory",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 35.738611,
    longitude: -81.391667,
    icao: "KHKY"
  },
  HLA: {
    iata: "HLA",
    name: "Lanseria International Airport",
    city: "Lanseria",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -25.935917,
    longitude: 27.926212,
    icao: "FALA"
  },
  HLB: {
    iata: "HLB",
    name: "Hillenbrand Airport",
    city: "Batesville",
    countryId: "US",
    timeZoneRegionName: "America/Indiana/Indianapolis",
    latitude: 39.3,
    longitude: -85.216667,
    icao: "KHLB"
  },
  HLC: {
    iata: "HLC",
    name: "Hill City Airport",
    city: "Hill City",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 39.366667,
    longitude: -99.85,
    icao: "KHLC"
  },
  HLD: {
    iata: "HLD",
    name: "Hulunbuir Hailar Airport",
    city: "Hailar",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 49.209906,
    longitude: 119.818129,
    icao: "ZBLA"
  },
  HLE: {
    iata: "HLE",
    name: "Saint Helena Airport",
    city: "Jamestown",
    countryId: "SH",
    timeZoneRegionName: "Atlantic/St_Helena",
    latitude: -15.959167,
    longitude: -5.645833,
    icao: "FHSH"
  },
  HLF: {
    iata: "HLF",
    name: "Hultsfred Airport",
    city: "Hultsfred",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 57.526389,
    longitude: 15.827778,
    icao: "ESSF"
  },
  HLG: {
    iata: "HLG",
    name: "Ohio County Airport",
    city: "Wheeling",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.183333,
    longitude: -80.65,
    icao: "KHLG"
  },
  HLH: {
    iata: "HLH",
    name: "Ulanhot Yilelite Airport",
    city: "Ulanhot",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 46.193488,
    longitude: 122.001482,
    icao: "ZBUL"
  },
  HLM: {
    iata: "HLM",
    name: "Park Township Airport",
    city: "Holland",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.783333,
    longitude: -86.116667,
    icao: "KHLM"
  },
  HLN: {
    iata: "HLN",
    name: "Helena Regional Airport",
    city: "Helena",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 46.610518,
    longitude: -111.990182,
    icao: "KHLN"
  },
  HLP: {
    iata: "HLP",
    name: "Halim Perdanakusuma Airport",
    city: "Jakarta",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: -6.268056,
    longitude: 106.890278,
    icao: "WIHH"
  },
  HLR: {
    iata: "HLR",
    name: "Hood Army Air Field",
    city: "Killeen",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 31.138698,
    longitude: -97.714511,
    icao: "KHLR"
  },
  HLS: {
    iata: "HLS",
    name: "St. Helens Airport",
    city: "Saint Helens",
    countryId: "AU",
    timeZoneRegionName: "Australia/Hobart",
    latitude: -41.3367,
    longitude: 148.281998,
    icao: "YSTH"
  },
  HLT: {
    iata: "HLT",
    name: "Hamilton Airport",
    city: "Hamilton",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -37.65,
    longitude: 142.060556,
    icao: "YHML"
  },
  HLU: {
    iata: "HLU",
    name: "Houailou Airport",
    city: "Houailou",
    countryId: "NC",
    timeZoneRegionName: "Pacific/Noumea",
    latitude: -21.033333,
    longitude: 166.066667,
    icao: "NWWH"
  },
  HLW: {
    iata: "HLW",
    name: "Hluhluwe Airport",
    city: "Hluhluwe",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -28.016667,
    longitude: 32.25,
    icao: "FAHL"
  },
  HLZ: {
    iata: "HLZ",
    name: "Hamilton International Airport",
    city: "Hamilton",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -37.86622,
    longitude: 175.336023,
    icao: "NZHN"
  },
  HMA: {
    iata: "HMA",
    name: "Khanty-Mansiysk Airport",
    city: "Khanty-Mansiysk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yekaterinburg",
    latitude: 61.02613,
    longitude: 69.09714,
    icao: "USHH"
  },
  HMB: {
    iata: "HMB",
    name: "Mubarak International Airport",
    city: "Sohag",
    countryId: "EG",
    timeZoneRegionName: "Africa/Cairo",
    latitude: 26.338877,
    longitude: 31.737168,
    icao: "HEMK"
  },
  HME: {
    iata: "HME",
    name: "Oued Irara Airport",
    city: "Hassi Messaoud",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 31.675303,
    longitude: 6.145436,
    icao: "DAUH"
  },
  HMG: {
    iata: "HMG",
    name: "Hermannsburg Airport",
    city: "Hermannsburg",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -23.95,
    longitude: 132.75,
    icao: "YHMB"
  },
  HMI: {
    iata: "HMI",
    name: "Hami Airport",
    city: "Hami",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 42.916667,
    longitude: 93.416667,
    icao: "ZWHM"
  },
  HMN: {
    iata: "HMN",
    name: "Holloman Air Force Base",
    city: "Alamogordo",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 32.852489,
    longitude: -106.107011,
    icao: "KHMN"
  },
  HMO: {
    iata: "HMO",
    name: "Gen Pesqueira Garcia Airport",
    city: "Hermosillo",
    countryId: "MX",
    timeZoneRegionName: "America/Hermosillo",
    latitude: 29.089904,
    longitude: -111.051706,
    icao: "MMHO"
  },
  HMR: {
    iata: "HMR",
    name: "Hamar Airport",
    city: "Hamar",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 60.8,
    longitude: 11.116667,
    icao: "ENHA"
  },
  HMS: {
    iata: "HMS",
    name: "Haji Muhammad Sidik Airport",
    city: "Muara Teweh",
    countryId: "ID",
    timeZoneRegionName: "Asia/Pontianak",
    latitude: -1.0219,
    longitude: 114.9256,
    icao: ""
  },
  HMT: {
    iata: "HMT",
    name: "Ryan Field",
    city: "Hemet",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 33.733333,
    longitude: -117.025,
    icao: "KHMT"
  },
  HMV: {
    iata: "HMV",
    name: "Hemavan Airport",
    city: "Hemavan",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 65.806085,
    longitude: 15.082767,
    icao: "ESUT"
  },
  HMY: {
    iata: "HMY",
    name: "Seosan Airport",
    city: "Seosan",
    countryId: "KR",
    timeZoneRegionName: "Asia/Seoul",
    latitude: 36.705556,
    longitude: 126.487222,
    icao: "RKTP"
  },
  HNA: {
    iata: "HNA",
    name: "Hanamaki Airport",
    city: "Hanamaki",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 39.426926,
    longitude: 141.130767,
    icao: "RJSI"
  },
  HNB: {
    iata: "HNB",
    name: "Huntingburg Municipal Airport",
    city: "Huntingburg",
    countryId: "US",
    timeZoneRegionName: "America/Indiana/Indianapolis",
    latitude: 38.3,
    longitude: -86.95,
    icao: "KHNB"
  },
  HNC: {
    iata: "HNC",
    name: "Hatteras Airport",
    city: "Hatteras",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 35.2328,
    longitude: -75.617798,
    icao: "KHSE"
  },
  HND: {
    iata: "HND",
    name: "Haneda Airport",
    city: "Tokyo",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 35.549069,
    longitude: 139.784524,
    icao: "RJTT"
  },
  HNH: {
    iata: "HNH",
    name: "Hoonah Airport",
    city: "Hoonah",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 58.098569,
    longitude: -135.411807,
    icao: "PAOH"
  },
  HNL: {
    iata: "HNL",
    name: "Daniel K. Inouye International Airport",
    city: "Honolulu",
    countryId: "US",
    timeZoneRegionName: "Pacific/Honolulu",
    latitude: 21.325833,
    longitude: -157.921667,
    icao: "PHNL"
  },
  HNM: {
    iata: "HNM",
    name: "Hana Airport",
    city: "Hana",
    countryId: "US",
    timeZoneRegionName: "Pacific/Honolulu",
    latitude: 20.795833,
    longitude: -156.018889,
    icao: "PHHN"
  },
  HNS: {
    iata: "HNS",
    name: "Haines Municipal Airport",
    city: "Haines",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 59.246197,
    longitude: -135.529234,
    icao: "PAHN"
  },
  HNY: {
    iata: "HNY",
    name: "Hengyang Nanyue Airport",
    city: "Hengyang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 26.723889,
    longitude: 112.618333,
    icao: "ZGHY"
  },
  HOA: {
    iata: "HOA",
    name: "Hola Airport",
    city: "Hola",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: -1.520005,
    longitude: 40.00371,
    icao: "HKHO"
  },
  HOB: {
    iata: "HOB",
    name: "Lea County Airport",
    city: "Hobbs",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 32.688611,
    longitude: -103.216944,
    icao: "KHOB"
  },
  HOD: {
    iata: "HOD",
    name: "Hodeidah Airport",
    city: "Hodeidah",
    countryId: "YE",
    timeZoneRegionName: "Asia/Aden",
    latitude: 14.755638,
    longitude: 42.970477,
    icao: "OYHD"
  },
  HOE: {
    iata: "HOE",
    name: "Ban Houeisay Airport",
    city: "Houeisay",
    countryId: "LA",
    timeZoneRegionName: "Asia/Vientiane",
    latitude: 20.260512,
    longitude: 100.436785,
    icao: "VLHS"
  },
  HOF: {
    iata: "HOF",
    name: "Al-Ahsa Airport",
    city: "Hofuf",
    countryId: "SA",
    timeZoneRegionName: "Asia/Riyadh",
    latitude: 25.294783,
    longitude: 49.487462,
    icao: "OEAH"
  },
  HOG: {
    iata: "HOG",
    name: "Frank Pais Airport",
    city: "Holguin",
    countryId: "CU",
    timeZoneRegionName: "America/Havana",
    latitude: 20.785278,
    longitude: -76.315,
    icao: "MUHG"
  },
  HOH: {
    iata: "HOH",
    name: "Hohenems Airport",
    city: "Hohenems",
    countryId: "AT",
    timeZoneRegionName: "Europe/Vienna",
    latitude: 47.383333,
    longitude: 9.7,
    icao: "LOIH"
  },
  HOI: {
    iata: "HOI",
    name: "Hao Island Airport",
    city: "Hao Island",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -18.06248,
    longitude: -140.965292,
    icao: "NTTO"
  },
  HOK: {
    iata: "HOK",
    name: "Hooker Creek Airport",
    city: "Hooker Creek",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -18.335,
    longitude: 130.6325,
    icao: "YHOO"
  },
  HOM: {
    iata: "HOM",
    name: "Homer Airport",
    city: "Homer",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 59.643241,
    longitude: -151.493161,
    icao: "PAHO"
  },
  HON: {
    iata: "HON",
    name: "Howes Airport",
    city: "Huron",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 44.383611,
    longitude: -98.226389,
    icao: "KHON"
  },
  HOP: {
    iata: "HOP",
    name: "Campbell Army Airfield",
    city: "Hopkinsville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.672079,
    longitude: -87.488868,
    icao: "KHOP"
  },
  HOQ: {
    iata: "HOQ",
    name: "Hof Airport",
    city: "Hof",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 50.289167,
    longitude: 11.862222,
    icao: "EDQM"
  },
  HOR: {
    iata: "HOR",
    name: "Horta Airport",
    city: "Horta (Azores)",
    countryId: "PT",
    timeZoneRegionName: "Atlantic/Azores",
    latitude: 38.52,
    longitude: -28.717222,
    icao: "LPHR"
  },
  HOT: {
    iata: "HOT",
    name: "Memorial Field",
    city: "Hot Springs",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 34.478889,
    longitude: -93.096111,
    icao: "KHOT"
  },
  HOU: {
    iata: "HOU",
    name: "William P. Hobby Airport",
    city: "Houston",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 29.654513,
    longitude: -95.277018,
    icao: "KHOU"
  },
  HOV: {
    iata: "HOV",
    name: "Hovden Airport",
    city: "Orsta-Volda",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 62.179787,
    longitude: 6.078802,
    icao: "ENOV"
  },
  HOX: {
    iata: "HOX",
    name: "Homalin Airport",
    city: "Homalin",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 24.898928,
    longitude: 94.914636,
    icao: "VYHL"
  },
  HPA: {
    iata: "HPA",
    name: "Salote Pilolevu Airport",
    city: "Ha'Apai",
    countryId: "TO",
    timeZoneRegionName: "Pacific/Tongatapu",
    latitude: -19.778537,
    longitude: -174.340885,
    icao: "NFTL"
  },
  HPB: {
    iata: "HPB",
    name: "Hooper Bay Airport",
    city: "Hooper Bay",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 61.525077,
    longitude: -166.14586,
    icao: "PAHP"
  },
  HPH: {
    iata: "HPH",
    name: "Cat Bi International Airport",
    city: "Haiphong",
    countryId: "VN",
    timeZoneRegionName: "Asia/Ho_Chi_Minh",
    latitude: 20.823314,
    longitude: 106.727325,
    icao: "VVCI"
  },
  HPN: {
    iata: "HPN",
    name: "Westchester County Airport",
    city: "Westchester County",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.068674,
    longitude: -73.703889,
    icao: "KHPN"
  },
  HPT: {
    iata: "HPT",
    name: "Hampton Municipal Airport",
    city: "Hampton",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 42.75,
    longitude: -93.2,
    icao: "KHPT"
  },
  HPV: {
    iata: "HPV",
    name: "Princeville Airport",
    city: "Kauai Island",
    countryId: "US",
    timeZoneRegionName: "Pacific/Honolulu",
    latitude: 22.210378,
    longitude: -159.444808,
    icao: "HI01"
  },
  HPY: {
    iata: "HPY",
    name: "Baytown Airport",
    city: "Baytown",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 29.774058,
    longitude: -94.958621,
    icao: "KHPY"
  },
  HQL: {
    iata: "HQL",
    name: "Tashikuergan Hongqilafu Airport",
    city: "Tashikuergan",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 37.661111,
    longitude: 75.288611,
    icao: ""
  },
  HQM: {
    iata: "HQM",
    name: "Bowerman Airport",
    city: "Hoquiam",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 46.971111,
    longitude: -123.935556,
    icao: "KHQM"
  },
  HQQ: {
    iata: "HQQ",
    name: "Hong Qiqu Airport",
    city: "An Yang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 35.8689,
    longitude: 114.4656,
    icao: ""
  },
  HRB: {
    iata: "HRB",
    name: "Harbin Taiping International Airport",
    city: "Harbin",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 45.620854,
    longitude: 126.23644,
    icao: "ZYHB"
  },
  HRE: {
    iata: "HRE",
    name: "RG Mugabe International Airport",
    city: "Harare",
    countryId: "ZW",
    timeZoneRegionName: "Africa/Harare",
    latitude: -17.918631,
    longitude: 31.099249,
    icao: "FVHA"
  },
  HRF: {
    iata: "HRF",
    name: "Hoarafushi Airport",
    city: "Hoarafushi",
    countryId: "MV",
    timeZoneRegionName: "Indian/Maldives",
    latitude: 6.9725,
    longitude: 72.8942,
    icao: ""
  },
  HRG: {
    iata: "HRG",
    name: "Hurghada International Airport",
    city: "Hurghada",
    countryId: "EG",
    timeZoneRegionName: "Africa/Cairo",
    latitude: 27.189156,
    longitude: 33.8055,
    icao: "HEGN"
  },
  HRI: {
    iata: "HRI",
    name: "Mattala Rajapaksa International Airport",
    city: "Hambantota",
    countryId: "LK",
    timeZoneRegionName: "Asia/Colombo",
    latitude: 6.283889,
    longitude: 81.123886,
    icao: "VCRI"
  },
  HRK: {
    iata: "HRK",
    name: "Kharkov Airport",
    city: "Kharkov",
    countryId: "UA",
    timeZoneRegionName: "Europe/Kiev",
    latitude: 49.920781,
    longitude: 36.281187,
    icao: "UKHH"
  },
  HRL: {
    iata: "HRL",
    name: "Valley International Airport",
    city: "Harlingen",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 26.223483,
    longitude: -97.662253,
    icao: "KHRL"
  },
  HRO: {
    iata: "HRO",
    name: "Boone County Airport",
    city: "Harrison",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.264468,
    longitude: -93.154259,
    icao: "KHRO"
  },
  HRS: {
    iata: "HRS",
    name: "Harrismith Airport",
    city: "Harrismith",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -26.233333,
    longitude: 29.1,
    icao: "FAHR"
  },
  HRT: {
    iata: "HRT",
    name: "Linton-On-Ouse RAF",
    city: "Linton-on-Ouse",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 54.045878,
    longitude: -1.251643,
    icao: "EGXU"
  },
  HSA: {
    iata: "HSA",
    name: "Turkistan Hazret Sultan International Airport",
    city: "Turkistan",
    countryId: "KZ",
    timeZoneRegionName: "Asia/Almaty",
    latitude: 43.31111,
    longitude: 68.550278,
    icao: ""
  },
  HSB: {
    iata: "HSB",
    name: "Raleigh Airport",
    city: "Harrisburg",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 37.733333,
    longitude: -88.533333,
    icao: "KHSB"
  },
  HSC: {
    iata: "HSC",
    name: "Shaoguan Danxia Airport",
    city: "Shaoguan",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 24.833333,
    longitude: 113.616667,
    icao: ""
  },
  HSF: {
    iata: "HSF",
    name: "Suifenhe Dongning Airport",
    city: "Suifenhe",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 44.45361,
    longitude: 130.8425,
    icao: ""
  },
  HSG: {
    iata: "HSG",
    name: "Saga Airport",
    city: "Saga",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 33.153828,
    longitude: 130.302775,
    icao: "RJFS"
  },
  HSH: {
    iata: "HSH",
    name: "Henderson Executive Airport",
    city: "Las Vegas",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 35.973171,
    longitude: -115.134188,
    icao: "KHND"
  },
  HSI: {
    iata: "HSI",
    name: "Hastings Airport",
    city: "Hastings",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 40.605556,
    longitude: -98.426944,
    icao: "KHSI"
  },
  HSK: {
    iata: "HSK",
    name: "Huesca-Pirineos Airport",
    city: "Huesca",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 42.080927,
    longitude: -0.323469,
    icao: "LEHC"
  },
  HSL: {
    iata: "HSL",
    name: "Huslia Airport",
    city: "Huslia",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 65.7025,
    longitude: -156.375,
    icao: "PAHS"
  },
  HSM: {
    iata: "HSM",
    name: "Horsham Airport",
    city: "Horsham",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -36.666667,
    longitude: 142.166667,
    icao: "YHSM"
  },
  HSN: {
    iata: "HSN",
    name: "Zhoushan Putuoshan Airport",
    city: "Zhujiajian",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 29.934167,
    longitude: 122.362222,
    icao: "ZSZS"
  },
  HSP: {
    iata: "HSP",
    name: "Ingalls Field",
    city: "Hot Springs",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 37.950556,
    longitude: -79.833889,
    icao: "KHSP"
  },
  HSR: {
    iata: "HSR",
    name: "Hirasar Airport",
    city: "Hirasar",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 22.3742,
    longitude: 71.035,
    icao: ""
  },
  HSS: {
    iata: "HSS",
    name: "Hisar Airport",
    city: "Hissar",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 29.166667,
    longitude: 75.8,
    icao: "VIHR"
  },
  HST: {
    iata: "HST",
    name: "Homestead Air Force Base",
    city: "Homestead",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 25.4886,
    longitude: -80.383598,
    icao: "KHST"
  },
  HSV: {
    iata: "HSV",
    name: "Huntsville International Airport - Carl T. Jones Field",
    city: "Huntsville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 34.64857,
    longitude: -86.774838,
    icao: "KHSV"
  },
  HSZ: {
    iata: "HSZ",
    name: "Hsinchu Airport",
    city: "Hsinchu",
    countryId: "TW",
    timeZoneRegionName: "Asia/Taipei",
    latitude: 24.816667,
    longitude: 120.933333,
    icao: "RCPO"
  },
  HTA: {
    iata: "HTA",
    name: "Chita Airport",
    city: "Chita",
    countryId: "RU",
    timeZoneRegionName: "Asia/Chita",
    latitude: 52.033333,
    longitude: 113.3,
    icao: "UIAA"
  },
  HTG: {
    iata: "HTG",
    name: "Hatanga Airport",
    city: "Hatanga",
    countryId: "RU",
    timeZoneRegionName: "Asia/Krasnoyarsk",
    latitude: 71.975681,
    longitude: 102.477651,
    icao: "UOHH"
  },
  HTH: {
    iata: "HTH",
    name: "Hawthorne Airport",
    city: "Hawthorne",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 38.533333,
    longitude: -118.633333,
    icao: "KHTH"
  },
  HTI: {
    iata: "HTI",
    name: "Hamilton Island Airport",
    city: "Hamilton Island",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -20.35175,
    longitude: 148.948474,
    icao: "YBHM"
  },
  HTL: {
    iata: "HTL",
    name: "Roscommon County Airport",
    city: "Houghton Lake",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 44.448056,
    longitude: -84.711111,
    icao: "KHTL"
  },
  HTN: {
    iata: "HTN",
    name: "Hotan Airport",
    city: "Hotan",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 37.040434,
    longitude: 79.872449,
    icao: "ZWTN"
  },
  HTO: {
    iata: "HTO",
    name: "East Hampton Airport",
    city: "East Hampton",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.959444,
    longitude: -72.251667,
    icao: "KHTO"
  },
  HTR: {
    iata: "HTR",
    name: "Hateruma Airport",
    city: "Hateruma",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 24.05,
    longitude: 123.8,
    icao: "RORH"
  },
  HTS: {
    iata: "HTS",
    name: "Tri-State/Milton Airport",
    city: "Huntington",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 38.366944,
    longitude: -82.556111,
    icao: "KHTS"
  },
  HTT: {
    iata: "HTT",
    name: "Huatugou Airport",
    city: "Huatugou",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 38.256275,
    longitude: 90.830354,
    icao: ""
  },
  HTU: {
    iata: "HTU",
    name: "Hopetown Airport",
    city: "Hopetown",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -35.7,
    longitude: 142.366667,
    icao: "YHPN"
  },
  HTV: {
    iata: "HTV",
    name: "Huntsville Airport",
    city: "Huntsville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.716667,
    longitude: -95.55,
    icao: "KUTS"
  },
  HTW: {
    iata: "HTW",
    name: "Huntington County Airport",
    city: "Chesapeake",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 36.833333,
    longitude: -76.283333,
    icao: "KHTW"
  },
  HTY: {
    iata: "HTY",
    name: "Hatay Airport",
    city: "Antakya",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 36.364544,
    longitude: 36.28057,
    icao: "LTDA"
  },
  HTZ: {
    iata: "HTZ",
    name: "Hato Corozal Airport",
    city: "Hato Corozal",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 6.033333,
    longitude: -72.633333,
    icao: "SKHC"
  },
  HUA: {
    iata: "HUA",
    name: "Redstone Army Air Field",
    city: "Huntsville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 34.678679,
    longitude: -86.684783,
    icao: "KHUA"
  },
  HUE: {
    iata: "HUE",
    name: "Humera Airport",
    city: "Humera",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 13.835854,
    longitude: 36.880778,
    icao: "HAHU"
  },
  HUF: {
    iata: "HUF",
    name: "Hulman Field",
    city: "Terre Haute",
    countryId: "US",
    timeZoneRegionName: "America/Indiana/Indianapolis",
    latitude: 39.454444,
    longitude: -87.3075,
    icao: "KHUF"
  },
  HUH: {
    iata: "HUH",
    name: "Huahine Airport",
    city: "Huahine",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -16.689682,
    longitude: -151.028253,
    icao: "NTTH"
  },
  HUI: {
    iata: "HUI",
    name: "Phu Bai International Airport",
    city: "Hue",
    countryId: "VN",
    timeZoneRegionName: "Asia/Ho_Chi_Minh",
    latitude: 16.398224,
    longitude: 107.700871,
    icao: "VVPB"
  },
  HUJ: {
    iata: "HUJ",
    name: "Hugo Airport",
    city: "Hugo",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 34.016667,
    longitude: -95.516667,
    icao: "KHHW"
  },
  HUL: {
    iata: "HUL",
    name: "Houlton International Airport",
    city: "Houlton",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 46.133333,
    longitude: -67.8,
    icao: "KHUL"
  },
  HUM: {
    iata: "HUM",
    name: "Houma-Terrebonne Airport",
    city: "Houma",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 29.566944,
    longitude: -90.660833,
    icao: "KHUM"
  },
  HUN: {
    iata: "HUN",
    name: "Hualien Airport",
    city: "Hualien",
    countryId: "TW",
    timeZoneRegionName: "Asia/Taipei",
    latitude: 24.025764,
    longitude: 121.613431,
    icao: "RCYU"
  },
  HUO: {
    iata: "HUO",
    name: "Holingol Huolinhe Airport",
    city: "Huolinguole",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 45.48673,
    longitude: 119.40851,
    icao: ""
  },
  HUQ: {
    iata: "HUQ",
    name: "Houn Airport",
    city: "Houn",
    countryId: "LY",
    timeZoneRegionName: "Africa/Tripoli",
    latitude: 29.5,
    longitude: 15.5,
    icao: "HLON"
  },
  HUS: {
    iata: "HUS",
    name: "Hughes Municipal Airport",
    city: "Hughes",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 66.040556,
    longitude: -154.263333,
    icao: "PAHU"
  },
  HUT: {
    iata: "HUT",
    name: "Hutchinson Airport",
    city: "Hutchinson",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 38.068056,
    longitude: -97.861111,
    icao: "KHUT"
  },
  HUU: {
    iata: "HUU",
    name: "Huanuco Airport",
    city: "Huanuco",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -9.866667,
    longitude: -76.216667,
    icao: "SPNC"
  },
  HUV: {
    iata: "HUV",
    name: "Hudiksvall Airport",
    city: "Hudiksvall",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 61.767101,
    longitude: 17.084194,
    icao: "ESNH"
  },
  HUW: {
    iata: "HUW",
    name: "Humaita Airport",
    city: "Humaita",
    countryId: "BR",
    timeZoneRegionName: "America/Porto_Velho",
    latitude: -7.537679,
    longitude: -63.069795,
    icao: "SWHT"
  },
  HUX: {
    iata: "HUX",
    name: "Huatulco Airport",
    city: "Huatulco",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 15.768333,
    longitude: -96.235556,
    icao: "MMBT"
  },
  HUY: {
    iata: "HUY",
    name: "Humberside Airport",
    city: "Humberside",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 53.583378,
    longitude: -0.34851,
    icao: "EGNJ"
  },
  HUZ: {
    iata: "HUZ",
    name: "Huizhou Airport",
    city: "Huizhou",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 23.050418,
    longitude: 114.596859,
    icao: "ZGHZ"
  },
  HVA: {
    iata: "HVA",
    name: "Analalava Airport",
    city: "Analalava",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -14.633333,
    longitude: 47.766667,
    icao: "FMNL"
  },
  HVB: {
    iata: "HVB",
    name: "Hervey Bay Airport",
    city: "Hervey Bay",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -25.319868,
    longitude: 152.885203,
    icao: "YHBA"
  },
  HVD: {
    iata: "HVD",
    name: "Khovd Airport",
    city: "Khovd",
    countryId: "MN",
    timeZoneRegionName: "Asia/Ulaanbaatar",
    latitude: 48.016667,
    longitude: 91.65,
    icao: "ZMKD"
  },
  HVE: {
    iata: "HVE",
    name: "Hanksville Intermediate Airport",
    city: "Hanksville",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 38.366667,
    longitude: -110.716667,
    icao: "KHVE"
  },
  HVG: {
    iata: "HVG",
    name: "Valan Airport",
    city: "Honningsvag",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 71.009697,
    longitude: 25.983601,
    icao: "ENHV"
  },
  HVN: {
    iata: "HVN",
    name: "New Haven Airport",
    city: "New Haven",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.265278,
    longitude: -72.888333,
    icao: "KHVN"
  },
  HVR: {
    iata: "HVR",
    name: "Havre City County Airport",
    city: "Havre",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 48.544444,
    longitude: -109.761111,
    icao: "KHVR"
  },
  HVS: {
    iata: "HVS",
    name: "Hartsville Municipal Airport",
    city: "Hartsville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 34.383333,
    longitude: -80.066667,
    icao: "KHVS"
  },
  HVT: {
    iata: "HVT",
    name: "Tikkurila railway station",
    city: "Vantaa",
    countryId: "FI",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 60.29388888,
    longitude: 25.045,
    icao: ""
  },
  HWD: {
    iata: "HWD",
    name: "Hayward Executive Airport",
    city: "Hayward",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 37.659199,
    longitude: -122.122002,
    icao: "KHWD"
  },
  HWN: {
    iata: "HWN",
    name: "Hwange National Park Airport",
    city: "Hwange National Park",
    countryId: "ZW",
    timeZoneRegionName: "Africa/Harare",
    latitude: -19.3625,
    longitude: 26.518333,
    icao: "FVWN"
  },
  HWO: {
    iata: "HWO",
    name: "North Perry Airport",
    city: "Hollywood",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 26.002428,
    longitude: -80.238918,
    icao: "KHWO"
  },
  HXD: {
    iata: "HXD",
    name: "Delingha Airport",
    city: "Delingha City",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 37.125,
    longitude: 97.268611,
    icao: ""
  },
  HXX: {
    iata: "HXX",
    name: "Hay Airport",
    city: "Hay",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -34.516667,
    longitude: 144.833333,
    icao: "YHAY"
  },
  HYA: {
    iata: "HYA",
    name: "Barnstable Municipal Airport",
    city: "Hyannis",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.665833,
    longitude: -70.280556,
    icao: "KHYA"
  },
  HYD: {
    iata: "HYD",
    name: "Rajiv Gandhi International Airport",
    city: "Hyderabad",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 17.233702,
    longitude: 78.430427,
    icao: "VOHS"
  },
  HYN: {
    iata: "HYN",
    name: "Luqiao Airport",
    city: "Taizhou",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 28.562224,
    longitude: 121.428614,
    icao: "ZSLQ"
  },
  HYR: {
    iata: "HYR",
    name: "Hayward Municipal Airport",
    city: "Hayward",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 46.024444,
    longitude: -91.444444,
    icao: "KHYR"
  },
  HYS: {
    iata: "HYS",
    name: "Hays Municipal Airport",
    city: "Hays",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 38.846111,
    longitude: -99.274167,
    icao: "KHYS"
  },
  HYV: {
    iata: "HYV",
    name: "Hyvinkaa Airport",
    city: "Hyvinkaa",
    countryId: "FI",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 60.654167,
    longitude: 24.884444,
    icao: "EFHV"
  },
  HZA: {
    iata: "HZA",
    name: "Heze Mudan Airport",
    city: "Heze",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 35.212222,
    longitude: 115.731944,
    icao: ""
  },
  HZB: {
    iata: "HZB",
    name: "Merville/Calonne Airport",
    city: "Hazebrouck",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 50.616667,
    longitude: 2.65,
    icao: "LFQT"
  },
  HZG: {
    iata: "HZG",
    name: "Hanzhong Airport",
    city: "Hanzhong",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 33.063443,
    longitude: 107.008446,
    icao: "ZLHZ"
  },
  HZH: {
    iata: "HZH",
    name: "Liping Airport",
    city: "Liping",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 26.320214,
    longitude: 109.153806,
    icao: "ZUNP"
  },
  HZK: {
    iata: "HZK",
    name: "Husavik Airport",
    city: "Husavik",
    countryId: "IS",
    timeZoneRegionName: "Atlantic/Reykjavik",
    latitude: 65.955754,
    longitude: -17.419672,
    icao: "BIHU"
  },
  HZL: {
    iata: "HZL",
    name: "Hazleton Airport",
    city: "Hazleton",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.986389,
    longitude: -75.991111,
    icao: "KHZL"
  },
  HZP: {
    iata: "HZP",
    name: "Fort MacKay/Horizon Airport",
    city: "Fort MacKay",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 57.381667,
    longitude: -111.701111,
    icao: "CYNR"
  },
  IAA: {
    iata: "IAA",
    name: "Igarka Airport",
    city: "Igarka",
    countryId: "RU",
    timeZoneRegionName: "Asia/Krasnoyarsk",
    latitude: 67.433333,
    longitude: 86.633333,
    icao: ""
  },
  IAB: {
    iata: "IAB",
    name: "McConnell Air Force Base",
    city: "Wichita",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 37.681139,
    longitude: -97.276167,
    icao: "KIAB"
  },
  IAD: {
    iata: "IAD",
    name: "Washington Dulles International Airport",
    city: "Dulles",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 38.95315,
    longitude: -77.447735,
    icao: "KIAD"
  },
  IAG: {
    iata: "IAG",
    name: "Niagara Falls International Airport",
    city: "Niagara Falls",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 43.1,
    longitude: -78.95,
    icao: "KIAG"
  },
  IAH: {
    iata: "IAH",
    name: "George Bush Intercontinental Airport",
    city: "Houston",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 29.983333,
    longitude: -95.34,
    icao: "KIAH"
  },
  IAL: {
    iata: "IAL",
    name: "Salinas Airport (Brazil)",
    city: "Salinas",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -16.2086,
    longitude: -42.3233,
    icao: ""
  },
  IAM: {
    iata: "IAM",
    name: "In Amenas Airport",
    city: "In Amenas",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 28.051111,
    longitude: 9.638056,
    icao: "DAUZ"
  },
  IAN: {
    iata: "IAN",
    name: "Bob Baker Memorial Airport",
    city: "Kiana",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 66.974752,
    longitude: -160.441212,
    icao: "PAIK"
  },
  IAO: {
    iata: "IAO",
    name: "Sayak Airport",
    city: "Del Carmin",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 9.858889,
    longitude: 126.013889,
    icao: "RPNS"
  },
  IAR: {
    iata: "IAR",
    name: "Tunoshna Airport",
    city: "Yaroslavl",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 57.559753,
    longitude: 40.160893,
    icao: "UUDL"
  },
  IAS: {
    iata: "IAS",
    name: "Iasi Airport",
    city: "Iasi",
    countryId: "RO",
    timeZoneRegionName: "Europe/Bucharest",
    latitude: 47.176988,
    longitude: 27.616993,
    icao: "LRIA"
  },
  IBA: {
    iata: "IBA",
    name: "Ibadan Airport",
    city: "Ibadan",
    countryId: "NG",
    timeZoneRegionName: "Africa/Lagos",
    latitude: 7.360181,
    longitude: 3.976361,
    icao: "DNIB"
  },
  IBE: {
    iata: "IBE",
    name: "Ibague Airport",
    city: "Ibague",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 4.423948,
    longitude: -75.138579,
    icao: "SKIB"
  },
  IBP: {
    iata: "IBP",
    name: "Iberia Airport",
    city: "Iberia",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -11.366667,
    longitude: -69.583333,
    icao: "SPBR"
  },
  IBR: {
    iata: "IBR",
    name: "Ibaraki Airport",
    city: "Omitami",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 36.181667,
    longitude: 140.414722,
    icao: "RJAH"
  },
  IBZ: {
    iata: "IBZ",
    name: "Ibiza Airport",
    city: "Ibiza",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 38.876595,
    longitude: 1.367803,
    icao: "LEIB"
  },
  ICA: {
    iata: "ICA",
    name: "Icabaru Airport",
    city: "Icabaru",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 4.333333,
    longitude: -61.733333,
    icao: "SVIC"
  },
  ICI: {
    iata: "ICI",
    name: "Cicia Airport",
    city: "Cicia",
    countryId: "FJ",
    timeZoneRegionName: "Pacific/Fiji",
    latitude: -17.743709,
    longitude: -179.341929,
    icao: "NFCI"
  },
  ICL: {
    iata: "ICL",
    name: "Schenk Field",
    city: "Clarinda",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 40.721862,
    longitude: -95.026542,
    icao: "KICL"
  },
  ICN: {
    iata: "ICN",
    name: "Incheon International Airport",
    city: "Seoul",
    countryId: "KR",
    timeZoneRegionName: "Asia/Seoul",
    latitude: 37.448526,
    longitude: 126.451234,
    icao: "RKSI"
  },
  ICR: {
    iata: "ICR",
    name: "Nicaro Airport",
    city: "Nicaro",
    countryId: "CU",
    timeZoneRegionName: "America/Havana",
    latitude: 20.983333,
    longitude: -75.975,
    icao: "MUNC"
  },
  ICT: {
    iata: "ICT",
    name: "Wichita Dwight D. Eisenhower National Airport",
    city: "Wichita",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 37.653044,
    longitude: -97.428957,
    icao: "KICT"
  },
  IDA: {
    iata: "IDA",
    name: "Idaho Falls Regional Airport",
    city: "Idaho Falls",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 43.514854,
    longitude: -112.06751,
    icao: "KIDA"
  },
  IDB: {
    iata: "IDB",
    name: "Idre Airport",
    city: "Idre",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 61.866667,
    longitude: 12.683333,
    icao: "ESUE"
  },
  IDF: {
    iata: "IDF",
    name: "Idiofa Airport",
    city: "Idiofa",
    countryId: "CD",
    timeZoneRegionName: "Africa/Kinshasa",
    latitude: -5.033333,
    longitude: 19.6,
    icao: "FZCB"
  },
  IDG: {
    iata: "IDG",
    name: "Ida Grove Municipal Airport",
    city: "Ida Grove",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 42.35,
    longitude: -95.466667,
    icao: "KIDG"
  },
  IDI: {
    iata: "IDI",
    name: "Indiana County Airport",
    city: "Indiana",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.632198,
    longitude: -79.105499,
    icao: "KIDI"
  },
  IDK: {
    iata: "IDK",
    name: "Indulkana Airport",
    city: "Indulkana",
    countryId: "AU",
    timeZoneRegionName: "Australia/Adelaide",
    latitude: -26.966667,
    longitude: 133.325,
    icao: "YIDK"
  },
  IDO: {
    iata: "IDO",
    name: "Santa Isabel do Morro Airport",
    city: "Santa Isabel do Morro",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -11.566667,
    longitude: -50.666667,
    icao: "SWIY"
  },
  IDP: {
    iata: "IDP",
    name: "Independence Airport",
    city: "Independence",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 37.233333,
    longitude: -95.7,
    icao: "KIDP"
  },
  IDR: {
    iata: "IDR",
    name: "Devi Ahilya Bai Holkar Airport",
    city: "Indore",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 22.72715,
    longitude: 75.808227,
    icao: "VAID"
  },
  IDY: {
    iata: "IDY",
    name: "Ile 'd' Yeu Airport",
    city: "Ile 'd' Yeu",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 46.717867,
    longitude: -2.388694,
    icao: "LFEY"
  },
  IEG: {
    iata: "IEG",
    name: "Zielona Gora-Babimost Airport",
    city: "Zielona Gora",
    countryId: "PL",
    timeZoneRegionName: "Europe/Warsaw",
    latitude: 52.138611,
    longitude: 15.798611,
    icao: "EPZG"
  },
  IEJ: {
    iata: "IEJ",
    name: "Iejima Airport",
    city: "Iejima",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 26.723887,
    longitude: 127.789093,
    icao: "RORE"
  },
  IEV: {
    iata: "IEV",
    name: "Kyiv International Airport",
    city: "Kiev",
    countryId: "UA",
    timeZoneRegionName: "Europe/Kiev",
    latitude: 50.401944,
    longitude: 30.450833,
    icao: "UKKK"
  },
  IFA: {
    iata: "IFA",
    name: "Iowa Falls Airport",
    city: "Iowa Falls",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 42.516667,
    longitude: -93.266667,
    icao: "KIFA"
  },
  IFF: {
    iata: "IFF",
    name: "Iffley Airport",
    city: "Iffley",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -18.9,
    longitude: 141.216667,
    icao: "YIFY"
  },
  IFJ: {
    iata: "IFJ",
    name: "Isafjordur Airport",
    city: "Isafjordur",
    countryId: "IS",
    timeZoneRegionName: "Atlantic/Reykjavik",
    latitude: 66.059722,
    longitude: -23.132778,
    icao: "BIIS"
  },
  IFL: {
    iata: "IFL",
    name: "Innisfail Airport",
    city: "Innisfail",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -17.55,
    longitude: 146.016667,
    icao: "YIFL"
  },
  IFN: {
    iata: "IFN",
    name: "Isfahan International Airport",
    city: "Isfahan",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 32.745686,
    longitude: 51.876381,
    icao: "OIFM"
  },
  IFO: {
    iata: "IFO",
    name: "Ivano-Frankovsk Airport",
    city: "Ivano-Frankovsk",
    countryId: "UA",
    timeZoneRegionName: "Europe/Kiev",
    latitude: 48.887535,
    longitude: 24.707566,
    icao: "UKLI"
  },
  IFP: {
    iata: "IFP",
    name: "Laughlin Bullhead International Airport",
    city: "Bullhead City",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 35.157684,
    longitude: -114.557624,
    icao: "KIFP"
  },
  IFU: {
    iata: "IFU",
    name: "Ifuru Airport",
    city: "Ifuru Island",
    countryId: "MV",
    timeZoneRegionName: "Indian/Maldives",
    latitude: 5.708055,
    longitude: 73.025,
    icao: ""
  },
  IGA: {
    iata: "IGA",
    name: "Inagua Airport",
    city: "Inagua",
    countryId: "BS",
    timeZoneRegionName: "America/Nassau",
    latitude: 20.983333,
    longitude: -73.666667,
    icao: "MYIG"
  },
  IGD: {
    iata: "IGD",
    name: "Igdir Airport",
    city: "Igdir",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 39.974445,
    longitude: 43.879723,
    icao: "LTCT"
  },
  IGG: {
    iata: "IGG",
    name: "Igiugig Airport",
    city: "Igiugig",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 59.324042,
    longitude: -155.901772,
    icao: "PAIG"
  },
  IGH: {
    iata: "IGH",
    name: "Ingham Airport",
    city: "Ingham",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -18.716667,
    longitude: 146.166667,
    icao: "YIGM"
  },
  IGL: {
    iata: "IGL",
    name: "Cigli Air Base",
    city: "Izmir",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 38.318889,
    longitude: 27.159444,
    icao: "LTBL"
  },
  IGM: {
    iata: "IGM",
    name: "Kingman Airport",
    city: "Kingman",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 35.256667,
    longitude: -113.94,
    icao: "KIGM"
  },
  IGN: {
    iata: "IGN",
    name: "Maria Cristina Airport",
    city: "Iligan",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 8.131111,
    longitude: 124.214167,
    icao: "RPMI"
  },
  IGO: {
    iata: "IGO",
    name: "Chigorodo Airport",
    city: "Chigorodo",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 7.681667,
    longitude: -76.686667,
    icao: "SKIG"
  },
  IGR: {
    iata: "IGR",
    name: "Cataratas del Iguazu International Airport",
    city: "Iguazu",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -25.731505,
    longitude: -54.476347,
    icao: "SARI"
  },
  IGS: {
    iata: "IGS",
    name: "Ingolstadt Manching Airport",
    city: "Ingolstadt",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 48.722247,
    longitude: 11.537143,
    icao: "ETSI"
  },
  IGT: {
    iata: "IGT",
    name: "Magas Airport",
    city: "Ordzhonikidzevskaya",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 43.322124,
    longitude: 45.012611,
    icao: ""
  },
  IGU: {
    iata: "IGU",
    name: "Cataratas International Airport",
    city: "Iguassu Falls",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -25.597937,
    longitude: -54.488822,
    icao: "SBFI"
  },
  IHC: {
    iata: "IHC",
    name: "Inhaca Airport",
    city: "Inhaca",
    countryId: "MZ",
    timeZoneRegionName: "Africa/Maputo",
    latitude: -26,
    longitude: 32.933333,
    icao: "FQIA"
  },
  IHN: {
    iata: "IHN",
    name: "Qishn Airport",
    city: "Qishn",
    countryId: "YE",
    timeZoneRegionName: "Asia/Aden",
    latitude: 15.05,
    longitude: 50.05,
    icao: "OYQN"
  },
  IHO: {
    iata: "IHO",
    name: "Ihosy Airport",
    city: "Ihosy",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -22.416667,
    longitude: 46.116667,
    icao: "FMSI"
  },
  IHR: {
    iata: "IHR",
    name: "Iranshahr Airport",
    city: "Iranshahr",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 27.236099,
    longitude: 60.720001,
    icao: "OIZI"
  },
  IIA: {
    iata: "IIA",
    name: "Inishmaan Airport",
    city: "Inishmaan",
    countryId: "IE",
    timeZoneRegionName: "Europe/Dublin",
    latitude: 53.083333,
    longitude: -9.533333,
    icao: "EIMN"
  },
  IIL: {
    iata: "IIL",
    name: "Ilam Airport",
    city: "Ilaam",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 33.586367,
    longitude: 46.399236,
    icao: ""
  },
  IJK: {
    iata: "IJK",
    name: "Izhevsk Airport",
    city: "Izhevsk",
    countryId: "RU",
    timeZoneRegionName: "Europe/Samara",
    latitude: 56.830447,
    longitude: 53.456529,
    icao: "USII"
  },
  IJU: {
    iata: "IJU",
    name: "J. Batista Bos Filho Airport",
    city: "Ijui",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -28.3687,
    longitude: -53.8466,
    icao: "SSIJ"
  },
  IJX: {
    iata: "IJX",
    name: "Jacksonville Municipal Airport",
    city: "Jacksonville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 39.774167,
    longitude: -90.237222,
    icao: "KIJX"
  },
  IKA: {
    iata: "IKA",
    name: "Imam Khomeini International Airport",
    city: "Tehran",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 35.408632,
    longitude: 51.1548,
    icao: "OIIE"
  },
  IKB: {
    iata: "IKB",
    name: "Wilkes County Airport",
    city: "Wilkesboro",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 36.222801,
    longitude: -81.098297,
    icao: "KUKF"
  },
  IKE: {
    iata: "IKE",
    name: "Ikerasak Heliport",
    city: "Ikerasak",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 70.498145,
    longitude: -51.303084,
    icao: "BGIA"
  },
  IKG: {
    iata: "IKG",
    name: "Karakol International Airport",
    city: "Karakol",
    countryId: "KG",
    timeZoneRegionName: "Asia/Bishkek",
    latitude: 42.50222222,
    longitude: 78.3925,
    icao: ""
  },
  IKI: {
    iata: "IKI",
    name: "Iki Airport",
    city: "Iki",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 33.745556,
    longitude: 129.788333,
    icao: "RJDB"
  },
  IKK: {
    iata: "IKK",
    name: "Greater Kankakee Airport",
    city: "Kankakee",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.383333,
    longitude: -88.25,
    icao: "KIKK"
  },
  IKL: {
    iata: "IKL",
    name: "Ikela Airport",
    city: "Ikela",
    countryId: "CD",
    timeZoneRegionName: "Africa/Kinshasa",
    latitude: -1.666667,
    longitude: 23.666667,
    icao: "FZGV"
  },
  IKS: {
    iata: "IKS",
    name: "Tiksi Airport",
    city: "Tiksi",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yakutsk",
    latitude: 71.7,
    longitude: 128.9,
    icao: "UEST"
  },
  IKT: {
    iata: "IKT",
    name: "Irkutsk International Airport",
    city: "Irkutsk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Irkutsk",
    latitude: 52.273309,
    longitude: 104.356071,
    icao: "UIII"
  },
  IKU: {
    iata: "IKU",
    name: "Issyk-Kul International Airport",
    city: "Tamchy",
    countryId: "KG",
    timeZoneRegionName: "Asia/Bishkek",
    latitude: 42.588056,
    longitude: 76.713056,
    icao: "UCFL"
  },
  ILD: {
    iata: "ILD",
    name: "Lleida-Alguaire Airport",
    city: "Alguaire",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 41.726926,
    longitude: 0.539164,
    icao: "LEDA"
  },
  ILE: {
    iata: "ILE",
    name: "Skylark Field",
    city: "Killeen",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 31.086389,
    longitude: -97.686667,
    icao: "KILE"
  },
  ILF: {
    iata: "ILF",
    name: "Ilford Airport",
    city: "Ilford",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 56.066667,
    longitude: -95.616667,
    icao: "CZBD"
  },
  ILG: {
    iata: "ILG",
    name: "New Castle Airport",
    city: "Wilmington",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.678333,
    longitude: -75.6075,
    icao: "KILG"
  },
  ILI: {
    iata: "ILI",
    name: "Iliamna Airport",
    city: "Iliamna",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 59.755502,
    longitude: -154.908568,
    icao: "PAIL"
  },
  ILK: {
    iata: "ILK",
    name: "Ilaka Airport",
    city: "Ilaka",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -20.333333,
    longitude: 47.166667,
    icao: "FMMQ"
  },
  ILL: {
    iata: "ILL",
    name: "Willmar Airport",
    city: "Willmar",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 45.115278,
    longitude: -95.085278,
    icao: "KILL"
  },
  ILM: {
    iata: "ILM",
    name: "Wilmington International Airport",
    city: "Wilmington",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 34.267052,
    longitude: -77.910627,
    icao: "KILM"
  },
  ILN: {
    iata: "ILN",
    name: "Wilmington Airpark",
    city: "Wilmington",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.433342,
    longitude: -83.791092,
    icao: "KILN"
  },
  ILO: {
    iata: "ILO",
    name: "Mandurriao Airport",
    city: "Iloilo",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 10.713742,
    longitude: 122.544193,
    icao: "RPVI"
  },
  ILP: {
    iata: "ILP",
    name: "Ile Des Pins Airport",
    city: "Ile Des Pins",
    countryId: "NC",
    timeZoneRegionName: "Pacific/Noumea",
    latitude: -22.589722,
    longitude: 167.4475,
    icao: "NWEE"
  },
  ILQ: {
    iata: "ILQ",
    name: "Ilo Airport",
    city: "Ilo",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -17.694932,
    longitude: -71.343938,
    icao: "SPLO"
  },
  ILR: {
    iata: "ILR",
    name: "Ilorin International Airport",
    city: "Ilorin",
    countryId: "NG",
    timeZoneRegionName: "Africa/Lagos",
    latitude: 8.436093,
    longitude: 4.493616,
    icao: "DNIL"
  },
  ILS: {
    iata: "ILS",
    name: "Ilopango Airport",
    city: "San Salvador",
    countryId: "SV",
    timeZoneRegionName: "America/El_Salvador",
    latitude: 13.699471,
    longitude: -89.119781,
    icao: "MSSS"
  },
  ILU: {
    iata: "ILU",
    name: "Kilaguni Airport",
    city: "Kilaguni",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: -2.906443,
    longitude: 38.072049,
    icao: "HKKL"
  },
  ILY: {
    iata: "ILY",
    name: "Glenegedale Airport",
    city: "Islay",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 55.681944,
    longitude: -6.254167,
    icao: "EGPI"
  },
  ILZ: {
    iata: "ILZ",
    name: "Zilina Airport",
    city: "Zilina",
    countryId: "SK",
    timeZoneRegionName: "Europe/Bratislava",
    latitude: 49.231499,
    longitude: 18.613501,
    icao: "LZZI"
  },
  IMB: {
    iata: "IMB",
    name: "Imbaimadai Airport",
    city: "Imbaimadai",
    countryId: "GY",
    timeZoneRegionName: "America/Guyana",
    latitude: 5.716667,
    longitude: -60.283333,
    icao: "SYIB"
  },
  IMF: {
    iata: "IMF",
    name: "Imphal Municipal Airport",
    city: "Imphal",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 24.76457,
    longitude: 93.897063,
    icao: "VEIM"
  },
  IMK: {
    iata: "IMK",
    name: "Simikot Airport",
    city: "Simikot",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 29.970565,
    longitude: 81.818705,
    icao: "VNST"
  },
  IML: {
    iata: "IML",
    name: "Imperial Airport",
    city: "Imperial",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 40.516667,
    longitude: -101.65,
    icao: "KIML"
  },
  IMM: {
    iata: "IMM",
    name: "Immokalee Airport",
    city: "Immokalee",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 26.416667,
    longitude: -81.416667,
    icao: "KIMM"
  },
  IMO: {
    iata: "IMO",
    name: "Zemio Airport",
    city: "Zemio",
    countryId: "CF",
    timeZoneRegionName: "Africa/Bangui",
    latitude: 5.033333,
    longitude: 25.083333,
    icao: "FEFZ"
  },
  IMP: {
    iata: "IMP",
    name: "Imperatriz Airport",
    city: "Imperatriz",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -5.531944,
    longitude: -47.480556,
    icao: "SBIZ"
  },
  IMT: {
    iata: "IMT",
    name: "Ford Airport",
    city: "Iron Mountain",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 45.815556,
    longitude: -88.114167,
    icao: "KIMT"
  },
  INB: {
    iata: "INB",
    name: "Independence Airport",
    city: "Independence",
    countryId: "BZ",
    timeZoneRegionName: "America/Belize",
    latitude: 16.535536,
    longitude: -88.43826,
    icao: ""
  },
  INC: {
    iata: "INC",
    name: "Yinchuan Hedong International Airport",
    city: "Yinchuan",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 38.323031,
    longitude: 106.388059,
    icao: "ZLIC"
  },
  IND: {
    iata: "IND",
    name: "Indianapolis International Airport",
    city: "Indianapolis",
    countryId: "US",
    timeZoneRegionName: "America/Indiana/Indianapolis",
    latitude: 39.71627,
    longitude: -86.292991,
    icao: "KIND"
  },
  INF: {
    iata: "INF",
    name: "In Guezzam Airport",
    city: "In Guezzam",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 19.560488,
    longitude: 5.749467,
    icao: "DATG"
  },
  ING: {
    iata: "ING",
    name: "Lago Argentino Airport",
    city: "Lago Argentino",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -50.583333,
    longitude: -72.666667,
    icao: "SAWA"
  },
  INH: {
    iata: "INH",
    name: "Inhambane Airport",
    city: "Inhambane",
    countryId: "MZ",
    timeZoneRegionName: "Africa/Maputo",
    latitude: -23.874444,
    longitude: 35.408333,
    icao: "FQIN"
  },
  INI: {
    iata: "INI",
    name: "Nis Constantine the Great Airport",
    city: "Nis",
    countryId: "RS",
    timeZoneRegionName: "Europe/Belgrade",
    latitude: 43.33717,
    longitude: 21.86548,
    icao: "LYNI"
  },
  INJ: {
    iata: "INJ",
    name: "Injune Airport",
    city: "Injune",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -25.883333,
    longitude: 148.533333,
    icao: "YINJ"
  },
  INK: {
    iata: "INK",
    name: "Wink Airport",
    city: "Wink",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 31.75,
    longitude: -103.15,
    icao: "KINK"
  },
  INL: {
    iata: "INL",
    name: "Falls International Airport",
    city: "International Falls",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 48.563056,
    longitude: -93.404167,
    icao: "KINL"
  },
  INM: {
    iata: "INM",
    name: "Innamincka Airport",
    city: "Innamincka",
    countryId: "AU",
    timeZoneRegionName: "Australia/Adelaide",
    latitude: -27.75,
    longitude: 140.733333,
    icao: "YINN"
  },
  INN: {
    iata: "INN",
    name: "Innsbruck Airport",
    city: "Innsbruck",
    countryId: "AT",
    timeZoneRegionName: "Europe/Vienna",
    latitude: 47.25745,
    longitude: 11.351467,
    icao: "LOWI"
  },
  INO: {
    iata: "INO",
    name: "Inongo Airport",
    city: "Inongo",
    countryId: "CD",
    timeZoneRegionName: "Africa/Kinshasa",
    latitude: -1.95,
    longitude: 18.279167,
    icao: "FZBA"
  },
  INQ: {
    iata: "INQ",
    name: "Inisheer Airport",
    city: "Inisheer",
    countryId: "IE",
    timeZoneRegionName: "Europe/Dublin",
    latitude: 53.033333,
    longitude: -9.433333,
    icao: "EIIR"
  },
  INS: {
    iata: "INS",
    name: "Af Aux Airport",
    city: "Indian Springs",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 36.583333,
    longitude: -115.666667,
    icao: "KINS"
  },
  INT: {
    iata: "INT",
    name: "Smith-Reynolds Airport",
    city: "Winston-Salem",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 36.135278,
    longitude: -80.225556,
    icao: "KINT"
  },
  INU: {
    iata: "INU",
    name: "Nauru Island International Airport",
    city: "Nauru Island",
    countryId: "NR",
    timeZoneRegionName: "Pacific/Nauru",
    latitude: -0.547451,
    longitude: 166.919023,
    icao: "ANYN"
  },
  INV: {
    iata: "INV",
    name: "Inverness Airport",
    city: "Inverness",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 57.539346,
    longitude: -4.063738,
    icao: "EGPE"
  },
  INW: {
    iata: "INW",
    name: "Winslow Airport",
    city: "Winslow",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 35.024167,
    longitude: -110.725,
    icao: "KINW"
  },
  INZ: {
    iata: "INZ",
    name: "In Salah Airport",
    city: "In Salah",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 27.250807,
    longitude: 2.511885,
    icao: "DAUI"
  },
  IOA: {
    iata: "IOA",
    name: "Ioannina Airport",
    city: "Ioannina",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 39.696667,
    longitude: 20.825833,
    icao: "LGIO"
  },
  IOB: {
    iata: "IOB",
    name: "Innsbruck Railway Station",
    city: "Innsbruck",
    countryId: "AT",
    timeZoneRegionName: "Europe/Vienna",
    latitude: 47.2628,
    longitude: 11.4011,
    icao: ""
  },
  IOM: {
    iata: "IOM",
    name: "Isle of Man Airport",
    city: "Isle Of Man",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 54.086795,
    longitude: -4.633191,
    icao: "EGNS"
  },
  ION: {
    iata: "ION",
    name: "Impfondo Airport",
    city: "Impfondo",
    countryId: "CG",
    timeZoneRegionName: "Africa/Brazzaville",
    latitude: 1.613333,
    longitude: 18.061944,
    icao: "FCOI"
  },
  IOQ: {
    iata: "IOQ",
    name: "Isortoq Heliport",
    city: "Isortoq",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 65.54665,
    longitude: -38.977981,
    icao: "BGIS"
  },
  IOS: {
    iata: "IOS",
    name: "Ilheus/Bahia-Jorge Amado Airport",
    city: "Ilheus",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -14.815859,
    longitude: -39.033268,
    icao: "SBIL"
  },
  IOT: {
    iata: "IOT",
    name: "Illorsuit Heliport",
    city: "Illorsuit",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 71.23977,
    longitude: -53.555393,
    icao: "BGLL"
  },
  IOW: {
    iata: "IOW",
    name: "Iowa City Airport",
    city: "Iowa City",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.666667,
    longitude: -91.533333,
    icao: "KIOW"
  },
  IPA: {
    iata: "IPA",
    name: "Ipota Airport",
    city: "Ipota",
    countryId: "VU",
    timeZoneRegionName: "Pacific/Efate",
    latitude: -18.75,
    longitude: 169.183333,
    icao: "NVVI"
  },
  IPC: {
    iata: "IPC",
    name: "Mataveri International Airport",
    city: "Easter Island",
    countryId: "CL",
    timeZoneRegionName: "Pacific/Easter",
    latitude: -27.116667,
    longitude: -109.366667,
    icao: "SCIP"
  },
  IPG: {
    iata: "IPG",
    name: "Ipiranga Airport",
    city: "Ipiranga",
    countryId: "BR",
    timeZoneRegionName: "America/Porto_Velho",
    latitude: -3.216667,
    longitude: -65.95,
    icao: "SWII"
  },
  IPH: {
    iata: "IPH",
    name: "Ipoh Airport",
    city: "Ipoh",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 4.566944,
    longitude: 101.095833,
    icao: "WMKI"
  },
  IPI: {
    iata: "IPI",
    name: "San Luis Airport",
    city: "Ipiales",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 0.858325,
    longitude: -77.676418,
    icao: "SKIP"
  },
  IPL: {
    iata: "IPL",
    name: "Imperial County Airport",
    city: "Imperial",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 32.834832,
    longitude: -115.574054,
    icao: "KIPL"
  },
  IPN: {
    iata: "IPN",
    name: "Usiminas Airport",
    city: "Ipatinga",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -19.5,
    longitude: -42.533333,
    icao: "SBIP"
  },
  IPT: {
    iata: "IPT",
    name: "Lycoming County Airport",
    city: "Williamsport",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.242222,
    longitude: -76.920556,
    icao: "KIPT"
  },
  IQM: {
    iata: "IQM",
    name: "Qiemo Airport",
    city: "Qiemo",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 38.144572,
    longitude: 85.531552,
    icao: "ZWCM"
  },
  IQN: {
    iata: "IQN",
    name: "Qingyang Airport",
    city: "Qingyang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 35.8001,
    longitude: 107.6044,
    icao: "ZLQY"
  },
  IQQ: {
    iata: "IQQ",
    name: "Diego Aracena International Airport",
    city: "Iquique",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -20.547938,
    longitude: -70.178481,
    icao: "SCDA"
  },
  IQT: {
    iata: "IQT",
    name: "C.F. Secada Vignetta International Airport",
    city: "Iquitos",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -3.785098,
    longitude: -73.302838,
    icao: "SPQT"
  },
  IRA: {
    iata: "IRA",
    name: "Kirakira Airport",
    city: "Kirakira",
    countryId: "SB",
    timeZoneRegionName: "Pacific/Guadalcanal",
    latitude: -10.5,
    longitude: 161.833333,
    icao: "AGGK"
  },
  IRC: {
    iata: "IRC",
    name: "Circle City Airport",
    city: "Circle",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 65.829167,
    longitude: -144.063889,
    icao: "SCIR"
  },
  IRD: {
    iata: "IRD",
    name: "Ishurdi Airport",
    city: "Ishurdi",
    countryId: "BD",
    timeZoneRegionName: "Asia/Dhaka",
    latitude: 24.153424,
    longitude: 89.048828,
    icao: "VGIS"
  },
  IRE: {
    iata: "IRE",
    name: "Irece Airport",
    city: "Irece",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -11.3,
    longitude: -41.866667,
    icao: "SNIC"
  },
  IRG: {
    iata: "IRG",
    name: "Lockhart River Airport",
    city: "Lockhart River",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -12.785644,
    longitude: 143.305822,
    icao: "YLHR"
  },
  IRI: {
    iata: "IRI",
    name: "Nduli Airport",
    city: "Iringa",
    countryId: "TZ",
    timeZoneRegionName: "Africa/Dar_es_Salaam",
    latitude: -7.676324,
    longitude: 35.751589,
    icao: "HTIR"
  },
  IRJ: {
    iata: "IRJ",
    name: "La Rioja Airport",
    city: "La Rioja",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -29.383333,
    longitude: -66.783333,
    icao: "SANL"
  },
  IRK: {
    iata: "IRK",
    name: "Kirksville Municipal Airport",
    city: "Kirksville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 40.0925,
    longitude: -92.543889,
    icao: "KIRK"
  },
  IRM: {
    iata: "IRM",
    name: "Igrim Airport",
    city: "Igrim",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yekaterinburg",
    latitude: 63.199993,
    longitude: 64.435751,
    icao: "USHI"
  },
  IRO: {
    iata: "IRO",
    name: "Birao Airport",
    city: "Birao",
    countryId: "CF",
    timeZoneRegionName: "Africa/Bangui",
    latitude: 10.186389,
    longitude: 22.713889,
    icao: "FEFI"
  },
  IRP: {
    iata: "IRP",
    name: "Matari Airport",
    city: "Isiro",
    countryId: "CD",
    timeZoneRegionName: "Africa/Lubumbashi",
    latitude: 2.8275,
    longitude: 27.588333,
    icao: "FZJH"
  },
  IRS: {
    iata: "IRS",
    name: "Kirsch Municipal",
    city: "Sturgis",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.816667,
    longitude: -85.435278,
    icao: "KIRS"
  },
  ISA: {
    iata: "ISA",
    name: "Mount Isa Airport",
    city: "Mount Isa",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -20.667637,
    longitude: 139.491792,
    icao: "YBMA"
  },
  ISB: {
    iata: "ISB",
    name: "Islamabad International Airport",
    city: "Islamabad",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 33.548333,
    longitude: 72.825,
    icao: "OPIS"
  },
  ISC: {
    iata: "ISC",
    name: "Isles of Scilly Airport",
    city: "Isles Of Scilly",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 49.913333,
    longitude: -6.291667,
    icao: "EGHE"
  },
  ISE: {
    iata: "ISE",
    name: "Isparta Suleyman Demirel Airport",
    city: "Isparta",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 37.866111,
    longitude: 30.382222,
    icao: "LTFC"
  },
  ISG: {
    iata: "ISG",
    name: "Painushima Ishigaki Airport",
    city: "Ishigaki",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 24.390349,
    longitude: 124.245538,
    icao: "ROIG"
  },
  ISI: {
    iata: "ISI",
    name: "Isisford Airport",
    city: "Isisford",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -24.263333,
    longitude: 144.423333,
    icao: "YISF"
  },
  ISJ: {
    iata: "ISJ",
    name: "Isla Mujeres Airport",
    city: "Isla Mujeres",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 21.246669,
    longitude: -86.741363,
    icao: "MMIM"
  },
  ISK: {
    iata: "ISK",
    name: "Ozar Airport",
    city: "Ozar",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 20.119548,
    longitude: 73.913354,
    icao: "VAOZ"
  },
  ISL: {
    iata: "ISL",
    name: "Istanbul Ataturk Airport",
    city: "Istanbul",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 40.976667,
    longitude: 28.815278,
    icao: "LTBA"
  },
  ISM: {
    iata: "ISM",
    name: "Kissimmee Gateway Airport",
    city: "Kissimmee",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 28.29093,
    longitude: -81.435014,
    icao: "KISM"
  },
  ISN: {
    iata: "ISN",
    name: "Sloulin Field International Airport",
    city: "Williston",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 48.175867,
    longitude: -103.631886,
    icao: "KISN"
  },
  ISO: {
    iata: "ISO",
    name: "Kinston Regional Jetport",
    city: "Kinston",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 35.326667,
    longitude: -77.616667,
    icao: "KISO"
  },
  ISP: {
    iata: "ISP",
    name: "Long Island MacArthur Airport",
    city: "Islip",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.789314,
    longitude: -73.097546,
    icao: "KISP"
  },
  ISQ: {
    iata: "ISQ",
    name: "Schoolcraft County Airport",
    city: "Manistique",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 45.95,
    longitude: -86.25,
    icao: "KISQ"
  },
  ISS: {
    iata: "ISS",
    name: "Wiscasset Airport",
    city: "Wiscasset",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 43.961399,
    longitude: -69.712601,
    icao: "KIWI"
  },
  IST: {
    iata: "IST",
    name: "Istanbul Airport",
    city: "Istanbul",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 41.260278,
    longitude: 28.741944,
    icao: "LTFM"
  },
  ISU: {
    iata: "ISU",
    name: "Sulaimaniyah International Airport",
    city: "Sulaimaniyah",
    countryId: "IQ",
    timeZoneRegionName: "Asia/Baghdad",
    latitude: 35.572389,
    longitude: 45.302424,
    icao: "ORSU"
  },
  ISW: {
    iata: "ISW",
    name: "South Wood County Airport",
    city: "Wisconsin Rapids",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 44.360278,
    longitude: -89.838889,
    icao: "KISW"
  },
  ITA: {
    iata: "ITA",
    name: "Itacoatiara Airport",
    city: "Itacoatiara",
    countryId: "BR",
    timeZoneRegionName: "America/Porto_Velho",
    latitude: -3.133333,
    longitude: -58.416667,
    icao: "SBIC"
  },
  ITB: {
    iata: "ITB",
    name: "Itaituba Airport",
    city: "Itaituba",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -4.283333,
    longitude: -55.983333,
    icao: "SBIH"
  },
  ITH: {
    iata: "ITH",
    name: "Ithaca Tompkins Regional Airport",
    city: "Ithaca",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.490342,
    longitude: -76.463593,
    icao: "KITH"
  },
  ITI: {
    iata: "ITI",
    name: "Itambacuri Airport",
    city: "Itambacuri",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -18,
    longitude: -41.5,
    icao: "SNYH"
  },
  ITM: {
    iata: "ITM",
    name: "Itami Airport",
    city: "Osaka",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 34.790975,
    longitude: 135.441719,
    icao: "RJOO"
  },
  ITN: {
    iata: "ITN",
    name: "Itabuna Airport",
    city: "Itabuna",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -14.8,
    longitude: -39.3,
    icao: "SNHA"
  },
  ITO: {
    iata: "ITO",
    name: "Hilo International Airport",
    city: "Hilo",
    countryId: "US",
    timeZoneRegionName: "Pacific/Honolulu",
    latitude: 19.714565,
    longitude: -155.039628,
    icao: "PHTO"
  },
  ITQ: {
    iata: "ITQ",
    name: "Itaqui Airport",
    city: "Itaqui",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -29.133333,
    longitude: -56.55,
    icao: "SSIQ"
  },
  ITU: {
    iata: "ITU",
    name: "Iturup Airport",
    city: "Iturup Island",
    countryId: "RU",
    timeZoneRegionName: "Asia/Ust-Nera",
    latitude: 45.259148,
    longitude: 147.95405,
    icao: ""
  },
  IUE: {
    iata: "IUE",
    name: "Hanan Airport",
    city: "Niue Island",
    countryId: "NU",
    timeZoneRegionName: "Pacific/Niue",
    latitude: -19.083333,
    longitude: -169.933333,
    icao: "NIUE"
  },
  IUI: {
    iata: "IUI",
    name: "Innarsuit Heliport",
    city: "Innarsuit",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 73.202364,
    longitude: -56.011326,
    icao: "BGIN"
  },
  IVA: {
    iata: "IVA",
    name: "Ambanja Airport",
    city: "Ambanja",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -13.642222,
    longitude: 48.457778,
    icao: "FMNJ"
  },
  IVC: {
    iata: "IVC",
    name: "Invercargill Airport",
    city: "Invercargill",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -46.415432,
    longitude: 168.321743,
    icao: "NZNV"
  },
  IVL: {
    iata: "IVL",
    name: "Ivalo Airport",
    city: "Ivalo",
    countryId: "FI",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 68.611111,
    longitude: 27.415556,
    icao: "EFIV"
  },
  IVR: {
    iata: "IVR",
    name: "Inverell Airport",
    city: "Inverell",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -29.887945,
    longitude: 151.144681,
    icao: "YIVL"
  },
  IWA: {
    iata: "IWA",
    name: "Ivanovo Yuzhny Airport",
    city: "Ivanovo",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 56.942956,
    longitude: 40.944546,
    icao: "UUBI"
  },
  IWD: {
    iata: "IWD",
    name: "Gogebic County Airport",
    city: "Ironwood",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 46.525556,
    longitude: -90.131667,
    icao: "KIWD"
  },
  IWJ: {
    iata: "IWJ",
    name: "Hagi-Iwami Airport",
    city: "Masuda",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 34.676389,
    longitude: 131.790278,
    icao: "RJOW"
  },
  IWK: {
    iata: "IWK",
    name: "Iwakuni Kintaikyo Airport",
    city: "Iwakuni",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 34.135277,
    longitude: 132.23555,
    icao: "RJOI"
  },
  IWO: {
    iata: "IWO",
    name: "Iwoto (Iwo Jima) Air Base",
    city: "Iwoto (Iwo Jima)",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 24.783333,
    longitude: 141.316667,
    icao: "RJAW"
  },
  IWS: {
    iata: "IWS",
    name: "West Houston Airport",
    city: "Houston",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 29.816667,
    longitude: -95.666667,
    icao: "KIWS"
  },
  IXA: {
    iata: "IXA",
    name: "Agartala Airport",
    city: "Agartala",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 23.8926,
    longitude: 91.244513,
    icao: "VEAT"
  },
  IXB: {
    iata: "IXB",
    name: "Bagdogra Airport",
    city: "Bagdogra",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 26.68488,
    longitude: 88.324816,
    icao: "VEBD"
  },
  IXC: {
    iata: "IXC",
    name: "Chandigarh Airport",
    city: "Chandigarh",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 30.676809,
    longitude: 76.788039,
    icao: "VICG"
  },
  IXD: {
    iata: "IXD",
    name: "Allahabad Airport",
    city: "Allahabad",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 25.440072,
    longitude: 81.733876,
    icao: "VEAB"
  },
  IXE: {
    iata: "IXE",
    name: "Mangalore Airport",
    city: "Mangalore",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 12.963543,
    longitude: 74.890141,
    icao: "VOML"
  },
  IXG: {
    iata: "IXG",
    name: "Belgaum Airport",
    city: "Belgaum",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 15.858611,
    longitude: 74.618333,
    icao: "VOBM"
  },
  IXH: {
    iata: "IXH",
    name: "Kailashahar Airport",
    city: "Kailashahar",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 24.307222,
    longitude: 92.008889,
    icao: "VEKR"
  },
  IXI: {
    iata: "IXI",
    name: "Lilabari Airport",
    city: "Lilabari",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 27.288274,
    longitude: 94.092061,
    icao: "VELR"
  },
  IXJ: {
    iata: "IXJ",
    name: "Satwari Airport",
    city: "Jammu",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 32.68077,
    longitude: 74.842824,
    icao: "VIJU"
  },
  IXK: {
    iata: "IXK",
    name: "Keshod Airport",
    city: "Keshod",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 21.319444,
    longitude: 70.270833,
    icao: "VAKS"
  },
  IXL: {
    iata: "IXL",
    name: "Leh Airport",
    city: "Leh",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 34.140351,
    longitude: 77.547465,
    icao: "VILH"
  },
  IXM: {
    iata: "IXM",
    name: "Madurai Airport",
    city: "Madurai",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 9.838571,
    longitude: 78.089494,
    icao: "VOMD"
  },
  IXP: {
    iata: "IXP",
    name: "Pathankot Airport",
    city: "Pathankot",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 32.233889,
    longitude: 75.634631,
    icao: "VIPK"
  },
  IXQ: {
    iata: "IXQ",
    name: "Kamalpur Airport",
    city: "Kamalpur",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 24.1325,
    longitude: 91.815556,
    icao: "VEKM"
  },
  IXR: {
    iata: "IXR",
    name: "Birsa Munda Airport",
    city: "Ranchi",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 23.318192,
    longitude: 85.322851,
    icao: "VERC"
  },
  IXS: {
    iata: "IXS",
    name: "Kumbhirgram Airport",
    city: "Silchar",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 24.916017,
    longitude: 92.979255,
    icao: "VEKU"
  },
  IXT: {
    iata: "IXT",
    name: "Pasighat Airport",
    city: "Pasighat",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 28.068259,
    longitude: 95.335528,
    icao: "VEPG"
  },
  IXU: {
    iata: "IXU",
    name: "Chikkalthana Airport",
    city: "Aurangabad",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 19.866464,
    longitude: 75.397207,
    icao: "VAAU"
  },
  IXW: {
    iata: "IXW",
    name: "Sonari Airport",
    city: "Jamshedpur",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 22.813056,
    longitude: 86.168889,
    icao: "VEJS"
  },
  IXX: {
    iata: "IXX",
    name: "Bidar Airport",
    city: "Bidar",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 17.908081,
    longitude: 77.487142,
    icao: "VOBR"
  },
  IXY: {
    iata: "IXY",
    name: "Kandla Airport",
    city: "Kandla",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 23.111111,
    longitude: 70.104167,
    icao: "VAKE"
  },
  IXZ: {
    iata: "IXZ",
    name: "Port Blair Airport",
    city: "Port Blair",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 11.650083,
    longitude: 92.732267,
    icao: "VOPB"
  },
  IYK: {
    iata: "IYK",
    name: "Kern County Airport",
    city: "Inyokern",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 35.656667,
    longitude: -117.829167,
    icao: "KIYK"
  },
  IZA: {
    iata: "IZA",
    name: "Zona da Mata Regional Airport",
    city: "Juiz de Fora",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -21.513056,
    longitude: -43.173056,
    icao: "SBZM"
  },
  IZE: {
    iata: "IZE",
    name: "Hungriger Wolf Airport",
    city: "Itzehoe",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 53.994446,
    longitude: 9.578611,
    icao: "EDHF"
  },
  IZO: {
    iata: "IZO",
    name: "Izumo Airport",
    city: "Izumo",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 35.41485,
    longitude: 132.885751,
    icao: "RJOC"
  },
  IZT: {
    iata: "IZT",
    name: "Ixtepec Airport",
    city: "Ixtepec",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 16.569167,
    longitude: -95.108333,
    icao: "MMIT"
  },
  JAA: {
    iata: "JAA",
    name: "Jalalabad Airport",
    city: "Jalalabad",
    countryId: "AF",
    timeZoneRegionName: "Asia/Kabul",
    latitude: 34.401257,
    longitude: 70.496824,
    icao: "OAJL"
  },
  JAB: {
    iata: "JAB",
    name: "Jabiru Airport",
    city: "Jabiru",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -12.659722,
    longitude: 132.891944,
    icao: "YJAB"
  },
  JAC: {
    iata: "JAC",
    name: "Jackson Hole Airport",
    city: "Jackson",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 43.602807,
    longitude: -110.736131,
    icao: "KJAC"
  },
  JAD: {
    iata: "JAD",
    name: "Jandakot Airport",
    city: "Jandakot",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -32.083333,
    longitude: 115.883333,
    icao: "YPJT"
  },
  JAE: {
    iata: "JAE",
    name: "Shumba Airport",
    city: "Jaen",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -5.594444,
    longitude: -78.773624,
    icao: "SPJE"
  },
  JAF: {
    iata: "JAF",
    name: "Kankesanturai Airport",
    city: "Jaffna",
    countryId: "LK",
    timeZoneRegionName: "Asia/Colombo",
    latitude: 9.791667,
    longitude: 80.075,
    icao: "VCCJ"
  },
  JAG: {
    iata: "JAG",
    name: "Jacobabad Airport",
    city: "Jacobabad",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 28.3,
    longitude: 68.45,
    icao: "OPJA"
  },
  JAI: {
    iata: "JAI",
    name: "Jaipur Airport",
    city: "Jaipur",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 26.822004,
    longitude: 75.800995,
    icao: "VIJP"
  },
  JAK: {
    iata: "JAK",
    name: "Jacmel Airport",
    city: "Jacmel",
    countryId: "HT",
    timeZoneRegionName: "America/Port-au-Prince",
    latitude: 18.240556,
    longitude: -72.518611,
    icao: "MTJA"
  },
  JAL: {
    iata: "JAL",
    name: "El Lencero Airport",
    city: "Xalapa",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 19.475468,
    longitude: -96.791405,
    icao: "MMJA"
  },
  JAN: {
    iata: "JAN",
    name: "Jackson-Evers International Airport",
    city: "Jackson",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.309896,
    longitude: -90.074955,
    icao: "KJAN"
  },
  JAR: {
    iata: "JAR",
    name: "Jahrom Airport",
    city: "Jahrom",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 28.58668,
    longitude: 53.579188,
    icao: "OISJ"
  },
  JAS: {
    iata: "JAS",
    name: "Jasper County-Bell Field",
    city: "Jasper",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.885701,
    longitude: -94.034907,
    icao: "KJAS"
  },
  JAU: {
    iata: "JAU",
    name: "Jauja Airport",
    city: "Jauja",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -11.75,
    longitude: -75.25,
    icao: "SPJJ"
  },
  JAV: {
    iata: "JAV",
    name: "Ilulissat Airport",
    city: "Ilulissat",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 69.241856,
    longitude: -51.059911,
    icao: "BGJN"
  },
  JAW: {
    iata: "JAW",
    name: "Araripina Airport",
    city: "Araripina",
    countryId: "BR",
    timeZoneRegionName: "America/Recife",
    latitude: -7.585278,
    longitude: -40.535,
    icao: ""
  },
  JAX: {
    iata: "JAX",
    name: "Jacksonville International Airport",
    city: "Jacksonville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 30.491254,
    longitude: -81.683053,
    icao: "KJAX"
  },
  JBB: {
    iata: "JBB",
    name: "Noto Hadinegoro Airport",
    city: "Jember",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: -8.242432,
    longitude: 113.695324,
    icao: "WARE"
  },
  JBQ: {
    iata: "JBQ",
    name: "Dr. Joaquin Balaguer International Airport",
    city: "Santo Domingo",
    countryId: "DO",
    timeZoneRegionName: "America/Santo_Domingo",
    latitude: 18.572517,
    longitude: -69.985611,
    icao: "MDJB"
  },
  JBR: {
    iata: "JBR",
    name: "Jonesboro Airport",
    city: "Jonesboro",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.831711,
    longitude: -90.646418,
    icao: "KJBR"
  },
  JCB: {
    iata: "JCB",
    name: "Joacaba Airport",
    city: "Joacaba",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -27.166667,
    longitude: -51.516667,
    icao: "SSJA"
  },
  JCI: {
    iata: "JCI",
    name: "New Century Aircenter",
    city: "Kansas City",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 38.833932,
    longitude: -94.892235,
    icao: "KIXD"
  },
  JCK: {
    iata: "JCK",
    name: "Julia Creek Airport",
    city: "Julia Creek",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -20.583333,
    longitude: 141.7,
    icao: "YJLC"
  },
  JCM: {
    iata: "JCM",
    name: "Jacobina Airport",
    city: "Jacobina",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -11.183333,
    longitude: -40.516667,
    icao: "SNJB"
  },
  JCR: {
    iata: "JCR",
    name: "Jacareacanga Airport",
    city: "Jacareacanga",
    countryId: "BR",
    timeZoneRegionName: "America/Porto_Velho",
    latitude: -5.983333,
    longitude: -57.533333,
    icao: "SBEK"
  },
  JCT: {
    iata: "JCT",
    name: "Kimble County Airport",
    city: "Junction",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.483333,
    longitude: -99.766667,
    icao: "KJCT"
  },
  JCY: {
    iata: "JCY",
    name: "Johnson Airport",
    city: "Johnson",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.283333,
    longitude: -98.416667,
    icao: "KJCY"
  },
  JDF: {
    iata: "JDF",
    name: "Francisco De Assis Airport",
    city: "Juiz De Fora",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -21.75,
    longitude: -43.333333,
    icao: "SBJF"
  },
  JDH: {
    iata: "JDH",
    name: "Jodhpur Airport",
    city: "Jodhpur",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 26.263948,
    longitude: 73.050552,
    icao: "VIJO"
  },
  JDN: {
    iata: "JDN",
    name: "Jordan Airport",
    city: "Jordan",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 47.316667,
    longitude: -106.883333,
    icao: "KJDN"
  },
  JDO: {
    iata: "JDO",
    name: "Orlando Bezerra de Menezes Airport",
    city: "Juazeiro Do Norte",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -7.21559,
    longitude: -39.272404,
    icao: "SBJU"
  },
  JDR: {
    iata: "JDR",
    name: "Sao Joao Del Rei Airport",
    city: "Sao Joao Del Rei",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -21.087957,
    longitude: -44.230097,
    icao: "SNJR"
  },
  JDZ: {
    iata: "JDZ",
    name: "Jingdezhen Airport",
    city: "Jingdezhen",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 29.335489,
    longitude: 117.17879,
    icao: "ZSJD"
  },
  JED: {
    iata: "JED",
    name: "King Abdulaziz International Airport",
    city: "Jeddah",
    countryId: "SA",
    timeZoneRegionName: "Asia/Riyadh",
    latitude: 21.670232,
    longitude: 39.150579,
    icao: "OEJN"
  },
  JEE: {
    iata: "JEE",
    name: "Jeremie Airport",
    city: "Jeremie",
    countryId: "HT",
    timeZoneRegionName: "America/Port-au-Prince",
    latitude: 18.662222,
    longitude: -74.169722,
    icao: "MTJE"
  },
  JEF: {
    iata: "JEF",
    name: "Jefferson City Memorial Airport",
    city: "Jefferson City",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 38.592222,
    longitude: -92.156389,
    icao: "KJEF"
  },
  JEG: {
    iata: "JEG",
    name: "Aasiaat Airport",
    city: "Aasiaat",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 68.7,
    longitude: -52.75,
    icao: "BGEM"
  },
  JEK: {
    iata: "JEK",
    name: "Jeki Airstrip",
    city: "Jeki",
    countryId: "ZM",
    timeZoneRegionName: "Africa/Lusaka",
    latitude: -15.633121,
    longitude: 29.603555,
    icao: "FLJK"
  },
  JEQ: {
    iata: "JEQ",
    name: "Jequie Airport",
    city: "Jequie",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -13.85,
    longitude: -40.083333,
    icao: "SNJK"
  },
  JER: {
    iata: "JER",
    name: "Jersey Airport",
    city: "Jersey",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 49.205297,
    longitude: -2.194344,
    icao: "EGJJ"
  },
  JFK: {
    iata: "JFK",
    name: "John F. Kennedy International Airport",
    city: "New York",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.642335,
    longitude: -73.78817,
    icao: "KJFK"
  },
  JFR: {
    iata: "JFR",
    name: "Paamiut Airport",
    city: "Paamiut",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 62.014735,
    longitude: -49.670949,
    icao: "BGPT"
  },
  JGA: {
    iata: "JGA",
    name: "Govardhanpur Airport",
    city: "Jamnagar",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 22.463333,
    longitude: 70.011944,
    icao: "VAJM"
  },
  JGB: {
    iata: "JGB",
    name: "Jagdalpur Airport",
    city: "Jagdalpur",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 19.066667,
    longitude: 82.033333,
    icao: ""
  },
  JGD: {
    iata: "JGD",
    name: "Jiagedaqi Airport",
    city: "Jiagedaqi District",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 50.370556,
    longitude: 124.11667,
    icao: ""
  },
  JGN: {
    iata: "JGN",
    name: "Jiayuguan Airport",
    city: "Jiayuguan",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 39.856988,
    longitude: 98.341401,
    icao: "ZLJQ"
  },
  JGS: {
    iata: "JGS",
    name: "Ji'an Jinggangshan Airport",
    city: "Ji'An",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 26.856899,
    longitude: 114.737,
    icao: "ZSJA"
  },
  JHB: {
    iata: "JHB",
    name: "Senai Airport",
    city: "Johor Bharu",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 1.63668,
    longitude: 103.667959,
    icao: "WMKJ"
  },
  JHG: {
    iata: "JHG",
    name: "Jinghong Xishuangbanna Gasa International Airport",
    city: "Jinghong",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 21.973422,
    longitude: 100.766454,
    icao: "ZPJH"
  },
  JHM: {
    iata: "JHM",
    name: "Kapalua Airport",
    city: "Kapalua",
    countryId: "US",
    timeZoneRegionName: "Pacific/Honolulu",
    latitude: 20.962194,
    longitude: -156.675692,
    icao: "PHJH"
  },
  JHS: {
    iata: "JHS",
    name: "Sisimiut Airport",
    city: "Sisimiut",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 66.951304,
    longitude: -53.729291,
    icao: "BGSS"
  },
  JHW: {
    iata: "JHW",
    name: "Jamestown Airport",
    city: "Jamestown",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.150556,
    longitude: -79.258056,
    icao: "KJHW"
  },
  JIA: {
    iata: "JIA",
    name: "Juina Airport",
    city: "Juina",
    countryId: "BR",
    timeZoneRegionName: "America/Campo_Grande",
    latitude: -11.418348,
    longitude: -58.710139,
    icao: "SWJN"
  },
  JIB: {
    iata: "JIB",
    name: "Djibouti-Ambouli International Airport",
    city: "Djibouti",
    countryId: "DJ",
    timeZoneRegionName: "Africa/Djibouti",
    latitude: 11.552361,
    longitude: 43.149678,
    icao: "HDAM"
  },
  JIC: {
    iata: "JIC",
    name: "Jinchang Jinchuan Airport",
    city: "Jinchang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 38.541943,
    longitude: 102.34861,
    icao: ""
  },
  JIJ: {
    iata: "JIJ",
    name: "Jijiga Airport",
    city: "Jijiga",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 9.366667,
    longitude: 42.766667,
    icao: "HAJJ"
  },
  JIK: {
    iata: "JIK",
    name: "Ikaria Airport",
    city: "Ikaria Island",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 37.666667,
    longitude: 26.333333,
    icao: "LGIK"
  },
  JIM: {
    iata: "JIM",
    name: "Jimma Airport",
    city: "Jimma",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 7.654444,
    longitude: 36.821111,
    icao: "HAJM"
  },
  JIN: {
    iata: "JIN",
    name: "Jinja Airport",
    city: "Jinja",
    countryId: "UG",
    timeZoneRegionName: "Africa/Kampala",
    latitude: 0.456389,
    longitude: 33.192222,
    icao: "HUJI"
  },
  JIO: {
    iata: "JIO",
    name: "Jos Orno Imsula Airport",
    city: "Tiakur",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jayapura",
    latitude: -8.140276,
    longitude: 127.908115,
    icao: "WAPM"
  },
  JIQ: {
    iata: "JIQ",
    name: "Qianjiang Wulingshan Airport",
    city: "Qianjiang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 29.517558,
    longitude: 108.829189,
    icao: ""
  },
  JIU: {
    iata: "JIU",
    name: "Jiujiang Lushan Airport",
    city: "Jiujiang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 29.7,
    longitude: 115.966667,
    icao: "ZSJJ"
  },
  JIW: {
    iata: "JIW",
    name: "Jiwani Airport",
    city: "Jiwani",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 25.083333,
    longitude: 61.816667,
    icao: "OPJI"
  },
  JJA: {
    iata: "JJA",
    name: "Jajao Airport",
    city: "Santa Isabel Island",
    countryId: "SB",
    timeZoneRegionName: "Pacific/Guadalcanal",
    latitude: -8.21666,
    longitude: 159.26666,
    icao: "AGJO"
  },
  JJD: {
    iata: "JJD",
    name: "Jericoacoara Airport",
    city: "Cruz",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -2.906667,
    longitude: -40.358056,
    icao: "SBJE"
  },
  JJG: {
    iata: "JJG",
    name: "Humberto Bortoluzzi Regional Airport",
    city: "Jaguaruna",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -28.675278,
    longitude: -49.060278,
    icao: "SBJA"
  },
  JJI: {
    iata: "JJI",
    name: "Juanjui Airport",
    city: "Juanjui",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -7.15,
    longitude: -76.716667,
    icao: "SPJI"
  },
  JJM: {
    iata: "JJM",
    name: "Mulika Lodge Airport",
    city: "Meru",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: 0.165006,
    longitude: 38.195025,
    icao: "HKMK"
  },
  JJN: {
    iata: "JJN",
    name: "Quanzhou Jinjiang International Airport",
    city: "Jinjiang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 24.802809,
    longitude: 118.587293,
    icao: "ZSQZ"
  },
  JKG: {
    iata: "JKG",
    name: "Jonkoping Airport",
    city: "Jonkoping",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 57.750101,
    longitude: 14.070497,
    icao: "ESGJ"
  },
  JKH: {
    iata: "JKH",
    name: "Chios Airport",
    city: "Chios",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 38.345795,
    longitude: 26.142335,
    icao: "LGHI"
  },
  JKL: {
    iata: "JKL",
    name: "Kalymnos Island National Airport",
    city: "Kalymnos",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 36.963333,
    longitude: 26.940556,
    icao: "LGKY"
  },
  JKR: {
    iata: "JKR",
    name: "Janakpur Airport",
    city: "Janakpur",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 26.708333,
    longitude: 85.923889,
    icao: "VNJP"
  },
  JLD: {
    iata: "JLD",
    name: "Landskrona Heliport",
    city: "Landskrona",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 56.05,
    longitude: 12.7,
    icao: "ESML"
  },
  JLG: {
    iata: "JLG",
    name: "Jalgaon Airport",
    city: "Jalgaon",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 20.962678,
    longitude: 75.627492,
    icao: "VAJL"
  },
  JLN: {
    iata: "JLN",
    name: "Joplin Airport",
    city: "Joplin",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 37.149722,
    longitude: -94.497778,
    icao: "KJLN"
  },
  JLR: {
    iata: "JLR",
    name: "Jabalpur Airport",
    city: "Jabalpur",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 23.17778,
    longitude: 80.05194,
    icao: "VAJB"
  },
  JLS: {
    iata: "JLS",
    name: "Jales Airport",
    city: "Jales",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -20.166667,
    longitude: -50.55,
    icao: "SDJL"
  },
  JMA: {
    iata: "JMA",
    name: "Manhuacu Elias Breder Airport",
    city: "Manhuacu",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -20.25972,
    longitude: -42.18389,
    icao: ""
  },
  JMJ: {
    iata: "JMJ",
    name: "Lancang Jingmai Airport",
    city: "Lancang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 22.417494,
    longitude: 99.784156,
    icao: ""
  },
  JMK: {
    iata: "JMK",
    name: "Mikonos Airport",
    city: "Mikonos",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 37.436111,
    longitude: 25.344444,
    icao: "LGMK"
  },
  JMO: {
    iata: "JMO",
    name: "Jomsom Airport",
    city: "Jomsom",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 28.781429,
    longitude: 83.723397,
    icao: "VNJS"
  },
  JMS: {
    iata: "JMS",
    name: "Jamestown Airport",
    city: "Jamestown",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 46.93,
    longitude: -98.678333,
    icao: "KJMS"
  },
  JMU: {
    iata: "JMU",
    name: "Jiamusi Airport",
    city: "Jiamusi",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 46.845396,
    longitude: 130.455408,
    icao: "ZYJM"
  },
  JNA: {
    iata: "JNA",
    name: "Januaria Airport",
    city: "Januaria",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -15.474167,
    longitude: -44.385833,
    icao: "SNJN"
  },
  JNB: {
    iata: "JNB",
    name: "O.R. Tambo International Airport",
    city: "Johannesburg",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -26.139164,
    longitude: 28.245999,
    icao: "FAOR"
  },
  JNG: {
    iata: "JNG",
    name: "Jining Da'an Airport",
    city: "Jining",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 35.646944,
    longitude: 116.742222,
    icao: "ZSJG"
  },
  JNI: {
    iata: "JNI",
    name: "Junin Airport",
    city: "Junin",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -34.583333,
    longitude: -60.966667,
    icao: "SAAJ"
  },
  JNJ: {
    iata: "JNJ",
    name: "Duqm Jaaluni Airport",
    city: "Duqm",
    countryId: "OM",
    timeZoneRegionName: "Asia/Muscat",
    latitude: 19.48464,
    longitude: 57.314302,
    icao: "OOJA"
  },
  JNN: {
    iata: "JNN",
    name: "Nanortalik Heliport",
    city: "Nanortalik",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 60.141883,
    longitude: -45.232961,
    icao: "BGNN"
  },
  JNU: {
    iata: "JNU",
    name: "Juneau International Airport",
    city: "Juneau",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 58.359323,
    longitude: -134.583395,
    icao: "PAJN"
  },
  JNX: {
    iata: "JNX",
    name: "Naxos Airport",
    city: "Naxos, Cyclades Islands",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 37.1,
    longitude: 25.383333,
    icao: "LGNX"
  },
  JNZ: {
    iata: "JNZ",
    name: "Jinzhou Jinzhouwan Airport",
    city: "Jinzhou",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 41.116667,
    longitude: 121.016667,
    icao: "ZYJZ"
  },
  JOE: {
    iata: "JOE",
    name: "Joensuu Airport",
    city: "Joensuu",
    countryId: "FI",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 62.656788,
    longitude: 29.61354,
    icao: "EFJO"
  },
  JOG: {
    iata: "JOG",
    name: "Adisutjipto International Airport",
    city: "Yogyakarta",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: -7.785572,
    longitude: 110.43706,
    icao: "WARJ"
  },
  JOI: {
    iata: "JOI",
    name: "Lauro Carneiro de Loyola Airport",
    city: "Joinville",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -26.224515,
    longitude: -48.797421,
    icao: "SBJV"
  },
  JOL: {
    iata: "JOL",
    name: "Jolo Airport",
    city: "Jolo",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 6.053552,
    longitude: 121.00653,
    icao: "RPMJ"
  },
  JOM: {
    iata: "JOM",
    name: "Njombe Airport",
    city: "Njombe",
    countryId: "TZ",
    timeZoneRegionName: "Africa/Dar_es_Salaam",
    latitude: -9.354444,
    longitude: 34.771389,
    icao: "HTNJ"
  },
  JOP: {
    iata: "JOP",
    name: "Josephstaal Airport",
    city: "Josephstaal",
    countryId: "PG",
    timeZoneRegionName: "Pacific/Port_Moresby",
    latitude: -4.743933,
    longitude: 145.005797,
    icao: "AYJS"
  },
  JOS: {
    iata: "JOS",
    name: "Jos Airport",
    city: "Jos",
    countryId: "NG",
    timeZoneRegionName: "Africa/Lagos",
    latitude: 9.868056,
    longitude: 8.893056,
    icao: "DNJO"
  },
  JOT: {
    iata: "JOT",
    name: "Joliet Municipal Airport",
    city: "Joliet",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.533333,
    longitude: -88.083333,
    icao: "KJOT"
  },
  JPA: {
    iata: "JPA",
    name: "Presidente Castro Pinto International Airport",
    city: "Joao Pessoa",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -7.145357,
    longitude: -34.948159,
    icao: "SBJP"
  },
  JPE: {
    iata: "JPE",
    name: "Paragominas Airport",
    city: "Paragominas",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -3.021361,
    longitude: -47.319307,
    icao: ""
  },
  JPO: {
    iata: "JPO",
    name: "Patos Brigadeiro Firmino Ayres Airport",
    city: "Patos de Paraiba",
    countryId: "BR",
    timeZoneRegionName: "America/Fortaleza",
    latitude: -7.038944,
    longitude: -37.251769,
    icao: "SNTS"
  },
  JPR: {
    iata: "JPR",
    name: "Ji-Parana Airport",
    city: "Ji-Parana",
    countryId: "BR",
    timeZoneRegionName: "America/Porto_Velho",
    latitude: -10.870556,
    longitude: -61.84667,
    icao: "SWJI"
  },
  JQA: {
    iata: "JQA",
    name: "Mittarfik Qaarsuarsuit Airport",
    city: "Qaarsut",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 70.73548371993061,
    longitude: -52.69676010439323,
    icao: "BGUQ"
  },
  JQE: {
    iata: "JQE",
    name: "Jaque Airport",
    city: "Jaque",
    countryId: "PA",
    timeZoneRegionName: "America/Panama",
    latitude: 7.5,
    longitude: -78.166667,
    icao: "MPJE"
  },
  JRF: {
    iata: "JRF",
    name: "Kalaeloa Airport",
    city: "Kapolei",
    countryId: "US",
    timeZoneRegionName: "Pacific/Honolulu",
    latitude: 21.310984,
    longitude: -158.079899,
    icao: "PHJR"
  },
  JRG: {
    iata: "JRG",
    name: "Veer Surendra Sai Airport",
    city: "Jharsuguda",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 21.912951,
    longitude: 84.050091,
    icao: "VEJH"
  },
  JRH: {
    iata: "JRH",
    name: "Rowriah Airport",
    city: "Jorhat",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 26.734483,
    longitude: 94.184902,
    icao: "VEJT"
  },
  JRJ: {
    iata: "JRJ",
    name: "Ganzhou Ruijin Airport",
    city: "Ruijin",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 25.9606,
    longitude: 116.0778,
    icao: ""
  },
  JRN: {
    iata: "JRN",
    name: "Juruena Airport",
    city: "Juruena",
    countryId: "BR",
    timeZoneRegionName: "America/Campo_Grande",
    latitude: -10.305556,
    longitude: -58.488889,
    icao: "SWJU"
  },
  JRO: {
    iata: "JRO",
    name: "Kilimanjaro International Airport",
    city: "Kilimanjaro",
    countryId: "TZ",
    timeZoneRegionName: "Africa/Dar_es_Salaam",
    latitude: -3.42537,
    longitude: 37.065475,
    icao: "HTKJ"
  },
  JRS: {
    iata: "JRS",
    name: "Jerusalem Airport",
    city: "Jerusalem",
    countryId: "IL",
    timeZoneRegionName: "Asia/Jerusalem",
    latitude: 31.8675,
    longitude: 35.214444,
    icao: "LLJR"
  },
  JSA: {
    iata: "JSA",
    name: "Jaisalmer Airport",
    city: "Jaisalmer",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 26.8887005,
    longitude: 70.8649979,
    icao: "VIJR"
  },
  JSH: {
    iata: "JSH",
    name: "Sitia Airport",
    city: "Sitia",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 35.216667,
    longitude: 26.116667,
    icao: "LGST"
  },
  JSI: {
    iata: "JSI",
    name: "Skiathos Airport",
    city: "Skiathos",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 39.177101,
    longitude: 23.5037,
    icao: "LGSK"
  },
  JSJ: {
    iata: "JSJ",
    name: "Jiansanjiang Airport",
    city: "Jiansanjiang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 47.108056,
    longitude: 132.656389,
    icao: ""
  },
  JSM: {
    iata: "JSM",
    name: "Jose San de Martin Airport",
    city: "Jose San de Martin",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -44.066667,
    longitude: -70.433333,
    icao: "SAWS"
  },
  JSR: {
    iata: "JSR",
    name: "Jessore Airport",
    city: "Jessore",
    countryId: "BD",
    timeZoneRegionName: "Asia/Dhaka",
    latitude: 23.17696,
    longitude: 89.160648,
    icao: "VGJR"
  },
  JST: {
    iata: "JST",
    name: "Cambria County Airport",
    city: "Johnstown",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.316667,
    longitude: -78.834444,
    icao: "KJST"
  },
  JSU: {
    iata: "JSU",
    name: "Maniitsoq Airport",
    city: "Maniitsoq",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 65.412439,
    longitude: -52.93537,
    icao: "BGMQ"
  },
  JSY: {
    iata: "JSY",
    name: "Syros Island Airport",
    city: "Syros Island",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 37.423611,
    longitude: 24.95,
    icao: "LGSO"
  },
  JTC: {
    iata: "JTC",
    name: "Bauru-Arealva Airport",
    city: "Baura-Arealva",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -22.165959,
    longitude: -49.07229,
    icao: "SJTC"
  },
  JTR: {
    iata: "JTR",
    name: "Santorini International Airport",
    city: "Thira",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 36.404262,
    longitude: 25.475983,
    icao: "LGSR"
  },
  JTY: {
    iata: "JTY",
    name: "Astypalaia Airport",
    city: "Astypalaia Island",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 36.566667,
    longitude: 26.366667,
    icao: "LGPL"
  },
  JUB: {
    iata: "JUB",
    name: "Juba International Airport",
    city: "Juba",
    countryId: "SS",
    timeZoneRegionName: "Africa/Juba",
    latitude: 4.867235,
    longitude: 31.602378,
    icao: "HSSJ"
  },
  JUH: {
    iata: "JUH",
    name: "Chizhou Jiuhuashan Airport",
    city: "Chizhou",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 30.766115,
    longitude: 117.735677,
    icao: ""
  },
  JUI: {
    iata: "JUI",
    name: "Juist Airport",
    city: "Juist",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 53.683333,
    longitude: 7.066667,
    icao: "EDWJ"
  },
  JUJ: {
    iata: "JUJ",
    name: "El Cadillal Airport",
    city: "Jujuy",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -24.4,
    longitude: -65.083333,
    icao: "SASJ"
  },
  JUK: {
    iata: "JUK",
    name: "Ukkusissat Heliport",
    city: "Ukkusissat",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 71.049438,
    longitude: -51.890016,
    icao: "BGUT"
  },
  JUL: {
    iata: "JUL",
    name: "Juliaca Airport",
    city: "Juliaca",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -15.464167,
    longitude: -70.154444,
    icao: "SPJL"
  },
  JUM: {
    iata: "JUM",
    name: "Jumla Airport",
    city: "Jumla",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 29.274403,
    longitude: 82.193278,
    icao: "VNJL"
  },
  JUN: {
    iata: "JUN",
    name: "Jundah Airport",
    city: "Jundah",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -24.833333,
    longitude: 143.066667,
    icao: "YJDA"
  },
  JUU: {
    iata: "JUU",
    name: "Nuugaatsiaq Heliport",
    city: "Nuugaatsiaq",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 71.538769,
    longitude: -53.205038,
    icao: "BGNQ"
  },
  JUV: {
    iata: "JUV",
    name: "Upernavik Airport",
    city: "Upernavik",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 72.790278,
    longitude: -56.130556,
    icao: "BGUK"
  },
  JUZ: {
    iata: "JUZ",
    name: "Quzhou Airport",
    city: "Quzhou, Zhejiang Province",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 28.966667,
    longitude: 118.833333,
    icao: "ZSJU"
  },
  JVA: {
    iata: "JVA",
    name: "Ankavandra Airport",
    city: "Ankavandra",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -18.8,
    longitude: 45.283333,
    icao: "FMMK"
  },
  JVL: {
    iata: "JVL",
    name: "Rock County Airport",
    city: "Janesville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 42.683333,
    longitude: -89.016667,
    icao: "KJVL"
  },
  JWA: {
    iata: "JWA",
    name: "Jwaneng Airport",
    city: "Jwaneng",
    countryId: "BW",
    timeZoneRegionName: "Africa/Gaborone",
    latitude: -24.6,
    longitude: 24.666667,
    icao: "FBJW"
  },
  JWN: {
    iata: "JWN",
    name: "Zanjan Airport",
    city: "Zanjan",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 36.774417,
    longitude: 48.369855,
    icao: "OITZ"
  },
  JXA: {
    iata: "JXA",
    name: "Jixi Airport",
    city: "Jixi",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 45.306082,
    longitude: 130.996745,
    icao: "ZYJX"
  },
  JXN: {
    iata: "JXN",
    name: "Jackson County Airport",
    city: "Jackson",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.258889,
    longitude: -84.461389,
    icao: "KJXN"
  },
  JYR: {
    iata: "JYR",
    name: "Jiroft Airport",
    city: "Jiroft",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 28.7269,
    longitude: 57.6703,
    icao: "OIKJ"
  },
  JYV: {
    iata: "JYV",
    name: "Jyvaskyla Airport",
    city: "Jyvaskyla",
    countryId: "FI",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 62.403623,
    longitude: 25.681431,
    icao: "EFJY"
  },
  JZH: {
    iata: "JZH",
    name: "Jiuzhai Huanglong Airport",
    city: "Jiuzhaigou",
    countryId: "CN",
    timeZoneRegionName: "Asia/Chongqing",
    latitude: 32.8533333,
    longitude: 103.6822222,
    icao: "ZUJZ"
  },
  KAA: {
    iata: "KAA",
    name: "Kasama Airport",
    city: "Kasama",
    countryId: "ZM",
    timeZoneRegionName: "Africa/Lusaka",
    latitude: -10.215833,
    longitude: 31.13,
    icao: "FLKS"
  },
  KAB: {
    iata: "KAB",
    name: "Kariba Airport",
    city: "Kariba",
    countryId: "ZW",
    timeZoneRegionName: "Africa/Harare",
    latitude: -16.518333,
    longitude: 28.885278,
    icao: "FVKB"
  },
  KAC: {
    iata: "KAC",
    name: "Kameshly Airport",
    city: "Kameshli",
    countryId: "SY",
    timeZoneRegionName: "Asia/Damascus",
    latitude: 37.031741,
    longitude: 41.202684,
    icao: "OSKL"
  },
  KAD: {
    iata: "KAD",
    name: "Kaduna Airport",
    city: "Kaduna",
    countryId: "NG",
    timeZoneRegionName: "Africa/Lagos",
    latitude: 10.595833,
    longitude: 7.440278,
    icao: "DNKA"
  },
  KAG: {
    iata: "KAG",
    name: "Gangneung Air Base",
    city: "Gangneung",
    countryId: "KR",
    timeZoneRegionName: "Asia/Seoul",
    latitude: 37.753403,
    longitude: 128.943617,
    icao: "RKNN"
  },
  KAJ: {
    iata: "KAJ",
    name: "Kajaani Airport",
    city: "Kajaani",
    countryId: "FI",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 64.277778,
    longitude: 27.688889,
    icao: "EFKI"
  },
  KAL: {
    iata: "KAL",
    name: "Kaltag Airport",
    city: "Kaltag",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 64.321944,
    longitude: -158.736111,
    icao: "PAKV"
  },
  KAN: {
    iata: "KAN",
    name: "Mallam Aminu Kano International Airport",
    city: "Kano",
    countryId: "NG",
    timeZoneRegionName: "Africa/Lagos",
    latitude: 12.045549,
    longitude: 8.522271,
    icao: "DNKN"
  },
  KAO: {
    iata: "KAO",
    name: "Kuusamo Airport",
    city: "Kuusamo",
    countryId: "FI",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 65.990278,
    longitude: 29.233889,
    icao: "EFKS"
  },
  KAP: {
    iata: "KAP",
    name: "Kapanga Airport",
    city: "Kapanga",
    countryId: "CD",
    timeZoneRegionName: "Africa/Lubumbashi",
    latitude: -8.5,
    longitude: 22.666667,
    icao: "FZSK"
  },
  KAR: {
    iata: "KAR",
    name: "Kamarang Airport",
    city: "Kamarang",
    countryId: "GY",
    timeZoneRegionName: "America/Guyana",
    latitude: 5.869577,
    longitude: -60.616292,
    icao: "SYKM"
  },
  KAT: {
    iata: "KAT",
    name: "Kaitaia Airport",
    city: "Kaitaia",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -35.066285,
    longitude: 173.285414,
    icao: "NZKT"
  },
  KAU: {
    iata: "KAU",
    name: "Kauhava Airport",
    city: "Kauhava",
    countryId: "FI",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 63.1,
    longitude: 23.083333,
    icao: "EFKA"
  },
  KAV: {
    iata: "KAV",
    name: "Kavanayen Airport",
    city: "Kavanayen",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 5.666667,
    longitude: -61.766667,
    icao: "SVKA"
  },
  KAW: {
    iata: "KAW",
    name: "Kawthaung Airport",
    city: "Kawthaung",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 10.05,
    longitude: 98.516667,
    icao: "VYKT"
  },
  KAX: {
    iata: "KAX",
    name: "Kalbarri Airport",
    city: "Kalbarri",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -27.691928,
    longitude: 114.260524,
    icao: "YKBR"
  },
  KBA: {
    iata: "KBA",
    name: "Kabala Airport",
    city: "Kabala",
    countryId: "SL",
    timeZoneRegionName: "Africa/Freetown",
    latitude: 9.333333,
    longitude: -12,
    icao: "GFKB"
  },
  KBC: {
    iata: "KBC",
    name: "Birch Creek Airport",
    city: "Birch Creek",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 66.27592,
    longitude: -145.812969,
    icao: ""
  },
  KBG: {
    iata: "KBG",
    name: "Kabalega Falls Airport",
    city: "Kabalega Falls",
    countryId: "UG",
    timeZoneRegionName: "Africa/Kampala",
    latitude: 2.329142,
    longitude: 31.500894,
    icao: "HUKF"
  },
  KBH: {
    iata: "KBH",
    name: "Kahama Buzwagi Airport",
    city: "Kahama",
    countryId: "TZ",
    timeZoneRegionName: "Africa/Dar_es_Salaam",
    latitude: -3.847053,
    longitude: 32.687081,
    icao: "HTKH"
  },
  KBI: {
    iata: "KBI",
    name: "Kribi Airport",
    city: "Kribi",
    countryId: "CM",
    timeZoneRegionName: "Africa/Douala",
    latitude: 2.95,
    longitude: 9.916667,
    icao: "FKKB"
  },
  KBL: {
    iata: "KBL",
    name: "Kabul International Airport",
    city: "Kabul",
    countryId: "AF",
    timeZoneRegionName: "Asia/Kabul",
    latitude: 34.560692,
    longitude: 69.211521,
    icao: "OAKB"
  },
  KBN: {
    iata: "KBN",
    name: "Kabinda Airport",
    city: "Kabinda",
    countryId: "CD",
    timeZoneRegionName: "Africa/Lubumbashi",
    latitude: -6.116667,
    longitude: 24.533333,
    icao: "FZWT"
  },
  KBO: {
    iata: "KBO",
    name: "Kabalo Airport",
    city: "Kabalo",
    countryId: "CD",
    timeZoneRegionName: "Africa/Lubumbashi",
    latitude: -6.088056,
    longitude: 26.916667,
    icao: "FZRM"
  },
  KBP: {
    iata: "KBP",
    name: "Boryspil International Airport",
    city: "Kiev/Kyiv",
    countryId: "UA",
    timeZoneRegionName: "Europe/Kiev",
    latitude: 50.341244,
    longitude: 30.895207,
    icao: "UKBB"
  },
  KBQ: {
    iata: "KBQ",
    name: "Kasungu Airport",
    city: "Kasungu",
    countryId: "MW",
    timeZoneRegionName: "Africa/Blantyre",
    latitude: -33.466667,
    longitude: 13.016667,
    icao: "FWKG"
  },
  KBR: {
    iata: "KBR",
    name: "Sultan Ismail Petra Airport",
    city: "Kota Bharu",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 6.17057,
    longitude: 102.290915,
    icao: "WMKC"
  },
  KBS: {
    iata: "KBS",
    name: "Bo Airport",
    city: "Bo",
    countryId: "SL",
    timeZoneRegionName: "Africa/Freetown",
    latitude: 7.943889,
    longitude: -11.761944,
    icao: "GFBO"
  },
  KBU: {
    iata: "KBU",
    name: "Gusti Syamsir Alam Airport",
    city: "Kotabaru",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -3.295796,
    longitude: 116.165701,
    icao: "WAOK"
  },
  KBV: {
    iata: "KBV",
    name: "Krabi Airport",
    city: "Krabi",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 8.097281,
    longitude: 98.980619,
    icao: "VTSG"
  },
  KBY: {
    iata: "KBY",
    name: "Streaky Bay Airport",
    city: "Streaky Bay",
    countryId: "AU",
    timeZoneRegionName: "Australia/Adelaide",
    latitude: -33,
    longitude: 134,
    icao: "YKBY"
  },
  KBZ: {
    iata: "KBZ",
    name: "Kaikoura Airport",
    city: "Kaikoura",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -42.42619,
    longitude: 173.600086,
    icao: "NZKI"
  },
  KCA: {
    iata: "KCA",
    name: "Quici Airport",
    city: "Kuqa",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 41.71806,
    longitude: 82.98694,
    icao: "ZWKC"
  },
  KCE: {
    iata: "KCE",
    name: "Collinsville Airport",
    city: "Collinsville",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -20.55,
    longitude: 147.866667,
    icao: "YCSV"
  },
  KCF: {
    iata: "KCF",
    name: "Kadanwari Airport",
    city: "Kadanwari",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 27.200146,
    longitude: 69.152835,
    icao: "OPKW"
  },
  KCG: {
    iata: "KCG",
    name: "Chignik Fisheries Airport",
    city: "Chignik",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 56.310833,
    longitude: -158.373611,
    icao: ""
  },
  KCH: {
    iata: "KCH",
    name: "Kuching International Airport",
    city: "Kuching",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 1.484167,
    longitude: 110.340833,
    icao: "WBGG"
  },
  KCK: {
    iata: "KCK",
    name: "Kirensk Airport",
    city: "Kirensk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Irkutsk",
    latitude: 57.77,
    longitude: 108.060002,
    icao: "UIKK"
  },
  KCL: {
    iata: "KCL",
    name: "Chignik Lagoon Airport",
    city: "Chignik",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 56.308333,
    longitude: -158.531944,
    icao: ""
  },
  KCM: {
    iata: "KCM",
    name: "Kahramanmaras Airport",
    city: "Kahramanmaras",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 37.534444,
    longitude: 36.950556,
    icao: "LTCN"
  },
  KCO: {
    iata: "KCO",
    name: "Cengiz Topel Airport",
    city: "Izmit",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 40.735028,
    longitude: 30.083336,
    icao: "LTBQ"
  },
  KCQ: {
    iata: "KCQ",
    name: "Chignik Lake Airport",
    city: "Chignik",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 56.261111,
    longitude: -158.777778,
    icao: "PAJC"
  },
  KCS: {
    iata: "KCS",
    name: "Kings Creek Station Airport",
    city: "Kings Creek Station",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -24.383333,
    longitude: 131.683333,
    icao: "YKCS"
  },
  KCT: {
    iata: "KCT",
    name: "Koggala Airport",
    city: "Koggala",
    countryId: "LK",
    timeZoneRegionName: "Asia/Colombo",
    latitude: 5.993832,
    longitude: 80.319743,
    icao: "VCCK"
  },
  KCU: {
    iata: "KCU",
    name: "Masindi Airport",
    city: "Masindi",
    countryId: "UG",
    timeZoneRegionName: "Africa/Kampala",
    latitude: 1.683333,
    longitude: 31.716667,
    icao: "HUMI"
  },
  KCY: {
    iata: "KCY",
    name: "Cheremshanka Airport",
    city: "Krasnoyarsk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Krasnoyarsk",
    latitude: 56.177584,
    longitude: 92.545881,
    icao: ""
  },
  KCZ: {
    iata: "KCZ",
    name: "Kochi Ryoma Airport",
    city: "Kochi",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 33.547689,
    longitude: 133.674852,
    icao: "RJOK"
  },
  KDA: {
    iata: "KDA",
    name: "Kolda Airport",
    city: "Kolda",
    countryId: "SN",
    timeZoneRegionName: "Africa/Dakar",
    latitude: 12.898835,
    longitude: -14.968835,
    icao: "GOGK"
  },
  KDC: {
    iata: "KDC",
    name: "Kandi Airport",
    city: "Kandi",
    countryId: "BJ",
    timeZoneRegionName: "Africa/Porto-Novo",
    latitude: 11.116667,
    longitude: 2.916667,
    icao: "DBBK"
  },
  KDD: {
    iata: "KDD",
    name: "Khuzdar Airport",
    city: "Khuzdar",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 27.780556,
    longitude: 66.630556,
    icao: "OPKH"
  },
  KDH: {
    iata: "KDH",
    name: "Kandahar Airport",
    city: "Kandahar",
    countryId: "AF",
    timeZoneRegionName: "Asia/Kabul",
    latitude: 31.506944,
    longitude: 65.8475,
    icao: "OAKN"
  },
  KDI: {
    iata: "KDI",
    name: "Haluoleo Airport",
    city: "Kendari",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -4.081461,
    longitude: 122.418851,
    icao: "WAWW"
  },
  KDJ: {
    iata: "KDJ",
    name: "Ndjole Airport",
    city: "Ndjole",
    countryId: "GA",
    timeZoneRegionName: "Africa/Libreville",
    latitude: -0.15,
    longitude: 10.766667,
    icao: "FOGJ"
  },
  KDL: {
    iata: "KDL",
    name: "Kardla Airport",
    city: "Kardla",
    countryId: "EE",
    timeZoneRegionName: "Europe/Tallinn",
    latitude: 58.994917,
    longitude: 22.824971,
    icao: "EEKA"
  },
  KDM: {
    iata: "KDM",
    name: "Kaadedhdhoo Airport",
    city: "Kaadedhdhoo",
    countryId: "MV",
    timeZoneRegionName: "Indian/Maldives",
    latitude: 0.488033,
    longitude: 72.995613,
    icao: "VRMT"
  },
  KDN: {
    iata: "KDN",
    name: "Ndende Airport",
    city: "Ndende",
    countryId: "GA",
    timeZoneRegionName: "Africa/Libreville",
    latitude: -2.5,
    longitude: 11.166667,
    icao: "FOGE"
  },
  KDO: {
    iata: "KDO",
    name: "Kadhdhoo Airport",
    city: "Kadhdhoo",
    countryId: "MV",
    timeZoneRegionName: "Indian/Maldives",
    latitude: 1.858339,
    longitude: 73.519787,
    icao: "VRMK"
  },
  KDT: {
    iata: "KDT",
    name: "Kamphangsaen Airport",
    city: "Kamphangsaen",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 14.1,
    longitude: 99.916667,
    icao: "VTBK"
  },
  KDU: {
    iata: "KDU",
    name: "Skardu Airport",
    city: "Skardu",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 35.333008,
    longitude: 75.538618,
    icao: "OPSD"
  },
  KDV: {
    iata: "KDV",
    name: "Kandavu Airport",
    city: "Kandavu",
    countryId: "FJ",
    timeZoneRegionName: "Pacific/Fiji",
    latitude: -19.053969,
    longitude: 178.156073,
    icao: "NFKD"
  },
  KDX: {
    iata: "KDX",
    name: "Kadugli Airport",
    city: "Kadugli",
    countryId: "SD",
    timeZoneRegionName: "Africa/Khartoum",
    latitude: 11.38,
    longitude: 29.701099,
    icao: "HSLI"
  },
  KEA: {
    iata: "KEA",
    name: "Kerki International Airport",
    city: "Kerki",
    countryId: "TM",
    timeZoneRegionName: "Asia/Ashgabat",
    latitude: 37.822201,
    longitude: 65.135306,
    icao: "UTAE"
  },
  KEC: {
    iata: "KEC",
    name: "Kasenga Airport",
    city: "Kasenga",
    countryId: "CD",
    timeZoneRegionName: "Africa/Lubumbashi",
    latitude: -10.333333,
    longitude: 28.75,
    icao: "FZQG"
  },
  KED: {
    iata: "KED",
    name: "Kaedi Airport",
    city: "Kaedi",
    countryId: "MR",
    timeZoneRegionName: "Africa/Nouakchott",
    latitude: 16.161389,
    longitude: -13.507778,
    icao: "GQNK"
  },
  KEE: {
    iata: "KEE",
    name: "Kelle Airport",
    city: "Kelle",
    countryId: "CG",
    timeZoneRegionName: "Africa/Brazzaville",
    latitude: -0.083333,
    longitude: 14.533333,
    icao: "FCOK"
  },
  KEF: {
    iata: "KEF",
    name: "Keflavik International Airport",
    city: "Reykjavik",
    countryId: "IS",
    timeZoneRegionName: "Atlantic/Reykjavik",
    latitude: 63.997765,
    longitude: -22.624283,
    icao: "BIKF"
  },
  KEI: {
    iata: "KEI",
    name: "Kepi Airport",
    city: "Kepi",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jayapura",
    latitude: -6.566667,
    longitude: 139.333333,
    icao: "WAKP"
  },
  KEJ: {
    iata: "KEJ",
    name: "Kemerovo Airport",
    city: "Kemerovo",
    countryId: "RU",
    timeZoneRegionName: "Asia/Novokuznetsk",
    latitude: 55.280569,
    longitude: 86.116226,
    icao: "UNEE"
  },
  KEK: {
    iata: "KEK",
    name: "Ekwok Airport",
    city: "Ekwok",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 59.35323,
    longitude: -157.476514,
    icao: ""
  },
  KEL: {
    iata: "KEL",
    name: "Holtenau Airport",
    city: "Kiel",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 54.380833,
    longitude: 10.143333,
    icao: "EDHK"
  },
  KEM: {
    iata: "KEM",
    name: "Kemi/Tornio Airport",
    city: "Kemi/Tornio",
    countryId: "FI",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 65.780057,
    longitude: 24.57677,
    icao: "EFKE"
  },
  KEN: {
    iata: "KEN",
    name: "Kenema Airport",
    city: "Kenema",
    countryId: "SL",
    timeZoneRegionName: "Africa/Freetown",
    latitude: 7.883333,
    longitude: -11.183333,
    icao: "GFKE"
  },
  KEO: {
    iata: "KEO",
    name: "Odienne Airport",
    city: "Odienne",
    countryId: "CI",
    timeZoneRegionName: "Africa/Abidjan",
    latitude: 9.53813,
    longitude: -7.563815,
    icao: "DIOD"
  },
  KEP: {
    iata: "KEP",
    name: "Nepalganj Airport",
    city: "Nepalganj",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 28.1036,
    longitude: 81.667,
    icao: "VNNG"
  },
  KER: {
    iata: "KER",
    name: "Kerman Airport",
    city: "Kerman",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 30.258778,
    longitude: 56.961921,
    icao: "OIKK"
  },
  KES: {
    iata: "KES",
    name: "Kelsey Airport",
    city: "Kelsey",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 56.016667,
    longitude: -96.5,
    icao: "CZEE"
  },
  KET: {
    iata: "KET",
    name: "Keng Tung Airport",
    city: "Keng Tung",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 21.3,
    longitude: 99.616667,
    icao: "VYKG"
  },
  KEU: {
    iata: "KEU",
    name: "Keekorok Airport",
    city: "Maasai Mara",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: -1.586377,
    longitude: 35.25746,
    icao: "HKKE"
  },
  KEV: {
    iata: "KEV",
    name: "Halli Airport",
    city: "Kuorevesi",
    countryId: "FI",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 61.583333,
    longitude: 24.75,
    icao: "EFHA"
  },
  KEW: {
    iata: "KEW",
    name: "Keewaywin Airport",
    city: "Keewaywin",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 52.992222,
    longitude: -92.838889,
    icao: "CPV8"
  },
  KEY: {
    iata: "KEY",
    name: "Kericho Airport",
    city: "Kericho",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: -0.366667,
    longitude: 35.283333,
    icao: "HKKR"
  },
  KFA: {
    iata: "KFA",
    name: "Kiffa Airport",
    city: "Kiffa",
    countryId: "MR",
    timeZoneRegionName: "Africa/Nouakchott",
    latitude: 16.588889,
    longitude: -11.405278,
    icao: "GQNF"
  },
  KFE: {
    iata: "KFE",
    name: "Fortescue Dave Forrest Airport",
    city: "Cloudbreak",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -22.291944,
    longitude: 119.437222,
    icao: "YFDF"
  },
  KFG: {
    iata: "KFG",
    name: "Kalkurung Airport",
    city: "Kalkurung",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -17.433333,
    longitude: 130.816667,
    icao: "YKKG"
  },
  KFP: {
    iata: "KFP",
    name: "False Pass Airport",
    city: "False Pass",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 54.849167,
    longitude: -163.409167,
    icao: "PAKF"
  },
  KFS: {
    iata: "KFS",
    name: "Kastamonu Airport",
    city: "Kastamonu",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 41.306446,
    longitude: 33.794951,
    icao: "LTAL"
  },
  KGA: {
    iata: "KGA",
    name: "Kananga Airport",
    city: "Kananga",
    countryId: "CD",
    timeZoneRegionName: "Africa/Lubumbashi",
    latitude: -5.922,
    longitude: 22.469167,
    icao: "FZUA"
  },
  KGC: {
    iata: "KGC",
    name: "Kingscote Airport",
    city: "Kingscote",
    countryId: "AU",
    timeZoneRegionName: "Australia/Adelaide",
    latitude: -35.709305,
    longitude: 137.523311,
    icao: "YKSC"
  },
  KGD: {
    iata: "KGD",
    name: "Khrabrovo Airport",
    city: "Kaliningrad",
    countryId: "RU",
    timeZoneRegionName: "Europe/Kaliningrad",
    latitude: 54.882656,
    longitude: 20.586646,
    icao: "UMKK"
  },
  KGE: {
    iata: "KGE",
    name: "Kaghau Island Airport",
    city: "Kaghau Island",
    countryId: "SB",
    timeZoneRegionName: "Pacific/Guadalcanal",
    latitude: -7.33278,
    longitude: 157.58694,
    icao: "AGKG"
  },
  KGF: {
    iata: "KGF",
    name: "Karaganda Airport",
    city: "Karaganda",
    countryId: "KZ",
    timeZoneRegionName: "Asia/Almaty",
    latitude: 49.675257,
    longitude: 73.328364,
    icao: "UAKK"
  },
  KGG: {
    iata: "KGG",
    name: "Kedougou Airport",
    city: "Kedougou",
    countryId: "SN",
    timeZoneRegionName: "Africa/Dakar",
    latitude: 12.570833,
    longitude: -12.217222,
    icao: "GOTK"
  },
  KGI: {
    iata: "KGI",
    name: "Kalgoorlie Airport",
    city: "Kalgoorlie",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -30.785246,
    longitude: 121.457914,
    icao: "YPKG"
  },
  KGJ: {
    iata: "KGJ",
    name: "Karonga Airport",
    city: "Karonga",
    countryId: "MW",
    timeZoneRegionName: "Africa/Blantyre",
    latitude: -9.957778,
    longitude: 33.892222,
    icao: "FWKA"
  },
  KGK: {
    iata: "KGK",
    name: "Koliganek Airport",
    city: "Koliganek",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 59.726739,
    longitude: -157.267107,
    icao: "PAJZ"
  },
  KGL: {
    iata: "KGL",
    name: "Kigali International Airport",
    city: "Kigali",
    countryId: "RW",
    timeZoneRegionName: "Africa/Kigali",
    latitude: -1.963042,
    longitude: 30.135014,
    icao: "HRYR"
  },
  KGN: {
    iata: "KGN",
    name: "Kasongo Lunda Airport",
    city: "Kasongo Lunda",
    countryId: "CD",
    timeZoneRegionName: "Africa/Kinshasa",
    latitude: -6.583333,
    longitude: 16.816667,
    icao: "FZOK"
  },
  KGP: {
    iata: "KGP",
    name: "Kogalym International Airport",
    city: "Kogalym",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yekaterinburg",
    latitude: 62.195833,
    longitude: 74.533611,
    icao: "USRK"
  },
  KGQ: {
    iata: "KGQ",
    name: "Kangersuatsiaq Heliport",
    city: "Kangersuatsiaq",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 72.381092,
    longitude: -55.536586,
    icao: "BGKS"
  },
  KGS: {
    iata: "KGS",
    name: "Kos Airport",
    city: "Kos",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 36.801002,
    longitude: 27.089479,
    icao: "LGKO"
  },
  KGT: {
    iata: "KGT",
    name: "Kangding Airport",
    city: "Kangding",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 30.13176,
    longitude: 101.747534,
    icao: "ZUKD"
  },
  KGV: {
    iata: "KGV",
    name: "Klagenfurt Railway Station",
    city: "Klagenfurt",
    countryId: "AT",
    timeZoneRegionName: "Europe/Vienna",
    latitude: 46.6156,
    longitude: 14.3133,
    icao: ""
  },
  KGX: {
    iata: "KGX",
    name: "Grayling Airport",
    city: "Grayling",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 62.895278,
    longitude: -160.0625,
    icao: ""
  },
  KGY: {
    iata: "KGY",
    name: "Kingaroy Airport",
    city: "Kingaroy",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -26.55,
    longitude: 151.833333,
    icao: "YKRY"
  },
  KHD: {
    iata: "KHD",
    name: "Khorramabad Airport",
    city: "Khorramabad",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 33.438611,
    longitude: 48.280833,
    icao: "OICK"
  },
  KHE: {
    iata: "KHE",
    name: "Kherson International Airport",
    city: "Kherson",
    countryId: "UA",
    timeZoneRegionName: "Europe/Kiev",
    latitude: 46.672395,
    longitude: 32.507988,
    icao: "UKOH"
  },
  KHG: {
    iata: "KHG",
    name: "Kashi Airport",
    city: "Kashi",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 39.53689,
    longitude: 76.010387,
    icao: "ZWSH"
  },
  KHH: {
    iata: "KHH",
    name: "Kaohsiung International Airport",
    city: "Kaohsiung",
    countryId: "TW",
    timeZoneRegionName: "Asia/Taipei",
    latitude: 22.5725,
    longitude: 120.345278,
    icao: "RCKH"
  },
  KHI: {
    iata: "KHI",
    name: "Jinnah International Airport",
    city: "Karachi",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 24.899986,
    longitude: 67.16828,
    icao: "OPKC"
  },
  KHJ: {
    iata: "KHJ",
    name: "Kauhajoki Airport",
    city: "Kauhajoki",
    countryId: "FI",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 62.463056,
    longitude: 22.394722,
    icao: "EFKJ"
  },
  KHK: {
    iata: "KHK",
    name: "Khark Airport",
    city: "Khark",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 29.2603,
    longitude: 50.323898,
    icao: "OIBQ"
  },
  KHM: {
    iata: "KHM",
    name: "Khamti Airport",
    city: "Khamti",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 25.9883,
    longitude: 95.6744,
    icao: "VYKI"
  },
  KHN: {
    iata: "KHN",
    name: "Nanchang Changbei International Airport",
    city: "Nanchang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 28.859902,
    longitude: 115.907845,
    icao: "ZSCN"
  },
  KHQ: {
    iata: "KHQ",
    name: "Kullorsuaq Heliport",
    city: "Kullorsuaq",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 74.579439,
    longitude: -57.23544,
    icao: "BGKQ"
  },
  KHS: {
    iata: "KHS",
    name: "Khasab Airport",
    city: "Khasab",
    countryId: "OM",
    timeZoneRegionName: "Asia/Muscat",
    latitude: 26.163939,
    longitude: 56.23506,
    icao: "OOKB"
  },
  KHT: {
    iata: "KHT",
    name: "Chapman Airport",
    city: "Khost",
    countryId: "AF",
    timeZoneRegionName: "Asia/Kabul",
    latitude: 33.336574,
    longitude: 69.960068,
    icao: "OAKS"
  },
  KHV: {
    iata: "KHV",
    name: "Khabarovsk Airport",
    city: "Khabarovsk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Vladivostok",
    latitude: 48.524564,
    longitude: 135.168616,
    icao: "UHHH"
  },
  KHW: {
    iata: "KHW",
    name: "Khwai River Lodge Airport",
    city: "Khwai River Lodge",
    countryId: "BW",
    timeZoneRegionName: "Africa/Gaborone",
    latitude: -19,
    longitude: 23.5,
    icao: "FBKR"
  },
  KHX: {
    iata: "KHX",
    name: "Kihihi Airport",
    city: "Kihihi",
    countryId: "UG",
    timeZoneRegionName: "Africa/Kampala",
    latitude: -0.719364,
    longitude: 29.698286,
    icao: ""
  },
  KHY: {
    iata: "KHY",
    name: "Khoy Airport",
    city: "Khoy",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 38.421558,
    longitude: 44.97413,
    icao: "OITK"
  },
  KHZ: {
    iata: "KHZ",
    name: "Kauehi Airport",
    city: "Kauehi",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -15.781204,
    longitude: -145.124112,
    icao: "NTKA"
  },
  KIC: {
    iata: "KIC",
    name: "Mesa Del Rey Airport",
    city: "King City",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 36.228001,
    longitude: -121.122002,
    icao: "KKIC"
  },
  KID: {
    iata: "KID",
    name: "Kristianstad Airport",
    city: "Kristianstad",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 55.919444,
    longitude: 14.088889,
    icao: "ESMK"
  },
  KIE: {
    iata: "KIE",
    name: "Aropa Airport",
    city: "Kieta",
    countryId: "PG",
    timeZoneRegionName: "Pacific/Bougainville",
    latitude: -6.30425,
    longitude: 155.725538,
    icao: "AYIQ"
  },
  KIF: {
    iata: "KIF",
    name: "Kingfisher Lake Airport",
    city: "Kingfisher Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 53.013889,
    longitude: -89.85,
    icao: "CNM5"
  },
  KIH: {
    iata: "KIH",
    name: "Kish International Airport",
    city: "Kish Island",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 26.532277,
    longitude: 53.972085,
    icao: "OIBK"
  },
  KIJ: {
    iata: "KIJ",
    name: "Niigata Airport",
    city: "Niigata",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 37.951993,
    longitude: 139.11325,
    icao: "RJSN"
  },
  KIK: {
    iata: "KIK",
    name: "Kirkuk Airport",
    city: "Kirkuk",
    countryId: "IQ",
    timeZoneRegionName: "Asia/Baghdad",
    latitude: 35.4695015,
    longitude: 44.3488998,
    icao: "ORKK"
  },
  KIM: {
    iata: "KIM",
    name: "Kimberley Airport",
    city: "Kimberley",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -28.805833,
    longitude: 24.766389,
    icao: "FAKM"
  },
  KIN: {
    iata: "KIN",
    name: "Norman Manley International Airport",
    city: "Kingston",
    countryId: "JM",
    timeZoneRegionName: "America/Jamaica",
    latitude: 17.935699,
    longitude: -76.787498,
    icao: "MKJP"
  },
  KIR: {
    iata: "KIR",
    name: "Kerry County Airport",
    city: "Kerry County",
    countryId: "IE",
    timeZoneRegionName: "Europe/Dublin",
    latitude: 52.181475,
    longitude: -9.535666,
    icao: "EIKY"
  },
  KIS: {
    iata: "KIS",
    name: "Kisumu Airport",
    city: "Kisumu",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: -0.084946,
    longitude: 34.7375,
    icao: "HKKI"
  },
  KIT: {
    iata: "KIT",
    name: "Kithira Airport",
    city: "Kithira",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 36.291667,
    longitude: 23.025,
    icao: "LGKC"
  },
  KIV: {
    iata: "KIV",
    name: "Chisinau International Airport",
    city: "Chisinau",
    countryId: "MD",
    timeZoneRegionName: "Europe/Chisinau",
    latitude: 46.935442,
    longitude: 28.934967,
    icao: "LUKK"
  },
  KIW: {
    iata: "KIW",
    name: "Southdowns Airport",
    city: "Kitwe",
    countryId: "ZM",
    timeZoneRegionName: "Africa/Lusaka",
    latitude: -12.897945,
    longitude: 28.147762,
    icao: "FLSO"
  },
  KIX: {
    iata: "KIX",
    name: "Kansai International Airport",
    city: "Osaka",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 34.43533,
    longitude: 135.243977,
    icao: "RJBB"
  },
  KIY: {
    iata: "KIY",
    name: "Kilwa Masoko Airport",
    city: "Kilwa Masoko",
    countryId: "TZ",
    timeZoneRegionName: "Africa/Dar_es_Salaam",
    latitude: -8.911243,
    longitude: 39.508909,
    icao: "HTKI"
  },
  KJA: {
    iata: "KJA",
    name: "Krasnoyarsk Airport",
    city: "Krasnojarsk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Krasnoyarsk",
    latitude: 56.18113,
    longitude: 92.482859,
    icao: "UNKL"
  },
  KJB: {
    iata: "KJB",
    name: "Kurnool Airport",
    city: "Kurnool",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 15.714722,
    longitude: 78.178056,
    icao: ""
  },
  KJH: {
    iata: "KJH",
    name: "Kaili Huangping Airport",
    city: "Kaili",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 26.97194,
    longitude: 107.9875,
    icao: ""
  },
  KJI: {
    iata: "KJI",
    name: "Burqin Kanas Airport",
    city: "Buerjin",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 48.22167,
    longitude: 86.99611,
    icao: ""
  },
  KJK: {
    iata: "KJK",
    name: "Kortrijk Airport",
    city: "Kortrijk",
    countryId: "BE",
    timeZoneRegionName: "Europe/Brussels",
    latitude: 50.817222,
    longitude: 3.201667,
    icao: "EBKT"
  },
  KJP: {
    iata: "KJP",
    name: "Kerama Airport",
    city: "Kerama",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 26.168331,
    longitude: 127.293855,
    icao: "ROKR"
  },
  KJT: {
    iata: "KJT",
    name: "West Java Kertajati International Airport",
    city: "Majalengka",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: -6.649717,
    longitude: 108.166296,
    icao: "WICA"
  },
  KKA: {
    iata: "KKA",
    name: "Koyuk Airport",
    city: "Koyuk",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 64.939444,
    longitude: -161.15,
    icao: "PAKK"
  },
  KKC: {
    iata: "KKC",
    name: "Khon Kaen Airport",
    city: "Khon Kaen",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 16.464671,
    longitude: 102.787494,
    icao: "VTUK"
  },
  KKE: {
    iata: "KKE",
    name: "Kerikeri Airport",
    city: "Kerikeri",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -35.263284,
    longitude: 173.912376,
    icao: "NZKK"
  },
  KKH: {
    iata: "KKH",
    name: "Kongiganak Airport",
    city: "Kongiganak",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 59.966667,
    longitude: -162.75,
    icao: "PADY"
  },
  KKI: {
    iata: "KKI",
    name: "Akiachak Airport",
    city: "Akiachak",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 60.906944,
    longitude: -161.422222,
    icao: ""
  },
  KKJ: {
    iata: "KKJ",
    name: "Kitakyushu Airport",
    city: "Kitakyushu",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 33.846156,
    longitude: 131.034936,
    icao: "RJFR"
  },
  KKM: {
    iata: "KKM",
    name: "Sa Pran Nak Airport",
    city: "Lop Buri",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 14.945759,
    longitude: 100.643581,
    icao: "VTBH"
  },
  KKN: {
    iata: "KKN",
    name: "Kirkenes Airport, Hoeybuktmoen",
    city: "Kirkenes",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 69.723503,
    longitude: 29.891184,
    icao: "ENKR"
  },
  KKO: {
    iata: "KKO",
    name: "Kaikohe Airport",
    city: "Kaikohe",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -35.452778,
    longitude: 173.816667,
    icao: "NZKO"
  },
  KKQ: {
    iata: "KKQ",
    name: "Krasnosel'Kup Airport",
    city: "Krasnosel'Kup",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yekaterinburg",
    latitude: 65.70796,
    longitude: 82.456055,
    icao: "USDP"
  },
  KKR: {
    iata: "KKR",
    name: "Kaukura Airport",
    city: "Kaukura Atoll",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -15.783333,
    longitude: -146.666667,
    icao: ""
  },
  KKS: {
    iata: "KKS",
    name: "Kashan Airport",
    city: "Kashan",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 33.895327,
    longitude: 51.577053,
    icao: "OIFK"
  },
  KKW: {
    iata: "KKW",
    name: "Kikwit Airport",
    city: "Kikwit",
    countryId: "CD",
    timeZoneRegionName: "Africa/Kinshasa",
    latitude: -5.036111,
    longitude: 18.780278,
    icao: "FZCA"
  },
  KKX: {
    iata: "KKX",
    name: "Kikaiga Shima Airport",
    city: "Kikaiga Shima",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 28.321389,
    longitude: 129.928056,
    icao: "RJKI"
  },
  KKY: {
    iata: "KKY",
    name: "Kilkenny Airport",
    city: "Kilkenny",
    countryId: "IE",
    timeZoneRegionName: "Europe/Dublin",
    latitude: 52.65,
    longitude: -7.25,
    icao: "EIKL"
  },
  KKZ: {
    iata: "KKZ",
    name: "Koh Kong Airport",
    city: "Koh Kong",
    countryId: "KH",
    timeZoneRegionName: "Asia/Phnom_Penh",
    latitude: 11.633333,
    longitude: 102.966667,
    icao: "VDKK"
  },
  KLB: {
    iata: "KLB",
    name: "Kalabo Airport",
    city: "Kalabo",
    countryId: "ZM",
    timeZoneRegionName: "Africa/Lusaka",
    latitude: -14.998512,
    longitude: 22.646713,
    icao: "FLKL"
  },
  KLC: {
    iata: "KLC",
    name: "Kaolack Airport",
    city: "Kaolack",
    countryId: "SN",
    timeZoneRegionName: "Africa/Dakar",
    latitude: 14.083333,
    longitude: -16.5,
    icao: "GOOK"
  },
  KLF: {
    iata: "KLF",
    name: "Kaluga Grabtsevo Airport",
    city: "Kaluga",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 54.548019,
    longitude: 36.368112,
    icao: "UUBC"
  },
  KLG: {
    iata: "KLG",
    name: "Kalskag Airport",
    city: "Kalskag",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 61.532582,
    longitude: -160.346503,
    icao: "PALG"
  },
  KLH: {
    iata: "KLH",
    name: "Kolhapur Airport",
    city: "Kolhapur",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 16.666667,
    longitude: 74.333333,
    icao: "VAKP"
  },
  KLI: {
    iata: "KLI",
    name: "Kota Koli Airport",
    city: "Kota Koli",
    countryId: "CD",
    timeZoneRegionName: "Africa/Kinshasa",
    latitude: -4.166667,
    longitude: 21.75,
    icao: "FZFP"
  },
  KLL: {
    iata: "KLL",
    name: "Levelock Airport",
    city: "Levelock",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 59.118611,
    longitude: -156.863333,
    icao: ""
  },
  KLM: {
    iata: "KLM",
    name: "Kalaleh Airport",
    city: "Kalaleh",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 37.383272,
    longitude: 55.452033,
    icao: "OINE"
  },
  KLO: {
    iata: "KLO",
    name: "Kalibo International Airport",
    city: "Kalibo",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 11.687152,
    longitude: 122.381832,
    icao: "RPVK"
  },
  KLR: {
    iata: "KLR",
    name: "Kalmar Oland Airport",
    city: "Kalmar",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 56.685,
    longitude: 16.287222,
    icao: "ESMQ"
  },
  KLS: {
    iata: "KLS",
    name: "Longview Airport",
    city: "Kelso",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 46.15,
    longitude: -122.9,
    icao: "KKLS"
  },
  KLU: {
    iata: "KLU",
    name: "Klagenfurt Airport",
    city: "Klagenfurt",
    countryId: "AT",
    timeZoneRegionName: "Europe/Vienna",
    latitude: 46.650122,
    longitude: 14.324192,
    icao: "LOWK"
  },
  KLV: {
    iata: "KLV",
    name: "Karlovy Vary Airport",
    city: "Karlovy Vary",
    countryId: "CZ",
    timeZoneRegionName: "Europe/Prague",
    latitude: 50.2,
    longitude: 12.916667,
    icao: "LKKV"
  },
  KLW: {
    iata: "KLW",
    name: "Klawock Airport",
    city: "Klawock",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 55.555,
    longitude: -133.1,
    icao: "PAKW"
  },
  KLX: {
    iata: "KLX",
    name: "Kalamata Airport",
    city: "Kalamata",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 37.069444,
    longitude: 22.027778,
    icao: "LGKL"
  },
  KLY: {
    iata: "KLY",
    name: "Kalima Airport",
    city: "Kalima",
    countryId: "CD",
    timeZoneRegionName: "Africa/Lubumbashi",
    latitude: -2.55,
    longitude: 26.533333,
    icao: "FZOD"
  },
  KLZ: {
    iata: "KLZ",
    name: "Kleinzee Airport",
    city: "Kleinzee",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -29.683333,
    longitude: 17.066667,
    icao: "FAKZ"
  },
  KMC: {
    iata: "KMC",
    name: "King Khaled Military City Airport",
    city: "King Khalid Military City",
    countryId: "SA",
    timeZoneRegionName: "Asia/Riyadh",
    latitude: 27.90092,
    longitude: 45.528202,
    icao: "OEKK"
  },
  KME: {
    iata: "KME",
    name: "Kamembe Airport",
    city: "Kamembe",
    countryId: "RW",
    timeZoneRegionName: "Africa/Kigali",
    latitude: -2.459348,
    longitude: 28.908972,
    icao: "HRZA"
  },
  KMG: {
    iata: "KMG",
    name: "Kunming Changshui International Airport",
    city: "Kunming",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 25.101944,
    longitude: 102.929167,
    icao: "ZPPP"
  },
  KMH: {
    iata: "KMH",
    name: "Kuruman Airport",
    city: "Kuruman",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -27.466667,
    longitude: 23.466667,
    icao: "FAKU"
  },
  KMI: {
    iata: "KMI",
    name: "Miyazaki Airport",
    city: "Miyazaki",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 31.872497,
    longitude: 131.441466,
    icao: "RJFM"
  },
  KMJ: {
    iata: "KMJ",
    name: "Kumamoto Airport",
    city: "Kumamoto",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 32.834132,
    longitude: 130.85799,
    icao: "RJFT"
  },
  KMK: {
    iata: "KMK",
    name: "Makabana Airport",
    city: "Makabana",
    countryId: "CG",
    timeZoneRegionName: "Africa/Brazzaville",
    latitude: -3.482116,
    longitude: 12.595687,
    icao: "FCPA"
  },
  KML: {
    iata: "KML",
    name: "Kamileroi Airport",
    city: "Kamileroi",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -19.366667,
    longitude: 140.05,
    icao: "YKML"
  },
  KMN: {
    iata: "KMN",
    name: "Kamina Airport",
    city: "Kamina",
    countryId: "CD",
    timeZoneRegionName: "Africa/Lubumbashi",
    latitude: -8.641111,
    longitude: 25.25,
    icao: "FZSA"
  },
  KMO: {
    iata: "KMO",
    name: "Manokotak Airport",
    city: "Manokotak",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 58.990197,
    longitude: -159.05002,
    icao: "PAMB"
  },
  KMP: {
    iata: "KMP",
    name: "J.G.H. Van Der Wath Airport",
    city: "Keetmanshoop",
    countryId: "NA",
    timeZoneRegionName: "Africa/Windhoek",
    latitude: -26.533611,
    longitude: 18.1,
    icao: "FYKT"
  },
  KMQ: {
    iata: "KMQ",
    name: "Komatsu Airport",
    city: "Komatsu",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 36.402369,
    longitude: 136.413428,
    icao: "RJNK"
  },
  KMS: {
    iata: "KMS",
    name: "Kumasi Airport",
    city: "Kumasi",
    countryId: "GH",
    timeZoneRegionName: "Africa/Accra",
    latitude: 6.7125,
    longitude: -1.591111,
    icao: "DGSI"
  },
  KMU: {
    iata: "KMU",
    name: "Kismayu Airport",
    city: "Kismayu",
    countryId: "SO",
    timeZoneRegionName: "Africa/Mogadishu",
    latitude: -0.377353,
    longitude: 42.459202,
    icao: "HCMK"
  },
  KMV: {
    iata: "KMV",
    name: "Kalemyo Airport",
    city: "Kalemyo",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 23.183333,
    longitude: 94.05,
    icao: ""
  },
  KMX: {
    iata: "KMX",
    name: "King Khalid Air Base",
    city: "Khamis Mushait",
    countryId: "SA",
    timeZoneRegionName: "Asia/Riyadh",
    latitude: 18.297283,
    longitude: 42.803495,
    icao: "OEKM"
  },
  KMZ: {
    iata: "KMZ",
    name: "Kaoma Airport",
    city: "Kaoma",
    countryId: "ZM",
    timeZoneRegionName: "Africa/Lusaka",
    latitude: -14.798889,
    longitude: 24.803333,
    icao: "FLKO"
  },
  KNA: {
    iata: "KNA",
    name: "Vina del Mar Airport",
    city: "Vina del Mar",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -32.9496,
    longitude: -71.4786,
    icao: "SCVM"
  },
  KNB: {
    iata: "KNB",
    name: "Kanab Airport",
    city: "Kanab",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 37.05,
    longitude: -112.533333,
    icao: "KKNB"
  },
  KND: {
    iata: "KND",
    name: "Kindu Airport",
    city: "Kindu",
    countryId: "CD",
    timeZoneRegionName: "Africa/Lubumbashi",
    latitude: -2.919167,
    longitude: 25.915278,
    icao: "FZOA"
  },
  KNG: {
    iata: "KNG",
    name: "Kaimana Utarom Airport",
    city: "Kaimana",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jayapura",
    latitude: -3.65,
    longitude: 133.75,
    icao: "WASK"
  },
  KNH: {
    iata: "KNH",
    name: "Kinmen Airport",
    city: "Kinmen",
    countryId: "TW",
    timeZoneRegionName: "Asia/Taipei",
    latitude: 24.435001,
    longitude: 118.368581,
    icao: "RCBS"
  },
  KNJ: {
    iata: "KNJ",
    name: "Kindamba Airport",
    city: "Kindamba",
    countryId: "CG",
    timeZoneRegionName: "Africa/Brazzaville",
    latitude: -3.95,
    longitude: 14.516667,
    icao: "FCBK"
  },
  KNK: {
    iata: "KNK",
    name: "Kokhanok Airport",
    city: "Kokhanok",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 59.43462,
    longitude: -154.798172,
    icao: ""
  },
  KNM: {
    iata: "KNM",
    name: "Kaniama Airport",
    city: "Kaniama",
    countryId: "CD",
    timeZoneRegionName: "Africa/Lubumbashi",
    latitude: -7.516667,
    longitude: 24.183333,
    icao: "FZTK"
  },
  KNN: {
    iata: "KNN",
    name: "Kankan Airport",
    city: "Kankan",
    countryId: "GN",
    timeZoneRegionName: "Africa/Conakry",
    latitude: 10.3975,
    longitude: -9.305556,
    icao: "GUXD"
  },
  KNO: {
    iata: "KNO",
    name: "Kuala Namu International Airport",
    city: "Kuala Namu",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: 3.635369,
    longitude: 98.879016,
    icao: "WIMM"
  },
  KNQ: {
    iata: "KNQ",
    name: "Kone Airport",
    city: "Kone",
    countryId: "NC",
    timeZoneRegionName: "Pacific/Noumea",
    latitude: -21.053333,
    longitude: 164.837778,
    icao: "NWWD"
  },
  KNR: {
    iata: "KNR",
    name: "Jam Airport",
    city: "Kangan",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 27.818056,
    longitude: 52.350833,
    icao: "OIBJ"
  },
  KNS: {
    iata: "KNS",
    name: "King Island Airport",
    city: "King Island",
    countryId: "AU",
    timeZoneRegionName: "Australia/Hobart",
    latitude: -39.879775,
    longitude: 143.881683,
    icao: "YKII"
  },
  KNT: {
    iata: "KNT",
    name: "Kennett Municipal Airport",
    city: "Kennett",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.230556,
    longitude: -90.034722,
    icao: "KTKX"
  },
  KNU: {
    iata: "KNU",
    name: "Kanpur Airport",
    city: "Kanpur",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 26.404278,
    longitude: 80.40989,
    icao: "VIKA"
  },
  KNW: {
    iata: "KNW",
    name: "New Stuyahok Airport",
    city: "New Stuyahok",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 59.456321,
    longitude: -157.374302,
    icao: "PANW"
  },
  KNX: {
    iata: "KNX",
    name: "Kununurra Airport",
    city: "Kununurra",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -15.784031,
    longitude: 128.712674,
    icao: "YPKU"
  },
  KNY: {
    iata: "KNY",
    name: "Kodinsk Airport",
    city: "Kodinsk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Krasnoyarsk",
    latitude: 58.48056,
    longitude: 99.09833,
    icao: ""
  },
  KNZ: {
    iata: "KNZ",
    name: "Kenieba Airport",
    city: "Kenieba",
    countryId: "ML",
    timeZoneRegionName: "Africa/Bamako",
    latitude: 12.843333,
    longitude: -11.2525,
    icao: "GAKA"
  },
  KOA: {
    iata: "KOA",
    name: "Kona International Airport at Keahole",
    city: "Kailua-Kona",
    countryId: "US",
    timeZoneRegionName: "Pacific/Honolulu",
    latitude: 19.736174,
    longitude: -156.041077,
    icao: "PHKO"
  },
  KOC: {
    iata: "KOC",
    name: "Koumac Airport",
    city: "Koumac",
    countryId: "NC",
    timeZoneRegionName: "Pacific/Noumea",
    latitude: -20.5,
    longitude: 164.416667,
    icao: "NWWK"
  },
  KOE: {
    iata: "KOE",
    name: "El Tari Airport",
    city: "Kupang",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -10.168536,
    longitude: 123.667254,
    icao: "WATT"
  },
  KOF: {
    iata: "KOF",
    name: "Komatipoort Airport",
    city: "Komatipoort",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -25.433333,
    longitude: 31.933333,
    icao: "FAKP"
  },
  KOI: {
    iata: "KOI",
    name: "Kirkwall Airport",
    city: "Kirkwall",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 58.958056,
    longitude: -2.900556,
    icao: "EGPA"
  },
  KOJ: {
    iata: "KOJ",
    name: "Kagoshima Airport",
    city: "Kagoshima",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 31.801224,
    longitude: 130.715616,
    icao: "RJFK"
  },
  KOK: {
    iata: "KOK",
    name: "Kruunupyy Airport",
    city: "Kokkola/Pietarsaari",
    countryId: "FI",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 63.718838,
    longitude: 23.133069,
    icao: "EFKK"
  },
  KOM: {
    iata: "KOM",
    name: "Komo Airport",
    city: "Komo",
    countryId: "PG",
    timeZoneRegionName: "Pacific/Port_Moresby",
    latitude: -6.0682,
    longitude: 142.8598,
    icao: "AYOO"
  },
  KOO: {
    iata: "KOO",
    name: "Kongolo Airport",
    city: "Kongolo",
    countryId: "CD",
    timeZoneRegionName: "Africa/Lubumbashi",
    latitude: -5.394122,
    longitude: 26.990874,
    icao: "FZRQ"
  },
  KOP: {
    iata: "KOP",
    name: "Nakhon Phanom Airport",
    city: "Nakhon Phanom",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 17.4,
    longitude: 104.75,
    icao: "VTUW"
  },
  KOS: {
    iata: "KOS",
    name: "Sihanouk International Airport",
    city: "Sihanoukville",
    countryId: "KH",
    timeZoneRegionName: "Asia/Phnom_Penh",
    latitude: 10.580739,
    longitude: 103.639079,
    icao: "VDSV"
  },
  KOT: {
    iata: "KOT",
    name: "Kotlik Airport",
    city: "Kotlik",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 63.031014,
    longitude: -163.532307,
    icao: ""
  },
  KOU: {
    iata: "KOU",
    name: "Koulamoutou Airport",
    city: "Koulamoutou",
    countryId: "GA",
    timeZoneRegionName: "Africa/Libreville",
    latitude: -1.184532,
    longitude: 12.441104,
    icao: "FOGK"
  },
  KOV: {
    iata: "KOV",
    name: "Kokshetau Airport",
    city: "Kokshetau",
    countryId: "KZ",
    timeZoneRegionName: "Asia/Almaty",
    latitude: 53.333268,
    longitude: 69.591593,
    icao: "UACK"
  },
  KOW: {
    iata: "KOW",
    name: "Ganzhou Huangjin Airport",
    city: "Ganzhou",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 25.851667,
    longitude: 114.776667,
    icao: "ZSGZ"
  },
  KPC: {
    iata: "KPC",
    name: "Port Clarence Coast Guard Station",
    city: "Port Clarence",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 65.25745,
    longitude: -166.857533,
    icao: "PAPC"
  },
  KPN: {
    iata: "KPN",
    name: "Kipnuk Sea Plane Base",
    city: "Kipnuk",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 59.933333,
    longitude: -164.05,
    icao: "PAKI"
  },
  KPO: {
    iata: "KPO",
    name: "Pohang Airport",
    city: "Pohang",
    countryId: "KR",
    timeZoneRegionName: "Asia/Seoul",
    latitude: 35.983713,
    longitude: 129.433743,
    icao: "RKTH"
  },
  KPS: {
    iata: "KPS",
    name: "Kempsey Airport",
    city: "Kempsey",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -31.083333,
    longitude: 152.766667,
    icao: "YKMP"
  },
  KPV: {
    iata: "KPV",
    name: "Perryville Airport",
    city: "Perryville",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 55.909003,
    longitude: -159.159249,
    icao: "PAPE"
  },
  KPW: {
    iata: "KPW",
    name: "Keperveyem Airport",
    city: "Keperveyem",
    countryId: "RU",
    timeZoneRegionName: "Asia/Anadyr",
    latitude: 67.846944,
    longitude: 166.138889,
    icao: "UHMK"
  },
  KQA: {
    iata: "KQA",
    name: "Akutan Airport",
    city: "Akutan",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 54.133333,
    longitude: -165.783333,
    icao: ""
  },
  KQH: {
    iata: "KQH",
    name: "Kishangarh Ajmer Airport",
    city: "Kishangarh",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 26.591219,
    longitude: 74.813277,
    icao: "VIKG"
  },
  KQT: {
    iata: "KQT",
    name: "Qurghonteppa International Airport",
    city: "Kurgon-Tyube",
    countryId: "TJ",
    timeZoneRegionName: "Asia/Dushanbe",
    latitude: 37.865622,
    longitude: 68.865131,
    icao: "UTDT"
  },
  KRA: {
    iata: "KRA",
    name: "Kerang Airport",
    city: "Kerang",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -35.7514,
    longitude: 143.938995,
    icao: "YKER"
  },
  KRB: {
    iata: "KRB",
    name: "Karumba Airport",
    city: "Karumba",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -17.454991,
    longitude: 140.831664,
    icao: "YKMD"
  },
  KRE: {
    iata: "KRE",
    name: "Kirundo Airport",
    city: "Kirundo",
    countryId: "BI",
    timeZoneRegionName: "Africa/Bujumbura",
    latitude: -3.333333,
    longitude: 29,
    icao: "HBBO"
  },
  KRF: {
    iata: "KRF",
    name: "Kramfors Airport",
    city: "Kramfors",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 63.048888,
    longitude: 17.768067,
    icao: "ESNK"
  },
  KRH: {
    iata: "KRH",
    name: "Redhill",
    city: "Redhill",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.2136,
    longitude: -0.138611,
    icao: "EGKR"
  },
  KRK: {
    iata: "KRK",
    name: "J. Paul II International Airport Krakow-Balice",
    city: "Krakow",
    countryId: "PL",
    timeZoneRegionName: "Europe/Warsaw",
    latitude: 50.075491,
    longitude: 19.793744,
    icao: "EPKK"
  },
  KRL: {
    iata: "KRL",
    name: "Korla Airport",
    city: "Korla",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 41.616399,
    longitude: 86.143123,
    icao: "ZWKL"
  },
  KRM: {
    iata: "KRM",
    name: "Karanambo Airport",
    city: "Karanambo",
    countryId: "GY",
    timeZoneRegionName: "America/Guyana",
    latitude: 3.75,
    longitude: -59.316667,
    icao: "SYKR"
  },
  KRN: {
    iata: "KRN",
    name: "Kiruna Airport",
    city: "Kiruna",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 67.822222,
    longitude: 20.345833,
    icao: "ESNQ"
  },
  KRO: {
    iata: "KRO",
    name: "Kurgan Airport",
    city: "Kurgan",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yekaterinburg",
    latitude: 55.474229,
    longitude: 65.413184,
    icao: "USUU"
  },
  KRP: {
    iata: "KRP",
    name: "Midtjyllands Airport",
    city: "Karup",
    countryId: "DK",
    timeZoneRegionName: "Europe/Copenhagen",
    latitude: 56.3,
    longitude: 9.116667,
    icao: "EKKA"
  },
  KRR: {
    iata: "KRR",
    name: "Krasnodar International Airport",
    city: "Krasnodar",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 45.034138,
    longitude: 39.139002,
    icao: "URKK"
  },
  KRS: {
    iata: "KRS",
    name: "Kristiansand Airport",
    city: "Kristiansand",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 58.202549,
    longitude: 8.073732,
    icao: "ENCN"
  },
  KRT: {
    iata: "KRT",
    name: "Khartoum International Airport",
    city: "Khartoum",
    countryId: "SD",
    timeZoneRegionName: "Africa/Khartoum",
    latitude: 15.592217,
    longitude: 32.549697,
    icao: "HSSS"
  },
  KRW: {
    iata: "KRW",
    name: "Turkmanbashi Airport",
    city: "Turkmanbashi",
    countryId: "TM",
    timeZoneRegionName: "Asia/Ashgabat",
    latitude: 40.056157,
    longitude: 53.012671,
    icao: "UTAK"
  },
  KRY: {
    iata: "KRY",
    name: "Karamay Airport",
    city: "Karamay",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 45.616667,
    longitude: 84.883333,
    icao: "ZWKM"
  },
  KSA: {
    iata: "KSA",
    name: "Kosrae Airport",
    city: "Kosrae, Caroline Islands",
    countryId: "FM",
    timeZoneRegionName: "Pacific/Pohnpei",
    latitude: 5.352478,
    longitude: 162.956603,
    icao: "PTSA"
  },
  KSC: {
    iata: "KSC",
    name: "Barca Airport",
    city: "Kosice",
    countryId: "SK",
    timeZoneRegionName: "Europe/Bratislava",
    latitude: 48.666667,
    longitude: 21.25,
    icao: "LZKZ"
  },
  KSD: {
    iata: "KSD",
    name: "Karlstad Airport",
    city: "Karlstad",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 59.444698,
    longitude: 13.3374,
    icao: "ESOK"
  },
  KSE: {
    iata: "KSE",
    name: "Kasese Airport",
    city: "Kasese",
    countryId: "UG",
    timeZoneRegionName: "Africa/Kampala",
    latitude: 0.185556,
    longitude: 30.100833,
    icao: "HUKS"
  },
  KSF: {
    iata: "KSF",
    name: "Kassel-Calden Airport",
    city: "Kassel",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 51.40568,
    longitude: 9.376578,
    icao: "EDVK"
  },
  KSH: {
    iata: "KSH",
    name: "Kermanshah Airport",
    city: "Kermanshah",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 34.355916,
    longitude: 47.145128,
    icao: "OICC"
  },
  KSI: {
    iata: "KSI",
    name: "Kissidougou Airport",
    city: "Kissidougou",
    countryId: "GN",
    timeZoneRegionName: "Africa/Conakry",
    latitude: 9.183333,
    longitude: -10.1,
    icao: "GUKU"
  },
  KSJ: {
    iata: "KSJ",
    name: "Kasos Island Airport",
    city: "Kasos Island",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 35.421267,
    longitude: 26.910895,
    icao: "LGKS"
  },
  KSK: {
    iata: "KSK",
    name: "Karlskoga Airport",
    city: "Karlskoga",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 59.316667,
    longitude: 14.55,
    icao: "ESKK"
  },
  KSL: {
    iata: "KSL",
    name: "Kassala Airport",
    city: "Kassala",
    countryId: "SD",
    timeZoneRegionName: "Africa/Khartoum",
    latitude: 15.390278,
    longitude: 36.342222,
    icao: "HSKA"
  },
  KSM: {
    iata: "KSM",
    name: "Saint Mary's Airport",
    city: "Saint Mary's",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 62.058667,
    longitude: -163.294894,
    icao: "PASM"
  },
  KSN: {
    iata: "KSN",
    name: "Kostanay Airport",
    city: "Kostanay",
    countryId: "KZ",
    timeZoneRegionName: "Asia/Qostanay",
    latitude: 53.206083,
    longitude: 63.550049,
    icao: "UAUU"
  },
  KSO: {
    iata: "KSO",
    name: "Aristoteles Airport",
    city: "Kastoria",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 40.450833,
    longitude: 21.273333,
    icao: "LGKA"
  },
  KSQ: {
    iata: "KSQ",
    name: "Karshi Airport",
    city: "Karshi",
    countryId: "UZ",
    timeZoneRegionName: "Asia/Tashkent",
    latitude: 38.802502,
    longitude: 65.773056,
    icao: "UTSK"
  },
  KSR: {
    iata: "KSR",
    name: "Selayar Islands H Aroeppala Airport",
    city: "Sulawesi Island",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -6.178611,
    longitude: 120.437222,
    icao: "WAWH"
  },
  KSS: {
    iata: "KSS",
    name: "Sikasso Airport",
    city: "Sikasso",
    countryId: "ML",
    timeZoneRegionName: "Africa/Bamako",
    latitude: 11.3,
    longitude: -5.583333,
    icao: "GASK"
  },
  KST: {
    iata: "KST",
    name: "Kosti Airport",
    city: "Kosti",
    countryId: "SD",
    timeZoneRegionName: "Africa/Khartoum",
    latitude: 13.133333,
    longitude: 32.716667,
    icao: "HSKI"
  },
  KSU: {
    iata: "KSU",
    name: "Kristiansund Airport, Kvernberget",
    city: "Kristiansund",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 63.113446,
    longitude: 7.826021,
    icao: "ENKB"
  },
  KSW: {
    iata: "KSW",
    name: "Kiryat Shmona Airport",
    city: "Kiryat Shmona",
    countryId: "IL",
    timeZoneRegionName: "Asia/Jerusalem",
    latitude: 33.216667,
    longitude: 35.566667,
    icao: "LLKS"
  },
  KSY: {
    iata: "KSY",
    name: "Kars Airport",
    city: "Kars",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 40.551667,
    longitude: 43.085833,
    icao: "LTCF"
  },
  KSZ: {
    iata: "KSZ",
    name: "Kotlas Airport",
    city: "Kotlas",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 61.236353,
    longitude: 46.698347,
    icao: "ULKK"
  },
  KTA: {
    iata: "KTA",
    name: "Karratha Airport",
    city: "Karratha",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -20.70826,
    longitude: 116.770058,
    icao: "YPKA"
  },
  KTD: {
    iata: "KTD",
    name: "Kitadaito Airport",
    city: "Kitadaito",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 25.944371,
    longitude: 131.325167,
    icao: "RORK"
  },
  KTE: {
    iata: "KTE",
    name: "Kerteh Airport",
    city: "Kerteh",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 4.538333,
    longitude: 103.428333,
    icao: "WMKE"
  },
  KTG: {
    iata: "KTG",
    name: "Ketapang Airport",
    city: "Ketapang",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: -1.833333,
    longitude: 109.983333,
    icao: "WIOK"
  },
  KTI: {
    iata: "KTI",
    name: "Techo International Airport",
    city: "Phnom Penh",
    countryId: "KH",
    timeZoneRegionName: "Asia/Phnom_Penh",
    latitude: 11.362917,
    longitude: 104.916611,
    icao: "VDTI"
  },
  KTJ: {
    iata: "KTJ",
    name: "Kichwa Tembo Airport",
    city: "Maasai Mara",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: -1.263508,
    longitude: 35.027596,
    icao: "HKTB"
  },
  KTL: {
    iata: "KTL",
    name: "Kitale Airport",
    city: "Kitale",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: 0.974111,
    longitude: 34.959246,
    icao: "HKKT"
  },
  KTM: {
    iata: "KTM",
    name: "Tribhuvan International Airport",
    city: "Kathmandu",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 27.699906,
    longitude: 85.35657,
    icao: "VNKT"
  },
  KTN: {
    iata: "KTN",
    name: "Ketchikan International Airport",
    city: "Ketchikan",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 55.35655,
    longitude: -131.708694,
    icao: "PAKT"
  },
  KTO: {
    iata: "KTO",
    name: "Kato Airport",
    city: "Kato",
    countryId: "GY",
    timeZoneRegionName: "America/Guyana",
    latitude: 4.65,
    longitude: -59.816667,
    icao: "SYKT"
  },
  KTP: {
    iata: "KTP",
    name: "Tinson Airport",
    city: "Kingston",
    countryId: "JM",
    timeZoneRegionName: "America/Jamaica",
    latitude: 17.9875,
    longitude: -76.823333,
    icao: "MKTP"
  },
  KTQ: {
    iata: "KTQ",
    name: "Kitee Airport",
    city: "Kitee",
    countryId: "FI",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 62.165833,
    longitude: 30.076667,
    icao: "EFIT"
  },
  KTR: {
    iata: "KTR",
    name: "RAAF Base Tindal",
    city: "Katherine",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -14.512409,
    longitude: 132.37184,
    icao: "YPTN"
  },
  KTS: {
    iata: "KTS",
    name: "Brevig Mission Airport",
    city: "Teller Mission",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 65.329444,
    longitude: -166.471667,
    icao: "PFKT"
  },
  KTT: {
    iata: "KTT",
    name: "Kittila Airport",
    city: "Kittila",
    countryId: "FI",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 67.695949,
    longitude: 24.859027,
    icao: "EFKT"
  },
  KTU: {
    iata: "KTU",
    name: "Kota Airport",
    city: "Kota",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 25,
    longitude: 76.5,
    icao: "VIKO"
  },
  KTW: {
    iata: "KTW",
    name: "Katowice International Airport",
    city: "Katowice",
    countryId: "PL",
    timeZoneRegionName: "Europe/Warsaw",
    latitude: 50.470833,
    longitude: 19.074029,
    icao: "EPKT"
  },
  KTX: {
    iata: "KTX",
    name: "Koutiala Airport",
    city: "Koutiala",
    countryId: "ML",
    timeZoneRegionName: "Africa/Bamako",
    latitude: 12.416667,
    longitude: -5.383333,
    icao: "GAKO"
  },
  KUA: {
    iata: "KUA",
    name: "Sultan Haji Ahmad Shah Airport",
    city: "Kuantan",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 3.780765,
    longitude: 103.215182,
    icao: "WMKD"
  },
  KUC: {
    iata: "KUC",
    name: "Kuria Airport",
    city: "Kuria",
    countryId: "KI",
    timeZoneRegionName: "Pacific/Tarawa",
    latitude: 0.233333,
    longitude: 173.383333,
    icao: "NGKT"
  },
  KUF: {
    iata: "KUF",
    name: "Kurumoch International Airport",
    city: "Samara",
    countryId: "RU",
    timeZoneRegionName: "Europe/Samara",
    latitude: 53.507819,
    longitude: 50.14742,
    icao: "UWWW"
  },
  KUG: {
    iata: "KUG",
    name: "Kubin Airport",
    city: "Kubin Island",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -10.226403,
    longitude: 142.219782,
    icao: "YKUB"
  },
  KUH: {
    iata: "KUH",
    name: "Kushiro Airport",
    city: "Kushiro",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 43.045651,
    longitude: 144.196819,
    icao: "RJCK"
  },
  KUK: {
    iata: "KUK",
    name: "Kasigluk Airport",
    city: "Kasigluk",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 60.876087,
    longitude: -162.521245,
    icao: ""
  },
  KUL: {
    iata: "KUL",
    name: "Kuala Lumpur International Airport",
    city: "Kuala Lumpur",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 2.744344,
    longitude: 101.717259,
    icao: "WMKK"
  },
  KUM: {
    iata: "KUM",
    name: "Yakushima Airport",
    city: "Yakushima",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 30.385556,
    longitude: 130.659167,
    icao: "RJFC"
  },
  KUN: {
    iata: "KUN",
    name: "Kaunas Airport",
    city: "Kaunas",
    countryId: "LT",
    timeZoneRegionName: "Europe/Vilnius",
    latitude: 54.963685,
    longitude: 24.080442,
    icao: "EYKA"
  },
  KUO: {
    iata: "KUO",
    name: "Kuopio Airport",
    city: "Kuopio",
    countryId: "FI",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 63.008908,
    longitude: 27.788696,
    icao: "EFKU"
  },
  KUS: {
    iata: "KUS",
    name: "Kulusuk Airport",
    city: "Kulusuk",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 65.566667,
    longitude: -37.116667,
    icao: "BGKK"
  },
  KUT: {
    iata: "KUT",
    name: "Kutaisi International Airport",
    city: "Kutaisi",
    countryId: "GE",
    timeZoneRegionName: "Asia/Tbilisi",
    latitude: 42.176389,
    longitude: 42.4825,
    icao: "UGKO"
  },
  KUU: {
    iata: "KUU",
    name: "Bhuntar Airport",
    city: "Kulu",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 31.983333,
    longitude: 77.1,
    icao: "VIBR"
  },
  KUV: {
    iata: "KUV",
    name: "Gunsan Airport",
    city: "Gunsan",
    countryId: "KR",
    timeZoneRegionName: "Asia/Seoul",
    latitude: 35.903801,
    longitude: 126.615997,
    icao: "RKJK"
  },
  KUZ: {
    iata: "KUZ",
    name: "Kuummiit Heliport",
    city: "Kuummiit",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 65.864128,
    longitude: -36.998001,
    icao: "BGKM"
  },
  KVA: {
    iata: "KVA",
    name: "Kavala International Airport",
    city: "Kavala",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 40.912994,
    longitude: 24.619675,
    icao: "LGKV"
  },
  KVB: {
    iata: "KVB",
    name: "Skovde Airport",
    city: "Skovde",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 58.45,
    longitude: 13.966667,
    icao: "ESGR"
  },
  KVC: {
    iata: "KVC",
    name: "King Cove Airport",
    city: "King Cove",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 55.116347,
    longitude: -162.266247,
    icao: "PAVC"
  },
  KVD: {
    iata: "KVD",
    name: "Gyandzha Airport",
    city: "Gyandzha",
    countryId: "AZ",
    timeZoneRegionName: "Asia/Baku",
    latitude: 40.733333,
    longitude: 46.316667,
    icao: "UBBG"
  },
  KVG: {
    iata: "KVG",
    name: "Kavieng Airport",
    city: "Kavieng",
    countryId: "PG",
    timeZoneRegionName: "Pacific/Port_Moresby",
    latitude: -2.58075,
    longitude: 150.80653,
    icao: "AYKV"
  },
  KVK: {
    iata: "KVK",
    name: "Kirovsk Apatity Khibiny Airport",
    city: "Kirovsk",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 67.463303,
    longitude: 33.588299,
    icao: ""
  },
  KVL: {
    iata: "KVL",
    name: "Kivalina Airport",
    city: "Kivalina",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 67.731667,
    longitude: -164.547222,
    icao: "PAVL"
  },
  KVN: {
    iata: "KVN",
    name: "Kunshan South Railway Station",
    city: "Kunshan",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 31.355,
    longitude: 120.946389,
    icao: ""
  },
  KVO: {
    iata: "KVO",
    name: "Moreva Airport",
    city: "Kraljevo",
    countryId: "RS",
    timeZoneRegionName: "Europe/Belgrade",
    latitude: 43.8181,
    longitude: 20.5858,
    icao: "LYKV"
  },
  KVR: {
    iata: "KVR",
    name: "Kavalerovo Airport",
    city: "Kavalerovo",
    countryId: "RU",
    timeZoneRegionName: "Asia/Vladivostok",
    latitude: 44.266864,
    longitude: 135.035707,
    icao: ""
  },
  KVX: {
    iata: "KVX",
    name: "Kirov Pobedilovo Airport",
    city: "Kirov",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 58.5,
    longitude: 49.35,
    icao: "USKK"
  },
  KWA: {
    iata: "KWA",
    name: "Kwajalein Airport",
    city: "Kwajalein",
    countryId: "MH",
    timeZoneRegionName: "Pacific/Majuro",
    latitude: 8.720843,
    longitude: 167.721953,
    icao: "PKWA"
  },
  KWB: {
    iata: "KWB",
    name: "Dewadaru Airport",
    city: "Karimunjawa",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: -5.802206,
    longitude: 110.478396,
    icao: "WARU"
  },
  KWE: {
    iata: "KWE",
    name: "Guiyang Longdongbao International Airport",
    city: "Guiyang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 26.544217,
    longitude: 106.79598,
    icao: "ZUGY"
  },
  KWG: {
    iata: "KWG",
    name: "Krivoy Rog Airport",
    city: "Krivoy Rog",
    countryId: "UA",
    timeZoneRegionName: "Europe/Kiev",
    latitude: 48.05,
    longitude: 33.216667,
    icao: "UKDR"
  },
  KWH: {
    iata: "KWH",
    name: "Khwahan Airport",
    city: "Khwahan",
    countryId: "AF",
    timeZoneRegionName: "Asia/Kabul",
    latitude: 33.916667,
    longitude: 66.333333,
    icao: "OAHN"
  },
  KWI: {
    iata: "KWI",
    name: "Kuwait International Airport",
    city: "Kuwait",
    countryId: "KW",
    timeZoneRegionName: "Asia/Kuwait",
    latitude: 29.240116,
    longitude: 47.971251,
    icao: "OKBK"
  },
  KWJ: {
    iata: "KWJ",
    name: "Gwangju Airport",
    city: "Gwangju",
    countryId: "KR",
    timeZoneRegionName: "Asia/Seoul",
    latitude: 35.140176,
    longitude: 126.810208,
    icao: "RKJJ"
  },
  KWK: {
    iata: "KWK",
    name: "Kwigillingok Airport",
    city: "Kwigillingok",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 59.875583,
    longitude: -163.168036,
    icao: "PAGG"
  },
  KWL: {
    iata: "KWL",
    name: "Guilin Liangjiang International Airport",
    city: "Guilin",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 25.217585,
    longitude: 110.046839,
    icao: "ZGKL"
  },
  KWM: {
    iata: "KWM",
    name: "Kowanyama Airport",
    city: "Kowanyama",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -15.4875,
    longitude: 141.748333,
    icao: "YKOW"
  },
  KWN: {
    iata: "KWN",
    name: "Kwinhagak Airport",
    city: "Quinhagak",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 59.751235,
    longitude: -161.840523,
    icao: "PAQH"
  },
  KWS: {
    iata: "KWS",
    name: "Kwailibesi Airport",
    city: "Kwailibesi",
    countryId: "SB",
    timeZoneRegionName: "Pacific/Guadalcanal",
    latitude: -8.360508,
    longitude: 160.775127,
    icao: "AGKW"
  },
  KWT: {
    iata: "KWT",
    name: "Kwethluk Airport",
    city: "Kwethluk",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 60.808889,
    longitude: -161.4375,
    icao: "PFKW"
  },
  KWZ: {
    iata: "KWZ",
    name: "Kolwezi Airport",
    city: "Kolwezi",
    countryId: "CD",
    timeZoneRegionName: "Africa/Lubumbashi",
    latitude: -10.766667,
    longitude: 25.506944,
    icao: "FZQM"
  },
  KXE: {
    iata: "KXE",
    name: "Klerksdorp Airport",
    city: "Klerksdorp",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -26.866667,
    longitude: 26.716667,
    icao: "FAKD"
  },
  KXB: {
    iata: "KXB",
    name: "Sangia Nibandera Airport",
    city: "Kolaka",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -4.341744,
    longitude: 121.523888,
    icao: "WAWP"
  },
  KXF: {
    iata: "KXF",
    name: "Koro Island Airport",
    city: "Koro Island",
    countryId: "FJ",
    timeZoneRegionName: "Pacific/Fiji",
    latitude: -17.3458,
    longitude: 179.421997,
    icao: "NFNO"
  },
  KXK: {
    iata: "KXK",
    name: "Khurba Airport",
    city: "Komsomolsk Na Amure",
    countryId: "RU",
    timeZoneRegionName: "Asia/Vladivostok",
    latitude: 50.403117,
    longitude: 136.933604,
    icao: "UHKK"
  },
  KXO: {
    iata: "KXO",
    name: "Kisoro Airport",
    city: "Kisoro",
    countryId: "UG",
    timeZoneRegionName: "Africa/Kampala",
    latitude: -1.283333,
    longitude: 29.719722,
    icao: ""
  },
  KXU: {
    iata: "KXU",
    name: "Katiu Airport",
    city: "Katiu",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -16.339444,
    longitude: -144.403056,
    icao: "NTKT"
  },
  KYA: {
    iata: "KYA",
    name: "Konya Airport",
    city: "Konya",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 37.979167,
    longitude: 32.562222,
    icao: "LTAN"
  },
  KYE: {
    iata: "KYE",
    name: "Kleyate Airport",
    city: "Tripoli",
    countryId: "LB",
    timeZoneRegionName: "Asia/Beirut",
    latitude: 34.586111,
    longitude: 36.002778,
    icao: "OLKA"
  },
  KYK: {
    iata: "KYK",
    name: "Karluk Airport",
    city: "Karluk",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 57.566111,
    longitude: -154.45,
    icao: "PAKY"
  },
  KYP: {
    iata: "KYP",
    name: "Kyaukpyu Airport",
    city: "Kyaukpyu",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 19.429139,
    longitude: 93.535166,
    icao: "VYKP"
  },
  KYS: {
    iata: "KYS",
    name: "Kayes Airport",
    city: "Kayes",
    countryId: "ML",
    timeZoneRegionName: "Africa/Bamako",
    latitude: 14.431944,
    longitude: -11.439444,
    icao: "GAKY"
  },
  KYT: {
    iata: "KYT",
    name: "Kyaukhtu Airport",
    city: "Kyaukhtu",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 21.414576,
    longitude: 94.144109,
    icao: "VYKU"
  },
  KYU: {
    iata: "KYU",
    name: "Koyukuk Airport",
    city: "Koyukuk",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 64.878056,
    longitude: -157.713056,
    icao: "PFKU"
  },
  KYZ: {
    iata: "KYZ",
    name: "Kyzyl Airport",
    city: "Kyzyl",
    countryId: "RU",
    timeZoneRegionName: "Asia/Krasnoyarsk",
    latitude: 51.673115,
    longitude: 94.4082,
    icao: "UNKY"
  },
  KZG: {
    iata: "KZG",
    name: "Kitzingen Airport",
    city: "Kitzingen",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 49.733333,
    longitude: 10.15,
    icao: "ETIN"
  },
  KZI: {
    iata: "KZI",
    name: "Philippos Airport",
    city: "Kozani",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 40.288611,
    longitude: 21.841944,
    icao: "LGKZ"
  },
  KZN: {
    iata: "KZN",
    name: "Kazan International Airport",
    city: "Kazan",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 55.608439,
    longitude: 49.29824,
    icao: "UWKD"
  },
  KZO: {
    iata: "KZO",
    name: "Kzyl-Orda Airport",
    city: "Kzyl-Orda",
    countryId: "KZ",
    timeZoneRegionName: "Asia/Qyzylorda",
    latitude: 44.70727,
    longitude: 65.592248,
    icao: "UAOO"
  },
  KZR: {
    iata: "KZR",
    name: "Zafer Airport",
    city: "Kutahya",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 39.120277,
    longitude: 30.116945,
    icao: "LTBZ"
  },
  KZS: {
    iata: "KZS",
    name: "Kastellorizo Airport",
    city: "Kastellorizo",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 36.14167,
    longitude: 29.576376,
    icao: "LGKJ"
  },
  LAA: {
    iata: "LAA",
    name: "Lamar Municipal Airport",
    city: "Lamar",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 38.068611,
    longitude: -102.690278,
    icao: "KLAA"
  },
  LAB: {
    iata: "LAB",
    name: "Lab Lab Airport",
    city: "Lablab",
    countryId: "PG",
    timeZoneRegionName: "Pacific/Port_Moresby",
    latitude: -5.633333,
    longitude: 148.066667,
    icao: ""
  },
  LAD: {
    iata: "LAD",
    name: "Quatro de Fevereiro Airport",
    city: "Luanda",
    countryId: "AO",
    timeZoneRegionName: "Africa/Luanda",
    latitude: -8.847951,
    longitude: 13.234862,
    icao: "FNLU"
  },
  LAE: {
    iata: "LAE",
    name: "Nadzab Airport",
    city: "Lae",
    countryId: "PG",
    timeZoneRegionName: "Pacific/Port_Moresby",
    latitude: -6.566117,
    longitude: 146.728205,
    icao: "AYNZ"
  },
  LAF: {
    iata: "LAF",
    name: "Purdue University Airport",
    city: "Lafayette",
    countryId: "US",
    timeZoneRegionName: "America/Indiana/Indianapolis",
    latitude: 40.411944,
    longitude: -86.933611,
    icao: "KLAF"
  },
  LAH: {
    iata: "LAH",
    name: "Oesman Sadik Airport",
    city: "Labuha",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jayapura",
    latitude: -0.636548,
    longitude: 127.500265,
    icao: "WAPH"
  },
  LAI: {
    iata: "LAI",
    name: "Servel Airport",
    city: "Lannion",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 48.754167,
    longitude: -3.481944,
    icao: "LFRO"
  },
  LAJ: {
    iata: "LAJ",
    name: "Correia Pinto Airport",
    city: "Lages",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -27.782115,
    longitude: -50.279757,
    icao: "SBLJ"
  },
  LAK: {
    iata: "LAK",
    name: "Freddie Carmichael Airport",
    city: "Aklavik",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 68.223286,
    longitude: -135.005889,
    icao: "CYKD"
  },
  LAL: {
    iata: "LAL",
    name: "Lakeland Municipal Airport",
    city: "Lakeland",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 27.988889,
    longitude: -82.014722,
    icao: "KLAL"
  },
  LAM: {
    iata: "LAM",
    name: "Los Alamos Airport",
    city: "Los Alamos",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 35.880135,
    longitude: -106.269054,
    icao: "KLAM"
  },
  LAN: {
    iata: "LAN",
    name: "Lansing Capital Region International Airport",
    city: "Lansing",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.778689,
    longitude: -84.587348,
    icao: "KLAN"
  },
  LAO: {
    iata: "LAO",
    name: "Laoag Airport",
    city: "Laoag",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 18.182408,
    longitude: 120.534123,
    icao: "RPLI"
  },
  LAP: {
    iata: "LAP",
    name: "Leon Airport",
    city: "La Paz",
    countryId: "MX",
    timeZoneRegionName: "America/Mazatlan",
    latitude: 24.076088,
    longitude: -110.367834,
    icao: "MMLP"
  },
  LAQ: {
    iata: "LAQ",
    name: "La Braq Airport",
    city: "Beida",
    countryId: "LY",
    timeZoneRegionName: "Africa/Tripoli",
    latitude: 32.788611,
    longitude: 21.964167,
    icao: "HLLQ"
  },
  LAR: {
    iata: "LAR",
    name: "General Brees Field",
    city: "Laramie",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 41.313611,
    longitude: -105.673056,
    icao: "KLAR"
  },
  LAS: {
    iata: "LAS",
    name: "McCarran International Airport",
    city: "Las Vegas",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 36.081,
    longitude: -115.147599,
    icao: "KLAS"
  },
  LAU: {
    iata: "LAU",
    name: "Lamu Airport",
    city: "Lamu",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: -2.25,
    longitude: 40.911667,
    icao: "HKLU"
  },
  LAW: {
    iata: "LAW",
    name: "Lawton-Fort Sill Regional Airport",
    city: "Lawton",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 34.569722,
    longitude: -98.416111,
    icao: "KLAW"
  },
  LAX: {
    iata: "LAX",
    name: "Los Angeles International Airport",
    city: "Los Angeles",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 33.943399,
    longitude: -118.408279,
    icao: "KLAX"
  },
  LAY: {
    iata: "LAY",
    name: "Ladysmith Airport",
    city: "Ladysmith",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -28.566667,
    longitude: 29.75,
    icao: "FALY"
  },
  LAZ: {
    iata: "LAZ",
    name: "Bom Jesus Da Lapa Airport",
    city: "Bom Jesus Da Lapa",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -13.256944,
    longitude: -43.4125,
    icao: "SBLP"
  },
  LBA: {
    iata: "LBA",
    name: "Leeds Bradford International Airport",
    city: "Leeds",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 53.869339,
    longitude: -1.659985,
    icao: "EGNM"
  },
  LBB: {
    iata: "LBB",
    name: "Lubbock Preston Smith International Airport",
    city: "Lubbock",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 33.656221,
    longitude: -101.8223,
    icao: "KLBB"
  },
  LBC: {
    iata: "LBC",
    name: "Luebeck-Blankensee Airport",
    city: "Hamburg",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 53.805273,
    longitude: 10.701162,
    icao: "EDHL"
  },
  LBD: {
    iata: "LBD",
    name: "Khujand Airport",
    city: "Khujand",
    countryId: "TJ",
    timeZoneRegionName: "Asia/Dushanbe",
    latitude: 40.219887,
    longitude: 69.6965,
    icao: "UTDL"
  },
  LBE: {
    iata: "LBE",
    name: "Westmoreland County Airport",
    city: "Latrobe",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.272927,
    longitude: -79.40855,
    icao: "KLBE"
  },
  LBF: {
    iata: "LBF",
    name: "North Platte Regional Airport (Lee Bird Field)",
    city: "North Platte",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.126198,
    longitude: -100.683984,
    icao: "KLBF"
  },
  LBG: {
    iata: "LBG",
    name: "Le Bourget Airport",
    city: "Paris",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 48.964426,
    longitude: 2.441525,
    icao: "LFPB"
  },
  LBI: {
    iata: "LBI",
    name: "Le Sequestre Airport",
    city: "Albi",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 43.933333,
    longitude: 2.15,
    icao: "LFCI"
  },
  LBJ: {
    iata: "LBJ",
    name: "Komodo Airport",
    city: "Labuan Bajo",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -8.486215,
    longitude: 119.889281,
    icao: "WATO"
  },
  LBL: {
    iata: "LBL",
    name: "Mid-America Regional Airport",
    city: "Liberal",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 37.044444,
    longitude: -100.960556,
    icao: "KLBL"
  },
  LBO: {
    iata: "LBO",
    name: "Lusambo Airport",
    city: "Lusambo",
    countryId: "CD",
    timeZoneRegionName: "Africa/Lubumbashi",
    latitude: -4.966667,
    longitude: 23.45,
    icao: "FZVI"
  },
  LBP: {
    iata: "LBP",
    name: "Long Banga Airport",
    city: "Long Banga",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 3.2,
    longitude: 115.4,
    icao: ""
  },
  LBQ: {
    iata: "LBQ",
    name: "Lambarene Airport",
    city: "Lambarene",
    countryId: "GA",
    timeZoneRegionName: "Africa/Libreville",
    latitude: -0.714722,
    longitude: 10.239444,
    icao: "FOGR"
  },
  LBR: {
    iata: "LBR",
    name: "Labrea Airport",
    city: "Labrea",
    countryId: "BR",
    timeZoneRegionName: "America/Porto_Velho",
    latitude: -7.25,
    longitude: -64.85,
    icao: "SWLB"
  },
  LBS: {
    iata: "LBS",
    name: "Labasa Airport",
    city: "Labasa",
    countryId: "FJ",
    timeZoneRegionName: "Pacific/Fiji",
    latitude: -16.466215,
    longitude: 179.337659,
    icao: "NFNL"
  },
  LBT: {
    iata: "LBT",
    name: "Lumberton Airport",
    city: "Lumberton",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 34.614039,
    longitude: -79.06011,
    icao: "KLBT"
  },
  LBU: {
    iata: "LBU",
    name: "Labuan Airport",
    city: "Labuan",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 5.294355,
    longitude: 115.249164,
    icao: "WBKL"
  },
  LBV: {
    iata: "LBV",
    name: "Libreville Airport",
    city: "Libreville",
    countryId: "GA",
    timeZoneRegionName: "Africa/Libreville",
    latitude: 0.456963,
    longitude: 9.409852,
    icao: "FOOL"
  },
  LBW: {
    iata: "LBW",
    name: "Long Bawan Airport",
    city: "Long Bawan",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: 3.9028,
    longitude: 115.6921,
    icao: "WALB"
  },
  LBX: {
    iata: "LBX",
    name: "Lubang Airport",
    city: "Lubang",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 13.865556,
    longitude: 120.105,
    icao: "RPLU"
  },
  LBY: {
    iata: "LBY",
    name: "La Baule-Escoublac Airport",
    city: "La Baule Escoublac",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 47.288136,
    longitude: -2.346783,
    icao: "LFRE"
  },
  LCA: {
    iata: "LCA",
    name: "Larnaca International Airport",
    city: "Larnaca",
    countryId: "CY",
    timeZoneRegionName: "Asia/Nicosia",
    latitude: 34.870871,
    longitude: 33.607975,
    icao: "LCLK"
  },
  LCC: {
    iata: "LCC",
    name: "Galatina Airport",
    city: "Lecce",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 40.242778,
    longitude: 18.133333,
    icao: "LIBN"
  },
  LCD: {
    iata: "LCD",
    name: "Louis Trichardt Airport",
    city: "Louis Trichardt",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -23.016667,
    longitude: 29.716667,
    icao: "FALO"
  },
  LCE: {
    iata: "LCE",
    name: "Goloson International Airport",
    city: "La Ceiba",
    countryId: "HN",
    timeZoneRegionName: "America/Tegucigalpa",
    latitude: 15.740556,
    longitude: -86.857222,
    icao: "MHLC"
  },
  LCG: {
    iata: "LCG",
    name: "A Coruna Airport",
    city: "La Coruna",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 43.30236,
    longitude: -8.381923,
    icao: "LECO"
  },
  LCH: {
    iata: "LCH",
    name: "Lake Charles Regional Airport",
    city: "Lake Charles",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.123227,
    longitude: -93.22105,
    icao: "KLCH"
  },
  LCI: {
    iata: "LCI",
    name: "Laconia Municipal Airport",
    city: "Laconia",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 43.571389,
    longitude: -71.421111,
    icao: "KLCI"
  },
  LCJ: {
    iata: "LCJ",
    name: "Lodz Lublinek Airport",
    city: "Lodz",
    countryId: "PL",
    timeZoneRegionName: "Europe/Warsaw",
    latitude: 51.721944,
    longitude: 19.398333,
    icao: "EPLL"
  },
  LCK: {
    iata: "LCK",
    name: "Rickenbacker International Airport",
    city: "Columbus",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.817957,
    longitude: -82.935508,
    icao: "KLCK"
  },
  LCL: {
    iata: "LCL",
    name: "La Coloma Airport",
    city: "La Coloma",
    countryId: "CU",
    timeZoneRegionName: "America/Havana",
    latitude: 22.337485,
    longitude: -83.640206,
    icao: "MULM"
  },
  LCM: {
    iata: "LCM",
    name: "La Cumbre Airport",
    city: "La Cumbre",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -30.966667,
    longitude: -64.5,
    icao: "SACC"
  },
  LCO: {
    iata: "LCO",
    name: "Lague Airport",
    city: "Lague",
    countryId: "CG",
    timeZoneRegionName: "Africa/Brazzaville",
    latitude: -2.45,
    longitude: 14.533333,
    icao: "FCBL"
  },
  LCQ: {
    iata: "LCQ",
    name: "Lake City Gateway Airport",
    city: "Lake City",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 30.181882,
    longitude: -82.57529,
    icao: "KLCQ"
  },
  LCR: {
    iata: "LCR",
    name: "La Chorrera Airport",
    city: "La Chorrera",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: -1.457889,
    longitude: -72.802319,
    icao: ""
  },
  LCV: {
    iata: "LCV",
    name: "Lucca Airport",
    city: "Lucca",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 43.833333,
    longitude: 10.583333,
    icao: "LIQL"
  },
  LCY: {
    iata: "LCY",
    name: "London City Airport",
    city: "London",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.50438,
    longitude: 0.049365,
    icao: "EGLC"
  },
  LDA: {
    iata: "LDA",
    name: "Malda Airport",
    city: "Malda",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 25.033333,
    longitude: 88.15,
    icao: "VEMH"
  },
  LDB: {
    iata: "LDB",
    name: "Londrina Airport",
    city: "Londrina",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -23.328456,
    longitude: -51.137715,
    icao: "SBLO"
  },
  LDE: {
    iata: "LDE",
    name: "Tarbes Ossun Lourdes Airport",
    city: "Lourdes",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 43.186508,
    longitude: 3368e-6,
    icao: "LFBT"
  },
  LDH: {
    iata: "LDH",
    name: "Lord Howe Island Airport",
    city: "Lord Howe Island",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -31.540807,
    longitude: 159.078148,
    icao: "YLHI"
  },
  LDI: {
    iata: "LDI",
    name: "Kikwetu Airport",
    city: "Lindi",
    countryId: "TZ",
    timeZoneRegionName: "Africa/Dar_es_Salaam",
    latitude: -9.845833,
    longitude: 39.759444,
    icao: "HTLI"
  },
  LDJ: {
    iata: "LDJ",
    name: "Linden Airport",
    city: "Linden",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.616667,
    longitude: -74.25,
    icao: "KLDJ"
  },
  LDK: {
    iata: "LDK",
    name: "Hovby Airport",
    city: "Lidkoping",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 58.5,
    longitude: 13.166667,
    icao: "ESGL"
  },
  LDM: {
    iata: "LDM",
    name: "Mason Co",
    city: "Ludington",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 44.075333,
    longitude: -86.479167,
    icao: "KLDM"
  },
  LDN: {
    iata: "LDN",
    name: "Lamidanda Airport",
    city: "Lamidanda",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 27.25,
    longitude: 86.716667,
    icao: "VNLD"
  },
  LDS: {
    iata: "LDS",
    name: "Yichun Shi Airport",
    city: "Yichun",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 47.751828,
    longitude: 129.017988,
    icao: "ZYLD"
  },
  LDU: {
    iata: "LDU",
    name: "Lahad Datu Airport",
    city: "Lahad Datu",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 5.035278,
    longitude: 118.326111,
    icao: "WBKD"
  },
  LDV: {
    iata: "LDV",
    name: "Landivisiau Airport",
    city: "Landivisiau",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 48.5,
    longitude: -4.1,
    icao: "LFRJ"
  },
  LDX: {
    iata: "LDX",
    name: "Saint Laurent du Maroni Airport",
    city: "Saint Laurent du Maroni",
    countryId: "GF",
    timeZoneRegionName: "America/Cayenne",
    latitude: 5.483333,
    longitude: -54.05,
    icao: "SOOM"
  },
  LDY: {
    iata: "LDY",
    name: "City of Derry Airport",
    city: "Derry",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 55.040986,
    longitude: -7.156924,
    icao: "EGAE"
  },
  LDZ: {
    iata: "LDZ",
    name: "Londolozi Airport",
    city: "Londolozi",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -24.809691,
    longitude: 31.505367,
    icao: "FALD"
  },
  LEA: {
    iata: "LEA",
    name: "Learmonth Airport",
    city: "Learmonth",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -22.239883,
    longitude: 114.094265,
    icao: "YPLM"
  },
  LEB: {
    iata: "LEB",
    name: "Lebanon Municipal Airport",
    city: "Lebanon",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 43.629359,
    longitude: -72.310007,
    icao: "KLEB"
  },
  LEC: {
    iata: "LEC",
    name: "Coronel Horacio de Mattos Airport",
    city: "Lencois",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -12.486064,
    longitude: -41.274079,
    icao: "SBLE"
  },
  LED: {
    iata: "LED",
    name: "Pulkovo Airport",
    city: "Saint Petersburg",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 59.799847,
    longitude: 30.270505,
    icao: "ULLI"
  },
  LEE: {
    iata: "LEE",
    name: "Leesburg International Airport",
    city: "Leesburg",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 28.823099,
    longitude: -81.808701,
    icao: "KLEE"
  },
  LEH: {
    iata: "LEH",
    name: "Octeville Airport",
    city: "Le Havre",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 49.53391,
    longitude: 0.088063,
    icao: "LFOH"
  },
  LEI: {
    iata: "LEI",
    name: "Almeria Airport",
    city: "Almeria",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 36.847984,
    longitude: -2.371873,
    icao: "LEAM"
  },
  LEJ: {
    iata: "LEJ",
    name: "Leipzig/Halle Airport",
    city: "Leipzig/Halle",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 51.420262,
    longitude: 12.221202,
    icao: "EDDP"
  },
  LEK: {
    iata: "LEK",
    name: "Labe Airport",
    city: "Labe",
    countryId: "GN",
    timeZoneRegionName: "Africa/Conakry",
    latitude: 11.333333,
    longitude: -12.297222,
    icao: "GULB"
  },
  LEL: {
    iata: "LEL",
    name: "Lake Evella Airport",
    city: "Lake Evella",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -12.508333,
    longitude: 135.8,
    icao: "YLEV"
  },
  LEM: {
    iata: "LEM",
    name: "Lemmon Airport",
    city: "Lemmon",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 45.940833,
    longitude: -102.158889,
    icao: "KLEM"
  },
  LEN: {
    iata: "LEN",
    name: "Leon Airport",
    city: "Leon",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 42.590569,
    longitude: -5.64629,
    icao: "LELN"
  },
  LEP: {
    iata: "LEP",
    name: "Leopoldina Airport",
    city: "Leopoldina",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -21.466667,
    longitude: -42.666667,
    icao: "SNDN"
  },
  LEQ: {
    iata: "LEQ",
    name: "Lands End Airport",
    city: "Lands End",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 50.102792,
    longitude: -5.670205,
    icao: "EGHC"
  },
  LER: {
    iata: "LER",
    name: "Leinster Airport",
    city: "Leinster",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -27.839283,
    longitude: 120.704372,
    icao: "YLST"
  },
  LET: {
    iata: "LET",
    name: "Gen. A.V. Cobo Airport",
    city: "Leticia",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: -4.196389,
    longitude: -69.939444,
    icao: "SKLT"
  },
  LEU: {
    iata: "LEU",
    name: "Andorra\u2013La Seu d'Urgell Airport",
    city: "La Seu d'Urgell",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 42.3386,
    longitude: 1.4092,
    icao: "LESU"
  },
  LEV: {
    iata: "LEV",
    name: "Levuka Airfield",
    city: "Bureta",
    countryId: "FJ",
    timeZoneRegionName: "Pacific/Fiji",
    latitude: -17.683333,
    longitude: 178.833333,
    icao: "NFNB"
  },
  LEW: {
    iata: "LEW",
    name: "Auburn Lewiston Municipal Airport",
    city: "Auburn",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 44.0485,
    longitude: -70.283501,
    icao: "KLEW"
  },
  LEX: {
    iata: "LEX",
    name: "Blue Grass Airport",
    city: "Lexington",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 38.037622,
    longitude: -84.597921,
    icao: "KLEX"
  },
  LEY: {
    iata: "LEY",
    name: "Lelystad Airport",
    city: "Lelystad",
    countryId: "NL",
    timeZoneRegionName: "Europe/Amsterdam",
    latitude: 52.466667,
    longitude: 5.533333,
    icao: "EHLE"
  },
  LEZ: {
    iata: "LEZ",
    name: "La Esperanza Airport",
    city: "La Esperanza",
    countryId: "HN",
    timeZoneRegionName: "America/Tegucigalpa",
    latitude: 14.25,
    longitude: -88.166667,
    icao: "MHLE"
  },
  LFB: {
    iata: "LFB",
    name: "Lumbo Airport",
    city: "Lumbo",
    countryId: "MZ",
    timeZoneRegionName: "Africa/Maputo",
    latitude: -15.032044,
    longitude: 40.67248,
    icao: "FQLU"
  },
  LFI: {
    iata: "LFI",
    name: "Langley Air Force Base",
    city: "Hampton",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 37.078971,
    longitude: -76.36109,
    icao: "KLFI"
  },
  LFK: {
    iata: "LFK",
    name: "Lufkin Angelina County Airport",
    city: "Nacogdoches",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 31.234167,
    longitude: -94.750278,
    icao: "KLFK"
  },
  LFM: {
    iata: "LFM",
    name: "Lamerd Airport",
    city: "Lamerd",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 27.369393,
    longitude: 53.195354,
    icao: "OISR"
  },
  LFN: {
    iata: "LFN",
    name: "Triangle North Executive Airport",
    city: "Louisburg",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 36.024947,
    longitude: -78.325418,
    icao: "KLHZ"
  },
  LFQ: {
    iata: "LFQ",
    name: "Linfen Qiaoli Airport",
    city: "Qiaoli",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 36.043525,
    longitude: 111.494936,
    icao: "ZBLF"
  },
  LFR: {
    iata: "LFR",
    name: "La Fria Airport",
    city: "La Fria",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 8.240556,
    longitude: -72.272222,
    icao: "SVLF"
  },
  LFT: {
    iata: "LFT",
    name: "Lafayette Regional Airport",
    city: "Lafayette",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.20851,
    longitude: -91.99327,
    icao: "KLFT"
  },
  LFW: {
    iata: "LFW",
    name: "Lome Airport",
    city: "Lome",
    countryId: "TG",
    timeZoneRegionName: "Africa/Lome",
    latitude: 6.167103,
    longitude: 1.250347,
    icao: "DXXX"
  },
  LGA: {
    iata: "LGA",
    name: "LaGuardia Airport",
    city: "New York",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.774252,
    longitude: -73.871617,
    icao: "KLGA"
  },
  LGB: {
    iata: "LGB",
    name: "Long Beach Airport",
    city: "Long Beach",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 33.818194,
    longitude: -118.144494,
    icao: "KLGB"
  },
  LGC: {
    iata: "LGC",
    name: "Calloway Airport",
    city: "La Grange",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 33.0075,
    longitude: -85.070833,
    icao: "KLGC"
  },
  LGD: {
    iata: "LGD",
    name: "La Grande/Union County Airport",
    city: "La Grande",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 45.289722,
    longitude: -118.005,
    icao: "KLGD"
  },
  LGE: {
    iata: "LGE",
    name: "Mulan Airport",
    city: "Lake Gregory",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -20.133333,
    longitude: 127.566667,
    icao: "YUAN"
  },
  LGF: {
    iata: "LGF",
    name: "Laguna Army Air Field",
    city: "Yuma",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 32.861859,
    longitude: -114.398003,
    icao: "KLGF"
  },
  LGG: {
    iata: "LGG",
    name: "Liege Airport",
    city: "Liege",
    countryId: "BE",
    timeZoneRegionName: "Europe/Brussels",
    latitude: 50.643334,
    longitude: 5.460149,
    icao: "EBLG"
  },
  LGH: {
    iata: "LGH",
    name: "Leigh Creek Airport",
    city: "Leigh Creek",
    countryId: "AU",
    timeZoneRegionName: "Australia/Adelaide",
    latitude: -30.466667,
    longitude: 138.416667,
    icao: "YLEC"
  },
  LGI: {
    iata: "LGI",
    name: "Deadmans Cay Airport",
    city: "Deadmans Cay",
    countryId: "BS",
    timeZoneRegionName: "America/Nassau",
    latitude: 23.179444,
    longitude: -75.090556,
    icao: "MYLD"
  },
  LGK: {
    iata: "LGK",
    name: "Langkawi International Airport",
    city: "Langkawi",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 6.342174,
    longitude: 99.731403,
    icao: "WMKL"
  },
  LGL: {
    iata: "LGL",
    name: "Long Lellang Airport",
    city: "Long Lellang",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 3.42139,
    longitude: 115.15361,
    icao: "WBGF"
  },
  LGO: {
    iata: "LGO",
    name: "Langeoog Airport",
    city: "Langeoog",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 53.766667,
    longitude: 7.533333,
    icao: "EDWL"
  },
  LGP: {
    iata: "LGP",
    name: "Legaspi Airport",
    city: "Legaspi",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 13.15213,
    longitude: 123.730204,
    icao: "RPLP"
  },
  LGQ: {
    iata: "LGQ",
    name: "Lago Agrio Airport",
    city: "Lago Agrio",
    countryId: "EC",
    timeZoneRegionName: "America/Guayaquil",
    latitude: 0.1,
    longitude: -76.883333,
    icao: "SELA"
  },
  LGR: {
    iata: "LGR",
    name: "Cochrane Airport",
    city: "Cochrane",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -47.166667,
    longitude: -72,
    icao: "SCHR"
  },
  LGS: {
    iata: "LGS",
    name: "Comodoro D.R. Salomon Airport",
    city: "Malargue",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -35.49324,
    longitude: -69.574566,
    icao: "SAMM"
  },
  LGU: {
    iata: "LGU",
    name: "Cache Airport",
    city: "Logan",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 41.7875,
    longitude: -111.855,
    icao: "KLGU"
  },
  LGW: {
    iata: "LGW",
    name: "London Gatwick Airport",
    city: "London",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.150836,
    longitude: -0.177416,
    icao: "EGKK"
  },
  LGZ: {
    iata: "LGZ",
    name: "Shannan Longzi Airport",
    city: "Shannan",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 28.422222,
    longitude: 92.348056,
    icao: ""
  },
  LHA: {
    iata: "LHA",
    name: "Black Forest Airport",
    city: "Lahr",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 48.369304,
    longitude: 7.827674,
    icao: "EDTL"
  },
  LHE: {
    iata: "LHE",
    name: "Allama Iqbal International Airport",
    city: "Lahore",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 31.520833,
    longitude: 74.402778,
    icao: "OPLA"
  },
  LHG: {
    iata: "LHG",
    name: "Lightning Ridge Airport",
    city: "Lightning Ridge",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -29.458333,
    longitude: 147.983333,
    icao: "YLRD"
  },
  LHN: {
    iata: "LHN",
    name: "Linhares Municipal Airport",
    city: "Linhares",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -19.3572,
    longitude: -40.0697,
    icao: ""
  },
  LHR: {
    iata: "LHR",
    name: "London Heathrow Airport",
    city: "London",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.469603,
    longitude: -0.453566,
    icao: "EGLL"
  },
  LHU: {
    iata: "LHU",
    name: "Lianshulu Airport",
    city: "Caprivi",
    countryId: "NA",
    timeZoneRegionName: "Africa/Windhoek",
    latitude: -18.116389,
    longitude: 23.391667,
    icao: "KLHU"
  },
  LHV: {
    iata: "LHV",
    name: "W T Piper Memorial Airport",
    city: "Lock Haven",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.133333,
    longitude: -77.45,
    icao: "KLHV"
  },
  LHW: {
    iata: "LHW",
    name: "Lanzhou Zhongchuan International Airport",
    city: "Lanzhou",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 36.509497,
    longitude: 103.61756,
    icao: "ZLLL"
  },
  LIC: {
    iata: "LIC",
    name: "Limon Municipal Airport",
    city: "Limon",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 39.266667,
    longitude: -103.683333,
    icao: "KLIC"
  },
  LID: {
    iata: "LID",
    name: "Valkenburg Airport",
    city: "Leiden",
    countryId: "NL",
    timeZoneRegionName: "Europe/Amsterdam",
    latitude: 52.15,
    longitude: 4.5,
    icao: "EHVB"
  },
  LIE: {
    iata: "LIE",
    name: "Libenge Airport",
    city: "Libenge",
    countryId: "CD",
    timeZoneRegionName: "Africa/Kinshasa",
    latitude: 3.623611,
    longitude: 18.638889,
    icao: "FZFA"
  },
  LIF: {
    iata: "LIF",
    name: "Lifou Airport",
    city: "Lifou",
    countryId: "NC",
    timeZoneRegionName: "Pacific/Noumea",
    latitude: -20.766667,
    longitude: 167.25,
    icao: "NWWL"
  },
  LIG: {
    iata: "LIG",
    name: "Bellegarde Airport",
    city: "Limoges",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 45.862179,
    longitude: 1.176245,
    icao: "LFBL"
  },
  LIH: {
    iata: "LIH",
    name: "Lihue Airport",
    city: "Kauai Island",
    countryId: "US",
    timeZoneRegionName: "Pacific/Honolulu",
    latitude: 21.978204,
    longitude: -159.349445,
    icao: "PHLI"
  },
  LIJ: {
    iata: "LIJ",
    name: "Lishui Airport",
    city: "Lishui",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 28.3727,
    longitude: 119.839,
    icao: "ZSLR"
  },
  LIL: {
    iata: "LIL",
    name: "Lille Airport",
    city: "Lille",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 50.572047,
    longitude: 3.106067,
    icao: "LFQQ"
  },
  LIM: {
    iata: "LIM",
    name: "Jorge Chavez International Airport",
    city: "Lima",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -12.024763,
    longitude: -77.10879,
    icao: "SPJC"
  },
  LIN: {
    iata: "LIN",
    name: "Milano Linate Airport",
    city: "Milan",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 45.460958,
    longitude: 9.279157,
    icao: "LIML"
  },
  LIO: {
    iata: "LIO",
    name: "Limon International Airport",
    city: "Limon",
    countryId: "CR",
    timeZoneRegionName: "America/Costa_Rica",
    latitude: 9.962695,
    longitude: -83.025518,
    icao: "MRLM"
  },
  LIP: {
    iata: "LIP",
    name: "Lins Airport",
    city: "Lins",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -21.666667,
    longitude: -49.75,
    icao: "SBLN"
  },
  LIQ: {
    iata: "LIQ",
    name: "Lisala Airport",
    city: "Lisala",
    countryId: "CD",
    timeZoneRegionName: "Africa/Kinshasa",
    latitude: 2.170556,
    longitude: 21.496667,
    icao: "FZGA"
  },
  LIR: {
    iata: "LIR",
    name: "Liberia Airport",
    city: "Liberia",
    countryId: "CR",
    timeZoneRegionName: "America/Costa_Rica",
    latitude: 10.600005,
    longitude: -85.538394,
    icao: "MRLB"
  },
  LIS: {
    iata: "LIS",
    name: "Lisbon Portela Airport",
    city: "Lisbon",
    countryId: "PT",
    timeZoneRegionName: "Europe/Lisbon",
    latitude: 38.770043,
    longitude: -9.128165,
    icao: "LPPT"
  },
  LIT: {
    iata: "LIT",
    name: "Bill and Hillary Clinton National Airport",
    city: "Little Rock",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 34.727431,
    longitude: -92.221374,
    icao: "KLIT"
  },
  LIW: {
    iata: "LIW",
    name: "Loikaw Airport",
    city: "Loikaw",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 19.689546,
    longitude: 97.214384,
    icao: "VYLK"
  },
  LIX: {
    iata: "LIX",
    name: "Likoma Island Airport",
    city: "Likoma Island",
    countryId: "MW",
    timeZoneRegionName: "Africa/Blantyre",
    latitude: -12.075532,
    longitude: 34.737195,
    icao: "FWLK"
  },
  LIY: {
    iata: "LIY",
    name: "Wright Army Air Field",
    city: "Hinesville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 31.85,
    longitude: -81.6,
    icao: "KLHW"
  },
  LJA: {
    iata: "LJA",
    name: "Lodja Airport",
    city: "Lodja",
    countryId: "CD",
    timeZoneRegionName: "Africa/Lubumbashi",
    latitude: -3.46296,
    longitude: 23.618839,
    icao: "FZVA"
  },
  LJG: {
    iata: "LJG",
    name: "Lijiang Sanyi Airport",
    city: "Lijiang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 26.679975,
    longitude: 100.245768,
    icao: "ZPLJ"
  },
  LJN: {
    iata: "LJN",
    name: "Brazoria County Airport",
    city: "Lake Jackson",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 29.108601,
    longitude: -95.462097,
    icao: "KLBX"
  },
  LJU: {
    iata: "LJU",
    name: "Ljubljana Joze Pucnik Airport",
    city: "Ljubljana",
    countryId: "SI",
    timeZoneRegionName: "Europe/Ljubljana",
    latitude: 46.23102,
    longitude: 14.454972,
    icao: "LJLJ"
  },
  LKA: {
    iata: "LKA",
    name: "Larantuka Gewayantana Airport",
    city: "Larantuka",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -8.274301,
    longitude: 123.001315,
    icao: "WATL"
  },
  LKB: {
    iata: "LKB",
    name: "Lakeba Island Airport",
    city: "Lakeba",
    countryId: "FJ",
    timeZoneRegionName: "Pacific/Fiji",
    latitude: -18.199565,
    longitude: -178.816461,
    icao: "NFNK"
  },
  LKG: {
    iata: "LKG",
    name: "Lokichogio Airport",
    city: "Lokichogio",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: 4.203645,
    longitude: 34.349976,
    icao: "HKLK"
  },
  LKH: {
    iata: "LKH",
    name: "Long Akah Airport",
    city: "Long Akah",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 3.312934,
    longitude: 114.785657,
    icao: "WBGA"
  },
  LKL: {
    iata: "LKL",
    name: "Banak Airport",
    city: "Lakselv",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 70.067778,
    longitude: 24.973611,
    icao: "ENNA"
  },
  LKN: {
    iata: "LKN",
    name: "Leknes Airport",
    city: "Leknes",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 68.154216,
    longitude: 13.614864,
    icao: "ENLK"
  },
  LKO: {
    iata: "LKO",
    name: "Chaudhary Charan Singh International Airport",
    city: "Lucknow",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 26.764257,
    longitude: 80.884186,
    icao: "VILK"
  },
  LKP: {
    iata: "LKP",
    name: "Lake Placid Airport",
    city: "Lake Placid",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 44.2645,
    longitude: -73.961899,
    icao: "KLKP"
  },
  LKV: {
    iata: "LKV",
    name: "Lake County Airport",
    city: "Lakeview",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 42.166667,
    longitude: -120.4,
    icao: "KLKV"
  },
  LKY: {
    iata: "LKY",
    name: "Lake Manyara Airport",
    city: "Lake Manyara",
    countryId: "TZ",
    timeZoneRegionName: "Africa/Dar_es_Salaam",
    latitude: -3.374524,
    longitude: 35.816626,
    icao: "HTLM"
  },
  LKZ: {
    iata: "LKZ",
    name: "Lakenheath RAF",
    city: "Brandon",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 52.491667,
    longitude: 0.67609,
    icao: "EGUL"
  },
  LLA: {
    iata: "LLA",
    name: "Lulea Airport",
    city: "Lulea",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 65.548278,
    longitude: 22.121523,
    icao: "ESPA"
  },
  LLB: {
    iata: "LLB",
    name: "Qiannan Libo Airport",
    city: "Libo City",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 25.452476,
    longitude: 107.961916,
    icao: ""
  },
  LLC: {
    iata: "LLC",
    name: "Cagayan North International Airport",
    city: "Lal-lo",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 18.1819,
    longitude: 121.7458,
    icao: "RPLH"
  },
  LLE: {
    iata: "LLE",
    name: "Malelane Airport",
    city: "Malelane",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -25.466667,
    longitude: 31.566667,
    icao: "FAMN"
  },
  LLF: {
    iata: "LLF",
    name: "Yongzhou Lingling Airport",
    city: "Yongzhou",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 26.345556,
    longitude: 111.612222,
    icao: "ZGLG"
  },
  LLG: {
    iata: "LLG",
    name: "Chillagoe Airport",
    city: "Chillagoe",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -17.14084,
    longitude: 144.527967,
    icao: "YCGO"
  },
  LLI: {
    iata: "LLI",
    name: "Lalibela Airport",
    city: "Lalibela",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 12.016667,
    longitude: 39.066667,
    icao: "HALL"
  },
  LLJ: {
    iata: "LLJ",
    name: "Silampari Airport",
    city: "Lubuk Linggau",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -3.284167,
    longitude: 102.913333,
    icao: "WIPB"
  },
  LLK: {
    iata: "LLK",
    name: "Lankaran International Airport",
    city: "Lankaran",
    countryId: "AZ",
    timeZoneRegionName: "Asia/Baku",
    latitude: 38.74203,
    longitude: 48.824093,
    icao: "UBBL"
  },
  LLM: {
    iata: "LLM",
    name: "Lomlom Airport",
    city: "Lomlom",
    countryId: "SB",
    timeZoneRegionName: "Pacific/Guadalcanal",
    latitude: -10.294722,
    longitude: 166.319444,
    icao: "AGLM"
  },
  LLO: {
    iata: "LLO",
    name: "Palopo Lagaligo Airport",
    city: "Palopo",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -3.084722,
    longitude: 120.245278,
    icao: ""
  },
  LLU: {
    iata: "LLU",
    name: "Alluitsup Paa Heliport",
    city: "Alluitsup Paa",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 60.464529,
    longitude: -45.588847,
    icao: "BGAP"
  },
  LLV: {
    iata: "LLV",
    name: "Luliang Dawu Airport",
    city: "Luliang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 37.683333,
    longitude: 111.142778,
    icao: ""
  },
  LLW: {
    iata: "LLW",
    name: "Lilongwe International Airport",
    city: "Lilongwe",
    countryId: "MW",
    timeZoneRegionName: "Africa/Blantyre",
    latitude: -13.780039,
    longitude: 33.780199,
    icao: "FWLI"
  },
  LLY: {
    iata: "LLY",
    name: "Burlington County Airport",
    city: "Mount Holly",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.916667,
    longitude: -74.75,
    icao: "KVAY"
  },
  LMA: {
    iata: "LMA",
    name: "Lake Minchumina Airport",
    city: "Lake Minchumina",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 63.883333,
    longitude: -152.316667,
    icao: ""
  },
  LMB: {
    iata: "LMB",
    name: "Salima Airport",
    city: "Salima",
    countryId: "MW",
    timeZoneRegionName: "Africa/Blantyre",
    latitude: -13.75,
    longitude: 34.583333,
    icao: "FWSM"
  },
  LME: {
    iata: "LME",
    name: "Arnage Airport",
    city: "Le Mans",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 47.948601,
    longitude: 0.201667,
    icao: "LFRM"
  },
  LMM: {
    iata: "LMM",
    name: "Federal Airport",
    city: "Los Mochis",
    countryId: "MX",
    timeZoneRegionName: "America/Mazatlan",
    latitude: 25.6852,
    longitude: -109.081001,
    icao: "MMLM"
  },
  LMN: {
    iata: "LMN",
    name: "Limbang Airport",
    city: "Limbang",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 4.666667,
    longitude: 115,
    icao: "WBGJ"
  },
  LMO: {
    iata: "LMO",
    name: "Lossiemouth Royal Air Force Station",
    city: "Lossiemouth",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 57.705527,
    longitude: -3.339777,
    icao: "EGQS"
  },
  LMP: {
    iata: "LMP",
    name: "Lampedusa Airport",
    city: "Lampedusa",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 35.5,
    longitude: 12.616667,
    icao: "LICD"
  },
  LMQ: {
    iata: "LMQ",
    name: "Marsa el Brega Airport",
    city: "Marsa el Brega",
    countryId: "LY",
    timeZoneRegionName: "Africa/Tripoli",
    latitude: 30.379444,
    longitude: 19.579444,
    icao: "HLMB"
  },
  LMR: {
    iata: "LMR",
    name: "Lima Acres Airport",
    city: "Lima Acres",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -28.366667,
    longitude: 23.45,
    icao: "FALC"
  },
  LMS: {
    iata: "LMS",
    name: "Winston County Airport",
    city: "Louisville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 33.116667,
    longitude: -89.05,
    icao: "KLMS"
  },
  LMT: {
    iata: "LMT",
    name: "Crater Lake Klamath Regional Airport",
    city: "Klamath Falls",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 42.163056,
    longitude: -121.735833,
    icao: "KLMT"
  },
  LMU: {
    iata: "LMU",
    name: "Letung Airport",
    city: "Jemaja Island",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: 2.963056,
    longitude: 105.754444,
    icao: "WIDL"
  },
  LMV: {
    iata: "LMV",
    name: "Madivaru Airport",
    city: "Naifaru",
    countryId: "MV",
    timeZoneRegionName: "Indian/Maldives",
    latitude: 5.4577,
    longitude: 73.3702,
    icao: ""
  },
  LNA: {
    iata: "LNA",
    name: "Palm Beach County Airport",
    city: "West Palm Beach",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 26.592477,
    longitude: -80.084477,
    icao: "KLNA"
  },
  LNB: {
    iata: "LNB",
    name: "Lamen Bay Airport",
    city: "Lamen Bay",
    countryId: "VU",
    timeZoneRegionName: "Pacific/Efate",
    latitude: -16.583333,
    longitude: 168.183333,
    icao: "NVSM"
  },
  LND: {
    iata: "LND",
    name: "Hunt Field",
    city: "Lander",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 42.833333,
    longitude: -108.733333,
    icao: "KLND"
  },
  LNE: {
    iata: "LNE",
    name: "Lonorore Airport",
    city: "Lonorore",
    countryId: "VU",
    timeZoneRegionName: "Pacific/Efate",
    latitude: -15.860106,
    longitude: 168.170072,
    icao: "NVSO"
  },
  LNJ: {
    iata: "LNJ",
    name: "Lincang Airport",
    city: "Lincang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 23.744107,
    longitude: 100.026244,
    icao: "ZPLC"
  },
  LNK: {
    iata: "LNK",
    name: "Lincoln Airport",
    city: "Lincoln",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 40.846176,
    longitude: -96.754707,
    icao: "KLNK"
  },
  LNL: {
    iata: "LNL",
    name: "Longnan Cheng Xian Airport",
    city: "Longan",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 33.7898,
    longitude: 105.788395,
    icao: ""
  },
  LNN: {
    iata: "LNN",
    name: "Lost Nation Airport",
    city: "Willoughby",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.683646,
    longitude: -81.391396,
    icao: "KLNN"
  },
  LNO: {
    iata: "LNO",
    name: "Leonora Airport",
    city: "Leonora",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -28.879344,
    longitude: 121.316924,
    icao: "YLEO"
  },
  LNP: {
    iata: "LNP",
    name: "Wise Airport",
    city: "Wise",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 36.983333,
    longitude: -82.566667,
    icao: "KLNP"
  },
  LNR: {
    iata: "LNR",
    name: "Tri County Regional Airport",
    city: "Lone Rock",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 43.211908,
    longitude: -90.182116,
    icao: "KLNR"
  },
  LNS: {
    iata: "LNS",
    name: "Lancaster Airport",
    city: "Lancaster",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.121111,
    longitude: -76.299722,
    icao: "KLNS"
  },
  LNU: {
    iata: "LNU",
    name: "Kolonel RA Bessing Airport",
    city: "Malinau",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: 3.576389,
    longitude: 116.618333,
    icao: "WALM"
  },
  LNV: {
    iata: "LNV",
    name: "Lihir Island Kunaye Airport",
    city: "Lihir Island",
    countryId: "PG",
    timeZoneRegionName: "Pacific/Port_Moresby",
    latitude: -3.043223,
    longitude: 152.627191,
    icao: "AYKY"
  },
  LNY: {
    iata: "LNY",
    name: "Lanai Airport",
    city: "Lanai",
    countryId: "US",
    timeZoneRegionName: "Pacific/Honolulu",
    latitude: 20.790084,
    longitude: -156.950481,
    icao: "PHNY"
  },
  LNZ: {
    iata: "LNZ",
    name: "Linz Airport",
    city: "Linz",
    countryId: "AT",
    timeZoneRegionName: "Europe/Vienna",
    latitude: 48.239868,
    longitude: 14.193345,
    icao: "LOWL"
  },
  LOA: {
    iata: "LOA",
    name: "Lorraine Airport",
    city: "Lorraine",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -19,
    longitude: 139.9,
    icao: "YLOR"
  },
  LOB: {
    iata: "LOB",
    name: "Los Andes Airport",
    city: "Los Andes",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -29.966667,
    longitude: -71.533333,
    icao: "SCAN"
  },
  LOD: {
    iata: "LOD",
    name: "Longana Airport",
    city: "Longana",
    countryId: "VU",
    timeZoneRegionName: "Pacific/Efate",
    latitude: -15.316667,
    longitude: 167.966667,
    icao: "NVSG"
  },
  LOE: {
    iata: "LOE",
    name: "Loei Airport",
    city: "Loei",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 17.437847,
    longitude: 101.72187,
    icao: "VTUL"
  },
  LOH: {
    iata: "LOH",
    name: "Ciudad de Catamayo Airport",
    city: "Loja",
    countryId: "EC",
    timeZoneRegionName: "America/Guayaquil",
    latitude: -3.995881,
    longitude: -79.37193,
    icao: "SECA"
  },
  LOK: {
    iata: "LOK",
    name: "Lodwar Airport",
    city: "Lodwar",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: 3.15,
    longitude: 35.6,
    icao: "HKLO"
  },
  LOL: {
    iata: "LOL",
    name: "Derby Field",
    city: "Lovelock",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 40.058333,
    longitude: -118.566667,
    icao: "KLOL"
  },
  LOO: {
    iata: "LOO",
    name: "L'Mekrareg Airport",
    city: "Laghouat",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 33.761019,
    longitude: 2.934811,
    icao: "DAUL"
  },
  LOP: {
    iata: "LOP",
    name: "Lombok International Airport",
    city: "Praya",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -8.761611,
    longitude: 116.273838,
    icao: "WADL"
  },
  LOS: {
    iata: "LOS",
    name: "Murtala Muhammed International Airport",
    city: "Lagos",
    countryId: "NG",
    timeZoneRegionName: "Africa/Lagos",
    latitude: 6.57737,
    longitude: 3.321156,
    icao: "DNMM"
  },
  LOT: {
    iata: "LOT",
    name: "Lewis University Airport",
    city: "Romeoville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.607476,
    longitude: -88.09617,
    icao: "KLOT"
  },
  LOU: {
    iata: "LOU",
    name: "Bowman Field",
    city: "Louisville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 38.227275,
    longitude: -85.656879,
    icao: "KLOU"
  },
  LOV: {
    iata: "LOV",
    name: "Venustiano Carranza International Airport",
    city: "Monclova",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 26.955455,
    longitude: -101.466072,
    icao: "MMMV"
  },
  LOW: {
    iata: "LOW",
    name: "Louisa Airport",
    city: "Louisa",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 38,
    longitude: -77.966667,
    icao: "KLKU"
  },
  LOY: {
    iata: "LOY",
    name: "Loyangalani Airport",
    city: "Loyangalani",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: 2.75,
    longitude: 36.716667,
    icao: "HKLY"
  },
  LOZ: {
    iata: "LOZ",
    name: "Magee Field",
    city: "London",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 37.087222,
    longitude: -84.076944,
    icao: "KLOZ"
  },
  LPA: {
    iata: "LPA",
    name: "Gran Canaria Airport",
    city: "Las Palmas",
    countryId: "ES",
    timeZoneRegionName: "Atlantic/Canary",
    latitude: 27.932398,
    longitude: -15.384626,
    icao: "GCLP"
  },
  LPB: {
    iata: "LPB",
    name: "El Alto International Airport",
    city: "La Paz",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -16.508891,
    longitude: -68.176903,
    icao: "SLLP"
  },
  LPC: {
    iata: "LPC",
    name: "Lompoc Airport",
    city: "Lompoc",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 34.664642,
    longitude: -120.466196,
    icao: "KLPC"
  },
  LPD: {
    iata: "LPD",
    name: "La Pedrera Airport",
    city: "La Pedrera",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: -1.3,
    longitude: -69.716667,
    icao: "SKLP"
  },
  LPF: {
    iata: "LPF",
    name: "Liupanshui Yuezhao Airport",
    city: "Yuezhao",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 26.605949,
    longitude: 104.971351,
    icao: ""
  },
  LPG: {
    iata: "LPG",
    name: "La Plata Airport",
    city: "La Plata",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -34.974952,
    longitude: -57.892334,
    icao: "SADL"
  },
  LPI: {
    iata: "LPI",
    name: "Linkoping City Airport",
    city: "Linkoping",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 58.406944,
    longitude: 15.656944,
    icao: "ESSL"
  },
  LPL: {
    iata: "LPL",
    name: "Liverpool John Lennon Airport",
    city: "Liverpool",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 53.337616,
    longitude: -2.854905,
    icao: "EGGP"
  },
  LPM: {
    iata: "LPM",
    name: "Lamap Airport",
    city: "Lamap",
    countryId: "VU",
    timeZoneRegionName: "Pacific/Efate",
    latitude: -16.466667,
    longitude: 167.816667,
    icao: "NVSL"
  },
  LPO: {
    iata: "LPO",
    name: "Laporte Municipal Airport",
    city: "Laporte",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.6,
    longitude: -86.716667,
    icao: "KPPO"
  },
  LPP: {
    iata: "LPP",
    name: "Lappeenranta Airport",
    city: "Lappeenranta",
    countryId: "FI",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 61.044114,
    longitude: 28.155163,
    icao: "EFLP"
  },
  LPQ: {
    iata: "LPQ",
    name: "Luang Prabang International Airport",
    city: "Luang Prabang",
    countryId: "LA",
    timeZoneRegionName: "Asia/Vientiane",
    latitude: 19.897055,
    longitude: 102.163709,
    icao: "VLLB"
  },
  LPS: {
    iata: "LPS",
    name: "Lopez Island Airport",
    city: "Lopez Island",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 48.482778,
    longitude: -122.935556,
    icao: ""
  },
  LPT: {
    iata: "LPT",
    name: "Lampang Airport",
    city: "Lampang",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 18.274167,
    longitude: 99.507222,
    icao: "VTCL"
  },
  LPX: {
    iata: "LPX",
    name: "Liepaya Airport",
    city: "Liepaya",
    countryId: "LV",
    timeZoneRegionName: "Europe/Riga",
    latitude: 56.516667,
    longitude: 21.1,
    icao: "EVLA"
  },
  LPY: {
    iata: "LPY",
    name: "Loudes Airport",
    city: "Le Puy",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 45.083333,
    longitude: 3.766667,
    icao: "LFHP"
  },
  LQK: {
    iata: "LQK",
    name: "Pickens Airport",
    city: "Pickens",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 34.883333,
    longitude: -82.7,
    icao: "KLQK"
  },
  LQM: {
    iata: "LQM",
    name: "Puerto Leguizamo Airport",
    city: "Puerto Leguizamo",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: -0.3,
    longitude: -74.583333,
    icao: "SKLG"
  },
  LQN: {
    iata: "LQN",
    name: "Qala i Naw Airport",
    city: "Qala i Naw",
    countryId: "AF",
    timeZoneRegionName: "Asia/Kabul",
    latitude: 34.986638,
    longitude: 63.119055,
    icao: "OAQN"
  },
  LRA: {
    iata: "LRA",
    name: "Larisa Airport",
    city: "Larisa",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 39.651111,
    longitude: 22.463889,
    icao: "LGLR"
  },
  LRB: {
    iata: "LRB",
    name: "Leribe Airport",
    city: "Leribe",
    countryId: "LS",
    timeZoneRegionName: "Africa/Maseru",
    latitude: -28.966667,
    longitude: 28,
    icao: "FXLR"
  },
  LRD: {
    iata: "LRD",
    name: "Laredo International Airport",
    city: "Laredo",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 27.543667,
    longitude: -99.455122,
    icao: "KLRD"
  },
  LRE: {
    iata: "LRE",
    name: "Longreach Airport",
    city: "Longreach",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -23.439475,
    longitude: 144.271464,
    icao: "YBLR"
  },
  LRF: {
    iata: "LRF",
    name: "Little Rock Air Force Base",
    city: "Jacksonville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 34.916667,
    longitude: -92.15,
    icao: "KLRF"
  },
  LRH: {
    iata: "LRH",
    name: "Laleu Airport",
    city: "La Rochelle",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 46.180556,
    longitude: -1.185833,
    icao: "LFBH"
  },
  LRJ: {
    iata: "LRJ",
    name: "Lemars Municipal Airport",
    city: "Lemars",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 42.8,
    longitude: -96.166667,
    icao: "KLRJ"
  },
  LRL: {
    iata: "LRL",
    name: "Niamtougou Airport",
    city: "Niamtougou",
    countryId: "TG",
    timeZoneRegionName: "Africa/Lome",
    latitude: 9.767359,
    longitude: 1.091265,
    icao: "DXNG"
  },
  LRM: {
    iata: "LRM",
    name: "La Romana Airport",
    city: "La Romana",
    countryId: "DO",
    timeZoneRegionName: "America/Santo_Domingo",
    latitude: 18.416667,
    longitude: -68.9,
    icao: "MDLR"
  },
  LRR: {
    iata: "LRR",
    name: "Lar Airport",
    city: "Lar",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 27.669689,
    longitude: 54.38276,
    icao: "OISL"
  },
  LRS: {
    iata: "LRS",
    name: "Leros Airport",
    city: "Leros",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 37.516667,
    longitude: 26.783333,
    icao: "LGLE"
  },
  LRT: {
    iata: "LRT",
    name: "Lann Bihoue Airport",
    city: "Lorient",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 47.753739,
    longitude: -3.436394,
    icao: "LFRH"
  },
  LRU: {
    iata: "LRU",
    name: "Las Cruces Municipal Airport",
    city: "Las Cruces",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 32.290833,
    longitude: -106.921667,
    icao: "KLRU"
  },
  LRV: {
    iata: "LRV",
    name: "Los Roques Airport",
    city: "Los Roques",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 11.857591,
    longitude: -66.750117,
    icao: "SVRS"
  },
  LSB: {
    iata: "LSB",
    name: "Lordsburg Airport",
    city: "Lordsburg",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 32.416667,
    longitude: -108.666667,
    icao: "KLSB"
  },
  LSC: {
    iata: "LSC",
    name: "La Florida Airport",
    city: "La Serena",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -29.917297,
    longitude: -71.203688,
    icao: "SCSE"
  },
  LSE: {
    iata: "LSE",
    name: "La Crosse Regional Airport",
    city: "La Crosse",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 43.875245,
    longitude: -91.264334,
    icao: "KLSE"
  },
  LSF: {
    iata: "LSF",
    name: "Lawson Army Air Field - Ft Benning",
    city: "Columbus",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 32.335278,
    longitude: -84.990074,
    icao: "KLSF"
  },
  LSH: {
    iata: "LSH",
    name: "Lashio Airport",
    city: "Lashio",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 22.966667,
    longitude: 97.75,
    icao: "VYLS"
  },
  LSI: {
    iata: "LSI",
    name: "Sumburgh Airport",
    city: "Shetland Islands",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 59.877889,
    longitude: -1.287111,
    icao: "EGPB"
  },
  LSK: {
    iata: "LSK",
    name: "Lusk Municipal",
    city: "Lusk",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 42.788083,
    longitude: -104.445528,
    icao: "KLSK"
  },
  LSL: {
    iata: "LSL",
    name: "Los Chiles Airport",
    city: "Los Chiles",
    countryId: "CR",
    timeZoneRegionName: "America/Costa_Rica",
    latitude: 11.033333,
    longitude: -84.7,
    icao: "MRLC"
  },
  LSN: {
    iata: "LSN",
    name: "Los Banos Airport",
    city: "Los Banos",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 37.066667,
    longitude: -120.85,
    icao: "KLSN"
  },
  LSP: {
    iata: "LSP",
    name: "Josefa Camejo Airport",
    city: "Las Piedras",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 11.777155,
    longitude: -70.14961,
    icao: "SVJC"
  },
  LSQ: {
    iata: "LSQ",
    name: "Los Angeles Airport",
    city: "Los Angeles",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -37.3975,
    longitude: -72.422778,
    icao: "SCGE"
  },
  LSS: {
    iata: "LSS",
    name: "Les Saintes Airport",
    city: "Terre-de-Haut",
    countryId: "GP",
    timeZoneRegionName: "America/Guadeloupe",
    latitude: 15.864594,
    longitude: -61.580187,
    icao: "TFFS"
  },
  LST: {
    iata: "LST",
    name: "Launceston Airport",
    city: "Launceston",
    countryId: "AU",
    timeZoneRegionName: "Australia/Hobart",
    latitude: -41.543511,
    longitude: 147.205328,
    icao: "YMLT"
  },
  LSV: {
    iata: "LSV",
    name: "Nellis Air Force Base",
    city: "Las Vegas",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 36.23297,
    longitude: -115.035953,
    icao: "KLSV"
  },
  LSW: {
    iata: "LSW",
    name: "Malikus Saleh Airport",
    city: "Lhoksumawe",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: 5.226667,
    longitude: 96.950278,
    icao: "WITM"
  },
  LSY: {
    iata: "LSY",
    name: "Lismore Airport",
    city: "Lismore",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -28.836652,
    longitude: 153.263362,
    icao: "YLIS"
  },
  LSZ: {
    iata: "LSZ",
    name: "Losinj Airport",
    city: "Mali Losinj",
    countryId: "HR",
    timeZoneRegionName: "Europe/Zagreb",
    latitude: 44.5658,
    longitude: 14.3931,
    icao: "LDLO"
  },
  LTA: {
    iata: "LTA",
    name: "Letaba Airport",
    city: "Tzaneen",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -23.833333,
    longitude: 30.15,
    icao: "FATZ"
  },
  LTC: {
    iata: "LTC",
    name: "Lai Airport",
    city: "Lai",
    countryId: "TD",
    timeZoneRegionName: "Africa/Ndjamena",
    latitude: 9.416667,
    longitude: 16.3,
    icao: "FTTH"
  },
  LTD: {
    iata: "LTD",
    name: "Ghadames Airport",
    city: "Ghadames",
    countryId: "LY",
    timeZoneRegionName: "Africa/Tripoli",
    latitude: 30.129167,
    longitude: 9.509722,
    icao: "HLTD"
  },
  LTI: {
    iata: "LTI",
    name: "Altai Airport",
    city: "Altai",
    countryId: "MN",
    timeZoneRegionName: "Asia/Ulaanbaatar",
    latitude: 46.376184,
    longitude: 96.221008,
    icao: "ZMAT"
  },
  LTK: {
    iata: "LTK",
    name: "Bassel al-Assad International Airport",
    city: "Latakia",
    countryId: "SY",
    timeZoneRegionName: "Asia/Damascus",
    latitude: 35.407353,
    longitude: 35.943994,
    icao: "OSLK"
  },
  LTL: {
    iata: "LTL",
    name: "Lastourville Airport",
    city: "Lastourville",
    countryId: "GA",
    timeZoneRegionName: "Africa/Libreville",
    latitude: -0.833333,
    longitude: 12.716667,
    icao: "FOOR"
  },
  LTM: {
    iata: "LTM",
    name: "Lethem Airport",
    city: "Lethem",
    countryId: "GY",
    timeZoneRegionName: "America/Guyana",
    latitude: 3.371667,
    longitude: -59.79,
    icao: "SYLT"
  },
  LTN: {
    iata: "LTN",
    name: "London Luton Airport",
    city: "London",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.879768,
    longitude: -0.376232,
    icao: "EGGW"
  },
  LTO: {
    iata: "LTO",
    name: "Loreto Airport",
    city: "Loreto",
    countryId: "MX",
    timeZoneRegionName: "America/Mazatlan",
    latitude: 25.983333,
    longitude: -111.35,
    icao: "MMLT"
  },
  LTQ: {
    iata: "LTQ",
    name: "Le Touquet Airport",
    city: "Le Touquet",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 50.514775,
    longitude: 1.627071,
    icao: "LFAT"
  },
  LTS: {
    iata: "LTS",
    name: "Altus Air Force Base",
    city: "Altus",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 34.658354,
    longitude: -99.269343,
    icao: "KLTS"
  },
  LTT: {
    iata: "LTT",
    name: "La Mole Airport",
    city: "Saint Tropez",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 43.205651,
    longitude: 6.483263,
    icao: "LFTZ"
  },
  LTX: {
    iata: "LTX",
    name: "Cotapaxi International Airport",
    city: "Latacunga",
    countryId: "EC",
    timeZoneRegionName: "America/Guayaquil",
    latitude: -0.918468,
    longitude: -78.616089,
    icao: "SELT"
  },
  LUA: {
    iata: "LUA",
    name: "Tenzing-Hillary Airport",
    city: "Lukla",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 27.687637,
    longitude: 86.731753,
    icao: "VNLK"
  },
  LUB: {
    iata: "LUB",
    name: "Lumid Pau Airport",
    city: "Lumid Pau",
    countryId: "GY",
    timeZoneRegionName: "America/Guyana",
    latitude: 2.4,
    longitude: -59.433333,
    icao: "SYLP"
  },
  LUC: {
    iata: "LUC",
    name: "Laucala Island Airport",
    city: "Laucala Island",
    countryId: "FJ",
    timeZoneRegionName: "Pacific/Fiji",
    latitude: -16.74889,
    longitude: 179.667273,
    icao: "NFNH"
  },
  LUD: {
    iata: "LUD",
    name: "Luderitz Airport",
    city: "Luderitz",
    countryId: "NA",
    timeZoneRegionName: "Africa/Windhoek",
    latitude: -26.686389,
    longitude: 15.243889,
    icao: "FYLZ"
  },
  LUF: {
    iata: "LUF",
    name: "Luke Air Force Base",
    city: "Phoenix",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 33.536394,
    longitude: -112.372838,
    icao: "KLUF"
  },
  LUG: {
    iata: "LUG",
    name: "Lugano Airport",
    city: "Lugano",
    countryId: "CH",
    timeZoneRegionName: "Europe/Zurich",
    latitude: 46.002393,
    longitude: 8.909827,
    icao: "LSZA"
  },
  LUH: {
    iata: "LUH",
    name: "Ludhiana Airport",
    city: "Ludhiana",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 30.9,
    longitude: 75.85,
    icao: "VILD"
  },
  LUJ: {
    iata: "LUJ",
    name: "Lusikisiki Airport",
    city: "Lusikisiki",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -31.366667,
    longitude: 29.583333,
    icao: "FALK"
  },
  LUK: {
    iata: "LUK",
    name: "Cincinnati Municipal Airport - Lunken Field",
    city: "Cincinnati",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.103297,
    longitude: -84.418596,
    icao: "KLUK"
  },
  LUL: {
    iata: "LUL",
    name: "Hesler-Noble Field",
    city: "Laurel",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 31.672604,
    longitude: -89.172207,
    icao: "KLUL"
  },
  LUM: {
    iata: "LUM",
    name: "Dehong Mangshi Airport",
    city: "Mangshi",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 24.405279,
    longitude: 98.531897,
    icao: "ZPLX"
  },
  LUN: {
    iata: "LUN",
    name: "Kenneth Kaunda International Airport",
    city: "Lusaka",
    countryId: "ZM",
    timeZoneRegionName: "Africa/Lusaka",
    latitude: -15.326256,
    longitude: 28.44567,
    icao: "FLLS"
  },
  LUO: {
    iata: "LUO",
    name: "Luena Airport",
    city: "Luena",
    countryId: "AO",
    timeZoneRegionName: "Africa/Luanda",
    latitude: -11.76806,
    longitude: 19.89778,
    icao: "FNUE"
  },
  LUP: {
    iata: "LUP",
    name: "Kalaupapa Airport",
    city: "Kalaupapa",
    countryId: "US",
    timeZoneRegionName: "Pacific/Honolulu",
    latitude: 21.211111,
    longitude: -156.974444,
    icao: "PHLU"
  },
  LUQ: {
    iata: "LUQ",
    name: "San Luis Airport",
    city: "San Luis",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -33.274444,
    longitude: -66.358611,
    icao: "SAOU"
  },
  LUR: {
    iata: "LUR",
    name: "Cape Lisburne Airport",
    city: "Cape Lisburne",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 68.875833,
    longitude: -166.106944,
    icao: "PALU"
  },
  LUS: {
    iata: "LUS",
    name: "Lusanga Airport",
    city: "Lusanga",
    countryId: "CD",
    timeZoneRegionName: "Africa/Kinshasa",
    latitude: -4.804654,
    longitude: 18.718886,
    icao: "FZCE"
  },
  LUV: {
    iata: "LUV",
    name: "Langgur Dumatubun Airport",
    city: "Langgur",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jayapura",
    latitude: -5.666667,
    longitude: 132.716667,
    icao: "WAPL"
  },
  LUW: {
    iata: "LUW",
    name: "S. Aminuddin Amir Airport",
    city: "Luwuk",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -1.039336,
    longitude: 122.771611,
    icao: "WAMW"
  },
  LUX: {
    iata: "LUX",
    name: "Luxembourg Airport",
    city: "Luxembourg",
    countryId: "LU",
    timeZoneRegionName: "Europe/Luxembourg",
    latitude: 49.631113,
    longitude: 6.209539,
    icao: "ELLX"
  },
  LUZ: {
    iata: "LUZ",
    name: "Lublin Airport",
    city: "Swidnik",
    countryId: "PL",
    timeZoneRegionName: "Europe/Warsaw",
    latitude: 51.231944,
    longitude: 22.690278,
    icao: "EPLB"
  },
  LVA: {
    iata: "LVA",
    name: "Entrammes Airport",
    city: "Laval",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 48.066667,
    longitude: -0.766667,
    icao: "LFOV"
  },
  LVB: {
    iata: "LVB",
    name: "Dos Galpoes Airport",
    city: "Livramento",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -30.833333,
    longitude: -55.616667,
    icao: "SSLI"
  },
  LVI: {
    iata: "LVI",
    name: "Livingstone Airport",
    city: "Livingstone",
    countryId: "ZM",
    timeZoneRegionName: "Africa/Lusaka",
    latitude: -17.820556,
    longitude: 25.822222,
    icao: "FLLI"
  },
  LVK: {
    iata: "LVK",
    name: "Livermore Municipal Airport",
    city: "Livermore",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 37.693889,
    longitude: -121.817222,
    icao: "KLVK"
  },
  LVL: {
    iata: "LVL",
    name: "Lawrenceville Airport",
    city: "Lawrenceville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 36.75,
    longitude: -77.833333,
    icao: "KLVL"
  },
  LVM: {
    iata: "LVM",
    name: "Mission Field",
    city: "Livingston",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 45.666667,
    longitude: -110.566667,
    icao: "KLVM"
  },
  LVO: {
    iata: "LVO",
    name: "Laverton Airport",
    city: "Laverton",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -28.614391,
    longitude: 122.423112,
    icao: "YLTN"
  },
  LVP: {
    iata: "LVP",
    name: "Lavan Island Airport",
    city: "Lavan",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 26.810278,
    longitude: 53.356111,
    icao: "OIBV"
  },
  LVS: {
    iata: "LVS",
    name: "Las Vegas Airport",
    city: "Las Vegas",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 35.6,
    longitude: -105.216667,
    icao: "KLVS"
  },
  LWB: {
    iata: "LWB",
    name: "Greenbrier Valley Airport",
    city: "Lewisburg",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 37.859722,
    longitude: -80.398611,
    icao: "KLWB"
  },
  LWC: {
    iata: "LWC",
    name: "Lawrence Airport",
    city: "Lawrence",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 39.009167,
    longitude: -95.2175,
    icao: "KLWC"
  },
  LWE: {
    iata: "LWE",
    name: "Wunopito Airport",
    city: "Lewoleba",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -8.36278,
    longitude: 123.43778,
    icao: "WATW"
  },
  LWH: {
    iata: "LWH",
    name: "Lawn Hill Airport",
    city: "Lawn Hill",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -18.576637,
    longitude: 138.584282,
    icao: "YLAH"
  },
  LWK: {
    iata: "LWK",
    name: "Lerwick/Tingwall Airport",
    city: "Shetland Islands",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 60.189061,
    longitude: -1.245291,
    icao: "EGET"
  },
  LWL: {
    iata: "LWL",
    name: "Wells Municipal Airport-Harriet Field",
    city: "Wells",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 41.117098,
    longitude: -114.922214,
    icao: "KLWL"
  },
  LWM: {
    iata: "LWM",
    name: "Lawrence Municipal Airport",
    city: "Lawrence",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.7175,
    longitude: -71.1225,
    icao: "KLWM"
  },
  LWN: {
    iata: "LWN",
    name: "Gyumri Shirak Airport",
    city: "Gyoumri",
    countryId: "AM",
    timeZoneRegionName: "Asia/Yerevan",
    latitude: 40.750556,
    longitude: 43.859444,
    icao: "UDSG"
  },
  LWO: {
    iata: "LWO",
    name: "Lviv International Airport",
    city: "Lviv",
    countryId: "UA",
    timeZoneRegionName: "Europe/Kiev",
    latitude: 49.812296,
    longitude: 23.959311,
    icao: "UKLL"
  },
  LWR: {
    iata: "LWR",
    name: "Leeuwarden Air Base",
    city: "Leeuwarden",
    countryId: "NL",
    timeZoneRegionName: "Europe/Amsterdam",
    latitude: 53.228594,
    longitude: 5.760549,
    icao: "EHLW"
  },
  LWS: {
    iata: "LWS",
    name: "Lewiston-Nez Perce County Regional Airport",
    city: "Lewiston",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 46.374722,
    longitude: -117.014444,
    icao: "KLWS"
  },
  LWT: {
    iata: "LWT",
    name: "Lewistown Municipal Airport",
    city: "Lewistown",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 47.051111,
    longitude: -109.471111,
    icao: "KLWT"
  },
  LWV: {
    iata: "LWV",
    name: "Lawrenceville Municipal Airport",
    city: "Lawrenceville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 38.733333,
    longitude: -87.683333,
    icao: "KLWV"
  },
  LWY: {
    iata: "LWY",
    name: "Lawas Airport",
    city: "Lawas",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 4.846565,
    longitude: 115.406995,
    icao: "WBGW"
  },
  LXA: {
    iata: "LXA",
    name: "Lhasa Gonggar Airport",
    city: "Lhasa",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 29.2978,
    longitude: 90.911903,
    icao: "ZULS"
  },
  LXG: {
    iata: "LXG",
    name: "Luang Namtha Airport",
    city: "Luang Namtha",
    countryId: "LA",
    timeZoneRegionName: "Asia/Vientiane",
    latitude: 21.05,
    longitude: 101.466667,
    icao: "VLLN"
  },
  LXN: {
    iata: "LXN",
    name: "Jim Kelly Field",
    city: "Lexington",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 40.791002,
    longitude: -99.777288,
    icao: "KLXN"
  },
  LXR: {
    iata: "LXR",
    name: "Luxor International Airport",
    city: "Luxor",
    countryId: "EG",
    timeZoneRegionName: "Africa/Cairo",
    latitude: 25.674919,
    longitude: 32.699683,
    icao: "HELX"
  },
  LXS: {
    iata: "LXS",
    name: "Limnos Airport",
    city: "Limnos",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 39.923906,
    longitude: 25.233446,
    icao: "LGLM"
  },
  LXU: {
    iata: "LXU",
    name: "Lukulu Airport",
    city: "Lukulu",
    countryId: "ZM",
    timeZoneRegionName: "Africa/Lusaka",
    latitude: -14.416667,
    longitude: 23.2,
    icao: "FLLK"
  },
  LXV: {
    iata: "LXV",
    name: "Leadville Airport",
    city: "Leadville",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 39.220278,
    longitude: -106.316111,
    icao: "KLXV"
  },
  LYA: {
    iata: "LYA",
    name: "Luoyang Beijiao Airport",
    city: "Luoyang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 34.736361,
    longitude: 112.385406,
    icao: "ZHLY"
  },
  LYB: {
    iata: "LYB",
    name: "Little Cayman Edward Bodden Airfield Airport",
    city: "Little Cayman",
    countryId: "KY",
    timeZoneRegionName: "America/Cayman",
    latitude: 19.6592,
    longitude: -80.084715,
    icao: "MWCL"
  },
  LYC: {
    iata: "LYC",
    name: "Lycksele Airport",
    city: "Lycksele",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 64.548308,
    longitude: 18.716216,
    icao: "ESNL"
  },
  LYE: {
    iata: "LYE",
    name: "Lyneham Royal Air Force Station",
    city: "Lyneham",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.505741,
    longitude: -1.99318,
    icao: "EGDL"
  },
  LYG: {
    iata: "LYG",
    name: "Lianyungang Airport",
    city: "Lianyungang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 34.565938,
    longitude: 118.876986,
    icao: "ZSLG"
  },
  LYH: {
    iata: "LYH",
    name: "Preston-Glenn Field",
    city: "Lynchburg",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 37.326944,
    longitude: -79.201111,
    icao: "KLYH"
  },
  LYI: {
    iata: "LYI",
    name: "Linyi Shubuling Airport",
    city: "Linyi",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 35.0461,
    longitude: 118.4125,
    icao: "ZSLY"
  },
  LYN: {
    iata: "LYN",
    name: "Bron Airport",
    city: "Lyon",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 45.730833,
    longitude: 4.943333,
    icao: "LFLY"
  },
  LYO: {
    iata: "LYO",
    name: "Rice County Municipal Airport",
    city: "Lyons",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 38.35,
    longitude: -98.2,
    icao: "KLYO"
  },
  LYP: {
    iata: "LYP",
    name: "Faisalabad Airport",
    city: "Faisalabad",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 31.363042,
    longitude: 72.987572,
    icao: "OPFA"
  },
  LYR: {
    iata: "LYR",
    name: "Svalbard Airport",
    city: "Longyearbyen",
    countryId: "SJ",
    timeZoneRegionName: "Arctic/Longyearbyen",
    latitude: 78.208889,
    longitude: 15.8,
    icao: "ENSB"
  },
  LYS: {
    iata: "LYS",
    name: "Lyon Saint-Exupery International Airport",
    city: "Lyon",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 45.721426,
    longitude: 5.080334,
    icao: "LFLL"
  },
  LYU: {
    iata: "LYU",
    name: "Ely Airport",
    city: "Ely",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 47.823889,
    longitude: -91.829167,
    icao: "KELO"
  },
  LYX: {
    iata: "LYX",
    name: "Lydd International Airport",
    city: "Lydd",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 50.955333,
    longitude: 0.938414,
    icao: "EGMD"
  },
  LZA: {
    iata: "LZA",
    name: "Luiza Airport",
    city: "Luiza",
    countryId: "CD",
    timeZoneRegionName: "Africa/Kinshasa",
    latitude: -7.666667,
    longitude: 22.5,
    icao: "FZUG"
  },
  LZC: {
    iata: "LZC",
    name: "Lazaro Cardenas Airport",
    city: "Lazaro Cardenas",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 18,
    longitude: -102.216667,
    icao: "MMLC"
  },
  LZG: {
    iata: "LZG",
    name: "Langzhong Gucheng Airport",
    city: "Langzhong",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 31.5025,
    longitude: 106.034444,
    icao: ""
  },
  LZH: {
    iata: "LZH",
    name: "Liuzhou Airport",
    city: "Liuzhou",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 24.206155,
    longitude: 109.398427,
    icao: "ZGZH"
  },
  LZI: {
    iata: "LZI",
    name: "Luozi Airport",
    city: "Luozi",
    countryId: "CD",
    timeZoneRegionName: "Africa/Kinshasa",
    latitude: -4.9,
    longitude: 14,
    icao: "FZAL"
  },
  LZN: {
    iata: "LZN",
    name: "Matsu Nangan Airport",
    city: "Nangan",
    countryId: "TW",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 26.159444,
    longitude: 119.958333,
    icao: "RCFG"
  },
  LZO: {
    iata: "LZO",
    name: "Yunlong Airport",
    city: "Luzhou",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 29.030556,
    longitude: 105.46889,
    icao: "ZULZ"
  },
  LZR: {
    iata: "LZR",
    name: "Lizard Island Airport",
    city: "Lizard Island",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -14.670046,
    longitude: 145.451358,
    icao: "YLZI"
  },
  LZS: {
    iata: "LZS",
    countryId: "AT",
    city: "Linz",
    icao: "",
    name: "Linz Central Station",
    latitude: 48.2906,
    longitude: 14.2911,
    timeZoneRegionName: "Europe/Vienna"
  },
  LZY: {
    iata: "LZY",
    name: "Nyingchi Mainling Airport",
    city: "Nyingchi",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 29.309076,
    longitude: 94.335883,
    icao: "ZUNZ"
  },
  MAA: {
    iata: "MAA",
    name: "Chennai Airport",
    city: "Chennai",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 12.982267,
    longitude: 80.163782,
    icao: "VOMM"
  },
  MAB: {
    iata: "MAB",
    name: "Maraba Airport",
    city: "Maraba",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -5.366667,
    longitude: -49.166667,
    icao: "SBMA"
  },
  MAC: {
    iata: "MAC",
    name: "Macon Downtown Airport",
    city: "Macon",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 32.822158,
    longitude: -83.562019,
    icao: "KMAC"
  },
  MAD: {
    iata: "MAD",
    name: "Adolfo Suarez Madrid-Barajas Airport",
    city: "Madrid",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 40.49027,
    longitude: -3.564479,
    icao: "LEMD"
  },
  MAE: {
    iata: "MAE",
    name: "Madera Airport",
    city: "Madera",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 36.95,
    longitude: -120.066667,
    icao: "KMAE"
  },
  MAF: {
    iata: "MAF",
    name: "Midland International Airport",
    city: "Midland",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 31.937145,
    longitude: -102.208167,
    icao: "KMAF"
  },
  MAG: {
    iata: "MAG",
    name: "Madang Airport",
    city: "Madang",
    countryId: "PG",
    timeZoneRegionName: "Pacific/Port_Moresby",
    latitude: -5.210852,
    longitude: 145.787849,
    icao: "AYMD"
  },
  MAH: {
    iata: "MAH",
    name: "Menorca Airport",
    city: "Menorca",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 39.86503,
    longitude: 4.224099,
    icao: "LEMH"
  },
  MAI: {
    iata: "MAI",
    name: "Mangochi Airport",
    city: "Mangochi",
    countryId: "MW",
    timeZoneRegionName: "Africa/Blantyre",
    latitude: -14.5,
    longitude: 35.25,
    icao: "FWMG"
  },
  MAJ: {
    iata: "MAJ",
    name: "Amata Kabua International Airport",
    city: "Majuro",
    countryId: "MH",
    timeZoneRegionName: "Pacific/Majuro",
    latitude: 7.068717,
    longitude: 171.282508,
    icao: "PKMJ"
  },
  MAK: {
    iata: "MAK",
    name: "Malakal Airport",
    city: "Malakal",
    countryId: "SS",
    timeZoneRegionName: "Africa/Juba",
    latitude: 9.555556,
    longitude: 31.644444,
    icao: "HSSM"
  },
  MAM: {
    iata: "MAM",
    name: "Matamoros Airport",
    city: "Matamoros",
    countryId: "MX",
    timeZoneRegionName: "America/Matamoros",
    latitude: 25.770278,
    longitude: -97.523611,
    icao: "MMMA"
  },
  MAN: {
    iata: "MAN",
    name: "Manchester Airport",
    city: "Manchester",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 53.362908,
    longitude: -2.273354,
    icao: "EGCC"
  },
  MAO: {
    iata: "MAO",
    name: "Eduardo Gomes International Airport",
    city: "Manaus",
    countryId: "BR",
    timeZoneRegionName: "America/Porto_Velho",
    latitude: -3.031327,
    longitude: -60.046092,
    icao: "SBEG"
  },
  MAQ: {
    iata: "MAQ",
    name: "Mae Sot Airport",
    city: "Mae Sot",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 16.701422,
    longitude: 98.543474,
    icao: "VTPM"
  },
  MAR: {
    iata: "MAR",
    name: "La Chinita Airport",
    city: "Maracaibo",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 10.555564,
    longitude: -71.723508,
    icao: "SVMC"
  },
  MAS: {
    iata: "MAS",
    name: "Momote Airport",
    city: "Manus Island",
    countryId: "PG",
    timeZoneRegionName: "Pacific/Port_Moresby",
    latitude: -2.056667,
    longitude: 147.424444,
    icao: "AYMO"
  },
  MAT: {
    iata: "MAT",
    name: "Matadi Airport",
    city: "Matadi",
    countryId: "CD",
    timeZoneRegionName: "Africa/Kinshasa",
    latitude: -5.798333,
    longitude: 13.441667,
    icao: "FZAM"
  },
  MAU: {
    iata: "MAU",
    name: "Maupiti Airport",
    city: "Maupiti",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -16.427386,
    longitude: -152.242351,
    icao: "NTTP"
  },
  MAW: {
    iata: "MAW",
    name: "Malden Airport",
    city: "Malden",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.605556,
    longitude: -89.988889,
    icao: "KMAW"
  },
  MAX: {
    iata: "MAX",
    name: "Matam Airport",
    city: "Matam",
    countryId: "SN",
    timeZoneRegionName: "Africa/Dakar",
    latitude: 15.593056,
    longitude: -13.323611,
    icao: "GOSM"
  },
  MAY: {
    iata: "MAY",
    name: "Mangrove Cay Airport",
    city: "Mangrove Cay",
    countryId: "BS",
    timeZoneRegionName: "America/Nassau",
    latitude: 24.288322,
    longitude: -77.677867,
    icao: "MYAB"
  },
  MAZ: {
    iata: "MAZ",
    name: "Eugenio M. De Hostos Airport",
    city: "Mayaguez",
    countryId: "PR",
    timeZoneRegionName: "America/Puerto_Rico",
    latitude: 18.257778,
    longitude: -67.148889,
    icao: "TJMZ"
  },
  MBA: {
    iata: "MBA",
    name: "Moi International Airport",
    city: "Mombasa",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: -4.0327,
    longitude: 39.603247,
    icao: "HKMO"
  },
  MBB: {
    iata: "MBB",
    name: "Marble Bar Airport",
    city: "Marble Bar",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -21.25,
    longitude: 119.583333,
    icao: "YMBL"
  },
  MBC: {
    iata: "MBC",
    name: "Mbigou Airport",
    city: "Mbigou",
    countryId: "GA",
    timeZoneRegionName: "Africa/Libreville",
    latitude: -2,
    longitude: 12,
    icao: "FOGG"
  },
  MBD: {
    iata: "MBD",
    name: "Mmabatho International Airport",
    city: "Mmabatho",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -25.804892,
    longitude: 25.543468,
    icao: "FAMM"
  },
  MBE: {
    iata: "MBE",
    name: "Monbetsu Airport",
    city: "Monbetsu",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 44.266667,
    longitude: 143.383333,
    icao: "RJEB"
  },
  MBG: {
    iata: "MBG",
    name: "Mobridge Municipal Airport",
    city: "Mobridge",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 45.544733,
    longitude: -100.406877,
    icao: "KMBG"
  },
  MBH: {
    iata: "MBH",
    name: "Maryborough Airport",
    city: "Maryborough",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -25.516667,
    longitude: 152.713333,
    icao: "YMBU"
  },
  MBI: {
    iata: "MBI",
    name: "Mbeya Airport",
    city: "Mbeya",
    countryId: "TZ",
    timeZoneRegionName: "Africa/Dar_es_Salaam",
    latitude: -8.916634,
    longitude: 33.458858,
    icao: "HTMB"
  },
  MBJ: {
    iata: "MBJ",
    name: "Sangster International Airport",
    city: "Montego Bay",
    countryId: "JM",
    timeZoneRegionName: "America/Jamaica",
    latitude: 18.498464,
    longitude: -77.916632,
    icao: "MKJS"
  },
  MBL: {
    iata: "MBL",
    name: "Blacker Airport",
    city: "Manistee",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 44.273889,
    longitude: -86.253333,
    icao: "KMBL"
  },
  MBO: {
    iata: "MBO",
    name: "Mamburao Airport",
    city: "Mamburao",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 13.211389,
    longitude: 120.603333,
    icao: "RPUM"
  },
  MBP: {
    iata: "MBP",
    name: "Moyobamba Airport",
    city: "Moyobamba",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -6.2,
    longitude: -77.166667,
    icao: "SPBB"
  },
  MBQ: {
    iata: "MBQ",
    name: "Mbarara Airport",
    city: "Mbarara",
    countryId: "UG",
    timeZoneRegionName: "Africa/Kampala",
    latitude: -0.616667,
    longitude: 30.65,
    icao: "HUMA"
  },
  MBS: {
    iata: "MBS",
    name: "MBS International Airport",
    city: "Saginaw",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 43.53339,
    longitude: -84.090742,
    icao: "KMBS"
  },
  MBT: {
    iata: "MBT",
    name: "Moises R. Espinosa Airport",
    city: "Masbate",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 12.36944,
    longitude: 123.62917,
    icao: "RPVJ"
  },
  MBW: {
    iata: "MBW",
    name: "Moorabbin Airport",
    city: "Moorabbin",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -37.975833,
    longitude: 145.102222,
    icao: "YMMB"
  },
  MBX: {
    iata: "MBX",
    name: "Maribor Edvard Rusjan Airport",
    city: "Maribor",
    countryId: "SI",
    timeZoneRegionName: "Europe/Ljubljana",
    latitude: 46.478502,
    longitude: 15.686741,
    icao: "LJMB"
  },
  MBY: {
    iata: "MBY",
    name: "Moberly Airport",
    city: "Moberly",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 39.463889,
    longitude: -92.426667,
    icao: "KMBY"
  },
  MBZ: {
    iata: "MBZ",
    name: "Maues Airport",
    city: "Maues",
    countryId: "BR",
    timeZoneRegionName: "America/Porto_Velho",
    latitude: -3.4,
    longitude: -57.7,
    icao: "SWMW"
  },
  MCA: {
    iata: "MCA",
    name: "Macenta Airport",
    city: "Macenta",
    countryId: "GN",
    timeZoneRegionName: "Africa/Conakry",
    latitude: 8.55,
    longitude: -9.466667,
    icao: "GUMA"
  },
  MCB: {
    iata: "MCB",
    name: "Pike County Airport",
    city: "Mc Comb",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 31.175556,
    longitude: -90.469444,
    icao: "KMCB"
  },
  MCC: {
    iata: "MCC",
    name: "McClellan Air Force Base",
    city: "Sacramento",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 38.662617,
    longitude: -121.398388,
    icao: "KMCC"
  },
  MCD: {
    iata: "MCD",
    name: "Mackinac Island Airport",
    city: "Mackinac Island",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 45.864899,
    longitude: -84.637299,
    icao: "KMCD"
  },
  MCE: {
    iata: "MCE",
    name: "Merced Municipal Airport",
    city: "Merced",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 37.284722,
    longitude: -120.512778,
    icao: "KMCE"
  },
  MCF: {
    iata: "MCF",
    name: "MacDill Air Force Base",
    city: "Tampa",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 27.848473,
    longitude: -82.49993,
    icao: "KMCF"
  },
  MCG: {
    iata: "MCG",
    name: "McGrath Airport",
    city: "McGrath",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 62.950732,
    longitude: -155.601923,
    icao: "PAMC"
  },
  MCH: {
    iata: "MCH",
    name: "Machala Airport",
    city: "Machala",
    countryId: "EC",
    timeZoneRegionName: "America/Guayaquil",
    latitude: -3.266667,
    longitude: -79.983333,
    icao: "SEMH"
  },
  MCI: {
    iata: "MCI",
    name: "Kansas City International Airport",
    city: "Kansas City",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 39.293807,
    longitude: -94.719925,
    icao: "KMCI"
  },
  MCJ: {
    iata: "MCJ",
    name: "Jorge Isaacs Airport",
    city: "Maicao",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 11.389458,
    longitude: -72.241795,
    icao: "SKMJ"
  },
  MCK: {
    iata: "MCK",
    name: "Mc Cook Airport",
    city: "McCook",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 40.206299,
    longitude: -100.592003,
    icao: "KMCK"
  },
  MCL: {
    iata: "MCL",
    name: "Mount Mckinley Airport",
    city: "Mount McKinley",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 63.875972,
    longitude: -149.006389,
    icao: "PAIN"
  },
  MCM: {
    iata: "MCM",
    name: "Fontvielle Heliport",
    city: "Monte Carlo",
    countryId: "MC",
    timeZoneRegionName: "Europe/Monaco",
    latitude: 43.725833,
    longitude: 7.419722,
    icao: "LNMC"
  },
  MCN: {
    iata: "MCN",
    name: "Middle Georgia Regional Airport",
    city: "Macon",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 32.701987,
    longitude: -83.648651,
    icao: "KMCN"
  },
  MCO: {
    iata: "MCO",
    name: "Orlando International Airport",
    city: "Orlando",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 28.432177,
    longitude: -81.308301,
    icao: "KMCO"
  },
  MCP: {
    iata: "MCP",
    name: "Macapa International Airport",
    city: "Macapa",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: 0.049895,
    longitude: -51.068384,
    icao: "SBMQ"
  },
  MCS: {
    iata: "MCS",
    name: "Monte Caseros Airport",
    city: "Monte Caseros",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -30.270833,
    longitude: -57.641111,
    icao: "SARM"
  },
  MCT: {
    iata: "MCT",
    name: "Muscat International Airport",
    city: "Muscat",
    countryId: "OM",
    timeZoneRegionName: "Asia/Muscat",
    latitude: 23.600739,
    longitude: 58.284042,
    icao: "OOMS"
  },
  MCU: {
    iata: "MCU",
    name: "Gueret (Lepaud) Airport",
    city: "Montlucon",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 46.222599,
    longitude: 2.36396,
    icao: "LFBK"
  },
  MCV: {
    iata: "MCV",
    name: "Mcarthur River Airport",
    city: "Mcarthur River",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -16.466667,
    longitude: 136.095,
    icao: "YMHU"
  },
  MCW: {
    iata: "MCW",
    name: "Mason City Airport",
    city: "Mason City",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 43.156944,
    longitude: -93.329444,
    icao: "KMCW"
  },
  MCX: {
    iata: "MCX",
    name: "Makhachkala Airport",
    city: "Makhachkala",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 42.816799,
    longitude: 47.652302,
    icao: "URML"
  },
  MCY: {
    iata: "MCY",
    name: "Sunshine Coast Airport",
    city: "Sunshine Coast",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -26.60538,
    longitude: 153.088208,
    icao: "YBSU"
  },
  MCZ: {
    iata: "MCZ",
    name: "Maceio-Zumbi dos Palmares International Airport",
    city: "Maceio",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -9.514027,
    longitude: -35.792114,
    icao: "SBMO"
  },
  MDA: {
    iata: "MDA",
    name: "Martindale Army Air Field",
    city: "San Antonio",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 29.43279,
    longitude: -98.376758,
    icao: "KMDA"
  },
  MDC: {
    iata: "MDC",
    name: "Sam Ratulangi International Airport",
    city: "Manado",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: 1.543533,
    longitude: 124.922029,
    icao: "WAMM"
  },
  MDD: {
    iata: "MDD",
    name: "Midland Airpark",
    city: "Midland",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.033175,
    longitude: -102.098865,
    icao: "KMDD"
  },
  MDE: {
    iata: "MDE",
    name: "Jose Maria Cordova International Airport",
    city: "Medellin",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 6.171382,
    longitude: -75.428206,
    icao: "SKRG"
  },
  MDF: {
    iata: "MDF",
    name: "Mooreland Municipal",
    city: "Mooreland",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.497583,
    longitude: -99.291583,
    icao: "KMDF"
  },
  MDG: {
    iata: "MDG",
    name: "Mudanjiang Airport",
    city: "Mudanjiang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 44.534943,
    longitude: 129.58384,
    icao: "ZYMD"
  },
  MDH: {
    iata: "MDH",
    name: "Southern Illinois Airport",
    city: "Carbondale",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 37.781389,
    longitude: -89.246944,
    icao: "KMDH"
  },
  MDK: {
    iata: "MDK",
    name: "Mbandaka Airport",
    city: "Mbandaka",
    countryId: "CD",
    timeZoneRegionName: "Africa/Kinshasa",
    latitude: 0.0225,
    longitude: 18.288611,
    icao: "FZEA"
  },
  MDL: {
    iata: "MDL",
    name: "Mandalay International Airport",
    city: "Mandalay",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 21.702169,
    longitude: 95.977893,
    icao: "VYMD"
  },
  MDO: {
    iata: "MDO",
    name: "Middleton Island Intermediate Airport",
    city: "Middleton Island",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 59.453056,
    longitude: -146.3,
    icao: "PAMD"
  },
  MDQ: {
    iata: "MDQ",
    name: "Mar Del Plata Airport",
    city: "Mar Del Plata",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -37.934722,
    longitude: -57.572222,
    icao: "SAZM"
  },
  MDR: {
    iata: "MDR",
    name: "Maasai Mara Musiara Airstrip Airport",
    city: "Medfra",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: -1.298733,
    longitude: 35.063473,
    icao: ""
  },
  MDS: {
    iata: "MDS",
    name: "Middle Caicos Airport",
    city: "Middle Caicos",
    countryId: "TC",
    timeZoneRegionName: "America/Grand_Turk",
    latitude: 21.783333,
    longitude: -71.716667,
    icao: "MBMC"
  },
  MDT: {
    iata: "MDT",
    name: "Harrisburg International Airport",
    city: "Middletown",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.196008,
    longitude: -76.756057,
    icao: "KMDT"
  },
  MDU: {
    iata: "MDU",
    name: "Mendi Airport",
    city: "Mendi",
    countryId: "PG",
    timeZoneRegionName: "Pacific/Port_Moresby",
    latitude: -6.158611,
    longitude: 143.65,
    icao: "AYMN"
  },
  MDW: {
    iata: "MDW",
    name: "Chicago Midway International Airport",
    city: "Chicago",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.788136,
    longitude: -87.740871,
    icao: "KMDW"
  },
  MDX: {
    iata: "MDX",
    name: "Mercedes Airport",
    city: "Mercedes",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -29.167222,
    longitude: -58.075556,
    icao: "SATM"
  },
  MDY: {
    iata: "MDY",
    name: "Henderson Field",
    city: "Sand Island",
    countryId: "UM",
    timeZoneRegionName: "Pacific/Midway",
    latitude: 28.201878,
    longitude: -177.38057,
    icao: "PMDY"
  },
  MDZ: {
    iata: "MDZ",
    name: "El Plumerillo International Airport",
    city: "Mendoza",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -32.827888,
    longitude: -68.798909,
    icao: "SAME"
  },
  MEA: {
    iata: "MEA",
    name: "Macae Airport",
    city: "Macae",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -22.341842,
    longitude: -41.764049,
    icao: "SBME"
  },
  MEB: {
    iata: "MEB",
    name: "Essendon Airport",
    city: "Melbourne",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -37.730423,
    longitude: 144.900813,
    icao: "YMEN"
  },
  MEC: {
    iata: "MEC",
    name: "Manta Airport",
    city: "Manta",
    countryId: "EC",
    timeZoneRegionName: "America/Guayaquil",
    latitude: -0.953035,
    longitude: -80.683999,
    icao: "SEMT"
  },
  MED: {
    iata: "MED",
    name: "Prince Mohammad Bin Abdulaziz International Airport",
    city: "Madinah",
    countryId: "SA",
    timeZoneRegionName: "Asia/Riyadh",
    latitude: 24.544369,
    longitude: 39.698966,
    icao: "OEMA"
  },
  MEE: {
    iata: "MEE",
    name: "Mare Airport",
    city: "Mare",
    countryId: "NC",
    timeZoneRegionName: "Pacific/Noumea",
    latitude: -21.482312,
    longitude: 168.036082,
    icao: "NWWR"
  },
  MEG: {
    iata: "MEG",
    name: "Malanje Airport",
    city: "Malanje",
    countryId: "AO",
    timeZoneRegionName: "Africa/Luanda",
    latitude: -9.526404,
    longitude: 16.318961,
    icao: "FNMA"
  },
  MEH: {
    iata: "MEH",
    name: "Mehamn Airport",
    city: "Mehamn",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 71.033333,
    longitude: 27.833333,
    icao: "ENMR"
  },
  MEI: {
    iata: "MEI",
    name: "Meridian Regional (Key Field) Airport",
    city: "Meridian",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.337222,
    longitude: -88.749167,
    icao: "KMEI"
  },
  MEJ: {
    iata: "MEJ",
    name: "Meadville Airport",
    city: "Meadville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.633333,
    longitude: -80.166667,
    icao: "KGKJ"
  },
  MEL: {
    iata: "MEL",
    name: "Melbourne Tullamarine Airport",
    city: "Melbourne",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -37.673295,
    longitude: 144.843013,
    icao: "YMML"
  },
  MEM: {
    iata: "MEM",
    name: "Memphis International Airport",
    city: "Memphis",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.044579,
    longitude: -89.982258,
    icao: "KMEM"
  },
  MEN: {
    iata: "MEN",
    name: "Brenoux Airport",
    city: "Mende",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 44.504157,
    longitude: 3.527748,
    icao: "LFNB"
  },
  MEO: {
    iata: "MEO",
    name: "Dare County Regional Airport",
    city: "Manteo",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 35.919167,
    longitude: -75.695278,
    icao: "KMQI"
  },
  MEQ: {
    iata: "MEQ",
    name: "Cut Nyak Dhien Airport",
    city: "Meulaboh",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: 4.15,
    longitude: 96.116667,
    icao: "WITC"
  },
  MER: {
    iata: "MER",
    name: "Castle Air Force Base",
    city: "Merced",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 37.380501,
    longitude: -120.568001,
    icao: "KMER"
  },
  MES: {
    iata: "MES",
    name: "Soewondo Air Force Base",
    city: "Medan",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: 3.56587,
    longitude: 98.677374,
    icao: "WIMK"
  },
  MEU: {
    iata: "MEU",
    name: "Monte Dourado Airport",
    city: "Monte Dourado",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -0.883333,
    longitude: -52.583333,
    icao: "SBMD"
  },
  MEV: {
    iata: "MEV",
    name: "Douglas County Airport",
    city: "Minden",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 39,
    longitude: -119.75,
    icao: "KMEV"
  },
  MEW: {
    iata: "MEW",
    name: "Mweka Airport",
    city: "Mweka",
    countryId: "CD",
    timeZoneRegionName: "Africa/Lubumbashi",
    latitude: -4.85,
    longitude: 21.566667,
    icao: "FZVM"
  },
  MEX: {
    iata: "MEX",
    name: "Benito Juarez International Airport",
    city: "Mexico City",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 19.435278,
    longitude: -99.072778,
    icao: "MMMX"
  },
  MEY: {
    iata: "MEY",
    name: "Meghauli Airport",
    city: "Meghauli",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 27.576389,
    longitude: 84.231389,
    icao: "VNMG"
  },
  MFA: {
    iata: "MFA",
    name: "Mafia Island Airport",
    city: "Mafia Island",
    countryId: "TZ",
    timeZoneRegionName: "Africa/Dar_es_Salaam",
    latitude: -7.917577,
    longitude: 39.668576,
    icao: "HTMA"
  },
  MFC: {
    iata: "MFC",
    name: "Mafeteng Airport",
    city: "Mafeteng",
    countryId: "LS",
    timeZoneRegionName: "Africa/Maseru",
    latitude: -29.75,
    longitude: 27.3,
    icao: "FXMF"
  },
  MFD: {
    iata: "MFD",
    name: "Lahm Municipal Airport",
    city: "Mansfield",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.82,
    longitude: -82.512778,
    icao: "KMFD"
  },
  MFE: {
    iata: "MFE",
    name: "McAllen International Airport",
    city: "McAllen",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 26.181295,
    longitude: -98.239775,
    icao: "KMFE"
  },
  MFF: {
    iata: "MFF",
    name: "Moanda Airport",
    city: "Moanda",
    countryId: "GA",
    timeZoneRegionName: "Africa/Libreville",
    latitude: -1.536944,
    longitude: 13.270833,
    icao: "FOOD"
  },
  MFG: {
    iata: "MFG",
    name: "Muzaffarabad Airport",
    city: "Muzaffarabad",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 34.366667,
    longitude: 73.466667,
    icao: "OPMF"
  },
  MFI: {
    iata: "MFI",
    name: "Marshfield Municipal Airport",
    city: "Marshfield",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 44.633889,
    longitude: -90.186667,
    icao: "KMFI"
  },
  MFJ: {
    iata: "MFJ",
    name: "Moala Airport",
    city: "Moala",
    countryId: "FJ",
    timeZoneRegionName: "Pacific/Fiji",
    latitude: -18.566667,
    longitude: 179.933333,
    icao: "NFMO"
  },
  MFK: {
    iata: "MFK",
    name: "Matsu Beigan Airport",
    city: "Matsu",
    countryId: "TW",
    timeZoneRegionName: "Asia/Taipei",
    latitude: 26.224018,
    longitude: 120.000507,
    icao: "RCMT"
  },
  MFM: {
    iata: "MFM",
    name: "Macau International Airport",
    city: "Macau",
    countryId: "MO",
    timeZoneRegionName: "Asia/Macau",
    latitude: 22.156587,
    longitude: 113.57285,
    icao: "VMMC"
  },
  MFN: {
    iata: "MFN",
    name: "Milford Sound Airport",
    city: "Milford Sound",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -44.669444,
    longitude: 167.911111,
    icao: "NZMF"
  },
  MFO: {
    iata: "MFO",
    name: "Manguna Airport",
    city: "Manguna",
    countryId: "PG",
    timeZoneRegionName: "Pacific/Port_Moresby",
    latitude: -5.566667,
    longitude: 151.783333,
    icao: "HERN"
  },
  MFQ: {
    iata: "MFQ",
    name: "Maradi Airport",
    city: "Maradi",
    countryId: "NE",
    timeZoneRegionName: "Africa/Niamey",
    latitude: 13.5025,
    longitude: 7.125278,
    icao: "DRRM"
  },
  MFR: {
    iata: "MFR",
    name: "Rogue Valley International-Medford Airport",
    city: "Medford",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 42.369025,
    longitude: -122.87312,
    icao: "KMFR"
  },
  MFS: {
    iata: "MFS",
    name: "Miraflores Airport",
    city: "Miraflores",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 5.166667,
    longitude: -73.25,
    icao: "SKMF"
  },
  MFU: {
    iata: "MFU",
    name: "Mfuwe Airport",
    city: "Mfuwe",
    countryId: "ZM",
    timeZoneRegionName: "Africa/Lusaka",
    latitude: -13.266667,
    longitude: 31.933333,
    icao: "FLMF"
  },
  MFV: {
    iata: "MFV",
    name: "Accomack County Airport",
    city: "Melfa",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 37.633333,
    longitude: -75.783333,
    icao: "KMFV"
  },
  MFX: {
    iata: "MFX",
    name: "Meribel Airport",
    city: "Meribel",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 45.416667,
    longitude: 6.566667,
    icao: "LFKX"
  },
  MGA: {
    iata: "MGA",
    name: "Augusto C Sandino International Airport",
    city: "Managua",
    countryId: "NI",
    timeZoneRegionName: "America/Managua",
    latitude: 12.144838,
    longitude: -86.171263,
    icao: "MNMG"
  },
  MGB: {
    iata: "MGB",
    name: "Mount Gambier Airport",
    city: "Mount Gambier",
    countryId: "AU",
    timeZoneRegionName: "Australia/Adelaide",
    latitude: -37.744072,
    longitude: 140.782715,
    icao: "YMTG"
  },
  MGC: {
    iata: "MGC",
    name: "Michigan City Airport",
    city: "Michigan City",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.7,
    longitude: -86.816667,
    icao: "KMGC"
  },
  MGD: {
    iata: "MGD",
    name: "Magdalena Airport",
    city: "Magdalena",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -13.325278,
    longitude: -64.124722,
    icao: "SLMG"
  },
  MGE: {
    iata: "MGE",
    name: "Dobbins Air Force Base",
    city: "Marietta",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 33.912954,
    longitude: -84.510918,
    icao: "KMGE"
  },
  MGF: {
    iata: "MGF",
    name: "Regional De Maringa",
    city: "Maringa",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -23.479445,
    longitude: -52.012222,
    icao: "SBMG"
  },
  MGH: {
    iata: "MGH",
    name: "Margate Airport",
    city: "Margate",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -30.858344,
    longitude: 30.344464,
    icao: "FAMG"
  },
  MGJ: {
    iata: "MGJ",
    name: "Orange County Airport",
    city: "Montgomery",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.516667,
    longitude: -74.266667,
    icao: "KMGJ"
  },
  MGK: {
    iata: "MGK",
    name: "Mong Ton Airport",
    city: "Mong Ton",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 20.283333,
    longitude: 98.9,
    icao: "VYMT"
  },
  MGL: {
    iata: "MGL",
    name: "Monchengladbach Airport",
    city: "Dusseldorf",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 51.22972,
    longitude: 6.51097,
    icao: "EDLN"
  },
  MGM: {
    iata: "MGM",
    name: "Montgomery Regional Airport-Dannelly Field",
    city: "Montgomery",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.300596,
    longitude: -86.393997,
    icao: "KMGM"
  },
  MGN: {
    iata: "MGN",
    name: "Baracoa Airport",
    city: "Magangue",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 9.288056,
    longitude: -74.845,
    icao: "SKMG"
  },
  MGQ: {
    iata: "MGQ",
    name: "Mogadishu International Airport",
    city: "Mogadishu",
    countryId: "SO",
    timeZoneRegionName: "Africa/Mogadishu",
    latitude: 2.013333,
    longitude: 45.313333,
    icao: "HCMM"
  },
  MGR: {
    iata: "MGR",
    name: "Thomasville Airport",
    city: "Moultrie",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 31.069444,
    longitude: -83.802778,
    icao: "KMGR"
  },
  MGS: {
    iata: "MGS",
    name: "Mangaia Island Airport",
    city: "Mangaia Island",
    countryId: "CK",
    timeZoneRegionName: "Pacific/Rarotonga",
    latitude: -21.933333,
    longitude: -157.933333,
    icao: "NCGO"
  },
  MGT: {
    iata: "MGT",
    name: "Milingimbi Airport",
    city: "Milingimbi",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -12.093703,
    longitude: 134.893518,
    icao: "YMGB"
  },
  MGU: {
    iata: "MGU",
    name: "Manaung Airport",
    city: "Manaung",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 18.84453,
    longitude: 93.684923,
    icao: "VYMN"
  },
  MGV: {
    iata: "MGV",
    name: "Margaret River Station Airport",
    city: "Margaret River Station",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -18.616667,
    longitude: 126.866667,
    icao: "YMGR"
  },
  MGW: {
    iata: "MGW",
    name: "Morgantown Airport",
    city: "Morgantown",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.642778,
    longitude: -79.915833,
    icao: "KMGW"
  },
  MGX: {
    iata: "MGX",
    name: "Moabi Airport",
    city: "Moabi",
    countryId: "GA",
    timeZoneRegionName: "Africa/Libreville",
    latitude: -2.25,
    longitude: 11,
    icao: "FOGI"
  },
  MGZ: {
    iata: "MGZ",
    name: "Myeik Airport",
    city: "Myeik",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 12.45,
    longitude: 98.616667,
    icao: "VYME"
  },
  MHA: {
    iata: "MHA",
    name: "Mahdia Airport",
    city: "Mahdia",
    countryId: "GY",
    timeZoneRegionName: "America/Guyana",
    latitude: 5.25,
    longitude: -59.15,
    icao: "SYMD"
  },
  MHC: {
    iata: "MHC",
    name: "Mocopulli Airport",
    city: "Castro",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -42.34611,
    longitude: -73.71389,
    icao: "SCPQ"
  },
  MHD: {
    iata: "MHD",
    name: "Shahid Hashemi Nejad Airport",
    city: "Mashad",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 36.235207,
    longitude: 59.640996,
    icao: "OIMM"
  },
  MHE: {
    iata: "MHE",
    name: "Mitchell Municipal Airport",
    city: "Mitchell",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 43.775278,
    longitude: -98.038056,
    icao: "KMHE"
  },
  MHG: {
    iata: "MHG",
    name: "Mannheim Airport",
    city: "Mannheim",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 49.476577,
    longitude: 8.521081,
    icao: "EDFM"
  },
  MHH: {
    iata: "MHH",
    name: "Marsh Harbour International Airport",
    city: "Marsh Harbour",
    countryId: "BS",
    timeZoneRegionName: "America/Nassau",
    latitude: 26.513428,
    longitude: -77.077119,
    icao: "MYAM"
  },
  MHJ: {
    iata: "MHJ",
    name: "Mannheim Hbf Railway Station",
    city: "Mannheim",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 49.47972,
    longitude: 8.46972,
    icao: ""
  },
  MHK: {
    iata: "MHK",
    name: "Manhattan Municipal Airport",
    city: "Manhattan",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 39.142222,
    longitude: -96.668889,
    icao: "KMHK"
  },
  MHL: {
    iata: "MHL",
    name: "Memorial Municipal Airport",
    city: "Marshall",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 39.116667,
    longitude: -93.2,
    icao: "KMHL"
  },
  MHM: {
    iata: "MHM",
    name: "Manaoba Airport",
    city: "Malaita",
    countryId: "SB",
    timeZoneRegionName: "Pacific/Guadalcanal",
    latitude: -8.32167,
    longitude: 160.79528,
    icao: "AGOB"
  },
  MHN: {
    iata: "MHN",
    name: "Mullen Airport",
    city: "Mullen",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 42.05,
    longitude: -101.016667,
    icao: "KMHN"
  },
  MHO: {
    iata: "MHO",
    name: "Mount House Airport",
    city: "Mount House",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -17.133333,
    longitude: 125.766667,
    icao: "YMHO"
  },
  MHP: {
    iata: "MHP",
    name: "Minsk International 1 Airport",
    city: "Minsk",
    countryId: "BY",
    timeZoneRegionName: "Europe/Minsk",
    latitude: 53.864473,
    longitude: 27.539686,
    icao: "UMMM"
  },
  MHQ: {
    iata: "MHQ",
    name: "Mariehamn Airport",
    city: "Mariehamn",
    countryId: "AX",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 60.123333,
    longitude: 19.896667,
    icao: "EFMA"
  },
  MHR: {
    iata: "MHR",
    name: "Mather Airport",
    city: "Sacramento",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 38.553902,
    longitude: -121.297996,
    icao: "KMHR"
  },
  MHT: {
    iata: "MHT",
    name: "Manchester Boston Regional Airport",
    city: "Manchester",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.927862,
    longitude: -71.438439,
    icao: "KMHT"
  },
  MHV: {
    iata: "MHV",
    name: "Mojave Air and Space Port",
    city: "Mojave",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 35.057904,
    longitude: -118.147815,
    icao: "KMHV"
  },
  MHW: {
    iata: "MHW",
    name: "Monteagudo Airport",
    city: "Monteagudo",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -19.827,
    longitude: -63.960999,
    icao: "SLAG"
  },
  MHX: {
    iata: "MHX",
    name: "Manihiki Island Airport",
    city: "Manihiki Island",
    countryId: "CK",
    timeZoneRegionName: "Pacific/Rarotonga",
    latitude: -10.366667,
    longitude: -161,
    icao: "KMHX"
  },
  MHZ: {
    iata: "MHZ",
    name: "Mildenhall RAF Station",
    city: "Mildenhall",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 52.361902,
    longitude: 0.486411,
    icao: "EGUN"
  },
  MIA: {
    iata: "MIA",
    name: "Miami International Airport",
    city: "Miami",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 25.796,
    longitude: -80.278234,
    icao: "KMIA"
  },
  MIB: {
    iata: "MIB",
    name: "Minot Air Force Base",
    city: "Minot",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 48.415781,
    longitude: -101.35787,
    icao: "KMIB"
  },
  MIC: {
    iata: "MIC",
    name: "Crystal Airport",
    city: "Minneapolis",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 45.061944,
    longitude: -93.353889,
    icao: "KMIC"
  },
  MID: {
    iata: "MID",
    name: "Manuel Crescencio Rejon International Airport",
    city: "Merida",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 20.933822,
    longitude: -89.663748,
    icao: "MMMD"
  },
  MIE: {
    iata: "MIE",
    name: "Delaware County Regional Airport",
    city: "Muncie",
    countryId: "US",
    timeZoneRegionName: "America/Indiana/Indianapolis",
    latitude: 40.239722,
    longitude: -85.394444,
    icao: "KMIE"
  },
  MIG: {
    iata: "MIG",
    name: "Mianyang Nanjiao Airport",
    city: "Mian Yang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 31.427633,
    longitude: 104.747139,
    icao: "EDPN"
  },
  MII: {
    iata: "MII",
    name: "Dr Gastao Vidigal Airport",
    city: "Marilia",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -22.2,
    longitude: -49.933333,
    icao: "SBML"
  },
  MIK: {
    iata: "MIK",
    name: "Mikkeli Airport",
    city: "Mikkeli",
    countryId: "FI",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 61.683889,
    longitude: 27.213056,
    icao: "EFMI"
  },
  MIM: {
    iata: "MIM",
    name: "Merimbula Airport",
    city: "Merimbula",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -36.910044,
    longitude: 149.902029,
    icao: "YMER"
  },
  MIN: {
    iata: "MIN",
    name: "Minnipa Airport",
    city: "Minnipa",
    countryId: "AU",
    timeZoneRegionName: "Australia/Adelaide",
    latitude: -32.833333,
    longitude: 134.833333,
    icao: "YMPA"
  },
  MIO: {
    iata: "MIO",
    name: "Miami Airport",
    city: "Miami",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.883333,
    longitude: -94.9,
    icao: "KMIO"
  },
  MIP: {
    iata: "MIP",
    name: "Mitspeh Ramon Airport",
    city: "Mitspeh Ramon",
    countryId: "IL",
    timeZoneRegionName: "Asia/Jerusalem",
    latitude: 30.7761,
    longitude: 34.666698,
    icao: "LLMR"
  },
  MIQ: {
    iata: "MIQ",
    name: "Millard Airport",
    city: "Omaha",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.195123,
    longitude: -96.112097,
    icao: "KMLE"
  },
  MIR: {
    iata: "MIR",
    name: "Habib Bourguiba International Airport",
    city: "Monastir",
    countryId: "TN",
    timeZoneRegionName: "Africa/Tunis",
    latitude: 35.761083,
    longitude: 10.753155,
    icao: "DTMB"
  },
  MIT: {
    iata: "MIT",
    name: "Minter Field",
    city: "Shafter",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 35.507387,
    longitude: -119.192002,
    icao: "KMIT"
  },
  MIU: {
    iata: "MIU",
    name: "Maiduguri International Airport",
    city: "Maiduguri",
    countryId: "NG",
    timeZoneRegionName: "Africa/Lagos",
    latitude: 11.855487,
    longitude: 13.082928,
    icao: "DNMA"
  },
  MIV: {
    iata: "MIV",
    name: "Millville Municipal Airport",
    city: "Millville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.364644,
    longitude: -75.079292,
    icao: "KMIV"
  },
  MIW: {
    iata: "MIW",
    name: "Marshalltown Municipal Airport",
    city: "Marshalltown",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 42.166667,
    longitude: -92.916667,
    icao: "KMIW"
  },
  MJA: {
    iata: "MJA",
    name: "Manja Airport",
    city: "Manja",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -21.416667,
    longitude: 44.316667,
    icao: "FMSJ"
  },
  MJC: {
    iata: "MJC",
    name: "Man Airport",
    city: "Man",
    countryId: "CI",
    timeZoneRegionName: "Africa/Abidjan",
    latitude: 7.272002,
    longitude: -7.589494,
    icao: "DIMN"
  },
  MJD: {
    iata: "MJD",
    name: "Mohenjo Daro Airport",
    city: "Mohenjo Daro",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 27.336389,
    longitude: 68.141667,
    icao: "OPMJ"
  },
  MJF: {
    iata: "MJF",
    name: "Kjaerstad Airport",
    city: "Mosjoen",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 65.78439,
    longitude: 13.218328,
    icao: "ENMS"
  },
  MJI: {
    iata: "MJI",
    name: "Mitiga, Tripoli Airport",
    city: "Mitiga, Tripoli",
    countryId: "LY",
    timeZoneRegionName: "Africa/Tripoli",
    latitude: 32.897222,
    longitude: 13.277778,
    icao: "HLLM"
  },
  MJK: {
    iata: "MJK",
    name: "Shark Bay Airport",
    city: "Monkey Mia",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -25.888158,
    longitude: 113.576952,
    icao: "YSHK"
  },
  MJL: {
    iata: "MJL",
    name: "Mouila Airport",
    city: "Mouila",
    countryId: "GA",
    timeZoneRegionName: "Africa/Libreville",
    latitude: -1.817778,
    longitude: 10.924167,
    icao: "FOGM"
  },
  MJM: {
    iata: "MJM",
    name: "Mbuji Mayi Airport",
    city: "Mbuji Mayi",
    countryId: "CD",
    timeZoneRegionName: "Africa/Lubumbashi",
    latitude: -6.15,
    longitude: 23.633333,
    icao: "FZWA"
  },
  MJN: {
    iata: "MJN",
    name: "Amborovy Airport",
    city: "Majunga",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -15.665833,
    longitude: 46.353056,
    icao: "FMNM"
  },
  MJP: {
    iata: "MJP",
    name: "Manjimup Airport",
    city: "Manjimup",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -34.233333,
    longitude: 116.1,
    icao: "YMJM"
  },
  MJQ: {
    iata: "MJQ",
    name: "Jackson Airport",
    city: "Jackson",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 43.616667,
    longitude: -95.016667,
    icao: "KMJQ"
  },
  MJT: {
    iata: "MJT",
    name: "Mytilene International Airport",
    city: "Mytilene",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 39.053867,
    longitude: 26.603171,
    icao: "LGMT"
  },
  MJU: {
    iata: "MJU",
    name: "Tampa Padang Airport",
    city: "Mamuju",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -2.586667,
    longitude: 119.029167,
    icao: "WAFJ"
  },
  MJV: {
    iata: "MJV",
    name: "Murcia-San Javier Airport",
    city: "Murcia",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 37.775213,
    longitude: -0.81904,
    icao: "LELC"
  },
  MJW: {
    iata: "MJW",
    name: "Mahenye Airfield",
    city: "Mahenye",
    countryId: "ZW",
    timeZoneRegionName: "Africa/Harare",
    latitude: -21.233333,
    longitude: 32.333333,
    icao: "FVMH"
  },
  MJX: {
    iata: "MJX",
    name: "Robert J. Miller Air Park",
    city: "Toms River",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.928092,
    longitude: -74.293055,
    icao: "KMJX"
  },
  MJZ: {
    iata: "MJZ",
    name: "Mirnyj Airport",
    city: "Mirnyj",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yakutsk",
    latitude: 62.533333,
    longitude: 114.033333,
    icao: "UERR"
  },
  MKA: {
    iata: "MKA",
    name: "Marianske Lazne Airport",
    city: "Marianske Lazne",
    countryId: "CZ",
    timeZoneRegionName: "Europe/Prague",
    latitude: 49.983333,
    longitude: 12.716667,
    icao: "LKMR"
  },
  MKB: {
    iata: "MKB",
    name: "Mekambo Airport",
    city: "Mekambo",
    countryId: "GA",
    timeZoneRegionName: "Africa/Libreville",
    latitude: 1.05,
    longitude: 13.833333,
    icao: "FOOE"
  },
  MKC: {
    iata: "MKC",
    name: "Charles B. Wheeler Downtown Airport",
    city: "Kansas City",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 39.124167,
    longitude: -94.591944,
    icao: "KMKC"
  },
  MKE: {
    iata: "MKE",
    name: "General Mitchell International Airport",
    city: "Milwaukee",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 42.948095,
    longitude: -87.902668,
    icao: "KMKE"
  },
  MKG: {
    iata: "MKG",
    name: "Muskegon Airport",
    city: "Muskegon",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 43.170556,
    longitude: -86.2375,
    icao: "KMKG"
  },
  MKH: {
    iata: "MKH",
    name: "Mokhotlong Airport",
    city: "Mokhotlong",
    countryId: "LS",
    timeZoneRegionName: "Africa/Maseru",
    latitude: -29.166667,
    longitude: 29.166667,
    icao: "FXMK"
  },
  MKI: {
    iata: "MKI",
    name: "M'boki Airport",
    city: "M'Boki",
    countryId: "CF",
    timeZoneRegionName: "Africa/Bangui",
    latitude: 5.316667,
    longitude: 25.95,
    icao: "FEFB"
  },
  MKJ: {
    iata: "MKJ",
    name: "Makoua Airport",
    city: "Makoua",
    countryId: "CG",
    timeZoneRegionName: "Africa/Brazzaville",
    latitude: -0.020278,
    longitude: 15.576667,
    icao: "FCOM"
  },
  MKK: {
    iata: "MKK",
    name: "Molokai Airport",
    city: "Hoolehua",
    countryId: "US",
    timeZoneRegionName: "Pacific/Honolulu",
    latitude: 21.155184,
    longitude: -157.092927,
    icao: "PHMK"
  },
  MKL: {
    iata: "MKL",
    name: "Mckellar-Sipes Regional Airport",
    city: "Jackson",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.599778,
    longitude: -88.915097,
    icao: "KMKL"
  },
  MKM: {
    iata: "MKM",
    name: "Mukah Airport",
    city: "Mukah",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 2.906944,
    longitude: 112.079722,
    icao: "WBGK"
  },
  MKO: {
    iata: "MKO",
    name: "Davis Field",
    city: "Muskogee",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.660556,
    longitude: -95.366667,
    icao: "KMKO"
  },
  MKP: {
    iata: "MKP",
    name: "Makemo Airport",
    city: "Makemo",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -16.587921,
    longitude: -143.654364,
    icao: "NTGM"
  },
  MKQ: {
    iata: "MKQ",
    name: "Mopah Airport",
    city: "Merauke",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jayapura",
    latitude: -8.519837,
    longitude: 140.41894,
    icao: "WAKK"
  },
  MKR: {
    iata: "MKR",
    name: "Meekatharra Airport",
    city: "Meekatharra",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -26.61113,
    longitude: 118.545959,
    icao: "YMEK"
  },
  MKS: {
    iata: "MKS",
    name: "Mekane Selam Airport",
    city: "Mekane Selam",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 11.683333,
    longitude: 38.15,
    icao: "HAMA"
  },
  MKT: {
    iata: "MKT",
    name: "Mankato Municipal Airport",
    city: "Mankato",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 44.223611,
    longitude: -93.918333,
    icao: "KMKT"
  },
  MKU: {
    iata: "MKU",
    name: "Makokou Airport",
    city: "Makokou",
    countryId: "GA",
    timeZoneRegionName: "Africa/Libreville",
    latitude: 0.559167,
    longitude: 12.861111,
    icao: "FOOK"
  },
  MKW: {
    iata: "MKW",
    name: "Rendani Airport",
    city: "Manokwari",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jayapura",
    latitude: -0.893056,
    longitude: 134.052778,
    icao: "WASR"
  },
  MKY: {
    iata: "MKY",
    name: "Mackay Airport",
    city: "Mackay",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -21.176284,
    longitude: 149.181789,
    icao: "YBMK"
  },
  MKZ: {
    iata: "MKZ",
    name: "Malacca International Airport",
    city: "Malacca",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 2.262959,
    longitude: 102.252464,
    icao: "WMKM"
  },
  MLA: {
    iata: "MLA",
    name: "Malta International Airport",
    city: "Malta",
    countryId: "MT",
    timeZoneRegionName: "Europe/Malta",
    latitude: 35.849776,
    longitude: 14.495401,
    icao: "LMML"
  },
  MLB: {
    iata: "MLB",
    name: "Orlando Melbourne International Airport",
    city: "Melbourne",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 28.1025,
    longitude: -80.630278,
    icao: "KMLB"
  },
  MLC: {
    iata: "MLC",
    name: "McAlester Regional Airport",
    city: "McAlester",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 34.880278,
    longitude: -95.785,
    icao: "KMLC"
  },
  MLD: {
    iata: "MLD",
    name: "Malad City Airport",
    city: "Malad City",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 42.2,
    longitude: -112.45,
    icao: "KMLD"
  },
  MLE: {
    iata: "MLE",
    name: "Velana International Airport",
    city: "Male",
    countryId: "MV",
    timeZoneRegionName: "Indian/Maldives",
    latitude: 4.19183,
    longitude: 73.529108,
    icao: "VRMM"
  },
  MLF: {
    iata: "MLF",
    name: "Milford Airport",
    city: "Milford",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 38.433333,
    longitude: -113.016667,
    icao: "KMLF"
  },
  MLG: {
    iata: "MLG",
    name: "Abdul Rachman Saleh Airport",
    city: "Malang",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: -7.926611,
    longitude: 112.71449,
    icao: "WARA"
  },
  MLH: {
    iata: "MLH",
    name: "EuroAirport Basel-Mulhouse-Freiburg",
    city: "Mulhouse",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 47.599324,
    longitude: 7.532864,
    icao: "LFSB"
  },
  MLI: {
    iata: "MLI",
    name: "Quad City International Airport",
    city: "Moline",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.453897,
    longitude: -90.506111,
    icao: "KMLI"
  },
  MLJ: {
    iata: "MLJ",
    name: "Baldwin County Airport",
    city: "Milledgeville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 33.083333,
    longitude: -83.233333,
    icao: "KMLJ"
  },
  MLK: {
    iata: "MLK",
    name: "Malta",
    city: "Malta",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 48.494417,
    longitude: -107.9095,
    icao: "KMLK"
  },
  MLL: {
    iata: "MLL",
    name: "Marshall Don Hunter Sr. Airport",
    city: "Marshall",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 61.864187,
    longitude: -162.026166,
    icao: "PADM"
  },
  MLM: {
    iata: "MLM",
    name: "Morelia Airport",
    city: "Morelia",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 19.843509,
    longitude: -101.026932,
    icao: "MMMM"
  },
  MLN: {
    iata: "MLN",
    name: "Melilla Airport",
    city: "Melilla",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 35.277078,
    longitude: -2.957473,
    icao: "GEML"
  },
  MLO: {
    iata: "MLO",
    name: "Milos Airport",
    city: "Milos",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 36.69611,
    longitude: 24.475,
    icao: "LGML"
  },
  MLP: {
    iata: "MLP",
    name: "Malabang Airport",
    city: "Malabang",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 7.618333,
    longitude: 124.0575,
    icao: "RPMM"
  },
  MLR: {
    iata: "MLR",
    name: "Millicent Airport",
    city: "Millicent",
    countryId: "AU",
    timeZoneRegionName: "Australia/Adelaide",
    latitude: -37.583599,
    longitude: 140.365997,
    icao: "YMCT"
  },
  MLS: {
    iata: "MLS",
    name: "Frank Wiley Field",
    city: "Miles City",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 46.428325,
    longitude: -105.884503,
    icao: "KMLS"
  },
  MLT: {
    iata: "MLT",
    name: "Millinocket Municipal Airport",
    city: "Millinocket",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 45.6478,
    longitude: -68.6856,
    icao: "KMLT"
  },
  MLU: {
    iata: "MLU",
    name: "Monroe Regional Airport",
    city: "Monroe",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.511842,
    longitude: -92.043659,
    icao: "KMLU"
  },
  MLW: {
    iata: "MLW",
    name: "Spriggs Payne Airport",
    city: "Monrovia",
    countryId: "LR",
    timeZoneRegionName: "Africa/Monrovia",
    latitude: 6.289444,
    longitude: -10.758333,
    icao: "GLMR"
  },
  MLX: {
    iata: "MLX",
    name: "Malatya Airport",
    city: "Malatya",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 38.354444,
    longitude: 38.253611,
    icao: "LTAT"
  },
  MLY: {
    iata: "MLY",
    name: "Manley Hot Springs Airport",
    city: "Manley Hot Springs",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 64.996667,
    longitude: -150.643056,
    icao: "PAML"
  },
  MLZ: {
    iata: "MLZ",
    name: "Melo Airport",
    city: "Melo",
    countryId: "UY",
    timeZoneRegionName: "America/Montevideo",
    latitude: -32.333333,
    longitude: -54.2,
    icao: "SUMO"
  },
  MMB: {
    iata: "MMB",
    name: "Memanbetsu Airport",
    city: "Memanbetsu",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 43.881084,
    longitude: 144.160012,
    icao: "RJCM"
  },
  MMC: {
    iata: "MMC",
    name: "Ciudad Mante Airport",
    city: "Ciudad Mante",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 22.833333,
    longitude: -99,
    icao: "MMDM"
  },
  MMD: {
    iata: "MMD",
    name: "Maridor Airport",
    city: "Minami Daito",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 25.846431,
    longitude: 131.263668,
    icao: "ROMD"
  },
  MME: {
    iata: "MME",
    name: "Teesside International Airport",
    city: "Durham Tees Valley",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 54.512226,
    longitude: -1.434013,
    icao: "EGNV"
  },
  MMF: {
    iata: "MMF",
    name: "Mamfe Airport",
    city: "Mamfe",
    countryId: "CM",
    timeZoneRegionName: "Africa/Douala",
    latitude: 5.716667,
    longitude: 9.3,
    icao: "FKKF"
  },
  MMG: {
    iata: "MMG",
    name: "Mount Magnet Airport",
    city: "Mount Magnet",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -28.116412,
    longitude: 117.842955,
    icao: "YMOG"
  },
  MMH: {
    iata: "MMH",
    name: "Mammoth Lakes Airport",
    city: "Mammoth Lakes",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 37.631111,
    longitude: -118.851389,
    icao: "KMMH"
  },
  MMI: {
    iata: "MMI",
    name: "McMinn County Airport",
    city: "Athens",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 35.523028,
    longitude: -84.675694,
    icao: "KMMI"
  },
  MMJ: {
    iata: "MMJ",
    name: "Matsumoto Airport",
    city: "Matsumoto",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 36.166801,
    longitude: 137.923004,
    icao: "RJAF"
  },
  MMK: {
    iata: "MMK",
    name: "Murmansk Airport",
    city: "Murmansk",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 68.785092,
    longitude: 32.759155,
    icao: "ULMM"
  },
  MML: {
    iata: "MML",
    name: "Southwest Minnesota Regional Airport",
    city: "Marshall",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 44.447222,
    longitude: -95.8175,
    icao: "KMML"
  },
  MMM: {
    iata: "MMM",
    name: "Middlemount Airport",
    city: "Middlemount",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -22.802474,
    longitude: 148.706619,
    icao: "YMMU"
  },
  MMO: {
    iata: "MMO",
    name: "Vila Do Maio Airport",
    city: "Maio",
    countryId: "CV",
    timeZoneRegionName: "Atlantic/Cape_Verde",
    latitude: 15.25,
    longitude: -23.166667,
    icao: "GVMA"
  },
  MMP: {
    iata: "MMP",
    name: "San Bernardo Airport",
    city: "Mompos",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 9.262399,
    longitude: -74.436095,
    icao: "SKMP"
  },
  MMQ: {
    iata: "MMQ",
    name: "Mbala Airport",
    city: "Mbala",
    countryId: "ZM",
    timeZoneRegionName: "Africa/Lusaka",
    latitude: -8.859409,
    longitude: 31.336367,
    icao: "FLBA"
  },
  MMS: {
    iata: "MMS",
    name: "Selfs Airport",
    city: "Marks",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 34.266667,
    longitude: -90.266667,
    icao: "KMMS"
  },
  MMT: {
    iata: "MMT",
    name: "McEntire Joint National Guard Base",
    city: "Columbia",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 33.92465,
    longitude: -80.806428,
    icao: "KMMT"
  },
  MMU: {
    iata: "MMU",
    name: "Morristown Municipal Airport",
    city: "Morristown",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.795183,
    longitude: -74.421112,
    icao: "KMMU"
  },
  MMX: {
    iata: "MMX",
    name: "Malmo Airport",
    city: "Malmo",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 55.538759,
    longitude: 13.363727,
    icao: "ESMS"
  },
  MMY: {
    iata: "MMY",
    name: "Miyako Airport",
    city: "Miyako",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 24.779198,
    longitude: 125.297786,
    icao: "ROMY"
  },
  MMZ: {
    iata: "MMZ",
    name: "Maimana Airport",
    city: "Maimana",
    countryId: "AF",
    timeZoneRegionName: "Asia/Kabul",
    latitude: 35.925463,
    longitude: 64.766352,
    icao: "OAMN"
  },
  MNB: {
    iata: "MNB",
    name: "Moanda Airport",
    city: "Moanda",
    countryId: "CD",
    timeZoneRegionName: "Africa/Kinshasa",
    latitude: -5.926944,
    longitude: 12.352778,
    icao: "FZAG"
  },
  MNC: {
    iata: "MNC",
    name: "Nacala Airport",
    city: "Nacala",
    countryId: "MZ",
    timeZoneRegionName: "Africa/Maputo",
    latitude: -14.49363,
    longitude: 40.708218,
    icao: "FQNC"
  },
  MNF: {
    iata: "MNF",
    name: "Mana Island Airstrip",
    city: "Mana Island",
    countryId: "FJ",
    timeZoneRegionName: "Pacific/Fiji",
    latitude: -17.633333,
    longitude: 177.116667,
    icao: "NFMA"
  },
  MNG: {
    iata: "MNG",
    name: "Maningrida Airport",
    city: "Maningrida",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -12.05492,
    longitude: 134.232266,
    icao: "YMGD"
  },
  MNH: {
    iata: "MNH",
    name: "Rustaq Airport",
    city: "Al Masnaah",
    countryId: "OM",
    timeZoneRegionName: "Asia/Muscat",
    latitude: 23.64111,
    longitude: 57.48639,
    icao: "OORQ"
  },
  MNI: {
    iata: "MNI",
    name: "Montserrat John A. Osborne Airport",
    city: "Montserrat",
    countryId: "MS",
    timeZoneRegionName: "America/Montserrat",
    latitude: 16.791423,
    longitude: -62.193339,
    icao: "TRPG"
  },
  MNJ: {
    iata: "MNJ",
    name: "Mananjary Airport",
    city: "Mananjary",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -21.207066,
    longitude: 48.356779,
    icao: "FMSM"
  },
  MNK: {
    iata: "MNK",
    name: "Maiana Airport",
    city: "Maiana",
    countryId: "KI",
    timeZoneRegionName: "Pacific/Tarawa",
    latitude: 1,
    longitude: 173,
    icao: "NGMA"
  },
  MNL: {
    iata: "MNL",
    name: "Ninoy Aquino International Airport",
    city: "Manila",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 14.511205,
    longitude: 121.019208,
    icao: "RPLL"
  },
  MNM: {
    iata: "MNM",
    name: "Menominee-Marinette Twin County Airport",
    city: "Menominee",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 45.121667,
    longitude: -87.636111,
    icao: "KMNM"
  },
  MNN: {
    iata: "MNN",
    name: "Marion Municipal Airport",
    city: "Marion",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.583333,
    longitude: -83.133333,
    icao: "KMNN"
  },
  MNO: {
    iata: "MNO",
    name: "Manono Airport",
    city: "Manono",
    countryId: "CD",
    timeZoneRegionName: "Africa/Lubumbashi",
    latitude: -7.288056,
    longitude: 27.393889,
    icao: "FZRA"
  },
  MNQ: {
    iata: "MNQ",
    name: "Monto Airport",
    city: "Monto",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -24.883333,
    longitude: 151.1,
    icao: "YMTO"
  },
  MNR: {
    iata: "MNR",
    name: "Mongu Airport",
    city: "Mongu",
    countryId: "ZM",
    timeZoneRegionName: "Africa/Lusaka",
    latitude: -15.254778,
    longitude: 23.16233,
    icao: "FLMG"
  },
  MNS: {
    iata: "MNS",
    name: "Mansa Airport",
    city: "Mansa",
    countryId: "ZM",
    timeZoneRegionName: "Africa/Lusaka",
    latitude: -11.125,
    longitude: 28.866667,
    icao: "FLMA"
  },
  MNU: {
    iata: "MNU",
    name: "Mawlamyine Airport",
    city: "Mawlamyine",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 16.444747,
    longitude: 97.660669,
    icao: "VYMM"
  },
  MNX: {
    iata: "MNX",
    name: "Manicore Airport",
    city: "Manicore",
    countryId: "BR",
    timeZoneRegionName: "America/Porto_Velho",
    latitude: -5.816667,
    longitude: -61.283333,
    icao: "SBMY"
  },
  MNY: {
    iata: "MNY",
    name: "Mono Airport",
    city: "Mono",
    countryId: "SB",
    timeZoneRegionName: "Pacific/Guadalcanal",
    latitude: -7.417428,
    longitude: 155.564628,
    icao: "AGGO"
  },
  MNZ: {
    iata: "MNZ",
    name: "Manassas Regional Airport",
    city: "Manassas",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 38.721944,
    longitude: -77.518056,
    icao: "KHEF"
  },
  MOA: {
    iata: "MOA",
    name: "Orestes Acosta Airport",
    city: "Moa",
    countryId: "CU",
    timeZoneRegionName: "America/Havana",
    latitude: 20.5,
    longitude: -74.883333,
    icao: "MUMO"
  },
  MOB: {
    iata: "MOB",
    name: "Mobile Regional Airport",
    city: "Mobile",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.681085,
    longitude: -88.244753,
    icao: "KMOB"
  },
  MOC: {
    iata: "MOC",
    name: "Montes Claros Airport",
    city: "Montes Claros",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -16.707778,
    longitude: -43.817222,
    icao: "SBMK"
  },
  MOD: {
    iata: "MOD",
    name: "Modesto Municipal Airport",
    city: "Modesto",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 37.626944,
    longitude: -120.955278,
    icao: "KMOD"
  },
  MOE: {
    iata: "MOE",
    name: "Momeik Airport",
    city: "Momeik",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 23.1,
    longitude: 96.65,
    icao: "VYMO"
  },
  MOF: {
    iata: "MOF",
    name: "Wai Oti Airport",
    city: "Maumere",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -8.637726,
    longitude: 122.238255,
    icao: "WATC"
  },
  MOG: {
    iata: "MOG",
    name: "Mong Hsat Airport",
    city: "Mong Hsat",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 20.518667,
    longitude: 99.256952,
    icao: "VYMS"
  },
  MOH: {
    iata: "MOH",
    name: "Morowali Maleo Airport",
    city: "Morowali",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -2.201897,
    longitude: 121.662013,
    icao: ""
  },
  MOK: {
    iata: "MOK",
    name: "Muynaq Airport",
    city: "Muynaq",
    countryId: "UZ",
    timeZoneRegionName: "Asia/Samarkand",
    latitude: 43.755833,
    longitude: 59.029722,
    icao: ""
  },
  MOL: {
    iata: "MOL",
    name: "Molde Airport, Aro",
    city: "Molde",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 62.745714,
    longitude: 7.261039,
    icao: "ENML"
  },
  MOM: {
    iata: "MOM",
    name: "Moudjeria Airport",
    city: "Moudjeria",
    countryId: "MR",
    timeZoneRegionName: "Africa/Nouakchott",
    latitude: 17.75,
    longitude: -12.5,
    icao: "GQNL"
  },
  MON: {
    iata: "MON",
    name: "Mount Cook Airport",
    city: "Mount Cook",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -43.765018,
    longitude: 170.135337,
    icao: "NZMC"
  },
  MOO: {
    iata: "MOO",
    name: "Moomba Airport",
    city: "Moomba",
    countryId: "AU",
    timeZoneRegionName: "Australia/Adelaide",
    latitude: -28.100822,
    longitude: 140.199106,
    icao: "YOOM"
  },
  MOP: {
    iata: "MOP",
    name: "Mount Pleasant Municipal Airport",
    city: "Mount Pleasant",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 43.620642,
    longitude: -84.737792,
    icao: "KMOP"
  },
  MOQ: {
    iata: "MOQ",
    name: "Morondava Airport",
    city: "Morondava",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -20.283611,
    longitude: 44.318333,
    icao: "FMMV"
  },
  MOR: {
    iata: "MOR",
    name: "Moore-Murrell Airport",
    city: "Morristown",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 36.216667,
    longitude: -83.3,
    icao: "KMOR"
  },
  MOT: {
    iata: "MOT",
    name: "Minot International Airport",
    city: "Minot",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 48.256328,
    longitude: -101.291519,
    icao: "KMOT"
  },
  MOU: {
    iata: "MOU",
    name: "Mountain Village Airport",
    city: "Mountain Village",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 62.089444,
    longitude: -163.716667,
    icao: "PAMO"
  },
  MOV: {
    iata: "MOV",
    name: "Moranbah Airport",
    city: "Moranbah",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -22.06057,
    longitude: 148.074417,
    icao: "YMRB"
  },
  MOX: {
    iata: "MOX",
    name: "Morris Municipal Airport",
    city: "Morris",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 45.583333,
    longitude: -95.916667,
    icao: "KMOX"
  },
  MOZ: {
    iata: "MOZ",
    name: "Temae Airport",
    city: "Moorea",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -17.490432,
    longitude: -149.764138,
    icao: "NTTM"
  },
  MPA: {
    iata: "MPA",
    name: "Mpacha Airport",
    city: "Mpacha",
    countryId: "NA",
    timeZoneRegionName: "Africa/Windhoek",
    latitude: -17.5,
    longitude: 24.266667,
    icao: "FAMP"
  },
  MPH: {
    iata: "MPH",
    name: "Godofredo P. Ramos Airport",
    city: "Caticlan",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 11.924497,
    longitude: 121.954003,
    icao: "RPWY"
  },
  MPK: {
    iata: "MPK",
    name: "Mokpo Airport",
    city: "Mokpo",
    countryId: "KR",
    timeZoneRegionName: "Asia/Seoul",
    latitude: 34.756667,
    longitude: 126.385,
    icao: "RKJM"
  },
  MPL: {
    iata: "MPL",
    name: "Montpellier Mediterranee Airport",
    city: "Montpellier",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 43.57843,
    longitude: 3.959174,
    icao: "LFMT"
  },
  MPM: {
    iata: "MPM",
    name: "Maputo International Airport",
    city: "Maputo",
    countryId: "MZ",
    timeZoneRegionName: "Africa/Maputo",
    latitude: -25.924388,
    longitude: 32.57429,
    icao: "FQMA"
  },
  MPN: {
    iata: "MPN",
    name: "Mount Pleasant RAF Station",
    city: "Mount Pleasant",
    countryId: "FK",
    timeZoneRegionName: "Atlantic/Stanley",
    latitude: -51.822711,
    longitude: -58.44598,
    icao: "EGYP"
  },
  MPO: {
    iata: "MPO",
    name: "Mount Pocono Airport",
    city: "Mount Pocono",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.133333,
    longitude: -75.366667,
    icao: "KMPO"
  },
  MPR: {
    iata: "MPR",
    name: "McPherson Airport",
    city: "McPherson",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 38.374361,
    longitude: -97.763306,
    icao: "KMPR"
  },
  MPS: {
    iata: "MPS",
    name: "Mount Pleasant Airport",
    city: "Mount Pleasant",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 33.166667,
    longitude: -94.983333,
    icao: "KMSA"
  },
  MPV: {
    iata: "MPV",
    name: "Edward F. Knapp State Airport",
    city: "Berlin",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 44.202842,
    longitude: -72.563806,
    icao: "KMPV"
  },
  MPY: {
    iata: "MPY",
    name: "Maripasoula Airport",
    city: "Maripasoula",
    countryId: "GF",
    timeZoneRegionName: "America/Cayenne",
    latitude: 3.666667,
    longitude: -54.033333,
    icao: "SOOA"
  },
  MPZ: {
    iata: "MPZ",
    name: "Mount Pleasant Municipal Airport",
    city: "Mount Pleasant",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 40.966667,
    longitude: -91.55,
    icao: "KMPZ"
  },
  MQB: {
    iata: "MQB",
    name: "Macomb Municipal Airport",
    city: "Macomb",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 40.4525,
    longitude: -90.621389,
    icao: "KMQB"
  },
  MQC: {
    iata: "MQC",
    name: "Miquelon Airport",
    city: "Miquelon",
    countryId: "PM",
    timeZoneRegionName: "America/Miquelon",
    latitude: 47.05,
    longitude: -56.333333,
    icao: "LFVM"
  },
  MQD: {
    iata: "MQD",
    name: "Maquinchao Airport",
    city: "Maquinchao",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -41.25,
    longitude: -68.733333,
    icao: "SAVQ"
  },
  MQF: {
    iata: "MQF",
    name: "Magnitogorsk Airport",
    city: "Magnitogorsk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yekaterinburg",
    latitude: 53.391881,
    longitude: 58.755257,
    icao: "USCM"
  },
  MQJ: {
    iata: "MQJ",
    name: "Moma Airport",
    city: "Khonu",
    countryId: "RU",
    timeZoneRegionName: "Asia/Srednekolymsk",
    latitude: 66.455833,
    longitude: 143.253056,
    icao: "UEMA"
  },
  MQK: {
    iata: "MQK",
    name: "San Matias Airport",
    city: "San Matias",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -16.334444,
    longitude: -58.385556,
    icao: "SLTI"
  },
  MQL: {
    iata: "MQL",
    name: "Mildura Airport",
    city: "Mildura",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -34.230834,
    longitude: 142.084548,
    icao: "YMIA"
  },
  MQM: {
    iata: "MQM",
    name: "Mardin Airport",
    city: "Mardin",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 37.2233,
    longitude: 40.6317,
    icao: "LTCR"
  },
  MQN: {
    iata: "MQN",
    name: "Mo i Rana Airport",
    city: "Mo i Rana",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 66.364646,
    longitude: 14.302748,
    icao: "ENRA"
  },
  MQP: {
    iata: "MQP",
    name: "Kruger Mpumalanga International Airport",
    city: "Nelspruit",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -25.383333,
    longitude: 31.105556,
    icao: "FAKN"
  },
  MQQ: {
    iata: "MQQ",
    name: "Moundou Airport",
    city: "Moundou",
    countryId: "TD",
    timeZoneRegionName: "Africa/Ndjamena",
    latitude: 8.625,
    longitude: 16.073333,
    icao: "FTTD"
  },
  MQT: {
    iata: "MQT",
    name: "Sawyer International Airport",
    city: "Marquette",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 46.353611,
    longitude: -87.395278,
    icao: "KSAW"
  },
  MQU: {
    iata: "MQU",
    name: "Mariquita Airport",
    city: "Mariquita",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 5.216667,
    longitude: -74.883333,
    icao: "SKQU"
  },
  MQW: {
    iata: "MQW",
    name: "Telfair-Wheeler Airport",
    city: "McRae",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 32.207778,
    longitude: -83.000278,
    icao: "KMQW"
  },
  MQX: {
    iata: "MQX",
    name: "Alula Aba Nega Airport",
    city: "Makale",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 13.467388,
    longitude: 39.53346,
    icao: "HAMK"
  },
  MQY: {
    iata: "MQY",
    name: "Smyrna Airport",
    city: "Smyrna",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.006745,
    longitude: -86.510593,
    icao: "KMQY"
  },
  MQZ: {
    iata: "MQZ",
    name: "Margaret River Airport",
    city: "Margaret River",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -33.928014,
    longitude: 115.100337,
    icao: "YMGT"
  },
  MRA: {
    iata: "MRA",
    name: "Misrata International Airport",
    city: "Misrata",
    countryId: "LY",
    timeZoneRegionName: "Africa/Tripoli",
    latitude: 32.325556,
    longitude: 15.059722,
    icao: "HLMS"
  },
  MRB: {
    iata: "MRB",
    name: "Eastern West Virginia Regional Airport",
    city: "Martinsburg",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.401667,
    longitude: -77.985,
    icao: "KMRB"
  },
  MRC: {
    iata: "MRC",
    name: "Maury County Airport",
    city: "Columbia",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.553375,
    longitude: -87.177436,
    icao: "KMRC"
  },
  MRD: {
    iata: "MRD",
    name: "Alberto Carnevalli Airport",
    city: "Merida",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 8.582471,
    longitude: -71.160504,
    icao: "SVMD"
  },
  MRE: {
    iata: "MRE",
    name: "Mara Serena Airport",
    city: "Maasai Mara",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: -1.404931,
    longitude: 35.008236,
    icao: "HKMS"
  },
  MRF: {
    iata: "MRF",
    name: "Marfa Municipal Airport",
    city: "Marfa",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.371099,
    longitude: -104.017997,
    icao: "KMRF"
  },
  MRG: {
    iata: "MRG",
    name: "Mareeba Airport",
    city: "Mareeba",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -17.069201,
    longitude: 145.419006,
    icao: "YMBA"
  },
  MRI: {
    iata: "MRI",
    name: "Merrill Field",
    city: "Anchorage",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 61.221681,
    longitude: -149.855652,
    icao: "PAMR"
  },
  MRK: {
    iata: "MRK",
    name: "Marco Island Airport",
    city: "Marco Island",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 25.999664,
    longitude: -81.674172,
    icao: "KMKY"
  },
  MRN: {
    iata: "MRN",
    name: "Lenoir Airport",
    city: "Morganton",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 35.75,
    longitude: -81.683333,
    icao: "KMRN"
  },
  MRO: {
    iata: "MRO",
    name: "Masterton Airport",
    city: "Masterton",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -40.975,
    longitude: 175.633333,
    icao: "NZMS"
  },
  MRP: {
    iata: "MRP",
    name: "Marla Airport",
    city: "Marla",
    countryId: "AU",
    timeZoneRegionName: "Australia/Adelaide",
    latitude: -27,
    longitude: 135,
    icao: "YALA"
  },
  MRQ: {
    iata: "MRQ",
    name: "Marinduque Airport",
    city: "Marinduque",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 13.363056,
    longitude: 121.823611,
    icao: "RPUW"
  },
  MRR: {
    iata: "MRR",
    name: "Macara Airport",
    city: "Macara",
    countryId: "EC",
    timeZoneRegionName: "America/Guayaquil",
    latitude: -4.383333,
    longitude: -79.933333,
    icao: "SEMA"
  },
  MRS: {
    iata: "MRS",
    name: "Marseille Provence Airport",
    city: "Marseille",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 43.44178,
    longitude: 5.222137,
    icao: "LFML"
  },
  MRU: {
    iata: "MRU",
    name: "Sir Seewoosagur Ramgoolam International Airport",
    city: "Mauritius",
    countryId: "MU",
    timeZoneRegionName: "Indian/Mauritius",
    latitude: -20.431998,
    longitude: 57.676629,
    icao: "FIMP"
  },
  MRV: {
    iata: "MRV",
    name: "Mineralnye Vody Airport",
    city: "Mineralnye Vody",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 44.218354,
    longitude: 43.088178,
    icao: "URMM"
  },
  MRW: {
    iata: "MRW",
    name: "Maribo Airport",
    city: "Maribo",
    countryId: "DK",
    timeZoneRegionName: "Europe/Copenhagen",
    latitude: 54.685833,
    longitude: 11.435,
    icao: "EKMB"
  },
  MRX: {
    iata: "MRX",
    name: "Mahshahr Airport",
    city: "Bandar Mahshahr",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 30.553822,
    longitude: 49.149379,
    icao: "OIAM"
  },
  MRY: {
    iata: "MRY",
    name: "Monterey Regional Airport",
    city: "Monterey",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 36.587294,
    longitude: -121.850813,
    icao: "KMRY"
  },
  MRZ: {
    iata: "MRZ",
    name: "Moree Airport",
    city: "Moree",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -29.496345,
    longitude: 149.850186,
    icao: "YMOR"
  },
  MSA: {
    iata: "MSA",
    name: "Muskrat Dam Airport",
    city: "Muskrat Dam",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 53.44111,
    longitude: -91.76306,
    icao: "CZMD"
  },
  MSC: {
    iata: "MSC",
    name: "Falcon Field",
    city: "Mesa",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 33.460689,
    longitude: -111.728631,
    icao: "KFFZ"
  },
  MSE: {
    iata: "MSE",
    name: "Manston Airport",
    city: "Manston",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.346396,
    longitude: 1.357335,
    icao: "EGMH"
  },
  MSH: {
    iata: "MSH",
    name: "Masirah Air Force Base",
    city: "Masirah",
    countryId: "OM",
    timeZoneRegionName: "Asia/Muscat",
    latitude: 20.669335,
    longitude: 58.890696,
    icao: "OOMA"
  },
  MSJ: {
    iata: "MSJ",
    name: "Misawa Airport",
    city: "Misawa",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 40.696315,
    longitude: 141.386897,
    icao: "RJSM"
  },
  MSK: {
    iata: "MSK",
    name: "Puerto Gaitan Morelia Airport",
    city: "Puerto Gaitan",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 3.754722,
    longitude: -71.458056,
    icao: "SKMO"
  },
  MSL: {
    iata: "MSL",
    name: "Northwest Alabama Regional Airport",
    city: "Muscle Shoals",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 34.748611,
    longitude: -87.616111,
    icao: "KMSL"
  },
  MSM: {
    iata: "MSM",
    name: "Masi Manimba Airport",
    city: "Masi Manimba",
    countryId: "CD",
    timeZoneRegionName: "Africa/Kinshasa",
    latitude: -4.766667,
    longitude: 17.916667,
    icao: "FZCV"
  },
  MSN: {
    iata: "MSN",
    name: "Dane County Regional Airport",
    city: "Madison",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 43.136377,
    longitude: -89.346497,
    icao: "KMSN"
  },
  MSO: {
    iata: "MSO",
    name: "Missoula International Airport",
    city: "Missoula",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 46.918965,
    longitude: -114.083216,
    icao: "KMSO"
  },
  MSP: {
    iata: "MSP",
    name: "Minneapolis-St. Paul International Airport",
    city: "Minneapolis",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 44.883016,
    longitude: -93.210922,
    icao: "KMSP"
  },
  MSQ: {
    iata: "MSQ",
    name: "Minsk National Airport",
    city: "Minsk",
    countryId: "BY",
    timeZoneRegionName: "Europe/Minsk",
    latitude: 53.889725,
    longitude: 28.032442,
    icao: "UMMS"
  },
  MSR: {
    iata: "MSR",
    name: "Mus Airport",
    city: "Mus",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 38.725,
    longitude: 41.625,
    icao: "LTCK"
  },
  MSS: {
    iata: "MSS",
    name: "Richards Field",
    city: "Massena",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 44.937778,
    longitude: -74.846667,
    icao: "KMSS"
  },
  MST: {
    iata: "MST",
    name: "Maastricht Aachen Airport",
    city: "Maastricht",
    countryId: "NL",
    timeZoneRegionName: "Europe/Amsterdam",
    latitude: 50.915619,
    longitude: 5.768827,
    icao: "EHBK"
  },
  MSU: {
    iata: "MSU",
    name: "Moshoeshoe International Airport",
    city: "Maseru",
    countryId: "LS",
    timeZoneRegionName: "Africa/Maseru",
    latitude: -29.301389,
    longitude: 27.505556,
    icao: "FXMM"
  },
  MSV: {
    iata: "MSV",
    name: "Sullivan County International Airport",
    city: "Monticello",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.701389,
    longitude: -74.795,
    icao: "KMSV"
  },
  MSW: {
    iata: "MSW",
    name: "Massawa Airport",
    city: "Massawa",
    countryId: "ER",
    timeZoneRegionName: "Africa/Asmara",
    latitude: 15.603333,
    longitude: 39.441111,
    icao: "HHMS"
  },
  MSX: {
    iata: "MSX",
    name: "Mossendjo Airport",
    city: "Mossendjo",
    countryId: "CG",
    timeZoneRegionName: "Africa/Brazzaville",
    latitude: -2.95,
    longitude: 12.733333,
    icao: "FCMM"
  },
  MSY: {
    iata: "MSY",
    name: "Louis Armstrong New Orleans International Airport",
    city: "New Orleans",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 29.984564,
    longitude: -90.256391,
    icao: "KMSY"
  },
  MSZ: {
    iata: "MSZ",
    name: "Yuri Gagarin Airport",
    city: "Namibe",
    countryId: "AO",
    timeZoneRegionName: "Africa/Luanda",
    latitude: -15.258293,
    longitude: 12.150872,
    icao: "FNMO"
  },
  MTA: {
    iata: "MTA",
    name: "Matamata Glider Airport",
    city: "Matamata",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -37.737414,
    longitude: 175.743368,
    icao: "NZMA"
  },
  MTB: {
    iata: "MTB",
    name: "Montelibano Airport",
    city: "Montelibano",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 7.97538,
    longitude: -75.432769,
    icao: "SKML"
  },
  MTC: {
    iata: "MTC",
    name: "Selfridge Air National Guard Base",
    city: "Mount Clemens",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.610445,
    longitude: -82.836492,
    icao: "KMTC"
  },
  MTE: {
    iata: "MTE",
    name: "Monte Alegre Airport",
    city: "Monte Alegre",
    countryId: "BR",
    timeZoneRegionName: "America/Porto_Velho",
    latitude: -1.983333,
    longitude: -54.066667,
    icao: "SNMA"
  },
  MTF: {
    iata: "MTF",
    name: "Mizan Teferi Airport",
    city: "Mizan Teferi",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 6.966667,
    longitude: 35.533333,
    icao: "HAMT"
  },
  MTH: {
    iata: "MTH",
    name: "The Florida Keys Marathon Airport",
    city: "Marathon",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 24.726206,
    longitude: -81.050937,
    icao: "KMTH"
  },
  MTJ: {
    iata: "MTJ",
    name: "Montrose Regional Airport",
    city: "Montrose",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 38.510287,
    longitude: -107.896955,
    icao: "KMTJ"
  },
  MTK: {
    iata: "MTK",
    name: "Makin Airport",
    city: "Makin Island",
    countryId: "KI",
    timeZoneRegionName: "Pacific/Tarawa",
    latitude: 3,
    longitude: 174,
    icao: "NGMN"
  },
  MTL: {
    iata: "MTL",
    name: "Maitland Airport",
    city: "Maitland",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -32.733333,
    longitude: 151.55,
    icao: "YMND"
  },
  MTN: {
    iata: "MTN",
    name: "Martin State Airport",
    city: "Baltimore",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.321667,
    longitude: -76.411667,
    icao: "KMTN"
  },
  MTO: {
    iata: "MTO",
    name: "Coles County Memorial Airport",
    city: "Mattoon",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 39.478611,
    longitude: -88.278333,
    icao: "KMTO"
  },
  MTP: {
    iata: "MTP",
    name: "Montauk Airport",
    city: "Montauk Point",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.074444,
    longitude: -71.923611,
    icao: "KMTP"
  },
  MTQ: {
    iata: "MTQ",
    name: "Mitchell Airport",
    city: "Mitchell",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -26.583333,
    longitude: 147.966667,
    icao: "YMIT"
  },
  MTR: {
    iata: "MTR",
    name: "Los Garzones Airport",
    city: "Monteria",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 8.825035,
    longitude: -75.823923,
    icao: "SKMR"
  },
  MTS: {
    iata: "MTS",
    name: "Matsapha International Airport",
    city: "Manzini",
    countryId: "SZ",
    timeZoneRegionName: "Africa/Mbabane",
    latitude: -26.520331,
    longitude: 31.314132,
    icao: "FDMS"
  },
  MTT: {
    iata: "MTT",
    name: "Minatitlan Airport",
    city: "Minatitlan",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 17.983333,
    longitude: -94.516667,
    icao: "MMMT"
  },
  MTV: {
    iata: "MTV",
    name: "Mota Lava Airport",
    city: "Mota Lava",
    countryId: "VU",
    timeZoneRegionName: "Pacific/Efate",
    latitude: -13.666667,
    longitude: 167.666667,
    icao: "NVSA"
  },
  MTW: {
    iata: "MTW",
    name: "Manitowoc Municipal Airport",
    city: "Manitowoc",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 44.129722,
    longitude: -87.682222,
    icao: "KMTW"
  },
  MTY: {
    iata: "MTY",
    name: "Gen Mariano Escobedo Airport",
    city: "Monterrey",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 25.776569,
    longitude: -100.114395,
    icao: "MMMY"
  },
  MUA: {
    iata: "MUA",
    name: "Munda Airport",
    city: "Munda",
    countryId: "SB",
    timeZoneRegionName: "Pacific/Guadalcanal",
    latitude: -8.32794,
    longitude: 157.269712,
    icao: "AGGM"
  },
  MUB: {
    iata: "MUB",
    name: "Maun Airport",
    city: "Maun",
    countryId: "BW",
    timeZoneRegionName: "Africa/Gaborone",
    latitude: -19.970833,
    longitude: 23.430556,
    icao: "FBMN"
  },
  MUC: {
    iata: "MUC",
    name: "Franz Josef Strauss Airport",
    city: "Munich",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 48.353005,
    longitude: 11.790143,
    icao: "EDDM"
  },
  MUE: {
    iata: "MUE",
    name: "Kamuela Airport",
    city: "Kamuela",
    countryId: "US",
    timeZoneRegionName: "Pacific/Honolulu",
    latitude: 20.002464,
    longitude: -155.651457,
    icao: "PHMU"
  },
  MUH: {
    iata: "MUH",
    name: "Mersa Matruh Airport",
    city: "Mersa Matruh",
    countryId: "EG",
    timeZoneRegionName: "Africa/Cairo",
    latitude: 31.325123,
    longitude: 27.221652,
    icao: "HEMM"
  },
  MUI: {
    iata: "MUI",
    name: "Muir Aaf",
    city: "Ft Indiantown Gap",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.447583,
    longitude: -76.596611,
    icao: "KMUI"
  },
  MUK: {
    iata: "MUK",
    name: "Mauke Island Airport",
    city: "Mauke Island",
    countryId: "CK",
    timeZoneRegionName: "Pacific/Rarotonga",
    latitude: -19.333333,
    longitude: -158.5,
    icao: "NCMK"
  },
  MUL: {
    iata: "MUL",
    name: "Spence Airport",
    city: "Moultrie",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 31.183333,
    longitude: -83.783333,
    icao: "KMUL"
  },
  MUM: {
    iata: "MUM",
    name: "Muli Airport",
    city: "Muli",
    countryId: "MV",
    timeZoneRegionName: "Indian/Maldives",
    latitude: 2.91111111,
    longitude: 73.58361111,
    icao: ""
  },
  MUN: {
    iata: "MUN",
    name: "Jose Tadeo Monagas International Airport",
    city: "Maturin",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 9.749384,
    longitude: -63.156931,
    icao: "SVMT"
  },
  MUO: {
    iata: "MUO",
    name: "Mountain Home Air Force Base",
    city: "Mountain Home",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 43.043598,
    longitude: -115.872417,
    icao: "KMUO"
  },
  MUR: {
    iata: "MUR",
    name: "Marudi Airport",
    city: "Marudi",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 4.183333,
    longitude: 114.316667,
    icao: "WBGM"
  },
  MUT: {
    iata: "MUT",
    name: "Muscatine Airport",
    city: "Muscatine",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.366667,
    longitude: -91.145,
    icao: "KMUT"
  },
  MUU: {
    iata: "MUU",
    name: "Mount Union Airport",
    city: "Mount Union",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.383333,
    longitude: -77.883333,
    icao: "KMUU"
  },
  MUW: {
    iata: "MUW",
    name: "Ghriss Airport",
    city: "Ghriss",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 35.208533,
    longitude: 0.147669,
    icao: "DAOV"
  },
  MUX: {
    iata: "MUX",
    name: "Multan Airport",
    city: "Multan",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 30.199507,
    longitude: 71.414978,
    icao: "OPMT"
  },
  MUY: {
    iata: "MUY",
    name: "Mouyondzi Airport",
    city: "Mouyondzi",
    countryId: "CG",
    timeZoneRegionName: "Africa/Brazzaville",
    latitude: -3.983333,
    longitude: 13.919444,
    icao: "FCBM"
  },
  MUZ: {
    iata: "MUZ",
    name: "Musoma Airport",
    city: "Musoma",
    countryId: "TZ",
    timeZoneRegionName: "Africa/Dar_es_Salaam",
    latitude: -1.497311,
    longitude: 33.802545,
    icao: "HTMU"
  },
  MVB: {
    iata: "MVB",
    name: "M'Vengue El Hadj Omar Bongo Ondimba Intl Airport",
    city: "Franceville",
    countryId: "GA",
    timeZoneRegionName: "Africa/Libreville",
    latitude: -1.65,
    longitude: 13.433333,
    icao: "FOON"
  },
  MVC: {
    iata: "MVC",
    name: "Monroe County Airport",
    city: "Monroeville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 31.516667,
    longitude: -87.333333,
    icao: "KMVC"
  },
  MVD: {
    iata: "MVD",
    name: "Carrasco International Airport",
    city: "Montevideo",
    countryId: "UY",
    timeZoneRegionName: "America/Montevideo",
    latitude: -34.841154,
    longitude: -56.026466,
    icao: "SUMU"
  },
  MVE: {
    iata: "MVE",
    name: "Montevideo Municipal Airport",
    city: "Montevideo",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 44.95,
    longitude: -95.716667,
    icao: "KMVE"
  },
  MVF: {
    iata: "MVF",
    name: "Dix-Sept Rosado Airport",
    city: "Mossoro",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -5.201949,
    longitude: -37.364147,
    icao: "SBMS"
  },
  MVL: {
    iata: "MVL",
    name: "Morrisville-Stowe Airport",
    city: "Stowe",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 44.537403,
    longitude: -72.615433,
    icao: "KMVL"
  },
  MVN: {
    iata: "MVN",
    name: "Mount Vernon Airport",
    city: "Mount Vernon",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 38.323056,
    longitude: -88.858611,
    icao: "KMVN"
  },
  MVO: {
    iata: "MVO",
    name: "Mongo Airport",
    city: "Mongo",
    countryId: "TD",
    timeZoneRegionName: "Africa/Ndjamena",
    latitude: 12.2,
    longitude: 18.783333,
    icao: "FTTM"
  },
  MVP: {
    iata: "MVP",
    name: "Mitu Airport",
    city: "Mitu",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 1.133333,
    longitude: -70.05,
    icao: "SKMU"
  },
  MVQ: {
    iata: "MVQ",
    name: "Mogilev Airport",
    city: "Mogilev",
    countryId: "BY",
    timeZoneRegionName: "Europe/Minsk",
    latitude: 53.957457,
    longitude: 30.096425,
    icao: "UMOO"
  },
  MVR: {
    iata: "MVR",
    name: "Salak Airport",
    city: "Maroua",
    countryId: "CM",
    timeZoneRegionName: "Africa/Douala",
    latitude: 10.452222,
    longitude: 14.256389,
    icao: "FKKL"
  },
  MVT: {
    iata: "MVT",
    name: "Mataiva Airport",
    city: "Mataiva",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -14.833333,
    longitude: -148.416667,
    icao: "NTGV"
  },
  MVV: {
    iata: "MVV",
    name: "Megeve Airport",
    city: "Megeve",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 45.816667,
    longitude: 6.65,
    icao: "LFHM"
  },
  MVW: {
    iata: "MVW",
    name: "Skagit Regional Airport",
    city: "Mount Vernon",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 48.472747,
    longitude: -122.417975,
    icao: "KBVS"
  },
  MVX: {
    iata: "MVX",
    name: "Minvoul Airport",
    city: "Minvoul",
    countryId: "GA",
    timeZoneRegionName: "Africa/Libreville",
    latitude: 2.15,
    longitude: 12.133333,
    icao: "FOGV"
  },
  MVY: {
    iata: "MVY",
    name: "Martha's Vineyard Airport",
    city: "Martha's Vineyard",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.389335,
    longitude: -70.61182,
    icao: "KMVY"
  },
  MVZ: {
    iata: "MVZ",
    name: "Masvingo Airport",
    city: "Masvingo",
    countryId: "ZW",
    timeZoneRegionName: "Africa/Harare",
    latitude: -20.054167,
    longitude: 30.860556,
    icao: "FVMV"
  },
  MWA: {
    iata: "MWA",
    name: "Veterans Airport of Southern Illinois",
    city: "Marion",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 37.751944,
    longitude: -89.016389,
    icao: "KMWA"
  },
  MWB: {
    iata: "MWB",
    name: "Morawa Airport",
    city: "Morawa",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -29.204167,
    longitude: 116.0225,
    icao: "YMRW"
  },
  MWC: {
    iata: "MWC",
    name: "Lawrence J. Timmerman Airport",
    city: "Milwaukee",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 43.110636,
    longitude: -88.033293,
    icao: "KMWC"
  },
  MWE: {
    iata: "MWE",
    name: "Merowe Airport",
    city: "Merowe",
    countryId: "SD",
    timeZoneRegionName: "Africa/Khartoum",
    latitude: 18.442416,
    longitude: 31.840898,
    icao: "HSMR"
  },
  MWF: {
    iata: "MWF",
    name: "Maewo Airport",
    city: "Maewo",
    countryId: "VU",
    timeZoneRegionName: "Pacific/Efate",
    latitude: -15.166667,
    longitude: 168.166667,
    icao: "NVSN"
  },
  MWH: {
    iata: "MWH",
    name: "Grant County International Airport",
    city: "Moses Lake",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 47.205,
    longitude: -119.315556,
    icao: "KMWH"
  },
  MWK: {
    iata: "MWK",
    name: "Tarempa Airport",
    city: "Matak",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: 3.349249,
    longitude: 106.258179,
    icao: "WIOM"
  },
  MWL: {
    iata: "MWL",
    name: "Mineral Wells Airport",
    city: "Mineral Wells",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.783333,
    longitude: -98.066667,
    icao: "KMWL"
  },
  MWM: {
    iata: "MWM",
    name: "Windom Municipal Airport",
    city: "Windom",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 43.916667,
    longitude: -95.1,
    icao: "KMWM"
  },
  MWN: {
    iata: "MWN",
    name: "Mwadui Airport",
    city: "Mwadui",
    countryId: "TZ",
    timeZoneRegionName: "Africa/Dar_es_Salaam",
    latitude: -3.55,
    longitude: 33.6,
    icao: "HTMD"
  },
  MWO: {
    iata: "MWO",
    name: "Middletown Regional Airport",
    city: "Middletown",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.529251,
    longitude: -84.394168,
    icao: "KMWO"
  },
  MWQ: {
    iata: "MWQ",
    name: "Magwe Airport",
    city: "Magwe",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 20.166667,
    longitude: 94.941111,
    icao: "VYMW"
  },
  MWX: {
    iata: "MWX",
    name: "Muan International Airport",
    city: "Gwangju",
    countryId: "KR",
    timeZoneRegionName: "Asia/Seoul",
    latitude: 34.991406,
    longitude: 126.382814,
    icao: "RKJB"
  },
  MWZ: {
    iata: "MWZ",
    name: "Mwanza Airport",
    city: "Mwanza",
    countryId: "TZ",
    timeZoneRegionName: "Africa/Dar_es_Salaam",
    latitude: -2.441221,
    longitude: 32.923225,
    icao: "HTMW"
  },
  MXA: {
    iata: "MXA",
    name: "Manila Municipal Airport",
    city: "Manila",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.883333,
    longitude: -90.183333,
    icao: "KMXA"
  },
  MXE: {
    iata: "MXE",
    name: "Maxton Airport",
    city: "Maxton",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 34.716667,
    longitude: -79.333333,
    icao: "KMEB"
  },
  MXF: {
    iata: "MXF",
    name: "Maxwell Air Force Base",
    city: "Montgomery",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.382266,
    longitude: -86.365684,
    icao: "KMXF"
  },
  MXI: {
    iata: "MXI",
    name: "Mati Airport",
    city: "Mati",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 6.916667,
    longitude: 126.25,
    icao: "RPMQ"
  },
  MXJ: {
    iata: "MXJ",
    name: "Minna Airport",
    city: "Minna",
    countryId: "NG",
    timeZoneRegionName: "Africa/Lagos",
    latitude: 9.616667,
    longitude: 6.533333,
    icao: "DNMN"
  },
  MXL: {
    iata: "MXL",
    name: "Mexicali Airport",
    city: "Mexicali",
    countryId: "MX",
    timeZoneRegionName: "America/Tijuana",
    latitude: 32.6282,
    longitude: -115.248215,
    icao: "MMML"
  },
  MXM: {
    iata: "MXM",
    name: "Morombe Airport",
    city: "Morombe",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -21.751706,
    longitude: 43.375739,
    icao: "FMSR"
  },
  MXN: {
    iata: "MXN",
    name: "Morlaix Airport",
    city: "Morlaix",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 48.6,
    longitude: -3.816667,
    icao: "LFRU"
  },
  MXO: {
    iata: "MXO",
    name: "Monticello Municipal Airport",
    city: "Monticello",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 42.25,
    longitude: -91.2,
    icao: "KMXO"
  },
  MXP: {
    iata: "MXP",
    name: "Milano Malpensa Airport",
    city: "Milan",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 45.627405,
    longitude: 8.71237,
    icao: "LIMC"
  },
  MXQ: {
    iata: "MXQ",
    name: "Lorenzo Airport",
    city: "Cairu",
    countryId: "BR",
    timeZoneRegionName: "America/Bahia",
    latitude: -13.3894,
    longitude: -38.91,
    icao: ""
  },
  MXS: {
    iata: "MXS",
    name: "Maota Savall Island Airport",
    city: "Maota Savall Island",
    countryId: "WS",
    timeZoneRegionName: "Pacific/Apia",
    latitude: -13.716667,
    longitude: -172.233333,
    icao: "NSMA"
  },
  MXT: {
    iata: "MXT",
    name: "Maintirano Airport",
    city: "Maintirano",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -18.047778,
    longitude: 44.032778,
    icao: "FMMO"
  },
  MXU: {
    iata: "MXU",
    name: "Mullewa Airport",
    city: "Mullewa",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -28.55,
    longitude: 115.516667,
    icao: "YMWA"
  },
  MXV: {
    iata: "MXV",
    name: "Moron Airport",
    city: "Moron",
    countryId: "MN",
    timeZoneRegionName: "Asia/Ulaanbaatar",
    latitude: 49.663244,
    longitude: 100.095329,
    icao: "ZMMN"
  },
  MXX: {
    iata: "MXX",
    name: "Mora Airport",
    city: "Mora",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 60.958119,
    longitude: 14.504529,
    icao: "ESKM"
  },
  MXZ: {
    iata: "MXZ",
    name: "Mei Xian Airport",
    city: "Mei Xian",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 24.266812,
    longitude: 116.104491,
    icao: "ZGMX"
  },
  MYA: {
    iata: "MYA",
    name: "Moruya Airport",
    city: "Moruya",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -35.90251,
    longitude: 150.147172,
    icao: "YMRY"
  },
  MYB: {
    iata: "MYB",
    name: "Mayoumba Airport",
    city: "Mayoumba",
    countryId: "GA",
    timeZoneRegionName: "Africa/Libreville",
    latitude: -3.45,
    longitude: 10.683333,
    icao: "FOOY"
  },
  MYD: {
    iata: "MYD",
    name: "Malindi Airport",
    city: "Malindi",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: -3.230755,
    longitude: 40.100479,
    icao: "HKML"
  },
  MYE: {
    iata: "MYE",
    name: "Miyake Jima Airport",
    city: "Miyake Jima",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 34.069444,
    longitude: 139.5625,
    icao: "RJTQ"
  },
  MYF: {
    iata: "MYF",
    name: "Montgomery Field",
    city: "San Diego",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 32.815449,
    longitude: -117.135633,
    icao: "KMYF"
  },
  MYG: {
    iata: "MYG",
    name: "Mayaguana Airport",
    city: "Mayaguana",
    countryId: "BS",
    timeZoneRegionName: "America/Nassau",
    latitude: 22.376667,
    longitude: -73.018333,
    icao: "MYMM"
  },
  MYJ: {
    iata: "MYJ",
    name: "Matsuyama Airport",
    city: "Matsuyama",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 33.829102,
    longitude: 132.704058,
    icao: "RJOM"
  },
  MYL: {
    iata: "MYL",
    name: "Mc Call Airport",
    city: "Mc Call",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 44.916667,
    longitude: -116.1,
    icao: "KMYL"
  },
  MYN: {
    iata: "MYN",
    name: "Mareb Airport",
    city: "Mareb",
    countryId: "YE",
    timeZoneRegionName: "Asia/Aden",
    latitude: 15.483333,
    longitude: 45.333333,
    icao: "OYMB"
  },
  MYP: {
    iata: "MYP",
    name: "Mary Airport",
    city: "Mary",
    countryId: "TM",
    timeZoneRegionName: "Asia/Ashgabat",
    latitude: 37.664034,
    longitude: 61.829644,
    icao: "UTAM"
  },
  MYQ: {
    iata: "MYQ",
    name: "Mysore Airport",
    city: "Mysore",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 12.22886,
    longitude: 76.657727,
    icao: "VOMY"
  },
  MYR: {
    iata: "MYR",
    name: "Myrtle Beach International Airport",
    city: "Myrtle Beach",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 33.682676,
    longitude: -78.922944,
    icao: "KMYR"
  },
  MYT: {
    iata: "MYT",
    name: "Myitkyina Airport",
    city: "Myitkyina",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 25.384256,
    longitude: 97.356922,
    icao: "VYMK"
  },
  MYU: {
    iata: "MYU",
    name: "Ellis Field",
    city: "Mekoryuk",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 60.372778,
    longitude: -166.268056,
    icao: "PAMY"
  },
  MYV: {
    iata: "MYV",
    name: "Yuba County Airport",
    city: "Marysville",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 39.098056,
    longitude: -121.569722,
    icao: "KMYV"
  },
  MYW: {
    iata: "MYW",
    name: "Mtwara Airport",
    city: "Mtwara",
    countryId: "TZ",
    timeZoneRegionName: "Africa/Dar_es_Salaam",
    latitude: -10.338889,
    longitude: 40.193611,
    icao: "HTMT"
  },
  MYY: {
    iata: "MYY",
    name: "Miri Airport",
    city: "Miri",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 4.324112,
    longitude: 113.988106,
    icao: "WBGR"
  },
  MYZ: {
    iata: "MYZ",
    name: "Monkey Bay Airport",
    city: "Monkey Bay",
    countryId: "MW",
    timeZoneRegionName: "Africa/Blantyre",
    latitude: -14.1,
    longitude: 34.533333,
    icao: "FWMY"
  },
  MZA: {
    iata: "MZA",
    name: "Manuel Prado Airport",
    city: "Mazamari",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -11.3254,
    longitude: -74.535599,
    icao: "SPMF"
  },
  MZB: {
    iata: "MZB",
    name: "Mocimboa da Praia Airport",
    city: "Mocimboa da Praia",
    countryId: "MZ",
    timeZoneRegionName: "Africa/Maputo",
    latitude: -11.360261,
    longitude: 40.356075,
    icao: "FQMP"
  },
  MZC: {
    iata: "MZC",
    name: "Mitzic Airport",
    city: "Mitzic",
    countryId: "GA",
    timeZoneRegionName: "Africa/Libreville",
    latitude: 0.783333,
    longitude: 11.566667,
    icao: "FOOM"
  },
  MZG: {
    iata: "MZG",
    name: "Penghu Airport",
    city: "Magong",
    countryId: "TW",
    timeZoneRegionName: "Asia/Taipei",
    latitude: 23.560451,
    longitude: 119.6295,
    icao: "RCQC"
  },
  MZH: {
    iata: "MZH",
    name: "Merzifon Airport",
    city: "Merzifon",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 40.883333,
    longitude: 35.533333,
    icao: "LTAP"
  },
  MZI: {
    iata: "MZI",
    name: "Ambodedjo Airport",
    city: "Mopti",
    countryId: "ML",
    timeZoneRegionName: "Africa/Bamako",
    latitude: 14.512805,
    longitude: -4.079561,
    icao: "GAMB"
  },
  MZJ: {
    iata: "MZJ",
    name: "Pinal Airpark",
    city: "Marana",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 32.510705,
    longitude: -111.322337,
    icao: "KMZJ"
  },
  MZK: {
    iata: "MZK",
    name: "Marakei Airport",
    city: "Marakei",
    countryId: "KI",
    timeZoneRegionName: "Pacific/Tarawa",
    latitude: 1.983333,
    longitude: 173.666667,
    icao: "NGMK"
  },
  MZL: {
    iata: "MZL",
    name: "La Nubia Airport",
    city: "Manizales",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 5.029005,
    longitude: -75.468782,
    icao: "SKMZ"
  },
  MZM: {
    iata: "MZM",
    name: "Frescaty Airport",
    city: "Metz",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 49.0725,
    longitude: 6.134444,
    icao: "LFSF"
  },
  MZO: {
    iata: "MZO",
    name: "Sierra Maestra Airport",
    city: "Manzanillo",
    countryId: "CU",
    timeZoneRegionName: "America/Havana",
    latitude: 20.325,
    longitude: -77.128889,
    icao: "MUMZ"
  },
  MZP: {
    iata: "MZP",
    name: "Motueka Airport",
    city: "Motueka",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -41.122883,
    longitude: 172.991693,
    icao: "NZMK"
  },
  MZQ: {
    iata: "MZQ",
    name: "Mkuze Airport",
    city: "Mkuze",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -27.623335,
    longitude: 32.045906,
    icao: "FAMU"
  },
  MZR: {
    iata: "MZR",
    name: "Mazar-I-Sharif Airport",
    city: "Mazar-I-Sharif",
    countryId: "AF",
    timeZoneRegionName: "Asia/Kabul",
    latitude: 36.709192,
    longitude: 67.208485,
    icao: "OAMS"
  },
  MZT: {
    iata: "MZT",
    name: "Mazatlan International Airport",
    city: "Mazatlan",
    countryId: "MX",
    timeZoneRegionName: "America/Mazatlan",
    latitude: 23.167314,
    longitude: -106.270148,
    icao: "MMMZ"
  },
  MZU: {
    iata: "MZU",
    name: "Muzaffarpur Airport",
    city: "Muzaffarpur",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 26.116667,
    longitude: 85.383333,
    icao: "VEMZ"
  },
  MZV: {
    iata: "MZV",
    name: "Mulu Airport",
    city: "Mulu",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 4.033333,
    longitude: 114.8,
    icao: "WBFC"
  },
  MZW: {
    iata: "MZW",
    name: "Mechria Airport",
    city: "Mechria",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 33.5354,
    longitude: -0.242177,
    icao: "DAAY"
  },
  MZX: {
    iata: "MZX",
    name: "Mena Airport",
    city: "Mena",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 6.35,
    longitude: 39.716667,
    icao: "HAML"
  },
  MZZ: {
    iata: "MZZ",
    name: "Marion Airport",
    city: "Marion",
    countryId: "US",
    timeZoneRegionName: "America/Indiana/Indianapolis",
    latitude: 40.490833,
    longitude: -85.679444,
    icao: "KMZZ"
  },
  NAA: {
    iata: "NAA",
    name: "Narrabri Airport",
    city: "Narrabri",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -30.31829,
    longitude: 149.82912,
    icao: "YNBR"
  },
  NAC: {
    iata: "NAC",
    name: "Naracoorte Airport",
    city: "Naracoorte",
    countryId: "AU",
    timeZoneRegionName: "Australia/Adelaide",
    latitude: -36.979112,
    longitude: 140.72714,
    icao: "YNRC"
  },
  NAE: {
    iata: "NAE",
    name: "Natitingou Airport",
    city: "Natitingou",
    countryId: "BJ",
    timeZoneRegionName: "Africa/Porto-Novo",
    latitude: 10.383333,
    longitude: 1.366667,
    icao: "DBBN"
  },
  NAG: {
    iata: "NAG",
    name: "Dr. Babasaheb Ambedkar International Airport",
    city: "Nagpur",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 21.090037,
    longitude: 79.05636,
    icao: "VANP"
  },
  NAI: {
    iata: "NAI",
    name: "Annai Airport",
    city: "Annai",
    countryId: "GY",
    timeZoneRegionName: "America/Guyana",
    latitude: 3.75,
    longitude: -59,
    icao: "SYAN"
  },
  NAJ: {
    iata: "NAJ",
    name: "Nakhchivan International Airport",
    city: "Nakhchivan",
    countryId: "AZ",
    timeZoneRegionName: "Asia/Baku",
    latitude: 39.188611,
    longitude: 45.458333,
    icao: "UBBN"
  },
  NAK: {
    iata: "NAK",
    name: "Nakhon Ratchasima Airport",
    city: "Nakhon Ratchasima",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 14.950625,
    longitude: 102.314112,
    icao: "VTUQ"
  },
  NAL: {
    iata: "NAL",
    name: "Nalchik Airport",
    city: "Nalchik",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 43.533333,
    longitude: 43.7,
    icao: "URMN"
  },
  NAM: {
    iata: "NAM",
    name: "Namlea Airport",
    city: "Namlea",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jayapura",
    latitude: -3.237134,
    longitude: 127.100235,
    icao: "WAPR"
  },
  NAN: {
    iata: "NAN",
    name: "Nadi International Airport",
    city: "Nadi",
    countryId: "FJ",
    timeZoneRegionName: "Pacific/Fiji",
    latitude: -17.75327,
    longitude: 177.451607,
    icao: "NFFN"
  },
  NAO: {
    iata: "NAO",
    name: "Nanchong Gaoping Airport",
    city: "Nanchong",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 30.8,
    longitude: 106.066667,
    icao: "ZUNC"
  },
  NAP: {
    iata: "NAP",
    name: "Naples International Airport",
    city: "Naples",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 40.886111,
    longitude: 14.291667,
    icao: "LIRN"
  },
  NAQ: {
    iata: "NAQ",
    name: "Qaanaaq Airport",
    city: "Qaanaaq",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 77.488644,
    longitude: -69.388676,
    icao: ""
  },
  NAS: {
    iata: "NAS",
    name: "Lynden Pindling International Airport",
    city: "Nassau",
    countryId: "BS",
    timeZoneRegionName: "America/Nassau",
    latitude: 25.050419,
    longitude: -77.466499,
    icao: "MYNN"
  },
  NAT: {
    iata: "NAT",
    name: "Sao Goncalo do Amarante-Governador Aluizio Alves Intl Airport",
    city: "Natal",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -5.76339,
    longitude: -35.372976,
    icao: "SBSG"
  },
  NAU: {
    iata: "NAU",
    name: "Napuka Island Airport",
    city: "Napuka Island",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -14.166667,
    longitude: -141.583333,
    icao: "NTGN"
  },
  NAV: {
    iata: "NAV",
    name: "Nevsehir Airport",
    city: "Nevsehir",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 38.633333,
    longitude: 34.716667,
    icao: "LTAZ"
  },
  NAW: {
    iata: "NAW",
    name: "Narathiwat Airport",
    city: "Narathiwat",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 6.516667,
    longitude: 101.75,
    icao: "VTSC"
  },
  NBC: {
    iata: "NBC",
    name: "Begishevo Airport",
    city: "Naberezhnye Chelny",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 55.565785,
    longitude: 52.101637,
    icao: "UWKE"
  },
  NBE: {
    iata: "NBE",
    name: "Enfidha - Hammamet International Airport",
    city: "Enfidha",
    countryId: "TN",
    timeZoneRegionName: "Africa/Tunis",
    latitude: 36.08326,
    longitude: 10.438738,
    icao: "DTNH"
  },
  NBG: {
    iata: "NBG",
    name: "Naval Air Station/Alvin Callendar",
    city: "New Orleans",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 29.830831,
    longitude: -90.02336,
    icao: "KNBG"
  },
  NBJ: {
    iata: "NBJ",
    name: "Dr. Antonio Agostinho Neto International Airport",
    city: "Luanda",
    countryId: "AO",
    timeZoneRegionName: "Africa/Luanda",
    latitude: -9.0467,
    longitude: 13.5067,
    icao: "FNBJ"
  },
  NBN: {
    iata: "NBN",
    name: "Annobon Airport",
    city: "Annobon",
    countryId: "GQ",
    timeZoneRegionName: "Africa/Malabo",
    latitude: -1.410277,
    longitude: 5.621944,
    icao: "FGAN"
  },
  NBO: {
    iata: "NBO",
    name: "Jomo Kenyatta International Airport",
    city: "Nairobi",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: -1.319167,
    longitude: 36.925781,
    icao: "HKJK"
  },
  NBS: {
    iata: "NBS",
    name: "Baishan Changbaishan Airport",
    city: "Baishan",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 42.083332,
    longitude: 127.6,
    icao: ""
  },
  NBW: {
    iata: "NBW",
    name: "Guantanamo Bay Naval Station",
    city: "Guantanamo",
    countryId: "CU",
    timeZoneRegionName: "America/Havana",
    latitude: 19.909212,
    longitude: -75.209294,
    icao: "MUGM"
  },
  NBX: {
    iata: "NBX",
    name: "Nabire Airport",
    city: "Nabire",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jayapura",
    latitude: -3.366667,
    longitude: 135.433333,
    icao: "WABI"
  },
  NCA: {
    iata: "NCA",
    name: "North Caicos Airport",
    city: "North Caicos",
    countryId: "TC",
    timeZoneRegionName: "America/Grand_Turk",
    latitude: 21.933333,
    longitude: -71.983333,
    icao: "MBNC"
  },
  NCE: {
    iata: "NCE",
    name: "Cote D'Azur Airport",
    city: "Nice",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 43.660488,
    longitude: 7.205232,
    icao: "LFMN"
  },
  NCG: {
    iata: "NCG",
    name: "Nueva Casas Grandes Airport",
    city: "Nueva Casas Grandes",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 30.416667,
    longitude: -107.916667,
    icao: "MMCG"
  },
  NCH: {
    iata: "NCH",
    name: "Nachingwea Airport",
    city: "Nachingwea",
    countryId: "TZ",
    timeZoneRegionName: "Africa/Dar_es_Salaam",
    latitude: -10.363889,
    longitude: 38.775,
    icao: "HTNA"
  },
  NCI: {
    iata: "NCI",
    name: "Necocli Airport",
    city: "Necocli",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 8.483333,
    longitude: -76.75,
    icao: "SKNC"
  },
  NCJ: {
    iata: "NCJ",
    name: "Sunchales Aeroclub Airport",
    city: "Sunchales",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Cordoba",
    latitude: -30.956625,
    longitude: -61.533459,
    icao: "SAFS"
  },
  NCL: {
    iata: "NCL",
    name: "Newcastle International Airport",
    city: "Newcastle",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 55.037062,
    longitude: -1.710629,
    icao: "EGNT"
  },
  NCS: {
    iata: "NCS",
    name: "Newcastle Airport",
    city: "Newcastle",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -27.774167,
    longitude: 29.99,
    icao: "FANC"
  },
  NCU: {
    iata: "NCU",
    name: "Nukus Airport",
    city: "Nukus",
    countryId: "UZ",
    timeZoneRegionName: "Asia/Tashkent",
    latitude: 42.483333,
    longitude: 59.633333,
    icao: "UTNN"
  },
  NCY: {
    iata: "NCY",
    name: "Annecy-Meythet Airport",
    city: "Annecy",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 45.930556,
    longitude: 6.100833,
    icao: "LFLP"
  },
  NDB: {
    iata: "NDB",
    name: "Nouadhibou Airport",
    city: "Nouadhibou",
    countryId: "MR",
    timeZoneRegionName: "Africa/Nouakchott",
    latitude: 20.934167,
    longitude: -17.028333,
    icao: "GQPP"
  },
  NDC: {
    iata: "NDC",
    name: "Nanded Airport",
    city: "Nanded",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 19.183333,
    longitude: 77.316667,
    icao: "VAND"
  },
  NDD: {
    iata: "NDD",
    name: "Sumbe Airport",
    city: "Sumbe",
    countryId: "AO",
    timeZoneRegionName: "Africa/Luanda",
    latitude: -11.166667,
    longitude: 13.866667,
    icao: "FNSU"
  },
  NDE: {
    iata: "NDE",
    name: "Mandera Airport",
    city: "Mandera",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: 3.933333,
    longitude: 41.866667,
    icao: "HKMA"
  },
  NDG: {
    iata: "NDG",
    name: "Qiqihar Sanjiazi Airport",
    city: "Qiqihar",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 47.316667,
    longitude: 123.916667,
    icao: "ZYQQ"
  },
  NDJ: {
    iata: "NDJ",
    name: "Ndjamena Airport",
    city: "Ndjamena",
    countryId: "TD",
    timeZoneRegionName: "Africa/Ndjamena",
    latitude: 12.129056,
    longitude: 15.034215,
    icao: "FTTJ"
  },
  NDL: {
    iata: "NDL",
    name: "Ndele Airport",
    city: "Ndele",
    countryId: "CF",
    timeZoneRegionName: "Africa/Bangui",
    latitude: 8.416667,
    longitude: 20.6,
    icao: "FEFN"
  },
  NDM: {
    iata: "NDM",
    name: "Mendi Airport",
    city: "Mendi",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 9.816667,
    longitude: 35.083333,
    icao: "HAMN"
  },
  NDR: {
    iata: "NDR",
    name: "Nador International Airport",
    city: "Nador",
    countryId: "MA",
    timeZoneRegionName: "Africa/Casablanca",
    latitude: 34.992863,
    longitude: -3.026172,
    icao: "GMMW"
  },
  NDU: {
    iata: "NDU",
    name: "Rundu Airport",
    city: "Rundu",
    countryId: "NA",
    timeZoneRegionName: "Africa/Windhoek",
    latitude: -17.955779,
    longitude: 19.723513,
    icao: "FYRU"
  },
  NDZ: {
    iata: "NDZ",
    name: "Cuxhaven Airport",
    city: "Nordholz-Spieka",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 53.768611,
    longitude: 8.644722,
    icao: "EDXN"
  },
  NEC: {
    iata: "NEC",
    name: "Necochea Airport",
    city: "Necochea",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -38.566667,
    longitude: -58.75,
    icao: "SAZO"
  },
  NEG: {
    iata: "NEG",
    name: "Negril Airport",
    city: "Negril",
    countryId: "JM",
    timeZoneRegionName: "America/Jamaica",
    latitude: 18.308333,
    longitude: -78.333333,
    icao: "MKNG"
  },
  NEI: {
    iata: "NEI",
    name: "Terney Airport",
    city: "Terney",
    countryId: "RU",
    timeZoneRegionName: "Asia/Vladivostok",
    latitude: 45.083056,
    longitude: 136.590556,
    icao: ""
  },
  NEJ: {
    iata: "NEJ",
    name: "Nejjo Airport",
    city: "Nejjo",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 9.5,
    longitude: 35.466667,
    icao: "HANJ"
  },
  NEK: {
    iata: "NEK",
    name: "Nekemt Airport",
    city: "Nekemt",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 9.066667,
    longitude: 36.5,
    icao: "HANK"
  },
  NEL: {
    iata: "NEL",
    name: "Naec Airport",
    city: "Lakehurst",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.016667,
    longitude: -74.316667,
    icao: "KNEL"
  },
  NER: {
    iata: "NER",
    name: "Chulman Neryungri Airport",
    city: "Neryungri",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yakutsk",
    latitude: 56.913898,
    longitude: 124.914001,
    icao: "UELL"
  },
  NEU: {
    iata: "NEU",
    name: "Sam Neua Airport",
    city: "Sam Neua",
    countryId: "LA",
    timeZoneRegionName: "Asia/Vientiane",
    latitude: 20.419033,
    longitude: 104.067893,
    icao: "VLSN"
  },
  NEV: {
    iata: "NEV",
    name: "Newcastle Airport",
    city: "Nevis",
    countryId: "KN",
    timeZoneRegionName: "America/St_Kitts",
    latitude: 17.205,
    longitude: -62.5925,
    icao: "TKPN"
  },
  NEW: {
    iata: "NEW",
    name: "Lakefront Airport",
    city: "New Orleans",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.0424,
    longitude: -90.028297,
    icao: "KNEW"
  },
  NFL: {
    iata: "NFL",
    name: "Naval Air Station",
    city: "Fallon",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 39.416599,
    longitude: -118.700996,
    icao: "KNFL"
  },
  NFO: {
    iata: "NFO",
    name: "Mata'aho Airport",
    city: "Niuafo'ou",
    countryId: "TO",
    timeZoneRegionName: "Pacific/Tongatapu",
    latitude: -15.570655,
    longitude: -175.632804,
    icao: "NFTO"
  },
  NGA: {
    iata: "NGA",
    name: "Young Airport",
    city: "Young",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -34.25,
    longitude: 148.25,
    icao: "YYNG"
  },
  NGB: {
    iata: "NGB",
    name: "Ningbo Lishe International Airport",
    city: "Ningbo",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 29.826696,
    longitude: 121.462002,
    icao: "ZSNB"
  },
  NGD: {
    iata: "NGD",
    name: "Auguste George Airport",
    city: "Anegada",
    countryId: "VG",
    timeZoneRegionName: "America/Tortola",
    latitude: 18.727395,
    longitude: -64.330057,
    icao: "TUPA"
  },
  NGE: {
    iata: "NGE",
    name: "Ngaoundere Airport",
    city: "Ngaoundere",
    countryId: "CM",
    timeZoneRegionName: "Africa/Douala",
    latitude: 7.359071,
    longitude: 13.561862,
    icao: "FKKN"
  },
  NGF: {
    iata: "NGF",
    name: "Kaneohe Bay Marine Corps Air Station",
    city: "Mokapu",
    countryId: "US",
    timeZoneRegionName: "Pacific/Honolulu",
    latitude: 21.449229,
    longitude: -157.769446,
    icao: "PHNG"
  },
  NGI: {
    iata: "NGI",
    name: "Ngau Island Airport",
    city: "Ngau Island",
    countryId: "FJ",
    timeZoneRegionName: "Pacific/Fiji",
    latitude: -18,
    longitude: 179.333333,
    icao: "NFNG"
  },
  NGK: {
    iata: "NGK",
    name: "Nogliki Airport",
    city: "Nogliki",
    countryId: "RU",
    timeZoneRegionName: "Asia/Sakhalin",
    latitude: 51.784636,
    longitude: 143.142505,
    icao: "UHSN"
  },
  NGL: {
    iata: "NGL",
    name: "Ngala Airfield",
    city: "Ngala",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -24.38705,
    longitude: 31.324125,
    icao: "FANG"
  },
  NGO: {
    iata: "NGO",
    name: "Chubu Centrair International Airport",
    city: "Nagoya",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 34.858333,
    longitude: 136.805278,
    icao: "RJGG"
  },
  NGP: {
    iata: "NGP",
    name: "Corpus Christi Naval Air Station (Truax Field)",
    city: "Corpus Christi",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 27.7,
    longitude: -97.283333,
    icao: "KNGP"
  },
  NGQ: {
    iata: "NGQ",
    name: "Ngari Gunsa/Ali Kunsha Airport",
    city: "Shi Quan He",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 32.103817,
    longitude: 80.054276,
    icao: "ZUAL"
  },
  NGS: {
    iata: "NGS",
    name: "Nagasaki Airport",
    city: "Nagasaki",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 32.914398,
    longitude: 129.92257,
    icao: "RJFU"
  },
  NGU: {
    iata: "NGU",
    name: "Naval Station Norfolk",
    city: "Norfolk",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 36.940781,
    longitude: -76.29248,
    icao: "KNGU"
  },
  NGX: {
    iata: "NGX",
    name: "Manang Airport",
    city: "Manang",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 28.64121,
    longitude: 84.088033,
    icao: "VNMA"
  },
  NHA: {
    iata: "NHA",
    name: "Nha Trang Airport",
    city: "Nha Trang",
    countryId: "VN",
    timeZoneRegionName: "Asia/Ho_Chi_Minh",
    latitude: 12.227912,
    longitude: 109.196662,
    icao: "VVNT"
  },
  NHF: {
    iata: "NHF",
    name: "New Halfa Airport",
    city: "New Halfa",
    countryId: "SD",
    timeZoneRegionName: "Africa/Khartoum",
    latitude: 15.35,
    longitude: 35.733333,
    icao: "HSNW"
  },
  NHK: {
    iata: "NHK",
    name: "Naval Air Station",
    city: "Patuxent River",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 38.3,
    longitude: -76.433333,
    icao: "KNHK"
  },
  NHT: {
    iata: "NHT",
    name: "Northolt Airport",
    city: "Northolt",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.547257,
    longitude: -0.41452,
    icao: "EGWU"
  },
  NHV: {
    iata: "NHV",
    name: "Nuku Hiva Airport",
    city: "Nuku Hiva",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Marquesas",
    latitude: -8.795214,
    longitude: -140.222224,
    icao: "NTMD"
  },
  NHZ: {
    iata: "NHZ",
    name: "Brunswick Executive Airport",
    city: "Brunswick",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 43.892289,
    longitude: -69.937591,
    icao: "KNHZ"
  },
  NIA: {
    iata: "NIA",
    name: "Nimba Airport",
    city: "Nimba",
    countryId: "LR",
    timeZoneRegionName: "Africa/Monrovia",
    latitude: 7.491111,
    longitude: -8.591667,
    icao: "GLNA"
  },
  NIF: {
    iata: "NIF",
    name: "Nifty Airport",
    city: "Nifty",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -21.670777,
    longitude: 121.588067,
    icao: "YCNF"
  },
  NIG: {
    iata: "NIG",
    name: "Nikunau Airport",
    city: "Nikunau",
    countryId: "KI",
    timeZoneRegionName: "Pacific/Tarawa",
    latitude: -1.333333,
    longitude: 176.416667,
    icao: "NGNU"
  },
  NIM: {
    iata: "NIM",
    name: "Niamey Airport",
    city: "Niamey",
    countryId: "NE",
    timeZoneRegionName: "Africa/Niamey",
    latitude: 13.476534,
    longitude: 2.177158,
    icao: "DRRN"
  },
  NIO: {
    iata: "NIO",
    name: "Nioki Airport",
    city: "Nioki",
    countryId: "CD",
    timeZoneRegionName: "Africa/Kinshasa",
    latitude: -2.75,
    longitude: 17.7,
    icao: "FZBI"
  },
  NIP: {
    iata: "NIP",
    name: "NAS (Towers Field)",
    city: "Jacksonville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 30.234314,
    longitude: -81.675612,
    icao: "KNIP"
  },
  NIQ: {
    iata: "NIQ",
    name: "Niaqornat Heliport",
    city: "Niaqornat",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 70.789442,
    longitude: -53.656142,
    icao: "BGNT"
  },
  NIT: {
    iata: "NIT",
    name: "Niort Airport",
    city: "Niort",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 46.316667,
    longitude: -0.45,
    icao: "LFBN"
  },
  NIU: {
    iata: "NIU",
    name: "Niau Airport",
    city: "Fakarava Niau",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -16.119094,
    longitude: -146.3683,
    icao: "NTKN"
  },
  NIX: {
    iata: "NIX",
    name: "Nioro Airport",
    city: "Nioro",
    countryId: "ML",
    timeZoneRegionName: "Africa/Bamako",
    latitude: 15.239167,
    longitude: -9.577222,
    icao: "GANR"
  },
  NJA: {
    iata: "NJA",
    name: "Atsugi Naval Air Field",
    city: "Atsugi",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 35.454603,
    longitude: 139.450174,
    icao: "RJTA"
  },
  NJC: {
    iata: "NJC",
    name: "Nizhnevartovsk Airport",
    city: "Nizhnevartovsk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yekaterinburg",
    latitude: 60.947603,
    longitude: 76.491447,
    icao: "USNN"
  },
  NJF: {
    iata: "NJF",
    name: "Al-Ashraf International Airport",
    city: "Al-Najaf",
    countryId: "IQ",
    timeZoneRegionName: "Asia/Baghdad",
    latitude: 31.989792,
    longitude: 44.404576,
    icao: "ORNI"
  },
  NJK: {
    iata: "NJK",
    name: "Navy Air Facility El Centro",
    city: "El Centro",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 32.822125,
    longitude: -115.661315,
    icao: "KNJK"
  },
  NKC: {
    iata: "NKC",
    name: "Nouakchott International Airport",
    city: "Nouakchott",
    countryId: "MR",
    timeZoneRegionName: "Africa/Nouakchott",
    latitude: 18.305687,
    longitude: -15.967166,
    icao: "GQNN"
  },
  NKG: {
    iata: "NKG",
    name: "Nanjing Lukou International Airport",
    city: "Nanjing",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 31.735737,
    longitude: 118.86652,
    icao: "ZSNJ"
  },
  NKJ: {
    iata: "NKJ",
    name: "Nanjing South Railway Station",
    city: "Ningnan",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 31.968789,
    longitude: 118.798537,
    icao: ""
  },
  NKM: {
    iata: "NKM",
    name: "Nagoya Airport",
    city: "Nagoya",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 35.253892,
    longitude: 136.919572,
    icao: "RJNA"
  },
  NKT: {
    iata: "NKT",
    name: "Sirnak Airport",
    city: "Cizre",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 37.363333,
    longitude: 42.059722,
    icao: "LTCV"
  },
  NKX: {
    iata: "NKX",
    name: "Marine Corps Air Station Miramar",
    city: "San Diego",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 32.867945,
    longitude: -117.134429,
    icao: "KNKX"
  },
  NKY: {
    iata: "NKY",
    name: "Nkayi Airport",
    city: "Nkayi",
    countryId: "CG",
    timeZoneRegionName: "Africa/Brazzaville",
    latitude: -4.216667,
    longitude: 13.3,
    icao: "FCBY"
  },
  NLA: {
    iata: "NLA",
    name: "Simon Mwansa Kapwepwe International Airport",
    city: "Ndola",
    countryId: "ZM",
    timeZoneRegionName: "Africa/Lusaka",
    latitude: -12.993449,
    longitude: 28.665024,
    icao: "FLND"
  },
  NLC: {
    iata: "NLC",
    name: "Naval Air Station/Reeves Field",
    city: "Lemoore",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 36.3,
    longitude: -119.766667,
    icao: "KNLC"
  },
  NLD: {
    iata: "NLD",
    name: "Quetzalcoatl International Airport",
    city: "Nuevo Laredo",
    countryId: "MX",
    timeZoneRegionName: "America/Matamoros",
    latitude: 27.443702,
    longitude: -99.570128,
    icao: "MMNL"
  },
  NLF: {
    iata: "NLF",
    name: "Darnley Island Airport",
    city: "Darnley Island",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -9.579122,
    longitude: 143.780203,
    icao: "YDNI"
  },
  NLG: {
    iata: "NLG",
    name: "Nelson Lagoon Airport",
    city: "Nelson Lagoon",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 56.007536,
    longitude: -161.160367,
    icao: "PAOU"
  },
  NLH: {
    iata: "NLH",
    name: "Ninglang Luguhu Airport",
    city: "Ninglang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 27.542558,
    longitude: 100.759323,
    icao: ""
  },
  NLI: {
    iata: "NLI",
    name: "Nikolayevsk-na-Amure Airport",
    city: "Nikolayevsk-na-Amure",
    countryId: "RU",
    timeZoneRegionName: "Asia/Vladivostok",
    latitude: 53.154167,
    longitude: 140.651111,
    icao: "UHNN"
  },
  NLK: {
    iata: "NLK",
    name: "Norfolk Island Airport",
    city: "Norfolk Island",
    countryId: "NF",
    timeZoneRegionName: "Pacific/Norfolk",
    latitude: -29.0425,
    longitude: 167.939444,
    icao: "YSNF"
  },
  NLL: {
    iata: "NLL",
    name: "Nullagine Airport",
    city: "Nullagine",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -21.75,
    longitude: 120.2,
    icao: "YNUL"
  },
  NLO: {
    iata: "NLO",
    name: "N'Dolo Airport",
    city: "Kinshasa",
    countryId: "CD",
    timeZoneRegionName: "Africa/Kinshasa",
    latitude: -4.325,
    longitude: 15.326389,
    icao: "FZAB"
  },
  NLP: {
    iata: "NLP",
    name: "Nelspruit Airport",
    city: "Nelspruit",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -25.500833,
    longitude: 30.913889,
    icao: "FANS"
  },
  NLT: {
    iata: "NLT",
    name: "Nalati Airport",
    city: "Xinyuan",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 43.43222,
    longitude: 83.382225,
    icao: "ZWNL"
  },
  NLU: {
    iata: "NLU",
    name: "Felipe \xC1ngeles International Airport",
    city: "Santa Luc\xEDa",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 19.756667,
    longitude: -99.015278,
    icao: "MMSM"
  },
  NLV: {
    iata: "NLV",
    name: "Nikolaev Airport",
    city: "Nikolaev",
    countryId: "UA",
    timeZoneRegionName: "Europe/Kiev",
    latitude: 47.05,
    longitude: 31.916667,
    icao: "UKON"
  },
  NMA: {
    iata: "NMA",
    name: "Namangan Airport",
    city: "Namangan",
    countryId: "UZ",
    timeZoneRegionName: "Asia/Tashkent",
    latitude: 40.983981,
    longitude: 71.574846,
    icao: "UTFN"
  },
  NME: {
    iata: "NME",
    name: "Nightmute Airport",
    city: "Nightmute",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 60.471047,
    longitude: -164.700838,
    icao: "PAGT"
  },
  NMF: {
    iata: "NMF",
    name: "Maafaru International Airport",
    city: "Maafaru",
    countryId: "MV",
    timeZoneRegionName: "Indian/Maldives",
    latitude: 5.818333,
    longitude: 73.469444,
    icao: ""
  },
  NMI: {
    iata: "NMI",
    name: "Navi Mumbai International Airport",
    city: "Mumbai",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 18.985945,
    longitude: 73.072215,
    icao: "VANM"
  },
  NMR: {
    iata: "NMR",
    name: "Nappamerry Airport",
    city: "Nappamerry",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -27.6,
    longitude: 141.116667,
    icao: "YNAP"
  },
  NMS: {
    iata: "NMS",
    name: "Namsang Airport",
    city: "Namsang",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 20.890685,
    longitude: 97.735926,
    icao: "VYNS"
  },
  NNB: {
    iata: "NNB",
    name: "Santa Ana Island Airport",
    city: "Santa Ana",
    countryId: "SB",
    timeZoneRegionName: "Pacific/Guadalcanal",
    latitude: -10.833333,
    longitude: 162.5,
    icao: "AGGT"
  },
  NNG: {
    iata: "NNG",
    name: "Nanning Airport",
    city: "Nanning",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 22.61321,
    longitude: 108.167501,
    icao: "ZGNN"
  },
  NNI: {
    iata: "NNI",
    name: "Namutoni Airport",
    city: "Namutoni",
    countryId: "NA",
    timeZoneRegionName: "Africa/Windhoek",
    latitude: -18.816667,
    longitude: 16.916667,
    icao: "FYNA"
  },
  NNL: {
    iata: "NNL",
    name: "Nondalton Airport",
    city: "Nondalton",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 59.978528,
    longitude: -154.837769,
    icao: ""
  },
  NNM: {
    iata: "NNM",
    name: "Naryan-Mar Airport",
    city: "Naryan-Mar",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 67.616667,
    longitude: 53.15,
    icao: "ULAM"
  },
  NNR: {
    iata: "NNR",
    name: "Connemara Airport",
    city: "Spiddal",
    countryId: "IE",
    timeZoneRegionName: "Europe/Dublin",
    latitude: 53.216667,
    longitude: -9.466667,
    icao: "EICA"
  },
  NNT: {
    iata: "NNT",
    name: "Nan Airport",
    city: "Nan",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 18.8,
    longitude: 100.783333,
    icao: "VTCN"
  },
  NNU: {
    iata: "NNU",
    name: "Nanuque Airport",
    city: "Nanuque",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -17.816667,
    longitude: -40.333333,
    icao: "SNNU"
  },
  NNX: {
    iata: "NNX",
    name: "Nunukan Airport",
    city: "Nunukan",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: 4.136772,
    longitude: 117.667141,
    icao: "WALF"
  },
  NNY: {
    iata: "NNY",
    name: "Nanyang Airport",
    city: "Nanyang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 32.9837,
    longitude: 112.613056,
    icao: "ZHNY"
  },
  NOA: {
    iata: "NOA",
    name: "Nowra Airport",
    city: "Nowra",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -34.950556,
    longitude: 150.5375,
    icao: "YSNW"
  },
  NOB: {
    iata: "NOB",
    name: "Nosara Beach Airport",
    city: "Nosara Beach",
    countryId: "CR",
    timeZoneRegionName: "America/Costa_Rica",
    latitude: 9.976398,
    longitude: -85.653057,
    icao: "MRNS"
  },
  NOC: {
    iata: "NOC",
    name: "Ireland West Airport Knock",
    city: "Knock",
    countryId: "IE",
    timeZoneRegionName: "Europe/Dublin",
    latitude: 53.914002,
    longitude: -8.810468,
    icao: "EIKN"
  },
  NOD: {
    iata: "NOD",
    name: "Norden Airport",
    city: "Norden",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 53.583333,
    longitude: 7.2,
    icao: "EDWS"
  },
  NOG: {
    iata: "NOG",
    name: "Nogales Airport",
    city: "Nogales",
    countryId: "MX",
    timeZoneRegionName: "America/Hermosillo",
    latitude: 31.333333,
    longitude: -110.933333,
    icao: "MMNG"
  },
  NOJ: {
    iata: "NOJ",
    name: "Noyabrsk Airport",
    city: "Nojabrxsk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yekaterinburg",
    latitude: 63.176731,
    longitude: 75.294596,
    icao: "USRO"
  },
  NOK: {
    iata: "NOK",
    name: "Nova Xavantina Airport",
    city: "Nova Xavantina",
    countryId: "BR",
    timeZoneRegionName: "America/Campo_Grande",
    latitude: -14.690278,
    longitude: -52.348611,
    icao: "SWXV"
  },
  NON: {
    iata: "NON",
    name: "Nonouti Airport",
    city: "Nonouti",
    countryId: "KI",
    timeZoneRegionName: "Pacific/Tarawa",
    latitude: -0.680556,
    longitude: 174.35,
    icao: "NGTO"
  },
  NOP: {
    iata: "NOP",
    name: "Sinop Airport - Turkey",
    city: "Sinop",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 42.0175,
    longitude: 35.068889,
    icao: "LTCM"
  },
  NOR: {
    iata: "NOR",
    name: "Nordfjordur Airport",
    city: "Nordfjordur",
    countryId: "IS",
    timeZoneRegionName: "Atlantic/Reykjavik",
    latitude: 65.131883,
    longitude: -13.746385,
    icao: "BINF"
  },
  NOS: {
    iata: "NOS",
    name: "Fascene Airport",
    city: "Nossi-be",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -13.311111,
    longitude: 48.313889,
    icao: "FMNN"
  },
  NOT: {
    iata: "NOT",
    name: "Marin County Airport",
    city: "Novato",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 38.143333,
    longitude: -122.555833,
    icao: "KDVO"
  },
  NOU: {
    iata: "NOU",
    name: "Tontouta Airport",
    city: "Noumea",
    countryId: "NC",
    timeZoneRegionName: "Pacific/Noumea",
    latitude: -22.016389,
    longitude: 166.216111,
    icao: "NWWW"
  },
  NOV: {
    iata: "NOV",
    name: "Huambo Airport",
    city: "Huambo",
    countryId: "AO",
    timeZoneRegionName: "Africa/Luanda",
    latitude: -12.805556,
    longitude: 15.757222,
    icao: "FNHU"
  },
  NOZ: {
    iata: "NOZ",
    name: "Novokuznetsk Airport",
    city: "Novokuznetsk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Novokuznetsk",
    latitude: 53.811401,
    longitude: 86.877197,
    icao: "UNWW"
  },
  NPA: {
    iata: "NPA",
    name: "Naval Air Station Pensacola",
    city: "Pensacola",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.353596,
    longitude: -87.314051,
    icao: "KNPA"
  },
  NPE: {
    iata: "NPE",
    name: "Hawkes Bay Airport",
    city: "Napier",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -39.466672,
    longitude: 176.872261,
    icao: "NZNR"
  },
  NPL: {
    iata: "NPL",
    name: "New Plymouth Airport",
    city: "New Plymouth",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -39.010132,
    longitude: 174.179325,
    icao: "NZNP"
  },
  NPT: {
    iata: "NPT",
    name: "Newport State Airport",
    city: "Newport",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.532423,
    longitude: -71.281362,
    icao: "KUUU"
  },
  NPY: {
    iata: "NPY",
    name: "Mpanda Airport",
    city: "Mpanda",
    countryId: "TZ",
    timeZoneRegionName: "Africa/Dar_es_Salaam",
    latitude: -6.355285,
    longitude: 31.084045,
    icao: "HTMP"
  },
  NQA: {
    iata: "NQA",
    name: "Naval Air Station",
    city: "Memphis",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.133333,
    longitude: -90.05,
    icao: "KNQA"
  },
  NQI: {
    iata: "NQI",
    name: "Naval Air Station",
    city: "Kingsville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 27.516667,
    longitude: -97.866667,
    icao: "KNQI"
  },
  NQL: {
    iata: "NQL",
    name: "Niquelandia Airport",
    city: "Niquelandia",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -14,
    longitude: -48.983333,
    icao: "SWNQ"
  },
  NQN: {
    iata: "NQN",
    name: "Presidente Peron International Airport",
    city: "Neuquen",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -38.952503,
    longitude: -68.140082,
    icao: "SAZN"
  },
  NQT: {
    iata: "NQT",
    name: "Nottingham Airport",
    city: "Nottingham",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 52.918793,
    longitude: -1.0799,
    icao: "EGBN"
  },
  NQU: {
    iata: "NQU",
    name: "Nuqui Airport",
    city: "Nuqui",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 5.695137,
    longitude: -77.2793,
    icao: "SKNQ"
  },
  NQX: {
    iata: "NQX",
    name: "Naval Air Station Key West",
    city: "Key West",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 24.576032,
    longitude: -81.688479,
    icao: "KNQX"
  },
  NQY: {
    iata: "NQY",
    name: "Newquay Cornwall Airport",
    city: "Newquay",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 50.43745,
    longitude: -4.997922,
    icao: "EGDG"
  },
  NQZ: {
    iata: "NQZ",
    name: "Nur-Sultan Nazarbayev Airport",
    city: "Nur-Sultan",
    countryId: "KZ",
    timeZoneRegionName: "Asia/Almaty",
    latitude: 51.027811,
    longitude: 71.461199,
    icao: "UACC"
  },
  NRA: {
    iata: "NRA",
    name: "Narrandera Airport",
    city: "Narrandera",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -34.705644,
    longitude: 146.511702,
    icao: "YNAR"
  },
  NRB: {
    iata: "NRB",
    name: "Mayport Naval Station",
    city: "Mayport",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 30.39151,
    longitude: -81.418771,
    icao: "KNRB"
  },
  NRD: {
    iata: "NRD",
    name: "Norderney Airport",
    city: "Norderney",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 53.706944,
    longitude: 7.23,
    icao: "EDWY"
  },
  NRE: {
    iata: "NRE",
    name: "Namrole Airport",
    city: "Namrole",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jayapura",
    latitude: -3.854102,
    longitude: 126.703082,
    icao: "WAPG"
  },
  NRK: {
    iata: "NRK",
    name: "Kungsangen Airport",
    city: "Norrkoping",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 58.583296,
    longitude: 16.232393,
    icao: "ESSP"
  },
  NRL: {
    iata: "NRL",
    name: "North Ronaldsay Airport",
    city: "North Ronaldsay",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 59.367491,
    longitude: -2.434444,
    icao: "EGEN"
  },
  NRM: {
    iata: "NRM",
    name: "Nara Airport",
    city: "Nara",
    countryId: "ML",
    timeZoneRegionName: "Africa/Bamako",
    latitude: 15.25,
    longitude: -7.283333,
    icao: "GANK"
  },
  NRN: {
    iata: "NRN",
    name: "Weeze Airport",
    city: "Dusseldorf",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 51.599286,
    longitude: 6.150168,
    icao: "EDLV"
  },
  NRR: {
    iata: "NRR",
    name: "Jose Aponte de la Torre Airport",
    city: "Ceiba",
    countryId: "PR",
    timeZoneRegionName: "America/Puerto_Rico",
    latitude: 18.25,
    longitude: -65.638889,
    icao: "TJNR"
  },
  NRS: {
    iata: "NRS",
    name: "NOLF Imperial Beach",
    city: "Imperial Beach",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 32.564201,
    longitude: -117.113811,
    icao: "KNRS"
  },
  NRT: {
    iata: "NRT",
    name: "Narita International Airport",
    city: "Tokyo",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 35.773213,
    longitude: 140.387443,
    icao: "RJAA"
  },
  NSE: {
    iata: "NSE",
    name: "Whiting Field Naval Air Station",
    city: "Milton",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 30.633333,
    longitude: -87.05,
    icao: "KNDZ"
  },
  NSH: {
    iata: "NSH",
    name: "Now Shahr Airport",
    city: "Now Shahr",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 36.666667,
    longitude: 51.5,
    icao: ""
  },
  NSI: {
    iata: "NSI",
    name: "Nsimalen Airport",
    city: "Yaounde",
    countryId: "CM",
    timeZoneRegionName: "Africa/Douala",
    latitude: 3.702222,
    longitude: 11.550278,
    icao: "FKYS"
  },
  NSK: {
    iata: "NSK",
    name: "Noril'sk Airport",
    city: "Noril'sk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Krasnoyarsk",
    latitude: 69.323123,
    longitude: 87.339807,
    icao: "UOOO"
  },
  NSM: {
    iata: "NSM",
    name: "Norseman Airport",
    city: "Norseman",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -32.2,
    longitude: 121.75,
    icao: "YNSM"
  },
  NSN: {
    iata: "NSN",
    name: "Nelson Airport",
    city: "Nelson",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -41.299122,
    longitude: 173.224227,
    icao: "NZNS"
  },
  NSO: {
    iata: "NSO",
    name: "Scone Airport",
    city: "Scone",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -32.036111,
    longitude: 150.8325,
    icao: "YSCO"
  },
  NSQ: {
    iata: "NSQ",
    name: "Nuussuaq Heliport",
    city: "Nuussuaq",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 74.109853,
    longitude: -57.065037,
    icao: "BGNU"
  },
  NST: {
    iata: "NST",
    name: "Nakhon Si Thammarat Airport",
    city: "Nakhon Si Thammarat",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 8.467457,
    longitude: 99.957527,
    icao: "VTSN"
  },
  NSY: {
    iata: "NSY",
    name: "Sigonella Naval Air Field",
    city: "Sigonella",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 37.40702,
    longitude: 14.914698,
    icao: "LICZ"
  },
  NTB: {
    iata: "NTB",
    name: "Notodden Airport",
    city: "Notodden",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 59.564869,
    longitude: 9.215656,
    icao: "ENNO"
  },
  NTD: {
    iata: "NTD",
    name: "Naval Base Ventura County",
    city: "Oxnard",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 34.119199,
    longitude: -119.119432,
    icao: "KNTD"
  },
  NTE: {
    iata: "NTE",
    name: "Nantes Atlantique Airport",
    city: "Nantes",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 47.157623,
    longitude: -1.601402,
    icao: "LFRS"
  },
  NTG: {
    iata: "NTG",
    name: "Nantong Xingdong International Airport",
    city: "Nantong",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 32.070833,
    longitude: 120.975556,
    icao: "ZSNT"
  },
  NTL: {
    iata: "NTL",
    name: "Newcastle Airport",
    city: "Newcastle",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -32.804594,
    longitude: 151.84005,
    icao: "YWLM"
  },
  NTN: {
    iata: "NTN",
    name: "Normanton Airport",
    city: "Normanton",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -17.685399,
    longitude: 141.073071,
    icao: "YNTN"
  },
  NTO: {
    iata: "NTO",
    name: "Agostinho Neto Airport",
    city: "Santo Antao Island",
    countryId: "CV",
    timeZoneRegionName: "Atlantic/Cape_Verde",
    latitude: 17.202718,
    longitude: -25.090392,
    icao: "GVAN"
  },
  NTQ: {
    iata: "NTQ",
    name: "Noto Airport",
    city: "Wajima",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 37.294677,
    longitude: 136.956803,
    icao: "RJNW"
  },
  NTR: {
    iata: "NTR",
    name: "Del Norte International Airport",
    city: "Monterrey",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 25.86456,
    longitude: -100.238216,
    icao: "MMAN"
  },
  NTT: {
    iata: "NTT",
    name: "Kuini Lavenia Airport",
    city: "Niuatoputapu",
    countryId: "TO",
    timeZoneRegionName: "Pacific/Tongatapu",
    latitude: -15.5,
    longitude: -174,
    icao: "NFTP"
  },
  NTU: {
    iata: "NTU",
    name: "Naval Air Station",
    city: "Oceana",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 36.816667,
    longitude: -76.033333,
    icao: "KNTU"
  },
  NTX: {
    iata: "NTX",
    name: "Natuna Ranai Airport",
    city: "Natuna Ranai",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: 3.95,
    longitude: 108.383333,
    icao: "WIDO"
  },
  NTY: {
    iata: "NTY",
    name: "Pilanesberg International Airport",
    city: "Sun City",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -25.333799,
    longitude: 27.173401,
    icao: "FAPN"
  },
  NUB: {
    iata: "NUB",
    name: "Numbulwar Airport",
    city: "Numbulwar",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -14.271667,
    longitude: 135.716389,
    icao: "YNUM"
  },
  NUD: {
    iata: "NUD",
    name: "En Nahud Airport",
    city: "En Nahud",
    countryId: "SD",
    timeZoneRegionName: "Africa/Khartoum",
    latitude: 12.75,
    longitude: 28.416667,
    icao: "HSNH"
  },
  NUE: {
    iata: "NUE",
    name: "Nuremberg Airport",
    city: "Nuremberg",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 49.494168,
    longitude: 11.077062,
    icao: "EDDN"
  },
  NUI: {
    iata: "NUI",
    name: "Nuiqsut Airport",
    city: "Nuiqsut",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 70.209722,
    longitude: -151.005556,
    icao: "PAQT"
  },
  NUK: {
    iata: "NUK",
    name: "Nukutavake Airport",
    city: "Nukutavake, Tuamoto Island",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -19.183333,
    longitude: -138.7,
    icao: "NTGW"
  },
  NUL: {
    iata: "NUL",
    name: "Nulato Airport",
    city: "Nulato",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 64.727778,
    longitude: -158.076667,
    icao: "PANU"
  },
  NUM: {
    iata: "NUM",
    name: "Neom Bay",
    city: "Neom",
    countryId: "SA",
    timeZoneRegionName: "Asia/Riyadh",
    latitude: 27.9172,
    longitude: 35.294,
    icao: "OENN"
  },
  NUN: {
    iata: "NUN",
    name: "Saufley Naval Air Station",
    city: "Pensacola",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.468549,
    longitude: -87.334118,
    icao: "KNUN"
  },
  NUP: {
    iata: "NUP",
    name: "Nunapitchuk Airport",
    city: "Nunapitchuk",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 60.894444,
    longitude: -162.466667,
    icao: ""
  },
  NUQ: {
    iata: "NUQ",
    name: "Moffett Federal Field",
    city: "Mountain View",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 37.413874,
    longitude: -122.049245,
    icao: "KNUQ"
  },
  NUS: {
    iata: "NUS",
    name: "Norsup Airport",
    city: "Norsup",
    countryId: "VU",
    timeZoneRegionName: "Pacific/Efate",
    latitude: -16.058333,
    longitude: 167.4,
    icao: "NVSP"
  },
  NUU: {
    iata: "NUU",
    name: "Nakuru Airport",
    city: "Nakuru",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: -0.29812,
    longitude: 36.159241,
    icao: "HKNK"
  },
  NUW: {
    iata: "NUW",
    name: "Ault Field",
    city: "Whidbey Island",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 48.351944,
    longitude: -122.655833,
    icao: "KNUW"
  },
  NUX: {
    iata: "NUX",
    name: "Novy Urengoy Airport",
    city: "Novyj Urengoj",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yekaterinburg",
    latitude: 66.073351,
    longitude: 76.522831,
    icao: ""
  },
  NVA: {
    iata: "NVA",
    name: "Benito Salas Airport",
    city: "Neiva",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 2.946896,
    longitude: -75.293548,
    icao: "SKNV"
  },
  NVD: {
    iata: "NVD",
    name: "Nevada Airport",
    city: "Nevada",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 37.851389,
    longitude: -94.303889,
    icao: "KNVD"
  },
  NVI: {
    iata: "NVI",
    name: "Navoi International Airport",
    city: "Navoi",
    countryId: "UZ",
    timeZoneRegionName: "Asia/Tashkent",
    latitude: 40.115,
    longitude: 65.159167,
    icao: "UZSA"
  },
  NVP: {
    iata: "NVP",
    name: "Novo Aripuana Airport",
    city: "Novo Aripuana",
    countryId: "BR",
    timeZoneRegionName: "America/Porto_Velho",
    latitude: -5.133333,
    longitude: -60.366667,
    icao: "SWNA"
  },
  NVS: {
    iata: "NVS",
    name: "Nevers Airport",
    city: "Nevers",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 47,
    longitude: 3.15,
    icao: "LFQG"
  },
  NVT: {
    iata: "NVT",
    name: "Navegantes Airport",
    city: "Navegantes",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -26.879914,
    longitude: -48.64937,
    icao: "SBNF"
  },
  NWA: {
    iata: "NWA",
    name: "Bandar Es Eslam Airport",
    city: "Moheli",
    countryId: "KM",
    timeZoneRegionName: "Indian/Comoro",
    latitude: -12.298664,
    longitude: 43.767155,
    icao: "FMCI"
  },
  NWI: {
    iata: "NWI",
    name: "Norwich International Airport",
    city: "Norwich",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 52.669534,
    longitude: 1.276782,
    icao: "EGSH"
  },
  NXX: {
    iata: "NXX",
    name: "Willow Grove Naval Air Station",
    city: "Willow Grove",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.2,
    longitude: -75.133333,
    icao: "KNXX"
  },
  NYA: {
    iata: "NYA",
    name: "Nyagan Airport",
    city: "Nyagan",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yekaterinburg",
    latitude: 62.101076,
    longitude: 65.605627,
    icao: "USHN"
  },
  NYE: {
    iata: "NYE",
    name: "Nyeri Airport",
    city: "Nyeri",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: -0.416667,
    longitude: 36.95,
    icao: "HKNI"
  },
  NYG: {
    iata: "NYG",
    name: "Quantico Naval Air Station",
    city: "Quantico",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 38.516667,
    longitude: -77.283333,
    icao: "KNYG"
  },
  NYI: {
    iata: "NYI",
    name: "Sunyani Airport",
    city: "Sunyani",
    countryId: "GH",
    timeZoneRegionName: "Africa/Accra",
    latitude: 7.360586,
    longitude: -2.329254,
    icao: "DGSN"
  },
  NYK: {
    iata: "NYK",
    name: "Nanyuki Airport",
    city: "Nanyuki",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: 0.016667,
    longitude: 37.066667,
    icao: "HKNY"
  },
  NYM: {
    iata: "NYM",
    name: "Nadym Airport",
    city: "Nadym",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yekaterinburg",
    latitude: 65.483333,
    longitude: 72.716667,
    icao: "USMM"
  },
  NYN: {
    iata: "NYN",
    name: "Nyngan Airport",
    city: "Nyngan",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -31.566667,
    longitude: 147.183333,
    icao: "YNYN"
  },
  NYO: {
    iata: "NYO",
    name: "Stockholm Skavsta Airport",
    city: "Stockholm",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 58.784247,
    longitude: 16.922866,
    icao: "ESKN"
  },
  NYR: {
    iata: "NYR",
    name: "Nyurba Airport",
    city: "Nyurba",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yakutsk",
    latitude: 63.297222,
    longitude: 118.346944,
    icao: "UENN"
  },
  NYT: {
    iata: "NYT",
    name: "Nay Pyi Taw Airport",
    city: "Naypyidaw",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 19.6225,
    longitude: 96.201385,
    icao: "VYNT"
  },
  NYU: {
    iata: "NYU",
    name: "Nyaung U Airport",
    city: "Nyaung-u",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 21.175342,
    longitude: 94.928321,
    icao: "VBNU"
  },
  NYW: {
    iata: "NYW",
    name: "Monywa Airport",
    city: "Monywa",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 22.22151,
    longitude: 95.093978,
    icao: "VYMY"
  },
  NZC: {
    iata: "NZC",
    name: "Maria Reiche Neuman Airport",
    city: "Nazca",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -14.85453,
    longitude: -74.960174,
    icao: "SPZA"
  },
  NZE: {
    iata: "NZE",
    name: "Nzerekore Airport",
    city: "Nzerekore",
    countryId: "GN",
    timeZoneRegionName: "Africa/Conakry",
    latitude: 7.808333,
    longitude: -8.702778,
    icao: "GUNZ"
  },
  NZG: {
    iata: "NZG",
    name: "Nizhneangarsk International Airport",
    city: "Nizhneangarsk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Irkutsk",
    latitude: 55.801709,
    longitude: 109.59607,
    icao: ""
  },
  NZH: {
    iata: "NZH",
    name: "Manzhouli Xijiao Airport",
    city: "Manzhouli",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 49.570592,
    longitude: 117.331627,
    icao: "ZBMZ"
  },
  NZL: {
    iata: "NZL",
    name: "Zhalantun Chengjisihan Airport",
    city: "Chengjisihan",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 47.719903,
    longitude: 122.832004,
    icao: ""
  },
  NZY: {
    iata: "NZY",
    name: "North Island Naval Air Station",
    city: "San Diego",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 32.700555,
    longitude: -117.202708,
    icao: "KNZY"
  },
  OAG: {
    iata: "OAG",
    name: "Orange Airport",
    city: "Orange",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -33.381601,
    longitude: 149.124473,
    icao: "YORG"
  },
  OAI: {
    iata: "OAI",
    name: "Bagram Airport",
    city: "Bagram",
    countryId: "AF",
    timeZoneRegionName: "Asia/Kabul",
    latitude: 34.946141,
    longitude: 69.264969,
    icao: "OAIX"
  },
  OAJ: {
    iata: "OAJ",
    name: "Albert J Ellis Airport",
    city: "Richlands",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 34.830441,
    longitude: -77.605834,
    icao: "KOAJ"
  },
  OAK: {
    iata: "OAK",
    name: "Metropolitan Oakland International Airport",
    city: "Oakland",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 37.71188,
    longitude: -122.212011,
    icao: "KOAK"
  },
  OAL: {
    iata: "OAL",
    name: "Capital do Cafe Airport",
    city: "Cacoal",
    countryId: "BR",
    timeZoneRegionName: "America/Porto_Velho",
    latitude: -11.496,
    longitude: -61.4508,
    icao: ""
  },
  OAM: {
    iata: "OAM",
    name: "Oamaru Airport",
    city: "Oamaru",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -44.970281,
    longitude: 171.081889,
    icao: "NZOU"
  },
  OAS: {
    iata: "OAS",
    name: "Sharana Air Base",
    city: "Sharana",
    countryId: "AF",
    timeZoneRegionName: "Asia/Kabul",
    latitude: 33.12583,
    longitude: 68.83861,
    icao: "OASA"
  },
  OAX: {
    iata: "OAX",
    name: "Xoxocotlan Airport",
    city: "Oaxaca",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 17.000884,
    longitude: -96.721635,
    icao: "MMOX"
  },
  OAZ: {
    iata: "OAZ",
    name: "Camp Bastion",
    city: "Lashkar Gah",
    countryId: "AF",
    timeZoneRegionName: "Asia/Kabul",
    latitude: 31.863889,
    longitude: 64.224722,
    icao: "OAZI"
  },
  OBC: {
    iata: "OBC",
    name: "Obock Airport",
    city: "Obock",
    countryId: "DJ",
    timeZoneRegionName: "Africa/Djibouti",
    latitude: 11.983333,
    longitude: 43.266667,
    icao: "HDOB"
  },
  OBE: {
    iata: "OBE",
    name: "Okeechobee County Airport",
    city: "Okeechobee",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 27.25,
    longitude: -80.833333,
    icao: "KOBE"
  },
  OBF: {
    iata: "OBF",
    name: "Oberpfaffenhofen Airport",
    city: "Oberpfaffenhofen",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 48.083333,
    longitude: 11.283333,
    icao: "EDMO"
  },
  OBI: {
    iata: "OBI",
    name: "Obidos Airport",
    city: "Obidos",
    countryId: "BR",
    timeZoneRegionName: "America/Porto_Velho",
    latitude: -1.916667,
    longitude: -55.516667,
    icao: "SNTI"
  },
  OBN: {
    iata: "OBN",
    name: "North Connel Oban Airport",
    city: "Oban",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 56.463501,
    longitude: -5.39967,
    icao: "EGEO"
  },
  OBO: {
    iata: "OBO",
    name: "Tokachi-Obihiro Airport",
    city: "Obihiro",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 42.732003,
    longitude: 143.212437,
    icao: "RJCB"
  },
  OBS: {
    iata: "OBS",
    name: "Vals-Lanas Airport",
    city: "Aubenas",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 44.666667,
    longitude: 4.7,
    icao: "LFHO"
  },
  OBU: {
    iata: "OBU",
    name: "Kobuk Wien Airport",
    city: "Kobuk",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 66.910556,
    longitude: -156.883333,
    icao: "PAOB"
  },
  OBY: {
    iata: "OBY",
    name: "Ittoqqortoormiit Heliport",
    city: "Ittoqqortoormiit",
    countryId: "GL",
    timeZoneRegionName: "America/Scoresbysund",
    latitude: 70.488333,
    longitude: -21.971944,
    icao: "BGSC"
  },
  OCC: {
    iata: "OCC",
    name: "Coca Airport",
    city: "Coca",
    countryId: "EC",
    timeZoneRegionName: "America/Guayaquil",
    latitude: -0.462171,
    longitude: -76.985962,
    icao: "SECO"
  },
  OCE: {
    iata: "OCE",
    name: "Ocean City Municipal Airport",
    city: "Ocean City",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 38.310398,
    longitude: -75.124001,
    icao: "KOXB"
  },
  OCF: {
    iata: "OCF",
    name: "Ocala International Airport",
    city: "Ocala",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 29.174091,
    longitude: -82.221597,
    icao: "KOCF"
  },
  OCH: {
    iata: "OCH",
    name: "A.L. Mangham Jr. Regional Airport",
    city: "Nacogdoches",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 31.577999,
    longitude: -94.709503,
    icao: "KOCH"
  },
  OCJ: {
    iata: "OCJ",
    name: "Boscobel Airport",
    city: "Ocho Rios",
    countryId: "JM",
    timeZoneRegionName: "America/Jamaica",
    latitude: 18.400556,
    longitude: -76.969722,
    icao: "MKBS"
  },
  OCM: {
    iata: "OCM",
    name: "Boolgeeda Airport",
    city: "Boolgeeda",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -22.54,
    longitude: 117.275,
    icao: "YBGD"
  },
  OCN: {
    iata: "OCN",
    name: "Oceanside Municipal Airport",
    city: "Oceanside",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 33.218611,
    longitude: -117.353333,
    icao: "KOKB"
  },
  OCV: {
    iata: "OCV",
    name: "Aguasclaras Airport",
    city: "Ocana",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 8.25,
    longitude: -73.333333,
    icao: "SKOC"
  },
  OCW: {
    iata: "OCW",
    name: "Warren Field",
    city: "Washington",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 35.55,
    longitude: -77.05,
    icao: "KOCW"
  },
  ODB: {
    iata: "ODB",
    name: "Cordoba Airport",
    city: "Cordoba",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 37.841111,
    longitude: -4.847222,
    icao: "LEBA"
  },
  ODD: {
    iata: "ODD",
    name: "Oodnadatta Airport",
    city: "Oodnadatta",
    countryId: "AU",
    timeZoneRegionName: "Australia/Adelaide",
    latitude: -27.550278,
    longitude: 135.45,
    icao: "YOOD"
  },
  ODE: {
    iata: "ODE",
    name: "Beldringe Airport",
    city: "Odense",
    countryId: "DK",
    timeZoneRegionName: "Europe/Copenhagen",
    latitude: 55.47356,
    longitude: 10.328814,
    icao: "EKOD"
  },
  ODH: {
    iata: "ODH",
    name: "Odiham RAF Station",
    city: "Odiham",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.234232,
    longitude: -0.943024,
    icao: "EGVO"
  },
  ODN: {
    iata: "ODN",
    name: "Long Seridan Airport",
    city: "Long Seridan",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 4.033333,
    longitude: 115.066667,
    icao: "WBGI"
  },
  ODO: {
    iata: "ODO",
    name: "Bodaybo Airport",
    city: "Bodaybo",
    countryId: "RU",
    timeZoneRegionName: "Asia/Irkutsk",
    latitude: 57.866389,
    longitude: 114.2425,
    icao: ""
  },
  ODS: {
    iata: "ODS",
    name: "Odessa International Airport",
    city: "Odessa",
    countryId: "UA",
    timeZoneRegionName: "Europe/Kiev",
    latitude: 46.441008,
    longitude: 30.676718,
    icao: "UKOO"
  },
  ODY: {
    iata: "ODY",
    name: "Oudomxai Airport",
    city: "Muang Xay",
    countryId: "LA",
    timeZoneRegionName: "Asia/Vientiane",
    latitude: 20.682699,
    longitude: 101.994003,
    icao: "VLOS"
  },
  OEA: {
    iata: "OEA",
    name: "Oneal Airport",
    city: "Vincennes",
    countryId: "US",
    timeZoneRegionName: "America/Indiana/Indianapolis",
    latitude: 38.683333,
    longitude: -87.533333,
    icao: "KOEA"
  },
  OEM: {
    iata: "OEM",
    name: "Vincent Fayks Airport",
    city: "Paloemeu",
    countryId: "SR",
    timeZoneRegionName: "America/Paramaribo",
    latitude: 3.35,
    longitude: -55.45,
    icao: "SMPA"
  },
  OEO: {
    iata: "OEO",
    name: "Osceola Municipal Airport",
    city: "Osceola",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 45.3,
    longitude: -92.7,
    icao: "KOEO"
  },
  OER: {
    iata: "OER",
    name: "Ornskoldsvik Airport",
    city: "Ornskoldsvik",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 63.412583,
    longitude: 18.992074,
    icao: "ESNO"
  },
  OES: {
    iata: "OES",
    name: "San Antonio Oeste Airport",
    city: "San Antonio Oeste",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -40.733333,
    longitude: -64.95,
    icao: "SAVO"
  },
  OFF: {
    iata: "OFF",
    name: "Offutt Air Force Base",
    city: "Omaha",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.118376,
    longitude: -95.913037,
    icao: "KOFF"
  },
  OFI: {
    iata: "OFI",
    name: "Ouango Fitini Airport",
    city: "Ouango Fitini",
    countryId: "CI",
    timeZoneRegionName: "Africa/Abidjan",
    latitude: 9.600119,
    longitude: -4.04991,
    icao: "DIOF"
  },
  OFK: {
    iata: "OFK",
    name: "Stefan Field",
    city: "Norfolk",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.984167,
    longitude: -97.434167,
    icao: "KOFK"
  },
  OFU: {
    iata: "OFU",
    name: "Ofu Airport",
    city: "Ofu",
    countryId: "AS",
    timeZoneRegionName: "Pacific/Pago_Pago",
    latitude: -14.18432,
    longitude: -169.669464,
    icao: "NSAS"
  },
  OGA: {
    iata: "OGA",
    name: "Searle Field",
    city: "Ogallala",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 41.133333,
    longitude: -101.716667,
    icao: "KOGA"
  },
  OGB: {
    iata: "OGB",
    name: "Orangeburg Municipal Airport",
    city: "Orangeburg",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 33.5,
    longitude: -80.866667,
    icao: "KOGB"
  },
  OGD: {
    iata: "OGD",
    name: "Ogden Municipal Airport",
    city: "Ogden",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 41.196389,
    longitude: -112.010833,
    icao: "KOGD"
  },
  OGG: {
    iata: "OGG",
    name: "Kahului Airport",
    city: "Kahului",
    countryId: "US",
    timeZoneRegionName: "Pacific/Honolulu",
    latitude: 20.892883,
    longitude: -156.438629,
    icao: "PHOG"
  },
  OGL: {
    iata: "OGL",
    name: "Ogle Airport",
    city: "Georgetown",
    countryId: "GY",
    timeZoneRegionName: "America/Guyana",
    latitude: 6.807733,
    longitude: -58.105211,
    icao: "SYGO"
  },
  OGN: {
    iata: "OGN",
    name: "Yonaguni Airport",
    city: "Yonaguni",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 24.465925,
    longitude: 122.979684,
    icao: "ROYN"
  },
  OGO: {
    iata: "OGO",
    name: "Abengourou Airport",
    city: "Abengourou",
    countryId: "CI",
    timeZoneRegionName: "Africa/Abidjan",
    latitude: 6.7,
    longitude: -3.45,
    icao: "DIAU"
  },
  OGR: {
    iata: "OGR",
    name: "Bongor Airport",
    city: "Bongor",
    countryId: "TD",
    timeZoneRegionName: "Africa/Ndjamena",
    latitude: 10.289444,
    longitude: 15.383333,
    icao: "FTTB"
  },
  OGS: {
    iata: "OGS",
    name: "Ogdensburg Airport",
    city: "Ogdensburg",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 44.681667,
    longitude: -75.465833,
    icao: "KOGS"
  },
  OGU: {
    iata: "OGU",
    name: "Ordu\u2013Giresun Airport",
    city: "G\xFClyal\u0131",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 40.966667,
    longitude: 38.08,
    icao: "LTCB"
  },
  OGX: {
    iata: "OGX",
    name: "Ain Beida Airport",
    city: "Ouargla",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 31.916667,
    longitude: 5.4,
    icao: "DAUU"
  },
  OGZ: {
    iata: "OGZ",
    name: "Vladikavkaz Airport",
    city: "Vladikavkaz",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 43.2,
    longitude: 44.6,
    icao: "URMO"
  },
  OHA: {
    iata: "OHA",
    name: "Royal Air Force Base",
    city: "Ohakea",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -40.208333,
    longitude: 175.386667,
    icao: "NZOH"
  },
  OHD: {
    iata: "OHD",
    name: "Ohrid Airport",
    city: "Ohrid",
    countryId: "MK",
    timeZoneRegionName: "Europe/Skopje",
    latitude: 41.180231,
    longitude: 20.743216,
    icao: "LWOH"
  },
  OHE: {
    iata: "OHE",
    name: "Mohe Airport",
    city: "Mohe",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 52.921132,
    longitude: 122.420595,
    icao: "ZYMH"
  },
  OHH: {
    iata: "OHH",
    name: "Novostroyka Airport",
    city: "Okha",
    countryId: "RU",
    timeZoneRegionName: "Asia/Sakhalin",
    latitude: 53.516666,
    longitude: 142.88333,
    icao: "UHSH"
  },
  OHO: {
    iata: "OHO",
    name: "Okhotsk Airport",
    city: "Okhotsk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Vladivostok",
    latitude: 59.413672,
    longitude: 143.064436,
    icao: "UHOO"
  },
  OHR: {
    iata: "OHR",
    name: "Wyk Airport",
    city: "Wyk",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 54.685833,
    longitude: 8.529167,
    icao: "EDXY"
  },
  OIA: {
    iata: "OIA",
    name: "Ourilandia do Norte Airport",
    city: "Ourilandia",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -6.761303,
    longitude: -51.049001,
    icao: ""
  },
  OIC: {
    iata: "OIC",
    name: "Eaton Airport",
    city: "Norwich",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.533333,
    longitude: -75.533333,
    icao: "KOIC"
  },
  OIM: {
    iata: "OIM",
    name: "Oshima Airport",
    city: "Oshima",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 34.779167,
    longitude: 139.365,
    icao: "RJTO"
  },
  OIR: {
    iata: "OIR",
    name: "Okushiri Airport",
    city: "Okushiri",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 42.071984,
    longitude: 139.43488,
    icao: "RJEO"
  },
  OIT: {
    iata: "OIT",
    name: "Oita Airport",
    city: "Oita",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 33.477237,
    longitude: 131.732362,
    icao: "RJFO"
  },
  OJC: {
    iata: "OJC",
    name: "Johnson Executive Airport",
    city: "Kansas City",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 38.85,
    longitude: -94.733333,
    icao: "KOJC"
  },
  OKA: {
    iata: "OKA",
    name: "Naha Airport",
    city: "Okinawa",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 26.204954,
    longitude: 127.645842,
    icao: "ROAH"
  },
  OKC: {
    iata: "OKC",
    name: "Will Rogers World Airport",
    city: "Oklahoma City",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.395629,
    longitude: -97.59609,
    icao: "KOKC"
  },
  OKD: {
    iata: "OKD",
    name: "Okadama Airport",
    city: "Sapporo",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 43.110374,
    longitude: 141.381998,
    icao: "RJCO"
  },
  OKE: {
    iata: "OKE",
    name: "Okino Erabu Airport",
    city: "Wadomari",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 27.431667,
    longitude: 128.705556,
    icao: "RJKB"
  },
  OKF: {
    iata: "OKF",
    name: "Okaukuejo Airport",
    city: "Okaukuejo",
    countryId: "NA",
    timeZoneRegionName: "Africa/Windhoek",
    latitude: -19.166667,
    longitude: 16,
    icao: "FYOO"
  },
  OKI: {
    iata: "OKI",
    name: "Oki Island Airport",
    city: "Oki Island",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 36.166667,
    longitude: 133.316667,
    icao: "RJNO"
  },
  OKJ: {
    iata: "OKJ",
    name: "Okayama Airport",
    city: "Okayama",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 34.760218,
    longitude: 133.85277,
    icao: "RJOB"
  },
  OKK: {
    iata: "OKK",
    name: "Kokomo Municipal Airport",
    city: "Kokomo",
    countryId: "US",
    timeZoneRegionName: "America/Indiana/Indianapolis",
    latitude: 40.529722,
    longitude: -86.058056,
    icao: "KOKK"
  },
  OKL: {
    iata: "OKL",
    name: "Gunung Bintang Airport",
    city: "Oksibil",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jayapura",
    latitude: -4.908143,
    longitude: 140.630456,
    icao: "WAJO"
  },
  OKM: {
    iata: "OKM",
    name: "Okmulgee Airport",
    city: "Okmulgee",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.616667,
    longitude: -95.966667,
    icao: "KOKM"
  },
  OKN: {
    iata: "OKN",
    name: "Okondja Airport",
    city: "Okondja",
    countryId: "GA",
    timeZoneRegionName: "Africa/Libreville",
    latitude: -1,
    longitude: 14.008333,
    icao: "FOGQ"
  },
  OKO: {
    iata: "OKO",
    name: "Yokota Air Force Base",
    city: "Tokyo",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 35.75,
    longitude: 139.35,
    icao: "RJTY"
  },
  OKR: {
    iata: "OKR",
    name: "Yorke Island Airport",
    city: "Yorke Island",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -9.752783,
    longitude: 143.405625,
    icao: "YYKI"
  },
  OKS: {
    iata: "OKS",
    name: "Oshkosh Airport",
    city: "Oshkosh",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.4,
    longitude: -102.35,
    icao: "KOKS"
  },
  OKU: {
    iata: "OKU",
    name: "Mokuti Lodge Airport",
    city: "Mokuti Lodge",
    countryId: "NA",
    timeZoneRegionName: "Africa/Windhoek",
    latitude: -18.808333,
    longitude: 17.05,
    icao: "FYMO"
  },
  OKY: {
    iata: "OKY",
    name: "Oakey Airport",
    city: "Oakey",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -27.406667,
    longitude: 151.735,
    icao: "YBOK"
  },
  OLA: {
    iata: "OLA",
    name: "Orland Airport",
    city: "Orland",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 63.698789,
    longitude: 9.604094,
    icao: "ENOL"
  },
  OLB: {
    iata: "OLB",
    name: "Olbia Costa Smeralda Airport",
    city: "Olbia",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 40.903143,
    longitude: 9.514823,
    icao: "LIEO"
  },
  OLD: {
    iata: "OLD",
    name: "Old Town Airport",
    city: "Old Town",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 44.933333,
    longitude: -68.65,
    icao: "KOLD"
  },
  OLE: {
    iata: "OLE",
    name: "Cattaraugus County Airport",
    city: "Olean",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.241199,
    longitude: -78.371399,
    icao: "KOLE"
  },
  OLF: {
    iata: "OLF",
    name: "Wolf Point International Airport",
    city: "Wolf Point",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 48.094722,
    longitude: -105.566389,
    icao: "KOLF"
  },
  OLG: {
    iata: "OLG",
    name: "Maasai Mara Olare Airport",
    city: "Maasai Mara",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: -1.324397,
    longitude: 35.247367,
    icao: ""
  },
  OLM: {
    iata: "OLM",
    name: "Olympia Regional Airport",
    city: "Olympia",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 46.973611,
    longitude: -122.903333,
    icao: "KOLM"
  },
  OLP: {
    iata: "OLP",
    name: "Olympic Dam Airport",
    city: "Olympic Dam",
    countryId: "AU",
    timeZoneRegionName: "Australia/Adelaide",
    latitude: -30.483898,
    longitude: 136.884111,
    icao: "YOLD"
  },
  OLS: {
    iata: "OLS",
    name: "Nogales International Airport",
    city: "Nogales",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 31.416667,
    longitude: -110.85,
    icao: "KOLS"
  },
  OLU: {
    iata: "OLU",
    name: "Columbus Airport",
    city: "Columbus",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.447222,
    longitude: -97.341667,
    icao: "KOLU"
  },
  OLV: {
    iata: "OLV",
    name: "Olive Branch Airport",
    city: "Olive Branch",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 34.978307,
    longitude: -89.788449,
    icao: "KOLV"
  },
  OLX: {
    iata: "OLX",
    name: "Olkiombo Airport",
    city: "Maasai Mara",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: -1.408695,
    longitude: 35.109912,
    icao: "HKOK"
  },
  OLY: {
    iata: "OLY",
    name: "Olney Airport",
    city: "Olney",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 38.716667,
    longitude: -88.083333,
    icao: "KOLY"
  },
  OLZ: {
    iata: "OLZ",
    name: "Olokminsk Airport",
    city: "Olokminsk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yakutsk",
    latitude: 60.399167,
    longitude: 120.464167,
    icao: "UEMK"
  },
  OMA: {
    iata: "OMA",
    name: "Eppley Airfield",
    city: "Omaha",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.29957,
    longitude: -95.899717,
    icao: "KOMA"
  },
  OMB: {
    iata: "OMB",
    name: "Omboue Airport",
    city: "Omboue",
    countryId: "GA",
    timeZoneRegionName: "Africa/Libreville",
    latitude: -1.6,
    longitude: 9.266667,
    icao: "FOOH"
  },
  OMC: {
    iata: "OMC",
    name: "Ormoc Airport",
    city: "Ormoc",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 11.055482,
    longitude: 124.565485,
    icao: "RPVO"
  },
  OMD: {
    iata: "OMD",
    name: "Oranjemund Airport",
    city: "Oranjemund",
    countryId: "NA",
    timeZoneRegionName: "Africa/Windhoek",
    latitude: -28.583333,
    longitude: 16.45,
    icao: "FYOG"
  },
  OME: {
    iata: "OME",
    name: "Nome Airport",
    city: "Nome",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 64.510601,
    longitude: -165.431055,
    icao: "PAOM"
  },
  OMH: {
    iata: "OMH",
    name: "Urmia Airport",
    city: "Nazluy-ye Jonubi",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 37.664954,
    longitude: 45.065648,
    icao: "OITR"
  },
  OMI: {
    iata: "OMI",
    name: "Omidiyeh Air Base",
    city: "Omidiyeh",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 30.833333,
    longitude: 49.533333,
    icao: "OIAJ"
  },
  OMK: {
    iata: "OMK",
    name: "Omak Municipal Airport",
    city: "Omak",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 48.461576,
    longitude: -119.517174,
    icao: "KOMK"
  },
  OMM: {
    iata: "OMM",
    name: "Marmul Airport",
    city: "Marmul",
    countryId: "OM",
    timeZoneRegionName: "Asia/Muscat",
    latitude: 18.139893,
    longitude: 55.181691,
    icao: "OOMX"
  },
  OMN: {
    iata: "OMN",
    name: "Zomin Airport",
    city: "Zomin",
    countryId: "UZ",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 40.0089,
    longitude: 68.415,
    icao: ""
  },
  OMO: {
    iata: "OMO",
    name: "Mostar Airport",
    city: "Mostar",
    countryId: "BA",
    timeZoneRegionName: "Europe/Sarajevo",
    latitude: 43.285556,
    longitude: 17.846667,
    icao: "LQMO"
  },
  OMR: {
    iata: "OMR",
    name: "Oradea Airport",
    city: "Oradea",
    countryId: "RO",
    timeZoneRegionName: "Europe/Bucharest",
    latitude: 47.0275,
    longitude: 21.903056,
    icao: "LROD"
  },
  OMS: {
    iata: "OMS",
    name: "Omsk Airport",
    city: "Omsk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Omsk",
    latitude: 54.957455,
    longitude: 73.316707,
    icao: "UNOO"
  },
  ONA: {
    iata: "ONA",
    name: "Winona Municipal Airport",
    city: "Winona",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 44.076667,
    longitude: -91.706111,
    icao: "KONA"
  },
  OND: {
    iata: "OND",
    name: "Ondangwa Airport",
    city: "Ondangwa",
    countryId: "NA",
    timeZoneRegionName: "Africa/Windhoek",
    latitude: -17.885496,
    longitude: 15.942233,
    icao: "FAOA"
  },
  ONG: {
    iata: "ONG",
    name: "Mornington Airport",
    city: "Mornington",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -16.662558,
    longitude: 139.170047,
    icao: "YMTI"
  },
  ONJ: {
    iata: "ONJ",
    name: "Odate Noshiro Airport",
    city: "Odate Noshiro",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 40.196414,
    longitude: 140.373826,
    icao: "RJSR"
  },
  ONK: {
    iata: "ONK",
    name: "Olenyok Airport",
    city: "Olenyok",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yakutsk",
    latitude: 68.515556,
    longitude: 112.479167,
    icao: ""
  },
  ONL: {
    iata: "ONL",
    name: "O'Neill Municipal Airport",
    city: "O'Neill",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 42.466414,
    longitude: -98.686259,
    icao: "KONL"
  },
  ONM: {
    iata: "ONM",
    name: "Socorro Airport",
    city: "Socorro",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 34.066667,
    longitude: -106.9,
    icao: "KONM"
  },
  ONO: {
    iata: "ONO",
    name: "Ontario Airport",
    city: "Ontario",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 44.022778,
    longitude: -117.013889,
    icao: "KONO"
  },
  ONP: {
    iata: "ONP",
    name: "Newport Airport",
    city: "Newport",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 44.580399,
    longitude: -124.057999,
    icao: "KONP"
  },
  ONQ: {
    iata: "ONQ",
    name: "Zonguldak Airport",
    city: "Zonguldak",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 41.506141,
    longitude: 32.089599,
    icao: "LTAS"
  },
  ONR: {
    iata: "ONR",
    name: "Monkira Airport",
    city: "Monkira",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -24.816667,
    longitude: 140.566667,
    icao: "YMNK"
  },
  ONS: {
    iata: "ONS",
    name: "Onslow Airport",
    city: "Onslow",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -21.668927,
    longitude: 115.111987,
    icao: "YOLW"
  },
  ONT: {
    iata: "ONT",
    name: "Ontario International Airport",
    city: "Ontario",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 34.056001,
    longitude: -117.601193,
    icao: "KONT"
  },
  ONX: {
    iata: "ONX",
    name: "Colon Airport",
    city: "Colon",
    countryId: "PA",
    timeZoneRegionName: "America/Panama",
    latitude: 9.35,
    longitude: -79.9,
    icao: "MPEJ"
  },
  ONY: {
    iata: "ONY",
    name: "Olney Airport",
    city: "Olney",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 33.366667,
    longitude: -98.75,
    icao: "KONY"
  },
  OOA: {
    iata: "OOA",
    name: "Oskaloosa Municipal Airport",
    city: "Oskaloosa",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.3,
    longitude: -92.65,
    icao: "KOOA"
  },
  OOK: {
    iata: "OOK",
    name: "Toksook Bay Airport",
    city: "Toksook Bay",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 60.531944,
    longitude: -165.108333,
    icao: "PAOO"
  },
  OOL: {
    iata: "OOL",
    name: "Gold Coast Airport",
    city: "Coolangatta (Gold Coast)",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -28.166164,
    longitude: 153.513137,
    icao: "YBCG"
  },
  OOM: {
    iata: "OOM",
    name: "Snowy Mountains Airport",
    city: "Cooma",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -36.29273,
    longitude: 148.971479,
    icao: "YCOM"
  },
  OOT: {
    iata: "OOT",
    name: "Onotoa Airport",
    city: "Onotoa",
    countryId: "KI",
    timeZoneRegionName: "Pacific/Tarawa",
    latitude: -1.916667,
    longitude: 175.566667,
    icao: "NGON"
  },
  OPF: {
    iata: "OPF",
    name: "Opa-locka Executive Airport",
    city: "Miami",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 25.90856,
    longitude: -80.274424,
    icao: "KOPF"
  },
  OPI: {
    iata: "OPI",
    name: "Oenpelli Airport",
    city: "Oenpelli",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -12.333333,
    longitude: 133.066667,
    icao: "YOEN"
  },
  OPL: {
    iata: "OPL",
    name: "St Landry Parish Airport",
    city: "Opelousas",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.533333,
    longitude: -92.083333,
    icao: "KOPL"
  },
  OPO: {
    iata: "OPO",
    name: "Porto Airport",
    city: "Porto",
    countryId: "PT",
    timeZoneRegionName: "Europe/Lisbon",
    latitude: 41.237774,
    longitude: -8.670272,
    icao: "LPPR"
  },
  OPP: {
    iata: "OPP",
    name: "Salinopolis Airport",
    city: "Salinopolis",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -0.696026,
    longitude: -47.3336014,
    icao: ""
  },
  OPS: {
    iata: "OPS",
    name: "Sinop Airport",
    city: "Sinop",
    countryId: "BR",
    timeZoneRegionName: "America/Campo_Grande",
    latitude: -11.878573,
    longitude: -55.58156,
    icao: "SWSI"
  },
  OQN: {
    iata: "OQN",
    name: "Qoqon Airport",
    city: "Qoqon",
    countryId: "UZ",
    timeZoneRegionName: "Asia/Tashkent",
    latitude: 40.45,
    longitude: 70.9894,
    icao: ""
  },
  ORA: {
    iata: "ORA",
    name: "Oran Airport",
    city: "Oran",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -23.333333,
    longitude: -64.166667,
    icao: "SASO"
  },
  ORB: {
    iata: "ORB",
    name: "Orebro-Bofors Airport",
    city: "Orebro",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 59.225756,
    longitude: 15.047543,
    icao: "ESOE"
  },
  ORD: {
    iata: "ORD",
    name: "O'Hare International Airport",
    city: "Chicago",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.976912,
    longitude: -87.904876,
    icao: "KORD"
  },
  ORE: {
    iata: "ORE",
    name: "Orleans Airport",
    city: "Orleans",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 47.916667,
    longitude: 1.9,
    icao: "LFOJ"
  },
  ORF: {
    iata: "ORF",
    name: "Norfolk International Airport",
    city: "Norfolk",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 36.898583,
    longitude: -76.206295,
    icao: "KORF"
  },
  ORG: {
    iata: "ORG",
    name: "Zorg En Hoop Airport",
    city: "Paramaribo",
    countryId: "SR",
    timeZoneRegionName: "America/Paramaribo",
    latitude: 5.811089,
    longitude: -55.190965,
    icao: "SMZO"
  },
  ORH: {
    iata: "ORH",
    name: "Worcester Regional Airport",
    city: "Worcester",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.269167,
    longitude: -71.874444,
    icao: "KORH"
  },
  ORJ: {
    iata: "ORJ",
    name: "Orinduik Airport",
    city: "Orinduik",
    countryId: "GY",
    timeZoneRegionName: "America/Guyana",
    latitude: 4.716667,
    longitude: -60.033333,
    icao: "SYOR"
  },
  ORK: {
    iata: "ORK",
    name: "Cork Airport",
    city: "Cork",
    countryId: "IE",
    timeZoneRegionName: "Europe/Dublin",
    latitude: 51.849107,
    longitude: -8.489847,
    icao: "EICK"
  },
  ORL: {
    iata: "ORL",
    name: "Orlando Executive Airport",
    city: "Orlando",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 28.544167,
    longitude: -81.335556,
    icao: "KORL"
  },
  ORM: {
    iata: "ORM",
    name: "Northampton Airport",
    city: "Northampton",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 52.305302,
    longitude: -0.793056,
    icao: "EGBK"
  },
  ORN: {
    iata: "ORN",
    name: "Es Senia Airport",
    city: "Oran",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 35.620019,
    longitude: -0.606108,
    icao: "DAOO"
  },
  ORP: {
    iata: "ORP",
    name: "Orapa Airport",
    city: "Orapa",
    countryId: "BW",
    timeZoneRegionName: "Africa/Gaborone",
    latitude: -21.266701,
    longitude: 25.3167,
    icao: "FBOR"
  },
  ORT: {
    iata: "ORT",
    name: "Northway Airport",
    city: "Northway",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 62.961944,
    longitude: -141.923889,
    icao: "PAOR"
  },
  ORU: {
    iata: "ORU",
    name: "Juan Mendoza Airport",
    city: "Oruro",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -17.962283,
    longitude: -67.07796,
    icao: "SLOR"
  },
  ORV: {
    iata: "ORV",
    name: "Robert (Bob) Curtis Memorial Airport",
    city: "Noorvik",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 66.817428,
    longitude: -161.029281,
    icao: "PFNO"
  },
  ORW: {
    iata: "ORW",
    name: "Ormara Airport",
    city: "Ormara",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 25.3,
    longitude: 64.583333,
    icao: "OPOR"
  },
  ORX: {
    iata: "ORX",
    name: "Oriximina Airport",
    city: "Oriximina",
    countryId: "BR",
    timeZoneRegionName: "America/Porto_Velho",
    latitude: -1.75,
    longitude: -55.866667,
    icao: "SNOX"
  },
  ORY: {
    iata: "ORY",
    name: "Paris Orly Airport",
    city: "Paris",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 48.728283,
    longitude: 2.3597,
    icao: "LFPO"
  },
  OSC: {
    iata: "OSC",
    name: "Wurtsmith Air Force Base",
    city: "Oscoda",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 44.453811,
    longitude: -83.384978,
    icao: "KOSC"
  },
  OSD: {
    iata: "OSD",
    name: "Are Ostersund Airport",
    city: "Ostersund",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 63.198611,
    longitude: 14.494444,
    icao: "ESPC"
  },
  OSF: {
    iata: "OSF",
    name: "Ostafyevo International Airport",
    city: "Moscow",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 55.5075,
    longitude: 37.5025,
    icao: "UUMO"
  },
  OSH: {
    iata: "OSH",
    name: "Wittman Regional Airport",
    city: "Oshkosh",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 43.983889,
    longitude: -88.556944,
    icao: "KOSH"
  },
  OSI: {
    iata: "OSI",
    name: "Osijek Airport",
    city: "Osijek",
    countryId: "HR",
    timeZoneRegionName: "Europe/Zagreb",
    latitude: 45.465883,
    longitude: 18.807212,
    icao: "LDOS"
  },
  OSK: {
    iata: "OSK",
    name: "Oskarshamn Airport",
    city: "Oskarshamn",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 57.266667,
    longitude: 16.433333,
    icao: "ESMO"
  },
  OSL: {
    iata: "OSL",
    name: "Oslo Airport Gardermoen",
    city: "Oslo",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 60.194192,
    longitude: 11.100411,
    icao: "ENGM"
  },
  OSM: {
    iata: "OSM",
    name: "Mosul International Airport",
    city: "Mosul",
    countryId: "IQ",
    timeZoneRegionName: "Asia/Baghdad",
    latitude: 36.3075,
    longitude: 43.149444,
    icao: "ORBM"
  },
  OSN: {
    iata: "OSN",
    name: "Osan Air Base",
    city: "Osan",
    countryId: "KR",
    timeZoneRegionName: "Asia/Seoul",
    latitude: 37.088688,
    longitude: 127.030015,
    icao: "RKSO"
  },
  OSO: {
    iata: "OSO",
    name: "Osborne Mine Airport",
    city: "Osborne Mine",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -22.08573,
    longitude: 140.560884,
    icao: "YOSB"
  },
  OSP: {
    iata: "OSP",
    name: "Redzikowo Airport",
    city: "Slupsk",
    countryId: "PL",
    timeZoneRegionName: "Europe/Warsaw",
    latitude: 54.466667,
    longitude: 17.016667,
    icao: "EPSK"
  },
  OSR: {
    iata: "OSR",
    name: "Mosnov Airport",
    city: "Ostrava",
    countryId: "CZ",
    timeZoneRegionName: "Europe/Prague",
    latitude: 49.695517,
    longitude: 18.121285,
    icao: "LKMT"
  },
  OSS: {
    iata: "OSS",
    name: "Osh Airport",
    city: "Osh",
    countryId: "KG",
    timeZoneRegionName: "Asia/Bishkek",
    latitude: 40.60769,
    longitude: 72.786482,
    icao: "UAFO"
  },
  OST: {
    iata: "OST",
    name: "Ostend-Bruges International Airport",
    city: "Ostend",
    countryId: "BE",
    timeZoneRegionName: "Europe/Brussels",
    latitude: 51.199722,
    longitude: 2.863611,
    icao: "EBOS"
  },
  OSU: {
    iata: "OSU",
    name: "Ohio State University Airport",
    city: "Columbus",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.075696,
    longitude: -83.074769,
    icao: "KOSU"
  },
  OSW: {
    iata: "OSW",
    name: "Orsk Airport",
    city: "Orsk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yekaterinburg",
    latitude: 51.072498,
    longitude: 58.5956,
    icao: "UWOR"
  },
  OSX: {
    iata: "OSX",
    name: "Attala County Airport",
    city: "Kosciusko",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 33.066667,
    longitude: -89.583333,
    icao: "KOSX"
  },
  OSY: {
    iata: "OSY",
    name: "Namsos Airport",
    city: "Namsos",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 64.47273,
    longitude: 11.570002,
    icao: "ENNM"
  },
  OTC: {
    iata: "OTC",
    name: "Bol Airport",
    city: "Bol",
    countryId: "TD",
    timeZoneRegionName: "Africa/Ndjamena",
    latitude: 13.433333,
    longitude: 14.733333,
    icao: "FTTL"
  },
  OTG: {
    iata: "OTG",
    name: "Worthington Airport",
    city: "Worthington",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 43.652222,
    longitude: -95.583611,
    icao: "KOTG"
  },
  OTH: {
    iata: "OTH",
    name: "Southwest Oregon Regional Airport",
    city: "North Bend",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 43.416235,
    longitude: -124.245908,
    icao: "KOTH"
  },
  OTI: {
    iata: "OTI",
    name: "Pitu Airport",
    city: "Morotai Island",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jayapura",
    latitude: 2.04599,
    longitude: 128.324997,
    icao: "WAMR"
  },
  OTJ: {
    iata: "OTJ",
    name: "Otjiwarongo Airport",
    city: "Otjiwarongo",
    countryId: "NA",
    timeZoneRegionName: "Africa/Windhoek",
    latitude: -20.430556,
    longitude: 16.6625,
    icao: "FYOW"
  },
  OTK: {
    iata: "OTK",
    name: "Tillamook Airport",
    city: "Tillamook",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 45.417299,
    longitude: -123.814525,
    icao: "KTMK"
  },
  OTL: {
    iata: "OTL",
    name: "Boutilimit Airport",
    city: "Boutilimit",
    countryId: "MR",
    timeZoneRegionName: "Africa/Nouakchott",
    latitude: 17.75,
    longitude: -14.666667,
    icao: "GQNB"
  },
  OTM: {
    iata: "OTM",
    name: "Industrial Airport",
    city: "Ottumwa",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.106389,
    longitude: -92.449167,
    icao: "KOTM"
  },
  OTP: {
    iata: "OTP",
    name: "Bucharest Henri Coanda International Airport",
    city: "Bucharest",
    countryId: "RO",
    timeZoneRegionName: "Europe/Bucharest",
    latitude: 44.571155,
    longitude: 26.077063,
    icao: "LROP"
  },
  OTR: {
    iata: "OTR",
    name: "Coto 47 Airport",
    city: "Coto 47",
    countryId: "CR",
    timeZoneRegionName: "America/Costa_Rica",
    latitude: 8.566667,
    longitude: -82.933333,
    icao: "MRCC"
  },
  OTU: {
    iata: "OTU",
    name: "Otu Airport",
    city: "Otu",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 7,
    longitude: -74.716667,
    icao: "SKOT"
  },
  OTZ: {
    iata: "OTZ",
    name: "Ralph Wien Memorial Airport",
    city: "Kotzebue",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 66.890613,
    longitude: -162.602699,
    icao: "PAOT"
  },
  OUA: {
    iata: "OUA",
    name: "Ouagadougou International Airport",
    city: "Ouagadougou",
    countryId: "BF",
    timeZoneRegionName: "Africa/Ouagadougou",
    latitude: 12.355019,
    longitude: -1.514283,
    icao: "DFFD"
  },
  OUD: {
    iata: "OUD",
    name: "Les Angades Airport",
    city: "Oujda",
    countryId: "MA",
    timeZoneRegionName: "Africa/Casablanca",
    latitude: 34.783333,
    longitude: -1.933333,
    icao: "GMFO"
  },
  OUE: {
    iata: "OUE",
    name: "Ouesso Airport",
    city: "Ouesso",
    countryId: "CG",
    timeZoneRegionName: "Africa/Brazzaville",
    latitude: 1.616667,
    longitude: 16.048611,
    icao: "FCOU"
  },
  OUG: {
    iata: "OUG",
    name: "Ouahigouya Airport",
    city: "Ouahigouya",
    countryId: "BF",
    timeZoneRegionName: "Africa/Ouagadougou",
    latitude: 13.516667,
    longitude: -2.333333,
    icao: "DFCC"
  },
  OUH: {
    iata: "OUH",
    name: "Oudtshoorn Airport",
    city: "Oudtshoorn",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -33.603333,
    longitude: 22.188333,
    icao: "FAOH"
  },
  OUL: {
    iata: "OUL",
    name: "Oulu Airport",
    city: "Oulu",
    countryId: "FI",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 64.93012,
    longitude: 25.375425,
    icao: "EFOU"
  },
  OUN: {
    iata: "OUN",
    name: "Max Westheimer Airport",
    city: "Norman",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.24507,
    longitude: -97.471223,
    icao: "KOUN"
  },
  OUR: {
    iata: "OUR",
    name: "Batouri Airport",
    city: "Batouri",
    countryId: "CM",
    timeZoneRegionName: "Africa/Douala",
    latitude: 4.473056,
    longitude: 14.363611,
    icao: "FKKI"
  },
  OUS: {
    iata: "OUS",
    name: "Ourinhos Airport",
    city: "Ourinhos",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -22.966667,
    longitude: -49.916667,
    icao: "SDOU"
  },
  OUT: {
    iata: "OUT",
    name: "Bousso Airport",
    city: "Bousso",
    countryId: "TD",
    timeZoneRegionName: "Africa/Ndjamena",
    latitude: 10.483333,
    longitude: 16.716667,
    icao: "FTTS"
  },
  OUZ: {
    iata: "OUZ",
    name: "Tazadit Airport",
    city: "Zouerate",
    countryId: "MR",
    timeZoneRegionName: "Africa/Nouakchott",
    latitude: 22.757367,
    longitude: -12.481762,
    icao: "GQPZ"
  },
  OVA: {
    iata: "OVA",
    name: "Bekily Airport",
    city: "Bekily",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -24.2325,
    longitude: 45.305,
    icao: "FMSL"
  },
  OVB: {
    iata: "OVB",
    name: "Novosibirsk Tolmachevo Airport",
    city: "Novosibirsk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Novosibirsk",
    latitude: 55.009011,
    longitude: 82.666999,
    icao: "UNNT"
  },
  OVD: {
    iata: "OVD",
    name: "Asturias Airport",
    city: "Asturias",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 43.55891,
    longitude: -6.032094,
    icao: "LEAS"
  },
  OVE: {
    iata: "OVE",
    name: "Oroville Airport",
    city: "Oroville",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 39.5,
    longitude: -121.616667,
    icao: "KOVE"
  },
  OVS: {
    iata: "OVS",
    name: "Sovetsky Airport",
    city: "Sovetsky",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yekaterinburg",
    latitude: 61.325288,
    longitude: 63.603381,
    icao: "USHS"
  },
  OWA: {
    iata: "OWA",
    name: "Owatonna Airport",
    city: "Owatonna",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 44.1,
    longitude: -93.166667,
    icao: "KOWA"
  },
  OWB: {
    iata: "OWB",
    name: "Daviess County Airport",
    city: "Owensboro",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 37.740833,
    longitude: -87.165833,
    icao: "KOWB"
  },
  OWD: {
    iata: "OWD",
    name: "Norwood Memorial Airport",
    city: "Norwood",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.192124,
    longitude: -71.176789,
    icao: "KOWD"
  },
  OWK: {
    iata: "OWK",
    name: "Central Maine Airport",
    city: "Norridgewock",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 44.716667,
    longitude: -69.8,
    icao: "KOWK"
  },
  OXB: {
    iata: "OXB",
    name: "Osvaldo Vieira Airport",
    city: "Bissau",
    countryId: "GW",
    timeZoneRegionName: "Africa/Bissau",
    latitude: 11.888889,
    longitude: -15.657222,
    icao: "GGOV"
  },
  OXC: {
    iata: "OXC",
    name: "Waterbury-Oxford Airport",
    city: "Oxford",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.479167,
    longitude: -73.136389,
    icao: "KOXC"
  },
  OXD: {
    iata: "OXD",
    name: "Miami University Airport",
    city: "Oxford",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.860278,
    longitude: -84.761111,
    icao: "KOXD"
  },
  OXF: {
    iata: "OXF",
    name: "London Oxford Airport",
    city: "Oxford",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.836944,
    longitude: -1.32,
    icao: "EGTK"
  },
  OXR: {
    iata: "OXR",
    name: "Oxnard Airport",
    city: "Oxnard",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 34.201111,
    longitude: -119.206389,
    icao: "KOXR"
  },
  OXY: {
    iata: "OXY",
    name: "Morney Airport",
    city: "Morney",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -25.35,
    longitude: 141.366667,
    icao: "YMNY"
  },
  OYA: {
    iata: "OYA",
    name: "Goya Airport",
    city: "Goya",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -29.103333,
    longitude: -59.216667,
    icao: "SATG"
  },
  OYC: {
    iata: "OYC",
    name: "Camopi Airport",
    city: "Camopi",
    countryId: "GF",
    timeZoneRegionName: "America/Cayenne",
    latitude: 3.173043,
    longitude: -52.337194,
    icao: ""
  },
  OYE: {
    iata: "OYE",
    name: "Oyem Airport",
    city: "Oyem",
    countryId: "GA",
    timeZoneRegionName: "Africa/Libreville",
    latitude: 1.536975,
    longitude: 11.578365,
    icao: "FOGO"
  },
  OYK: {
    iata: "OYK",
    name: "Oiapoque Airport",
    city: "Oiapoque",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: 3.883333,
    longitude: -51.783333,
    icao: "SBOI"
  },
  OYL: {
    iata: "OYL",
    name: "Moyale Airport",
    city: "Moyale",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: 3.471859,
    longitude: 39.099871,
    icao: "HKMY"
  },
  OYO: {
    iata: "OYO",
    name: "Tres Arroyos Airport",
    city: "Tres Arroyos",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -38.366667,
    longitude: -60.25,
    icao: "SAZH"
  },
  OYP: {
    iata: "OYP",
    name: "St. Georges de L/Oyapock Airport",
    city: "Saint Georges de L/Oyapock",
    countryId: "GF",
    timeZoneRegionName: "America/Cayenne",
    latitude: 3.9,
    longitude: -51.8,
    icao: "SOOG"
  },
  OZA: {
    iata: "OZA",
    name: "Ozona Airport",
    city: "Ozona",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.716667,
    longitude: -101.216667,
    icao: "KOZA"
  },
  OZC: {
    iata: "OZC",
    name: "Labo Airport",
    city: "Ozamiz",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 8.181967,
    longitude: 123.845414,
    icao: "RPMO"
  },
  OZG: {
    iata: "OZG",
    name: "Zagora Airport",
    city: "Zagora",
    countryId: "MA",
    timeZoneRegionName: "Africa/Casablanca",
    latitude: 30.267143,
    longitude: -5.852456,
    icao: "GMAZ"
  },
  OZH: {
    iata: "OZH",
    name: "Zaporozhye Airport",
    city: "Zaporozhye",
    countryId: "UA",
    timeZoneRegionName: "Europe/Kiev",
    latitude: 47.8675,
    longitude: 35.315833,
    icao: "UKDE"
  },
  OZP: {
    iata: "OZP",
    name: "Moron Air Base",
    city: "Moron",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 37.169797,
    longitude: -5.611906,
    icao: "LEMO"
  },
  OZR: {
    iata: "OZR",
    name: "Cairns Army Air Field",
    city: "Ozark",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 31.276799,
    longitude: -85.710038,
    icao: "KOZR"
  },
  OZZ: {
    iata: "OZZ",
    name: "Ouarzazate Airport",
    city: "Ouarzazate",
    countryId: "MA",
    timeZoneRegionName: "Africa/Casablanca",
    latitude: 30.916667,
    longitude: -6.916667,
    icao: "GMMZ"
  },
  PAA: {
    iata: "PAA",
    name: "Pa-an Airport",
    city: "Pa-an",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 16.892778,
    longitude: 97.678333,
    icao: "VYPA"
  },
  PAB: {
    iata: "PAB",
    name: "Bilaspur Airport",
    city: "Bilaspur",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 31.316667,
    longitude: 76.833333,
    icao: "VABI"
  },
  PAC: {
    iata: "PAC",
    name: "Marcos A. Gelabert International Airport",
    city: "Panama City",
    countryId: "PA",
    timeZoneRegionName: "America/Panama",
    latitude: 8.971004,
    longitude: -79.555613,
    icao: "MPMG"
  },
  PAD: {
    iata: "PAD",
    name: "Paderborn Lippstadt Airport",
    city: "Paderborn",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 51.610332,
    longitude: 8.619832,
    icao: "EDLP"
  },
  PAE: {
    iata: "PAE",
    name: "Snohomish County Airport",
    city: "Everett",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 47.909744,
    longitude: -122.285618,
    icao: "KPAE"
  },
  PAF: {
    iata: "PAF",
    name: "Pakuba Airport",
    city: "Pakuba",
    countryId: "UG",
    timeZoneRegionName: "Africa/Kampala",
    latitude: 2.203072,
    longitude: 31.554146,
    icao: "HUPA"
  },
  PAG: {
    iata: "PAG",
    name: "Pagadian Airport",
    city: "Pagadian",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 7.826667,
    longitude: 123.4575,
    icao: "RPMP"
  },
  PAH: {
    iata: "PAH",
    name: "Barkley Regional Airport",
    city: "Paducah",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 37.061111,
    longitude: -88.7725,
    icao: "KPAH"
  },
  PAJ: {
    iata: "PAJ",
    name: "Para Chinar Airport",
    city: "Para Chinar",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 33.9,
    longitude: 70.1,
    icao: "OPPC"
  },
  PAL: {
    iata: "PAL",
    name: "Palanquero Airport",
    city: "Palanquero",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 5.48361,
    longitude: -74.6574,
    icao: "SKPQ"
  },
  PAM: {
    iata: "PAM",
    name: "Tyndall Air Force Base",
    city: "Panama City",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.066928,
    longitude: -85.575637,
    icao: "KPAM"
  },
  PAN: {
    iata: "PAN",
    name: "Pattani Airport",
    city: "Pattani",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 6.777222,
    longitude: 101.158333,
    icao: "VTSK"
  },
  PAO: {
    iata: "PAO",
    name: "Palo Alto Airport of Santa Clara County",
    city: "Palo Alto",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 37.460661,
    longitude: -122.115247,
    icao: "KPAO"
  },
  PAP: {
    iata: "PAP",
    name: "Toussaint Louverture International Airport",
    city: "Port Au Prince",
    countryId: "HT",
    timeZoneRegionName: "America/Port-au-Prince",
    latitude: 18.575394,
    longitude: -72.294712,
    icao: "MTPP"
  },
  PAQ: {
    iata: "PAQ",
    name: "Palmer Municipal Airport",
    city: "Palmer",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 61.601497,
    longitude: -149.087667,
    icao: "PAAQ"
  },
  PAR: {
    iata: "PAR",
    name: "Paris Metropolitan",
    city: "Paris",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 48.833333,
    longitude: 2.331938,
    icao: "LFPW"
  },
  PAS: {
    iata: "PAS",
    name: "Paros Airport",
    city: "Paros",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 37.066667,
    longitude: 25.1,
    icao: "LGPA"
  },
  PAT: {
    iata: "PAT",
    name: "Jay Prakash Narayan International Airport",
    city: "Patna",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 25.594891,
    longitude: 85.090669,
    icao: "VEPT"
  },
  PAU: {
    iata: "PAU",
    name: "Pauk Airport",
    city: "Pauk",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 21.45,
    longitude: 94.516667,
    icao: "VYPK"
  },
  PAV: {
    iata: "PAV",
    name: "Paulo Afonso Airport",
    city: "Paulo Afonso",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -9.40077,
    longitude: -38.249916,
    icao: "SBUF"
  },
  PAX: {
    iata: "PAX",
    name: "Port De Paix Airport",
    city: "Port De Paix",
    countryId: "HT",
    timeZoneRegionName: "America/Port-au-Prince",
    latitude: 19.933333,
    longitude: -72.841667,
    icao: "MTPX"
  },
  PAZ: {
    iata: "PAZ",
    name: "El Tajin National Airport",
    city: "Poza Rica",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 20.600162,
    longitude: -97.460548,
    icao: "MMPA"
  },
  PBA: {
    iata: "PBA",
    name: "Cairu Fabio Perini Airport",
    city: "Cairu",
    countryId: "BR",
    timeZoneRegionName: "America/Bahia",
    latitude: -13.56444,
    longitude: -38.93889,
    icao: ""
  },
  PBB: {
    iata: "PBB",
    name: "Paranaiba Airport",
    city: "Paranaiba",
    countryId: "BR",
    timeZoneRegionName: "America/Campo_Grande",
    latitude: -19.649901,
    longitude: -51.202139,
    icao: "SSPN"
  },
  PBC: {
    iata: "PBC",
    name: "Huejotsingo Airport",
    city: "Puebla",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 19.135,
    longitude: -98.3675,
    icao: "MMPB"
  },
  PBD: {
    iata: "PBD",
    name: "Porbandar Airport",
    city: "Porbandar",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 21.647222,
    longitude: 69.656944,
    icao: "VAPR"
  },
  PBE: {
    iata: "PBE",
    name: "Puerto Berrio Airport",
    city: "Puerto Berrio",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 6.483333,
    longitude: -74.483333,
    icao: "SKPR"
  },
  PBF: {
    iata: "PBF",
    name: "Grider Field",
    city: "Pine Bluff",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 34.175556,
    longitude: -91.935556,
    icao: "KPBF"
  },
  PBG: {
    iata: "PBG",
    name: "Plattsburgh International Airport",
    city: "Plattsburgh",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 44.658745,
    longitude: -73.465092,
    icao: "KPBG"
  },
  PBH: {
    iata: "PBH",
    name: "Paro Airport",
    city: "Paro",
    countryId: "BT",
    timeZoneRegionName: "Asia/Thimphu",
    latitude: 27.433333,
    longitude: 89.416667,
    icao: "VQPR"
  },
  PBI: {
    iata: "PBI",
    name: "Palm Beach International Airport",
    city: "West Palm Beach",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 26.683164,
    longitude: -80.095589,
    icao: "KPBI"
  },
  PBL: {
    iata: "PBL",
    name: "General Bartolome Salom International Airport",
    city: "Puerto Cabello",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 10.479167,
    longitude: -68.073611,
    icao: "SVPC"
  },
  PBM: {
    iata: "PBM",
    name: "Zanderij International Airport",
    city: "Paramaribo",
    countryId: "SR",
    timeZoneRegionName: "America/Paramaribo",
    latitude: 5.451389,
    longitude: -55.191111,
    icao: "SMJP"
  },
  PBN: {
    iata: "PBN",
    name: "Porto Amboim Airport",
    city: "Porto Amboim",
    countryId: "AO",
    timeZoneRegionName: "Africa/Luanda",
    latitude: -10.7,
    longitude: 13.75,
    icao: "FNPA"
  },
  PBO: {
    iata: "PBO",
    name: "Paraburdoo Airport",
    city: "Paraburdoo",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -23.173908,
    longitude: 117.748002,
    icao: "APPB"
  },
  PBQ: {
    iata: "PBQ",
    name: "Pimenta Bueno Airport",
    city: "Pimenta Bueno",
    countryId: "BR",
    timeZoneRegionName: "America/Porto_Velho",
    latitude: -11.7,
    longitude: -61.2,
    icao: "SWPM"
  },
  PBR: {
    iata: "PBR",
    name: "Puerto Barrios Airport",
    city: "Puerto Barrios",
    countryId: "GT",
    timeZoneRegionName: "America/Guatemala",
    latitude: 15.730871,
    longitude: -88.583744,
    icao: "MGPB"
  },
  PBU: {
    iata: "PBU",
    name: "Putao Airport",
    city: "Putao",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 27.333333,
    longitude: 97.416667,
    icao: "VYPT"
  },
  PBV: {
    iata: "PBV",
    name: "Porto Dos Gauchos Airport",
    city: "Porto Dos Gauchos",
    countryId: "BR",
    timeZoneRegionName: "America/Campo_Grande",
    latitude: -11.541461,
    longitude: -57.365343,
    icao: "SWPG"
  },
  PBZ: {
    iata: "PBZ",
    name: "Plettenberg Bay Airport",
    city: "Plettenberg Bay",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -34.088225,
    longitude: 23.328589,
    icao: "KPBZ"
  },
  PCA: {
    iata: "PCA",
    name: "Portage Creek Airport",
    city: "Portage Creek",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 58.901389,
    longitude: -157.701944,
    icao: "PAOC"
  },
  PCD: {
    iata: "PCD",
    name: "Prairie Du Chien Municipal Airport",
    city: "Prairie Du Chien",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 43.016667,
    longitude: -91.116667,
    icao: "KPDC"
  },
  PCL: {
    iata: "PCL",
    name: "Capitan Rolden Airport",
    city: "Pucallpa",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -8.384505,
    longitude: -74.574745,
    icao: "SPCL"
  },
  PCN: {
    iata: "PCN",
    name: "Picton Aerodrome",
    city: "Picton",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -41.342834,
    longitude: 173.959595,
    icao: "NZOK"
  },
  PCP: {
    iata: "PCP",
    name: "Principe Airport",
    city: "Principe",
    countryId: "ST",
    timeZoneRegionName: "Africa/Sao_Tome",
    latitude: 1.665093,
    longitude: 7.412398,
    icao: "FPPR"
  },
  PCQ: {
    iata: "PCQ",
    name: "Boun Neua Airport",
    city: "Phongsaly",
    countryId: "LA",
    timeZoneRegionName: "Asia/Vientiane",
    latitude: 21.645601,
    longitude: 101.900337,
    icao: ""
  },
  PCR: {
    iata: "PCR",
    name: "Puerto Carreno Airport",
    city: "Puerto Carreno",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 6.183333,
    longitude: -67.633333,
    icao: "SKPC"
  },
  PCS: {
    iata: "PCS",
    name: "Picos Airport",
    city: "Picos",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -7.083333,
    longitude: -41.466667,
    icao: "SNPC"
  },
  PCU: {
    iata: "PCU",
    name: "Pearl River County Airport",
    city: "Picayune",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.433333,
    longitude: -89.683333,
    icao: "KPCU"
  },
  PDA: {
    iata: "PDA",
    name: "Puerto Inirida Airport",
    city: "Puerto Inirida",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 3.883333,
    longitude: -67.883333,
    icao: "SKPD"
  },
  PDB: {
    iata: "PDB",
    name: "Pedro Bay Airport",
    city: "Pedro Bay",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 59.797036,
    longitude: -154.130286,
    icao: ""
  },
  PDD: {
    iata: "PDD",
    name: "Ponta De Ouro",
    city: "Ponta De Ouro",
    countryId: "MZ",
    timeZoneRegionName: "Africa/Maputo",
    latitude: -26.783056,
    longitude: 32.880556,
    icao: "FQPO"
  },
  PDF: {
    iata: "PDF",
    name: "Prado Airport",
    city: "Prado",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -17.35,
    longitude: -39.216667,
    icao: "SNRD"
  },
  PDG: {
    iata: "PDG",
    name: "Minangkabau International Airport",
    city: "Padang",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: -0.786667,
    longitude: 100.280556,
    icao: "WIEE"
  },
  PDK: {
    iata: "PDK",
    name: "DeKalb Peachtree Airport",
    city: "Atlanta",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 33.875556,
    longitude: -84.301944,
    icao: "KPDK"
  },
  PDL: {
    iata: "PDL",
    name: "Joao Paulo II Airport",
    city: "Ponta Delgada (Azores)",
    countryId: "PT",
    timeZoneRegionName: "Atlantic/Azores",
    latitude: 37.743847,
    longitude: -25.696469,
    icao: "LPPD"
  },
  PDP: {
    iata: "PDP",
    name: "Capitan de Corbeta Carlos A. Curbelo International Airport",
    city: "Punta Del Este",
    countryId: "UY",
    timeZoneRegionName: "America/Montevideo",
    latitude: -34.857213,
    longitude: -55.093164,
    icao: "SULS"
  },
  PDS: {
    iata: "PDS",
    name: "Piedras Negras International Airport",
    city: "Piedras Negras",
    countryId: "MX",
    timeZoneRegionName: "America/Matamoros",
    latitude: 28.628948,
    longitude: -100.53604,
    icao: "MMPG"
  },
  PDT: {
    iata: "PDT",
    name: "Eastern Oregon Regional Airport",
    city: "Pendleton",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 45.693009,
    longitude: -118.843229,
    icao: "KPDT"
  },
  PDU: {
    iata: "PDU",
    name: "Paysandu Airport",
    city: "Paysandu",
    countryId: "UY",
    timeZoneRegionName: "America/Montevideo",
    latitude: -32.365833,
    longitude: -58.064167,
    icao: "SUPU"
  },
  PDV: {
    iata: "PDV",
    name: "Plovdiv Airport",
    city: "Plovdiv",
    countryId: "BG",
    timeZoneRegionName: "Europe/Sofia",
    latitude: 42.067799,
    longitude: 24.8508,
    icao: "LBPD"
  },
  PDX: {
    iata: "PDX",
    name: "Portland International Airport",
    city: "Portland",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 45.588995,
    longitude: -122.592901,
    icao: "KPDX"
  },
  PED: {
    iata: "PED",
    name: "Pardubice Airport",
    city: "Pardubice",
    countryId: "CZ",
    timeZoneRegionName: "Europe/Prague",
    latitude: 50.013333,
    longitude: 15.738611,
    icao: "LKPD"
  },
  PEE: {
    iata: "PEE",
    name: "Perm International Airport",
    city: "Perm",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yekaterinburg",
    latitude: 57.920026,
    longitude: 56.019179,
    icao: "USPP"
  },
  PEG: {
    iata: "PEG",
    name: "Sant Egidio Airport",
    city: "Perugia",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 43.097819,
    longitude: 12.51386,
    icao: "LIRZ"
  },
  PEH: {
    iata: "PEH",
    name: "Pehuajo Airport",
    city: "Pehuajo",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -35.85,
    longitude: -61.866667,
    icao: "SAZP"
  },
  PEI: {
    iata: "PEI",
    name: "Matecana International Airport",
    city: "Pereira",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 4.815945,
    longitude: -75.736531,
    icao: "SKPE"
  },
  PEK: {
    iata: "PEK",
    name: "Beijing Capital International Airport",
    city: "Beijing",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 40.078538,
    longitude: 116.587095,
    icao: "ZBAA"
  },
  PEM: {
    iata: "PEM",
    name: "Puerto Maldonado Airport",
    city: "Puerto Maldonado",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -12.583333,
    longitude: -69.233333,
    icao: "SPTU"
  },
  PEN: {
    iata: "PEN",
    name: "Penang International Airport",
    city: "Penang",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 5.292961,
    longitude: 100.265173,
    icao: "WMKP"
  },
  PEQ: {
    iata: "PEQ",
    name: "Pecos Municipal Airport",
    city: "Pecos City",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 31.382401,
    longitude: -103.511002,
    icao: "KPEQ"
  },
  PER: {
    iata: "PER",
    name: "Perth Airport",
    city: "Perth",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -31.933604,
    longitude: 115.960236,
    icao: "YPPH"
  },
  PES: {
    iata: "PES",
    name: "Petrozavodsk Airport",
    city: "Petrozavodsk",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 61.878284,
    longitude: 34.153871,
    icao: "ULPB"
  },
  PET: {
    iata: "PET",
    name: "Federal Airport",
    city: "Pelotas",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -31.718056,
    longitude: -52.324444,
    icao: "SBPK"
  },
  PEU: {
    iata: "PEU",
    name: "Puerto Lempira Airport",
    city: "Puerto Lempira",
    countryId: "HN",
    timeZoneRegionName: "America/Tegucigalpa",
    latitude: 15.2622,
    longitude: -83.781197,
    icao: "MHPL"
  },
  PEW: {
    iata: "PEW",
    name: "Bacha Khan International Airport",
    city: "Peshawar",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 33.989083,
    longitude: 71.519252,
    icao: "OPPS"
  },
  PEX: {
    iata: "PEX",
    name: "Pechora Airport",
    city: "Pechora",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 65.116667,
    longitude: 57.133333,
    icao: "UUYP"
  },
  PEZ: {
    iata: "PEZ",
    name: "Penza Ternovka Airport",
    city: "Penza",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 53.118517,
    longitude: 45.023048,
    icao: "UWPP"
  },
  PFB: {
    iata: "PFB",
    name: "Passo Fundo Airport",
    city: "Passo Fundo",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -28.25,
    longitude: -52.333333,
    icao: "SBPF"
  },
  PFC: {
    iata: "PFC",
    name: "Pacific City State Airport",
    city: "Pacific City",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 45.199796,
    longitude: -123.962047,
    icao: "KPFC"
  },
  PFJ: {
    iata: "PFJ",
    name: "Patrekstjord Airport",
    city: "Patrekstjord",
    countryId: "IS",
    timeZoneRegionName: "Atlantic/Reykjavik",
    latitude: 65.033333,
    longitude: -19.008333,
    icao: "BIPA"
  },
  PFO: {
    iata: "PFO",
    name: "Paphos International Airport",
    city: "Paphos",
    countryId: "CY",
    timeZoneRegionName: "Asia/Nicosia",
    latitude: 34.711552,
    longitude: 32.489104,
    icao: "LCPH"
  },
  PFQ: {
    iata: "PFQ",
    name: "Parsabad Moghan Airport",
    city: "Parsabad",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 39.606892,
    longitude: 47.877521,
    icao: "OITP"
  },
  PFR: {
    iata: "PFR",
    name: "Ilebo Airport",
    city: "Ilebo",
    countryId: "CD",
    timeZoneRegionName: "Africa/Lubumbashi",
    latitude: -4.316667,
    longitude: 20.583333,
    icao: "FZVS"
  },
  PFT: {
    iata: "PFT",
    name: "Pazhou Bus Station",
    city: "Guangzhou",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 23.1039,
    longitude: 113.3628,
    icao: ""
  },
  PGA: {
    iata: "PGA",
    name: "Page Airport",
    city: "Page",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 36.926389,
    longitude: -111.447222,
    icao: "KPGA"
  },
  PGD: {
    iata: "PGD",
    name: "Charlotte County Airport",
    city: "Punta Gorda",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 26.919167,
    longitude: -81.991389,
    icao: "KPGD"
  },
  PGF: {
    iata: "PGF",
    name: "Llabanere Airport",
    city: "Perpignan",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 42.741018,
    longitude: 2.868183,
    icao: "LFMP"
  },
  PGH: {
    iata: "PGH",
    name: "Pantnagar Airport",
    city: "Pantnagar",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 29.031944,
    longitude: 79.473611,
    icao: "VIPT"
  },
  PGK: {
    iata: "PGK",
    name: "Depati Amir Airport",
    city: "Pangkal Pinang",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: -2.164017,
    longitude: 106.137071,
    icao: "WIPK"
  },
  PGQ: {
    iata: "PGQ",
    name: "Buli Airport",
    city: "Buil",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: 0.918889,
    longitude: 128.3825,
    icao: "WAME"
  },
  PGR: {
    iata: "PGR",
    name: "Kirk Field",
    city: "Paragould",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.062905,
    longitude: -90.507802,
    icao: "KPGR"
  },
  PGU: {
    iata: "PGU",
    name: "Ala'Marvdasht Airport",
    city: "Ala'Marvdasht",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 27.383959,
    longitude: 52.735514,
    icao: "OIBP"
  },
  PGV: {
    iata: "PGV",
    name: "Pitt-Greenville Airport",
    city: "Greenville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 35.633333,
    longitude: -77.385278,
    icao: "KPGV"
  },
  PGX: {
    iata: "PGX",
    name: "Perigueux Airport",
    city: "Perigueux",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 45.183333,
    longitude: 0.716667,
    icao: "LFBX"
  },
  PGZ: {
    iata: "PGZ",
    name: "Comte Antonio Amilton Beraldo Airport",
    city: "Ponta Grossa",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -25.185669,
    longitude: -50.145818,
    icao: "SSZW"
  },
  PHB: {
    iata: "PHB",
    name: "Parnaiba-Prefeito Dr. Joao Silva Filho International Airport",
    city: "Parnaiba",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -2.894273,
    longitude: -41.730505,
    icao: "SBPB"
  },
  PHC: {
    iata: "PHC",
    name: "Port Harcourt International Airport",
    city: "Port Harcourt",
    countryId: "NG",
    timeZoneRegionName: "Africa/Lagos",
    latitude: 5.006506,
    longitude: 6.9499,
    icao: "DNPO"
  },
  PHD: {
    iata: "PHD",
    name: "Harry Clever Field",
    city: "New Philadelphia",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.470892,
    longitude: -81.419694,
    icao: "KPHD"
  },
  PHE: {
    iata: "PHE",
    name: "Port Hedland International Airport",
    city: "Port Hedland",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -20.377945,
    longitude: 118.63164,
    icao: "YPPD"
  },
  PHF: {
    iata: "PHF",
    name: "Newport News/Williamsburg International Airport",
    city: "Newport News",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 37.130328,
    longitude: -76.502825,
    icao: "KPHF"
  },
  PHH: {
    iata: "PHH",
    name: "Pokhara International Airport",
    city: "Pokhara",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 28.184683,
    longitude: 84.013617,
    icao: "VNPR"
  },
  PHI: {
    iata: "PHI",
    name: "Pinheiro Airport",
    city: "Pinheiro",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -2.516667,
    longitude: -45.083333,
    icao: "SNYE"
  },
  PHK: {
    iata: "PHK",
    name: "Palm Beach County Glades Airport",
    city: "Pahokee",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 26.816667,
    longitude: -80.666667,
    icao: "KPHK"
  },
  PHL: {
    iata: "PHL",
    name: "Philadelphia International Airport",
    city: "Philadelphia",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.876413,
    longitude: -75.243305,
    icao: "KPHL"
  },
  PHN: {
    iata: "PHN",
    name: "St Clair County International Airport",
    city: "Port Huron",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.913056,
    longitude: -82.526111,
    icao: "KPHN"
  },
  PHO: {
    iata: "PHO",
    name: "Point Hope Airport",
    city: "Point Hope",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 68.35,
    longitude: -166.8,
    icao: "PAPO"
  },
  PHP: {
    iata: "PHP",
    name: "Phillip Airport",
    city: "Philip",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 44.333333,
    longitude: -101.666667,
    icao: "KPHP"
  },
  PHQ: {
    iata: "PHQ",
    name: "The Monument Airport",
    city: "Phosphate Hill",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -21.811667,
    longitude: 139.923333,
    icao: "YTMO"
  },
  PHS: {
    iata: "PHS",
    name: "Phitsanulok Airport",
    city: "Phitsanulok",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 16.771307,
    longitude: 100.281196,
    icao: "VTPP"
  },
  PHT: {
    iata: "PHT",
    name: "Henry County Airport",
    city: "Paris",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.333611,
    longitude: -88.383333,
    icao: "KPHT"
  },
  PHW: {
    iata: "PHW",
    name: "Phalaborwa Airport",
    city: "Phalaborwa",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -23.933611,
    longitude: 31.156111,
    icao: "FAPH"
  },
  PHX: {
    iata: "PHX",
    name: "Phoenix Sky Harbor International Airport",
    city: "Phoenix",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 33.435036,
    longitude: -112.000164,
    icao: "KPHX"
  },
  PHY: {
    iata: "PHY",
    name: "Phetchabun Airport",
    city: "Phetchabun",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 16.675982,
    longitude: 101.195104,
    icao: "VTPB"
  },
  PIA: {
    iata: "PIA",
    name: "Peoria International Airport",
    city: "Peoria",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 40.666432,
    longitude: -89.690117,
    icao: "KPIA"
  },
  PIB: {
    iata: "PIB",
    name: "Hattiesburg-Laurel Regional Airport",
    city: "Laurel",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 31.4675,
    longitude: -89.336667,
    icao: "KPIB"
  },
  PIC: {
    iata: "PIC",
    name: "Pine Cay Airport",
    city: "Pine Cay",
    countryId: "TC",
    timeZoneRegionName: "America/Grand_Turk",
    latitude: 21.883333,
    longitude: -72.1,
    icao: "MBPI"
  },
  PID: {
    iata: "PID",
    name: "Paradise Island Airport",
    city: "Nassau",
    countryId: "BS",
    timeZoneRegionName: "America/Nassau",
    latitude: 25.083333,
    longitude: -77.3,
    icao: "MYPI"
  },
  PIE: {
    iata: "PIE",
    name: "St. Petersburg-Clearwater International Airport",
    city: "Saint Petersburg",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 27.912005,
    longitude: -82.695109,
    icao: "KPIE"
  },
  PIF: {
    iata: "PIF",
    name: "Pingtung Airport",
    city: "Pingtung",
    countryId: "TW",
    timeZoneRegionName: "Asia/Taipei",
    latitude: 22.705003,
    longitude: 120.490232,
    icao: "RCDC"
  },
  PIH: {
    iata: "PIH",
    name: "Pocatello Regional Airport",
    city: "Pocatello",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 42.909777,
    longitude: -112.585879,
    icao: "KPIH"
  },
  PIK: {
    iata: "PIK",
    name: "Glasgow Prestwick Airport",
    city: "Glasgow",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 55.508432,
    longitude: -4.611286,
    icao: "EGPK"
  },
  PIM: {
    iata: "PIM",
    name: "Garden Harris County Airport",
    city: "Pine Mountain",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 32.866667,
    longitude: -84.833333,
    icao: "KPIM"
  },
  PIN: {
    iata: "PIN",
    name: "Julio Belem Airport",
    city: "Parintins",
    countryId: "BR",
    timeZoneRegionName: "America/Porto_Velho",
    latitude: -2.673015,
    longitude: -56.777151,
    icao: "SWPI"
  },
  PIO: {
    iata: "PIO",
    name: "Capitan FAP Renan Elias Olivera Airport",
    city: "Pisco",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -13.736786,
    longitude: -76.217276,
    icao: "SPSO"
  },
  PIR: {
    iata: "PIR",
    name: "Pierre Regional Airport",
    city: "Pierre",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 44.380362,
    longitude: -100.293192,
    icao: "KPIR"
  },
  PIS: {
    iata: "PIS",
    name: "Poitiers-Biard Airport",
    city: "Poitiers",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 46.586111,
    longitude: 0.306389,
    icao: "LFBI"
  },
  PIT: {
    iata: "PIT",
    name: "Pittsburgh International Airport",
    city: "Pittsburgh",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.49585,
    longitude: -80.25657,
    icao: "KPIT"
  },
  PIU: {
    iata: "PIU",
    name: "Cap. FAP Guillermo Concha Iberico International Airport",
    city: "Piura",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -5.202246,
    longitude: -80.615623,
    icao: "SPUR"
  },
  PIV: {
    iata: "PIV",
    name: "Pirapora Airport",
    city: "Pirapora",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -17.338611,
    longitude: -44.932222,
    icao: "SNRA"
  },
  PIW: {
    iata: "PIW",
    name: "Pikwitonei Airport",
    city: "Pikwitonei",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 55.7,
    longitude: -97.333333,
    icao: "CZMN"
  },
  PIX: {
    iata: "PIX",
    name: "Pico Island Airport",
    city: "Pico Island (Azores)",
    countryId: "PT",
    timeZoneRegionName: "Atlantic/Azores",
    latitude: 38.554298,
    longitude: -28.441299,
    icao: "LPPI"
  },
  PIZ: {
    iata: "PIZ",
    name: "Dew Station Airport",
    city: "Point Lay",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 69.75,
    longitude: -163.166667,
    icao: "PPIZ"
  },
  PJA: {
    iata: "PJA",
    name: "Pajala Airport",
    city: "Pajala",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 67.245704,
    longitude: 23.068743,
    icao: "ESUP"
  },
  PJB: {
    iata: "PJB",
    name: "Payson Airport",
    city: "Payson",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 34.256544,
    longitude: -111.339588,
    icao: "KPAN"
  },
  PJG: {
    iata: "PJG",
    name: "Panjgur Airport",
    city: "Panjgur",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 26.966667,
    longitude: 64.1,
    icao: "OPPG"
  },
  PJM: {
    iata: "PJM",
    name: "Puerto Jimenez Airport",
    city: "Puerto Jimenez",
    countryId: "CR",
    timeZoneRegionName: "America/Costa_Rica",
    latitude: 8.535467,
    longitude: -83.301079,
    icao: "MRPJ"
  },
  PKB: {
    iata: "PKB",
    name: "Wood County Airport",
    city: "Parkersburg",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.345556,
    longitude: -81.438889,
    icao: "KPKB"
  },
  PKC: {
    iata: "PKC",
    name: "Petropavlovsk-Kamchatsky Airport",
    city: "Petropavlovsk-Kamchatsky",
    countryId: "RU",
    timeZoneRegionName: "Asia/Kamchatka",
    latitude: 53.175041,
    longitude: 158.446571,
    icao: "UHPP"
  },
  PKD: {
    iata: "PKD",
    name: "Park Rapids Municipal Airport-Konshok Field",
    city: "Park Rapids",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 46.898333,
    longitude: -95.071667,
    icao: "KPKD"
  },
  PKE: {
    iata: "PKE",
    name: "Parkes Airport",
    city: "Parkes",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -33.138455,
    longitude: 148.2329,
    icao: "YPKS"
  },
  PKF: {
    iata: "PKF",
    name: "Park Falls Airport",
    city: "Park Falls",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 45.933333,
    longitude: -90.533333,
    icao: "KPKF"
  },
  PKG: {
    iata: "PKG",
    name: "Pangkor Airport",
    city: "Pangkor Island",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 4.245778,
    longitude: 100.554002,
    icao: "WMPA"
  },
  PKK: {
    iata: "PKK",
    name: "Pakokku Airport",
    city: "Pakokku",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 21.404321,
    longitude: 95.11033,
    icao: "VYPU"
  },
  PKN: {
    iata: "PKN",
    name: "Iskandar Airport",
    city: "Pangkalanbun",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: -2.703815,
    longitude: 111.669942,
    icao: "WAOI"
  },
  PKO: {
    iata: "PKO",
    name: "Parakou Airport",
    city: "Parakou",
    countryId: "BJ",
    timeZoneRegionName: "Africa/Porto-Novo",
    latitude: 9.35,
    longitude: 2.616667,
    icao: "DBBP"
  },
  PKP: {
    iata: "PKP",
    name: "Puka Puka Airport",
    city: "Puka Puka",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -14.75,
    longitude: -138.966667,
    icao: "NTGP"
  },
  PKR: {
    iata: "PKR",
    name: "Pokhara Airport",
    city: "Pokhara",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 28.198646,
    longitude: 83.977761,
    icao: "VNPK"
  },
  PKT: {
    iata: "PKT",
    name: "Port Keats Airport",
    city: "Port Keats",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -14.25,
    longitude: 129.533333,
    icao: "YPKT"
  },
  PKU: {
    iata: "PKU",
    name: "Sultan Syarif Kasim II International Airport",
    city: "Pekanbaru",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: 0.464563,
    longitude: 101.446883,
    icao: "WIBB"
  },
  PKV: {
    iata: "PKV",
    name: "Pskov Airport",
    city: "Pskov",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 57.790968,
    longitude: 28.397663,
    icao: "ULOO"
  },
  PKW: {
    iata: "PKW",
    name: "Selebi-Phikwe Airport",
    city: "Selebi-Phikwe",
    countryId: "BW",
    timeZoneRegionName: "Africa/Gaborone",
    latitude: -22.05,
    longitude: 27.816667,
    icao: "FBSP"
  },
  PKX: {
    iata: "PKX",
    name: "Beijing Daxing International Airport",
    city: "Beijing",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 39.509167,
    longitude: 116.410556,
    icao: "ZBAD"
  },
  PKY: {
    iata: "PKY",
    name: "Tjilik Riwut Airport",
    city: "Palangkaraya",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: -2.223958,
    longitude: 113.945782,
    icao: "WAOP"
  },
  PKZ: {
    iata: "PKZ",
    name: "Pakse Airport",
    city: "Pakse",
    countryId: "LA",
    timeZoneRegionName: "Asia/Vientiane",
    latitude: 15.136257,
    longitude: 105.781295,
    icao: "VLPS"
  },
  PLB: {
    iata: "PLB",
    name: "Clinton County Airport",
    city: "Plattsburgh",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 44.688333,
    longitude: -73.521111,
    icao: "KPLB"
  },
  PLD: {
    iata: "PLD",
    name: "Playa Samara Airport",
    city: "Playa Samara",
    countryId: "CR",
    timeZoneRegionName: "America/Costa_Rica",
    latitude: 9.870578,
    longitude: -85.480309,
    icao: "MRCR"
  },
  PLF: {
    iata: "PLF",
    name: "Pala Airport",
    city: "Pala",
    countryId: "TD",
    timeZoneRegionName: "Africa/Ndjamena",
    latitude: 9.383333,
    longitude: 14.933333,
    icao: "FTTP"
  },
  PLH: {
    iata: "PLH",
    name: "Plymouth Airport",
    city: "Plymouth",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 50.422338,
    longitude: -4.110009,
    icao: "EGDB"
  },
  PLJ: {
    iata: "PLJ",
    name: "Placencia Airport",
    city: "Placencia",
    countryId: "BZ",
    timeZoneRegionName: "America/Belize",
    latitude: 16.537363899819816,
    longitude: -88.36161104768692,
    icao: "MZPL"
  },
  PLK: {
    iata: "PLK",
    name: "M Graham Clark Airport",
    city: "Branson/Point Lookout",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.65,
    longitude: -93.216667,
    icao: "KPLK"
  },
  PLL: {
    iata: "PLL",
    name: "Ponta Pelada Airport",
    city: "Ponta Pelada",
    countryId: "BR",
    timeZoneRegionName: "America/Porto_Velho",
    latitude: -3.145556,
    longitude: -59.984444,
    icao: "SBMN"
  },
  PLM: {
    iata: "PLM",
    name: "Sultan Mahmud Badaruddin II Airport",
    city: "Palembang",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: -2.900146,
    longitude: 104.698607,
    icao: "WIPP"
  },
  PLN: {
    iata: "PLN",
    name: "Emmet County Airport",
    city: "Pellston",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 45.570833,
    longitude: -84.792778,
    icao: "KPLN"
  },
  PLO: {
    iata: "PLO",
    name: "Port Lincoln Airport",
    city: "Port Lincoln",
    countryId: "AU",
    timeZoneRegionName: "Australia/Adelaide",
    latitude: -34.603331,
    longitude: 135.87454,
    icao: "YPLC"
  },
  PLP: {
    iata: "PLP",
    name: "La Palma Airport",
    city: "La Palma",
    countryId: "PA",
    timeZoneRegionName: "America/Panama",
    latitude: 8.333333,
    longitude: -78.133333,
    icao: "MPLP"
  },
  PLQ: {
    iata: "PLQ",
    name: "Palanga International Airport",
    city: "Palanga",
    countryId: "LT",
    timeZoneRegionName: "Europe/Vilnius",
    latitude: 55.95,
    longitude: 21.083333,
    icao: "EYPA"
  },
  PLR: {
    iata: "PLR",
    name: "St. Clair County Airport",
    city: "Pell City",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 33.583333,
    longitude: -86.283333,
    icao: "KPLR"
  },
  PLS: {
    iata: "PLS",
    name: "Providenciales International Airport",
    city: "Providenciales",
    countryId: "TC",
    timeZoneRegionName: "America/Grand_Turk",
    latitude: 21.775328,
    longitude: -72.262635,
    icao: "MBPV"
  },
  PLU: {
    iata: "PLU",
    name: "Pampulha Airport",
    city: "Belo Horizonte",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -19.851199,
    longitude: -43.950613,
    icao: "SBBH"
  },
  PLV: {
    iata: "PLV",
    name: "Poltava Airport",
    city: "Poltava",
    countryId: "UA",
    timeZoneRegionName: "Europe/Kiev",
    latitude: 49.583333,
    longitude: 34.533333,
    icao: "UKHP"
  },
  PLW: {
    iata: "PLW",
    name: "Mutiara Airport",
    city: "Palu",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -0.918617,
    longitude: 119.909729,
    icao: "WAML"
  },
  PLX: {
    iata: "PLX",
    name: "Semipalatinsk Airport",
    city: "Semipalatinsk",
    countryId: "KZ",
    timeZoneRegionName: "Asia/Almaty",
    latitude: 50.351741,
    longitude: 80.233789,
    icao: "UASS"
  },
  PLZ: {
    iata: "PLZ",
    name: "Port Elizabeth International Airport",
    city: "Port Elizabeth",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -33.98371,
    longitude: 25.611421,
    icao: "FAPE"
  },
  PMA: {
    iata: "PMA",
    name: "Wawi Airport",
    city: "Pemba",
    countryId: "TZ",
    timeZoneRegionName: "Africa/Dar_es_Salaam",
    latitude: -5.258731,
    longitude: 39.812617,
    icao: "HTPE"
  },
  PMB: {
    iata: "PMB",
    name: "Pembina Intermediate Airport",
    city: "Pembina",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 49,
    longitude: -98.083333,
    icao: "KPMB"
  },
  PMC: {
    iata: "PMC",
    name: "El Tepual Airport",
    city: "Puerto Montt",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -41.433726,
    longitude: -73.098312,
    icao: "SCTE"
  },
  PMD: {
    iata: "PMD",
    name: "Palmdale Air Force 42 Base",
    city: "Palmdale",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 34.6275,
    longitude: -118.083333,
    icao: "KPMD"
  },
  PMF: {
    iata: "PMF",
    name: "Parma Airport",
    city: "Parma",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 44.822222,
    longitude: 10.295278,
    icao: "LIMP"
  },
  PMG: {
    iata: "PMG",
    name: "Ponta Pora International Airport",
    city: "Ponta Pora",
    countryId: "BR",
    timeZoneRegionName: "America/Campo_Grande",
    latitude: -22.55,
    longitude: -55.7,
    icao: "SBPP"
  },
  PMH: {
    iata: "PMH",
    name: "Portsmouth Regional Airport",
    city: "Portsmouth",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 38.75,
    longitude: -82.983333,
    icao: "KPMH"
  },
  PMI: {
    iata: "PMI",
    name: "Palma de Mallorca Airport",
    city: "Palma de Mallorca",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 39.547654,
    longitude: 2.730388,
    icao: "LEPA"
  },
  PMK: {
    iata: "PMK",
    name: "Palm Island Airport",
    city: "Palm Island",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -18.755301,
    longitude: 146.580994,
    icao: "YPAM"
  },
  PMO: {
    iata: "PMO",
    name: "Falcone-Borsellino Airport",
    city: "Palermo",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 38.186525,
    longitude: 13.104779,
    icao: "LICJ"
  },
  PMQ: {
    iata: "PMQ",
    name: "Perito Moreno Airport",
    city: "Perito Moreno",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -46.536389,
    longitude: -70.983611,
    icao: "SAWP"
  },
  PMR: {
    iata: "PMR",
    name: "Palmerston North Airport",
    city: "Palmerston North",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -40.323534,
    longitude: 175.621268,
    icao: "NZPM"
  },
  PMS: {
    iata: "PMS",
    name: "Palmyra Airport",
    city: "Palmyra",
    countryId: "SY",
    timeZoneRegionName: "Asia/Damascus",
    latitude: 34.6,
    longitude: 38.25,
    icao: "OSPR"
  },
  PMV: {
    iata: "PMV",
    name: "Santiago Marino International Airport",
    city: "Porlamar",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 10.917189,
    longitude: -63.968992,
    icao: "SVMG"
  },
  PMW: {
    iata: "PMW",
    name: "Palmas Airport",
    city: "Palmas",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -10.294687,
    longitude: -48.357668,
    icao: "SBPJ"
  },
  PMX: {
    iata: "PMX",
    name: "Palmer Metropolitan Airport",
    city: "Palmer",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.15,
    longitude: -72.316667,
    icao: "KPMX"
  },
  PMY: {
    iata: "PMY",
    name: "El Tehuelche Airport",
    city: "Puerto Madryn",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -42.733333,
    longitude: -65.066667,
    icao: "SAVY"
  },
  PMZ: {
    iata: "PMZ",
    name: "Palmur'Sur Airport",
    city: "Palmar",
    countryId: "CR",
    timeZoneRegionName: "America/Costa_Rica",
    latitude: 8.951035,
    longitude: -83.468583,
    icao: "MRPM"
  },
  PNA: {
    iata: "PNA",
    name: "Pamplona Airport",
    city: "Pamplona",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 42.767497,
    longitude: -1.639347,
    icao: "LEPP"
  },
  PNB: {
    iata: "PNB",
    name: "Porto Nacional Airport",
    city: "Porto Nacional",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -10.7,
    longitude: -48.416667,
    icao: "SBPN"
  },
  PNC: {
    iata: "PNC",
    name: "Ponca City Regional Airport",
    city: "Ponca City",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.728056,
    longitude: -97.099444,
    icao: "KPNC"
  },
  PND: {
    iata: "PND",
    name: "Punta Gorda Airport (Belize)",
    city: "Punta Gorda",
    countryId: "BZ",
    timeZoneRegionName: "America/Belize",
    latitude: 16.10237,
    longitude: -88.807849,
    icao: ""
  },
  PNE: {
    iata: "PNE",
    name: "Northeast Philadelphia Airport",
    city: "Philadelphia",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.080278,
    longitude: -75.0125,
    icao: "KPNE"
  },
  PNG: {
    iata: "PNG",
    name: "Paranagua Municipal Airport",
    city: "Paranagua",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -25.516667,
    longitude: -48.5,
    icao: "SSPG"
  },
  PNH: {
    iata: "PNH",
    name: "Phnom Penh International Airport",
    city: "Phnom Penh",
    countryId: "KH",
    timeZoneRegionName: "Asia/Phnom_Penh",
    latitude: 11.552193,
    longitude: 104.846174,
    icao: "VDPP"
  },
  PNI: {
    iata: "PNI",
    name: "Pohnpei Airport",
    city: "Pohnpei, Caroline Islands",
    countryId: "FM",
    timeZoneRegionName: "Pacific/Pohnpei",
    latitude: 6.980947,
    longitude: 158.203343,
    icao: "PTPN"
  },
  PNK: {
    iata: "PNK",
    name: "Supadio International Airport",
    city: "Pontianak",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: -0.14735,
    longitude: 109.405328,
    icao: "WIOO"
  },
  PNL: {
    iata: "PNL",
    name: "Pantelleria Airport",
    city: "Pantelleria",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 36.813611,
    longitude: 11.966111,
    icao: "LICG"
  },
  PNN: {
    iata: "PNN",
    name: "Princeton Airport",
    city: "Princeton",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 45.233333,
    longitude: -67.566667,
    icao: "KPNN"
  },
  PNP: {
    iata: "PNP",
    name: "Popondetta Girua Airport",
    city: "Popondetta",
    countryId: "PG",
    timeZoneRegionName: "Pacific/Port_Moresby",
    latitude: -8.807474,
    longitude: 148.308728,
    icao: "AYGR"
  },
  PNQ: {
    iata: "PNQ",
    name: "Pune Airport",
    city: "Pune",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 18.581389,
    longitude: 73.920556,
    icao: "VAPO"
  },
  PNR: {
    iata: "PNR",
    name: "Pointe Noire Airport",
    city: "Pointe Noire",
    countryId: "CG",
    timeZoneRegionName: "Africa/Brazzaville",
    latitude: -4.815822,
    longitude: 11.884085,
    icao: "FCPP"
  },
  PNS: {
    iata: "PNS",
    name: "Pensacola International Airport",
    city: "Pensacola",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.475942,
    longitude: -87.194157,
    icao: "KPNS"
  },
  PNT: {
    iata: "PNT",
    name: "Teniente J. Gallardo Airport",
    city: "Puerto Natales",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -51.668664,
    longitude: -72.529105,
    icao: "SCNT"
  },
  PNY: {
    iata: "PNY",
    name: "Puducherry Airport",
    city: "Puducherry",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 11.968967,
    longitude: 79.812846,
    icao: "VOPC"
  },
  PNZ: {
    iata: "PNZ",
    name: "Petrolina International Airport",
    city: "Petrolina",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -9.365738,
    longitude: -40.565845,
    icao: "SBPL"
  },
  POA: {
    iata: "POA",
    name: "Salgado Filho International Airport",
    city: "Porto Alegre",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -29.989611,
    longitude: -51.177088,
    icao: "SBPA"
  },
  POB: {
    iata: "POB",
    name: "Pope Field",
    city: "Fayetteville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 35.170833,
    longitude: -79.014444,
    icao: "KPOB"
  },
  POC: {
    iata: "POC",
    name: "Brackett Field",
    city: "La Verne",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 34.091599,
    longitude: -117.781998,
    icao: "KPOC"
  },
  POD: {
    iata: "POD",
    name: "Podor Airport",
    city: "Podor",
    countryId: "SN",
    timeZoneRegionName: "Africa/Dakar",
    latitude: 16.666667,
    longitude: -14.966667,
    icao: "GOSP"
  },
  POE: {
    iata: "POE",
    name: "Polk Army Air Field",
    city: "Fort Polk",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 31.045833,
    longitude: -93.192222,
    icao: "KPOE"
  },
  POF: {
    iata: "POF",
    name: "Earl Fields Memorial Airport",
    city: "Poplar Bluff",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.711111,
    longitude: -90.313889,
    icao: "KPOF"
  },
  POG: {
    iata: "POG",
    name: "Port Gentil Airport",
    city: "Port Gentil",
    countryId: "GA",
    timeZoneRegionName: "Africa/Libreville",
    latitude: -0.719964,
    longitude: 8.753584,
    icao: "FOOG"
  },
  POH: {
    iata: "POH",
    name: "Pocahontas Municipal Airport",
    city: "Pocahontas",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 42.742222,
    longitude: -94.644167,
    icao: "KPOH"
  },
  POI: {
    iata: "POI",
    name: "Captain Nicolas Rojas Airport",
    city: "Potosi",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -19.543056,
    longitude: -65.723611,
    icao: "SLPO"
  },
  POJ: {
    iata: "POJ",
    name: "Patos De Minas Airport",
    city: "Patos De Minas",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -18.671667,
    longitude: -46.490833,
    icao: "SNPD"
  },
  POL: {
    iata: "POL",
    name: "Pemba Airport",
    city: "Pemba",
    countryId: "MZ",
    timeZoneRegionName: "Africa/Maputo",
    latitude: -12.988333,
    longitude: 40.5225,
    icao: "FQPB"
  },
  POM: {
    iata: "POM",
    name: "Jacksons International Airport",
    city: "Port Moresby",
    countryId: "PG",
    timeZoneRegionName: "Pacific/Port_Moresby",
    latitude: -9.444308,
    longitude: 147.214469,
    icao: "AYPY"
  },
  PON: {
    iata: "PON",
    name: "Poptun Airport",
    city: "Poptun",
    countryId: "GT",
    timeZoneRegionName: "America/Guatemala",
    latitude: 16.35,
    longitude: -89.433333,
    icao: "MGPP"
  },
  POO: {
    iata: "POO",
    name: "Pocos De Caldas Airport",
    city: "Pocos De Caldas",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -21.841389,
    longitude: -46.5675,
    icao: "SBPC"
  },
  POP: {
    iata: "POP",
    name: "La Union Airport",
    city: "Puerto Plata",
    countryId: "DO",
    timeZoneRegionName: "America/Santo_Domingo",
    latitude: 19.754942,
    longitude: -70.56315,
    icao: "MDPP"
  },
  POR: {
    iata: "POR",
    name: "Pori Airport",
    city: "Pori",
    countryId: "FI",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 61.46866,
    longitude: 21.791381,
    icao: "EFPO"
  },
  POS: {
    iata: "POS",
    name: "Piarco International Airport",
    city: "Port Of Spain",
    countryId: "TT",
    timeZoneRegionName: "America/Port_of_Spain",
    latitude: 10.602089,
    longitude: -61.339414,
    icao: "TTPP"
  },
  POT: {
    iata: "POT",
    name: "Ken Jones Airport",
    city: "Port Antonio",
    countryId: "JM",
    timeZoneRegionName: "America/Jamaica",
    latitude: 18.198333,
    longitude: -76.535556,
    icao: "MKKJ"
  },
  POU: {
    iata: "POU",
    name: "Dutchess County Airport",
    city: "Poughkeepsie",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.628056,
    longitude: -73.882778,
    icao: "KPOU"
  },
  POV: {
    iata: "POV",
    name: "Presov Airport",
    city: "Presov",
    countryId: "SK",
    timeZoneRegionName: "Europe/Bratislava",
    latitude: 49,
    longitude: 21.25,
    icao: "LZPW"
  },
  POW: {
    iata: "POW",
    name: "Portoroz Airport",
    city: "Portoroz",
    countryId: "SI",
    timeZoneRegionName: "Europe/Ljubljana",
    latitude: 45.474521,
    longitude: 13.616055,
    icao: "LJPZ"
  },
  POX: {
    iata: "POX",
    name: "Pontoise - Cormeilles Aerodrome",
    city: "Pontoise",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 49.096717,
    longitude: 2.040864,
    icao: "LFPT"
  },
  POY: {
    iata: "POY",
    name: "Powell/Lovell Airport",
    city: "Powell/Lovell",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 44.75,
    longitude: -108.766667,
    icao: "KPOY"
  },
  POZ: {
    iata: "POZ",
    name: "Poznan Airport",
    city: "Poznan",
    countryId: "PL",
    timeZoneRegionName: "Europe/Warsaw",
    latitude: 52.414327,
    longitude: 16.828845,
    icao: "EPPO"
  },
  PPA: {
    iata: "PPA",
    name: "Perry Lefors Field",
    city: "Pampa",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.533333,
    longitude: -100.966667,
    icao: "KPPA"
  },
  PPB: {
    iata: "PPB",
    name: "A. De Barros Airport",
    city: "Presidente Prudente",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -22.1751,
    longitude: -51.424599,
    icao: "SBDN"
  },
  PPC: {
    iata: "PPC",
    name: "Prospect Creek Airport",
    city: "Prospect Creek",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 66.796667,
    longitude: -150.7,
    icao: "PAPR"
  },
  PPE: {
    iata: "PPE",
    name: "Puerto Penasco Airport",
    city: "Puerto Penasco",
    countryId: "MX",
    timeZoneRegionName: "America/Hermosillo",
    latitude: 31.352573,
    longitude: -113.519369,
    icao: "MMPE"
  },
  PPF: {
    iata: "PPF",
    name: "Tri-City Airport",
    city: "Parsons",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 37.332222,
    longitude: -95.508611,
    icao: "KPPF"
  },
  PPG: {
    iata: "PPG",
    name: "Pago Pago International Airport",
    city: "Pago Pago",
    countryId: "AS",
    timeZoneRegionName: "Pacific/Pago_Pago",
    latitude: -14.326389,
    longitude: -170.696389,
    icao: "NSTU"
  },
  PPI: {
    iata: "PPI",
    name: "Port Pirie Airport",
    city: "Port Pirie",
    countryId: "AU",
    timeZoneRegionName: "Australia/Adelaide",
    latitude: -33.233333,
    longitude: 138,
    icao: "YPIR"
  },
  PPK: {
    iata: "PPK",
    name: "Petropavlovsk Airport",
    city: "Petropavlovsk",
    countryId: "KZ",
    timeZoneRegionName: "Asia/Almaty",
    latitude: 54.775735,
    longitude: 69.187045,
    icao: "UACP"
  },
  PPM: {
    iata: "PPM",
    name: "Pompano Beach Airport",
    city: "Pompano Beach",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 26.25,
    longitude: -80.116667,
    icao: "KPMP"
  },
  PPN: {
    iata: "PPN",
    name: "Guillermo Leon Valencia Airport",
    city: "Popayan",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 2.453029,
    longitude: -76.609592,
    icao: "SKPP"
  },
  PPP: {
    iata: "PPP",
    name: "Whitsunday Coast Airport",
    city: "Proserpine",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -20.488923,
    longitude: 148.551939,
    icao: "YBPN"
  },
  PPQ: {
    iata: "PPQ",
    name: "Paraparaumu Airport",
    city: "Paraparaumu",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -40.90575,
    longitude: 174.990903,
    icao: "NZPP"
  },
  PPR: {
    iata: "PPR",
    name: "Pasir Pangarayan Airport",
    city: "Pasir Pangarayan",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: 0.845755,
    longitude: 100.367981,
    icao: "WIDE"
  },
  PPS: {
    iata: "PPS",
    name: "Puerto Princesa International Airport",
    city: "Puerto Princesa",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 9.740198,
    longitude: 118.756739,
    icao: "RPVP"
  },
  PPT: {
    iata: "PPT",
    name: "Tahiti Faa'a Airport",
    city: "Papeete",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -17.559629,
    longitude: -149.609375,
    icao: "NTAA"
  },
  PPU: {
    iata: "PPU",
    name: "Papun Airport",
    city: "Papun",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 18.066667,
    longitude: 97.45,
    icao: "VYPP"
  },
  PPW: {
    iata: "PPW",
    name: "Papa Westray Airport",
    city: "Papa Westray",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 59.35145,
    longitude: -2.899779,
    icao: "EGEP"
  },
  PPY: {
    iata: "PPY",
    name: "Pouso Alegre Airport",
    city: "Pouso Alegre",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -22.288333,
    longitude: -45.918889,
    icao: "SNZA"
  },
  PQC: {
    iata: "PQC",
    name: "Phu Quoc International Airport",
    city: "Phu Quoc",
    countryId: "VN",
    timeZoneRegionName: "Asia/Ho_Chi_Minh",
    latitude: 10.169789,
    longitude: 103.993104,
    icao: "VVPQ"
  },
  PQI: {
    iata: "PQI",
    name: "Presque Isle Municipal Airport",
    city: "Presque Isle",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 46.685,
    longitude: -68.0475,
    icao: "KPQI"
  },
  PQM: {
    iata: "PQM",
    name: "Palenque International Airport",
    city: "Palenque",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 17.534443,
    longitude: -91.988926,
    icao: "MMPQ"
  },
  PQQ: {
    iata: "PQQ",
    name: "Port Macquarie Airport",
    city: "Port Macquarie",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -31.431402,
    longitude: 152.867233,
    icao: "YPMQ"
  },
  PQS: {
    iata: "PQS",
    name: "Pilot Station Airport",
    city: "Pilot Station",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 61.934722,
    longitude: -162.890556,
    icao: ""
  },
  PQT: {
    iata: "PQT",
    name: "Qeqertaq Heliport",
    city: "Qeqertaq",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 69.999466,
    longitude: -51.303705,
    icao: "BGQE"
  },
  PRA: {
    iata: "PRA",
    name: "General Justo Jose de Urquiza Airport",
    city: "Parana",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -31.794722,
    longitude: -60.480278,
    icao: "SAAP"
  },
  PRB: {
    iata: "PRB",
    name: "Paso Robles Municipal Airport",
    city: "Paso Robles",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 35.670556,
    longitude: -120.625833,
    icao: "KPRB"
  },
  PRC: {
    iata: "PRC",
    name: "Ernest A. Love Field",
    city: "Prescott",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 34.65,
    longitude: -112.424167,
    icao: "KPRC"
  },
  PRG: {
    iata: "PRG",
    name: "Vaclav Havel Airport Prague",
    city: "Prague",
    countryId: "CZ",
    timeZoneRegionName: "Europe/Prague",
    latitude: 50.106188,
    longitude: 14.266638,
    icao: "LKPR"
  },
  PRH: {
    iata: "PRH",
    name: "Phrae Airport",
    city: "Phrae",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 18.131593,
    longitude: 100.164106,
    icao: "VTCP"
  },
  PRI: {
    iata: "PRI",
    name: "Praslin Island Airport",
    city: "Praslin Island",
    countryId: "SC",
    timeZoneRegionName: "Indian/Mahe",
    latitude: -4.323883,
    longitude: 55.692313,
    icao: "FSPP"
  },
  PRK: {
    iata: "PRK",
    name: "Prieska Airport",
    city: "Prieska",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -29.666667,
    longitude: 22.7,
    icao: "FAPK"
  },
  PRM: {
    iata: "PRM",
    name: "Portimao Airport",
    city: "Portimao",
    countryId: "PT",
    timeZoneRegionName: "Europe/Lisbon",
    latitude: 37.147727,
    longitude: -8.581365,
    icao: "LPPM"
  },
  PRN: {
    iata: "PRN",
    name: "Pristina International Airport",
    city: "Pristina",
    countryId: "RS",
    timeZoneRegionName: "Europe/Belgrade",
    latitude: 42.573611,
    longitude: 21.035556,
    icao: "LYPR"
  },
  PRO: {
    iata: "PRO",
    name: "Perry Municipal Airport",
    city: "Perry",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.85,
    longitude: -94.1,
    icao: "KPRO"
  },
  PRP: {
    iata: "PRP",
    name: "Propriano Airport",
    city: "Propriano",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 41.666667,
    longitude: 8.9,
    icao: "LFKO"
  },
  PRQ: {
    iata: "PRQ",
    name: "Pres. Roque Saenz Pena Airport",
    city: "Pres. Roque Saenz Pena",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -26.833333,
    longitude: -60.666667,
    icao: "SARS"
  },
  PRS: {
    iata: "PRS",
    name: "Parasi Airport",
    city: "Parasi",
    countryId: "SB",
    timeZoneRegionName: "Pacific/Guadalcanal",
    latitude: -9.641429,
    longitude: 161.425319,
    icao: "AGGP"
  },
  PRU: {
    iata: "PRU",
    name: "Prome Airport",
    city: "Prome",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 18.825,
    longitude: 95.268611,
    icao: "VYPY"
  },
  PRX: {
    iata: "PRX",
    name: "Cox Field",
    city: "Paris",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 33.636667,
    longitude: -95.450278,
    icao: "KPRX"
  },
  PRY: {
    iata: "PRY",
    name: "Wonderboom Airport",
    city: "Pretoria",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -25.654444,
    longitude: 28.220833,
    icao: "FAWB"
  },
  PSA: {
    iata: "PSA",
    name: "Pisa International Airport",
    city: "Pisa",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 43.698713,
    longitude: 10.399915,
    icao: "LIRP"
  },
  PSB: {
    iata: "PSB",
    name: "Mid-State Airport",
    city: "Philipsburg",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.883333,
    longitude: -78.085833,
    icao: "KPSB"
  },
  PSC: {
    iata: "PSC",
    name: "Tri-Cities Airport",
    city: "Pasco",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 46.259093,
    longitude: -119.1152,
    icao: "KPSC"
  },
  PSD: {
    iata: "PSD",
    name: "Port Said Airport",
    city: "Port Said",
    countryId: "EG",
    timeZoneRegionName: "Africa/Cairo",
    latitude: 31.266667,
    longitude: 32.3,
    icao: "HEPS"
  },
  PSE: {
    iata: "PSE",
    name: "Mercedita Airport",
    city: "Ponce",
    countryId: "PR",
    timeZoneRegionName: "America/Puerto_Rico",
    latitude: 18.010702,
    longitude: -66.563542,
    icao: "TJPS"
  },
  PSF: {
    iata: "PSF",
    name: "Pittsfield Municipal Airport",
    city: "Pittsfield",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.426667,
    longitude: -73.291667,
    icao: "KPSF"
  },
  PSG: {
    iata: "PSG",
    name: "Petersburg Municipal Airport",
    city: "Petersburg",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 56.804167,
    longitude: -132.9425,
    icao: "PAPG"
  },
  PSH: {
    iata: "PSH",
    name: "St. Peter Airport",
    city: "Saint Peter",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 54.5,
    longitude: 8.116667,
    icao: "EDXO"
  },
  PSI: {
    iata: "PSI",
    name: "Pasni Airport",
    city: "Pasni",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 25.3,
    longitude: 63.361111,
    icao: "OPPI"
  },
  PSJ: {
    iata: "PSJ",
    name: "Kasiguncu Airport",
    city: "Poso",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -1.416767,
    longitude: 120.657577,
    icao: "WAMP"
  },
  PSK: {
    iata: "PSK",
    name: "New River Valley Airport",
    city: "Dublin",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 37.137222,
    longitude: -80.678611,
    icao: "KPSK"
  },
  PSL: {
    iata: "PSL",
    name: "Perth International Airport",
    city: "Perth",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 56.439201,
    longitude: -3.37222,
    icao: "EGPT"
  },
  PSM: {
    iata: "PSM",
    name: "Pease Air Force Base",
    city: "Portsmouth",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 43.0779,
    longitude: -70.823303,
    icao: "KPSM"
  },
  PSN: {
    iata: "PSN",
    name: "Palestine Municipal Airport",
    city: "Palestine",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 31.776972,
    longitude: -95.706372,
    icao: "KPSN"
  },
  PSO: {
    iata: "PSO",
    name: "Cano Airport",
    city: "Pasto",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 1.466667,
    longitude: -77.25,
    icao: "SKPS"
  },
  PSP: {
    iata: "PSP",
    name: "Palm Springs International Airport",
    city: "Palm Springs",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 33.822976,
    longitude: -116.508444,
    icao: "KPSP"
  },
  PSR: {
    iata: "PSR",
    name: "Abruzzo Airport",
    city: "Pescara",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 42.437222,
    longitude: 14.187222,
    icao: "LIBP"
  },
  PSS: {
    iata: "PSS",
    name: "Posadas Airport",
    city: "Posadas",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -27.383889,
    longitude: -55.9675,
    icao: "SARP"
  },
  PSU: {
    iata: "PSU",
    name: "Pangsuma Airport",
    city: "Putussibau",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: 0.835433,
    longitude: 112.937507,
    icao: "WIOP"
  },
  PSW: {
    iata: "PSW",
    name: "Passos Airport",
    city: "Passos",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -20.716667,
    longitude: -46.616667,
    icao: "SNOS"
  },
  PSX: {
    iata: "PSX",
    name: "Palacios Airport",
    city: "Palacios",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 28.7,
    longitude: -96.25,
    icao: "KPSX"
  },
  PSZ: {
    iata: "PSZ",
    name: "Puerto Suarez Airport",
    city: "Puerto Suarez",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -18.980472,
    longitude: -57.823839,
    icao: "SLPS"
  },
  PTA: {
    iata: "PTA",
    name: "Port Alsworth Airport",
    city: "Port Alsworth",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 60.202767,
    longitude: -154.318713,
    icao: ""
  },
  PTB: {
    iata: "PTB",
    name: "Dinwiddie County Airport",
    city: "Petersburg",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 37.183941,
    longitude: -77.50569,
    icao: "KPTB"
  },
  PTF: {
    iata: "PTF",
    name: "Malolo Lailai Island Airport",
    city: "Malololailai",
    countryId: "FJ",
    timeZoneRegionName: "Pacific/Fiji",
    latitude: -17.778008,
    longitude: 177.196717,
    icao: "NFFO"
  },
  PTG: {
    iata: "PTG",
    name: "Polokwane Airport",
    city: "Polokwane",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -23.916667,
    longitude: 29.966667,
    icao: "FAPI"
  },
  PTH: {
    iata: "PTH",
    name: "Port Heiden Airport",
    city: "Port Heiden",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 56.956667,
    longitude: -158.6375,
    icao: "PAPH"
  },
  PTJ: {
    iata: "PTJ",
    name: "Portland Airport",
    city: "Portland",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -38.319141,
    longitude: 141.470332,
    icao: "YPOR"
  },
  PTK: {
    iata: "PTK",
    name: "Oakland County International Airport",
    city: "Pontiac",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.665101,
    longitude: -83.420035,
    icao: "KPTK"
  },
  PTM: {
    iata: "PTM",
    name: "Palmarito Airport",
    city: "Palmarito",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 7.566667,
    longitude: -70.183333,
    icao: "SVPT"
  },
  PTN: {
    iata: "PTN",
    name: "Patterson Municipal Heliport",
    city: "Patterson",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 29.708333,
    longitude: -91.3375,
    icao: "KPTN"
  },
  PTO: {
    iata: "PTO",
    name: "Pato Branco Municipal Airport",
    city: "Pato Branco",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -26.216667,
    longitude: -52.666667,
    icao: "SSPB"
  },
  PTP: {
    iata: "PTP",
    name: "Pointe-a-Pitre Le Raizet Airport",
    city: "Pointe-a-Pitre",
    countryId: "GP",
    timeZoneRegionName: "America/Guadeloupe",
    latitude: 16.265297,
    longitude: -61.531803,
    icao: "TFFR"
  },
  PTQ: {
    iata: "PTQ",
    name: "Porto de Moz Airport",
    city: "Porto de Moz",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -1.738889,
    longitude: -52.244444,
    icao: "SBMZ"
  },
  PTS: {
    iata: "PTS",
    name: "Pittsburg Municipal Airport",
    city: "Pittsburg",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 37.446667,
    longitude: -94.730556,
    icao: "KPTS"
  },
  PTT: {
    iata: "PTT",
    name: "Pratt Airport",
    city: "Pratt",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 37.716667,
    longitude: -98.75,
    icao: "KPTT"
  },
  PTU: {
    iata: "PTU",
    name: "Platinum Airport",
    city: "Platinum",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 59.011389,
    longitude: -161.816944,
    icao: "PAPM"
  },
  PTV: {
    iata: "PTV",
    name: "Porterville Airport",
    city: "Porterville",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 36.066667,
    longitude: -119.016667,
    icao: "KPTV"
  },
  PTW: {
    iata: "PTW",
    name: "Heritage Field",
    city: "Pottstown",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.260373,
    longitude: -75.669518,
    icao: "KPTW"
  },
  PTX: {
    iata: "PTX",
    name: "Pitalito Airport",
    city: "Pitalito",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 1.856385,
    longitude: -76.089636,
    icao: "SKPI"
  },
  PTY: {
    iata: "PTY",
    name: "Tocumen International Airport",
    city: "Panama City",
    countryId: "PA",
    timeZoneRegionName: "America/Panama",
    latitude: 9.066897,
    longitude: -79.387639,
    icao: "MPTO"
  },
  PTZ: {
    iata: "PTZ",
    name: "Pastaza Airport",
    city: "Pastaza",
    countryId: "EC",
    timeZoneRegionName: "America/Guayaquil",
    latitude: -2,
    longitude: -77,
    icao: "SESM"
  },
  PUB: {
    iata: "PUB",
    name: "Pueblo Memorial Airport",
    city: "Pueblo",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 38.284206,
    longitude: -104.495106,
    icao: "KPUB"
  },
  PUC: {
    iata: "PUC",
    name: "Carbon County Regional Airport",
    city: "Price",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 39.609722,
    longitude: -110.752778,
    icao: "KPUC"
  },
  PUD: {
    iata: "PUD",
    name: "Puerto Deseado Airport",
    city: "Puerto Deseado",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -47.75,
    longitude: -65.916667,
    icao: "SAWD"
  },
  PUE: {
    iata: "PUE",
    name: "Puerto Obaldia Airport",
    city: "Puerto Obaldia",
    countryId: "PA",
    timeZoneRegionName: "America/Panama",
    latitude: 8.66694,
    longitude: -77.41694,
    icao: "MPOA"
  },
  PUF: {
    iata: "PUF",
    name: "The Pau-Pyrenees International Airport",
    city: "Pau",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 43.382348,
    longitude: -0.413573,
    icao: "LFBP"
  },
  PUG: {
    iata: "PUG",
    name: "Port Augusta Airport",
    city: "Port Augusta",
    countryId: "AU",
    timeZoneRegionName: "Australia/Adelaide",
    latitude: -32.50721,
    longitude: 137.715382,
    icao: "YPAG"
  },
  PUJ: {
    iata: "PUJ",
    name: "Punta Cana International Airport",
    city: "Punta Cana",
    countryId: "DO",
    timeZoneRegionName: "America/Santo_Domingo",
    latitude: 18.562477,
    longitude: -68.363998,
    icao: "MDPC"
  },
  PUK: {
    iata: "PUK",
    name: "Pukarua Airport",
    city: "Pukarua, Tuamoto Island",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -18.296126,
    longitude: -137.017844,
    icao: "NTGQ"
  },
  PUN: {
    iata: "PUN",
    name: "Punia Airport",
    city: "Punia",
    countryId: "CD",
    timeZoneRegionName: "Africa/Lubumbashi",
    latitude: -1.366667,
    longitude: 26.333333,
    icao: "FZOP"
  },
  PUO: {
    iata: "PUO",
    name: "Prudhoe Bay Airport",
    city: "Prudhoe Bay",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 70.251389,
    longitude: -148.336944,
    icao: "PAUD"
  },
  PUQ: {
    iata: "PUQ",
    name: "Pres Ibanez Airport",
    city: "Punta Arenas",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -53.005357,
    longitude: -70.843074,
    icao: "SCCI"
  },
  PUS: {
    iata: "PUS",
    name: "Gimhae International Airport",
    city: "Busan",
    countryId: "KR",
    timeZoneRegionName: "Asia/Seoul",
    latitude: 35.179319,
    longitude: 128.948728,
    icao: "RKPK"
  },
  PUU: {
    iata: "PUU",
    name: "Puerto Asis Airport",
    city: "Puerto Asis",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 0.533333,
    longitude: -76.533333,
    icao: "SKAS"
  },
  PUW: {
    iata: "PUW",
    name: "Pullman-Moscow Regional Airport",
    city: "Pullman",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 46.744722,
    longitude: -117.105,
    icao: "KPUW"
  },
  PUY: {
    iata: "PUY",
    name: "Pula Airport",
    city: "Pula",
    countryId: "HR",
    timeZoneRegionName: "Europe/Zagreb",
    latitude: 44.891667,
    longitude: 13.923611,
    icao: "LDPL"
  },
  PUZ: {
    iata: "PUZ",
    name: "Puerto Cabezas Airport",
    city: "Puerto Cabezas",
    countryId: "NI",
    timeZoneRegionName: "America/Managua",
    latitude: 14.046136,
    longitude: -83.383661,
    icao: "MNPC"
  },
  PVA: {
    iata: "PVA",
    name: "Providencia Airport",
    city: "Providencia",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 13.35,
    longitude: -81.35,
    icao: "SKPV"
  },
  PVC: {
    iata: "PVC",
    name: "Provincetown Airport",
    city: "Provincetown",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.071944,
    longitude: -70.221667,
    icao: "KPVC"
  },
  PVD: {
    iata: "PVD",
    name: "Theodore Francis Green Memorial State Airport",
    city: "Providence",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.726312,
    longitude: -71.436317,
    icao: "KPVD"
  },
  PVF: {
    iata: "PVF",
    name: "Placerville Airport",
    city: "Placerville",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 38.72123,
    longitude: -120.757327,
    icao: "KPVF"
  },
  PVG: {
    iata: "PVG",
    name: "Shanghai Pudong International Airport",
    city: "Shanghai",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 31.151824,
    longitude: 121.799808,
    icao: "ZSPD"
  },
  PVH: {
    iata: "PVH",
    name: "Porto Velho International Airport",
    city: "Porto Velho",
    countryId: "BR",
    timeZoneRegionName: "America/Porto_Velho",
    latitude: -8.714311,
    longitude: -63.898307,
    icao: "SBPV"
  },
  PVI: {
    iata: "PVI",
    name: "Paranavia Airport",
    city: "Paranavia",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -23.066667,
    longitude: -52.466667,
    icao: "SSPI"
  },
  PVK: {
    iata: "PVK",
    name: "Aktion Airport",
    city: "Preveza",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 38.926389,
    longitude: 20.765833,
    icao: "LGPZ"
  },
  PVL: {
    iata: "PVL",
    name: "Pike County Airport",
    city: "Pikeville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 37.559214,
    longitude: -82.564639,
    icao: "KPBX"
  },
  PVO: {
    iata: "PVO",
    name: "Portoviejo Airport",
    city: "Portoviejo",
    countryId: "EC",
    timeZoneRegionName: "America/Guayaquil",
    latitude: -1.033333,
    longitude: -80.466667,
    icao: "SEPV"
  },
  PVR: {
    iata: "PVR",
    name: "Gustavo Diaz Ordaz International Airport",
    city: "Puerto Vallarta",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 20.678297,
    longitude: -105.248979,
    icao: "MMPR"
  },
  PVS: {
    iata: "PVS",
    name: "Provideniya Bay Airport",
    city: "Provideniya",
    countryId: "RU",
    timeZoneRegionName: "Asia/Anadyr",
    latitude: 64.383333,
    longitude: -173.243333,
    icao: "UHMD"
  },
  PVU: {
    iata: "PVU",
    name: "Provo Airport",
    city: "Provo",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 40.218056,
    longitude: -111.722222,
    icao: "KPVU"
  },
  PVW: {
    iata: "PVW",
    name: "Hale County Airport",
    city: "Plainview",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 34.183333,
    longitude: -101.716667,
    icao: "KPVW"
  },
  PVZ: {
    iata: "PVZ",
    name: "Casement Airport",
    city: "Painesville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.716667,
    longitude: -81.25,
    icao: "KPVZ"
  },
  PWA: {
    iata: "PWA",
    name: "Wiley Post Airport",
    city: "Oklahoma City",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.535143,
    longitude: -97.646416,
    icao: "KPWA"
  },
  PWD: {
    iata: "PWD",
    name: "Sherwood Airport",
    city: "Plentywood",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 48.783333,
    longitude: -104.566667,
    icao: "KPWD"
  },
  PWE: {
    iata: "PWE",
    name: "Pevek Airport",
    city: "Pevek",
    countryId: "RU",
    timeZoneRegionName: "Asia/Anadyr",
    latitude: 69.783333,
    longitude: 170.6,
    icao: "UHMP"
  },
  PWK: {
    iata: "PWK",
    name: "Chicago Executive Airport",
    city: "Chicago",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 42.114167,
    longitude: -87.901667,
    icao: "KPWK"
  },
  PWM: {
    iata: "PWM",
    name: "Portland International Jetport",
    city: "Portland",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 43.647492,
    longitude: -70.310307,
    icao: "KPWM"
  },
  PWO: {
    iata: "PWO",
    name: "Pweto Airport",
    city: "Pweto",
    countryId: "CD",
    timeZoneRegionName: "Africa/Lubumbashi",
    latitude: -8.466667,
    longitude: 28.9,
    icao: "FZQC"
  },
  PWQ: {
    iata: "PWQ",
    name: "Pavlodar Airport",
    city: "Pavlodar",
    countryId: "KZ",
    timeZoneRegionName: "Asia/Almaty",
    latitude: 52.195808,
    longitude: 77.073959,
    icao: "UASP"
  },
  PWT: {
    iata: "PWT",
    name: "Bremerton National Airport",
    city: "Bremerton",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 47.485,
    longitude: -122.763333,
    icao: "KPWT"
  },
  PWY: {
    iata: "PWY",
    name: "Ralph Wenz Field",
    city: "Pinedale",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 42.796127,
    longitude: -109.805519,
    icao: "KPNA"
  },
  PXH: {
    iata: "PXH",
    name: "Prominent Hill Airport",
    city: "Prominent Hill Mine",
    countryId: "AU",
    timeZoneRegionName: "Australia/Adelaide",
    latitude: -29.710412,
    longitude: 135.526997,
    icao: "YPMH"
  },
  PXM: {
    iata: "PXM",
    name: "Puerto Escondido Airport",
    city: "Puerto Escondido",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 15.85,
    longitude: -97.083333,
    icao: "MMPS"
  },
  PXO: {
    iata: "PXO",
    name: "Porto Santo Airport",
    city: "Porto Santo (Madeira)",
    countryId: "PT",
    timeZoneRegionName: "Europe/Lisbon",
    latitude: 33.070023,
    longitude: -16.345014,
    icao: "LPPS"
  },
  PXU: {
    iata: "PXU",
    name: "Pleiku Airport",
    city: "Pleiku",
    countryId: "VN",
    timeZoneRegionName: "Asia/Ho_Chi_Minh",
    latitude: 14.006346,
    longitude: 108.00896,
    icao: "VVPK"
  },
  PYB: {
    iata: "PYB",
    name: "Jeypore Airport",
    city: "Jeypore",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 18.833333,
    longitude: 82.633333,
    icao: "VEJP"
  },
  PYE: {
    iata: "PYE",
    name: "Penrhyn Island Airport",
    city: "Penrhyn Island",
    countryId: "CK",
    timeZoneRegionName: "Pacific/Rarotonga",
    latitude: -9.016667,
    longitude: -158.033333,
    icao: "NCPY"
  },
  PYG: {
    iata: "PYG",
    name: "Pakyong Airport",
    city: "Pakyong",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 27.2278,
    longitude: 88.586944,
    icao: "VEPY"
  },
  PYH: {
    iata: "PYH",
    name: "Puerto Ayacucho Airport",
    city: "Puerto Ayacucho",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 5.6,
    longitude: -67.5,
    icao: "SVPA"
  },
  PYJ: {
    iata: "PYJ",
    name: "Polyarnyj Airport",
    city: "Polyarnyj",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yakutsk",
    latitude: 66.416667,
    longitude: 112.05,
    icao: "UERP"
  },
  PYM: {
    iata: "PYM",
    name: "Plymouth Municipal Airport",
    city: "Plymouth",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.909,
    longitude: -70.728798,
    icao: "KPYM"
  },
  PYR: {
    iata: "PYR",
    name: "Andravida Air Base",
    city: "Pyrgos",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 37.933333,
    longitude: 21.283333,
    icao: "LGAD"
  },
  PYT: {
    iata: "PYT",
    name: "Paracatu Airport",
    city: "Paracatu",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -17.242599,
    longitude: -46.883098,
    icao: "SNZR"
  },
  PYY: {
    iata: "PYY",
    name: "Pai Airport",
    city: "Pai",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 19.372789,
    longitude: 98.436106,
    icao: "VTCI"
  },
  PZA: {
    iata: "PZA",
    name: "Casanare Airport",
    city: "Paz De Ariporo",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 5.877778,
    longitude: -71.885,
    icao: "SKPZ"
  },
  PZB: {
    iata: "PZB",
    name: "Pietermaritzburg Airport",
    city: "Pietermaritzburg",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -29.643047,
    longitude: 30.396739,
    icao: "FAPM"
  },
  PZE: {
    iata: "PZE",
    name: "Penzance Heliport",
    city: "Penzance",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 50.127545,
    longitude: -5.518258,
    icao: "EGHK"
  },
  PZH: {
    iata: "PZH",
    name: "Zhob Airport",
    city: "Zhob",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 31.358241,
    longitude: 69.46392,
    icao: "OPZB"
  },
  PZI: {
    iata: "PZI",
    name: "Panzhihua Bao'angong Airport",
    city: "Pan Zhi Hua",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 26.538734,
    longitude: 101.793861,
    icao: ""
  },
  PZK: {
    iata: "PZK",
    name: "Pukapuka Island Airport",
    city: "Pukapuka Atoll",
    countryId: "CK",
    timeZoneRegionName: "Pacific/Rarotonga",
    latitude: -10.911279,
    longitude: -165.835424,
    icao: "NCPK"
  },
  PZL: {
    iata: "PZL",
    name: "Zulu Inyala Airport",
    city: "Phinda",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -27.8494,
    longitude: 32.3097,
    icao: "FADQ"
  },
  PZO: {
    iata: "PZO",
    name: "Manuel Carlos Piar Guayana Airport",
    city: "Puerto Ordaz",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 8.286533,
    longitude: -62.759138,
    icao: "SVPR"
  },
  PZU: {
    iata: "PZU",
    name: "Port Sudan Airport",
    city: "Port Sudan",
    countryId: "SD",
    timeZoneRegionName: "Africa/Khartoum",
    latitude: 19.577778,
    longitude: 37.213889,
    icao: "HSSP"
  },
  PZY: {
    iata: "PZY",
    name: "Piestany Airport",
    city: "Piestany",
    countryId: "SK",
    timeZoneRegionName: "Europe/Bratislava",
    latitude: 48.623731,
    longitude: 17.82808,
    icao: "LZPP"
  },
  QAC: {
    iata: "QAC",
    name: "Castro",
    city: "Castro",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -24.875,
    longitude: -50.052778,
    icao: "SSQT"
  },
  QAK: {
    iata: "QAK",
    name: "Barbacena",
    city: "Barbacena",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -21.397222,
    longitude: -43.883333,
    icao: "SBBQ"
  },
  QBC: {
    iata: "QBC",
    name: "Bella Coola Airport",
    city: "Bella Coola",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 52.333333,
    longitude: -126.666667,
    icao: "CYBD"
  },
  QBX: {
    iata: "QBX",
    name: "Sobral",
    city: "Sobral",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -3.781521,
    longitude: -40.366667,
    icao: "SNOB"
  },
  QCJ: {
    iata: "QCJ",
    name: "Botucatu",
    city: "Botucatu",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -22.966667,
    longitude: -48.475,
    icao: "SDBK"
  },
  QCP: {
    iata: "QCP",
    name: "Currais Novos",
    city: "Currais Novos",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -6.408333,
    longitude: -36.602778,
    icao: "SNKN"
  },
  QCR: {
    iata: "QCR",
    name: "Curitibanos",
    city: "Curitibanos",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -27.425,
    longitude: -50.713889,
    icao: "SSKU"
  },
  QDB: {
    iata: "QDB",
    name: "Cachoeira Do Sul",
    city: "Cachoeira Do Sul",
    countryId: "BR",
    timeZoneRegionName: "America/Campo_Grande",
    latitude: -30.022222,
    longitude: -53.002778,
    icao: "SSKS"
  },
  QDC: {
    iata: "QDC",
    name: "Dracena",
    city: "Dracena",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -21.561111,
    longitude: -51.666667,
    icao: "SDDR"
  },
  QDF: {
    iata: "QDF",
    name: "Conselheiro Lafaiete",
    city: "Conselheiro Lafaiete",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -20.786111,
    longitude: -43.930556,
    icao: "SNKF"
  },
  QDH: {
    iata: "QDH",
    name: "Ashford International Railway Station",
    city: "Ashford",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.1436,
    longitude: 0.87448,
    icao: ""
  },
  QDP: {
    iata: "QDP",
    name: "Dom Pedrito",
    city: "Dom Pedrito",
    countryId: "BR",
    timeZoneRegionName: "America/Campo_Grande",
    latitude: -31.1,
    longitude: -54.811111,
    icao: "SSDP"
  },
  QDU: {
    iata: "QDU",
    name: "Dusseldorf Central Station",
    city: "Dusseldorf",
    countryId: "DE",
    timeZoneRegionName: "Europe/Paris",
    latitude: 51.2203,
    longitude: 6.7928,
    icao: ""
  },
  QDV: {
    iata: "QDV",
    name: "Jundiai Airport",
    city: "Jundiai",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -23.181379,
    longitude: -46.943767,
    icao: "SDJD"
  },
  QFB: {
    iata: "QFB",
    name: "Freiburg Hbf Railway Station",
    city: "Freiburg",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 47.9999473826,
    longitude: 7.84475039281,
    icao: ""
  },
  QFG: {
    iata: "QFG",
    name: "Eqalugaarsuit Heliport",
    city: "Eqalugaarsuit",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 60.619732,
    longitude: -45.914074,
    icao: "BGET"
  },
  QFI: {
    iata: "QFI",
    name: "Iginniarfik Heliport",
    city: "Iginniarfik",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 68.145864,
    longitude: -53.169259,
    icao: "BGIG"
  },
  QFN: {
    iata: "QFN",
    name: "Narsaq Kujalleq Heliport",
    city: "Narsaq Kujalleq",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 60.004684,
    longitude: -44.656972,
    icao: "BGFD"
  },
  QFT: {
    iata: "QFT",
    name: "Qassiarsuk Heliport",
    city: "Qassiarsuk",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 61.152501,
    longitude: -45.519467,
    icao: "BGQK"
  },
  QFV: {
    iata: "QFV",
    name: "Bergen Railway Station",
    city: "Sandsli",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 60.333332,
    longitude: 5.333333,
    icao: ""
  },
  QFX: {
    iata: "QFX",
    name: "Igaliku Heliport",
    city: "Igaliku",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 60.990563,
    longitude: -45.421484,
    icao: "BGIO"
  },
  QGC: {
    iata: "QGC",
    name: "Lencois Paulista",
    city: "Lencois Paulista",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -22.672222,
    longitude: -48.852778,
    icao: "SDLP"
  },
  QGF: {
    iata: "QGF",
    name: "Montenegro",
    city: "Montenegro",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -29.744444,
    longitude: -51.544444,
    icao: "SSNG"
  },
  QGP: {
    iata: "QGP",
    name: "Garanhuns",
    city: "Garanhuns",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -8.911111,
    longitude: -36.65,
    icao: "SNGN"
  },
  QGU: {
    iata: "QGU",
    name: "Gifu Airport",
    city: "Gifu",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 35.394551,
    longitude: 136.870452,
    icao: "RJNG"
  },
  QGY: {
    iata: "QGY",
    name: "Gy\u0151r-P\xE9r International Airport",
    city: "Gy\u0151r",
    countryId: "HU",
    timeZoneRegionName: "Europe/Budapest",
    latitude: 47.627778,
    longitude: 17.806389,
    icao: "LHPR"
  },
  QHB: {
    iata: "QHB",
    name: "Piracicaba",
    city: "Piracicaba",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -22.805556,
    longitude: -47.644444,
    icao: "SDPW"
  },
  QHN: {
    iata: "QHN",
    name: "Taguatinga",
    city: "Taguatinga",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -12.438889,
    longitude: -46.405556,
    icao: "SWTY"
  },
  QHV: {
    iata: "QHV",
    name: "Novo Hamburgo",
    city: "Novo Hamburgo",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -29.811111,
    longitude: -51.216667,
    icao: "SSNH"
  },
  QID: {
    iata: "QID",
    name: "Mello Viana",
    city: "Tres Coracoes",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -21.855556,
    longitude: -45.291667,
    icao: "SNVI"
  },
  QIG: {
    iata: "QIG",
    name: "Iguatu",
    city: "Iguatu",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -6.477778,
    longitude: -39.436111,
    icao: "SNIG"
  },
  QIQ: {
    iata: "QIQ",
    name: "Rio Claro",
    city: "Rio Claro",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -22.561111,
    longitude: -47.691667,
    icao: "SDRK"
  },
  QIT: {
    iata: "QIT",
    name: "Itapetinga",
    city: "Itapetinga",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -15.338889,
    longitude: -40.361111,
    icao: "SNIP"
  },
  QJE: {
    iata: "QJE",
    name: "Kitsissuarsuit Heliport",
    city: "Kitsissuarsuit",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 68.857926,
    longitude: -53.123296,
    icao: "BGKT"
  },
  QJH: {
    iata: "QJH",
    name: "Qassimiut Heliport",
    city: "Qassimiut",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 60.779352,
    longitude: -47.152561,
    icao: "BGQT"
  },
  QJZ: {
    iata: "QJZ",
    name: "Nantes Railway Station",
    city: "Nantes",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 47.218371,
    longitude: -1.553621,
    icao: ""
  },
  QKL: {
    iata: "QKL",
    name: "K\xF6ln Hbf Railway Station",
    city: "Rosrath",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 50.9,
    longitude: 7.183,
    icao: ""
  },
  QLA: {
    iata: "QLA",
    name: "Lasham Airfield",
    city: "Lasham",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.184574,
    longitude: -1.037654,
    icao: "EGHL"
  },
  QLJ: {
    iata: "QLJ",
    name: "Lucerne Railway Station",
    city: "Lucerne",
    countryId: "CH",
    timeZoneRegionName: "Europe/Zurich",
    latitude: 47.050477,
    longitude: 8.3102871,
    icao: ""
  },
  QLR: {
    iata: "QLR",
    name: "Monte Real Airport",
    city: "Monte Real",
    countryId: "PT",
    timeZoneRegionName: "Europe/Lisbon",
    latitude: 39.828333,
    longitude: -8.8875,
    icao: "LPMR"
  },
  QLS: {
    iata: "QLS",
    name: "Lausanne Airport",
    city: "Lausanne",
    countryId: "CH",
    timeZoneRegionName: "Europe/Zurich",
    latitude: 46.545278,
    longitude: 6.616667,
    icao: "LSGL"
  },
  QMF: {
    iata: "QMF",
    name: "Mafra",
    city: "Mafra",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -26.238889,
    longitude: -49.972222,
    icao: "SSMF"
  },
  QNS: {
    iata: "QNS",
    name: "Canoas Ab",
    city: "Porto Alegre",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -30.016667,
    longitude: -51.288889,
    icao: "SBCO"
  },
  QNV: {
    iata: "QNV",
    name: "Aeroclube Nova Iguacu",
    city: "Nova Iguacu",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -22.74685,
    longitude: -43.461755,
    icao: "SDNY"
  },
  QOA: {
    iata: "QOA",
    name: "Mococa",
    city: "Mococa",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -21.527778,
    longitude: -47.044444,
    icao: "SDKK"
  },
  QOQ: {
    iata: "QOQ",
    name: "Saarloq Heliport",
    city: "Saarloq",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 60.537829,
    longitude: -46.02475,
    icao: "BGSO"
  },
  QOW: {
    iata: "QOW",
    name: "Sam Mbakwe International Airport",
    city: "Imo",
    countryId: "NG",
    timeZoneRegionName: "Africa/Lagos",
    latitude: 5.427866,
    longitude: 7.201676,
    icao: "DNIM"
  },
  QPG: {
    iata: "QPG",
    name: "Paya Lebar Airport",
    city: "Singapore",
    countryId: "SG",
    timeZoneRegionName: "Asia/Singapore",
    latitude: 1.358398,
    longitude: 103.902305,
    icao: "WSAP"
  },
  QPK: {
    iata: "QPK",
    name: "Strausberg Airport",
    city: "Strausberg",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 52.582638,
    longitude: 13.915935,
    icao: "EDAY"
  },
  QPP: {
    iata: "QPP",
    name: "Berlin Hbf Railway Station",
    city: "Berlin",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 52.5234051,
    longitude: 13.4113999,
    icao: ""
  },
  QQK: {
    iata: "QQK",
    name: "Kings Cross Rail Station",
    city: "Kings",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.51,
    longitude: 0.06,
    icao: ""
  },
  QQM: {
    iata: "QQM",
    name: "Piccadilly Railway Station",
    city: "Manchester",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 53.477,
    longitude: 2.23,
    icao: ""
  },
  QQN: {
    iata: "QQN",
    name: "New Street Rail Station",
    city: "Birmingham",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 52.4829614,
    longitude: -1.893592,
    icao: ""
  },
  QQP: {
    iata: "QQP",
    name: "Paddington Railway Station",
    city: "Paddington",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.5173,
    longitude: 0.1774,
    icao: ""
  },
  QQS: {
    iata: "QQS",
    name: "St Pancras International RailSt",
    city: "St",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.51,
    longitude: 0.06,
    icao: ""
  },
  QQU: {
    iata: "QQU",
    name: "Euston Railway Station",
    city: "Euston",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.51,
    longitude: 0.06,
    icao: ""
  },
  QQW: {
    iata: "QQW",
    name: "London-Waterloo",
    city: "London-Waterloo",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.51,
    longitude: 0.06,
    icao: ""
  },
  QQY: {
    iata: "QQY",
    name: "York Railway Station",
    city: "York",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 53.957981,
    longitude: -1.093191,
    icao: ""
  },
  QRA: {
    iata: "QRA",
    name: "Randgermiston Airport",
    city: "Johannesburg",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -26.24284,
    longitude: 28.151648,
    icao: "FAGM"
  },
  QRC: {
    iata: "QRC",
    name: "De La Independencia",
    city: "Rancagua",
    countryId: "CL",
    timeZoneRegionName: "Pacific/Easter",
    latitude: -34.244444,
    longitude: -70.855556,
    icao: "SCRG"
  },
  QRE: {
    iata: "QRE",
    name: "Carazinho",
    city: "Carazinho",
    countryId: "BR",
    timeZoneRegionName: "America/Campo_Grande",
    latitude: -28.363889,
    longitude: -52.955556,
    icao: "SSKZ"
  },
  QRH: {
    iata: "QRH",
    name: "Rotterdam Centraal Railway Station",
    city: "Rotterdam",
    countryId: "NL",
    timeZoneRegionName: "Europe/Amsterdam",
    latitude: 51.916668,
    longitude: 4.5,
    icao: ""
  },
  QRM: {
    iata: "QRM",
    name: "Narromine",
    city: "Narromine",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -32.244444,
    longitude: 148.363889,
    icao: "YNRM"
  },
  QRO: {
    iata: "QRO",
    name: "Queretaro Intercontinental Airport",
    city: "Queretaro",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 20.622084,
    longitude: -100.18924,
    icao: "MMQT"
  },
  QRR: {
    iata: "QRR",
    name: "Warren",
    city: "Warren",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -31.733333,
    longitude: 147.825,
    icao: "YWRN"
  },
  QRW: {
    iata: "QRW",
    name: "Osubi Airstrip",
    city: "Warri",
    countryId: "NG",
    timeZoneRegionName: "Africa/Lagos",
    latitude: 5.594487,
    longitude: 5.819282,
    icao: "DNSU"
  },
  QRY: {
    iata: "QRY",
    name: "Ikerasaarsuk Heliport",
    city: "Ikerasaarsuk",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 68.140895,
    longitude: -53.441474,
    icao: "BGIK"
  },
  QSC: {
    iata: "QSC",
    name: "Mario Pereira Lopes State Airport",
    city: "Sao Carlos",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -21.87148,
    longitude: -47.903567,
    icao: "SDSC"
  },
  QSF: {
    iata: "QSF",
    name: "Ain Arnat Airport",
    city: "Setif",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 36.178611,
    longitude: 5.33,
    icao: "DAAS"
  },
  QSM: {
    iata: "QSM",
    name: "Uetersen Airport",
    city: "Uetersen",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 53.648084,
    longitude: 9.70936,
    icao: "EDHE"
  },
  QSR: {
    iata: "QSR",
    name: "Salerno Costa d'Amalfi Airport",
    city: "Salerno",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 40.620146,
    longitude: 14.92084,
    icao: "LIRI"
  },
  QSZ: {
    iata: "QSZ",
    name: "Shache Ye'erqiang Airport",
    city: "Shache",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 38.245562,
    longitude: 77.056094,
    icao: ""
  },
  QUB: {
    iata: "QUB",
    name: "Ubari Airport",
    city: "Ubari",
    countryId: "LY",
    timeZoneRegionName: "Africa/Tripoli",
    latitude: 26.568267,
    longitude: 12.820452,
    icao: "HLUB"
  },
  QUG: {
    iata: "QUG",
    name: "Goodwood",
    city: "Chichester",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 50.859402,
    longitude: -0.759167,
    icao: "EGHR"
  },
  QUN: {
    iata: "QUN",
    name: "A-306",
    city: "Chunchon",
    countryId: "KR",
    timeZoneRegionName: "Asia/Seoul",
    latitude: 37.9,
    longitude: 127.85,
    icao: "RKNC"
  },
  QUO: {
    iata: "QUO",
    name: "Akwa Ibom Airport",
    city: "Uyo",
    countryId: "NG",
    timeZoneRegionName: "Africa/Lagos",
    latitude: 4.876463,
    longitude: 8.085693,
    icao: "DNAI"
  },
  QUP: {
    iata: "QUP",
    name: "Saqqaq Heliport",
    city: "Saqqaq",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 70.05,
    longitude: -52,
    icao: "BGSQ"
  },
  QUT: {
    iata: "QUT",
    name: "Utsunomiya Aero",
    city: "Utsunomiya",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 36.631528,
    longitude: 140.006083,
    icao: "RJTU"
  },
  QUV: {
    iata: "QUV",
    name: "Aappilattoq-Nanortalik Heliport",
    city: "Aappilattoq",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 60.148344,
    longitude: -44.286883,
    icao: "BGAQ"
  },
  QUW: {
    iata: "QUW",
    name: "Ammassivik Heliport",
    city: "Ammassivik",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 60.596143,
    longitude: -45.377452,
    icao: "BGAS"
  },
  QVP: {
    iata: "QVP",
    name: "Avare-Arandu",
    city: "Avare",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -23.180556,
    longitude: -48.991667,
    icao: "SDRR"
  },
  QXB: {
    iata: "QXB",
    name: "Aix-en-Provence TGV Railway Station",
    city: "Les Pennes-Mirabeau",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 43.455,
    longitude: 5.317222,
    icao: ""
  },
  QXC: {
    iata: "QXC",
    name: "Caxias",
    city: "Caxias",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -4.870141,
    longitude: -43.355556,
    icao: "SNXS"
  },
  QXD: {
    iata: "QXD",
    name: "Cachoeiro Do Itapemirim",
    city: "Cachoeiro Do Itapemirim",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -20.866667,
    longitude: -41.225,
    icao: "SNKI"
  },
  QXG: {
    iata: "QXG",
    name: "Angers Railway Station",
    city: "Angers",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 47.478419,
    longitude: -0.563166,
    icao: ""
  },
  QYG: {
    iata: "QYG",
    name: "German railway stations",
    city: "German",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 51.165691,
    longitude: 10.451526,
    icao: ""
  },
  QYX: {
    iata: "QYX",
    name: "Uppsala C Railway Station",
    city: "Uppsala",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 59.858611,
    longitude: 17.646111,
    icao: ""
  },
  RAB: {
    iata: "RAB",
    name: "Tokua Airport",
    city: "Rabaul",
    countryId: "PG",
    timeZoneRegionName: "Pacific/Port_Moresby",
    latitude: -4.340517,
    longitude: 152.37997,
    icao: "AYTK"
  },
  RAC: {
    iata: "RAC",
    name: "Horlick Airport",
    city: "Racine",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 42.683333,
    longitude: -87.85,
    icao: "KRAC"
  },
  RAE: {
    iata: "RAE",
    name: "Arar Airport",
    city: "Arar",
    countryId: "SA",
    timeZoneRegionName: "Asia/Riyadh",
    latitude: 30.903029,
    longitude: 41.137115,
    icao: "OERR"
  },
  RAG: {
    iata: "RAG",
    name: "Raglan Airfield",
    city: "Raglan",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -37.804648,
    longitude: 174.859635,
    icao: "NZRA"
  },
  RAH: {
    iata: "RAH",
    name: "Rafha Airport",
    city: "Rafha",
    countryId: "SA",
    timeZoneRegionName: "Asia/Riyadh",
    latitude: 29.623463,
    longitude: 43.488786,
    icao: "OERF"
  },
  RAI: {
    iata: "RAI",
    name: "Nelson Mandela International Airport",
    city: "Praia",
    countryId: "CV",
    timeZoneRegionName: "Atlantic/Cape_Verde",
    latitude: 14.945321,
    longitude: -23.486566,
    icao: "GVNP"
  },
  RAJ: {
    iata: "RAJ",
    name: "Civil Airport",
    city: "Rajkot",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 22.308673,
    longitude: 70.782346,
    icao: "VARK"
  },
  RAK: {
    iata: "RAK",
    name: "Menara Airport",
    city: "Marrakech",
    countryId: "MA",
    timeZoneRegionName: "Africa/Casablanca",
    latitude: 31.601875,
    longitude: -8.026902,
    icao: "GMMX"
  },
  RAL: {
    iata: "RAL",
    name: "Riverside Municipal Airport",
    city: "Riverside",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 33.951667,
    longitude: -117.442222,
    icao: "KRAL"
  },
  RAM: {
    iata: "RAM",
    name: "Ramingining Airport",
    city: "Ramingining",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -12,
    longitude: 134.816667,
    icao: "YRNG"
  },
  RAN: {
    iata: "RAN",
    name: "La Spreta Airport",
    city: "Ravenna",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 44.366667,
    longitude: 12.223333,
    icao: "LIDR"
  },
  RAO: {
    iata: "RAO",
    name: "Dr. Leite Lopes State Airport",
    city: "Ribeirao Preto",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -21.139432,
    longitude: -47.775859,
    icao: "SBRP"
  },
  RAP: {
    iata: "RAP",
    name: "Rapid City Regional Airport",
    city: "Rapid City",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 44.037581,
    longitude: -103.061182,
    icao: "KRAP"
  },
  RAR: {
    iata: "RAR",
    name: "Rarotonga Airport",
    city: "Rarotonga",
    countryId: "CK",
    timeZoneRegionName: "Pacific/Rarotonga",
    latitude: -21.19992,
    longitude: -159.798529,
    icao: "NCRG"
  },
  RAS: {
    iata: "RAS",
    name: "Rasht Airport",
    city: "Rasht",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 37.321814,
    longitude: 49.619586,
    icao: "OIGG"
  },
  RAT: {
    iata: "RAT",
    name: "Raduzhnyi Airport",
    city: "Raduzhnyi",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yekaterinburg",
    latitude: 62.5,
    longitude: 77,
    icao: "USNR"
  },
  RAV: {
    iata: "RAV",
    name: "Cravo Norte Airport",
    city: "Cravo Norte",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 6.316667,
    longitude: -70.183333,
    icao: "SKCN"
  },
  RAZ: {
    iata: "RAZ",
    name: "Rawala Kot Airport",
    city: "Rawala Kot",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 33.841667,
    longitude: 73.833333,
    icao: "OPRT"
  },
  RBA: {
    iata: "RBA",
    name: "Sale Airport",
    city: "Rabat",
    countryId: "MA",
    timeZoneRegionName: "Africa/Casablanca",
    latitude: 34.036138,
    longitude: -6.748619,
    icao: "GMME"
  },
  RBB: {
    iata: "RBB",
    name: "Borba Airport",
    city: "Borba",
    countryId: "BR",
    timeZoneRegionName: "America/Porto_Velho",
    latitude: -4.4,
    longitude: -59.583333,
    icao: "SWBR"
  },
  RBC: {
    iata: "RBC",
    name: "Robinvale Airport",
    city: "Robinvale",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -34.666667,
    longitude: 142.75,
    icao: "YROI"
  },
  RBD: {
    iata: "RBD",
    name: "Dallas Executive Airport",
    city: "Dallas",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.680833,
    longitude: -96.868333,
    icao: "KRBD"
  },
  RBE: {
    iata: "RBE",
    name: "Ratanakiri Airport",
    city: "Ratanakiri",
    countryId: "KH",
    timeZoneRegionName: "Asia/Phnom_Penh",
    latitude: 13.666667,
    longitude: 106.983333,
    icao: "VRBE"
  },
  RBG: {
    iata: "RBG",
    name: "Roseburg Regional Airport",
    city: "Roseburg",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 43.235436,
    longitude: -123.357623,
    icao: "KRBG"
  },
  RBJ: {
    iata: "RBJ",
    name: "Rebun Airport",
    city: "Rebun",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 45.383333,
    longitude: 141.033333,
    icao: "RJCR"
  },
  RBL: {
    iata: "RBL",
    name: "Red Bluff Municipal Airport",
    city: "Red Bluff",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 40.154998,
    longitude: -122.252468,
    icao: "KRBL"
  },
  RBM: {
    iata: "RBM",
    name: "Wallmuhle Airport",
    city: "Straubing",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 48.901636,
    longitude: 12.515756,
    icao: "EDMS"
  },
  RBO: {
    iata: "RBO",
    name: "Robore Airport",
    city: "Robore",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -18.344444,
    longitude: -59.755278,
    icao: "SLRB"
  },
  RBQ: {
    iata: "RBQ",
    name: "Rurrenabaque Airport",
    city: "Rurrenabaque",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -14.45,
    longitude: -67.55,
    icao: "SLRQ"
  },
  RBR: {
    iata: "RBR",
    name: "Pres. Medici Airport",
    city: "Rio Branco",
    countryId: "BR",
    timeZoneRegionName: "America/Rio_Branco",
    latitude: -9.868889,
    longitude: -67.898056,
    icao: "SBRB"
  },
  RBS: {
    iata: "RBS",
    name: "Orbost Airport",
    city: "Orbost",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -37.790001,
    longitude: 148.610001,
    icao: "YORB"
  },
  RBT: {
    iata: "RBT",
    name: "Marsabit Airport",
    city: "Marsabit",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: 2.333333,
    longitude: 37.983333,
    icao: "HKMB"
  },
  RBV: {
    iata: "RBV",
    name: "Ramata Island Airport",
    city: "Ramata",
    countryId: "SB",
    timeZoneRegionName: "Pacific/Guadalcanal",
    latitude: -8.165556,
    longitude: 157.639444,
    icao: "AGRM"
  },
  RBW: {
    iata: "RBW",
    name: "Lowcountry Regional Airport",
    city: "Walterboro",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 32.92106,
    longitude: -80.640584,
    icao: "KRBW"
  },
  RBX: {
    iata: "RBX",
    name: "Rumbek Airport",
    city: "Rumbek",
    countryId: "SS",
    timeZoneRegionName: "Africa/Juba",
    latitude: 6.825243,
    longitude: 29.669531,
    icao: "HSMK"
  },
  RBY: {
    iata: "RBY",
    name: "Ruby Airport",
    city: "Ruby",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 64.73,
    longitude: -155.460833,
    icao: "PARY"
  },
  RBZ: {
    iata: "RBZ",
    name: "Shahrisabz Southwest Airport",
    city: "Shakhrisabz",
    countryId: "UZ",
    timeZoneRegionName: "Asia/Samarkand",
    latitude: 39.0314,
    longitude: 66.7778,
    icao: ""
  },
  RCA: {
    iata: "RCA",
    name: "Ellsworth Air Force Base",
    city: "Rapid City",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 44.145036,
    longitude: -103.103563,
    icao: "KRCA"
  },
  RCB: {
    iata: "RCB",
    name: "Richards Bay Airport",
    city: "Richards Bay",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -28.740556,
    longitude: 32.093056,
    icao: "FARB"
  },
  RCH: {
    iata: "RCH",
    name: "Riohacha Airport",
    city: "Riohacha",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 11.526226,
    longitude: -72.925956,
    icao: "SKRH"
  },
  RCK: {
    iata: "RCK",
    name: "Coffield Airport",
    city: "Rockdale",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.65,
    longitude: -97,
    icao: "KRCK"
  },
  RCL: {
    iata: "RCL",
    name: "Redcliffe Airport",
    city: "Redcliffe",
    countryId: "VU",
    timeZoneRegionName: "Pacific/Efate",
    latitude: -15.472,
    longitude: 167.83501,
    icao: "NVSR"
  },
  RCM: {
    iata: "RCM",
    name: "Richmond Airport",
    city: "Richmond",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -20.700448,
    longitude: 143.117298,
    icao: "YRMD"
  },
  RCO: {
    iata: "RCO",
    name: "Saint Agnant Airport",
    city: "Rochefort",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 45.890556,
    longitude: -0.980556,
    icao: "LFDN"
  },
  RCQ: {
    iata: "RCQ",
    name: "Reconquista Airport",
    city: "Reconquista",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -29.210298,
    longitude: -59.680007,
    icao: "SATR"
  },
  RCR: {
    iata: "RCR",
    name: "Fulton County Airport",
    city: "Rochester",
    countryId: "US",
    timeZoneRegionName: "America/Indiana/Indianapolis",
    latitude: 41.066667,
    longitude: -86.216667,
    icao: "KRCR"
  },
  RCS: {
    iata: "RCS",
    name: "Rochester Airport",
    city: "Rochester",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.35,
    longitude: 0.5,
    icao: "EGTO"
  },
  RCT: {
    iata: "RCT",
    name: "Nartron Field",
    city: "Reed City",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 43.899998,
    longitude: -85.51579,
    icao: "KRCT"
  },
  RCU: {
    iata: "RCU",
    name: "Las Higueras Airport",
    city: "Rio Cuarto",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -33.096852,
    longitude: -64.274677,
    icao: "SAOC"
  },
  RCY: {
    iata: "RCY",
    name: "New Port Nelson Airport",
    city: "Rum Cay",
    countryId: "BS",
    timeZoneRegionName: "America/Nassau",
    latitude: 23.684308,
    longitude: -74.835023,
    icao: "MYRP"
  },
  RDC: {
    iata: "RDC",
    name: "Redencao Airport",
    city: "Redencao",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -8.030278,
    longitude: -49.98,
    icao: "SNDC"
  },
  RDD: {
    iata: "RDD",
    name: "Redding Municipal Airport",
    city: "Redding",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 40.505769,
    longitude: -122.299914,
    icao: "KRDD"
  },
  RDG: {
    iata: "RDG",
    name: "Reading Regional Airport",
    city: "Reading",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.378611,
    longitude: -75.963889,
    icao: "KRDG"
  },
  RDM: {
    iata: "RDM",
    name: "Roberts Field",
    city: "Redmond",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 44.254112,
    longitude: -121.150106,
    icao: "KRDM"
  },
  RDO: {
    iata: "RDO",
    name: "Radom Airport",
    city: "Radom",
    countryId: "PL",
    timeZoneRegionName: "Europe/Warsaw",
    latitude: 51.389167,
    longitude: 21.213611,
    icao: "EPRA"
  },
  RDP: {
    iata: "RDP",
    name: "Kazi Nazrul Islam Airport",
    city: "Andal",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 23.621389,
    longitude: 87.243333,
    icao: "VEDG"
  },
  RDR: {
    iata: "RDR",
    name: "Grand Forks Air Force Base",
    city: "Red River",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 47.961307,
    longitude: -97.400751,
    icao: "KRDR"
  },
  RDT: {
    iata: "RDT",
    name: "Richard Toll Airport",
    city: "Richard Toll",
    countryId: "SN",
    timeZoneRegionName: "Africa/Dakar",
    latitude: 16.437222,
    longitude: -15.657222,
    icao: "GOSR"
  },
  RDU: {
    iata: "RDU",
    name: "Raleigh-Durham International Airport",
    city: "Raleigh/Durham",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 35.873592,
    longitude: -78.790862,
    icao: "KRDU"
  },
  RDV: {
    iata: "RDV",
    name: "Red Devil Airport",
    city: "Red Devil",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 61.787222,
    longitude: -157.346944,
    icao: ""
  },
  RDZ: {
    iata: "RDZ",
    name: "Marcillac Airport",
    city: "Rodez",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 44.410594,
    longitude: 2.483866,
    icao: "LFCR"
  },
  REA: {
    iata: "REA",
    name: "Reao Airport",
    city: "Reao, Tuamoto Island",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -18.5,
    longitude: -136.4,
    icao: "NTGE"
  },
  REC: {
    iata: "REC",
    name: "Guararapes-Gilberto Freyre International Airport",
    city: "Recife",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -8.131507,
    longitude: -34.917921,
    icao: "SBRF"
  },
  RED: {
    iata: "RED",
    name: "Mifflin County Airport",
    city: "Reedsville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.683333,
    longitude: -77.616667,
    icao: "KRVL"
  },
  REG: {
    iata: "REG",
    name: "Tito Menniti Airport",
    city: "Reggio Calabria",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 38.075278,
    longitude: 15.650833,
    icao: "LICR"
  },
  REL: {
    iata: "REL",
    name: "Trelew Airport",
    city: "Trelew",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -43.233333,
    longitude: -65.323333,
    icao: "SAVT"
  },
  REN: {
    iata: "REN",
    name: "Orenburg Airport",
    city: "Orenburg",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yekaterinburg",
    latitude: 51.791049,
    longitude: 55.456698,
    icao: "UWOO"
  },
  REO: {
    iata: "REO",
    name: "Rome State Airport",
    city: "Rome",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 42.577778,
    longitude: -117.885556,
    icao: "KREO"
  },
  REP: {
    iata: "REP",
    name: "Siem Reap International Airport",
    city: "Siem Reap",
    countryId: "KH",
    timeZoneRegionName: "Asia/Phnom_Penh",
    latitude: 13.408436,
    longitude: 103.815927,
    icao: "VDSR"
  },
  RER: {
    iata: "RER",
    name: "Retalhuleu Airport",
    city: "Retalhuleu",
    countryId: "GT",
    timeZoneRegionName: "America/Guatemala",
    latitude: 14.521131,
    longitude: -91.697382,
    icao: "MGRT"
  },
  RES: {
    iata: "RES",
    name: "Resistencia Airport",
    city: "Resistencia",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -27.451389,
    longitude: -59.050833,
    icao: "SARE"
  },
  RET: {
    iata: "RET",
    name: "Rost Airport",
    city: "Rost",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 67.527675,
    longitude: 12.103479,
    icao: "ENRS"
  },
  REU: {
    iata: "REU",
    name: "Reus Airport",
    city: "Reus",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 41.146102,
    longitude: 1.153319,
    icao: "LERS"
  },
  REW: {
    iata: "REW",
    name: "Rewa Chorhata Airport",
    city: "Rewa",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 24.533333,
    longitude: 81.3,
    icao: ""
  },
  REX: {
    iata: "REX",
    name: "Gen Lucio Blanco International Airport",
    city: "Reynosa",
    countryId: "MX",
    timeZoneRegionName: "America/Matamoros",
    latitude: 26.011243,
    longitude: -98.227557,
    icao: "MMRX"
  },
  REY: {
    iata: "REY",
    name: "Reyes Airport",
    city: "Reyes",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -14.316667,
    longitude: -67.266667,
    icao: "SLRY"
  },
  RFD: {
    iata: "RFD",
    name: "Chicago Rockford International Airport",
    city: "Rockford",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 42.201748,
    longitude: -89.095372,
    icao: "KRFD"
  },
  RFG: {
    iata: "RFG",
    name: "Rooke Field",
    city: "Refugio",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 28.2934,
    longitude: -97.324458,
    icao: "KRFG"
  },
  RFN: {
    iata: "RFN",
    name: "Raufarhofn Airport",
    city: "Raufarhofn",
    countryId: "IS",
    timeZoneRegionName: "Atlantic/Reykjavik",
    latitude: 66.4143,
    longitude: -15.9208,
    icao: "BIRG"
  },
  RFP: {
    iata: "RFP",
    name: "Raiatea Airport",
    city: "Raiatea",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -16.725004,
    longitude: -151.466665,
    icao: "NTTR"
  },
  RGA: {
    iata: "RGA",
    name: "Rio Grande Airport",
    city: "Rio Grande",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -53.779167,
    longitude: -67.75,
    icao: "SAWE"
  },
  RGI: {
    iata: "RGI",
    name: "Rangiroa Airport",
    city: "Rangiroa",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -14.956334,
    longitude: -147.659149,
    icao: "NTTG"
  },
  RGK: {
    iata: "RGK",
    name: "Gorno-Altaysk Airport",
    city: "Gorno-Altaysk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Barnaul",
    latitude: 51.969166,
    longitude: 85.83639,
    icao: "UNBG"
  },
  RGL: {
    iata: "RGL",
    name: "Rio Gallegos Internacional Airport",
    city: "Rio Gallegos",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -51.616667,
    longitude: -69.283333,
    icao: "SAWG"
  },
  RGN: {
    iata: "RGN",
    name: "Yangon International Airport",
    city: "Yangon",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 16.900069,
    longitude: 96.134152,
    icao: "VYYY"
  },
  RGS: {
    iata: "RGS",
    name: "Villafria Airport",
    city: "Burgos",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 42.357451,
    longitude: -3.613573,
    icao: "LEBG"
  },
  RGT: {
    iata: "RGT",
    name: "Japura Airport",
    city: "Rengat",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: -0.4,
    longitude: 102.55,
    icao: "WIPR"
  },
  RHD: {
    iata: "RHD",
    name: "Termas de Rio Hondo Airport",
    city: "Rio Hondo",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -27.496667,
    longitude: -64.935958,
    icao: "SANR"
  },
  RHE: {
    iata: "RHE",
    name: "Reims Airport",
    city: "Reims",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 49.310833,
    longitude: 4.050556,
    icao: "LFSR"
  },
  RHG: {
    iata: "RHG",
    name: "Ruhengeri Airport",
    city: "Ruhengeri",
    countryId: "RW",
    timeZoneRegionName: "Africa/Kigali",
    latitude: -1.5,
    longitude: 29.6,
    icao: "HRYU"
  },
  RHI: {
    iata: "RHI",
    name: "Oneida County Airport",
    city: "Rhinelander",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 45.625707,
    longitude: -89.462533,
    icao: "KRHI"
  },
  RHO: {
    iata: "RHO",
    name: "Rhodes Airport",
    city: "Rhodes",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 36.401866,
    longitude: 28.090677,
    icao: "LGRP"
  },
  RHP: {
    iata: "RHP",
    name: "Ramechhap Airport",
    city: "Ramechhap",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 27.333333,
    longitude: 86.083333,
    icao: "VNRC"
  },
  RHV: {
    iata: "RHV",
    name: "Reid-Hillview Airport",
    city: "San Jose",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 37.334155,
    longitude: -121.818215,
    icao: "KRHV"
  },
  RIA: {
    iata: "RIA",
    name: "Santa Maria Airport",
    city: "Santa Maria",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -29.710556,
    longitude: -53.6875,
    icao: "SBSM"
  },
  RIB: {
    iata: "RIB",
    name: "Gen Buech Airport",
    city: "Riberalta",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -11.006944,
    longitude: -66.093056,
    icao: "SLRI"
  },
  RIC: {
    iata: "RIC",
    name: "Richmond International Airport (Byrd Field)",
    city: "Richmond",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 37.506111,
    longitude: -77.3225,
    icao: "KRIC"
  },
  RID: {
    iata: "RID",
    name: "Richmond Airport",
    city: "Richmond",
    countryId: "US",
    timeZoneRegionName: "America/Indiana/Indianapolis",
    latitude: 39.833333,
    longitude: -84.9,
    icao: "KRID"
  },
  RIE: {
    iata: "RIE",
    name: "Rice Lake Regional Airport-Carl's Field",
    city: "Rice Lake",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 45.42054,
    longitude: -91.773847,
    icao: "KRPD"
  },
  RIF: {
    iata: "RIF",
    name: "Reynolds Airport",
    city: "Richfield",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 38.741111,
    longitude: -112.094444,
    icao: "KRIF"
  },
  RIG: {
    iata: "RIG",
    name: "Rio Grande Airport",
    city: "Rio Grande",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -32.083333,
    longitude: -52.166667,
    icao: "SBRG"
  },
  RIH: {
    iata: "RIH",
    name: "Scarlett Martinez International Airport",
    city: "Rio Hato",
    countryId: "PA",
    timeZoneRegionName: "America/Panama",
    latitude: 8.371162,
    longitude: -80.12788,
    icao: "MPSM"
  },
  RIJ: {
    iata: "RIJ",
    name: "Juan Simons Vela Airport",
    city: "Rioja",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -6.065464,
    longitude: -77.162062,
    icao: "SPJA"
  },
  RIL: {
    iata: "RIL",
    name: "Garfield County Airport",
    city: "Rifle",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 39.526267,
    longitude: -107.725484,
    icao: "KRIL"
  },
  RIM: {
    iata: "RIM",
    name: "Rodriguez De Mendoza Airport",
    city: "Rodriguez De Mendoza",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -6,
    longitude: -78,
    icao: "SPLN"
  },
  RIR: {
    iata: "RIR",
    name: "Riverside Flabob Airport",
    city: "Riverside",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 33.988828,
    longitude: -117.409042,
    icao: "KRIR"
  },
  RIS: {
    iata: "RIS",
    name: "Rishiri Airport",
    city: "Rishiri",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 45.183333,
    longitude: 141.25,
    icao: "RJER"
  },
  RIV: {
    iata: "RIV",
    name: "March Air Reserve Base",
    city: "Riverside",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 33.888479,
    longitude: -117.258414,
    icao: "KRIV"
  },
  RIW: {
    iata: "RIW",
    name: "Riverton Airport",
    city: "Riverton",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 43.064444,
    longitude: -108.456944,
    icao: "KRIW"
  },
  RIX: {
    iata: "RIX",
    name: "Riga International Airport",
    city: "Riga",
    countryId: "LV",
    timeZoneRegionName: "Europe/Riga",
    latitude: 56.92208,
    longitude: 23.979806,
    icao: "EVRA"
  },
  RIY: {
    iata: "RIY",
    name: "Riyan Airport",
    city: "Riyan",
    countryId: "YE",
    timeZoneRegionName: "Asia/Aden",
    latitude: 14.666999,
    longitude: 49.373684,
    icao: "OYRN"
  },
  RIZ: {
    iata: "RIZ",
    name: "Rizhao Shanzihe Airport",
    city: "Rizhao",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 35.400771,
    longitude: 119.317278,
    icao: ""
  },
  RJA: {
    iata: "RJA",
    name: "Rajahmundry Airport",
    city: "Rajahmundry",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 17.109639,
    longitude: 81.820807,
    icao: "VORY"
  },
  RJB: {
    iata: "RJB",
    name: "Rajbiraj Airport",
    city: "Rajbiraj",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 26.509793,
    longitude: 86.734684,
    icao: "VNRB"
  },
  RJH: {
    iata: "RJH",
    name: "Rajshahi Airport",
    city: "Rajshahi",
    countryId: "BD",
    timeZoneRegionName: "Asia/Dhaka",
    latitude: 24.433333,
    longitude: 88.616667,
    icao: "VGRJ"
  },
  RJK: {
    iata: "RJK",
    name: "Rijeka Airport",
    city: "Rijeka",
    countryId: "HR",
    timeZoneRegionName: "Europe/Zagreb",
    latitude: 45.215833,
    longitude: 14.568333,
    icao: "LDRI"
  },
  RJL: {
    iata: "RJL",
    name: "Logro\xF1o\u2013Agoncillo Airport",
    city: "Logro\xF1o",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 42.460278,
    longitude: -2.320278,
    icao: "LERJ"
  },
  RJN: {
    iata: "RJN",
    name: "Rafsanjan Airport",
    city: "Rafsanjan",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 30.297701,
    longitude: 56.051102,
    icao: "OIKR"
  },
  RKA: {
    iata: "RKA",
    name: "Aratika-Nord Airport",
    city: "Aratika",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -15.485299,
    longitude: -145.468877,
    icao: "NTKK"
  },
  RKD: {
    iata: "RKD",
    name: "Knox County Regional Airport",
    city: "Rockland",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 44.059167,
    longitude: -69.098056,
    icao: "KRKD"
  },
  RKE: {
    iata: "RKE",
    name: "Roskilde Airport",
    city: "Copenhagen",
    countryId: "DK",
    timeZoneRegionName: "Europe/Copenhagen",
    latitude: 55.589721,
    longitude: 12.128183,
    icao: "EKRK"
  },
  RKH: {
    iata: "RKH",
    name: "York County Airport-Bryant Field",
    city: "Rock Hill",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 34.987798,
    longitude: -81.057196,
    icao: "KUZA"
  },
  RKP: {
    iata: "RKP",
    name: "Aransas County Airport",
    city: "Rockport",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 28.033333,
    longitude: -97.05,
    icao: "KRKP"
  },
  RKR: {
    iata: "RKR",
    name: "Robert S. Kerr Airport",
    city: "Poteau",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.05,
    longitude: -94.616667,
    icao: "KRKR"
  },
  RKS: {
    iata: "RKS",
    name: "Rock Springs-Sweetwater County Airport",
    city: "Rock Springs",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 41.598034,
    longitude: -109.072092,
    icao: "KRKS"
  },
  RKT: {
    iata: "RKT",
    name: "Ras Al Khaimah International Airport",
    city: "Ras al-Khaimah",
    countryId: "AE",
    timeZoneRegionName: "Asia/Dubai",
    latitude: 25.616667,
    longitude: 55.941224,
    icao: "OMRK"
  },
  RKV: {
    iata: "RKV",
    name: "Reykjavik International Airport",
    city: "Reykjavik",
    countryId: "IS",
    timeZoneRegionName: "Atlantic/Reykjavik",
    latitude: 64.131055,
    longitude: -21.932476,
    icao: "BIRK"
  },
  RKW: {
    iata: "RKW",
    name: "Rockwood Municipal Airport",
    city: "Rockwood",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 35.866667,
    longitude: -84.683333,
    icao: "KRKW"
  },
  RKZ: {
    iata: "RKZ",
    name: "Shigatse Peace Airport",
    city: "Shigatse",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 29.351944,
    longitude: 89.31,
    icao: "ZURK"
  },
  RLA: {
    iata: "RLA",
    name: "Rolla Downtown Airport",
    city: "Rolla",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 37.935903,
    longitude: -91.813478,
    icao: "KVIH"
  },
  RLD: {
    iata: "RLD",
    name: "Richland Airport",
    city: "Richland",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 46.308333,
    longitude: -119.305556,
    icao: "KRLD"
  },
  RLG: {
    iata: "RLG",
    name: "Laage Airport",
    city: "Rostock-Laage",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 53.92,
    longitude: 12.266667,
    icao: "ETNL"
  },
  RLK: {
    iata: "RLK",
    name: "Bayannur Tianjitai Airport",
    city: "Bayannur",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 40.926388,
    longitude: 107.73889,
    icao: ""
  },
  RLO: {
    iata: "RLO",
    name: "Valle del Conlara Airport",
    city: "Santa Rose de Conlara",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -32.380006,
    longitude: -65.180267,
    icao: "SAOS"
  },
  RMA: {
    iata: "RMA",
    name: "Roma Airport",
    city: "Roma",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -26.543553,
    longitude: 148.779431,
    icao: "YROM"
  },
  RME: {
    iata: "RME",
    name: "Griffiss International Airport",
    city: "Rome",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 43.233799,
    longitude: -75.406998,
    icao: "KRME"
  },
  RMF: {
    iata: "RMF",
    name: "Marsa Alam International Airport",
    city: "Marsa Alam",
    countryId: "EG",
    timeZoneRegionName: "Africa/Cairo",
    latitude: 25.555787,
    longitude: 34.592778,
    icao: "HEMA"
  },
  RMG: {
    iata: "RMG",
    name: "Richard B Russell Airport",
    city: "Rome",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 34.351389,
    longitude: -85.158611,
    icao: "KRMG"
  },
  RMI: {
    iata: "RMI",
    name: "Miramare Airport",
    city: "Rimini",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 44.022952,
    longitude: 12.619594,
    icao: "LIPR"
  },
  RMK: {
    iata: "RMK",
    name: "Renmark Airport",
    city: "Renmark",
    countryId: "AU",
    timeZoneRegionName: "Australia/Adelaide",
    latitude: -34.2,
    longitude: 140.683333,
    icao: "YREN"
  },
  RML: {
    iata: "RML",
    name: "Ratmalana Airport",
    city: "Colombo",
    countryId: "LK",
    timeZoneRegionName: "Asia/Colombo",
    latitude: 6.821998,
    longitude: 79.886201,
    icao: "VCCC"
  },
  RMO: {
    iata: "RMO",
    name: "Chisinau International Airport",
    city: "Chisinau",
    countryId: "MD",
    timeZoneRegionName: "Europe/Chisinau",
    latitude: 46.935442,
    longitude: 28.934967,
    icao: "LUKK"
  },
  RMQ: {
    iata: "RMQ",
    name: "Taichung International Airport",
    city: "Shalu",
    countryId: "TW",
    timeZoneRegionName: "Asia/Taipei",
    latitude: 24.254755,
    longitude: 120.601184,
    icao: "RCMQ"
  },
  RMS: {
    iata: "RMS",
    name: "Ramstein Air Base",
    city: "Ramstein",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 49.441015,
    longitude: 7.589789,
    icao: "ETAR"
  },
  RMT: {
    iata: "RMT",
    name: "Rimatara Airport",
    city: "Rimatara",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Gambier",
    latitude: -22.638783,
    longitude: -152.805155,
    icao: "NTAM"
  },
  RMU: {
    iata: "RMU",
    name: "Regi\xF3n de Murcia International Airport",
    city: "Valladolises",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 37.802583,
    longitude: -1.125389,
    icao: "LEMI"
  },
  RMZ: {
    iata: "RMZ",
    name: "Tobolsk Remezov Airport",
    city: "Tobolsk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yekaterinburg",
    latitude: 58.058333,
    longitude: 68.348611,
    icao: ""
  },
  RNA: {
    iata: "RNA",
    name: "Ulawa Airport",
    city: "Arona",
    countryId: "SB",
    timeZoneRegionName: "Pacific/Guadalcanal",
    latitude: -9.864444,
    longitude: 161.983056,
    icao: "AGAR"
  },
  RNB: {
    iata: "RNB",
    name: "Kallinge Airport",
    city: "Ronneby",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 56.258333,
    longitude: 15.261111,
    icao: "ESDF"
  },
  RNC: {
    iata: "RNC",
    name: "Warren County Memorial Airport",
    city: "McMinnville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.698566,
    longitude: -85.843808,
    icao: "KRNC"
  },
  RND: {
    iata: "RND",
    name: "Randolph Air Force Base",
    city: "San Antonio",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 29.529672,
    longitude: -98.27889,
    icao: "KRND"
  },
  RNE: {
    iata: "RNE",
    name: "Renaison Airport",
    city: "Roanne",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 46.053333,
    longitude: 4.000833,
    icao: "LFLO"
  },
  RNH: {
    iata: "RNH",
    name: "New Richmond Municipal Airport",
    city: "New Richmond",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 45.133333,
    longitude: -92.55,
    icao: "KRNH"
  },
  RNI: {
    iata: "RNI",
    name: "Corn Island Airport",
    city: "Corn Island",
    countryId: "NI",
    timeZoneRegionName: "America/Managua",
    latitude: 12.174154,
    longitude: -83.059682,
    icao: "MNCI"
  },
  RNJ: {
    iata: "RNJ",
    name: "Yoron Airport",
    city: "Yoronjima",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 27.042213,
    longitude: 128.406343,
    icao: "RORY"
  },
  RNL: {
    iata: "RNL",
    name: "Rennell Tingoa Airport",
    city: "Rennell",
    countryId: "SB",
    timeZoneRegionName: "Pacific/Guadalcanal",
    latitude: -11.666667,
    longitude: 160.3,
    icao: "AGGR"
  },
  RNM: {
    iata: "RNM",
    name: "Qarn Alam Airport",
    city: "Qarn Alam",
    countryId: "OM",
    timeZoneRegionName: "Asia/Muscat",
    latitude: 21.375585,
    longitude: 57.054806,
    icao: "OOGB"
  },
  RNN: {
    iata: "RNN",
    name: "Bornholm Airport",
    city: "Bornholm",
    countryId: "DK",
    timeZoneRegionName: "Europe/Copenhagen",
    latitude: 55.063645,
    longitude: 14.758274,
    icao: "EKRN"
  },
  RNO: {
    iata: "RNO",
    name: "Reno/Tahoe International Airport",
    city: "Reno",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 39.505782,
    longitude: -119.775698,
    icao: "KRNO"
  },
  RNS: {
    iata: "RNS",
    name: "Rennes Airport",
    city: "Rennes",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 48.068064,
    longitude: -1.726249,
    icao: "LFRN"
  },
  RNT: {
    iata: "RNT",
    name: "Renton Municipal Airport",
    city: "Renton",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 47.493099,
    longitude: -122.216003,
    icao: "KRNT"
  },
  RNZ: {
    iata: "RNZ",
    name: "Rensselaer Airport",
    city: "Rensselaer",
    countryId: "US",
    timeZoneRegionName: "America/Indiana/Indianapolis",
    latitude: 40.95,
    longitude: -87.15,
    icao: "KRZL"
  },
  ROA: {
    iata: "ROA",
    name: "Roanoke-Blacksburg Regional Airport",
    city: "Roanoke",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 37.320509,
    longitude: -79.970384,
    icao: "KROA"
  },
  ROB: {
    iata: "ROB",
    name: "Roberts International Airport",
    city: "Monrovia",
    countryId: "LR",
    timeZoneRegionName: "Africa/Monrovia",
    latitude: 6.239722,
    longitude: -10.358889,
    icao: "GLRB"
  },
  ROC: {
    iata: "ROC",
    name: "Greater Rochester International Airport",
    city: "Rochester",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 43.127974,
    longitude: -77.665427,
    icao: "KROC"
  },
  ROD: {
    iata: "ROD",
    name: "Robertson Airport",
    city: "Robertson",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -33.816667,
    longitude: 19.9,
    icao: "FARS"
  },
  ROG: {
    iata: "ROG",
    name: "Rogers Municipal Airport - Carter Field",
    city: "Rogers",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.372222,
    longitude: -94.106667,
    icao: "KROG"
  },
  ROI: {
    iata: "ROI",
    name: "Roi Et Airport",
    city: "Roi Et",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 16.116736,
    longitude: 103.773842,
    icao: "VTUV"
  },
  ROK: {
    iata: "ROK",
    name: "Rockhampton Airport",
    city: "Rockhampton",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -23.381901,
    longitude: 150.475006,
    icao: "YBRK"
  },
  ROO: {
    iata: "ROO",
    name: "Rondonopolis Airport",
    city: "Rondonopolis",
    countryId: "BR",
    timeZoneRegionName: "America/Campo_Grande",
    latitude: -16.586,
    longitude: -54.7248,
    icao: "SWRD"
  },
  ROP: {
    iata: "ROP",
    name: "Rota Airport",
    city: "Rota",
    countryId: "MP",
    timeZoneRegionName: "Pacific/Saipan",
    latitude: 14.171568,
    longitude: 145.244085,
    icao: "PGRO"
  },
  ROR: {
    iata: "ROR",
    name: "Airai Airport",
    city: "Koror",
    countryId: "PW",
    timeZoneRegionName: "Pacific/Palau",
    latitude: 7.364122,
    longitude: 134.532892,
    icao: "PTRO"
  },
  ROS: {
    iata: "ROS",
    name: "Fisherton Airport",
    city: "Rosario",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -32.933333,
    longitude: -60.783333,
    icao: "SAAR"
  },
  ROT: {
    iata: "ROT",
    name: "Rotorua International Airport",
    city: "Rotorua",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -38.10982,
    longitude: 176.317459,
    icao: "NZRO"
  },
  ROV: {
    iata: "ROV",
    name: "Platov International Airport",
    city: "Rostov",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 47.497087,
    longitude: 39.916471,
    icao: "URRR"
  },
  ROW: {
    iata: "ROW",
    name: "Roswell International Air Center",
    city: "Roswell",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 33.305389,
    longitude: -104.525744,
    icao: "KROW"
  },
  ROX: {
    iata: "ROX",
    name: "Roseau Municipal Airport",
    city: "Roseau",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 48.853845,
    longitude: -95.696899,
    icao: "KROX"
  },
  ROY: {
    iata: "ROY",
    name: "Rio Mayo Airport",
    city: "Rio Mayo",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -45.666667,
    longitude: -70.25,
    icao: "SAWM"
  },
  ROZ: {
    iata: "ROZ",
    name: "Naval Station Rota",
    city: "Rota",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 36.645252,
    longitude: -6.350709,
    icao: "LERT"
  },
  RPM: {
    iata: "RPM",
    name: "Ngukurr Airport",
    city: "Ngukurr",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -14.933333,
    longitude: 134,
    icao: "YNGU"
  },
  RPN: {
    iata: "RPN",
    name: "Rosh Pina Airport",
    city: "Rosh Pina",
    countryId: "IL",
    timeZoneRegionName: "Asia/Jerusalem",
    latitude: 32.981667,
    longitude: 35.571111,
    icao: "LLIB"
  },
  RPR: {
    iata: "RPR",
    name: "Swami Vivekananda Airport",
    city: "Raipur",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 21.184561,
    longitude: 81.739751,
    icao: "VARP"
  },
  RPX: {
    iata: "RPX",
    name: "Roundup Airport",
    city: "Roundup",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 46.433333,
    longitude: -108.533333,
    icao: "KRPX"
  },
  RQA: {
    iata: "RQA",
    name: "Ruoqiang Loulan Airport",
    city: "Ruogiang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 38.974722,
    longitude: 88.008333,
    icao: ""
  },
  RQY: {
    iata: "RQY",
    name: "Shivamogga Airport",
    city: "Shivamogga",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 13.857305,
    longitude: 75.614962,
    icao: ""
  },
  RRE: {
    iata: "RRE",
    name: "Marree Airport",
    city: "Marree",
    countryId: "AU",
    timeZoneRegionName: "Australia/Adelaide",
    latitude: -29.65,
    longitude: 138.066667,
    icao: "YMRE"
  },
  RRG: {
    iata: "RRG",
    name: "Plaine Corail Airport",
    city: "Rodrigues Island",
    countryId: "MU",
    timeZoneRegionName: "Indian/Mauritius",
    latitude: -19.757652,
    longitude: 63.360985,
    icao: "FIMR"
  },
  RRJ: {
    iata: "RRJ",
    name: "Jacarepagua-Roberto Marinho Airport",
    city: "Rio De Janeiro",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -22.986689,
    longitude: -43.369897,
    icao: "SBJR"
  },
  RRK: {
    iata: "RRK",
    name: "Rourkela Airport",
    city: "Rourkela",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 22.256667,
    longitude: 84.814722,
    icao: "VERK"
  },
  RRL: {
    iata: "RRL",
    name: "Merrill Municipal Airport",
    city: "Merrill",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 45.183333,
    longitude: -89.683333,
    icao: "KRRL"
  },
  RRR: {
    iata: "RRR",
    name: "Raroia Airport",
    city: "Raroia",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -16.044858,
    longitude: -142.475561,
    icao: "NTKO"
  },
  RRS: {
    iata: "RRS",
    name: "Roros Airport",
    city: "Roros",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 62.579167,
    longitude: 11.345556,
    icao: "ENRO"
  },
  RRT: {
    iata: "RRT",
    name: "Warroad Airport",
    city: "Warroad",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 48.9,
    longitude: -95.3,
    icao: "KRRT"
  },
  RSA: {
    iata: "RSA",
    name: "Santa Rosa Airport",
    city: "Santa Rosa",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -36.566667,
    longitude: -64.266667,
    icao: "SAZR"
  },
  RSB: {
    iata: "RSB",
    name: "Roseberth Airport",
    city: "Roseberth",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -25.833333,
    longitude: 139.633333,
    icao: "YRSB"
  },
  RSD: {
    iata: "RSD",
    name: "South Eleuthera Airport",
    city: "Rock Sound",
    countryId: "BS",
    timeZoneRegionName: "America/Nassau",
    latitude: 24.891667,
    longitude: -76.178056,
    icao: "MYER"
  },
  RSH: {
    iata: "RSH",
    name: "Russian Mission Airport",
    city: "Russian Mission",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 61.783056,
    longitude: -161.319167,
    icao: "PARS"
  },
  RSI: {
    iata: "RSI",
    name: "Red Sea International Airport",
    city: "Red Sea Project",
    countryId: "SA",
    timeZoneRegionName: "Asia/Riyadh",
    latitude: 25.630278,
    longitude: 37.078333,
    icao: "OERS"
  },
  RSK: {
    iata: "RSK",
    name: "Abresso Airport",
    city: "Ransiki",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jayapura",
    latitude: -1.499828,
    longitude: 134.179972,
    icao: "WASC"
  },
  RSL: {
    iata: "RSL",
    name: "Russell Airport",
    city: "Russell",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 38.883333,
    longitude: -98.85,
    icao: "KRSL"
  },
  RSN: {
    iata: "RSN",
    name: "Ruston Airport",
    city: "Ruston",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.516667,
    longitude: -92.633333,
    icao: "KRSN"
  },
  RSS: {
    iata: "RSS",
    name: "Damazin Airport",
    city: "Damazin",
    countryId: "SD",
    timeZoneRegionName: "Africa/Khartoum",
    latitude: 11.792422,
    longitude: 34.336558,
    icao: "HSDZ"
  },
  RST: {
    iata: "RST",
    name: "Rochester International Airport",
    city: "Rochester",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 43.910793,
    longitude: -92.489768,
    icao: "KRST"
  },
  RSU: {
    iata: "RSU",
    name: "Yeosu Airport",
    city: "Yeosu",
    countryId: "KR",
    timeZoneRegionName: "Asia/Seoul",
    latitude: 34.8419,
    longitude: 127.612673,
    icao: "RKJY"
  },
  RSW: {
    iata: "RSW",
    name: "Southwest Florida International Airport",
    city: "Fort Myers",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 26.527887,
    longitude: -81.755263,
    icao: "KRSW"
  },
  RTA: {
    iata: "RTA",
    name: "Rotuma Island Airport",
    city: "Rotuma Island",
    countryId: "FJ",
    timeZoneRegionName: "Pacific/Fiji",
    latitude: -12.4825,
    longitude: 177.0711,
    icao: "NFNR"
  },
  RTB: {
    iata: "RTB",
    name: "Roatan Airport",
    city: "Roatan",
    countryId: "HN",
    timeZoneRegionName: "America/Tegucigalpa",
    latitude: 16.318209,
    longitude: -86.52722,
    icao: "MHRO"
  },
  RTC: {
    iata: "RTC",
    name: "Ratnagiri Airport",
    city: "Ratnagiri",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 17,
    longitude: 73.316667,
    icao: "VARG"
  },
  RTE: {
    iata: "RTE",
    name: "Campo de Marte Airport",
    city: "Sao Paulo",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -23.510839,
    longitude: -46.634107,
    icao: "SBMT"
  },
  RTG: {
    iata: "RTG",
    name: "Frans Sales Lega Airport",
    city: "Ruteng",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -8.596921,
    longitude: 120.478345,
    icao: "WATG"
  },
  RTI: {
    iata: "RTI",
    name: "David C. Saudale Airport",
    city: "Rote Island",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -10.767597,
    longitude: 123.073303,
    icao: "WATR"
  },
  RTM: {
    iata: "RTM",
    name: "Rotterdam The Hague Airport",
    city: "Rotterdam",
    countryId: "NL",
    timeZoneRegionName: "Europe/Amsterdam",
    latitude: 51.948949,
    longitude: 4.433606,
    icao: "EHRD"
  },
  RTN: {
    iata: "RTN",
    name: "Crews Field",
    city: "Raton",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 36.741389,
    longitude: -104.501111,
    icao: "KRTN"
  },
  RTP: {
    iata: "RTP",
    name: "Rutland Plains Airport",
    city: "Rutland Plains",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -15.6,
    longitude: 141.833333,
    icao: "YRTP"
  },
  RTS: {
    iata: "RTS",
    name: "Rottnest Island Airport",
    city: "Rottnest Island",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -32.006944,
    longitude: 115.536667,
    icao: "YRTI"
  },
  RTW: {
    iata: "RTW",
    name: "Saratov Airport",
    city: "Saratov",
    countryId: "RU",
    timeZoneRegionName: "Europe/Saratov",
    latitude: 51.561674,
    longitude: 46.035095,
    icao: "UWSS"
  },
  RUA: {
    iata: "RUA",
    name: "Arua Airport",
    city: "Arua",
    countryId: "UG",
    timeZoneRegionName: "Africa/Kampala",
    latitude: 3.033333,
    longitude: 30.933333,
    icao: "HUAR"
  },
  RUD: {
    iata: "RUD",
    name: "Shahrud Airport",
    city: "Shahrud",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 36.425301,
    longitude: 55.104198,
    icao: "OIMJ"
  },
  RUH: {
    iata: "RUH",
    name: "King Khalid International Airport",
    city: "Riyadh",
    countryId: "SA",
    timeZoneRegionName: "Asia/Riyadh",
    latitude: 24.959289,
    longitude: 46.702876,
    icao: "OERK"
  },
  RUI: {
    iata: "RUI",
    name: "Ruidoso Municipal Airport",
    city: "Ruidoso",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 33.360833,
    longitude: -105.6625,
    icao: "KSRR"
  },
  RUK: {
    iata: "RUK",
    name: "Rukumkot Chaurjahari Airport",
    city: "Rukumkot",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 28.628006,
    longitude: 82.193888,
    icao: "VNCJ"
  },
  RUL: {
    iata: "RUL",
    name: "Maavarulu Airport",
    city: "Maavarulu",
    countryId: "MV",
    timeZoneRegionName: "Indian/Maldives",
    latitude: 0.338056,
    longitude: 73.512778,
    icao: ""
  },
  RUM: {
    iata: "RUM",
    name: "Rumjatar Airport",
    city: "Rumjatar",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 27.316667,
    longitude: 86.533333,
    icao: "VNRT"
  },
  RUN: {
    iata: "RUN",
    name: "Reunion Roland Garros Airport",
    city: "Saint Denis de la Reunion",
    countryId: "RE",
    timeZoneRegionName: "Indian/Reunion",
    latitude: -20.892,
    longitude: 55.511877,
    icao: "FMEE"
  },
  RUP: {
    iata: "RUP",
    name: "Rupsi Airport",
    city: "Rupsi",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 26.15,
    longitude: 89.916667,
    icao: "VERU"
  },
  RUR: {
    iata: "RUR",
    name: "Rurutu Airport",
    city: "Rurutu",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -22.433333,
    longitude: -151.333333,
    icao: "NTAR"
  },
  RUT: {
    iata: "RUT",
    name: "Rutland Airport",
    city: "Rutland",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 43.529444,
    longitude: -72.948333,
    icao: "KRUT"
  },
  RVA: {
    iata: "RVA",
    name: "Farafangana Airport",
    city: "Farafangana",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -22.801944,
    longitude: 47.819444,
    icao: "FMSG"
  },
  RVD: {
    iata: "RVD",
    name: "Rio Verde Airport",
    city: "Rio Verde",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -17.834723,
    longitude: -50.956112,
    icao: "SWLC"
  },
  RVE: {
    iata: "RVE",
    name: "Saravena Airport",
    city: "Saravena",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 6.916667,
    longitude: -71.9,
    icao: "SKSA"
  },
  RVK: {
    iata: "RVK",
    name: "Ryumsjoen Airport",
    city: "Roervik",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 64.838303,
    longitude: 11.1461,
    icao: "ENRM"
  },
  RVN: {
    iata: "RVN",
    name: "Rovaniemi Airport",
    city: "Rovaniemi",
    countryId: "FI",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 66.559047,
    longitude: 25.829609,
    icao: "EFRO"
  },
  RVO: {
    iata: "RVO",
    name: "Reivilo Airport",
    city: "Reivilo",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -27.6,
    longitude: 24.133333,
    icao: "FARI"
  },
  RVS: {
    iata: "RVS",
    name: "Richard Lloyd Jones Jr Airport",
    city: "Tulsa",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.038843,
    longitude: -95.98448,
    icao: "KRVS"
  },
  RVV: {
    iata: "RVV",
    name: "Raivavae Airport",
    city: "Raivavae",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -23.886111,
    longitude: -147.665278,
    icao: "NTAV"
  },
  RVY: {
    iata: "RVY",
    name: "Rivera Airport",
    city: "Rivera",
    countryId: "UY",
    timeZoneRegionName: "America/Montevideo",
    latitude: -30.973483,
    longitude: -55.477031,
    icao: "SURV"
  },
  RWF: {
    iata: "RWF",
    name: "Redwood Falls Municipal Airport",
    city: "Redwood Falls",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 44.5,
    longitude: -95.1,
    icao: "KRWF"
  },
  RWI: {
    iata: "RWI",
    name: "Rocky Mount-Wilson Airport",
    city: "Rocky Mount/Wilson",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 35.854444,
    longitude: -77.890556,
    icao: "KRWI"
  },
  RWL: {
    iata: "RWL",
    name: "Rawlins Municipal Airport (Harvey Field)",
    city: "Rawlins",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 41.804444,
    longitude: -107.201389,
    icao: "KRWL"
  },
  RWN: {
    iata: "RWN",
    name: "Rovno Airport",
    city: "Rovno",
    countryId: "UA",
    timeZoneRegionName: "Europe/Kiev",
    latitude: 50.6,
    longitude: 26.15,
    icao: "UKLR"
  },
  RXE: {
    iata: "RXE",
    name: "Rexburg-Madison County Airport",
    city: "Rexburg",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 43.833825,
    longitude: -111.80542,
    icao: "KRXE"
  },
  RXS: {
    iata: "RXS",
    name: "Roxas City Airport",
    city: "Roxas City",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 11.60066,
    longitude: 122.748817,
    icao: "RPVR"
  },
  RYG: {
    iata: "RYG",
    name: "Moss-Rygge Airport",
    city: "Rygge",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 59.375931,
    longitude: 10.783043,
    icao: "ENRY"
  },
  RYK: {
    iata: "RYK",
    name: "Rahim Yar Khan Airport",
    city: "Rahim Yar Khan",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 28.39178,
    longitude: 70.286621,
    icao: "OPRK"
  },
  RYL: {
    iata: "RYL",
    name: "Royal Airport",
    city: "Lower Zambezi National Park",
    countryId: "ZM",
    timeZoneRegionName: "Africa/Lusaka",
    latitude: -15.726728,
    longitude: 29.296678,
    icao: "FLRZ"
  },
  RYN: {
    iata: "RYN",
    name: "Medis Airport",
    city: "Royan",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 45.616667,
    longitude: -1.016667,
    icao: "LFCY"
  },
  RYO: {
    iata: "RYO",
    name: "Rio Turbio Airport",
    city: "Rio Turbio",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -51.604478,
    longitude: -72.219595,
    icao: "SAWT"
  },
  RZA: {
    iata: "RZA",
    name: "Santa Cruz Airport",
    city: "Santa Cruz",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -50,
    longitude: -68.533333,
    icao: "SAWU"
  },
  RZE: {
    iata: "RZE",
    name: "Rzeszow International Airport",
    city: "Rzeszow",
    countryId: "PL",
    timeZoneRegionName: "Europe/Warsaw",
    latitude: 50.115248,
    longitude: 22.031331,
    icao: "EPRZ"
  },
  RZH: {
    iata: "RZH",
    name: "Preobrazheniye Airport",
    city: "Preobrazheniye",
    countryId: "RU",
    timeZoneRegionName: "Asia/Vladivostok",
    latitude: 42.921669,
    longitude: 133.904442,
    icao: ""
  },
  RZR: {
    iata: "RZR",
    name: "Ramsar Airport",
    city: "Ramsar",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 36.904624,
    longitude: 50.682442,
    icao: "OINR"
  },
  RZS: {
    iata: "RZS",
    name: "Sawan Airport",
    city: "Sawan",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 26.966531,
    longitude: 68.87952,
    icao: "OPSW"
  },
  RZV: {
    iata: "RZV",
    name: "Rize\u2013Artvin Airport",
    city: "Rize",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 41.169167,
    longitude: 40.828889,
    icao: "LTFO"
  },
  RZZ: {
    iata: "RZZ",
    name: "Halifax County Airport",
    city: "Roanoke Rapids",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 36.466667,
    longitude: -77.666667,
    icao: "KRZZ"
  },
  SAA: {
    iata: "SAA",
    name: "Shively Field",
    city: "Saratoga",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 41.444782,
    longitude: -106.823933,
    icao: "KSAA"
  },
  SAB: {
    iata: "SAB",
    name: "J. Yrausquin Airport",
    city: "Saba",
    countryId: "BQ",
    timeZoneRegionName: "America/Curacao",
    latitude: 17.65,
    longitude: -63.216667,
    icao: "TNCS"
  },
  SAC: {
    iata: "SAC",
    name: "Sacramento Executive Airport",
    city: "Sacramento",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 38.513195,
    longitude: -121.494136,
    icao: "KSAC"
  },
  SAD: {
    iata: "SAD",
    name: "Safford Regional Airport",
    city: "Safford",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 32.853332,
    longitude: -109.636769,
    icao: "KSAD"
  },
  SAE: {
    iata: "SAE",
    name: "Saattut Heliport",
    city: "Saattut",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 70.808742,
    longitude: -51.626467,
    icao: "BGST"
  },
  SAF: {
    iata: "SAF",
    name: "Santa Fe Municipal Airport",
    city: "Santa Fe",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 35.6175,
    longitude: -106.088333,
    icao: "KSAF"
  },
  SAG: {
    iata: "SAG",
    name: "Shirdi Airport",
    city: "Shirdi",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 19.688611,
    longitude: 74.378889,
    icao: "VASD"
  },
  SAH: {
    iata: "SAH",
    name: "Sana'a International Airport",
    city: "Sana'a",
    countryId: "YE",
    timeZoneRegionName: "Asia/Aden",
    latitude: 15.476298,
    longitude: 44.219702,
    icao: "OYSN"
  },
  SAI: {
    iata: "SAI",
    name: "Siem Reap International Airport",
    city: "Siem Reap",
    countryId: "KH",
    timeZoneRegionName: "Asia/Phnom_Penh",
    latitude: 13.2231,
    longitude: 104.1315,
    icao: "VDSA"
  },
  SAK: {
    iata: "SAK",
    name: "Saudarkrokur Airport",
    city: "Saudarkrokur",
    countryId: "IS",
    timeZoneRegionName: "Atlantic/Reykjavik",
    latitude: 65.75,
    longitude: -19.65,
    icao: "BIKR"
  },
  SAL: {
    iata: "SAL",
    name: "El Salvador International Airport",
    city: "San Salvador",
    countryId: "SV",
    timeZoneRegionName: "America/El_Salvador",
    latitude: 13.445126,
    longitude: -89.05723,
    icao: "MSLP"
  },
  SAN: {
    iata: "SAN",
    name: "San Diego International Airport",
    city: "San Diego",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 32.731938,
    longitude: -117.197312,
    icao: "KSAN"
  },
  SAP: {
    iata: "SAP",
    name: "Ramon Villeda Morales International Airport",
    city: "San Pedro Sula",
    countryId: "HN",
    timeZoneRegionName: "America/Tegucigalpa",
    latitude: 15.456245,
    longitude: -87.927796,
    icao: "MHLM"
  },
  SAQ: {
    iata: "SAQ",
    name: "San Andros Airport",
    city: "San Andros",
    countryId: "BS",
    timeZoneRegionName: "America/Nassau",
    latitude: 25.053652,
    longitude: -78.048182,
    icao: "MYAN"
  },
  SAR: {
    iata: "SAR",
    name: "Sparta Community Airport",
    city: "Sparta",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 38.133333,
    longitude: -89.7,
    icao: "KSAR"
  },
  SAS: {
    iata: "SAS",
    name: "Salton City Airport",
    city: "Salton City",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 33.316667,
    longitude: -115.983333,
    icao: "KSAS"
  },
  SAT: {
    iata: "SAT",
    name: "San Antonio International Airport",
    city: "San Antonio",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 29.524937,
    longitude: -98.472643,
    icao: "KSAT"
  },
  SAV: {
    iata: "SAV",
    name: "Savannah/Hilton Head Airport",
    city: "Savannah",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 32.1358,
    longitude: -81.210588,
    icao: "KSAV"
  },
  SAW: {
    iata: "SAW",
    name: "Sabiha Gokcen International Airport",
    city: "Istanbul",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 40.904676,
    longitude: 29.309188,
    icao: "LTFJ"
  },
  SAY: {
    iata: "SAY",
    name: "Ampugnano Airport",
    city: "Siena",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 43.256302,
    longitude: 11.255,
    icao: "LIQS"
  },
  SBA: {
    iata: "SBA",
    name: "Santa Barbara Municipal Airport",
    city: "Santa Barbara",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 34.432833,
    longitude: -119.836476,
    icao: "KSBA"
  },
  SBD: {
    iata: "SBD",
    name: "San Bernadino International Airport",
    city: "San Bernardino",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 34.098476,
    longitude: -117.242902,
    icao: "KSBD"
  },
  SBG: {
    iata: "SBG",
    name: "Maimun Saleh Airport",
    city: "Sabang",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: 5.87365,
    longitude: 95.341587,
    icao: "WITN"
  },
  SBH: {
    iata: "SBH",
    name: "St. Barthelemy Airport",
    city: "Saint Barthelemy",
    countryId: "GP",
    timeZoneRegionName: "America/Guadeloupe",
    latitude: 17.9044,
    longitude: -62.843601,
    icao: "TFFJ"
  },
  SBI: {
    iata: "SBI",
    name: "Sambailo Airport",
    city: "Koundara",
    countryId: "GN",
    timeZoneRegionName: "Africa/Conakry",
    latitude: 12.483333,
    longitude: -13.3,
    icao: "GUSB"
  },
  SBJ: {
    iata: "SBJ",
    name: "Sao Mateus Airport",
    city: "Sao Mateus",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -18.583333,
    longitude: -39.733333,
    icao: "SNMX"
  },
  SBK: {
    iata: "SBK",
    name: "Tremuson Airport",
    city: "Saint Brieuc",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 48.513056,
    longitude: -2.808889,
    icao: "LFRT"
  },
  SBM: {
    iata: "SBM",
    name: "Sheboygan County Memorial Airport",
    city: "Sheboygan",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 43.764751,
    longitude: -87.850707,
    icao: "KSBM"
  },
  SBN: {
    iata: "SBN",
    name: "South Bend Regional",
    city: "South Bend",
    countryId: "US",
    timeZoneRegionName: "America/Indiana/Indianapolis",
    latitude: 41.700555,
    longitude: -86.313345,
    icao: "KSBN"
  },
  SBP: {
    iata: "SBP",
    name: "San Luis Obispo County Regional Airport",
    city: "San Luis Obispo",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 35.239113,
    longitude: -120.640623,
    icao: "KSBP"
  },
  SBR: {
    iata: "SBR",
    name: "Saibai Island Airport",
    city: "Saibai Island",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -9.378331,
    longitude: 142.625011,
    icao: "YSLI"
  },
  SBS: {
    iata: "SBS",
    name: "Bob Adams Field",
    city: "Steamboat Springs",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 40.516366,
    longitude: -106.866379,
    icao: "KSBS"
  },
  SBT: {
    iata: "SBT",
    name: "Sabetta International Airport",
    city: "Sabetta",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yekaterinburg",
    latitude: 71.215207,
    longitude: 72.043922,
    icao: "USDA"
  },
  SBU: {
    iata: "SBU",
    name: "Springbok Airport",
    city: "Springbok",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -29.688611,
    longitude: 17.939444,
    icao: "FASB"
  },
  SBW: {
    iata: "SBW",
    name: "Sibu Airport",
    city: "Sibu",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 2.254997,
    longitude: 111.986575,
    icao: "WBGS"
  },
  SBX: {
    iata: "SBX",
    name: "Shelby Airport",
    city: "Shelby",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 48.5,
    longitude: -111.85,
    icao: "KSBX"
  },
  SBY: {
    iata: "SBY",
    name: "Wicomico Regional Airport",
    city: "Salisbury-Ocean City",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 38.34312,
    longitude: -75.517269,
    icao: "KSBY"
  },
  SBZ: {
    iata: "SBZ",
    name: "Sibiu Airport",
    city: "Sibiu",
    countryId: "RO",
    timeZoneRegionName: "Europe/Bucharest",
    latitude: 45.789757,
    longitude: 24.093529,
    icao: "LRSB"
  },
  SCB: {
    iata: "SCB",
    name: "Scribner State Airport",
    city: "Scribner",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.610328,
    longitude: -96.629823,
    icao: "KSCB"
  },
  SCC: {
    iata: "SCC",
    name: "Prudhoe Bay/Deadhorse Airport",
    city: "Prudhoe Bay/Deadhorse",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 70.196561,
    longitude: -148.464206,
    icao: "PASC"
  },
  SCE: {
    iata: "SCE",
    name: "University Park Airport",
    city: "State College",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.853721,
    longitude: -77.848228,
    icao: "KUNV"
  },
  SCF: {
    iata: "SCF",
    name: "Scottsdale Airport",
    city: "Phoenix",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 33.621966,
    longitude: -111.908681,
    icao: "KSDL"
  },
  SCH: {
    iata: "SCH",
    name: "Schenectady County Airport",
    city: "Schenectady",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.853488,
    longitude: -73.92849,
    icao: "KSCH"
  },
  SCI: {
    iata: "SCI",
    name: "San Cristobal Airport",
    city: "San Cristobal",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 7.800072,
    longitude: -72.199896,
    icao: "SVPM"
  },
  SCK: {
    iata: "SCK",
    name: "Stockton Airport",
    city: "Stockton",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 37.894444,
    longitude: -121.239167,
    icao: "KSCK"
  },
  SCL: {
    iata: "SCL",
    name: "Arturo Merino Benitez Airport",
    city: "Santiago",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -33.397175,
    longitude: -70.793821,
    icao: "SCEL"
  },
  SCM: {
    iata: "SCM",
    name: "Scammon Bay Airport",
    city: "Scammon Bay",
    countryId: "US",
    timeZoneRegionName: "America/Nome",
    latitude: 61.844542,
    longitude: -165.57375,
    icao: "PACM"
  },
  SCN: {
    iata: "SCN",
    name: "Ensheim Airport",
    city: "Saarbruecken",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 49.220088,
    longitude: 7.112705,
    icao: "EDDR"
  },
  SCO: {
    iata: "SCO",
    name: "Aktau International Airport",
    city: "Aktau",
    countryId: "KZ",
    timeZoneRegionName: "Asia/Aqtau",
    latitude: 43.857447,
    longitude: 51.089073,
    icao: "UATE"
  },
  SCQ: {
    iata: "SCQ",
    name: "Santiago de Compostela Airport",
    city: "Santiago De Compostela",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 42.896308,
    longitude: -8.415125,
    icao: "LEST"
  },
  SCR: {
    iata: "SCR",
    name: "Scandinavian Mountains Airport",
    city: "Salen",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 61.159,
    longitude: 12.84,
    icao: "ESKS"
  },
  SCS: {
    iata: "SCS",
    name: "Scatsta Airport",
    city: "Shetland Islands",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 60.436824,
    longitude: -1.294972,
    icao: "EGPM"
  },
  SCT: {
    iata: "SCT",
    name: "Socotra Airport",
    city: "Socotra",
    countryId: "YE",
    timeZoneRegionName: "Asia/Aden",
    latitude: 12.627546,
    longitude: 53.909245,
    icao: "ODSQ"
  },
  SCU: {
    iata: "SCU",
    name: "Antonio Maceo Airport",
    city: "Santiago",
    countryId: "CU",
    timeZoneRegionName: "America/Havana",
    latitude: 19.969167,
    longitude: -75.835833,
    icao: "MUCU"
  },
  SCV: {
    iata: "SCV",
    name: "Suceava Airport",
    city: "Suceava",
    countryId: "RO",
    timeZoneRegionName: "Europe/Bucharest",
    latitude: 47.685773,
    longitude: 26.351656,
    icao: "LRSV"
  },
  SCW: {
    iata: "SCW",
    name: "Syktyvkar Airport",
    city: "Syktyvkar",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 61.666667,
    longitude: 50.766667,
    icao: "UUYY"
  },
  SCX: {
    iata: "SCX",
    name: "Salina Cruz Airport",
    city: "Salina Cruz",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 16.166667,
    longitude: -95.2,
    icao: "MM57"
  },
  SCY: {
    iata: "SCY",
    name: "San Cristobal Airport",
    city: "San Cristobal",
    countryId: "EC",
    timeZoneRegionName: "Pacific/Galapagos",
    latitude: -0.910206,
    longitude: -89.617401,
    icao: "SPSF"
  },
  SCZ: {
    iata: "SCZ",
    name: "Santa Cruz Island Airport",
    city: "Santa Cruz Island",
    countryId: "SB",
    timeZoneRegionName: "Pacific/Guadalcanal",
    latitude: -10.719397,
    longitude: 165.797497,
    icao: "AGGL"
  },
  SDB: {
    iata: "SDB",
    name: "Langebaanweg Airport",
    city: "Saldanha Bay",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -33.066667,
    longitude: 18,
    icao: "FALW"
  },
  SDD: {
    iata: "SDD",
    name: "Lubango Airport",
    city: "Lubango",
    countryId: "AO",
    timeZoneRegionName: "Africa/Luanda",
    latitude: -14.924444,
    longitude: 13.576667,
    icao: "FNUB"
  },
  SDE: {
    iata: "SDE",
    name: "Santiago Del Estero Airport",
    city: "Santiago Del Estero",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -27.765278,
    longitude: -64.322222,
    icao: "SANE"
  },
  SDF: {
    iata: "SDF",
    name: "Louisville International Airport-Standiford Field",
    city: "Louisville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 38.174397,
    longitude: -85.73599,
    icao: "KSDF"
  },
  SDG: {
    iata: "SDG",
    name: "Sanandaj Airport",
    city: "Sanandaj",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 35.251473,
    longitude: 47.013766,
    icao: "OICS"
  },
  SDJ: {
    iata: "SDJ",
    name: "Sendai Airport",
    city: "Sendai",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 38.135556,
    longitude: 140.923889,
    icao: "RJSS"
  },
  SDK: {
    iata: "SDK",
    name: "Sandakan Airport",
    city: "Sandakan",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 5.896877,
    longitude: 118.061833,
    icao: "WBKS"
  },
  SDL: {
    iata: "SDL",
    name: "Sundsvall-Timra Airport",
    city: "Sundsvall",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 62.526556,
    longitude: 17.43873,
    icao: "ESNN"
  },
  SDM: {
    iata: "SDM",
    name: "Brown Field Municipal Airport",
    city: "San Diego",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 32.572222,
    longitude: -116.98,
    icao: "KSDM"
  },
  SDN: {
    iata: "SDN",
    name: "Sandane Airport",
    city: "Sandane",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 61.766667,
    longitude: 6.216667,
    icao: "ENSD"
  },
  SDP: {
    iata: "SDP",
    name: "Sand Point Municipal Airport",
    city: "Sand Point",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 55.316667,
    longitude: -160.513889,
    icao: "PASD"
  },
  SDQ: {
    iata: "SDQ",
    name: "Las Americas International Airport",
    city: "Santo Domingo",
    countryId: "DO",
    timeZoneRegionName: "America/Santo_Domingo",
    latitude: 18.430125,
    longitude: -69.676742,
    icao: "MDSD"
  },
  SDR: {
    iata: "SDR",
    name: "Santander Airport",
    city: "Santander",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 43.423086,
    longitude: -3.824453,
    icao: "LEXJ"
  },
  SDS: {
    iata: "SDS",
    name: "Sado Shima Airport",
    city: "Sado Shima",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 38,
    longitude: 138.416667,
    icao: "RJSD"
  },
  SDT: {
    iata: "SDT",
    name: "Saidu Sharif Airport",
    city: "Saidu Sharif",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 34.75,
    longitude: 72.35,
    icao: "OPSS"
  },
  SDU: {
    iata: "SDU",
    name: "Santos Dumont Airport",
    city: "Rio De Janeiro",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -22.911541,
    longitude: -43.167097,
    icao: "SBRJ"
  },
  SDV: {
    iata: "SDV",
    name: "Dov Hoz Airport",
    city: "Tel Aviv-Yafo",
    countryId: "IL",
    timeZoneRegionName: "Asia/Jerusalem",
    latitude: 32.104885,
    longitude: 34.787858,
    icao: "LLSD"
  },
  SDW: {
    iata: "SDW",
    name: "Sindhudurg Airport",
    city: "Malvan",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 16.0025,
    longitude: 73.53111,
    icao: "VOSR"
  },
  SDX: {
    iata: "SDX",
    name: "Sedona Airport",
    city: "Sedona",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 34.848598,
    longitude: -111.788002,
    icao: "KSEZ"
  },
  SDY: {
    iata: "SDY",
    name: "Richland Municipal Airport",
    city: "Sidney",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 47.706944,
    longitude: -104.191944,
    icao: "KSDY"
  },
  SEA: {
    iata: "SEA",
    name: "Seattle-Tacoma International Airport",
    city: "Seattle",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 47.443839,
    longitude: -122.301732,
    icao: "KSEA"
  },
  SEB: {
    iata: "SEB",
    name: "Sebha Airport",
    city: "Sebha",
    countryId: "LY",
    timeZoneRegionName: "Africa/Tripoli",
    latitude: 27.001483,
    longitude: 14.461354,
    icao: "HLLS"
  },
  SEE: {
    iata: "SEE",
    name: "Gillespie Field",
    city: "San Diego",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 32.826111,
    longitude: -116.972222,
    icao: "KSEE"
  },
  SEF: {
    iata: "SEF",
    name: "Sebring Air Terminal",
    city: "Sebring",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 27.457846,
    longitude: -81.342519,
    icao: "KSEF"
  },
  SEG: {
    iata: "SEG",
    name: "Penn Valley Airport",
    city: "Selinsgrove",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.820599,
    longitude: -76.863899,
    icao: "KSEG"
  },
  SEK: {
    iata: "SEK",
    name: "Srednekolymsk Airport",
    city: "Srednekolymsk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Srednekolymsk",
    latitude: 67.47922,
    longitude: 153.735,
    icao: ""
  },
  SEM: {
    iata: "SEM",
    name: "Craig Field",
    city: "Selma",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.343889,
    longitude: -87.987778,
    icao: "KSEM"
  },
  SEN: {
    iata: "SEN",
    name: "London Southend Airport",
    city: "Southend",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.57265,
    longitude: 0.698248,
    icao: "EGMC"
  },
  SEO: {
    iata: "SEO",
    name: "Seguela Airport",
    city: "Seguela",
    countryId: "CI",
    timeZoneRegionName: "Africa/Abidjan",
    latitude: 7.966667,
    longitude: -6.666667,
    icao: "DISG"
  },
  SEP: {
    iata: "SEP",
    name: "Clark Field",
    city: "Stephenville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.216667,
    longitude: -98.2,
    icao: "KSEP"
  },
  SER: {
    iata: "SER",
    name: "Freeman Municipal Airport",
    city: "Seymour",
    countryId: "US",
    timeZoneRegionName: "America/Indiana/Indianapolis",
    latitude: 38.966667,
    longitude: -85.883333,
    icao: "KSER"
  },
  SES: {
    iata: "SES",
    name: "Svetlogorsk Airport",
    city: "Svetlogorsk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Krasnoyarsk",
    latitude: 66.842673,
    longitude: 88.409889,
    icao: ""
  },
  SET: {
    iata: "SET",
    name: "Santa Magalhaes Airport",
    city: "Serra Talhada",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -8.052778,
    longitude: -38.386111,
    icao: "SNHS"
  },
  SEU: {
    iata: "SEU",
    name: "Seronera Airstrip",
    city: "Seronera",
    countryId: "TZ",
    timeZoneRegionName: "Africa/Dar_es_Salaam",
    latitude: -2.4567,
    longitude: 34.821546,
    icao: "HTSN"
  },
  SEY: {
    iata: "SEY",
    name: "Selibaby Airport",
    city: "Selibaby",
    countryId: "MR",
    timeZoneRegionName: "Africa/Nouakchott",
    latitude: 15.182222,
    longitude: -12.206111,
    icao: "GQNS"
  },
  SEZ: {
    iata: "SEZ",
    name: "Seychelles International Airport",
    city: "Mahe Island",
    countryId: "SC",
    timeZoneRegionName: "Indian/Mahe",
    latitude: -4.671275,
    longitude: 55.511279,
    icao: "FSIA"
  },
  SFA: {
    iata: "SFA",
    name: "Sfax El Maou Airport",
    city: "Sfax",
    countryId: "TN",
    timeZoneRegionName: "Africa/Tunis",
    latitude: 34.716667,
    longitude: 10.683333,
    icao: "DTTX"
  },
  SFB: {
    iata: "SFB",
    name: "Orlando Sanford International Airport",
    city: "Orlando",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 28.775118,
    longitude: -81.243204,
    icao: "KSFB"
  },
  SFD: {
    iata: "SFD",
    name: "Las Flecheras Airport",
    city: "San Fernando de Apure",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 7.884271,
    longitude: -67.443462,
    icao: "SVSR"
  },
  SFE: {
    iata: "SFE",
    name: "San Fernando Airport",
    city: "San Fernando",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 16.6,
    longitude: 120.3,
    icao: "RPUS"
  },
  SFF: {
    iata: "SFF",
    name: "Felts Field",
    city: "Spokane",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 47.683148,
    longitude: -117.322714,
    icao: "KSFF"
  },
  SFG: {
    iata: "SFG",
    name: "Esperance Airport",
    city: "Saint Martin",
    countryId: "MF",
    timeZoneRegionName: "America/Marigot",
    latitude: 18.100555,
    longitude: -63.04889,
    icao: "TFFG"
  },
  SFH: {
    iata: "SFH",
    name: "San Felipe International Airport",
    city: "San Felipe",
    countryId: "MX",
    timeZoneRegionName: "America/Tijuana",
    latitude: 30.931762,
    longitude: -114.808764,
    icao: "MMSF"
  },
  SFI: {
    iata: "SFI",
    name: "Safi Airport",
    city: "Safi",
    countryId: "MA",
    timeZoneRegionName: "Africa/Casablanca",
    latitude: 32.3,
    longitude: -9.333333,
    icao: "GMMS"
  },
  SFJ: {
    iata: "SFJ",
    name: "Kangerlussuaq Airport",
    city: "Kangerlussuaq",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 67.012222,
    longitude: -50.719722,
    icao: "BGSF"
  },
  SFK: {
    iata: "SFK",
    name: "Soure Airport",
    city: "Soure",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -0.7,
    longitude: -48.522222,
    icao: "SNSW"
  },
  SFL: {
    iata: "SFL",
    name: "Sao Filipe Airport",
    city: "Sao Filipe",
    countryId: "CV",
    timeZoneRegionName: "Atlantic/Cape_Verde",
    latitude: 14.9,
    longitude: -24.516667,
    icao: "GVSF"
  },
  SFM: {
    iata: "SFM",
    name: "Seacoast Regional Airport",
    city: "Sanford",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 43.393902,
    longitude: -70.708,
    icao: "KSFM"
  },
  SFN: {
    iata: "SFN",
    name: "Santa Fe Airport",
    city: "Santa Fe",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -31.716667,
    longitude: -60.816667,
    icao: "SAAV"
  },
  SFO: {
    iata: "SFO",
    name: "San Francisco International Airport",
    city: "San Francisco",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 37.615215,
    longitude: -122.389881,
    icao: "KSFO"
  },
  SFS: {
    iata: "SFS",
    name: "Subic Bay International Airport",
    city: "Subic Bay",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 14.785556,
    longitude: 120.267222,
    icao: "RPLB"
  },
  SFT: {
    iata: "SFT",
    name: "Skelleftea Airport",
    city: "Skelleftea",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 64.622513,
    longitude: 21.068549,
    icao: "ESNS"
  },
  SFZ: {
    iata: "SFZ",
    name: "North Central State Airport",
    city: "Pawtucket",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.920799,
    longitude: -71.491402,
    icao: "KSFZ"
  },
  SGA: {
    iata: "SGA",
    name: "Sheghnan Airport",
    city: "Sheghnan",
    countryId: "AF",
    timeZoneRegionName: "Asia/Kabul",
    latitude: 38.033333,
    longitude: 71.716667,
    icao: "OASN"
  },
  SGC: {
    iata: "SGC",
    name: "Surgut Airport",
    city: "Surgut",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yekaterinburg",
    latitude: 61.339916,
    longitude: 73.409534,
    icao: "USRR"
  },
  SGD: {
    iata: "SGD",
    name: "Sonderborg Airport",
    city: "Sonderborg",
    countryId: "DK",
    timeZoneRegionName: "Europe/Copenhagen",
    latitude: 54.964444,
    longitude: 9.791731,
    icao: "EKSB"
  },
  SGE: {
    iata: "SGE",
    name: "Siegerland Airport",
    city: "Siegen",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 50.85,
    longitude: 8,
    icao: "EDGS"
  },
  SGF: {
    iata: "SGF",
    name: "Springfield-Branson National Airport",
    city: "Springfield",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 37.238707,
    longitude: -93.396929,
    icao: "KSGF"
  },
  SGH: {
    iata: "SGH",
    name: "Springfield Airport",
    city: "Springfield",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.916667,
    longitude: -83.8,
    icao: "KSGH"
  },
  SGL: {
    iata: "SGL",
    name: "Danilo Atienza Air Base",
    city: "Manila",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 14.496097,
    longitude: 120.905584,
    icao: "RPLS"
  },
  SGN: {
    iata: "SGN",
    name: "Tan Son Nhat International Airport",
    city: "Ho Chi Minh City",
    countryId: "VN",
    timeZoneRegionName: "Asia/Ho_Chi_Minh",
    latitude: 10.813045,
    longitude: 106.662477,
    icao: "VVTS"
  },
  SGO: {
    iata: "SGO",
    name: "St. George Airport",
    city: "Saint George",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -28.053333,
    longitude: 148.593889,
    icao: "YSGE"
  },
  SGR: {
    iata: "SGR",
    name: "Sugar Land Municipal Airport",
    city: "Houston",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 29.611597,
    longitude: -95.647824,
    icao: "KSGR"
  },
  SGT: {
    iata: "SGT",
    name: "Stuttgart Airport",
    city: "Stuttgart",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 34.599499,
    longitude: -91.574997,
    icao: "KSGT"
  },
  SGU: {
    iata: "SGU",
    name: "Saint George Municipal Airport",
    city: "Saint George",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 37.032628,
    longitude: -113.510167,
    icao: "KSGU"
  },
  SGV: {
    iata: "SGV",
    name: "Sierra Grande Airport",
    city: "Sierra Grande",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -41.566667,
    longitude: -65.35,
    icao: "SAVS"
  },
  SGX: {
    iata: "SGX",
    name: "Songea Airport",
    city: "Songea",
    countryId: "TZ",
    timeZoneRegionName: "Africa/Dar_es_Salaam",
    latitude: -10.682404,
    longitude: 35.582609,
    icao: "HTSO"
  },
  SGY: {
    iata: "SGY",
    name: "Skagway Airport",
    city: "Skagway",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 59.460556,
    longitude: -135.315556,
    icao: "PAGY"
  },
  SGZ: {
    iata: "SGZ",
    name: "Songkhla Airport",
    city: "Songkhla",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 7.183889,
    longitude: 100.616667,
    icao: "VTSH"
  },
  SHA: {
    iata: "SHA",
    name: "Shanghai Hongqiao International Airport",
    city: "Shanghai",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 31.19779,
    longitude: 121.333473,
    icao: "ZSSS"
  },
  SHB: {
    iata: "SHB",
    name: "Nakashibetsu Airport",
    city: "Nakashibetsu",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 43.572196,
    longitude: 144.956129,
    icao: "RJCN"
  },
  SHC: {
    iata: "SHC",
    name: "Shire Airport",
    city: "Shire",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 14.083742,
    longitude: 38.268239,
    icao: "HASR"
  },
  SHD: {
    iata: "SHD",
    name: "Shenandoah Valley Airport",
    city: "Staunton",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 38.263889,
    longitude: -78.896667,
    icao: "KSHD"
  },
  SHE: {
    iata: "SHE",
    name: "Shenyang Taoxian International Airport",
    city: "Shenyang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 41.634992,
    longitude: 123.485731,
    icao: "ZYTX"
  },
  SHF: {
    iata: "SHF",
    name: "Shihezi Huayuan Airport",
    city: "Shihezi",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 44.244171,
    longitude: 85.894731,
    icao: ""
  },
  SHG: {
    iata: "SHG",
    name: "Shungnak Airport",
    city: "Shungnak",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 66.889722,
    longitude: -157.157778,
    icao: "PAGH"
  },
  SHH: {
    iata: "SHH",
    name: "Shishmaref Airport",
    city: "Shishmaref",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 66.256944,
    longitude: -166.058333,
    icao: "PASH"
  },
  SHI: {
    iata: "SHI",
    name: "Shimojishima Airport",
    city: "Shimojishima",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 24.816667,
    longitude: 125.15,
    icao: "RORS"
  },
  SHJ: {
    iata: "SHJ",
    name: "Sharjah International Airport",
    city: "Sharjah",
    countryId: "AE",
    timeZoneRegionName: "Asia/Dubai",
    latitude: 25.320873,
    longitude: 55.52029,
    icao: "OMSJ"
  },
  SHK: {
    iata: "SHK",
    name: "Sehonghong Airport",
    city: "Sehonghong",
    countryId: "LS",
    timeZoneRegionName: "Africa/Maseru",
    latitude: -29.475,
    longitude: 27.833333,
    icao: "FXSH"
  },
  SHL: {
    iata: "SHL",
    name: "Shillong Airport",
    city: "Umroi",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 25.704872,
    longitude: 91.975983,
    icao: "VEBI"
  },
  SHM: {
    iata: "SHM",
    name: "Shirahama Airport",
    city: "Shirahama",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 33.661389,
    longitude: 135.358056,
    icao: "RJBD"
  },
  SHN: {
    iata: "SHN",
    name: "Sanderson Field",
    city: "Shelton",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 47.233889,
    longitude: -123.138889,
    icao: "KSHN"
  },
  SHO: {
    iata: "SHO",
    name: "King Mswati III International Airport",
    city: "Siteki",
    countryId: "SZ",
    timeZoneRegionName: "Africa/Mbabane",
    latitude: -26.356667,
    longitude: 31.716944,
    icao: "FDSK"
  },
  SHR: {
    iata: "SHR",
    name: "Sheridan Airport",
    city: "Sheridan",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 44.774167,
    longitude: -106.977222,
    icao: "KSHR"
  },
  SHS: {
    iata: "SHS",
    name: "Shashi Airport",
    city: "Shashi",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 30.321995,
    longitude: 112.2781,
    icao: "ZHSS"
  },
  SHT: {
    iata: "SHT",
    name: "Shepparton Airport",
    city: "Shepparton",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -36.383333,
    longitude: 145.433333,
    icao: "YSHT"
  },
  SHV: {
    iata: "SHV",
    name: "Shreveport Regional Airport",
    city: "Shreveport",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.454707,
    longitude: -93.828383,
    icao: "KSHV"
  },
  SHW: {
    iata: "SHW",
    name: "Sharurah Airport",
    city: "Sharurah",
    countryId: "SA",
    timeZoneRegionName: "Asia/Riyadh",
    latitude: 17.469459,
    longitude: 47.111983,
    icao: "OESH"
  },
  SHX: {
    iata: "SHX",
    name: "Shageluk Airport",
    city: "Shageluk",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 62.692306,
    longitude: -159.569222,
    icao: "PAHX"
  },
  SHY: {
    iata: "SHY",
    name: "Shinyanga Airport",
    city: "Shinyanga",
    countryId: "TZ",
    timeZoneRegionName: "Africa/Dar_es_Salaam",
    latitude: -3.608185,
    longitude: 33.504487,
    icao: "HTSY"
  },
  SIA: {
    iata: "SIA",
    name: "Xiguan Airport",
    city: "Xian",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 34.375941,
    longitude: 109.119659,
    icao: "ZLXG"
  },
  SIB: {
    iata: "SIB",
    name: "Sibiti Airport",
    city: "Sibiti",
    countryId: "CG",
    timeZoneRegionName: "Africa/Brazzaville",
    latitude: -3.733333,
    longitude: 13.4,
    icao: "FCBS"
  },
  SID: {
    iata: "SID",
    name: "Amilcar Cabral International Airport",
    city: "Sal",
    countryId: "CV",
    timeZoneRegionName: "Atlantic/Cape_Verde",
    latitude: 16.734696,
    longitude: -22.943613,
    icao: "GVAC"
  },
  SIE: {
    iata: "SIE",
    name: "Sines Airport",
    city: "Sines",
    countryId: "PT",
    timeZoneRegionName: "Europe/Lisbon",
    latitude: 37.944201,
    longitude: -8.809576,
    icao: "LPSI"
  },
  SIF: {
    iata: "SIF",
    name: "Simara Airport",
    city: "Simara",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 27.163563,
    longitude: 84.979195,
    icao: "VNSI"
  },
  SIG: {
    iata: "SIG",
    name: "Fernando Luis Ribas Dominicci Airport",
    city: "San Juan",
    countryId: "PR",
    timeZoneRegionName: "America/Puerto_Rico",
    latitude: 18.456006,
    longitude: -66.099306,
    icao: "TJIG"
  },
  SII: {
    iata: "SII",
    name: "Sidi Ifni Airport",
    city: "Sidi Ifni",
    countryId: "MA",
    timeZoneRegionName: "Africa/Casablanca",
    latitude: 29.4,
    longitude: -10.2,
    icao: "GMMF"
  },
  SIJ: {
    iata: "SIJ",
    name: "Siglufjordur Airport",
    city: "Siglufjordur",
    countryId: "IS",
    timeZoneRegionName: "Atlantic/Reykjavik",
    latitude: 66.166667,
    longitude: -18.933333,
    icao: "BISI"
  },
  SIK: {
    iata: "SIK",
    name: "Sikeston Memorial Airport",
    city: "Sikeston",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.866667,
    longitude: -89.55,
    icao: "KSIK"
  },
  SIN: {
    iata: "SIN",
    name: "Changi International Airport",
    city: "Singapore",
    countryId: "SG",
    timeZoneRegionName: "Asia/Singapore",
    latitude: 1.361173,
    longitude: 103.990201,
    icao: "WSSS"
  },
  SIO: {
    iata: "SIO",
    name: "Smithton Airport",
    city: "Smithton",
    countryId: "AU",
    timeZoneRegionName: "Australia/Hobart",
    latitude: -40.835833,
    longitude: 145.081667,
    icao: "YSMI"
  },
  SIP: {
    iata: "SIP",
    name: "Simferopol International Airport",
    city: "Simferopol",
    countryId: "UA",
    timeZoneRegionName: "Europe/Simferopol",
    latitude: 45.020658,
    longitude: 33.998193,
    icao: "UKFF"
  },
  SIQ: {
    iata: "SIQ",
    name: "Dabo Airport",
    city: "Singkep",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: -0.5,
    longitude: 104.416667,
    icao: "WIKS"
  },
  SIR: {
    iata: "SIR",
    name: "Sion Airport",
    city: "Sion",
    countryId: "CH",
    timeZoneRegionName: "Europe/Zurich",
    latitude: 46.21725,
    longitude: 7.322294,
    icao: "LSGS"
  },
  SIS: {
    iata: "SIS",
    name: "Sishen Airport",
    city: "Sishen",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -27.649178,
    longitude: 22.999137,
    icao: "FASS"
  },
  SIT: {
    iata: "SIT",
    name: "Sitka Airport",
    city: "Sitka",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 57.0471,
    longitude: -135.362,
    icao: "PASI"
  },
  SIV: {
    iata: "SIV",
    name: "Sullivan County Airport",
    city: "Sullivan",
    countryId: "US",
    timeZoneRegionName: "America/Indiana/Indianapolis",
    latitude: 39.1,
    longitude: -87.4,
    icao: "KSIV"
  },
  SIY: {
    iata: "SIY",
    name: "Siskiyou County Airport",
    city: "Montague",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 41.733333,
    longitude: -122.533333,
    icao: "KSIY"
  },
  SJA: {
    iata: "SJA",
    name: "San Juan Airport",
    city: "San Juan",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -15.35,
    longitude: -75.15,
    icao: "SPJN"
  },
  SJB: {
    iata: "SJB",
    name: "San Joaquin Airport",
    city: "San Joaquin",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -13.083333,
    longitude: -64.8,
    icao: "SLJO"
  },
  SJC: {
    iata: "SJC",
    name: "Norman Y. Mineta San Jose International Airport",
    city: "San Jose",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 37.366736,
    longitude: -121.926375,
    icao: "KSJC"
  },
  SJD: {
    iata: "SJD",
    name: "Los Cabos International Airport",
    city: "San Jose Cabo",
    countryId: "MX",
    timeZoneRegionName: "America/Mazatlan",
    latitude: 23.162354,
    longitude: -109.717283,
    icao: "MMSD"
  },
  SJE: {
    iata: "SJE",
    name: "San Jose Del Gua Airport",
    city: "San Jose Del Gua",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 2.583333,
    longitude: -72.666667,
    icao: "SKSJ"
  },
  SJI: {
    iata: "SJI",
    name: "San Jose Airport",
    city: "San Jose",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 12.360818,
    longitude: 121.045574,
    icao: "RPUH"
  },
  SJJ: {
    iata: "SJJ",
    name: "Sarajevo International Airport",
    city: "Sarajevo",
    countryId: "BA",
    timeZoneRegionName: "Europe/Sarajevo",
    latitude: 43.824601,
    longitude: 18.331541,
    icao: "LQSA"
  },
  SJK: {
    iata: "SJK",
    name: "Professor Urbano Ernesto Stumpf Airport",
    city: "Sao Jose dos Campos",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -23.22806,
    longitude: -45.86278,
    icao: "SBSJ"
  },
  SJL: {
    iata: "SJL",
    name: "Sao Gabriel Cachoeira Airport",
    city: "Sao Gabriel Cachoeira",
    countryId: "BR",
    timeZoneRegionName: "America/Porto_Velho",
    latitude: -0.148333,
    longitude: -66.98556,
    icao: "SBUA"
  },
  SJN: {
    iata: "SJN",
    name: "Saint Johns Municipal Airport",
    city: "Saint Johns",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 34.5,
    longitude: -109.35,
    icao: "KSJN"
  },
  SJO: {
    iata: "SJO",
    name: "Juan Santamaria International Airport",
    city: "San Jose",
    countryId: "CR",
    timeZoneRegionName: "America/Costa_Rica",
    latitude: 9.998238,
    longitude: -84.20408,
    icao: "MROC"
  },
  SJP: {
    iata: "SJP",
    name: "Sao Jose do Rio Preto Airport",
    city: "Sao Jose Do Rio Preto",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -20.814853,
    longitude: -49.406244,
    icao: "SBSR"
  },
  SJS: {
    iata: "SJS",
    name: "San Jose de Chiquitos Airport",
    city: "San Jose",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -17.830813,
    longitude: -60.748557,
    icao: "SLJE"
  },
  SJT: {
    iata: "SJT",
    name: "San Angelo Regional Airport",
    city: "San Angelo",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 31.359722,
    longitude: -100.494444,
    icao: "KSJT"
  },
  SJU: {
    iata: "SJU",
    name: "Luis Munoz Marin International Airport",
    city: "San Juan",
    countryId: "PR",
    timeZoneRegionName: "America/Puerto_Rico",
    latitude: 18.437403,
    longitude: -66.004683,
    icao: "TJSJ"
  },
  SJV: {
    iata: "SJV",
    name: "San Javier Airport",
    city: "San Javier",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -16.233333,
    longitude: -62.416667,
    icao: "SLJV"
  },
  SJW: {
    iata: "SJW",
    name: "Shijiazhuang Zhengding International Airport",
    city: "Shijiazhuang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 38.281868,
    longitude: 114.692106,
    icao: "ZBSJ"
  },
  SJY: {
    iata: "SJY",
    name: "Ilmajoki Airport",
    city: "Seinajoki",
    countryId: "FI",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 62.692567,
    longitude: 22.826712,
    icao: "EFIL"
  },
  SJZ: {
    iata: "SJZ",
    name: "Sao Jorge Island Airport",
    city: "Sao Jorge Island",
    countryId: "PT",
    timeZoneRegionName: "Atlantic/Azores",
    latitude: 38.664616,
    longitude: -28.16843,
    icao: "LPSJ"
  },
  SKA: {
    iata: "SKA",
    name: "Fairchild Air Force Base",
    city: "Spokane",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 47.615154,
    longitude: -117.655561,
    icao: "KSKA"
  },
  SKB: {
    iata: "SKB",
    name: "Robert L. Bradshaw International Airport",
    city: "Saint Kitts",
    countryId: "KN",
    timeZoneRegionName: "America/St_Kitts",
    latitude: 17.310843,
    longitude: -62.71397,
    icao: "TKPK"
  },
  SKD: {
    iata: "SKD",
    name: "Samarkand Airport",
    city: "Samarkand",
    countryId: "UZ",
    timeZoneRegionName: "Asia/Tashkent",
    latitude: 39.696217,
    longitude: 66.990854,
    icao: "UTSS"
  },
  SKE: {
    iata: "SKE",
    name: "Skien Airport",
    city: "Skien",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 59.182778,
    longitude: 9.5625,
    icao: "ENSN"
  },
  SKF: {
    iata: "SKF",
    name: "Kelly Field Annex",
    city: "San Antonio",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 29.372971,
    longitude: -98.570968,
    icao: "KSKF"
  },
  SKG: {
    iata: "SKG",
    name: "Thessaloniki International Airport",
    city: "Thessaloniki",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 40.520833,
    longitude: 22.972222,
    icao: "LGTS"
  },
  SKH: {
    iata: "SKH",
    name: "Surkhet Airport",
    city: "Surkhet",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 28.586104,
    longitude: 81.635933,
    icao: "VNSK"
  },
  SKJ: {
    iata: "SKJ",
    name: "Singkawang Airport",
    city: "Singkawang",
    countryId: "ID",
    timeZoneRegionName: "Asia/Pontianak",
    latitude: 0.791667,
    longitude: 108.959722,
    icao: "WIOJ"
  },
  SKK: {
    iata: "SKK",
    name: "Shaktoolik Airport",
    city: "Shaktoolik",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 64.324167,
    longitude: -161.138889,
    icao: ""
  },
  SKN: {
    iata: "SKN",
    name: "Stokmarknes Skagen Airport",
    city: "Stokmarknes",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 68.579147,
    longitude: 15.032921,
    icao: "ENSK"
  },
  SKO: {
    iata: "SKO",
    name: "Sokoto Airport",
    city: "Sokoto",
    countryId: "NG",
    timeZoneRegionName: "Africa/Lagos",
    latitude: 13.006389,
    longitude: 5.242222,
    icao: "DNSO"
  },
  SKP: {
    iata: "SKP",
    name: "Skopje International Airport",
    city: "Skopje",
    countryId: "MK",
    timeZoneRegionName: "Europe/Skopje",
    latitude: 41.960559,
    longitude: 21.625757,
    icao: "LWSK"
  },
  SKR: {
    iata: "SKR",
    name: "Shakiso Airport",
    city: "Shakiso",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 5.883333,
    longitude: 38.966667,
    icao: "HASK"
  },
  SKS: {
    iata: "SKS",
    name: "Vojens Airport",
    city: "Vojens",
    countryId: "DK",
    timeZoneRegionName: "Europe/Copenhagen",
    latitude: 55.221944,
    longitude: 9.264722,
    icao: "EKSP"
  },
  SKT: {
    iata: "SKT",
    name: "Sialkot International Airport",
    city: "Sialkot",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 32.535556,
    longitude: 74.363889,
    icao: "OPST"
  },
  SKU: {
    iata: "SKU",
    name: "Skiros Airport",
    city: "Skiros",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 38.916667,
    longitude: 24.566667,
    icao: "LGSY"
  },
  SKV: {
    iata: "SKV",
    name: "St Catherine International Airport",
    city: "St Catherine",
    countryId: "EG",
    timeZoneRegionName: "Africa/Cairo",
    latitude: 28.685278,
    longitude: 34.0625,
    icao: "HESC"
  },
  SKW: {
    iata: "SKW",
    name: "Skwentna Intermediate Airport",
    city: "Skwentna",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 61.965833,
    longitude: -151.188611,
    icao: "PASW"
  },
  SKX: {
    iata: "SKX",
    name: "Saransk Airport",
    city: "Saransk",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 54.127631,
    longitude: 45.216099,
    icao: "UWPS"
  },
  SKY: {
    iata: "SKY",
    name: "Griffin Sandusky Airport",
    city: "Sandusky",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.434295,
    longitude: -83.652619,
    icao: "KSKY"
  },
  SKZ: {
    iata: "SKZ",
    name: "Sukkur Airport",
    city: "Sukkur",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 27.72336,
    longitude: 68.795803,
    icao: "OPSK"
  },
  SLA: {
    iata: "SLA",
    name: "Martin Miguel de Guemes International Airport",
    city: "Salta",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -24.844217,
    longitude: -65.478493,
    icao: "SASA"
  },
  SLB: {
    iata: "SLB",
    name: "Storm Lake Municipal Airport",
    city: "Storm Lake",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 42.633333,
    longitude: -95.2,
    icao: "KSLB"
  },
  SLC: {
    iata: "SLC",
    name: "Salt Lake City International Airport",
    city: "Salt Lake City",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 40.785645,
    longitude: -111.980673,
    icao: "KSLC"
  },
  SLD: {
    iata: "SLD",
    name: "Sliac Airport",
    city: "Sliac",
    countryId: "SK",
    timeZoneRegionName: "Europe/Bratislava",
    latitude: 48.637963,
    longitude: 19.13442,
    icao: "LZSL"
  },
  SLE: {
    iata: "SLE",
    name: "McNary Field",
    city: "Salem",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 44.909534,
    longitude: -123.002496,
    icao: "KSLE"
  },
  SLG: {
    iata: "SLG",
    name: "Smith Field",
    city: "Siloam Springs",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.183333,
    longitude: -94.533333,
    icao: "KSLG"
  },
  SLH: {
    iata: "SLH",
    name: "Vanua Lava Airport",
    city: "Sola",
    countryId: "VU",
    timeZoneRegionName: "Pacific/Efate",
    latitude: -13.8517,
    longitude: 167.537003,
    icao: "NVSC"
  },
  SLI: {
    iata: "SLI",
    name: "Solwezi Airport",
    city: "Solwezi",
    countryId: "ZM",
    timeZoneRegionName: "Africa/Lusaka",
    latitude: -12.172222,
    longitude: 26.366667,
    icao: "FLSW"
  },
  SLJ: {
    iata: "SLJ",
    name: "Solomon Airport",
    city: "Solomon",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -22.255278,
    longitude: 117.761944,
    icao: "YSOL"
  },
  SLK: {
    iata: "SLK",
    name: "Adirondack Airport",
    city: "Saranac Lake",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 44.382778,
    longitude: -74.206667,
    icao: "KSLK"
  },
  SLL: {
    iata: "SLL",
    name: "Salalah International Airport",
    city: "Salalah",
    countryId: "OM",
    timeZoneRegionName: "Asia/Muscat",
    latitude: 17.045195,
    longitude: 54.089113,
    icao: "OOSA"
  },
  SLM: {
    iata: "SLM",
    name: "Salamanca Airport",
    city: "Salamanca",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 40.951944,
    longitude: -5.501944,
    icao: "LESA"
  },
  SLN: {
    iata: "SLN",
    name: "Salina Regional Airport",
    city: "Salina",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 38.790833,
    longitude: -97.6525,
    icao: "KSLN"
  },
  SLO: {
    iata: "SLO",
    name: "Leckrone Airport",
    city: "Salem",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 38.633333,
    longitude: -88.95,
    icao: "KSLO"
  },
  SLP: {
    iata: "SLP",
    name: "Ponciano Arriaga International Airport",
    city: "San Luis Potosi",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 22.254299,
    longitude: -100.931,
    icao: "MMSP"
  },
  SLQ: {
    iata: "SLQ",
    name: "Sleetmute Airport",
    city: "Sleetmute",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 61.705,
    longitude: -157.166667,
    icao: "PASL"
  },
  SLR: {
    iata: "SLR",
    name: "Sulphur Springs Airport",
    city: "Sulphur Springs",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 33.159655,
    longitude: -95.618679,
    icao: "KSLR"
  },
  SLU: {
    iata: "SLU",
    name: "George F. L. Charles Airport",
    city: "Saint Lucia",
    countryId: "LC",
    timeZoneRegionName: "America/St_Lucia",
    latitude: 14.020023,
    longitude: -60.99583,
    icao: "TLPC"
  },
  SLV: {
    iata: "SLV",
    name: "Shimla Airport",
    city: "Shimla",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 31.0818,
    longitude: 77.068001,
    icao: "VISM"
  },
  SLW: {
    iata: "SLW",
    name: "Plan de Guadalupe International Airport",
    city: "Saltillo",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 25.543326,
    longitude: -100.928347,
    icao: "MMIO"
  },
  SLX: {
    iata: "SLX",
    name: "Salt Cay Airport",
    city: "Salt Cay",
    countryId: "TC",
    timeZoneRegionName: "America/Grand_Turk",
    latitude: 21.333333,
    longitude: -71.201667,
    icao: "MBSY"
  },
  SLY: {
    iata: "SLY",
    name: "Salekhard Airport",
    city: "Salekhard",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yekaterinburg",
    latitude: 66.590358,
    longitude: 66.591548,
    icao: "USDD"
  },
  SLZ: {
    iata: "SLZ",
    name: "Marechal Cunha Machado International Airport",
    city: "Sao Luiz",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -2.583316,
    longitude: -44.236684,
    icao: "SBSL"
  },
  SMA: {
    iata: "SMA",
    name: "Vila Do Porto Airport",
    city: "Santa Maria (Azores)",
    countryId: "PT",
    timeZoneRegionName: "Atlantic/Azores",
    latitude: 36.966667,
    longitude: -25.1,
    icao: "LPAZ"
  },
  SMB: {
    iata: "SMB",
    name: "Franco Bianco Airport",
    city: "Cerro Sombrero",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -52.736698,
    longitude: -69.333603,
    icao: "SCSB"
  },
  SMD: {
    iata: "SMD",
    name: "Smith Field",
    city: "Fort Wayne",
    countryId: "US",
    timeZoneRegionName: "America/Indiana/Indianapolis",
    latitude: 41.143344,
    longitude: -85.152789,
    icao: "KSMD"
  },
  SME: {
    iata: "SME",
    name: "Lake Cumberland Regional Airport",
    city: "Somerset",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 37.053398,
    longitude: -84.615898,
    icao: "KSME"
  },
  SMF: {
    iata: "SMF",
    name: "Sacramento International Airport",
    city: "Sacramento",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 38.692283,
    longitude: -121.593695,
    icao: "KSMF"
  },
  SMG: {
    iata: "SMG",
    name: "Santa Maria Airport",
    city: "Santa Maria",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -12.391389,
    longitude: -76.755833,
    icao: "SPMR"
  },
  SMI: {
    iata: "SMI",
    name: "Samos Airport",
    city: "Samos",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 37.691448,
    longitude: 26.914418,
    icao: "LGSM"
  },
  SMK: {
    iata: "SMK",
    name: "St Michael Airport",
    city: "Saint Michael",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 63.484295,
    longitude: -162.111813,
    icao: "PAMK"
  },
  SML: {
    iata: "SML",
    name: "Stella Maris Airport",
    city: "Stella Maris",
    countryId: "BS",
    timeZoneRegionName: "America/Nassau",
    latitude: 23.583333,
    longitude: -75.268056,
    icao: "MYLS"
  },
  SMN: {
    iata: "SMN",
    name: "Lemhi County Airport",
    city: "Salmon",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 45.115059,
    longitude: -113.885913,
    icao: "KSMN"
  },
  SMO: {
    iata: "SMO",
    name: "Santa Monica Municipal Airport",
    city: "Santa Monica",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 34.017736,
    longitude: -118.449646,
    icao: "KSMO"
  },
  SMQ: {
    iata: "SMQ",
    name: "H. Asan Airport",
    city: "Sampit",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: -2.502806,
    longitude: 112.979002,
    icao: "WAOS"
  },
  SMR: {
    iata: "SMR",
    name: "Simon Bolivar International Airport",
    city: "Santa Marta",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 11.117132,
    longitude: -74.232704,
    icao: "SKSM"
  },
  SMS: {
    iata: "SMS",
    name: "Sainte Marie Airport",
    city: "Sainte Marie",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -17.083333,
    longitude: 49.816667,
    icao: "FMMS"
  },
  SMT: {
    iata: "SMT",
    name: "Sorriso Airport",
    city: "Sorriso",
    countryId: "BR",
    timeZoneRegionName: "America/Campo_Grande",
    latitude: -12.479939,
    longitude: -55.674872,
    icao: "SBSO"
  },
  SMU: {
    iata: "SMU",
    name: "Sheep Mountain Airport",
    city: "Sheep Mountain",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 61.8,
    longitude: -147.666667,
    icao: "PASP"
  },
  SMV: {
    iata: "SMV",
    name: "Samedan Airport",
    city: "Saint Moritz",
    countryId: "CH",
    timeZoneRegionName: "Europe/Zurich",
    latitude: 46.534722,
    longitude: 9.885556,
    icao: "LSZS"
  },
  SMW: {
    iata: "SMW",
    name: "Smara Airport",
    city: "Smara",
    countryId: "EH",
    timeZoneRegionName: "Africa/El_Aaiun",
    latitude: 26.733333,
    longitude: -11.683333,
    icao: ""
  },
  SMX: {
    iata: "SMX",
    name: "Santa Maria Public Airport",
    city: "Santa Maria",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 34.905,
    longitude: -120.457778,
    icao: "KSMX"
  },
  SMY: {
    iata: "SMY",
    name: "Simenti Airport",
    city: "Simenti",
    countryId: "SN",
    timeZoneRegionName: "Africa/Dakar",
    latitude: 13.166667,
    longitude: -13.166667,
    icao: "GOTS"
  },
  SNA: {
    iata: "SNA",
    name: "John Wayne Airport",
    city: "Santa Ana",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 33.680201,
    longitude: -117.860538,
    icao: "KSNA"
  },
  SNB: {
    iata: "SNB",
    name: "Snake Bay Airport",
    city: "Snake Bay",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -11.416667,
    longitude: 130.666667,
    icao: "YSNB"
  },
  SNC: {
    iata: "SNC",
    name: "General Ulpiano Paez Airport",
    city: "Salinas",
    countryId: "EC",
    timeZoneRegionName: "America/Guayaquil",
    latitude: -2.203127,
    longitude: -80.991491,
    icao: "SESA"
  },
  SNE: {
    iata: "SNE",
    name: "Preguica Airport",
    city: "Sao Nicolau",
    countryId: "CV",
    timeZoneRegionName: "Atlantic/Cape_Verde",
    latitude: 16.586944,
    longitude: -24.288611,
    icao: "GVSN"
  },
  SNF: {
    iata: "SNF",
    name: "San Felipe Airport",
    city: "San Felipe",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 10.280278,
    longitude: -68.753889,
    icao: "SVSP"
  },
  SNG: {
    iata: "SNG",
    name: "Cap. Juan Cochamanidis Airport",
    city: "San Ignacio De Velasco",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -16.3836,
    longitude: -60.962799,
    icao: "SLSI"
  },
  SNH: {
    iata: "SNH",
    name: "Stanthorpe Airport",
    city: "Stanthorpe",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -28.65,
    longitude: 151.95,
    icao: "YSPE"
  },
  SNI: {
    iata: "SNI",
    name: "R. E. Murray Airport",
    city: "Sinoe",
    countryId: "LR",
    timeZoneRegionName: "Africa/Monrovia",
    latitude: 5.033056,
    longitude: -9.063611,
    icao: "GLGE"
  },
  SNJ: {
    iata: "SNJ",
    name: "San Julian Air Base",
    city: "San Julian",
    countryId: "CU",
    timeZoneRegionName: "America/Havana",
    latitude: 22.095531,
    longitude: -84.152249,
    icao: "MUSJ"
  },
  SNK: {
    iata: "SNK",
    name: "Winston Field",
    city: "Snyder",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.716667,
    longitude: -100.9,
    icao: "KSNK"
  },
  SNL: {
    iata: "SNL",
    name: "Shawnee Municipal Airport",
    city: "Shawnee",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.333333,
    longitude: -96.916667,
    icao: "KSNL"
  },
  SNM: {
    iata: "SNM",
    name: "San Ignacio De Moxos Airport",
    city: "San Ignacio De Moxos",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -14.966389,
    longitude: -65.635556,
    icao: "SLSM"
  },
  SNN: {
    iata: "SNN",
    name: "Shannon Airport",
    city: "Shannon",
    countryId: "IE",
    timeZoneRegionName: "Europe/Dublin",
    latitude: 52.69248,
    longitude: -8.92039,
    icao: "EINN"
  },
  SNO: {
    iata: "SNO",
    name: "Sakon Nakhon Airport",
    city: "Sakon Nakhon",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 17.195101,
    longitude: 104.119003,
    icao: "VTUI"
  },
  SNP: {
    iata: "SNP",
    name: "Saint Paul Island Airport",
    city: "Saint Paul Island",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 57.152222,
    longitude: -170.217222,
    icao: "PASN"
  },
  SNR: {
    iata: "SNR",
    name: "Montoir Airport",
    city: "Saint Nazaire",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 47.312047,
    longitude: -2.153864,
    icao: "LFRZ"
  },
  SNS: {
    iata: "SNS",
    name: "Salinas Municipal Airport",
    city: "Salinas",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 36.664911,
    longitude: -121.610426,
    icao: "KSNS"
  },
  SNU: {
    iata: "SNU",
    name: "Santa Clara Airport",
    city: "Santa Clara",
    countryId: "CU",
    timeZoneRegionName: "America/Havana",
    latitude: 22.491944,
    longitude: -79.941944,
    icao: "MUSC"
  },
  SNV: {
    iata: "SNV",
    name: "Santa Elena Airport",
    city: "Santa Elena",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 4.55,
    longitude: -61.116667,
    icao: "SVSE"
  },
  SNW: {
    iata: "SNW",
    name: "Thandwe Airport",
    city: "Thandwe",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 18.453876,
    longitude: 94.30038,
    icao: "VYTD"
  },
  SNX: {
    iata: "SNX",
    name: "Semnan Airport",
    city: "Semnan",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 35.590833,
    longitude: 53.494444,
    icao: "OIIS"
  },
  SNY: {
    iata: "SNY",
    name: "Sidney Municipal Airport",
    city: "Sidney",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 41.099444,
    longitude: -102.9825,
    icao: "KSNY"
  },
  SOB: {
    iata: "SOB",
    name: "Sarmellek/Balaton Airport",
    city: "Sarmellek",
    countryId: "HU",
    timeZoneRegionName: "Europe/Budapest",
    latitude: 46.713472,
    longitude: 17.240444,
    icao: "LHSM"
  },
  SOC: {
    iata: "SOC",
    name: "Adi Sumarmo International Airport",
    city: "Surakarta",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: -7.514458,
    longitude: 110.749956,
    icao: "WARQ"
  },
  SOD: {
    iata: "SOD",
    name: "Sorocaba Airport",
    city: "Sorocaba",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -23.476313,
    longitude: -47.476095,
    icao: "SDCO"
  },
  SOE: {
    iata: "SOE",
    name: "Souanke Airport",
    city: "Souanke",
    countryId: "CG",
    timeZoneRegionName: "Africa/Brazzaville",
    latitude: 2,
    longitude: 14.166667,
    icao: "FCOS"
  },
  SOF: {
    iata: "SOF",
    name: "Sofia Airport",
    city: "Sofia",
    countryId: "BG",
    timeZoneRegionName: "Europe/Sofia",
    latitude: 42.688342,
    longitude: 23.414431,
    icao: "LBSF"
  },
  SOG: {
    iata: "SOG",
    name: "Sogndal Airport",
    city: "Sogndal",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 61.158127,
    longitude: 7.136988,
    icao: "ENSG"
  },
  SOI: {
    iata: "SOI",
    name: "South Molle Island Airport",
    city: "South Molle Island",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -20.75,
    longitude: 148.583333,
    icao: "YSML"
  },
  SOJ: {
    iata: "SOJ",
    name: "Sorkjosen Airport",
    city: "Sorkjosen",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 69.783333,
    longitude: 20.933333,
    icao: "ENSR"
  },
  SOK: {
    iata: "SOK",
    name: "Semongkong Airport",
    city: "Semongkong",
    countryId: "LS",
    timeZoneRegionName: "Africa/Maseru",
    latitude: -29.833333,
    longitude: 28.5,
    icao: "FXSM"
  },
  SOM: {
    iata: "SOM",
    name: "San Tome Airport",
    city: "San Tome",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 8.946078,
    longitude: -64.14502,
    icao: "SVST"
  },
  SON: {
    iata: "SON",
    name: "Santo International Airport",
    city: "Luganville",
    countryId: "VU",
    timeZoneRegionName: "Pacific/Efate",
    latitude: -15.5058,
    longitude: 167.2214,
    icao: "NVSS"
  },
  SOO: {
    iata: "SOO",
    name: "Soderhamn Airport",
    city: "Soderhamn",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 61.261823,
    longitude: 17.098267,
    icao: "ESNY"
  },
  SOP: {
    iata: "SOP",
    name: "Moore County Airport",
    city: "Southern Pines",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 35.237611,
    longitude: -79.388796,
    icao: "KSOP"
  },
  SOQ: {
    iata: "SOQ",
    name: "Sorong Airport",
    city: "Sorong",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jayapura",
    latitude: -0.890214,
    longitude: 131.290591,
    icao: "WASS"
  },
  SOT: {
    iata: "SOT",
    name: "Sodankyla Airport",
    city: "Sodankyla",
    countryId: "FI",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 67.383333,
    longitude: 26.616667,
    icao: "EFSO"
  },
  SOU: {
    iata: "SOU",
    name: "Southampton Airport",
    city: "Southampton",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 50.950725,
    longitude: -1.361318,
    icao: "EGHI"
  },
  SOV: {
    iata: "SOV",
    name: "Seldovia Airport",
    city: "Seldovia",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 59.4425,
    longitude: -151.704167,
    icao: "PASO"
  },
  SOW: {
    iata: "SOW",
    name: "Show Low Airport",
    city: "Show Low",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 34.264444,
    longitude: -110.004167,
    icao: "KSOW"
  },
  SOX: {
    iata: "SOX",
    name: "Sogamoso Airport",
    city: "Sogamoso",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 5.716667,
    longitude: -72.933333,
    icao: "SKSO"
  },
  SOY: {
    iata: "SOY",
    name: "Stronsay Airport",
    city: "Stronsay",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 59.155282,
    longitude: -2.641532,
    icao: "EGER"
  },
  SOZ: {
    iata: "SOZ",
    name: "Solenzara Airport",
    city: "Solenzara",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 41.883333,
    longitude: 9.383333,
    icao: "LFKS"
  },
  SPA: {
    iata: "SPA",
    name: "Spartanburg Downtown Memorial Airport",
    city: "Spartanburg",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 34.95,
    longitude: -81.916667,
    icao: "KSPA"
  },
  SPC: {
    iata: "SPC",
    name: "La Palma Airport",
    city: "Santa Cruz De La Palma",
    countryId: "ES",
    timeZoneRegionName: "Atlantic/Canary",
    latitude: 28.626389,
    longitude: -17.755556,
    icao: "GCLA"
  },
  SPD: {
    iata: "SPD",
    name: "Saidpur Airport",
    city: "Saidpur",
    countryId: "BD",
    timeZoneRegionName: "Asia/Dhaka",
    latitude: 25.759272,
    longitude: 88.90897,
    icao: "VGSD"
  },
  SPF: {
    iata: "SPF",
    name: "Black Hills Airport",
    city: "Spearfish",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 44.5,
    longitude: -103.866667,
    icao: "KSPF"
  },
  SPG: {
    iata: "SPG",
    name: "St Pete-Albert Whitted Airport",
    city: "Saint Petersburg",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 27.766944,
    longitude: -82.625278,
    icao: "KSPG"
  },
  SPH: {
    iata: "SPH",
    name: "Sopu Airport",
    city: "Sopu",
    countryId: "PG",
    timeZoneRegionName: "Pacific/Port_Moresby",
    latitude: -8.3038,
    longitude: 147.1659,
    icao: "AYQO"
  },
  SPI: {
    iata: "SPI",
    name: "Capital Airport",
    city: "Springfield",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 39.844167,
    longitude: -89.678889,
    icao: "KSPI"
  },
  SPJ: {
    iata: "SPJ",
    name: "Sparta Airport",
    city: "Sparta",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 36.983333,
    longitude: 22.533333,
    icao: "LGSP"
  },
  SPM: {
    iata: "SPM",
    name: "Spangdahlem Air Base",
    city: "Spangdahlem",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 49.973876,
    longitude: 6.694407,
    icao: "ETAD"
  },
  SPN: {
    iata: "SPN",
    name: "Francisco C. Ada International Airport",
    city: "Saipan",
    countryId: "MP",
    timeZoneRegionName: "Pacific/Saipan",
    latitude: 15.119011,
    longitude: 145.729013,
    icao: "PGSN"
  },
  SPP: {
    iata: "SPP",
    name: "Menongue Airport",
    city: "Menongue",
    countryId: "AO",
    timeZoneRegionName: "Africa/Luanda",
    latitude: -14.6375,
    longitude: 17.725556,
    icao: "FNME"
  },
  SPR: {
    iata: "SPR",
    name: "John Greif II Airport",
    city: "San Pedro",
    countryId: "BZ",
    timeZoneRegionName: "America/Belize",
    latitude: 17.913889,
    longitude: -87.971111,
    icao: "MZSP"
  },
  SPS: {
    iata: "SPS",
    name: "Wichita Falls Municipal Airport/Sheppard Air Force Base",
    city: "Wichita Falls",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 33.988333,
    longitude: -98.491944,
    icao: "KSPS"
  },
  SPU: {
    iata: "SPU",
    name: "Split Airport",
    city: "Split",
    countryId: "HR",
    timeZoneRegionName: "Europe/Zagreb",
    latitude: 43.536525,
    longitude: 16.29946,
    icao: "LDSP"
  },
  SPW: {
    iata: "SPW",
    name: "Spencer Municipal Airport",
    city: "Spencer",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 43.163889,
    longitude: -95.200833,
    icao: "KSPW"
  },
  SPX: {
    iata: "SPX",
    name: "Sphinx International Airport",
    city: "Giza",
    countryId: "EG",
    timeZoneRegionName: "Asia/Phnom_Penh",
    latitude: 30.109722,
    longitude: 30.894444,
    icao: "HESX"
  },
  SPY: {
    iata: "SPY",
    name: "San Pedro Airport",
    city: "San Pedro",
    countryId: "CI",
    timeZoneRegionName: "Africa/Abidjan",
    latitude: 4.746695,
    longitude: -6.658856,
    icao: "DISP"
  },
  SPZ: {
    iata: "SPZ",
    name: "Springdale Municipal Airport",
    city: "Springdale",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.183333,
    longitude: -94.166667,
    icao: "KASG"
  },
  SQA: {
    iata: "SQA",
    name: "Santa Ynez Airport",
    city: "Santa Ynez",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 34.60694,
    longitude: -120.07556,
    icao: "KIZA"
  },
  SQC: {
    iata: "SQC",
    name: "Southern Cross Airport",
    city: "Southern Cross",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -31.25,
    longitude: 119.35,
    icao: "YSCR"
  },
  SQD: {
    iata: "SQD",
    name: "Sanqingshan Airport",
    city: "Shangrao",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 28.379722,
    longitude: 117.964167,
    icao: "ZSSR"
  },
  SQG: {
    iata: "SQG",
    name: "Susilo Airport",
    city: "Sintang",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: 0.063215,
    longitude: 111.472328,
    icao: "WIOS"
  },
  SQI: {
    iata: "SQI",
    name: "Whiteside County Airport",
    city: "Sterling",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.74,
    longitude: -89.680833,
    icao: "KSQI"
  },
  SQJ: {
    iata: "SQJ",
    name: "Sanming Shaxian Airport",
    city: "Sanming",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 26.425812,
    longitude: 117.838929,
    icao: ""
  },
  SQL: {
    iata: "SQL",
    name: "San Carlos Airport",
    city: "San Carlos",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 37.511902,
    longitude: -122.25,
    icao: "KSQL"
  },
  SQN: {
    iata: "SQN",
    name: "Emalamo Sanana Airport",
    city: "Sanana",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jayapura",
    latitude: -2.098013,
    longitude: 125.965079,
    icao: "WAPN"
  },
  SQO: {
    iata: "SQO",
    name: "Gunnarn Airport",
    city: "Storuman",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 64.962222,
    longitude: 17.8,
    icao: "ESUD"
  },
  SQQ: {
    iata: "SQQ",
    name: "Siauliai International Airport",
    city: "Siauliai",
    countryId: "LT",
    timeZoneRegionName: "Europe/Vilnius",
    latitude: 55.895292,
    longitude: 23.39311,
    icao: "EYSA"
  },
  SQW: {
    iata: "SQW",
    name: "Skive Airport",
    city: "Skive",
    countryId: "DK",
    timeZoneRegionName: "Europe/Copenhagen",
    latitude: 56.550201,
    longitude: 9.17298,
    icao: "EKSV"
  },
  SQX: {
    iata: "SQX",
    name: "Sao Miguel Do Oeste Airport",
    city: "Sao Miguel Do Oeste",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -26.780556,
    longitude: -53.502778,
    icao: "SSOE"
  },
  SQY: {
    iata: "SQY",
    name: "Sao Lourenco Do Sul Airport",
    city: "Sao Lourenco Do Sul",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -31.382778,
    longitude: -52.032222,
    icao: "SSRU"
  },
  SRA: {
    iata: "SRA",
    name: "Santa Rosa Airport",
    city: "Santa Rosa",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -27.866667,
    longitude: -54.483333,
    icao: "SSZR"
  },
  SRC: {
    iata: "SRC",
    name: "Searcy Airport",
    city: "Searcy",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.25,
    longitude: -91.733333,
    icao: "KSRC"
  },
  SRD: {
    iata: "SRD",
    name: "San Ramon Airport",
    city: "San Ramon",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -13.283333,
    longitude: -64.716667,
    icao: "SLRA"
  },
  SRE: {
    iata: "SRE",
    name: "Juana Azurduy de Padilla International Airport",
    city: "Sucre",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -19.013393,
    longitude: -65.293155,
    icao: "SLSU"
  },
  SRG: {
    iata: "SRG",
    name: "Achmad Yani International Airport",
    city: "Semarang",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: -6.979155,
    longitude: 110.378549,
    icao: "WARS"
  },
  SRH: {
    iata: "SRH",
    name: "Sarh Airport",
    city: "Sarh",
    countryId: "TD",
    timeZoneRegionName: "Africa/Ndjamena",
    latitude: 9.083333,
    longitude: 18.383333,
    icao: "FTTA"
  },
  SRI: {
    iata: "SRI",
    name: "Aji Pangeran Tumenggung Pranoto International Airport",
    city: "Samarinda",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -0.373611,
    longitude: 117.255556,
    icao: "WALS"
  },
  SRJ: {
    iata: "SRJ",
    name: "Capitan G Q Guardia Airport",
    city: "San Borja",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -14.816667,
    longitude: -66.833333,
    icao: "SLSB"
  },
  SRK: {
    iata: "SRK",
    name: "Siorapaluk Heliport",
    city: "Siorapaluk",
    countryId: "GL",
    timeZoneRegionName: "America/Thule",
    latitude: 77.786526,
    longitude: -70.638584,
    icao: "BGSI"
  },
  SRN: {
    iata: "SRN",
    name: "Strahan Airport",
    city: "Strahan",
    countryId: "AU",
    timeZoneRegionName: "Australia/Hobart",
    latitude: -42.15,
    longitude: 145.316667,
    icao: "YSRN"
  },
  SRP: {
    iata: "SRP",
    name: "Stord Airport",
    city: "Stord",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 59.833333,
    longitude: 5.416667,
    icao: "ENSO"
  },
  SRQ: {
    iata: "SRQ",
    name: "Sarasota Bradenton International Airport",
    city: "Sarasota",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 27.38748,
    longitude: -82.553282,
    icao: "KSRQ"
  },
  SRT: {
    iata: "SRT",
    name: "Soroti Airport",
    city: "Soroti",
    countryId: "UG",
    timeZoneRegionName: "Africa/Kampala",
    latitude: 1.7,
    longitude: 33.616667,
    icao: "HUSO"
  },
  SRV: {
    iata: "SRV",
    name: "Stony River Airport",
    city: "Stony River",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 61.788762,
    longitude: -156.58863,
    icao: ""
  },
  SRW: {
    iata: "SRW",
    name: "Rowan County Airport",
    city: "Salisbury",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 35.666667,
    longitude: -80.483333,
    icao: "KRUQ"
  },
  SRY: {
    iata: "SRY",
    name: "Dashte Naz Airport",
    city: "Sary",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 36.635727,
    longitude: 53.197276,
    icao: "OINS"
  },
  SRZ: {
    iata: "SRZ",
    name: "El Trompillo Airport",
    city: "Santa Cruz",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -17.811047,
    longitude: -63.171715,
    icao: "SLET"
  },
  SSA: {
    iata: "SSA",
    name: "Deputado Luis Eduardo Magalhaes International Airport",
    city: "Salvador",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -12.913988,
    longitude: -38.335196,
    icao: "SBSV"
  },
  SSB: {
    iata: "SSB",
    name: "Christiansted Harbor Seaplane Base",
    city: "Saint Croix",
    countryId: "VI",
    timeZoneRegionName: "America/St_Thomas",
    latitude: 17.746836,
    longitude: -64.707825,
    icao: "VI32"
  },
  SSC: {
    iata: "SSC",
    name: "Shaw Air Force Base",
    city: "Sumter",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 33.972178,
    longitude: -80.47071,
    icao: "KSSC"
  },
  SSD: {
    iata: "SSD",
    name: "San Felipe Airport",
    city: "San Felipe",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 1.916667,
    longitude: -67.1,
    icao: "SCSF"
  },
  SSE: {
    iata: "SSE",
    name: "Sholapur Airport",
    city: "Sholapur",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 17.633333,
    longitude: 75.933333,
    icao: "VASL"
  },
  SSF: {
    iata: "SSF",
    name: "Stinson Municipal Airport",
    city: "San Antonio",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 29.337084,
    longitude: -98.469359,
    icao: "KSSF"
  },
  SSG: {
    iata: "SSG",
    name: "Malabo Airport",
    city: "Malabo",
    countryId: "GQ",
    timeZoneRegionName: "Africa/Malabo",
    latitude: 3.757791,
    longitude: 8.716096,
    icao: "FGSL"
  },
  SSH: {
    iata: "SSH",
    name: "Sharm El Sheikh Airport",
    city: "Sharm el Sheikh",
    countryId: "EG",
    timeZoneRegionName: "Africa/Cairo",
    latitude: 27.979357,
    longitude: 34.385253,
    icao: "HESH"
  },
  SSI: {
    iata: "SSI",
    name: "McKinnon St. Simons Island Airport",
    city: "Brunswick",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 31.152237,
    longitude: -81.390313,
    icao: "KSSI"
  },
  SSJ: {
    iata: "SSJ",
    name: "Stokka Airport",
    city: "Sandnessjoen",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 65.959944,
    longitude: 12.476518,
    icao: "ENST"
  },
  SSM: {
    iata: "SSM",
    name: "Sault Ste Marie Municipal Airport",
    city: "Sault Ste Marie",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 46.479166,
    longitude: -84.368275,
    icao: "KANJ"
  },
  SSN: {
    iata: "SSN",
    name: "Seoul Air Base",
    city: "Seoul",
    countryId: "KR",
    timeZoneRegionName: "Asia/Seoul",
    latitude: 37.447241,
    longitude: 127.112609,
    icao: "RKSM"
  },
  SSO: {
    iata: "SSO",
    name: "Sao Lourenzo Airport",
    city: "Sao Lourenzo",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -22.116667,
    longitude: -45.05,
    icao: "SNLO"
  },
  SSQ: {
    iata: "SSQ",
    name: "La Sarre Airport",
    city: "La Sarre",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 48.913745,
    longitude: -79.180253,
    icao: "CSR8"
  },
  SSR: {
    iata: "SSR",
    name: "Sara Airport",
    city: "Arongbwaratu",
    countryId: "VU",
    timeZoneRegionName: "Pacific/Efate",
    latitude: -15.472951,
    longitude: 168.153707,
    icao: "NVSH"
  },
  SST: {
    iata: "SST",
    name: "Santa Teresita Airport",
    city: "Santa Teresita",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -33.416667,
    longitude: -60.783333,
    icao: "SAZL"
  },
  SSY: {
    iata: "SSY",
    name: "M'Banza Congo Airport",
    city: "M'Banza Congo",
    countryId: "AO",
    timeZoneRegionName: "Africa/Luanda",
    latitude: -6.273889,
    longitude: 14.244167,
    icao: "FNBC"
  },
  SSZ: {
    iata: "SSZ",
    name: "Base Aerea de Santos Airport",
    city: "Santos",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -23.928796,
    longitude: -46.30147,
    icao: "SBST"
  },
  STA: {
    iata: "STA",
    name: "Stauning Airport",
    city: "Stauning",
    countryId: "DK",
    timeZoneRegionName: "Europe/Copenhagen",
    latitude: 55.990278,
    longitude: 8.355,
    icao: "EKVJ"
  },
  STB: {
    iata: "STB",
    name: "L Delicias Airport",
    city: "Santa Barbara Ed",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 9.033333,
    longitude: -71.95,
    icao: "SVSZ"
  },
  STC: {
    iata: "STC",
    name: "St. Cloud Municipal Airport",
    city: "Saint Cloud",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 45.545616,
    longitude: -94.057826,
    icao: "KSTC"
  },
  STD: {
    iata: "STD",
    name: "Mayo Guerrero Airport",
    city: "Santo Domingo",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 7.570489,
    longitude: -72.044116,
    icao: "SVSO"
  },
  STE: {
    iata: "STE",
    name: "Stevens Point Municipal Airport",
    city: "Stevens Point",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 44.545278,
    longitude: -89.530833,
    icao: "KSTE"
  },
  STG: {
    iata: "STG",
    name: "St George Island Airport",
    city: "Saint George Island",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 56.6,
    longitude: -169.5525,
    icao: ""
  },
  STI: {
    iata: "STI",
    name: "Cibao International Airport",
    city: "Santiago",
    countryId: "DO",
    timeZoneRegionName: "America/Santo_Domingo",
    latitude: 19.402928,
    longitude: -70.601868,
    icao: "MDST"
  },
  STJ: {
    iata: "STJ",
    name: "Rosecrans Memorial Airport",
    city: "Saint Joseph",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 39.960556,
    longitude: -94.925,
    icao: "KSTJ"
  },
  STK: {
    iata: "STK",
    name: "Sterling Municipal Airport",
    city: "Sterling",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 40.615312,
    longitude: -103.264838,
    icao: "KSTK"
  },
  STL: {
    iata: "STL",
    name: "Lambert-St. Louis International Airport",
    city: "Saint Louis",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 38.748707,
    longitude: -90.379002,
    icao: "KSTL"
  },
  STM: {
    iata: "STM",
    name: "Maestro Wilson Fonseca Airport",
    city: "Santarem",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -2.422362,
    longitude: -54.792406,
    icao: "SBSN"
  },
  STN: {
    iata: "STN",
    name: "Stansted Airport",
    city: "London",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.889267,
    longitude: 0.262703,
    icao: "EGSS"
  },
  STP: {
    iata: "STP",
    name: "St. Paul Downtown Airport",
    city: "Saint Paul",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 44.934502,
    longitude: -93.059998,
    icao: "KSTP"
  },
  STQ: {
    iata: "STQ",
    name: "St. Marys Airport",
    city: "Sainte Marys",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.433333,
    longitude: -78.566667,
    icao: "KOYM"
  },
  STR: {
    iata: "STR",
    name: "Stuttgart Airport",
    city: "Stuttgart",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 48.690732,
    longitude: 9.193624,
    icao: "EDDS"
  },
  STS: {
    iata: "STS",
    name: "Sonoma County Airport",
    city: "Santa Rosa",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 38.509962,
    longitude: -122.806704,
    icao: "KSTS"
  },
  STT: {
    iata: "STT",
    name: "Cyril E. King Airport",
    city: "Saint Thomas",
    countryId: "VI",
    timeZoneRegionName: "America/St_Thomas",
    latitude: 18.3375,
    longitude: -64.969444,
    icao: "TIST"
  },
  STV: {
    iata: "STV",
    name: "Surat Airport",
    city: "Surat",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 21.117658,
    longitude: 72.745258,
    icao: "VASU"
  },
  STW: {
    iata: "STW",
    name: "Stavropol Airport",
    city: "Stavropol",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 45.109419,
    longitude: 42.114278,
    icao: "URMT"
  },
  STX: {
    iata: "STX",
    name: "Henry E. Rohlsen Airport",
    city: "Saint Croix",
    countryId: "VI",
    timeZoneRegionName: "America/St_Thomas",
    latitude: 17.701944,
    longitude: -64.798611,
    icao: "TISX"
  },
  STY: {
    iata: "STY",
    name: "Salto Airport",
    city: "Salto",
    countryId: "UY",
    timeZoneRegionName: "America/Montevideo",
    latitude: -31.43704,
    longitude: -57.983723,
    icao: "SUSO"
  },
  STZ: {
    iata: "STZ",
    name: "Confresa Airport",
    city: "Santa Teresinha",
    countryId: "BR",
    timeZoneRegionName: "America/Campo_Grande",
    latitude: -10.300278,
    longitude: -50.45,
    icao: "SWST"
  },
  SUA: {
    iata: "SUA",
    name: "Witham Field",
    city: "Stuart",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 27.182892,
    longitude: -80.221679,
    icao: "KSUA"
  },
  SUB: {
    iata: "SUB",
    name: "Juanda International Airport",
    city: "Surabaya",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: -7.377937,
    longitude: 112.793782,
    icao: "WARR"
  },
  SUD: {
    iata: "SUD",
    name: "Stroud Airport",
    city: "Stroud",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.75,
    longitude: -96.683333,
    icao: "KSUD"
  },
  SUE: {
    iata: "SUE",
    name: "Door County Airport",
    city: "Sturgeon Bay",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 44.843889,
    longitude: -87.421389,
    icao: "KSUE"
  },
  SUF: {
    iata: "SUF",
    name: "Lamezia Terme International Airport",
    city: "Lamezia-Terme",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 38.910015,
    longitude: 16.244972,
    icao: "LICA"
  },
  SUG: {
    iata: "SUG",
    name: "Surigao Airport",
    city: "Surigao",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 9.758889,
    longitude: 125.479167,
    icao: "RPWS"
  },
  SUI: {
    iata: "SUI",
    name: "Babusheri Airport",
    city: "Sukhumi",
    countryId: "GE",
    timeZoneRegionName: "Asia/Tbilisi",
    latitude: 42.866667,
    longitude: 41.116667,
    icao: "UGSS"
  },
  SUJ: {
    iata: "SUJ",
    name: "Satu Mare International Airport",
    city: "Satu Mare",
    countryId: "RO",
    timeZoneRegionName: "Europe/Bucharest",
    latitude: 47.706094,
    longitude: 22.883396,
    icao: "LRSM"
  },
  SUK: {
    iata: "SUK",
    name: "Sakkyryr Airport",
    city: "Batagay-Alyta",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yakutsk",
    latitude: 67.79194,
    longitude: 130.39083,
    icao: ""
  },
  SUL: {
    iata: "SUL",
    name: "Sui Airport",
    city: "Sui",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 28.648889,
    longitude: 69.1725,
    icao: "OPSU"
  },
  SUM: {
    iata: "SUM",
    name: "Sumter Municipal Airport",
    city: "Sumter",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 33.993316,
    longitude: -80.361994,
    icao: "KSMS"
  },
  SUN: {
    iata: "SUN",
    name: "Friedman Memorial Airport",
    city: "Sun Valley",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 43.506471,
    longitude: -114.300822,
    icao: "KSUN"
  },
  SUP: {
    iata: "SUP",
    name: "Trunojoyo Airport",
    city: "Sumenep",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: -7.066667,
    longitude: 113.933333,
    icao: "WART"
  },
  SUQ: {
    iata: "SUQ",
    name: "Sucua Airport",
    city: "Sucua",
    countryId: "EC",
    timeZoneRegionName: "America/Guayaquil",
    latitude: -2.466667,
    longitude: -78.166667,
    icao: "SESC"
  },
  SUR: {
    iata: "SUR",
    name: "Summer Beaver Airport",
    city: "Summer Beaver",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 52.715278,
    longitude: -88.5475,
    icao: "CJV7"
  },
  SUS: {
    iata: "SUS",
    name: "Spirit of St. Louis Airport",
    city: "Saint Louis",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 38.663008,
    longitude: -90.65646,
    icao: "KSUS"
  },
  SUT: {
    iata: "SUT",
    name: "Sumbawanga Airport",
    city: "Sumbawanga",
    countryId: "TZ",
    timeZoneRegionName: "Africa/Dar_es_Salaam",
    latitude: -7.966667,
    longitude: 31.616667,
    icao: "HTSU"
  },
  SUU: {
    iata: "SUU",
    name: "Travis Air Force Base",
    city: "Fairfield",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 38.264321,
    longitude: -121.936722,
    icao: "KSUU"
  },
  SUV: {
    iata: "SUV",
    name: "Nausori Airport",
    city: "Suva",
    countryId: "FJ",
    timeZoneRegionName: "Pacific/Fiji",
    latitude: -18.045885,
    longitude: 178.559816,
    icao: "NFNA"
  },
  SUW: {
    iata: "SUW",
    name: "Richard I Bong Airport",
    city: "Superior",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 46.691111,
    longitude: -92.103333,
    icao: "KSUW"
  },
  SUX: {
    iata: "SUX",
    name: "Sioux Gateway Airport",
    city: "Sioux City",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 42.401944,
    longitude: -96.384167,
    icao: "KSUX"
  },
  SUY: {
    iata: "SUY",
    name: "Suntar Airport",
    city: "Suntar",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yakutsk",
    latitude: 62.184722,
    longitude: 117.636111,
    icao: "UENS"
  },
  SVA: {
    iata: "SVA",
    name: "Savoonga Airport",
    city: "Savoonga",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 63.690931,
    longitude: -170.486792,
    icao: "PASA"
  },
  SVB: {
    iata: "SVB",
    name: "Sambava Airport",
    city: "Sambava",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -14.276944,
    longitude: 50.175,
    icao: "FMNS"
  },
  SVC: {
    iata: "SVC",
    name: "Grant County Airport",
    city: "Silver City",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 32.631944,
    longitude: -108.153889,
    icao: "KSVC"
  },
  SVD: {
    iata: "SVD",
    name: "Argyle International Airport",
    city: "Saint Vincent",
    countryId: "VC",
    timeZoneRegionName: "America/St_Vincent",
    latitude: 13.156701,
    longitude: -61.149941,
    icao: "TVSA"
  },
  SVE: {
    iata: "SVE",
    name: "Susanville Airport",
    city: "Susanville",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 40.375702,
    longitude: -120.572998,
    icao: "KSVE"
  },
  SVG: {
    iata: "SVG",
    name: "Stavanger Airport Sola",
    city: "Stavanger",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 58.882149,
    longitude: 5.629197,
    icao: "ENZV"
  },
  SVH: {
    iata: "SVH",
    name: "Statesville Municipal Airport",
    city: "Statesville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 35.765122,
    longitude: -80.951421,
    icao: "KSVH"
  },
  SVI: {
    iata: "SVI",
    name: "Eduardo Falla Solano Airport",
    city: "San Vicente del Caguan",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 2.152148,
    longitude: -74.766263,
    icao: "SKSV"
  },
  SVJ: {
    iata: "SVJ",
    name: "Helle Airport",
    city: "Svolvaer",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 68.244983,
    longitude: 14.667774,
    icao: "ENSH"
  },
  SVL: {
    iata: "SVL",
    name: "Savonlinna Airport",
    city: "Savonlinna",
    countryId: "FI",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 61.944186,
    longitude: 28.932545,
    icao: "EFSA"
  },
  SVN: {
    iata: "SVN",
    name: "Hunter Air Force Base",
    city: "Savannah",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 32.010124,
    longitude: -81.146012,
    icao: "KSVN"
  },
  SVO: {
    iata: "SVO",
    name: "Sheremetyevo International Airport",
    city: "Moscow",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 55.966324,
    longitude: 37.416574,
    icao: "UUEE"
  },
  SVP: {
    iata: "SVP",
    name: "Kuito Airport",
    city: "Kuito",
    countryId: "AO",
    timeZoneRegionName: "Africa/Luanda",
    latitude: -12.3997,
    longitude: 16.955244,
    icao: "FNKU"
  },
  SVQ: {
    iata: "SVQ",
    name: "Seville Airport",
    city: "Sevilla",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 37.423476,
    longitude: -5.900136,
    icao: "LEZL"
  },
  SVR: {
    iata: "SVR",
    name: "Savissivik Heliport",
    city: "Savissivik",
    countryId: "GL",
    timeZoneRegionName: "America/Thule",
    latitude: 76.018608,
    longitude: -65.117578,
    icao: "BGSV"
  },
  SVU: {
    iata: "SVU",
    name: "Savusavu Airport",
    city: "Savusavu",
    countryId: "FJ",
    timeZoneRegionName: "Pacific/Fiji",
    latitude: -16.798828,
    longitude: 179.339123,
    icao: "NFNS"
  },
  SVW: {
    iata: "SVW",
    name: "Sparrevohn Air Force Station",
    city: "Sparrevohn",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 61.0975,
    longitude: -155.572222,
    icao: "PASV"
  },
  SVX: {
    iata: "SVX",
    name: "Koltsovo International Airport",
    city: "Yekaterinburg",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yekaterinburg",
    latitude: 56.750335,
    longitude: 60.804312,
    icao: "USSS"
  },
  SVZ: {
    iata: "SVZ",
    name: "Juan Vicente Gomez International Airport",
    city: "San Antonio del Tachira",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 7.839308,
    longitude: -72.440059,
    icao: "SVSA"
  },
  SWA: {
    iata: "SWA",
    name: "Jieyang Chaoshan Airport",
    city: "Jieyang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 23.54944,
    longitude: 116.510277,
    icao: "ZGOW"
  },
  SWC: {
    iata: "SWC",
    name: "Stawell Airport",
    city: "Stawell",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -37.066667,
    longitude: 142.766667,
    icao: "YSWL"
  },
  SWD: {
    iata: "SWD",
    name: "Seward Airport",
    city: "Seward",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 60.133333,
    longitude: -149.418056,
    icao: "PAWD"
  },
  SWF: {
    iata: "SWF",
    name: "Stewart International Airport",
    city: "Newburgh",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.49843,
    longitude: -74.101045,
    icao: "KSWF"
  },
  SWH: {
    iata: "SWH",
    name: "Swan Hill Airport",
    city: "Swan Hill",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -35.375801,
    longitude: 143.533005,
    icao: "YSWH"
  },
  SWJ: {
    iata: "SWJ",
    name: "South West Bay Airport",
    city: "South West Bay",
    countryId: "VU",
    timeZoneRegionName: "Pacific/Efate",
    latitude: -16.25,
    longitude: 167.166667,
    icao: "NVSX"
  },
  SWL: {
    iata: "SWL",
    name: "San Vicente Airport",
    city: "San Vicente",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 10.524722,
    longitude: 119.273333,
    icao: "RPSV"
  },
  SWO: {
    iata: "SWO",
    name: "Searcy Field",
    city: "Stillwater",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.158889,
    longitude: -97.085556,
    icao: "KSWO"
  },
  SWP: {
    iata: "SWP",
    name: "Swakopmund Airport",
    city: "Swakopmund",
    countryId: "NA",
    timeZoneRegionName: "Africa/Windhoek",
    latitude: -22.683333,
    longitude: 14.566667,
    icao: "FYSM"
  },
  SWQ: {
    iata: "SWQ",
    name: "Sultan Muhammad Kaharuddin III Airport",
    city: "Sumbawa Besar",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -8.489122,
    longitude: 117.414088,
    icao: "WADS"
  },
  SWS: {
    iata: "SWS",
    name: "Swansea Airport",
    city: "Swansea",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.605299,
    longitude: -4.067821,
    icao: "EGFH"
  },
  SWT: {
    iata: "SWT",
    name: "Strezhevoy Airport",
    city: "Strezhevoy",
    countryId: "RU",
    timeZoneRegionName: "Asia/Tomsk",
    latitude: 60.7094,
    longitude: 77.660004,
    icao: "UNSS"
  },
  SWU: {
    iata: "SWU",
    name: "Suwon Air Base",
    city: "Suwon",
    countryId: "KR",
    timeZoneRegionName: "Asia/Seoul",
    latitude: 37.239386,
    longitude: 127.006976,
    icao: "RKSW"
  },
  SWV: {
    iata: "SWV",
    name: "Severo-Evensk Airport",
    city: "Evensk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Magadan",
    latitude: 61.921667,
    longitude: 159.23,
    icao: ""
  },
  SWW: {
    iata: "SWW",
    name: "Avenger Field",
    city: "Sweetwater",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.467378,
    longitude: -100.466991,
    icao: "KSWW"
  },
  SWX: {
    iata: "SWX",
    name: "Shakawe Airport",
    city: "Shakawe",
    countryId: "BW",
    timeZoneRegionName: "Africa/Gaborone",
    latitude: -18.383333,
    longitude: 21.833333,
    icao: "FBSW"
  },
  SXB: {
    iata: "SXB",
    name: "Strasbourg Airport",
    city: "Strasbourg",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 48.544877,
    longitude: 7.627674,
    icao: "LFST"
  },
  SXE: {
    iata: "SXE",
    name: "Sale Airport",
    city: "Sale",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -38.09727,
    longitude: 147.140913,
    icao: "YMES"
  },
  SXG: {
    iata: "SXG",
    name: "Senanga Airport",
    city: "Senanga",
    countryId: "ZM",
    timeZoneRegionName: "Africa/Lusaka",
    latitude: -16.119444,
    longitude: 23.281944,
    icao: "FLSN"
  },
  SXI: {
    iata: "SXI",
    name: "Sirri Island Airport",
    city: "Sirri Island",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 25.902504,
    longitude: 54.546614,
    icao: "OIBS"
  },
  SXK: {
    iata: "SXK",
    name: "Saumlaki Olilit Airport",
    city: "Saumlaki",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jayapura",
    latitude: -7.988421,
    longitude: 131.304336,
    icao: "WAPI"
  },
  SXL: {
    iata: "SXL",
    name: "Collooney Airport",
    city: "Sligo",
    countryId: "IE",
    timeZoneRegionName: "Europe/Dublin",
    latitude: 54.280201,
    longitude: -8.59921,
    icao: "EISG"
  },
  SXM: {
    iata: "SXM",
    name: "Princess Juliana International Airport",
    city: "Sint Maarten",
    countryId: "SX",
    timeZoneRegionName: "America/Curacao",
    latitude: 18.041232,
    longitude: -63.108646,
    icao: "TNCM"
  },
  SXO: {
    iata: "SXO",
    name: "Sao Felix Do Araguaia Airport",
    city: "Sao Felix Do Araguaia",
    countryId: "BR",
    timeZoneRegionName: "America/Campo_Grande",
    latitude: -11.6,
    longitude: -50.65,
    icao: "SWFX"
  },
  SXP: {
    iata: "SXP",
    name: "Sheldon Point Airport",
    city: "Sheldon Point",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 62.533333,
    longitude: -164.833333,
    icao: ""
  },
  SXQ: {
    iata: "SXQ",
    name: "Soldotna Airport",
    city: "Soldotna",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 60.475556,
    longitude: -151.036389,
    icao: "PASX"
  },
  SXR: {
    iata: "SXR",
    name: "Srinagar International Airport",
    city: "Srinagar",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 34.002308,
    longitude: 74.762631,
    icao: "VISR"
  },
  SXU: {
    iata: "SXU",
    name: "Soddu Airport",
    city: "Soddu",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 6.836111,
    longitude: 37.775,
    icao: "HASD"
  },
  SXV: {
    iata: "SXV",
    name: "Salem Airport",
    city: "Salem",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 11.783128,
    longitude: 78.065217,
    icao: "VOSM"
  },
  SXX: {
    iata: "SXX",
    name: "Sao Felix Do Xingu Airport",
    city: "Sao Felix Do Xingu",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -6.633333,
    longitude: -51.983333,
    icao: "SNFX"
  },
  SXZ: {
    iata: "SXZ",
    name: "Siirt Airport",
    city: "Siirt",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 37.978894,
    longitude: 41.840439,
    icao: "LTCL"
  },
  SYA: {
    iata: "SYA",
    name: "Shemya Air Force Base",
    city: "Shemya",
    countryId: "US",
    timeZoneRegionName: "America/Adak",
    latitude: 52.7175,
    longitude: 174.089444,
    icao: "PASY"
  },
  SYC: {
    iata: "SYC",
    name: "Shiringayoc O Hda Mejia",
    city: "Leon Velarde",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -11.9,
    longitude: -69.166667,
    icao: "SPOV"
  },
  SYD: {
    iata: "SYD",
    name: "Sydney (Kingsford Smith) Airport",
    city: "Sydney",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -33.932922,
    longitude: 151.179898,
    icao: "YSSY"
  },
  SYE: {
    iata: "SYE",
    name: "Sadah Airport",
    city: "Sadah",
    countryId: "YE",
    timeZoneRegionName: "Asia/Aden",
    latitude: 16.866667,
    longitude: 43.616667,
    icao: "OYSH"
  },
  SYI: {
    iata: "SYI",
    name: "Shelbyville Municipal Airport-Bomar Field",
    city: "Shelbyville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.560833,
    longitude: -86.4425,
    icao: "KSYI"
  },
  SYJ: {
    iata: "SYJ",
    name: "Sirjan Airport",
    city: "Sirjan",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 29.551414,
    longitude: 55.665193,
    icao: "OIKY"
  },
  SYK: {
    iata: "SYK",
    name: "Stykkisholmur Airport",
    city: "Stykkisholmur",
    countryId: "IS",
    timeZoneRegionName: "Atlantic/Reykjavik",
    latitude: 65.1,
    longitude: -22.8,
    icao: "BIST"
  },
  SYM: {
    iata: "SYM",
    name: "Pu'er Simao Airport",
    city: "Pu'er",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 22.796569,
    longitude: 100.96222,
    icao: "ZPSM"
  },
  SYN: {
    iata: "SYN",
    name: "Carleton Airport",
    city: "Stanton",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.133333,
    longitude: -101.8,
    icao: "KSYN"
  },
  SYO: {
    iata: "SYO",
    name: "Shonai Airport",
    city: "Shonai",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 38.809444,
    longitude: 139.790556,
    icao: "RJSY"
  },
  SYR: {
    iata: "SYR",
    name: "Hancock International Airport",
    city: "Syracuse",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 43.113984,
    longitude: -76.112231,
    icao: "KSYR"
  },
  SYS: {
    iata: "SYS",
    name: "Saskylakh Airport",
    city: "Saskylakh",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yakutsk",
    latitude: 71.928889,
    longitude: 114.082222,
    icao: ""
  },
  SYV: {
    iata: "SYV",
    name: "Sylvester Airport",
    city: "Sylvester",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 31.516667,
    longitude: -83.833333,
    icao: "KSYV"
  },
  SYX: {
    iata: "SYX",
    name: "Sanya Phoenix International Airport",
    city: "Sanya",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 18.305276,
    longitude: 109.40888,
    icao: "ZJSY"
  },
  SYY: {
    iata: "SYY",
    name: "Stornoway Airport",
    city: "Stornoway, Outer Stat Hebrides",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 58.213626,
    longitude: -6.321995,
    icao: "EGPO"
  },
  SYZ: {
    iata: "SYZ",
    name: "Shiraz International Airport",
    city: "Shiraz",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 29.54613,
    longitude: 52.58997,
    icao: "OISS"
  },
  SZA: {
    iata: "SZA",
    name: "Soyo Airport",
    city: "Soyo",
    countryId: "AO",
    timeZoneRegionName: "Africa/Luanda",
    latitude: -6.140637,
    longitude: 12.375155,
    icao: "FNSO"
  },
  SZB: {
    iata: "SZB",
    name: "Sultan Abdul Aziz Shah Airport",
    city: "Kuala Lumpur",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 3.130644,
    longitude: 101.558078,
    icao: "WMSA"
  },
  SZC: {
    iata: "SZC",
    name: "Sarfannguit Heliport",
    city: "Sarfannguaq",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 66.896488,
    longitude: -52.865806,
    icao: ""
  },
  SZD: {
    iata: "SZD",
    name: "Sheffield City Airport",
    city: "Sheffield",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 53.399444,
    longitude: -1.389722,
    icao: "EGSY"
  },
  SZE: {
    iata: "SZE",
    name: "Semera Airport",
    city: "Semera",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 11.787483,
    longitude: 40.991723,
    icao: "HASM"
  },
  SZF: {
    iata: "SZF",
    name: "Samsun-Carsamba Airport",
    city: "Samsun",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 41.257381,
    longitude: 36.555057,
    icao: "LTFH"
  },
  SZG: {
    iata: "SZG",
    name: "W. A. Mozart Salzburg Airport",
    city: "Salzburg",
    countryId: "AT",
    timeZoneRegionName: "Europe/Vienna",
    latitude: 47.791226,
    longitude: 12.997331,
    icao: "LOWS"
  },
  SZH: {
    iata: "SZH",
    name: "Shuozhou Zirun Airport",
    city: "Shuozhou",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 39.273056,
    longitude: 112.691111,
    icao: ""
  },
  SZJ: {
    iata: "SZJ",
    name: "Siguanea Airport",
    city: "Siguanea",
    countryId: "CU",
    timeZoneRegionName: "America/Havana",
    latitude: 21.643059,
    longitude: -82.954448,
    icao: "MUSN"
  },
  SZK: {
    iata: "SZK",
    name: "Skukuza Airport",
    city: "Skukuza",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -24.9628,
    longitude: 31.589516,
    icao: "FASZ"
  },
  SZL: {
    iata: "SZL",
    name: "Whiteman Air Force Base",
    city: "Warrensburg",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 38.7303,
    longitude: -93.547922,
    icao: "KSZL"
  },
  SZP: {
    iata: "SZP",
    name: "Santa Paula Airport",
    city: "Santa Paula",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 34.347198,
    longitude: -119.060997,
    icao: "KSZP"
  },
  SZT: {
    iata: "SZT",
    name: "San Cristobal de las Casas Airport",
    city: "San Cristobal de las Casas",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 16.690556,
    longitude: -92.544167,
    icao: "MMSC"
  },
  SZW: {
    iata: "SZW",
    name: "Parchim Airport",
    city: "Schwerin",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 53.430391,
    longitude: 11.78091,
    icao: "EDOP"
  },
  SZX: {
    iata: "SZX",
    name: "Shenzhen Bao'an International Airport",
    city: "Shenzhen",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 22.639444,
    longitude: 113.810833,
    icao: "ZGSZ"
  },
  SZY: {
    iata: "SZY",
    name: "Mazury Airport",
    city: "Szymany",
    countryId: "PL",
    timeZoneRegionName: "Europe/Warsaw",
    latitude: 53.481924,
    longitude: 20.937668,
    icao: "EPSY"
  },
  SZZ: {
    iata: "SZZ",
    name: "Goleniow Airport",
    city: "Szczecin",
    countryId: "PL",
    timeZoneRegionName: "Europe/Warsaw",
    latitude: 53.593524,
    longitude: 14.894611,
    icao: "EPSC"
  },
  TAB: {
    iata: "TAB",
    name: "A.N.R. Robinson International Airport",
    city: "Tobago",
    countryId: "TT",
    timeZoneRegionName: "America/Port_of_Spain",
    latitude: 11.152541,
    longitude: -60.839685,
    icao: "TTCP"
  },
  TAC: {
    iata: "TAC",
    name: "D. Z. Romualdez Airport",
    city: "Tacloban",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 11.22684,
    longitude: 125.025916,
    icao: "RPVA"
  },
  TAD: {
    iata: "TAD",
    name: "Perry Stokes Municipal Airport",
    city: "Trinidad",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 37.262394,
    longitude: -104.336957,
    icao: "KTAD"
  },
  TAE: {
    iata: "TAE",
    name: "Daegu International Airport",
    city: "Daegu",
    countryId: "KR",
    timeZoneRegionName: "Asia/Seoul",
    latitude: 35.899254,
    longitude: 128.637874,
    icao: "RKTN"
  },
  TAF: {
    iata: "TAF",
    name: "Tafaraoui Airport",
    city: "Oran",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 35.543502,
    longitude: -0.532687,
    icao: "DAOL"
  },
  TAG: {
    iata: "TAG",
    name: "Bohol International Airport",
    city: "Panglao",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 9.574353,
    longitude: 123.770949,
    icao: "RPSP"
  },
  TAH: {
    iata: "TAH",
    name: "Whitegrass Airport",
    city: "Lenakel",
    countryId: "VU",
    timeZoneRegionName: "Pacific/Efate",
    latitude: -19.455,
    longitude: 169.223889,
    icao: "NVVW"
  },
  TAI: {
    iata: "TAI",
    name: "Al Janad Airport",
    city: "Taiz",
    countryId: "YE",
    timeZoneRegionName: "Asia/Aden",
    latitude: 13.685553,
    longitude: 44.134345,
    icao: "OYTZ"
  },
  TAK: {
    iata: "TAK",
    name: "Takamatsu Airport",
    city: "Takamatsu",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 34.219017,
    longitude: 134.018252,
    icao: "RJOT"
  },
  TAL: {
    iata: "TAL",
    name: "Ralph M Calhoun Airport",
    city: "Tanana",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 65.174422,
    longitude: -152.109955,
    icao: "PATA"
  },
  TAM: {
    iata: "TAM",
    name: "Tampico International Airport",
    city: "Tampico",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 22.289082,
    longitude: -97.870162,
    icao: "MMTM"
  },
  TAO: {
    iata: "TAO",
    name: "Qingdao Liuting International Airport",
    city: "Qingdao",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 36.265884,
    longitude: 120.382361,
    icao: "ZSQD"
  },
  TAP: {
    iata: "TAP",
    name: "Tapachula International Airport",
    city: "Tapachula",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 14.794083,
    longitude: -92.37022,
    icao: "MMTP"
  },
  TAR: {
    iata: "TAR",
    name: "Taranto-Grottaglie Airport",
    city: "Taranto",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 40.517778,
    longitude: 17.401944,
    icao: "LIBG"
  },
  TAS: {
    iata: "TAS",
    name: "Tashkent International Airport",
    city: "Tashkent",
    countryId: "UZ",
    timeZoneRegionName: "Asia/Tashkent",
    latitude: 41.257893,
    longitude: 69.281204,
    icao: "UTTT"
  },
  TAT: {
    iata: "TAT",
    name: "Poprad/Tatry Airport",
    city: "Poprad/Tatry",
    countryId: "SK",
    timeZoneRegionName: "Europe/Bratislava",
    latitude: 49.073281,
    longitude: 20.248118,
    icao: "LZTT"
  },
  TAW: {
    iata: "TAW",
    name: "Tacuarembo Airport",
    city: "Tacuarembo",
    countryId: "UY",
    timeZoneRegionName: "America/Montevideo",
    latitude: -31.75,
    longitude: -55.916667,
    icao: "SUTB"
  },
  TAY: {
    iata: "TAY",
    name: "Tartu Airport",
    city: "Tartu",
    countryId: "EE",
    timeZoneRegionName: "Europe/Tallinn",
    latitude: 58.30969,
    longitude: 26.690904,
    icao: "EETU"
  },
  TAZ: {
    iata: "TAZ",
    name: "Dashoguz Airport",
    city: "Dashoguz",
    countryId: "TM",
    timeZoneRegionName: "Asia/Ashgabat",
    latitude: 41.763678,
    longitude: 59.834052,
    icao: "UTAT"
  },
  TBB: {
    iata: "TBB",
    name: "Tuy Hoa Airport",
    city: "Tuy H\xF2a",
    countryId: "VN",
    timeZoneRegionName: "Asia/Ho_Chi_Minh",
    latitude: 13.0494444,
    longitude: 109.33361111111111,
    icao: "VVTH"
  },
  TBF: {
    iata: "TBF",
    name: "Tabiteuea North Airport",
    city: "Tabiteuea",
    countryId: "KI",
    timeZoneRegionName: "Pacific/Tarawa",
    latitude: -1.231944,
    longitude: 174.78,
    icao: "NGTE"
  },
  TBG: {
    iata: "TBG",
    name: "Tabubil Airport",
    city: "Tabubil",
    countryId: "PG",
    timeZoneRegionName: "Pacific/Port_Moresby",
    latitude: -5.274722,
    longitude: 141.227009,
    icao: "AYTB"
  },
  TBH: {
    iata: "TBH",
    name: "Tugdan Airport",
    city: "Barangay Tugdan",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 12.315823,
    longitude: 122.081968,
    icao: "RPVU"
  },
  TBI: {
    iata: "TBI",
    name: "New Bight Airport",
    city: "Cat Island",
    countryId: "BS",
    timeZoneRegionName: "America/Nassau",
    latitude: 24.315,
    longitude: -75.453611,
    icao: "MYCB"
  },
  TBJ: {
    iata: "TBJ",
    name: "Tabarka-Ain Draham Airport",
    city: "Tabarka",
    countryId: "TN",
    timeZoneRegionName: "Africa/Tunis",
    latitude: 36.978333,
    longitude: 8.876389,
    icao: "DTKA"
  },
  TBK: {
    iata: "TBK",
    name: "Timber Creek Airport",
    city: "Timber Creek",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -15.65,
    longitude: 130.483333,
    icao: "YTBR"
  },
  TBN: {
    iata: "TBN",
    name: "Waynesville-St. Robert Regional Airport",
    city: "Fort Leonard Wood",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 37.741389,
    longitude: -92.140556,
    icao: "KTBN"
  },
  TBO: {
    iata: "TBO",
    name: "Tabora Airport",
    city: "Tabora",
    countryId: "TZ",
    timeZoneRegionName: "Africa/Dar_es_Salaam",
    latitude: -5.073437,
    longitude: 32.834744,
    icao: "HTTB"
  },
  TBP: {
    iata: "TBP",
    name: "Capitan FAP Pedro Canga Rodriguez Airport",
    city: "Tumbes",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -3.550817,
    longitude: -80.384033,
    icao: "SPME"
  },
  TBR: {
    iata: "TBR",
    name: "Statesboro-Bulloch County Airport",
    city: "Statesboro",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 32.480883,
    longitude: -81.741444,
    icao: "KTBR"
  },
  TBS: {
    iata: "TBS",
    name: "Tbilisi International Airport",
    city: "Tbilisi",
    countryId: "GE",
    timeZoneRegionName: "Asia/Tbilisi",
    latitude: 41.674063,
    longitude: 44.958958,
    icao: "UGGG"
  },
  TBT: {
    iata: "TBT",
    name: "Tabatinga International Airport",
    city: "Tabatinga",
    countryId: "BR",
    timeZoneRegionName: "America/Rio_Branco",
    latitude: -4.251359,
    longitude: -69.939568,
    icao: "SBTT"
  },
  TBU: {
    iata: "TBU",
    name: "Fua'amotu International Airport",
    city: "Nuku'alofa",
    countryId: "TO",
    timeZoneRegionName: "Pacific/Tongatapu",
    latitude: -21.242181,
    longitude: -175.141916,
    icao: "NFTF"
  },
  TBW: {
    iata: "TBW",
    name: "Tambov Donskoye Airport",
    city: "Tambov",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 52.803388,
    longitude: 41.488676,
    icao: ""
  },
  TBY: {
    iata: "TBY",
    name: "Tsabong Airport",
    city: "Tsabong",
    countryId: "BW",
    timeZoneRegionName: "Africa/Gaborone",
    latitude: -26.066667,
    longitude: 22.466667,
    icao: "FBTS"
  },
  TBZ: {
    iata: "TBZ",
    name: "Tabriz Airport",
    city: "Tabriz",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 38.122849,
    longitude: 46.244274,
    icao: "OITT"
  },
  TCA: {
    iata: "TCA",
    name: "Tennant Creek Airport",
    city: "Tennant Creek",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -19.6409,
    longitude: 134.184487,
    icao: "YTNK"
  },
  TCB: {
    iata: "TCB",
    name: "Treasure Cay Airport",
    city: "Treasure Cay",
    countryId: "BS",
    timeZoneRegionName: "America/Nassau",
    latitude: 26.735,
    longitude: -77.372222,
    icao: "MYAT"
  },
  TCC: {
    iata: "TCC",
    name: "Tucumcari Airport",
    city: "Tucumcari",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 35.166667,
    longitude: -103.733333,
    icao: "KTCC"
  },
  TCD: {
    iata: "TCD",
    name: "Tarapaca Airport",
    city: "Tarapaca",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: -2.893984,
    longitude: -69.745354,
    icao: "SKRA"
  },
  TCE: {
    iata: "TCE",
    name: "Tulcea Airport",
    city: "Tulcea",
    countryId: "RO",
    timeZoneRegionName: "Europe/Bucharest",
    latitude: 45.064492,
    longitude: 28.714956,
    icao: "LRTC"
  },
  TCG: {
    iata: "TCG",
    name: "Tacheng Airport",
    city: "Tacheng",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 46.670595,
    longitude: 83.339733,
    icao: "ZWTC"
  },
  TCH: {
    iata: "TCH",
    name: "Tchibanga Airport",
    city: "Tchibanga",
    countryId: "GA",
    timeZoneRegionName: "Africa/Libreville",
    latitude: -2.816667,
    longitude: 11,
    icao: "FOOT"
  },
  TCL: {
    iata: "TCL",
    name: "Tuscaloosa Regional Airport",
    city: "Tuscaloosa",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 33.221111,
    longitude: -87.610833,
    icao: "KTCL"
  },
  TCM: {
    iata: "TCM",
    name: "McChord Field",
    city: "Tacoma",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 47.138344,
    longitude: -122.476581,
    icao: "KTCM"
  },
  TCN: {
    iata: "TCN",
    name: "Tehuacan Airport",
    city: "Tehuacan",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 18.499722,
    longitude: -97.417778,
    icao: "MMHC"
  },
  TCO: {
    iata: "TCO",
    name: "La Florida Airport",
    city: "Tumaco",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 1.816667,
    longitude: -78.766667,
    icao: "SKCO"
  },
  TCP: {
    iata: "TCP",
    name: "Taba International Airport",
    city: "Taba",
    countryId: "EG",
    timeZoneRegionName: "Africa/Cairo",
    latitude: 29.594197,
    longitude: 34.777077,
    icao: "HETB"
  },
  TCQ: {
    iata: "TCQ",
    name: "Tacna Airport",
    city: "Tacna",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -18.063333,
    longitude: -70.278889,
    icao: "SPTN"
  },
  TCR: {
    iata: "TCR",
    name: "Tuticorin Airport",
    city: "Tuticorin",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 8.716667,
    longitude: 78.033333,
    icao: "VOTK"
  },
  TCS: {
    iata: "TCS",
    name: "Truth Or Consequences Municipal Airport",
    city: "Truth Or Consequences",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 33.133333,
    longitude: -107.25,
    icao: "KTCS"
  },
  TCW: {
    iata: "TCW",
    name: "Tocumwal Airport",
    city: "Tocumwal",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -35.816667,
    longitude: 145.6,
    icao: "YTOC"
  },
  TCX: {
    iata: "TCX",
    name: "Tabas Airport",
    city: "Tabas",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 33.667169,
    longitude: 56.895559,
    icao: "OIMT"
  },
  TCZ: {
    iata: "TCZ",
    name: "Tengchong Tuofeng Airport",
    city: "Tengchong",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 24.939379,
    longitude: 98.482028,
    icao: "ZUTC"
  },
  TDA: {
    iata: "TDA",
    name: "Trinidad Airport",
    city: "Trinidad",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 5.42292,
    longitude: -71.66323,
    icao: "SKTD"
  },
  TDD: {
    iata: "TDD",
    name: "Teniente Jorge Henrich Arauz Airport",
    city: "Trinidad",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -14.822613,
    longitude: -64.919313,
    icao: "SLTR"
  },
  TDG: {
    iata: "TDG",
    name: "Tandag Airport",
    city: "Tandag",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 9.072063,
    longitude: 126.171174,
    icao: "RPMW"
  },
  TDJ: {
    iata: "TDJ",
    name: "Tadjoura Airport",
    city: "Tadjoura",
    countryId: "DJ",
    timeZoneRegionName: "Africa/Djibouti",
    latitude: 11.783333,
    longitude: 42.9,
    icao: "HDTJ"
  },
  TDK: {
    iata: "TDK",
    name: "Taldykorgan Airport",
    city: "Taldykorgan",
    countryId: "KZ",
    timeZoneRegionName: "Asia/Almaty",
    latitude: 45.109287,
    longitude: 78.441326,
    icao: "UAAT"
  },
  TDL: {
    iata: "TDL",
    name: "Tandil Airport",
    city: "Tandil",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -37.333333,
    longitude: -59.083333,
    icao: "SAZT"
  },
  TDO: {
    iata: "TDO",
    name: "Winlock Airport",
    city: "Toledo",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 46.433333,
    longitude: -122.85,
    icao: "KTDO"
  },
  TDR: {
    iata: "TDR",
    name: "Theodore Airport",
    city: "Theodore",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -24.983333,
    longitude: 150.083333,
    icao: "YTDR"
  },
  TDV: {
    iata: "TDV",
    name: "Tanandava Airport",
    city: "Tanandava",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -21.7,
    longitude: 43.733333,
    icao: "FMSN"
  },
  TDW: {
    iata: "TDW",
    name: "Tradewind Airport",
    city: "Amarillo",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.216667,
    longitude: -101.833333,
    icao: "KTDW"
  },
  TDX: {
    iata: "TDX",
    name: "Trat Airport",
    city: "Trat",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 12.274572,
    longitude: 102.318958,
    icao: "VTBO"
  },
  TDZ: {
    iata: "TDZ",
    name: "Toledo Executive Airport",
    city: "Toledo",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.56515,
    longitude: -83.476711,
    icao: "KTDZ"
  },
  TEA: {
    iata: "TEA",
    name: "Tela Airport",
    city: "Tela",
    countryId: "HN",
    timeZoneRegionName: "America/Tegucigalpa",
    latitude: 15.771667,
    longitude: -87.487778,
    icao: "MHTE"
  },
  TEB: {
    iata: "TEB",
    name: "Teterboro Airport",
    city: "Teterboro",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.849722,
    longitude: -74.062222,
    icao: "KTEB"
  },
  TEC: {
    iata: "TEC",
    name: "Telemaco Borba Airport",
    city: "Telemaco Borba",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -24.315833,
    longitude: -50.651667,
    icao: "SBTL"
  },
  TED: {
    iata: "TED",
    name: "Thisted Airport",
    city: "Thisted",
    countryId: "DK",
    timeZoneRegionName: "Europe/Copenhagen",
    latitude: 57.072222,
    longitude: 8.703333,
    icao: "EKTS"
  },
  TEE: {
    iata: "TEE",
    name: "Cheikh Larbi Tebessi Airport",
    city: "Tebessa",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 35.428594,
    longitude: 8.124067,
    icao: "DABS"
  },
  TEF: {
    iata: "TEF",
    name: "Telfer Airport",
    city: "Telfer",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -21.71113,
    longitude: 122.22613,
    icao: "YTEF"
  },
  TEG: {
    iata: "TEG",
    name: "Tenkodogo Airport",
    city: "Tenkodogo",
    countryId: "BF",
    timeZoneRegionName: "Africa/Ouagadougou",
    latitude: 11.9,
    longitude: -0.316667,
    icao: "DFET"
  },
  TEI: {
    iata: "TEI",
    name: "Tezu Airport",
    city: "Tezu",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 27.95,
    longitude: 96.133333,
    icao: "VETJ"
  },
  TEM: {
    iata: "TEM",
    name: "Temora Airport",
    city: "Temora",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -34.416667,
    longitude: 147.5,
    icao: "YTEM"
  },
  TEN: {
    iata: "TEN",
    name: "Tongren Fenhuang Airport",
    city: "Tongren",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 27.883689,
    longitude: 109.299019,
    icao: "ZUTR"
  },
  TEQ: {
    iata: "TEQ",
    name: "Corlu Airport",
    city: "Tekirdag",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 40.966667,
    longitude: 27.5,
    icao: "LTBU"
  },
  TER: {
    iata: "TER",
    name: "Lajes Field",
    city: "Terceira",
    countryId: "PT",
    timeZoneRegionName: "Atlantic/Azores",
    latitude: 38.754075,
    longitude: -27.08757,
    icao: "LPLA"
  },
  TES: {
    iata: "TES",
    name: "Tessenei Airport",
    city: "Tessenei",
    countryId: "ER",
    timeZoneRegionName: "Africa/Asmara",
    latitude: 15.116667,
    longitude: 36.683333,
    icao: "HHTS"
  },
  TET: {
    iata: "TET",
    name: "Matundo Airport",
    city: "Tete",
    countryId: "MZ",
    timeZoneRegionName: "Africa/Maputo",
    latitude: -16.103333,
    longitude: 33.638889,
    icao: "FQTT"
  },
  TEU: {
    iata: "TEU",
    name: "Manapouri Airport",
    city: "Te Anau",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -45.532876,
    longitude: 167.643093,
    icao: "NZMO"
  },
  TEV: {
    iata: "TEV",
    name: "Teruel Airport",
    city: "Teruel",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 40.411944,
    longitude: -1.2175,
    icao: "LETL"
  },
  TEX: {
    iata: "TEX",
    name: "Telluride Regional Airport",
    city: "Telluride",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 37.95354,
    longitude: -107.901005,
    icao: "KTEX"
  },
  TEY: {
    iata: "TEY",
    name: "Thingeyri Airport",
    city: "Thingeyri",
    countryId: "IS",
    timeZoneRegionName: "Atlantic/Reykjavik",
    latitude: 65.883333,
    longitude: -23.45,
    icao: "BITE"
  },
  TFF: {
    iata: "TFF",
    name: "Tefe Airport",
    city: "Tefe",
    countryId: "BR",
    timeZoneRegionName: "America/Porto_Velho",
    latitude: -3.379786,
    longitude: -64.724217,
    icao: "SBTF"
  },
  TFL: {
    iata: "TFL",
    name: "Teofilo Otoni Airport",
    city: "Teofilo Otoni",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -17.85,
    longitude: -41.5,
    icao: ""
  },
  TFN: {
    iata: "TFN",
    name: "Tenerife North Airport",
    city: "Tenerife",
    countryId: "ES",
    timeZoneRegionName: "Atlantic/Canary",
    latitude: 28.488057,
    longitude: -16.345982,
    icao: "GCXO"
  },
  TFS: {
    iata: "TFS",
    name: "Tenerife South Airport",
    city: "Tenerife",
    countryId: "ES",
    timeZoneRegionName: "Atlantic/Canary",
    latitude: 28.044444,
    longitude: -16.5725,
    icao: "GCTS"
  },
  TFU: {
    iata: "TFU",
    name: "Chengdu Tianfu International Airport",
    city: "Jianyang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 30.319,
    longitude: 104.445,
    icao: "ZUTF"
  },
  TGA: {
    iata: "TGA",
    name: "Tengah Airport",
    city: "Singapore",
    countryId: "SG",
    timeZoneRegionName: "Asia/Singapore",
    latitude: 1.389724,
    longitude: 103.711557,
    icao: "WSAT"
  },
  TGC: {
    iata: "TGC",
    name: "Tanjung Manis Airport",
    city: "Sarikei",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 2.176315,
    longitude: 111.203344,
    icao: "WBGT"
  },
  TGD: {
    iata: "TGD",
    name: "Podgorica Airport",
    city: "Podgorica",
    countryId: "ME",
    timeZoneRegionName: "Europe/Podgorica",
    latitude: 42.368023,
    longitude: 19.246024,
    icao: "LYPG"
  },
  TGG: {
    iata: "TGG",
    name: "Sultan Mahmud Airport",
    city: "Kuala Terengganu",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 5.379951,
    longitude: 103.104434,
    icao: "WMKN"
  },
  TGH: {
    iata: "TGH",
    name: "Tongoa Airport",
    city: "Tongoa",
    countryId: "VU",
    timeZoneRegionName: "Pacific/Efate",
    latitude: -16.8911,
    longitude: 168.550995,
    icao: "NVST"
  },
  TGI: {
    iata: "TGI",
    name: "Tingo Maria Airport",
    city: "Tingo Maria",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -9.292779,
    longitude: -76.005526,
    icao: "SPGM"
  },
  TGJ: {
    iata: "TGJ",
    name: "Tiga Airport",
    city: "Tiga",
    countryId: "NC",
    timeZoneRegionName: "Pacific/Noumea",
    latitude: -21.098359,
    longitude: 167.802935,
    icao: "NWWA"
  },
  TGK: {
    iata: "TGK",
    name: "Taganrog Yuzhny Airport",
    city: "Taganrog",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 47.198333,
    longitude: 38.849167,
    icao: "URRT"
  },
  TGM: {
    iata: "TGM",
    name: "Transilvania Airport",
    city: "Targu-Mures",
    countryId: "RO",
    timeZoneRegionName: "Europe/Bucharest",
    latitude: 46.467719,
    longitude: 24.412525,
    icao: "LRTM"
  },
  TGN: {
    iata: "TGN",
    name: "La Trobe Regional Airport",
    city: "Traralgon",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -38.207199,
    longitude: 146.470001,
    icao: "YLTV"
  },
  TGO: {
    iata: "TGO",
    name: "Tongliao Airport",
    city: "Tongliao",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 43.557011,
    longitude: 122.204604,
    icao: "ZBTL"
  },
  TGP: {
    iata: "TGP",
    name: "Podkamennaya Tunguska Airport",
    city: "Bor",
    countryId: "RU",
    timeZoneRegionName: "Asia/Krasnoyarsk",
    latitude: 61.59,
    longitude: 89.97945,
    icao: "UNIP"
  },
  TGR: {
    iata: "TGR",
    name: "Touggourt Airport",
    city: "Touggourt",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 33.066948,
    longitude: 6.089239,
    icao: "DAUK"
  },
  TGT: {
    iata: "TGT",
    name: "Tanga Airport",
    city: "Tanga",
    countryId: "TZ",
    timeZoneRegionName: "Africa/Dar_es_Salaam",
    latitude: -5.092163,
    longitude: 39.071669,
    icao: "HTTG"
  },
  TGU: {
    iata: "TGU",
    name: "Toncontin Airport",
    city: "Tegucigalpa",
    countryId: "HN",
    timeZoneRegionName: "America/Tegucigalpa",
    latitude: 14.060123,
    longitude: -87.219716,
    icao: "MHTG"
  },
  TGZ: {
    iata: "TGZ",
    name: "Angel Albino Corzo International Airport",
    city: "Tuxtla Gutierrez",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 16.563611,
    longitude: -93.0225,
    icao: "MMTG"
  },
  THA: {
    iata: "THA",
    name: "Northern Airport",
    city: "Tullahoma",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.366667,
    longitude: -86.183333,
    icao: "KTHA"
  },
  THC: {
    iata: "THC",
    name: "Tchien Airport",
    city: "Tchien",
    countryId: "LR",
    timeZoneRegionName: "Africa/Monrovia",
    latitude: 6.066667,
    longitude: -8.133333,
    icao: "GLTN"
  },
  THD: {
    iata: "THD",
    name: "Tho Xuan Airport",
    city: "Thanh H\xF3a",
    countryId: "VN",
    timeZoneRegionName: "Asia/Vientiane",
    latitude: 19.901667,
    longitude: 105.467778,
    icao: "VVTX"
  },
  THE: {
    iata: "THE",
    name: "Teresina Airport",
    city: "Teresina",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -5.06335,
    longitude: -42.821085,
    icao: "SBTE"
  },
  THG: {
    iata: "THG",
    name: "Thangool Airport",
    city: "Thangool",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -24.494162,
    longitude: 150.576387,
    icao: "YTNG"
  },
  THI: {
    iata: "THI",
    name: "Tichitt Airport",
    city: "Tichitt",
    countryId: "MR",
    timeZoneRegionName: "Africa/Nouakchott",
    latitude: 18.45,
    longitude: -9.5,
    icao: "GQNC"
  },
  THK: {
    iata: "THK",
    name: "Thakhek Airport",
    city: "Thakhek",
    countryId: "LA",
    timeZoneRegionName: "Asia/Vientiane",
    latitude: 17.4,
    longitude: 104.816667,
    icao: "VLTK"
  },
  THL: {
    iata: "THL",
    name: "Tachilek Airport",
    city: "Tachilek",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 20.48443,
    longitude: 99.934535,
    icao: "VYTL"
  },
  THN: {
    iata: "THN",
    name: "Trollhattan Airport",
    city: "Trollhattan",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 58.266667,
    longitude: 12.3,
    icao: "ESGT"
  },
  THO: {
    iata: "THO",
    name: "Thorshofn Airport",
    city: "Thorshofn",
    countryId: "IS",
    timeZoneRegionName: "Atlantic/Reykjavik",
    latitude: 66.220705,
    longitude: -15.332381,
    icao: "BITN"
  },
  THP: {
    iata: "THP",
    name: "Hot Springs Airport",
    city: "Thermopolis",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 43.65,
    longitude: -108.216667,
    icao: "KTHP"
  },
  THR: {
    iata: "THR",
    name: "Mehrabad International Airport",
    city: "Tehran",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 35.691534,
    longitude: 51.321868,
    icao: "OIII"
  },
  THS: {
    iata: "THS",
    name: "Sukhothai Airport",
    city: "Sukhothai",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 17.223056,
    longitude: 99.822222,
    icao: "VTPO"
  },
  THT: {
    iata: "THT",
    name: "Tamchakett Airport",
    city: "Tamchakett",
    countryId: "MR",
    timeZoneRegionName: "Africa/Nouakchott",
    latitude: 17.233333,
    longitude: -10.816667,
    icao: "GQNT"
  },
  THU: {
    iata: "THU",
    name: "Thule Air Base",
    city: "Pituffik",
    countryId: "GL",
    timeZoneRegionName: "America/Thule",
    latitude: 76.533333,
    longitude: -68.7,
    icao: "BGTL"
  },
  THV: {
    iata: "THV",
    name: "York Airport",
    city: "York",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.918128,
    longitude: -76.873739,
    icao: "KTHV"
  },
  THX: {
    iata: "THX",
    name: "Turukhansk Airport",
    city: "Turukhansk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Krasnoyarsk",
    latitude: 65.797222,
    longitude: 87.935278,
    icao: "UOTT"
  },
  THZ: {
    iata: "THZ",
    name: "Tahoua Airport",
    city: "Tahoua",
    countryId: "NE",
    timeZoneRegionName: "Africa/Niamey",
    latitude: 14.872778,
    longitude: 5.263889,
    icao: "DRRT"
  },
  TIA: {
    iata: "TIA",
    name: "Tirana International Airport",
    city: "Tirana",
    countryId: "AL",
    timeZoneRegionName: "Europe/Tirane",
    latitude: 41.419133,
    longitude: 19.71328,
    icao: "LATI"
  },
  TIB: {
    iata: "TIB",
    name: "Tibu Airport",
    city: "Tibu",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 8.633333,
    longitude: -72.733333,
    icao: "SKTB"
  },
  TID: {
    iata: "TID",
    name: "Bouchekif Airport",
    city: "Tiaret",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 35.343274,
    longitude: 1.46946,
    icao: "DAOB"
  },
  TIE: {
    iata: "TIE",
    name: "Tippi Airport",
    city: "Tippi",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 7.201111,
    longitude: 35.415278,
    icao: "HATP"
  },
  TIF: {
    iata: "TIF",
    name: "Taif Airport",
    city: "Taif",
    countryId: "SA",
    timeZoneRegionName: "Asia/Riyadh",
    latitude: 21.480364,
    longitude: 40.552684,
    icao: "OETF"
  },
  TIH: {
    iata: "TIH",
    name: "Tikehau Atoll Airport",
    city: "Tikehau Atoll",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -15.118639,
    longitude: -148.233789,
    icao: "NTGC"
  },
  TII: {
    iata: "TII",
    name: "Tereen Airport",
    city: "Tarin Kot",
    countryId: "AF",
    timeZoneRegionName: "Asia/Kabul",
    latitude: 32.866667,
    longitude: 65.633333,
    icao: "OATN"
  },
  TIJ: {
    iata: "TIJ",
    name: "Tijuana Airport",
    city: "Tijuana",
    countryId: "MX",
    timeZoneRegionName: "America/Tijuana",
    latitude: 32.544303,
    longitude: -116.975924,
    icao: "MMTJ"
  },
  TIK: {
    iata: "TIK",
    name: "Tinker Air Force Base",
    city: "Oklahoma City",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.416667,
    longitude: -97.383333,
    icao: "KTIK"
  },
  TIM: {
    iata: "TIM",
    name: "Timika Airport",
    city: "Tembagapura",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jayapura",
    latitude: -4.525666,
    longitude: 136.887486,
    icao: "WABP"
  },
  TIN: {
    iata: "TIN",
    name: "Tindouf Airport",
    city: "Tindouf",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 27.701163,
    longitude: -8.163246,
    icao: "DAOF"
  },
  TIP: {
    iata: "TIP",
    name: "Tripoli International Airport",
    city: "Tripoli",
    countryId: "LY",
    timeZoneRegionName: "Africa/Tripoli",
    latitude: 32.66989,
    longitude: 13.144279,
    icao: "HLLT"
  },
  TIQ: {
    iata: "TIQ",
    name: "Tinian International Airport",
    city: "Tinian",
    countryId: "MP",
    timeZoneRegionName: "Pacific/Saipan",
    latitude: 14.994319,
    longitude: 145.626344,
    icao: "PGWT"
  },
  TIR: {
    iata: "TIR",
    name: "Tirupati Airport",
    city: "Tirupati",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 13.635721,
    longitude: 79.542929,
    icao: "VOTP"
  },
  TIS: {
    iata: "TIS",
    name: "Thursday Island Airport",
    city: "Thursday Island",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -10.5,
    longitude: 142.05,
    icao: "YTUD"
  },
  TIU: {
    iata: "TIU",
    name: "Timaru Airport",
    city: "Timaru",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -44.303446,
    longitude: 171.226325,
    icao: "NZTU"
  },
  TIV: {
    iata: "TIV",
    name: "Tivat Airport",
    city: "Tivat",
    countryId: "ME",
    timeZoneRegionName: "Europe/Podgorica",
    latitude: 42.403611,
    longitude: 18.725556,
    icao: "LYTV"
  },
  TIW: {
    iata: "TIW",
    name: "Tacoma Narrows Airport",
    city: "Tacoma",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 47.267632,
    longitude: -122.576477,
    icao: "KTIW"
  },
  TIX: {
    iata: "TIX",
    name: "Space Center Executive Airport",
    city: "Titusville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 28.512222,
    longitude: -80.799444,
    icao: "KTIX"
  },
  TIY: {
    iata: "TIY",
    name: "Tidjikja Airport",
    city: "Tidjikja",
    countryId: "MR",
    timeZoneRegionName: "Africa/Nouakchott",
    latitude: 18.566667,
    longitude: -11.416667,
    icao: "GQND"
  },
  TIZ: {
    iata: "TIZ",
    name: "Tari Airport",
    city: "Tari",
    countryId: "PG",
    timeZoneRegionName: "Pacific/Port_Moresby",
    latitude: -5.845,
    longitude: 142.948,
    icao: "AYTA"
  },
  TJA: {
    iata: "TJA",
    name: "Capitan Oriel Lea Plaza Airport",
    city: "Tarija",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -21.548009,
    longitude: -64.709102,
    icao: "SLTJ"
  },
  TJG: {
    iata: "TJG",
    name: "Warukin Airport",
    city: "Tanjung",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -2.21656,
    longitude: 115.435997,
    icao: "WAON"
  },
  TJH: {
    iata: "TJH",
    name: "Tajima Airport",
    city: "Toyooka",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 35.51366,
    longitude: 134.787674,
    icao: "RJBT"
  },
  TJK: {
    iata: "TJK",
    name: "Tokat Airport",
    city: "Tokat",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 40.30402,
    longitude: 36.363533,
    icao: "LTAW"
  },
  TJL: {
    iata: "TJL",
    name: "Tres Lagoas Airport",
    city: "Tres Lagoas",
    countryId: "BR",
    timeZoneRegionName: "America/Campo_Grande",
    latitude: -20.753642,
    longitude: -51.681253,
    icao: "SSTL"
  },
  TJM: {
    iata: "TJM",
    name: "Roshchino International Airport",
    city: "Tyumen",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yekaterinburg",
    latitude: 57.181826,
    longitude: 65.350246,
    icao: "USTR"
  },
  TJN: {
    iata: "TJN",
    name: "Takume Airport",
    city: "Takume",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -15.850556,
    longitude: -142.266944,
    icao: "NTKM"
  },
  TJQ: {
    iata: "TJQ",
    name: "Bulutumbang Airport",
    city: "Tanjung Pandan",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: -2.74572,
    longitude: 107.754997,
    icao: "WIKD"
  },
  TJS: {
    iata: "TJS",
    name: "Tanjung Harapan Airport",
    city: "Tanjung Selor",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: 2.836389,
    longitude: 117.373611,
    icao: "WALG"
  },
  TJU: {
    iata: "TJU",
    name: "Kulyab Airport",
    city: "Kulyab",
    countryId: "TJ",
    timeZoneRegionName: "Asia/Dushanbe",
    latitude: 37.988335,
    longitude: 69.80666,
    icao: "UTDK"
  },
  TKA: {
    iata: "TKA",
    name: "Talkeetna Airport",
    city: "Talkeetna",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 62.322222,
    longitude: -150.09,
    icao: "PATK"
  },
  TKC: {
    iata: "TKC",
    name: "Tiko Airport",
    city: "Tiko",
    countryId: "CM",
    timeZoneRegionName: "Africa/Douala",
    latitude: 4.116667,
    longitude: 9.333333,
    icao: "FKKC"
  },
  TKD: {
    iata: "TKD",
    name: "Takoradi Airport",
    city: "Takoradi",
    countryId: "GH",
    timeZoneRegionName: "Africa/Accra",
    latitude: 4.89606,
    longitude: -1.77476,
    icao: "DGTK"
  },
  TKF: {
    iata: "TKF",
    name: "Truckee Tahoe Airport",
    city: "Truckee",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 39.317892,
    longitude: -120.140502,
    icao: "KTRK"
  },
  TKG: {
    iata: "TKG",
    name: "Radin Inten II Airport",
    city: "Bandar Lampung",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: -5.242783,
    longitude: 105.175795,
    icao: "WICT"
  },
  TKH: {
    iata: "TKH",
    name: "Takhli Airport",
    city: "Takhli",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 15.263263,
    longitude: 100.312602,
    icao: "VTPI"
  },
  TKJ: {
    iata: "TKJ",
    name: "Tok Airport",
    city: "Tok",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 63.303333,
    longitude: -143.001111,
    icao: "PATJ"
  },
  TKK: {
    iata: "TKK",
    name: "Chuuk International Airport",
    city: "Truk, Caroline Islands",
    countryId: "FM",
    timeZoneRegionName: "Pacific/Chuuk",
    latitude: 7.457446,
    longitude: 151.842005,
    icao: "PTKK"
  },
  TKM: {
    iata: "TKM",
    name: "Taksimo International Airport",
    city: "Taksimo",
    countryId: "RU",
    timeZoneRegionName: "Asia/Irkutsk",
    latitude: 56.361667,
    longitude: 114.93,
    icao: ""
  },
  TKN: {
    iata: "TKN",
    name: "Tokunoshima Airport",
    city: "Tokunoshima",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 27.833333,
    longitude: 128.883333,
    icao: "RJKN"
  },
  TKP: {
    iata: "TKP",
    name: "Takapoto Airport",
    city: "Takapoto",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -14.7095,
    longitude: -145.246002,
    icao: "NTGT"
  },
  TKQ: {
    iata: "TKQ",
    name: "Kigoma Airport",
    city: "Kigoma",
    countryId: "TZ",
    timeZoneRegionName: "Africa/Dar_es_Salaam",
    latitude: -4.885,
    longitude: 29.67,
    icao: "HTKA"
  },
  TKS: {
    iata: "TKS",
    name: "Tokushima Awaodori Airport",
    city: "Tokushima",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 34.139024,
    longitude: 134.594826,
    icao: "RJOS"
  },
  TKT: {
    iata: "TKT",
    name: "Tak Airport",
    city: "Tak",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 16.878333,
    longitude: 99.152222,
    icao: "VTPT"
  },
  TKU: {
    iata: "TKU",
    name: "Turku Airport",
    city: "Turku",
    countryId: "FI",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 60.512348,
    longitude: 22.272771,
    icao: "EFTU"
  },
  TKV: {
    iata: "TKV",
    name: "Tatakoto Airport",
    city: "Tatakoto",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -17.283333,
    longitude: -138.333333,
    icao: ""
  },
  TKX: {
    iata: "TKX",
    name: "Takaroa Airport",
    city: "Takaroa",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -14.457749,
    longitude: -145.026392,
    icao: "NTKR"
  },
  TKZ: {
    iata: "TKZ",
    name: "Tokoroa Airfield",
    city: "Tokoroa",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -38.238476,
    longitude: 175.89549,
    icao: "NZTO"
  },
  TLA: {
    iata: "TLA",
    name: "Teller Airport",
    city: "Teller",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 65.240389,
    longitude: -166.339389,
    icao: "PATE"
  },
  TLC: {
    iata: "TLC",
    name: "Toluca International Airport",
    city: "Toluca",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 19.336622,
    longitude: -99.565748,
    icao: "MMTO"
  },
  TLD: {
    iata: "TLD",
    name: "Limpopo Valley Airfield",
    city: "Tuli Block",
    countryId: "BW",
    timeZoneRegionName: "Africa/Gaborone",
    latitude: -22.183333,
    longitude: 29.116667,
    icao: "FBTL"
  },
  TLE: {
    iata: "TLE",
    name: "Toliara Airport",
    city: "Toliara",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -23.38882,
    longitude: 43.723888,
    icao: "FMST"
  },
  TLH: {
    iata: "TLH",
    name: "Tallahassee International Airport",
    city: "Tallahassee",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 30.395783,
    longitude: -84.34444,
    icao: "KTLH"
  },
  TLI: {
    iata: "TLI",
    name: "Sultan Bantilan Airport",
    city: "Toli Toli",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: 1.122492,
    longitude: 120.793618,
    icao: "WAMI"
  },
  TLK: {
    iata: "TLK",
    name: "Talakan Airport",
    city: "Talakan",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yakutsk",
    latitude: 59.876389,
    longitude: 111.044444,
    icao: ""
  },
  TLL: {
    iata: "TLL",
    name: "Tallinn Airport",
    city: "Tallinn",
    countryId: "EE",
    timeZoneRegionName: "Europe/Tallinn",
    latitude: 59.416622,
    longitude: 24.798703,
    icao: "EETN"
  },
  TLM: {
    iata: "TLM",
    name: "Zenata Airport",
    city: "Tlemcen",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 35.016667,
    longitude: -1.45,
    icao: "DAON"
  },
  TLN: {
    iata: "TLN",
    name: "Hyeres Airport",
    city: "Toulon",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 43.093489,
    longitude: 6.159303,
    icao: "LFTH"
  },
  TLQ: {
    iata: "TLQ",
    name: "Turpan Jiaohe Airport",
    city: "Turpan",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 43.019961,
    longitude: 89.074545,
    icao: "ZWTP"
  },
  TLR: {
    iata: "TLR",
    name: "Mefford Field",
    city: "Tulare",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 36.156302,
    longitude: -119.326001,
    icao: "KTLR"
  },
  TLS: {
    iata: "TLS",
    name: "Toulouse-Blagnac Airport",
    city: "Toulouse",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 43.630071,
    longitude: 1.374321,
    icao: "LFBO"
  },
  TLU: {
    iata: "TLU",
    name: "Golfo de Morrosquillo Airport",
    city: "Tolu",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 9.509446,
    longitude: -75.585763,
    icao: "SKTL"
  },
  TLV: {
    iata: "TLV",
    name: "Ben Gurion International Airport",
    city: "Tel Aviv-Yafo",
    countryId: "IL",
    timeZoneRegionName: "Asia/Jerusalem",
    latitude: 32.000454,
    longitude: 34.870741,
    icao: "LLBG"
  },
  TLX: {
    iata: "TLX",
    name: "Talca Airport",
    city: "Talca",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -35.466667,
    longitude: -71.666667,
    icao: "SCTL"
  },
  TLY: {
    iata: "TLY",
    name: "Plastun Airport",
    city: "Plastun",
    countryId: "RU",
    timeZoneRegionName: "Asia/Vladivostok",
    latitude: 44.81465,
    longitude: 136.289279,
    icao: "UHWP"
  },
  TMA: {
    iata: "TMA",
    name: "Henry Tift Myers Airport",
    city: "Tifton",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 31.433333,
    longitude: -83.483333,
    icao: "KTMA"
  },
  TMB: {
    iata: "TMB",
    name: "Kendall-Tamiami Executive Airport",
    city: "Miami",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 25.65,
    longitude: -80.433333,
    icao: "KTMB"
  },
  TMC: {
    iata: "TMC",
    name: "Waikabubak Tambolaka Airport",
    city: "Tambolaka",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -9.40972,
    longitude: 119.244003,
    icao: "WATK"
  },
  TMD: {
    iata: "TMD",
    name: "Timbedra Airport",
    city: "Timbedra",
    countryId: "MR",
    timeZoneRegionName: "Africa/Nouakchott",
    latitude: 16.236667,
    longitude: -8.154167,
    icao: "GQNH"
  },
  TME: {
    iata: "TME",
    name: "Gabriel Vargas Santos Airport",
    city: "Tame",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 6.454619,
    longitude: -71.752051,
    icao: "SKTM"
  },
  TMF: {
    iata: "TMF",
    name: "Thimarafushi Airport",
    city: "Thimarafushi",
    countryId: "MV",
    timeZoneRegionName: "Indian/Maldives",
    latitude: 2.211622,
    longitude: 73.149312,
    icao: "VRNT"
  },
  TMH: {
    iata: "TMH",
    name: "Tanahmerah Airport",
    city: "Tanahmerah",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jayapura",
    latitude: -6.096228,
    longitude: 140.305916,
    icao: "WAKT"
  },
  TMI: {
    iata: "TMI",
    name: "Tumling Tar Airport",
    city: "Tumling Tar",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 27.3,
    longitude: 87.2,
    icao: "VNTR"
  },
  TMJ: {
    iata: "TMJ",
    name: "Termez Airport",
    city: "Termez",
    countryId: "UZ",
    timeZoneRegionName: "Asia/Tashkent",
    latitude: 37.280501,
    longitude: 67.318954,
    icao: "UTST"
  },
  TML: {
    iata: "TML",
    name: "Tamale Airport",
    city: "Tamale",
    countryId: "GH",
    timeZoneRegionName: "Africa/Accra",
    latitude: 9.409979,
    longitude: -0.876603,
    icao: "DGLE"
  },
  TMM: {
    iata: "TMM",
    name: "Tamatave Airport",
    city: "Tamatave",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -18.11,
    longitude: 49.392222,
    icao: "FMMT"
  },
  TMN: {
    iata: "TMN",
    name: "Tamana Airport",
    city: "Tamana Island",
    countryId: "KI",
    timeZoneRegionName: "Pacific/Tarawa",
    latitude: -2.4858,
    longitude: 175.9681,
    icao: "NGTM"
  },
  TMO: {
    iata: "TMO",
    name: "Tumeremo Airport",
    city: "Tumeremo",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 7.3,
    longitude: -61.5,
    icao: "SVTM"
  },
  TMP: {
    iata: "TMP",
    name: "Tampere-Pirkkala Airport",
    city: "Tampere",
    countryId: "FI",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 61.420449,
    longitude: 23.617564,
    icao: "EFTP"
  },
  TMR: {
    iata: "TMR",
    name: "Aguenar Airport",
    city: "Tamanrasset",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 22.813283,
    longitude: 5.44912,
    icao: "DAAT"
  },
  TMS: {
    iata: "TMS",
    name: "Sao Tome Island Airport",
    city: "Sao Tome Island",
    countryId: "ST",
    timeZoneRegionName: "Africa/Sao_Tome",
    latitude: 0.378333,
    longitude: 6.725,
    icao: "FPST"
  },
  TMT: {
    iata: "TMT",
    name: "Trombetas Airport",
    city: "Trombetas",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -1.4896,
    longitude: -56.396801,
    icao: "SBTB"
  },
  TMU: {
    iata: "TMU",
    name: "Tambor Airport",
    city: "Tambor",
    countryId: "CR",
    timeZoneRegionName: "America/Costa_Rica",
    latitude: 9.739357,
    longitude: -85.016222,
    icao: "MRTR"
  },
  TMW: {
    iata: "TMW",
    name: "Tamworth Airport",
    city: "Tamworth",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -31.0845,
    longitude: 150.848496,
    icao: "YSTW"
  },
  TMX: {
    iata: "TMX",
    name: "Timimoun Airport",
    city: "Timimoun",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 29.24174,
    longitude: 0.284086,
    icao: "DAUT"
  },
  TMZ: {
    iata: "TMZ",
    name: "Thames Aerodrome",
    city: "Thames",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -37.16259,
    longitude: 175.553626,
    icao: "NZTH"
  },
  TNA: {
    iata: "TNA",
    name: "Jinan Yaoqiang International Airport",
    city: "Jinan",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 36.857689,
    longitude: 117.206881,
    icao: "ZSJN"
  },
  TNC: {
    iata: "TNC",
    name: "Tin City Air Force Station",
    city: "Tin City",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 65.563889,
    longitude: -167.918889,
    icao: "PATC"
  },
  TNE: {
    iata: "TNE",
    name: "New Tanegashima Airport",
    city: "Nakatane",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 30.604837,
    longitude: 130.9929,
    icao: "RJFG"
  },
  TNF: {
    iata: "TNF",
    name: "Toussus-le-Noble Airport",
    city: "Toussus-le-Noble",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 48.750833,
    longitude: 2.113056,
    icao: "LFPN"
  },
  TNG: {
    iata: "TNG",
    name: "Tangier Ibn Battouta Airport",
    city: "Tangier",
    countryId: "MA",
    timeZoneRegionName: "Africa/Casablanca",
    latitude: 35.726286,
    longitude: -5.912898,
    icao: "GMTT"
  },
  TNH: {
    iata: "TNH",
    name: "Tonghua Sanyuanpu Airport",
    city: "Sanyuanpu",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 42.253889,
    longitude: 125.703889,
    icao: "ZYTN"
  },
  TNI: {
    iata: "TNI",
    name: "Satna Airport",
    city: "Satna",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 24.564325,
    longitude: 80.85181,
    icao: "VIST"
  },
  TNJ: {
    iata: "TNJ",
    name: "Raja Haji Fisabilillah Airport",
    city: "Tanjung Pinang",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: 0.922683,
    longitude: 104.531998,
    icao: "WIKN"
  },
  TNK: {
    iata: "TNK",
    name: "Tununak Airport",
    city: "Tununak",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 60.570833,
    longitude: -165.266667,
    icao: ""
  },
  TNM: {
    iata: "TNM",
    name: "Teniente R. Marsh Martin Airport",
    city: "King George Island",
    countryId: "AQ",
    timeZoneRegionName: "Antarctica/Palmer",
    latitude: -62.190556,
    longitude: -58.986389,
    icao: "SCRM"
  },
  TNN: {
    iata: "TNN",
    name: "Tainan Airport",
    city: "Tainan",
    countryId: "TW",
    timeZoneRegionName: "Asia/Taipei",
    latitude: 22.948705,
    longitude: 120.215712,
    icao: "RCNN"
  },
  TNO: {
    iata: "TNO",
    name: "Tamarindo Airport",
    city: "Tamarindo",
    countryId: "CR",
    timeZoneRegionName: "America/Costa_Rica",
    latitude: 10.31587,
    longitude: -85.812226,
    icao: "MRTM"
  },
  TNP: {
    iata: "TNP",
    name: "Twentynine Palms Airport",
    city: "Twentynine Palms",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 34.118889,
    longitude: -115.935,
    icao: "KNXP"
  },
  TNQ: {
    iata: "TNQ",
    name: "Teraina Washington Island Airport",
    city: "Teraina",
    countryId: "KI",
    timeZoneRegionName: "Pacific/Kiritimati",
    latitude: 4.7,
    longitude: -160.333333,
    icao: ""
  },
  TNR: {
    iata: "TNR",
    name: "Antananarivo Ivato International Airport",
    city: "Antananarivo",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -18.799632,
    longitude: 47.475028,
    icao: "FMMI"
  },
  TNS: {
    iata: "TNS",
    name: "Cantung Airport",
    city: "Tungsten",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 61.956902,
    longitude: -128.203003,
    icao: "CBX5"
  },
  TNT: {
    iata: "TNT",
    name: "Dade Collier Training and Transition Airport",
    city: "Miami",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 25.86081,
    longitude: -80.895721,
    icao: "KTNT"
  },
  TNU: {
    iata: "TNU",
    name: "Newton Municipal Airport",
    city: "Newton",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.7,
    longitude: -93.05,
    icao: "KTNU"
  },
  TNV: {
    iata: "TNV",
    name: "Tabuaeran Island Airport",
    city: "Tabuaeran",
    countryId: "KI",
    timeZoneRegionName: "Pacific/Kiritimati",
    latitude: 3.833333,
    longitude: -159.35,
    icao: "PLFA"
  },
  TNW: {
    iata: "TNW",
    name: "Jumandy Airport",
    city: "Tena",
    countryId: "EC",
    timeZoneRegionName: "America/Guayaquil",
    latitude: -1.06248,
    longitude: -77.573011,
    icao: "SEJD"
  },
  TNX: {
    iata: "TNX",
    name: "Stung Treng Airport",
    city: "Stung Treng",
    countryId: "KH",
    timeZoneRegionName: "Asia/Phnom_Penh",
    latitude: 13.533333,
    longitude: 106.033333,
    icao: "VDST"
  },
  TOA: {
    iata: "TOA",
    name: "Zamperini Field",
    city: "Torrance",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 33.801676,
    longitude: -118.341548,
    icao: "KTOA"
  },
  TOC: {
    iata: "TOC",
    name: "R.G. LeTourneau Field",
    city: "Toccoa",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 34.5938,
    longitude: -83.295799,
    icao: "KTOC"
  },
  TOD: {
    iata: "TOD",
    name: "Tioman Airport",
    city: "Tioman",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 2.818021,
    longitude: 104.159803,
    icao: "WMBT"
  },
  TOE: {
    iata: "TOE",
    name: "Tozeur Nefta International Airport",
    city: "Tozeur",
    countryId: "TN",
    timeZoneRegionName: "Africa/Tunis",
    latitude: 33.939701,
    longitude: 8.11056,
    icao: "DTTZ"
  },
  TOF: {
    iata: "TOF",
    name: "Tomsk Bogashevo Airport",
    city: "Tomsk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Tomsk",
    latitude: 56.380299,
    longitude: 85.208298,
    icao: "UNTT"
  },
  TOG: {
    iata: "TOG",
    name: "Togiak Village Airport",
    city: "Togiak Village",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 59.05292,
    longitude: -160.397728,
    icao: "PATG"
  },
  TOI: {
    iata: "TOI",
    name: "Troy Municipal Airport",
    city: "Troy",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 31.8,
    longitude: -85.966667,
    icao: "KTOI"
  },
  TOJ: {
    iata: "TOJ",
    name: "Torrejon Air Force Base",
    city: "Madrid",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 40.4967,
    longitude: -3.44587,
    icao: "LETO"
  },
  TOL: {
    iata: "TOL",
    name: "Toledo Express Airport",
    city: "Toledo",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.592497,
    longitude: -83.806898,
    icao: "KTOL"
  },
  TOM: {
    iata: "TOM",
    name: "Tombouctou Airport",
    city: "Tombouctou",
    countryId: "ML",
    timeZoneRegionName: "Africa/Bamako",
    latitude: 16.732222,
    longitude: -3.005278,
    icao: "GATB"
  },
  TOO: {
    iata: "TOO",
    name: "San Vito Airport",
    city: "San Vito",
    countryId: "CR",
    timeZoneRegionName: "America/Costa_Rica",
    latitude: 8.833333,
    longitude: -82.966667,
    icao: "MRSV"
  },
  TOP: {
    iata: "TOP",
    name: "Philip Billard Municipal Airport",
    city: "Topeka",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 39.069722,
    longitude: -95.6225,
    icao: "KTOP"
  },
  TOQ: {
    iata: "TOQ",
    name: "Barriles Airport",
    city: "Tocopilla",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -22.136111,
    longitude: -70.061389,
    icao: "SCBE"
  },
  TOR: {
    iata: "TOR",
    name: "Torrington Municipal Airport",
    city: "Torrington",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 42.066667,
    longitude: -104.183333,
    icao: "KTOR"
  },
  TOS: {
    iata: "TOS",
    name: "Tromso/Langnes Airport",
    city: "Tromso",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 69.679835,
    longitude: 18.907343,
    icao: "ENTC"
  },
  TOU: {
    iata: "TOU",
    name: "Touho Airport",
    city: "Touho",
    countryId: "NC",
    timeZoneRegionName: "Pacific/Noumea",
    latitude: -20.8,
    longitude: 165.25,
    icao: "NWWU"
  },
  TOW: {
    iata: "TOW",
    name: "Luis dal Canalle Filho Airport",
    city: "Toledo",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -24.6863,
    longitude: -53.697497,
    icao: "SBTD"
  },
  TOY: {
    iata: "TOY",
    name: "Toyama Airport",
    city: "Toyama",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 36.642447,
    longitude: 137.189456,
    icao: "RJNT"
  },
  TOZ: {
    iata: "TOZ",
    name: "Mahana Airport",
    city: "Touba",
    countryId: "CI",
    timeZoneRegionName: "Africa/Abidjan",
    latitude: 8.29326,
    longitude: -7.673662,
    icao: "DITM"
  },
  TPA: {
    iata: "TPA",
    name: "Tampa International Airport",
    city: "Tampa",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 27.979869,
    longitude: -82.535415,
    icao: "KTPA"
  },
  TPC: {
    iata: "TPC",
    name: "Tarapoa Airport",
    city: "Tarapoa",
    countryId: "EC",
    timeZoneRegionName: "America/Guayaquil",
    latitude: -1.227777,
    longitude: -76.337777,
    icao: "SETR"
  },
  TPE: {
    iata: "TPE",
    name: "Taiwan Taoyuan International Airport",
    city: "Taipei",
    countryId: "TW",
    timeZoneRegionName: "Asia/Taipei",
    latitude: 25.075512,
    longitude: 121.23248,
    icao: "RCTP"
  },
  TPF: {
    iata: "TPF",
    name: "Peter O. Knight Airport",
    city: "Tampa",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 27.915572,
    longitude: -82.446688,
    icao: "KTPF"
  },
  TPG: {
    iata: "TPG",
    name: "Taiping Airport",
    city: "Taiping",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 4.85,
    longitude: 100.733333,
    icao: "WMBI"
  },
  TPH: {
    iata: "TPH",
    name: "Tonopah Airport",
    city: "Tonopah",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 38.066667,
    longitude: -117.233333,
    icao: "KTPH"
  },
  TPL: {
    iata: "TPL",
    name: "Draughon-Miller Airport",
    city: "Temple",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 31.150278,
    longitude: -97.409167,
    icao: "KTPL"
  },
  TPN: {
    iata: "TPN",
    name: "Tiputini Airport",
    city: "Tiputini",
    countryId: "EC",
    timeZoneRegionName: "America/Guayaquil",
    latitude: -0.766667,
    longitude: -75.533333,
    icao: "SETI"
  },
  TPP: {
    iata: "TPP",
    name: "Cad. FAP Guillermo del Castillo Paredes Airport",
    city: "Tarapoto",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -6.512208,
    longitude: -76.369621,
    icao: "SPST"
  },
  TPQ: {
    iata: "TPQ",
    name: "Amado Nervo Airport",
    city: "Tepic",
    countryId: "MX",
    timeZoneRegionName: "America/Mazatlan",
    latitude: 21.419445,
    longitude: -104.842575,
    icao: "MMEP"
  },
  TPR: {
    iata: "TPR",
    name: "Tom Price Airport",
    city: "Tom Price",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -22.75,
    longitude: 117.666667,
    icao: "YTMP"
  },
  TPS: {
    iata: "TPS",
    name: "Trapani-Birgi Airport",
    city: "Trapani",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 37.901385,
    longitude: 12.495865,
    icao: "LICT"
  },
  TQA: {
    iata: "TQA",
    name: "Tasiusaq Heliport (Upernavik)",
    city: "Tasiusaq",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 73.373056,
    longitude: -56.060278,
    icao: "BGTA"
  },
  TQI: {
    iata: "TQI",
    name: "Tiniteqilaaq Heliport",
    city: "Tiniteqilaaq",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 65.892015,
    longitude: -37.783347,
    icao: "BGTN"
  },
  TQL: {
    iata: "TQL",
    name: "Tarko-Sale Airport",
    city: "Tarko-Sale",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yekaterinburg",
    latitude: 64.92203,
    longitude: 77.790755,
    icao: "USDS"
  },
  TQO: {
    iata: "TQO",
    name: "Tulum International Airport",
    city: "Tulum",
    countryId: "MX",
    timeZoneRegionName: "America/Cancun",
    latitude: 20.2159,
    longitude: -87.4517,
    icao: "MMTL"
  },
  TQP: {
    iata: "TQP",
    name: "Trepell Airport",
    city: "Trepell",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -21.839603,
    longitude: 140.893762,
    icao: "YTEE"
  },
  TQS: {
    iata: "TQS",
    name: "Tres Esquinas Airport",
    city: "Tres Esquinas",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 0.733333,
    longitude: -75.233333,
    icao: "SKTQ"
  },
  TRA: {
    iata: "TRA",
    name: "Tarama Airport",
    city: "Taramajima",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 24.653795,
    longitude: 124.676793,
    icao: "RORT"
  },
  TRB: {
    iata: "TRB",
    name: "Gonzalo Airport",
    city: "Turbo",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 8.078333,
    longitude: -76.748056,
    icao: "SKTU"
  },
  TRC: {
    iata: "TRC",
    name: "Francisco Sarabia International Airport",
    city: "Torreon",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 25.563066,
    longitude: -103.398741,
    icao: "MMTC"
  },
  TRD: {
    iata: "TRD",
    name: "Trondheim Airport Vaernes",
    city: "Trondheim",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 63.454285,
    longitude: 10.917863,
    icao: "ENVA"
  },
  TRE: {
    iata: "TRE",
    name: "Tiree Airport",
    city: "Tiree, Inner Hebrides",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 56.500556,
    longitude: -6.871389,
    icao: "EGPU"
  },
  TRF: {
    iata: "TRF",
    name: "Torp Sandefjord Airport",
    city: "Sandefjord",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 59.178087,
    longitude: 10.251807,
    icao: "ENTO"
  },
  TRG: {
    iata: "TRG",
    name: "Tauranga City Airport",
    city: "Tauranga",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -37.671902,
    longitude: 176.195999,
    icao: "NZTG"
  },
  TRI: {
    iata: "TRI",
    name: "Tri-Cities Regional Airport",
    city: "Bristol, VA/Johnson City/Kingsport",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 36.481109,
    longitude: -82.407852,
    icao: "KTRI"
  },
  TRK: {
    iata: "TRK",
    name: "Juwata International Airport",
    city: "Tarakan",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: 3.326377,
    longitude: 117.568603,
    icao: "WALR"
  },
  TRL: {
    iata: "TRL",
    name: "Terrell Municipal Airport",
    city: "Terrell",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.709202,
    longitude: -96.267403,
    icao: "KTRL"
  },
  TRM: {
    iata: "TRM",
    name: "Jacqueline Cochran Regional Airport",
    city: "Thermal",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 33.639217,
    longitude: -116.15863,
    icao: "KTRM"
  },
  TRN: {
    iata: "TRN",
    name: "Turin Airport",
    city: "Turin",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 45.191455,
    longitude: 7.643049,
    icao: "LIMF"
  },
  TRO: {
    iata: "TRO",
    name: "Taree Airport",
    city: "Taree",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -31.890273,
    longitude: 152.508964,
    icao: "YTRE"
  },
  TRQ: {
    iata: "TRQ",
    name: "Tarauaca Airport",
    city: "Tarauaca",
    countryId: "BR",
    timeZoneRegionName: "America/Rio_Branco",
    latitude: -8.1,
    longitude: -70.75,
    icao: "SBTK"
  },
  TRR: {
    iata: "TRR",
    name: "China Bay Airport",
    city: "Trincomalee",
    countryId: "LK",
    timeZoneRegionName: "Asia/Colombo",
    latitude: 8.538984,
    longitude: 81.181889,
    icao: "VCCT"
  },
  TRS: {
    iata: "TRS",
    name: "Trieste - Friuli Venezia Giulia Airport",
    city: "Trieste",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 45.820781,
    longitude: 13.485678,
    icao: "LIPQ"
  },
  TRT: {
    iata: "TRT",
    name: "Toraja Airport",
    city: "Mengkendek",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -3.1856,
    longitude: 119.9178,
    icao: ""
  },
  TRU: {
    iata: "TRU",
    name: "Trujillo Airport",
    city: "Trujillo",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -8.09,
    longitude: -79.115,
    icao: "SPRU"
  },
  TRV: {
    iata: "TRV",
    name: "Trivandrum International Airport",
    city: "Thiruvananthapuram",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 8.476126,
    longitude: 76.91907,
    icao: "VOTV"
  },
  TRW: {
    iata: "TRW",
    name: "Bonriki Airport",
    city: "Tarawa",
    countryId: "KI",
    timeZoneRegionName: "Pacific/Tarawa",
    latitude: 1.38164,
    longitude: 173.147003,
    icao: "NGTA"
  },
  TRX: {
    iata: "TRX",
    name: "Trenton Memorial Airport",
    city: "Trenton",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 40.083333,
    longitude: -93.616667,
    icao: "KTRX"
  },
  TRY: {
    iata: "TRY",
    name: "Tororo Airport",
    city: "Tororo",
    countryId: "UG",
    timeZoneRegionName: "Africa/Kampala",
    latitude: 0.7,
    longitude: 34.183333,
    icao: "HUTO"
  },
  TRZ: {
    iata: "TRZ",
    name: "Tiruchirapalli International Airport",
    city: "Tiruchirappalli",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 10.762168,
    longitude: 78.707241,
    icao: "VOTR"
  },
  TSA: {
    iata: "TSA",
    name: "Taipei Songshan Airport",
    city: "Taipei",
    countryId: "TW",
    timeZoneRegionName: "Asia/Taipei",
    latitude: 25.062789,
    longitude: 121.551924,
    icao: "RCSS"
  },
  TSB: {
    iata: "TSB",
    name: "Tsumeb Airport",
    city: "Tsumeb",
    countryId: "NA",
    timeZoneRegionName: "Africa/Windhoek",
    latitude: -19.266667,
    longitude: 17.733333,
    icao: "FYTM"
  },
  TSC: {
    iata: "TSC",
    name: "Taisha Airport",
    city: "Taisha",
    countryId: "EC",
    timeZoneRegionName: "America/Guayaquil",
    latitude: -2.383333,
    longitude: -77.5,
    icao: "SETH"
  },
  TSF: {
    iata: "TSF",
    name: "Treviso Airport",
    city: "Venice",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 45.655113,
    longitude: 12.204444,
    icao: "LIPH"
  },
  TSH: {
    iata: "TSH",
    name: "Tshikapa Airport",
    city: "Tshikapa",
    countryId: "CD",
    timeZoneRegionName: "Africa/Lubumbashi",
    latitude: -6.437853,
    longitude: 20.794326,
    icao: "FZUK"
  },
  TSJ: {
    iata: "TSJ",
    name: "Tsushima Airport",
    city: "Tsushima",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 34.286151,
    longitude: 129.326368,
    icao: "RJDT"
  },
  TSL: {
    iata: "TSL",
    name: "Tamuin Airport",
    city: "Tamuin",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 21.983333,
    longitude: -98.75,
    icao: "MMTN"
  },
  TSM: {
    iata: "TSM",
    name: "Taos Airport",
    city: "Taos",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 36.459167,
    longitude: -105.675278,
    icao: "KSKX"
  },
  TSN: {
    iata: "TSN",
    name: "Tianjin Binhai International Airport",
    city: "Tianjin",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 39.128273,
    longitude: 117.355906,
    icao: "ZBTJ"
  },
  TSO: {
    iata: "TSO",
    name: "Tresco Airport",
    city: "Isles Of Scilly",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 49.945556,
    longitude: -6.331389,
    icao: "EGHT"
  },
  TSP: {
    iata: "TSP",
    name: "Kern County Airport",
    city: "Tehachapi",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 35.1375,
    longitude: -118.441667,
    icao: "KTSP"
  },
  TSR: {
    iata: "TSR",
    name: "Timisoara Traian Vuia International Airport",
    city: "Timisoara",
    countryId: "RO",
    timeZoneRegionName: "Europe/Bucharest",
    latitude: 45.809924,
    longitude: 21.32012,
    icao: "LRTR"
  },
  TST: {
    iata: "TST",
    name: "Trang Airport",
    city: "Trang",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 7.5,
    longitude: 99.616667,
    icao: "VTST"
  },
  TSU: {
    iata: "TSU",
    name: "Tabiteuea South Airport",
    city: "Tabiteuea South",
    countryId: "KI",
    timeZoneRegionName: "Pacific/Tarawa",
    latitude: -1.416667,
    longitude: 174.833333,
    icao: "NGTS"
  },
  TSV: {
    iata: "TSV",
    name: "Townsville Airport",
    city: "Townsville",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -19.256506,
    longitude: 146.770793,
    icao: "YBTL"
  },
  TTA: {
    iata: "TTA",
    name: "Tan Tan Airport",
    city: "Tan Tan",
    countryId: "MA",
    timeZoneRegionName: "Africa/Casablanca",
    latitude: 28.45,
    longitude: -11.083333,
    icao: "GMAT"
  },
  TTB: {
    iata: "TTB",
    name: "Arbatax Airport",
    city: "Tortoli",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 39.916667,
    longitude: 9.683333,
    icao: "LIET"
  },
  TTC: {
    iata: "TTC",
    name: "Taltal Airport",
    city: "Taltal",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -25.517778,
    longitude: -70.422222,
    icao: "SCTT"
  },
  TTD: {
    iata: "TTD",
    name: "Troutdale Airport",
    city: "Troutdale",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 45.5494,
    longitude: -122.401001,
    icao: "KTTD"
  },
  TTE: {
    iata: "TTE",
    name: "Babullah Airport",
    city: "Ternate",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jayapura",
    latitude: 0.832233,
    longitude: 127.379132,
    icao: "WAMT"
  },
  TTG: {
    iata: "TTG",
    name: "Tartagal Airport",
    city: "Tartagal",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -22.533333,
    longitude: -63.833333,
    icao: "SAST"
  },
  TTH: {
    iata: "TTH",
    name: "Thumrait Air Base",
    city: "Thumrait",
    countryId: "OM",
    timeZoneRegionName: "Asia/Muscat",
    latitude: 17.665789,
    longitude: 54.024752,
    icao: "OOTH"
  },
  TTJ: {
    iata: "TTJ",
    name: "Tottori Airport",
    city: "Tottori",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 35.525915,
    longitude: 134.167562,
    icao: "RJOR"
  },
  TTK: {
    iata: "TTK",
    name: "Hale Railway Station",
    city: "Harringay",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.583332,
    longitude: -0.083333,
    icao: ""
  },
  TTN: {
    iata: "TTN",
    name: "Trenton-Mercer Airport",
    city: "Trenton",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.278056,
    longitude: -74.8125,
    icao: "KTTN"
  },
  TTO: {
    iata: "TTO",
    name: "Britton Municipal Airport",
    city: "Britton",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 45.8,
    longitude: -97.75,
    icao: "KBTN"
  },
  TTQ: {
    iata: "TTQ",
    name: "Tortuguero Airport",
    city: "Tortuguero",
    countryId: "CR",
    timeZoneRegionName: "America/Costa_Rica",
    latitude: 10.569444,
    longitude: -83.515278,
    icao: "MRBT"
  },
  TTS: {
    iata: "TTS",
    name: "Tsaratanana Airport",
    city: "Tsaratanana",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -16.733333,
    longitude: 47.6,
    icao: "FMNT"
  },
  TTT: {
    iata: "TTT",
    name: "Taitung Airport",
    city: "Taitung City",
    countryId: "TW",
    timeZoneRegionName: "Asia/Taipei",
    latitude: 22.75683,
    longitude: 121.106027,
    icao: "RCFN"
  },
  TTU: {
    iata: "TTU",
    name: "Sania Ramel Airport",
    city: "Tetouan",
    countryId: "MA",
    timeZoneRegionName: "Africa/Casablanca",
    latitude: 35.591244,
    longitude: -5.330265,
    icao: "GMTN"
  },
  TUA: {
    iata: "TUA",
    name: "Tulcan Airport",
    city: "Tulcan",
    countryId: "EC",
    timeZoneRegionName: "America/Guayaquil",
    latitude: 0.8,
    longitude: -77.716667,
    icao: "SETU"
  },
  TUB: {
    iata: "TUB",
    name: "Tubuai Island Airport",
    city: "Tubuai Island",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -23.35,
    longitude: -149.466667,
    icao: "NTAT"
  },
  TUC: {
    iata: "TUC",
    name: "Teniente Benjamin Matienzo Airport",
    city: "Tucuman",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -26.836106,
    longitude: -65.10754,
    icao: "SANT"
  },
  TUD: {
    iata: "TUD",
    name: "Tambacounda Airport",
    city: "Tambacounda",
    countryId: "SN",
    timeZoneRegionName: "Africa/Dakar",
    latitude: 13.736111,
    longitude: -13.658333,
    icao: "GOTT"
  },
  TUF: {
    iata: "TUF",
    name: "Val de Loire Airport",
    city: "Tours",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 47.432237,
    longitude: 0.726584,
    icao: "LFOT"
  },
  TUG: {
    iata: "TUG",
    name: "Tuguegarao Airport",
    city: "Tuguegarao",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 17.641111,
    longitude: 121.731667,
    icao: "RPUT"
  },
  TUI: {
    iata: "TUI",
    name: "Turaif Airport",
    city: "Turaif",
    countryId: "SA",
    timeZoneRegionName: "Asia/Riyadh",
    latitude: 31.68873,
    longitude: 38.733831,
    icao: "OETR"
  },
  TUK: {
    iata: "TUK",
    name: "Turbat Airport",
    city: "Turbat",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 25.983333,
    longitude: 63.066667,
    icao: "OPTU"
  },
  TUL: {
    iata: "TUL",
    name: "Tulsa International Airport",
    city: "Tulsa",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.189809,
    longitude: -95.890102,
    icao: "KTUL"
  },
  TUM: {
    iata: "TUM",
    name: "Tumut Airport",
    city: "Tumut",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -35.3,
    longitude: 148.216667,
    icao: "YTMU"
  },
  TUN: {
    iata: "TUN",
    name: "Tunis-Carthage International Airport",
    city: "Tunis",
    countryId: "TN",
    timeZoneRegionName: "Africa/Tunis",
    latitude: 36.847621,
    longitude: 10.21709,
    icao: "DTTA"
  },
  TUO: {
    iata: "TUO",
    name: "Taupo Airport",
    city: "Taupo",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -38.741433,
    longitude: 176.082347,
    icao: "NZAP"
  },
  TUP: {
    iata: "TUP",
    name: "Tupelo Regional Airport",
    city: "Tupelo",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 34.258889,
    longitude: -88.767222,
    icao: "KTUP"
  },
  TUQ: {
    iata: "TUQ",
    name: "Tougan Airport",
    city: "Tougan",
    countryId: "BF",
    timeZoneRegionName: "Africa/Ouagadougou",
    latitude: 13.059053,
    longitude: -3.076275,
    icao: "DFOT"
  },
  TUR: {
    iata: "TUR",
    name: "Tucurui Airport",
    city: "Tucurui",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -3.7,
    longitude: -49.733333,
    icao: "SBTU"
  },
  TUS: {
    iata: "TUS",
    name: "Tucson International Airport",
    city: "Tucson",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 32.120688,
    longitude: -110.937369,
    icao: "KTUS"
  },
  TUU: {
    iata: "TUU",
    name: "Tabuk Regional Airport",
    city: "Tabuk",
    countryId: "SA",
    timeZoneRegionName: "Asia/Riyadh",
    latitude: 28.373017,
    longitude: 36.598686,
    icao: "OETB"
  },
  TUV: {
    iata: "TUV",
    name: "San Rafael Airport",
    city: "Tucupita",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 9.089247,
    longitude: -62.094541,
    icao: "SVTC"
  },
  TUX: {
    iata: "TUX",
    name: "Tumbler Ridge Airport",
    city: "Tumbler Ridge",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 55.1,
    longitude: -121.083333,
    icao: "CBX7"
  },
  TVA: {
    iata: "TVA",
    name: "Morafenobe Airport",
    city: "Morafenobe",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -17.849444,
    longitude: 44.919167,
    icao: "FMMR"
  },
  TVC: {
    iata: "TVC",
    name: "Cherry Capital Airport",
    city: "Traverse City",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 44.737631,
    longitude: -85.579631,
    icao: "KTVC"
  },
  TVF: {
    iata: "TVF",
    name: "Thief River Falls Regional Airport",
    city: "Thief River Falls",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 48.066111,
    longitude: -96.185,
    icao: "KTVF"
  },
  TVI: {
    iata: "TVI",
    name: "Thomasville Regional Airport",
    city: "Thomasville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 30.9025,
    longitude: -83.880556,
    icao: "KTVI"
  },
  TVL: {
    iata: "TVL",
    name: "Lake Tahoe Airport",
    city: "South Lake Tahoe",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 38.894167,
    longitude: -119.994444,
    icao: "KTVL"
  },
  TVS: {
    iata: "TVS",
    name: "Tangshan Sannuhe Airport",
    city: "Tangshan",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 39.718784,
    longitude: 117.997913,
    icao: "ZBTS"
  },
  TVU: {
    iata: "TVU",
    name: "Matei Airport",
    city: "Taveuni",
    countryId: "FJ",
    timeZoneRegionName: "Pacific/Fiji",
    latitude: -16.688375,
    longitude: 179.869921,
    icao: "NFNM"
  },
  TVY: {
    iata: "TVY",
    name: "Dawe Airport",
    city: "Dawe",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 14.1,
    longitude: 98.2,
    icao: "VBTV"
  },
  TWA: {
    iata: "TWA",
    name: "Twin Hills Airport",
    city: "Twin Hills",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 59.073842,
    longitude: -160.276996,
    icao: ""
  },
  TWB: {
    iata: "TWB",
    name: "Toowoomba Airport",
    city: "Toowoomba",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -27.542222,
    longitude: 151.913889,
    icao: "YTWB"
  },
  TWC: {
    iata: "TWC",
    name: "Tumxuk Tangwangcheng Airport",
    city: "Tumushuke",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 39.888331,
    longitude: 79.234455,
    icao: ""
  },
  TWF: {
    iata: "TWF",
    name: "Magic Valley Regional Airport",
    city: "Twin Falls",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 42.481944,
    longitude: -114.486667,
    icao: "KTWF"
  },
  TWT: {
    iata: "TWT",
    name: "Sanga Sanga Airport",
    city: "Bongao",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 5.044251,
    longitude: 119.740982,
    icao: "RPMN"
  },
  TWU: {
    iata: "TWU",
    name: "Tawau Airport",
    city: "Tawau",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 4.313084,
    longitude: 118.121497,
    icao: "WBKW"
  },
  TXF: {
    iata: "TXF",
    name: "Teixeira de Freitas Airport",
    city: "Teixeira de Freitas",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -17.523049,
    longitude: -39.669842,
    icao: "SNTF"
  },
  TXK: {
    iata: "TXK",
    name: "Texarkana Regional Airport - Webb Field",
    city: "Texarkana",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 33.456389,
    longitude: -93.989167,
    icao: "KTXK"
  },
  TXL: {
    iata: "TXL",
    name: "Tegel Airport",
    city: "Berlin",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 52.553944,
    longitude: 13.291722,
    icao: "EDDT"
  },
  TXN: {
    iata: "TXN",
    name: "Huangshan Tunxi International Airport",
    city: "Tunxi",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 29.731388,
    longitude: 118.254197,
    icao: "ZSTX"
  },
  TXU: {
    iata: "TXU",
    name: "Tabou Airport",
    city: "Tabou",
    countryId: "CI",
    timeZoneRegionName: "Africa/Abidjan",
    latitude: 4.433333,
    longitude: -7.366667,
    icao: "DITB"
  },
  TYB: {
    iata: "TYB",
    name: "Tibooburra Airport",
    city: "Tibooburra",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -29.456944,
    longitude: 142.062222,
    icao: "YTIB"
  },
  TYD: {
    iata: "TYD",
    name: "Tynda Airport",
    city: "Tynda",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yakutsk",
    latitude: 55.281011,
    longitude: 124.770875,
    icao: ""
  },
  TYF: {
    iata: "TYF",
    name: "Torsby Airport",
    city: "Torsby",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 60.154484,
    longitude: 12.99661,
    icao: "ESST"
  },
  TYL: {
    iata: "TYL",
    name: "Captain FAP Victor Montes Arias Airport",
    city: "Talara",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -4.575406,
    longitude: -81.254489,
    icao: "SPYL"
  },
  TYM: {
    iata: "TYM",
    name: "Staniel Cay Airport",
    city: "Staniel Cay",
    countryId: "BS",
    timeZoneRegionName: "America/Nassau",
    latitude: 24.168911,
    longitude: -76.439995,
    icao: "MYES"
  },
  TYN: {
    iata: "TYN",
    name: "Taiyuan Wusu International Airport",
    city: "Taiyuan",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 37.754996,
    longitude: 112.62585,
    icao: "ZBYN"
  },
  TYR: {
    iata: "TYR",
    name: "Tyler Pounds Regional Airport",
    city: "Tyler",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.351598,
    longitude: -95.410117,
    icao: "KTYR"
  },
  TYS: {
    iata: "TYS",
    name: "McGhee Tyson Airport",
    city: "Knoxville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 35.80565,
    longitude: -83.989729,
    icao: "KTYS"
  },
  TYT: {
    iata: "TYT",
    name: "Treinta-y-Tres Airport",
    city: "Treinta-y-Tres",
    countryId: "UY",
    timeZoneRegionName: "America/Montevideo",
    latitude: -33.266667,
    longitude: -54.283333,
    icao: "SUTR"
  },
  TYZ: {
    iata: "TYZ",
    name: "Taylor Airport",
    city: "Taylor",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 34.466667,
    longitude: -110.083333,
    icao: "KTYL"
  },
  TZA: {
    iata: "TZA",
    name: "Belize City Sir Barry Bowen Municipal Airport",
    city: "Belize City",
    countryId: "BZ",
    timeZoneRegionName: "America/Belize",
    latitude: 17.51578,
    longitude: -88.194394,
    icao: "MZBE"
  },
  TZL: {
    iata: "TZL",
    name: "Tuzla International Airport",
    city: "Tuzla",
    countryId: "BA",
    timeZoneRegionName: "Europe/Sarajevo",
    latitude: 44.409722,
    longitude: 18.709167,
    icao: "LQTZ"
  },
  TZN: {
    iata: "TZN",
    name: "South Andros Airport",
    city: "Congo Town",
    countryId: "BS",
    timeZoneRegionName: "America/Nassau",
    latitude: 24.158367,
    longitude: -77.588798,
    icao: "MYAK"
  },
  TZX: {
    iata: "TZX",
    name: "Trabzon Airport",
    city: "Trabzon",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 40.994191,
    longitude: 39.781681,
    icao: "LTCG"
  },
  UAB: {
    iata: "UAB",
    name: "Incirlik Air Base",
    city: "Adana",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 37.000278,
    longitude: 35.418333,
    icao: "LTAG"
  },
  UAH: {
    iata: "UAH",
    name: "Ua Huka Airport",
    city: "Ua Huka",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Marquesas",
    latitude: -8.933333,
    longitude: -139.55,
    icao: "NTMU"
  },
  UAK: {
    iata: "UAK",
    name: "Narsarsuaq Airport",
    city: "Narsarsuaq",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 61.162598,
    longitude: -45.417921,
    icao: "BGBW"
  },
  UAM: {
    iata: "UAM",
    name: "Anderson Air Force Base",
    city: "Guam",
    countryId: "GU",
    timeZoneRegionName: "Pacific/Guam",
    latitude: 13.580373,
    longitude: 144.92954,
    icao: "PGUA"
  },
  UAP: {
    iata: "UAP",
    name: "Ua Pou Airport",
    city: "Ua Pou, Marquesas Island",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Marquesas",
    latitude: -9.343477,
    longitude: -140.081252,
    icao: "NTMP"
  },
  UAQ: {
    iata: "UAQ",
    name: "San Juan Airport",
    city: "San Juan",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -31.571501,
    longitude: -68.418198,
    icao: "SANU"
  },
  UAR: {
    iata: "UAR",
    name: "Bouarfa Airport",
    city: "Bouarfa",
    countryId: "MA",
    timeZoneRegionName: "Africa/Casablanca",
    latitude: 32.51417,
    longitude: -1.98167,
    icao: "GMFB"
  },
  UAS: {
    iata: "UAS",
    name: "Samburu Airport",
    city: "Samburu",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: 0.466667,
    longitude: 37.55,
    icao: "HKSB"
  },
  UBA: {
    iata: "UBA",
    name: "Uberaba Airport",
    city: "Uberaba",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -19.776389,
    longitude: -47.958333,
    icao: "SBUR"
  },
  UBB: {
    iata: "UBB",
    name: "Mabuiag Island Airport",
    city: "Mabuiag Island",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -9.950447,
    longitude: 142.195363,
    icao: "YMAA"
  },
  UBJ: {
    iata: "UBJ",
    name: "Yamaguchi Ube Airport",
    city: "Ube",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 33.933397,
    longitude: 131.274894,
    icao: "RJDC"
  },
  UBN: {
    iata: "UBN",
    name: "Ulaanbaatar International Airport",
    city: "Ulaanbaatar",
    countryId: "MN",
    timeZoneRegionName: "Asia/Ulaanbaatar",
    latitude: 47.646944,
    longitude: 106.819722,
    icao: "ZMCK"
  },
  UBP: {
    iata: "UBP",
    name: "Ubon Ratchathani International Airport",
    city: "Ubon Ratchathani",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 15.246491,
    longitude: 104.870683,
    icao: "VTUU"
  },
  UBS: {
    iata: "UBS",
    name: "Lowndes County Airport",
    city: "Columbus",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 33.466667,
    longitude: -88.383333,
    icao: "KUBS"
  },
  UBT: {
    iata: "UBT",
    name: "Ubatuba Airport",
    city: "Ubatuba",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -23.433333,
    longitude: -45.083333,
    icao: "SDUB"
  },
  UBU: {
    iata: "UBU",
    name: "Kalumburu Airport",
    city: "Kalumburu",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -14.3,
    longitude: 126.65,
    icao: ""
  },
  UCA: {
    iata: "UCA",
    name: "Oneida County Airport",
    city: "Utica",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 43.141389,
    longitude: -75.380278,
    icao: "KUCA"
  },
  UCB: {
    iata: "UCB",
    name: "Ulanqab Jining Airport",
    city: "Ulanqab",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 41.127387,
    longitude: 113.109993,
    icao: ""
  },
  UCN: {
    iata: "UCN",
    name: "Buchanan Airport",
    city: "Buchanan",
    countryId: "LR",
    timeZoneRegionName: "Africa/Monrovia",
    latitude: 5.95,
    longitude: -10.033333,
    icao: "GLBU"
  },
  UCT: {
    iata: "UCT",
    name: "Ukhta Airport",
    city: "Ukhta",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 63.566667,
    longitude: 53.8,
    icao: "UUYH"
  },
  UCY: {
    iata: "UCY",
    name: "Everett-Stewart Airport",
    city: "Union City",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.433333,
    longitude: -89.05,
    icao: "KUCY"
  },
  UDD: {
    iata: "UDD",
    name: "Bermuda Dunes Airport",
    city: "Palm Springs",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 33.746019,
    longitude: -116.270782,
    icao: "KUDD"
  },
  UDI: {
    iata: "UDI",
    name: "Uberlandia-Ten. Cel. Av. Cesar Bombonato Airport",
    city: "Uberlandia",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -18.889319,
    longitude: -48.230073,
    icao: "SBUL"
  },
  UDJ: {
    iata: "UDJ",
    name: "Uzhhorod International Airport",
    city: "Uzhgorod",
    countryId: "UA",
    timeZoneRegionName: "Europe/Kiev",
    latitude: 48.636348,
    longitude: 22.271291,
    icao: "UKLU"
  },
  UDN: {
    iata: "UDN",
    name: "Udine Airfield",
    city: "Udine",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 46.033333,
    longitude: 13.183333,
    icao: "LIPD"
  },
  UDR: {
    iata: "UDR",
    name: "Maharana Pratap Airport",
    city: "Udaipur",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 24.61919,
    longitude: 73.891269,
    icao: "VAUD"
  },
  UEL: {
    iata: "UEL",
    name: "Quelimane Airport",
    city: "Quelimane",
    countryId: "MZ",
    timeZoneRegionName: "Africa/Maputo",
    latitude: -17.857741,
    longitude: 36.871545,
    icao: "FQQL"
  },
  UEO: {
    iata: "UEO",
    name: "Kume-jima Airport",
    city: "Kume-jima",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 26.365278,
    longitude: 126.719444,
    icao: "ROKJ"
  },
  UES: {
    iata: "UES",
    name: "Waukesha County Airport",
    city: "Waukesha",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 43.038912,
    longitude: -88.237747,
    icao: "KUES"
  },
  UET: {
    iata: "UET",
    name: "Quetta Airport",
    city: "Quetta",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 30.249266,
    longitude: 66.949036,
    icao: "OPQT"
  },
  UFA: {
    iata: "UFA",
    name: "Ufa International Airport",
    city: "Ufa",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yekaterinburg",
    latitude: 54.565403,
    longitude: 55.884543,
    icao: "UWUU"
  },
  UGA: {
    iata: "UGA",
    name: "Bulgan Airport",
    city: "Bulgan",
    countryId: "MN",
    timeZoneRegionName: "Asia/Ulaanbaatar",
    latitude: 48.8,
    longitude: 103.55,
    icao: "ZMBN"
  },
  UGC: {
    iata: "UGC",
    name: "Urgench Airport",
    city: "Urgench",
    countryId: "UZ",
    timeZoneRegionName: "Asia/Tashkent",
    latitude: 41.584834,
    longitude: 60.633029,
    icao: "UTNU"
  },
  UGN: {
    iata: "UGN",
    name: "Waukegan National Airport",
    city: "Waukegan",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 42.420903,
    longitude: -87.866024,
    icao: "KUGN"
  },
  UGO: {
    iata: "UGO",
    name: "Uige Airport",
    city: "Uige",
    countryId: "AO",
    timeZoneRegionName: "Africa/Luanda",
    latitude: -7.816667,
    longitude: 15.15,
    icao: "FNUG"
  },
  UHE: {
    iata: "UHE",
    name: "Kunovice Airport",
    city: "Uherske Hradiste",
    countryId: "CZ",
    timeZoneRegionName: "Europe/Prague",
    latitude: 49.029364,
    longitude: 17.439825,
    icao: "LKKU"
  },
  UHS: {
    iata: "UHS",
    name: "Aleksandrovsk-Sakhalinskiy Airport",
    city: "Aleksandrovsk-Sakhalinkiy",
    countryId: "RU",
    timeZoneRegionName: "Asia/Sakhalin",
    latitude: 50.87722,
    longitude: 142.17556,
    icao: ""
  },
  UIB: {
    iata: "UIB",
    name: "El Carano Airport",
    city: "Quibdo",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 5.690556,
    longitude: -76.641945,
    icao: "SKUI"
  },
  UIH: {
    iata: "UIH",
    name: "Phu Cat Airport",
    city: "Qui Nhon",
    countryId: "VN",
    timeZoneRegionName: "Asia/Ho_Chi_Minh",
    latitude: 13.955,
    longitude: 109.042222,
    icao: "VVPC"
  },
  UII: {
    iata: "UII",
    name: "Utila Airport",
    city: "Utila",
    countryId: "HN",
    timeZoneRegionName: "America/Tegucigalpa",
    latitude: 16.091667,
    longitude: -86.8875,
    icao: "MHUT"
  },
  UIK: {
    iata: "UIK",
    name: "Ust-Ilimsk Airport",
    city: "Ust-Ilimsk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Irkutsk",
    latitude: 58.133333,
    longitude: 102.55,
    icao: ""
  },
  UIL: {
    iata: "UIL",
    name: "Quillayute State Airport",
    city: "Quillayute",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 47.9,
    longitude: -124.633333,
    icao: "KUIL"
  },
  UIN: {
    iata: "UIN",
    name: "Quincy Municipal Airport",
    city: "Quincy",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 39.944167,
    longitude: -91.197222,
    icao: "KUIN"
  },
  UIO: {
    iata: "UIO",
    name: "Mariscal Sucre International Airport",
    city: "Quito",
    countryId: "EC",
    timeZoneRegionName: "America/Guayaquil",
    latitude: -0.123811,
    longitude: -78.355976,
    icao: "SEQM"
  },
  UIP: {
    iata: "UIP",
    name: "Pluguffan Airport",
    city: "Quimper",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 47.974444,
    longitude: -4.170833,
    icao: "LFRQ"
  },
  UIR: {
    iata: "UIR",
    name: "Quirindi Airport",
    city: "Quirindi",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -31.5,
    longitude: 150.516667,
    icao: "YQDI"
  },
  UIZ: {
    iata: "UIZ",
    name: "Berz-Macomb Airport",
    city: "Utica",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.616667,
    longitude: -83.05,
    icao: "KUIZ"
  },
  UKA: {
    iata: "UKA",
    name: "Ukunda Airport",
    city: "Ukunda",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: -4.296944,
    longitude: 39.571389,
    icao: "HKUK"
  },
  UKB: {
    iata: "UKB",
    name: "Kobe Airport",
    city: "Kobe",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 34.6373,
    longitude: 135.228388,
    icao: "RJBE"
  },
  UKE: {
    iata: "UKE",
    name: "Utkela Airport",
    city: "Utkela",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 20.0947,
    longitude: 83.1808,
    icao: "VEUK"
  },
  UKG: {
    iata: "UKG",
    name: "Ust-Kuyga Airport",
    city: "Ust-Kuyga",
    countryId: "RU",
    timeZoneRegionName: "Asia/Vladivostok",
    latitude: 70.011002,
    longitude: 135.645004,
    icao: "UEBT"
  },
  UKH: {
    iata: "UKH",
    name: "Mukhaizna Airport",
    city: "Mukhaizna Oil Field",
    countryId: "OM",
    timeZoneRegionName: "Asia/Muscat",
    latitude: 19.386389,
    longitude: 56.401389,
    icao: "OOMK"
  },
  UKI: {
    iata: "UKI",
    name: "Ukiah Municipal Airport",
    city: "Ukiah",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 39.125815,
    longitude: -123.202162,
    icao: "KUKI"
  },
  UKK: {
    iata: "UKK",
    name: "Ust-Kamenogorsk Airport",
    city: "Ust-Kamenogorsk",
    countryId: "KZ",
    timeZoneRegionName: "Asia/Almaty",
    latitude: 50.03657,
    longitude: 82.493495,
    icao: "UASK"
  },
  UKR: {
    iata: "UKR",
    name: "Mukeiras Airport",
    city: "Mukeiras",
    countryId: "YE",
    timeZoneRegionName: "Asia/Aden",
    latitude: 13.933333,
    longitude: 45.683333,
    icao: "OYMK"
  },
  UKT: {
    iata: "UKT",
    name: "Upper Bucks Airport",
    city: "Quakertown",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.434173,
    longitude: -75.381102,
    icao: "KUKT"
  },
  UKX: {
    iata: "UKX",
    name: "Ust-Kut Airport",
    city: "Ust-Kut",
    countryId: "RU",
    timeZoneRegionName: "Asia/Irkutsk",
    latitude: 56.85,
    longitude: 105.733333,
    icao: ""
  },
  ULA: {
    iata: "ULA",
    name: "San Julian Airport",
    city: "San Julian",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -49.316667,
    longitude: -67.666667,
    icao: "SAWJ"
  },
  ULB: {
    iata: "ULB",
    name: "Ulei Airport",
    city: "Ulei",
    countryId: "VU",
    timeZoneRegionName: "Pacific/Efate",
    latitude: -16.416667,
    longitude: 168.333333,
    icao: "NVSU"
  },
  ULC: {
    iata: "ULC",
    name: "Los Cerrillos Airport",
    city: "Santiago",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -33.489722,
    longitude: -70.694722,
    icao: "SCTI"
  },
  ULD: {
    iata: "ULD",
    name: "Prince Mangosuthu Buthelezi Airport",
    city: "Ulundi",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -28.315803,
    longitude: 31.419104,
    icao: "FAUL"
  },
  ULE: {
    iata: "ULE",
    name: "Sule Airport",
    city: "Sule",
    countryId: "PG",
    timeZoneRegionName: "Pacific/Port_Moresby",
    latitude: -4.933333,
    longitude: 151.266667,
    icao: "SULE"
  },
  ULG: {
    iata: "ULG",
    name: "Olgii Airport",
    city: "Ulgit",
    countryId: "MN",
    timeZoneRegionName: "Asia/Ulaanbaatar",
    latitude: 48.992091,
    longitude: 89.920228,
    icao: "ZMUL"
  },
  ULH: {
    iata: "ULH",
    name: "Prince Abdul Majeed bin Abdulaziz Airport",
    city: "Al Ula",
    countryId: "SA",
    timeZoneRegionName: "Asia/Riyadh",
    latitude: 26.480861,
    longitude: 38.116654,
    icao: "OEAO"
  },
  ULI: {
    iata: "ULI",
    name: "Ulithi Airport",
    city: "Ulithi Caroline Islands",
    countryId: "FM",
    timeZoneRegionName: "Pacific/Chuuk",
    latitude: 10.019938,
    longitude: 139.78999,
    icao: "TT02"
  },
  ULK: {
    iata: "ULK",
    name: "Lensk Airport",
    city: "Lensk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yakutsk",
    latitude: 60.723301,
    longitude: 114.824025,
    icao: "UERL"
  },
  ULM: {
    iata: "ULM",
    name: "New Ulm Airport",
    city: "New Ulm",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 44.321389,
    longitude: -94.500556,
    icao: "KULM"
  },
  ULN: {
    iata: "ULN",
    name: "Chinggis Khaan International Airport",
    city: "Ulaanbaatar",
    countryId: "MN",
    timeZoneRegionName: "Asia/Ulaanbaatar",
    latitude: 47.852749,
    longitude: 106.763268,
    icao: "ZMUB"
  },
  ULO: {
    iata: "ULO",
    name: "Ulaangom Airport",
    city: "Ulaangom",
    countryId: "MN",
    timeZoneRegionName: "Asia/Ulaanbaatar",
    latitude: 49.973383,
    longitude: 92.080288,
    icao: "ZMUG"
  },
  ULP: {
    iata: "ULP",
    name: "Quilpie Airport",
    city: "Quilpie",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -26.633333,
    longitude: 144.3,
    icao: "YQLP"
  },
  ULQ: {
    iata: "ULQ",
    name: "Farfan Airport",
    city: "Tulua",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 4.097222,
    longitude: -76.229167,
    icao: "SKUL"
  },
  ULU: {
    iata: "ULU",
    name: "Gulu Airport",
    city: "Gulu",
    countryId: "UG",
    timeZoneRegionName: "Africa/Kampala",
    latitude: 2.789803,
    longitude: 32.273952,
    icao: "HUGU"
  },
  ULV: {
    iata: "ULV",
    name: "Ulyanovsk Baratayevka Airport",
    city: "Ulyanovsk",
    countryId: "RU",
    timeZoneRegionName: "Europe/Ulyanovsk",
    latitude: 54.268333,
    longitude: 48.226665,
    icao: "UWLL"
  },
  ULX: {
    iata: "ULX",
    name: "Ulusaba Airport",
    city: "Ulusaba",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -24.782376,
    longitude: 31.353811,
    icao: "FAUS"
  },
  ULY: {
    iata: "ULY",
    name: "Ulyanovsk Vostochny Airport",
    city: "Ulyanovsk",
    countryId: "RU",
    timeZoneRegionName: "Europe/Ulyanovsk",
    latitude: 54.399045,
    longitude: 48.802801,
    icao: "UWLW"
  },
  ULZ: {
    iata: "ULZ",
    name: "Uliastai Donoi Airport",
    city: "Uliastai",
    countryId: "MN",
    timeZoneRegionName: "Asia/Ulaanbaatar",
    latitude: 47.709633,
    longitude: 96.525498,
    icao: "ZMDN"
  },
  UMB: {
    iata: "UMB",
    name: "Kalumbila Airport",
    city: "Solwezi",
    countryId: "ZM",
    timeZoneRegionName: "Africa/Lusaka",
    latitude: -12.25358,
    longitude: 25.44432,
    icao: ""
  },
  UMD: {
    iata: "UMD",
    name: "Uummannaq Heliport",
    city: "Uummannaq",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 70.680362,
    longitude: -52.111657,
    icao: "BGUM"
  },
  UME: {
    iata: "UME",
    name: "Umea Airport",
    city: "Umea",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 63.793332,
    longitude: 20.289539,
    icao: "ESNU"
  },
  UMI: {
    iata: "UMI",
    name: "Quincemil Airport",
    city: "Quincemil",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -13.25,
    longitude: -70.666667,
    icao: "SPIL"
  },
  UMR: {
    iata: "UMR",
    name: "Woomera Airport",
    city: "Woomera",
    countryId: "AU",
    timeZoneRegionName: "Australia/Adelaide",
    latitude: -31.15,
    longitude: 136.816667,
    icao: "YPWR"
  },
  UMT: {
    iata: "UMT",
    name: "Umiat Airport",
    city: "Umiat",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 69.416667,
    longitude: -152.333333,
    icao: "PAUM"
  },
  UMU: {
    iata: "UMU",
    name: "Ernesto Geisel Airport",
    city: "Umuarama",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -23.798333,
    longitude: -53.313333,
    icao: "SSUM"
  },
  UNA: {
    iata: "UNA",
    name: "Una-Comandatuba Airport",
    city: "Comandatuba",
    countryId: "BR",
    timeZoneRegionName: "America/Bahia",
    latitude: -15.353333,
    longitude: -38.997222,
    icao: "SBTC"
  },
  UND: {
    iata: "UND",
    name: "Kunduz Airport",
    city: "Kunduz",
    countryId: "AF",
    timeZoneRegionName: "Asia/Kabul",
    latitude: 36.665175,
    longitude: 68.910593,
    icao: "OAUZ"
  },
  UNE: {
    iata: "UNE",
    name: "Qachas Airport",
    city: "Qachas",
    countryId: "LS",
    timeZoneRegionName: "Africa/Maseru",
    latitude: -30.166667,
    longitude: 27.166667,
    icao: "FXQN"
  },
  UNG: {
    iata: "UNG",
    name: "Kiunga Airport",
    city: "Kiunga",
    countryId: "PG",
    timeZoneRegionName: "Pacific/Port_Moresby",
    latitude: -6.125552,
    longitude: 141.286017,
    icao: "AYKI"
  },
  UNI: {
    iata: "UNI",
    name: "Union Island Airport",
    city: "Union Island",
    countryId: "VC",
    timeZoneRegionName: "America/St_Vincent",
    latitude: 13.5,
    longitude: -61,
    icao: "TVSU"
  },
  UNK: {
    iata: "UNK",
    name: "Unalakleet Airport",
    city: "Unalakleet",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 63.881928,
    longitude: -160.799433,
    icao: "PAUN"
  },
  UNN: {
    iata: "UNN",
    name: "Ranong Airport",
    city: "Ranong",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 9.852778,
    longitude: 98.629167,
    icao: "VTSR"
  },
  UNT: {
    iata: "UNT",
    name: "Unst Airport",
    city: "Baltasound",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 60.748559,
    longitude: -0.849653,
    icao: "EGPW"
  },
  UNU: {
    iata: "UNU",
    name: "Dodge County Airport",
    city: "Juneau",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 58.3,
    longitude: -134.416667,
    icao: "KUNU"
  },
  UOL: {
    iata: "UOL",
    name: "Pogogul Airport",
    city: "Buol",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: 1.104373,
    longitude: 121.416029,
    icao: "WAMY"
  },
  UOS: {
    iata: "UOS",
    name: "Franklin County Airport",
    city: "Sewanee",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 35.183333,
    longitude: -85.9,
    icao: "KUOS"
  },
  UOX: {
    iata: "UOX",
    name: "University-Oxford Airport",
    city: "Oxford",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 34.38,
    longitude: -89.535296,
    icao: "KUOX"
  },
  UPB: {
    iata: "UPB",
    name: "Playa Baracoa Airport",
    city: "Havana",
    countryId: "CU",
    timeZoneRegionName: "America/Havana",
    latitude: 23.032778,
    longitude: -82.579444,
    icao: "MUPB"
  },
  UPG: {
    iata: "UPG",
    name: "Sultan Hasanuddin International Airport",
    city: "Ujung Pandang",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -5.077019,
    longitude: 119.547738,
    icao: "WAAA"
  },
  UPK: {
    iata: "UPK",
    name: "Upernavik Kujalleq Heliport",
    city: "Upernavik Kujalleq",
    countryId: "GL",
    timeZoneRegionName: "America/Godthab",
    latitude: 72.15273,
    longitude: -55.531099,
    icao: "BGKL"
  },
  UPN: {
    iata: "UPN",
    name: "Licenciado y General Ignacio Lopez Rayon Airport",
    city: "Uruapan",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 19.402278,
    longitude: -102.037988,
    icao: "MMPN"
  },
  UPP: {
    iata: "UPP",
    name: "Upolu Point Airport",
    city: "Upolu Point",
    countryId: "US",
    timeZoneRegionName: "Pacific/Honolulu",
    latitude: 20.268056,
    longitude: -155.8625,
    icao: "PHUP"
  },
  UPV: {
    iata: "UPV",
    name: "Upavon Airport",
    city: "Upavon",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.3,
    longitude: -1.816667,
    icao: "EGDJ"
  },
  URA: {
    iata: "URA",
    name: "Uralsk Airport",
    city: "Uralsk",
    countryId: "KZ",
    timeZoneRegionName: "Asia/Oral",
    latitude: 51.153708,
    longitude: 51.538562,
    icao: "UARR"
  },
  URB: {
    iata: "URB",
    name: "Ernesto Pochler Airport",
    city: "Urubupunga",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -20.77833,
    longitude: -51.56287,
    icao: "SBUP"
  },
  URC: {
    iata: "URC",
    name: "Urumqi Diwopu International Airport",
    city: "Urumqi",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 43.90126,
    longitude: 87.475148,
    icao: "ZWWW"
  },
  URD: {
    iata: "URD",
    name: "Burg Feuerstein Airport",
    city: "Burg Feuerstein",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 49.8,
    longitude: 11.133333,
    icao: "EDQE"
  },
  URE: {
    iata: "URE",
    name: "Kuressaare Airport",
    city: "Kuressaare",
    countryId: "EE",
    timeZoneRegionName: "Europe/Tallinn",
    latitude: 58.229938,
    longitude: 22.509542,
    icao: "EEKE"
  },
  URG: {
    iata: "URG",
    name: "Ruben Berta Airport",
    city: "Uruguaiana",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -29.783427,
    longitude: -57.035952,
    icao: "SBUG"
  },
  URJ: {
    iata: "URJ",
    name: "Uray Airport",
    city: "Uraj",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yekaterinburg",
    latitude: 60.116667,
    longitude: 64.833333,
    icao: "USHU"
  },
  URM: {
    iata: "URM",
    name: "Uriman Airport",
    city: "Uriman",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 5.341667,
    longitude: -62.758333,
    icao: "SVUM"
  },
  URO: {
    iata: "URO",
    name: "Boos Airport",
    city: "Rouen",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 49.388611,
    longitude: 1.1875,
    icao: "LFOP"
  },
  URR: {
    iata: "URR",
    name: "Urrao Airport",
    city: "Urrao",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 6.333333,
    longitude: -76.183333,
    icao: "SKUR"
  },
  URS: {
    iata: "URS",
    name: "Kursk Vostochny Airport",
    city: "Kursk",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 51.750993,
    longitude: 36.283127,
    icao: "UUOK"
  },
  URT: {
    iata: "URT",
    name: "Surat Thani Airport",
    city: "Surat Thani",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 9.133865,
    longitude: 99.143198,
    icao: "VTSB"
  },
  URY: {
    iata: "URY",
    name: "Gurayat Airport",
    city: "Gurayat",
    countryId: "SA",
    timeZoneRegionName: "Asia/Riyadh",
    latitude: 31.409623,
    longitude: 37.275006,
    icao: "OEGT"
  },
  USA: {
    iata: "USA",
    name: "Concord Regional Airport",
    city: "Concord",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 35.385139,
    longitude: -80.71119,
    icao: "KJQF"
  },
  USH: {
    iata: "USH",
    name: "Malvinas Argentinas International Airport",
    city: "Ushuaia",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -54.839347,
    longitude: -68.312449,
    icao: "SAWH"
  },
  USK: {
    iata: "USK",
    name: "Usinsk Airport",
    city: "Usinsk",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 66.002429,
    longitude: 57.37496,
    icao: "UUYS"
  },
  USM: {
    iata: "USM",
    name: "Koh Samui Airport",
    city: "Koh Samui",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 9.55117,
    longitude: 100.062878,
    icao: "VTSM"
  },
  USN: {
    iata: "USN",
    name: "Ulsan Airport",
    city: "Ulsan",
    countryId: "KR",
    timeZoneRegionName: "Asia/Seoul",
    latitude: 35.593671,
    longitude: 129.355976,
    icao: "RKPU"
  },
  USQ: {
    iata: "USQ",
    name: "Usak Airport",
    city: "Usak",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 38.680031,
    longitude: 29.481672,
    icao: "LTBO"
  },
  USR: {
    iata: "USR",
    name: "Ust-Nera Airport",
    city: "Ust-Nera",
    countryId: "RU",
    timeZoneRegionName: "Asia/Ust-Nera",
    latitude: 64.549444,
    longitude: 143.110833,
    icao: ""
  },
  UST: {
    iata: "UST",
    name: "St. Augustine Airport",
    city: "Saint Augustine",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 29.959323,
    longitude: -81.337849,
    icao: "KSGJ"
  },
  USU: {
    iata: "USU",
    name: "Busuanga Airport",
    city: "Busuanga",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 12.1,
    longitude: 120.166667,
    icao: "RPVV"
  },
  UTA: {
    iata: "UTA",
    name: "Mutare Airport",
    city: "Mutare",
    countryId: "ZW",
    timeZoneRegionName: "Africa/Harare",
    latitude: -18.966667,
    longitude: 32.666667,
    icao: "FVMU"
  },
  UTB: {
    iata: "UTB",
    name: "Muttaburra Airport",
    city: "Muttaburra",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -22.5875,
    longitude: 144.525,
    icao: "YMTB"
  },
  UTC: {
    iata: "UTC",
    name: "Soesterberg Airport",
    city: "Utrecht",
    countryId: "NL",
    timeZoneRegionName: "Europe/Amsterdam",
    latitude: 52.083333,
    longitude: 5.166667,
    icao: "EHSB"
  },
  UTH: {
    iata: "UTH",
    name: "Udon Thani International Airport",
    city: "Udon Thani",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 17.386392,
    longitude: 102.788,
    icao: "VTUD"
  },
  UTI: {
    iata: "UTI",
    name: "Utti Airport",
    city: "Kouvola",
    countryId: "FI",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 60.9,
    longitude: 26.933333,
    icao: "EFUT"
  },
  UTM: {
    iata: "UTM",
    name: "Tunica Municipal Airport",
    city: "Tunica",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 34.683418,
    longitude: -90.349798,
    icao: "KUTA"
  },
  UTN: {
    iata: "UTN",
    name: "Upington Airport",
    city: "Upington",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -28.400556,
    longitude: 21.253333,
    icao: "FAUP"
  },
  UTP: {
    iata: "UTP",
    name: "Utapao Airport",
    city: "Utapao",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 12.683333,
    longitude: 101.016667,
    icao: "VTBU"
  },
  UTR: {
    iata: "UTR",
    name: "Uttaradit Airport",
    city: "Uttaradit",
    countryId: "TH",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 17.669444,
    longitude: 100.243889,
    icao: "VTPU"
  },
  UTS: {
    iata: "UTS",
    name: "Ust-Tsilma Airport",
    city: "Ust-Tsilma",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 65.437294,
    longitude: 52.200336,
    icao: "UUYX"
  },
  UTT: {
    iata: "UTT",
    name: "Umtata Airport",
    city: "Umtata",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -31.583333,
    longitude: 28.783333,
    icao: "FAUT"
  },
  UTW: {
    iata: "UTW",
    name: "Queenstown Airport",
    city: "Queenstown",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -31.866667,
    longitude: 26.866667,
    icao: "FAQT"
  },
  UUA: {
    iata: "UUA",
    name: "Bugulma Airport",
    city: "Bugulma",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 54.633958,
    longitude: 52.791009,
    icao: "UWKB"
  },
  UUD: {
    iata: "UUD",
    name: "Ulan-Ude Airport",
    city: "Ulan-Ude",
    countryId: "RU",
    timeZoneRegionName: "Asia/Irkutsk",
    latitude: 51.833333,
    longitude: 107.5,
    icao: "UIUU"
  },
  UUK: {
    iata: "UUK",
    name: "Ugnu-Kuparuk Airport",
    city: "Ugnu Kuparuk",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 70.330819,
    longitude: -149.597556,
    icao: "PAKU"
  },
  UUN: {
    iata: "UUN",
    name: "Baruun-Urt Airport",
    city: "Baruun-Urt",
    countryId: "MN",
    timeZoneRegionName: "Asia/Ulaanbaatar",
    latitude: 46.683333,
    longitude: 113.283333,
    icao: "ZMBU"
  },
  UUS: {
    iata: "UUS",
    name: "Yuzhno-Sakhalinsk Airport",
    city: "Yuzhno-Sakhalinsk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Sakhalin",
    latitude: 46.885341,
    longitude: 142.721561,
    icao: "UHSS"
  },
  UVA: {
    iata: "UVA",
    name: "Garner Field",
    city: "Uvalde",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 29.201944,
    longitude: -99.735,
    icao: "KUVA"
  },
  UVE: {
    iata: "UVE",
    name: "Ouvea Airport",
    city: "Ouvea",
    countryId: "NC",
    timeZoneRegionName: "Pacific/Noumea",
    latitude: -20.64242,
    longitude: 166.571983,
    icao: "NWWV"
  },
  UVF: {
    iata: "UVF",
    name: "Hewanorra Airport",
    city: "Saint Lucia",
    countryId: "LC",
    timeZoneRegionName: "America/St_Lucia",
    latitude: 13.735556,
    longitude: -60.952222,
    icao: "TLPL"
  },
  UVI: {
    iata: "UVI",
    name: "Uniao da Vitoria Jose Cleto Airport",
    city: "Uniao da Vitoria",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -26.2317,
    longitude: -51.0689,
    icao: ""
  },
  UVL: {
    iata: "UVL",
    name: "Kharga Airport",
    city: "New Valley",
    countryId: "EG",
    timeZoneRegionName: "Africa/Cairo",
    latitude: 25.475,
    longitude: 30.590833,
    icao: "HENY"
  },
  UYL: {
    iata: "UYL",
    name: "Nyala Airport",
    city: "Nyala",
    countryId: "SD",
    timeZoneRegionName: "Africa/Khartoum",
    latitude: 12.071667,
    longitude: 24.894722,
    icao: "HSNL"
  },
  UYN: {
    iata: "UYN",
    name: "Yulin Airport",
    city: "Yulin",
    countryId: "CN",
    timeZoneRegionName: "Asia/Chongqing",
    latitude: 38.3611,
    longitude: 109.5964,
    icao: "ZLYL"
  },
  UYU: {
    iata: "UYU",
    name: "Uyuni Airport",
    city: "Uyuni",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -20.4463,
    longitude: -66.8484,
    icao: "SLUY"
  },
  UZC: {
    iata: "UZC",
    name: "Ponikve Airport",
    city: "Uzice",
    countryId: "RS",
    timeZoneRegionName: "Europe/Belgrade",
    latitude: 43.898836,
    longitude: 19.697403,
    icao: "LYUE"
  },
  UZU: {
    iata: "UZU",
    name: "Curuzu Cuatia Airport",
    city: "Curuzu Cuatia",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -29.778889,
    longitude: -58.095556,
    icao: "SATU"
  },
  VAA: {
    iata: "VAA",
    name: "Vaasa Airport",
    city: "Vaasa",
    countryId: "FI",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 63.043549,
    longitude: 21.760123,
    icao: "EFVA"
  },
  VAC: {
    iata: "VAC",
    name: "Varrelbusch Airport",
    city: "Varrelbusch",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 52.916667,
    longitude: 8.05,
    icao: "EDWU"
  },
  VAD: {
    iata: "VAD",
    name: "Moody Air Force Base",
    city: "Valdosta",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 30.968364,
    longitude: -83.193053,
    icao: "KVAD"
  },
  VAF: {
    iata: "VAF",
    name: "Chabeuil Airport",
    city: "Valence",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 44.920278,
    longitude: 4.970278,
    icao: "LFLU"
  },
  VAG: {
    iata: "VAG",
    name: "Major-Brigadeiro Trompowsky Airport",
    city: "Varginha",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -21.586348,
    longitude: -45.473199,
    icao: "SBVG"
  },
  VAH: {
    iata: "VAH",
    name: "Vallegrande Airport",
    city: "Vallegrande",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -18.483333,
    longitude: -64.1,
    icao: "SLVG"
  },
  VAI: {
    iata: "VAI",
    name: "Vanimo Airport",
    city: "Vanimo",
    countryId: "PG",
    timeZoneRegionName: "Pacific/Port_Moresby",
    latitude: -2.687288,
    longitude: 141.298987,
    icao: "AYVN"
  },
  VAK: {
    iata: "VAK",
    name: "Chevak Airport",
    city: "Chevak",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 61.528611,
    longitude: -165.590278,
    icao: "PAVA"
  },
  VAM: {
    iata: "VAM",
    name: "Maamigili Island Airport",
    city: "Maamigili Island",
    countryId: "MV",
    timeZoneRegionName: "Indian/Maldives",
    latitude: 3.470556,
    longitude: 72.835833,
    icao: "VRMV"
  },
  VAN: {
    iata: "VAN",
    name: "Van Ferit Melen Airport",
    city: "Van",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 38.469878,
    longitude: 43.337264,
    icao: "LTCI"
  },
  VAO: {
    iata: "VAO",
    name: "Suavanao Airstrip Airport",
    city: "Suavanao",
    countryId: "SB",
    timeZoneRegionName: "Pacific/Guadalcanal",
    latitude: -7.58556,
    longitude: 158.731003,
    icao: "AGGV"
  },
  VAQ: {
    iata: "VAQ",
    name: "Vanavara Airport",
    city: "Vanavara",
    countryId: "RU",
    timeZoneRegionName: "Asia/Krasnoyarsk",
    latitude: 60.356229,
    longitude: 102.309641,
    icao: ""
  },
  VAR: {
    iata: "VAR",
    name: "Varna Airport",
    city: "Varna",
    countryId: "BG",
    timeZoneRegionName: "Europe/Sofia",
    latitude: 43.237258,
    longitude: 27.829096,
    icao: "LBWN"
  },
  VAS: {
    iata: "VAS",
    name: "Sivas Airport",
    city: "Sivas",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 39.813889,
    longitude: 36.904167,
    icao: "LTAR"
  },
  VAT: {
    iata: "VAT",
    name: "Vatomandry Airport",
    city: "Vatomandry",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -19.283333,
    longitude: 48.833333,
    icao: "FMMY"
  },
  VAV: {
    iata: "VAV",
    name: "Vava'u International Airport",
    city: "Vava'u",
    countryId: "TO",
    timeZoneRegionName: "Pacific/Tongatapu",
    latitude: -18.585537,
    longitude: -173.96436,
    icao: "NFTV"
  },
  VAW: {
    iata: "VAW",
    name: "Vardoe Airport",
    city: "Vardoe",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 70.354722,
    longitude: 31.045556,
    icao: "ENSS"
  },
  VBA: {
    iata: "VBA",
    name: "Ann Airport",
    city: "Ann",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 19.777449,
    longitude: 94.028292,
    icao: "VYAN"
  },
  VBC: {
    iata: "VBC",
    name: "Mandalay Chan Mya Thazi Airport",
    city: "Mandalay",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 21.940539,
    longitude: 96.089586,
    icao: "VYCZ"
  },
  VCS: {
    iata: "VCS",
    name: "Con Dao Airport",
    city: "Con Dao",
    countryId: "VN",
    timeZoneRegionName: "Asia/Ho_Chi_Minh",
    latitude: 8.73194,
    longitude: 106.6325,
    icao: ""
  },
  VBG: {
    iata: "VBG",
    name: "Vandenburg Air Force Base",
    city: "Lompoc",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 34.733805,
    longitude: -120.575367,
    icao: "KVBG"
  },
  VBP: {
    iata: "VBP",
    name: "Bokpyin Airport",
    city: "Bokpyin",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 11.266667,
    longitude: 98.766667,
    icao: "VYBP"
  },
  VBS: {
    iata: "VBS",
    name: "Montichiari Airport",
    city: "Brescia",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 45.425447,
    longitude: 10.326545,
    icao: "LIPO"
  },
  VBV: {
    iata: "VBV",
    name: "Vanua Balavu Airport",
    city: "Vanuabalavu",
    countryId: "FJ",
    timeZoneRegionName: "Pacific/Fiji",
    latitude: -17.246505,
    longitude: -178.956461,
    icao: "NFVB"
  },
  VBY: {
    iata: "VBY",
    name: "Visby Airport",
    city: "Visby",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 57.660447,
    longitude: 18.338154,
    icao: "ESSV"
  },
  VCA: {
    iata: "VCA",
    name: "Can Tho International Airport",
    city: "Can Tho",
    countryId: "VN",
    timeZoneRegionName: "Asia/Ho_Chi_Minh",
    latitude: 10.0852778,
    longitude: 105.71194444444444,
    icao: "VVCT"
  },
  VCD: {
    iata: "VCD",
    name: "Victoria River Downs Airport",
    city: "Victoria River Downs",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -16.4,
    longitude: 131,
    icao: "YVRD"
  },
  VCE: {
    iata: "VCE",
    name: "Venice Marco Polo Airport",
    city: "Venice",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 45.502285,
    longitude: 12.337947,
    icao: "LIPZ"
  },
  VCH: {
    iata: "VCH",
    name: "Vichadero Airport",
    city: "Vichadero",
    countryId: "UY",
    timeZoneRegionName: "America/Montevideo",
    latitude: -31.733333,
    longitude: -54.25,
    icao: "SUVO"
  },
  VCL: {
    iata: "VCL",
    name: "Chu Lai Airport",
    city: "Tam Ky",
    countryId: "VN",
    timeZoneRegionName: "Asia/Ho_Chi_Minh",
    latitude: 15.406111,
    longitude: 108.705556,
    icao: "VVCA"
  },
  VCP: {
    iata: "VCP",
    name: "Viracopos Airport",
    city: "Campinas",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -23.009892,
    longitude: -47.141673,
    icao: "SBKP"
  },
  VCR: {
    iata: "VCR",
    name: "Carora Airport",
    city: "Carora",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 10.183333,
    longitude: -70.083333,
    icao: "SVCO"
  },
  VCT: {
    iata: "VCT",
    name: "County-Foster Airport",
    city: "Victoria",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 28.851111,
    longitude: -96.914444,
    icao: "KVCT"
  },
  VCV: {
    iata: "VCV",
    name: "Southern California Logistics Airport",
    city: "Victorville",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 34.586573,
    longitude: -117.378251,
    icao: "KVCV"
  },
  VDA: {
    iata: "VDA",
    name: "Ovda Airport",
    city: "Ovda",
    countryId: "IL",
    timeZoneRegionName: "Asia/Jerusalem",
    latitude: 29.952014,
    longitude: 34.9339,
    icao: "LLOV"
  },
  VDB: {
    iata: "VDB",
    name: "Leirin Airport",
    city: "Fagernes",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 61.015556,
    longitude: 9.288056,
    icao: "ENFG"
  },
  VDC: {
    iata: "VDC",
    name: "Glauber Rocha Airport",
    city: "Vitoria Da Conquista",
    countryId: "BR",
    timeZoneRegionName: "America/Belem",
    latitude: -14.906944,
    longitude: -40.916111,
    icao: "SBQV"
  },
  VDE: {
    iata: "VDE",
    name: "Hierro Airport",
    city: "Valverde",
    countryId: "ES",
    timeZoneRegionName: "Atlantic/Canary",
    latitude: 27.813968,
    longitude: -17.884937,
    icao: "GCHI"
  },
  VDF: {
    iata: "VDF",
    name: "Tampa Executive Airport",
    city: "Tampa",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 28.010858,
    longitude: -82.342102,
    icao: "KVDF"
  },
  VDH: {
    iata: "VDH",
    name: "Dong Hoi Airport",
    city: "Dong Hoi",
    countryId: "VN",
    timeZoneRegionName: "Asia/Bangkok",
    latitude: 17.515,
    longitude: 106.590556,
    icao: "VVDH"
  },
  VDI: {
    iata: "VDI",
    name: "Vidalia Municipal Airport",
    city: "Vidalia",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 32.216667,
    longitude: -82.416667,
    icao: "KVDI"
  },
  VDM: {
    iata: "VDM",
    name: "Gobernador Edgardo Castello Airport",
    city: "Viedma",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -40.8692,
    longitude: -63.0004,
    icao: "SAVV"
  },
  VDO: {
    iata: "VDO",
    name: "Van Don International Airport",
    city: "Quang Ninh",
    countryId: "VN",
    timeZoneRegionName: "Asia/Ho_Chi_Minh",
    latitude: 21.113775,
    longitude: 107.419444,
    icao: "VVVD"
  },
  VDP: {
    iata: "VDP",
    name: "Valle de la Pascua Airport",
    city: "Valle de la Pascua",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 9.221389,
    longitude: -65.991111,
    icao: "SVVP"
  },
  VDR: {
    iata: "VDR",
    name: "Villa Dolores Airport",
    city: "Villa Dolores",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -31.941111,
    longitude: -65.142222,
    icao: "SAOD"
  },
  VDS: {
    iata: "VDS",
    name: "Vadso Airport",
    city: "Vadso",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 70.065,
    longitude: 29.845278,
    icao: "ENVD"
  },
  VDY: {
    iata: "VDY",
    name: "Jindal Airport",
    city: "Vijaynagar",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 15.174967,
    longitude: 76.634947,
    icao: "VOJV"
  },
  VDZ: {
    iata: "VDZ",
    name: "Pioneer Field",
    city: "Valdez",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 61.133913,
    longitude: -146.248026,
    icao: "PAVD"
  },
  VEE: {
    iata: "VEE",
    name: "Venetie Airport",
    city: "Venetie",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 67.008675,
    longitude: -146.366358,
    icao: "PAVE"
  },
  VEL: {
    iata: "VEL",
    name: "Vernal Regional Airport",
    city: "Vernal",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 40.438889,
    longitude: -109.510278,
    icao: "KVEL"
  },
  VEO: {
    iata: "VEO",
    name: "Severo-Yeniseyskiy Airport",
    city: "Yeniseyskiy",
    countryId: "RU",
    timeZoneRegionName: "Asia/Krasnoyarsk",
    latitude: 60.3733,
    longitude: 93.0117,
    icao: ""
  },
  VER: {
    iata: "VER",
    name: "Veracruz International Airport",
    city: "Veracruz",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 19.142275,
    longitude: -96.18321,
    icao: "MMVR"
  },
  VEY: {
    iata: "VEY",
    name: "Vestmannaeyjar Airport",
    city: "Vestmannaeyjar",
    countryId: "IS",
    timeZoneRegionName: "Atlantic/Reykjavik",
    latitude: 63.426389,
    longitude: -20.277778,
    icao: "BIVM"
  },
  VFA: {
    iata: "VFA",
    name: "Victoria Falls Airport",
    city: "Victoria Falls",
    countryId: "ZW",
    timeZoneRegionName: "Africa/Harare",
    latitude: -18.093056,
    longitude: 25.840278,
    icao: "FVFA"
  },
  VGA: {
    iata: "VGA",
    name: "Vijayawada Airport",
    city: "Vijayawada",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 16.529444,
    longitude: 80.797222,
    icao: "VOBZ"
  },
  VGO: {
    iata: "VGO",
    name: "Vigo Airport",
    city: "Vigo",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 42.224551,
    longitude: -8.634025,
    icao: "LEVX"
  },
  VGT: {
    iata: "VGT",
    name: "North Las Vegas Airport",
    city: "Las Vegas",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 36.210172,
    longitude: -115.190826,
    icao: "KVGT"
  },
  VGZ: {
    iata: "VGZ",
    name: "Villa Garzon Airport",
    city: "Villa Garzon",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 0.982125,
    longitude: -76.604937,
    icao: "SKVG"
  },
  VHC: {
    iata: "VHC",
    name: "Saurimo Airport",
    city: "Saurimo",
    countryId: "AO",
    timeZoneRegionName: "Africa/Luanda",
    latitude: -9.75,
    longitude: 20.55,
    icao: "FNSA"
  },
  VHM: {
    iata: "VHM",
    name: "Vilhelmina Airport",
    city: "Vilhelmina",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 64.579084,
    longitude: 16.833586,
    icao: "ESNV"
  },
  VHN: {
    iata: "VHN",
    name: "Culberson County Airport",
    city: "Van Horn",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 31.0578,
    longitude: -104.783997,
    icao: "KVHN"
  },
  VHY: {
    iata: "VHY",
    name: "Charmeil Airport",
    city: "Vichy",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 46.165556,
    longitude: 3.409722,
    icao: "LFLV"
  },
  VHZ: {
    iata: "VHZ",
    name: "Vahitahi Airport",
    city: "Vahitahi",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -18.583333,
    longitude: -138.833333,
    icao: "NTUV"
  },
  VIA: {
    iata: "VIA",
    name: "Videira Airport",
    city: "Videira",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -27.008333,
    longitude: -51.136111,
    icao: "SSVI"
  },
  VIC: {
    iata: "VIC",
    name: "Vicenza Airport",
    city: "Vicenza",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 45.55,
    longitude: 11.55,
    icao: "LIPT"
  },
  VIE: {
    iata: "VIE",
    name: "Vienna International Airport",
    city: "Vienna",
    countryId: "AT",
    timeZoneRegionName: "Europe/Vienna",
    latitude: 48.11972,
    longitude: 16.563583,
    icao: "LOWW"
  },
  VIG: {
    iata: "VIG",
    name: "El Vigia Airport",
    city: "El Vigia",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 8.633333,
    longitude: -71.65,
    icao: "SVVG"
  },
  VII: {
    iata: "VII",
    name: "Vinh Airport",
    city: "Vinh City",
    countryId: "VN",
    timeZoneRegionName: "Asia/Ho_Chi_Minh",
    latitude: 18.728766,
    longitude: 105.669709,
    icao: "VVVH"
  },
  VIJ: {
    iata: "VIJ",
    name: "Virgin Gorda Airport",
    city: "Virgin Gorda",
    countryId: "VG",
    timeZoneRegionName: "America/Tortola",
    latitude: 18.45027,
    longitude: -64.427735,
    icao: "TUPW"
  },
  VIL: {
    iata: "VIL",
    name: "Dakhla Airport",
    city: "Dakhla",
    countryId: "MA",
    timeZoneRegionName: "Africa/Casablanca",
    latitude: 23.714534,
    longitude: -15.929061,
    icao: "GMMH"
  },
  VIN: {
    iata: "VIN",
    name: "Havryshivka Vinnytsia International Airport",
    city: "Vinnytsia",
    countryId: "UA",
    timeZoneRegionName: "Europe/Kiev",
    latitude: 49.243126,
    longitude: 28.606481,
    icao: "UKWW"
  },
  VIR: {
    iata: "VIR",
    name: "Virginia Airport",
    city: "Durban",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -29.770839,
    longitude: 31.058088,
    icao: "FAVG"
  },
  VIS: {
    iata: "VIS",
    name: "Visalia Municipal Airport",
    city: "Visalia",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 36.319444,
    longitude: -119.393889,
    icao: "KVIS"
  },
  VIT: {
    iata: "VIT",
    name: "Vitoria Airport",
    city: "Vitoria",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 42.881961,
    longitude: -2.725372,
    icao: "LEVT"
  },
  VIX: {
    iata: "VIX",
    name: "Eurico de Aguiar Salles Airport",
    city: "Vitoria",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -20.256809,
    longitude: -40.289567,
    icao: "SBVT"
  },
  VJI: {
    iata: "VJI",
    name: "Virginia Highlands Airport",
    city: "Abingdon",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 36.686111,
    longitude: -82.033333,
    icao: "KVJI"
  },
  VKG: {
    iata: "VKG",
    name: "Rach Gia Airport",
    city: "Rach Gia",
    countryId: "VN",
    timeZoneRegionName: "Asia/Ho_Chi_Minh",
    latitude: 9.95803,
    longitude: 105.13238,
    icao: "VVRG"
  },
  VKO: {
    iata: "VKO",
    name: "Vnukovo Airport",
    city: "Moscow",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 55.60315,
    longitude: 37.292098,
    icao: "UUWW"
  },
  VKS: {
    iata: "VKS",
    name: "Vicksburg Airport",
    city: "Vicksburg",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.35,
    longitude: -90.85,
    icao: "KVKS"
  },
  VKT: {
    iata: "VKT",
    name: "Vorkuta Airport",
    city: "Vorkuta",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 67.486238,
    longitude: 63.995203,
    icao: "UUYW"
  },
  VLA: {
    iata: "VLA",
    name: "Vandalia Airport",
    city: "Vandalia",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 38.966667,
    longitude: -89.1,
    icao: "KVLA"
  },
  VLC: {
    iata: "VLC",
    name: "Valencia Airport",
    city: "Valencia",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 39.491792,
    longitude: -0.473475,
    icao: "LEVC"
  },
  VLD: {
    iata: "VLD",
    name: "Valdosta Regional Airport",
    city: "Valdosta",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 30.784051,
    longitude: -83.272354,
    icao: "KVLD"
  },
  VLG: {
    iata: "VLG",
    name: "Villa Gesell Airport",
    city: "Villa Gesell",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -37.236258,
    longitude: -57.025808,
    icao: "SAZV"
  },
  VLI: {
    iata: "VLI",
    name: "Port Vila Airport",
    city: "Port Vila",
    countryId: "VU",
    timeZoneRegionName: "Pacific/Efate",
    latitude: -17.701853,
    longitude: 168.319503,
    icao: "NVVV"
  },
  VLL: {
    iata: "VLL",
    name: "Valladolid Airport",
    city: "Valladolid",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 41.70581,
    longitude: -4.844626,
    icao: "LEVD"
  },
  VLM: {
    iata: "VLM",
    name: "Villamontes Airport",
    city: "Villamontes",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -21.25,
    longitude: -63.5,
    icao: "SLVM"
  },
  VLN: {
    iata: "VLN",
    name: "Arturo Michelena International Airport",
    city: "Valencia",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 10.15429,
    longitude: -67.922479,
    icao: "SVVA"
  },
  VLP: {
    iata: "VLP",
    name: "Vila Rica Municipal Airport",
    city: "Vila Rica",
    countryId: "BR",
    timeZoneRegionName: "America/Campo_Grande",
    latitude: -10.015556,
    longitude: -51.122222,
    icao: "SWVC"
  },
  VLR: {
    iata: "VLR",
    name: "Vallenar Airport",
    city: "Vallenar",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -28.591667,
    longitude: -70.761667,
    icao: "SCLL"
  },
  VLS: {
    iata: "VLS",
    name: "Valesdir Airport",
    city: "Valesdir",
    countryId: "VU",
    timeZoneRegionName: "Pacific/Efate",
    latitude: -16.800254,
    longitude: 168.179006,
    icao: "NVSV"
  },
  VLV: {
    iata: "VLV",
    name: "Colonel Antonio Nicolas Briceno Airport",
    city: "Valera",
    countryId: "VE",
    timeZoneRegionName: "America/Caracas",
    latitude: 9.33998,
    longitude: -70.585942,
    icao: "SVVL"
  },
  VLY: {
    iata: "VLY",
    name: "Anglesey Airport",
    city: "Valley",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 53.250359,
    longitude: -4.529017,
    icao: "EGOV"
  },
  VME: {
    iata: "VME",
    name: "Villa Reynolds Airport",
    city: "Villa Mercedes",
    countryId: "AR",
    timeZoneRegionName: "America/Argentina/Buenos_Aires",
    latitude: -33.724979,
    longitude: -65.378143,
    icao: "SAOR"
  },
  VNA: {
    iata: "VNA",
    name: "Saravane Airport",
    city: "Saravane",
    countryId: "LA",
    timeZoneRegionName: "Asia/Vientiane",
    latitude: 15.692778,
    longitude: 106.426111,
    icao: "VLSV"
  },
  VNC: {
    iata: "VNC",
    name: "Venice Municipal Airport",
    city: "Venice",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 27.077821,
    longitude: -82.438754,
    icao: "KVNC"
  },
  VND: {
    iata: "VND",
    name: "Vangaindrano Airport",
    city: "Vangaindrano",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -23.35,
    longitude: 47.566667,
    icao: "FMSU"
  },
  VNE: {
    iata: "VNE",
    name: "Meucon Airport",
    city: "Vannes",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 47.723301,
    longitude: -2.71856,
    icao: "LFRV"
  },
  VNO: {
    iata: "VNO",
    name: "Vilnius International Airport",
    city: "Vilnius",
    countryId: "LT",
    timeZoneRegionName: "Europe/Vilnius",
    latitude: 54.643079,
    longitude: 25.279605,
    icao: "EYVI"
  },
  VNS: {
    iata: "VNS",
    name: "Lal Bahadur Shastri International Airport",
    city: "Varanasi",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 25.449697,
    longitude: 82.853732,
    icao: "VIBN"
  },
  VNX: {
    iata: "VNX",
    name: "Vilanculos Airport",
    city: "Vilanculos",
    countryId: "MZ",
    timeZoneRegionName: "Africa/Maputo",
    latitude: -22.016667,
    longitude: 35.283333,
    icao: "FQVL"
  },
  VNY: {
    iata: "VNY",
    name: "Van Nuys Airport",
    city: "Los Angeles",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 34.21016,
    longitude: -118.490169,
    icao: "KVNY"
  },
  VOG: {
    iata: "VOG",
    name: "Volgograd International Airport",
    city: "Volgograd",
    countryId: "RU",
    timeZoneRegionName: "Europe/Volgograd",
    latitude: 48.792,
    longitude: 44.354805,
    icao: "URWW"
  },
  VOH: {
    iata: "VOH",
    name: "Vohemar Airport",
    city: "Vohemar",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -13.366667,
    longitude: 50,
    icao: "FMNV"
  },
  VOK: {
    iata: "VOK",
    name: "Volk Field",
    city: "Camp Douglas",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 43.937056,
    longitude: -90.256884,
    icao: "KVOK"
  },
  VOL: {
    iata: "VOL",
    name: "Nea Anchialos Airport",
    city: "Volos",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 39.220291,
    longitude: 22.792661,
    icao: "LGBL"
  },
  VOT: {
    iata: "VOT",
    name: "Votuporanga Airport",
    city: "Votuporanga",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -20.433333,
    longitude: -49.883333,
    icao: "SDVG"
  },
  VOZ: {
    iata: "VOZ",
    name: "Voronezh Airport",
    city: "Voronezh",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 51.812356,
    longitude: 39.226997,
    icao: "UUOO"
  },
  VPE: {
    iata: "VPE",
    name: "Ongiva Airport",
    city: "Ongiva",
    countryId: "AO",
    timeZoneRegionName: "Africa/Luanda",
    latitude: -17.047413,
    longitude: 15.689624,
    icao: "FNGI"
  },
  VPN: {
    iata: "VPN",
    name: "Vopnafjordur Airport",
    city: "Vopnafjordur",
    countryId: "IS",
    timeZoneRegionName: "Atlantic/Reykjavik",
    latitude: 65.720596,
    longitude: -14.8506,
    icao: "BIVO"
  },
  VPS: {
    iata: "VPS",
    name: "Destin Fort Walton Beach Airport",
    city: "Fort Walton Beach",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 30.495913,
    longitude: -86.549461,
    icao: "KVPS"
  },
  VPY: {
    iata: "VPY",
    name: "Chimoio Airport",
    city: "Chimoio",
    countryId: "MZ",
    timeZoneRegionName: "Africa/Maputo",
    latitude: -19.148927,
    longitude: 33.426891,
    icao: "FQCH"
  },
  VPZ: {
    iata: "VPZ",
    name: "Porter County Regional Airport",
    city: "Valparaiso",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.4525,
    longitude: -87.005278,
    icao: "KVPZ"
  },
  VQQ: {
    iata: "VQQ",
    name: "Cecil Airport",
    city: "Jacksonville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 30.220195,
    longitude: -81.874156,
    icao: "KVQQ"
  },
  VQS: {
    iata: "VQS",
    name: "Antonio Rivera Rodriguez Airport",
    city: "Vieques",
    countryId: "PR",
    timeZoneRegionName: "America/Puerto_Rico",
    latitude: 18.134088,
    longitude: -65.488031,
    icao: "TJVQ"
  },
  VRA: {
    iata: "VRA",
    name: "Juan Gualberto Gomez Airport",
    city: "Varadero",
    countryId: "CU",
    timeZoneRegionName: "America/Havana",
    latitude: 23.039896,
    longitude: -81.436943,
    icao: "MUVR"
  },
  VRB: {
    iata: "VRB",
    name: "Vero Beach Municipal Airport",
    city: "Vero Beach",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 27.6525,
    longitude: -80.413611,
    icao: "KVRB"
  },
  VRC: {
    iata: "VRC",
    name: "Virac Airport",
    city: "Virac",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 13.579579,
    longitude: 124.211873,
    icao: "RPUV"
  },
  VRE: {
    iata: "VRE",
    name: "Vredendal Airport",
    city: "Vredendal",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -31.666667,
    longitude: 18.5,
    icao: "FAVR"
  },
  VRK: {
    iata: "VRK",
    name: "Varkaus Airport",
    city: "Varkaus",
    countryId: "FI",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 62.172505,
    longitude: 27.861281,
    icao: "EFVR"
  },
  VRL: {
    iata: "VRL",
    name: "Vila Real Airport",
    city: "Vila Real",
    countryId: "PT",
    timeZoneRegionName: "Europe/Lisbon",
    latitude: 41.275892,
    longitude: -7.719278,
    icao: "LPVR"
  },
  VRN: {
    iata: "VRN",
    name: "Verona Villafranca Airport",
    city: "Verona",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 45.40233,
    longitude: 10.906796,
    icao: "LIPX"
  },
  VRU: {
    iata: "VRU",
    name: "Vryburg Airport",
    city: "Vryburg",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -26.916667,
    longitude: 24.75,
    icao: "FAVB"
  },
  VSA: {
    iata: "VSA",
    name: "Carlos Rovirosa Perez International Airport",
    city: "Villahermosa",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 17.992429,
    longitude: -92.818987,
    icao: "MMVA"
  },
  VSE: {
    iata: "VSE",
    name: "Viseu Airport",
    city: "Viseu",
    countryId: "PT",
    timeZoneRegionName: "Europe/Lisbon",
    latitude: 40.722683,
    longitude: -7.889235,
    icao: "LPVZ"
  },
  VSF: {
    iata: "VSF",
    name: "Hartness State Airport",
    city: "Springfield",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 43.341625,
    longitude: -72.524756,
    icao: "KVSF"
  },
  VST: {
    iata: "VST",
    name: "Vasteras/Hasslo Airport",
    city: "Stockholm",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 59.589167,
    longitude: 16.630556,
    icao: "ESOW"
  },
  VTB: {
    iata: "VTB",
    name: "Vitebsk Airport",
    city: "Vitebsk",
    countryId: "BY",
    timeZoneRegionName: "Europe/Minsk",
    latitude: 55.13008,
    longitude: 30.35506,
    icao: "UMII"
  },
  VTE: {
    iata: "VTE",
    name: "Wattay International Airport",
    city: "Vientiane",
    countryId: "LA",
    timeZoneRegionName: "Asia/Vientiane",
    latitude: 17.975432,
    longitude: 102.567721,
    icao: "VLVT"
  },
  VTL: {
    iata: "VTL",
    name: "Vittel Airport",
    city: "Vittel",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 48.2,
    longitude: 5.95,
    icao: "LFSZ"
  },
  VTM: {
    iata: "VTM",
    name: "Nevatim Air Force Base",
    city: "Nevatim",
    countryId: "IL",
    timeZoneRegionName: "Asia/Jerusalem",
    latitude: 31.2083,
    longitude: 35.012299,
    icao: "LLNV"
  },
  VTN: {
    iata: "VTN",
    name: "Miller Field",
    city: "Valentine",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 42.866667,
    longitude: -100.55,
    icao: "KVTN"
  },
  VTU: {
    iata: "VTU",
    name: "Hermanos Ameijeiras Airport",
    city: "Las Tunas",
    countryId: "CU",
    timeZoneRegionName: "America/Havana",
    latitude: 20.985606,
    longitude: -76.939842,
    icao: "MUVT"
  },
  VTZ: {
    iata: "VTZ",
    name: "Vishakhapatnam Airport",
    city: "Vishakhapatnam",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 17.723596,
    longitude: 83.22768,
    icao: "VEVZ"
  },
  VUP: {
    iata: "VUP",
    name: "Valledupar Airport",
    city: "Valledupar",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 10.436667,
    longitude: -73.252778,
    icao: "SKVP"
  },
  VUS: {
    iata: "VUS",
    name: "Veliky Ustyug Airport",
    city: "Velikij Ustyug",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 60.766667,
    longitude: 46.316667,
    icao: ""
  },
  VVB: {
    iata: "VVB",
    name: "Mahanoro Airport",
    city: "Mahanoro",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -19.833333,
    longitude: 48.8,
    icao: "FMMH"
  },
  VVC: {
    iata: "VVC",
    name: "Vanguardia Airport",
    city: "Villavicencio",
    countryId: "CO",
    timeZoneRegionName: "America/Bogota",
    latitude: 4.167867,
    longitude: -73.613773,
    icao: "SKVV"
  },
  VVI: {
    iata: "VVI",
    name: "Viru Viru International Airport",
    city: "Santa Cruz",
    countryId: "BO",
    timeZoneRegionName: "America/La_Paz",
    latitude: -17.648234,
    longitude: -63.140489,
    icao: "SLVR"
  },
  VVK: {
    iata: "VVK",
    name: "Vastervik Airport",
    city: "Vastervik",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 57.75,
    longitude: 16.633333,
    icao: "ESSW"
  },
  VVN: {
    iata: "VVN",
    name: "Malvinas Airport",
    city: "Malvinas",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -11.85,
    longitude: -72.940278,
    icao: "SPWT"
  },
  VVO: {
    iata: "VVO",
    name: "Vladivostok International Airport",
    city: "Vladivostok",
    countryId: "RU",
    timeZoneRegionName: "Asia/Vladivostok",
    latitude: 43.396342,
    longitude: 132.165372,
    icao: "UHWW"
  },
  VVZ: {
    iata: "VVZ",
    name: "Illizi Airport",
    city: "Illizi",
    countryId: "DZ",
    timeZoneRegionName: "Africa/Algiers",
    latitude: 26.533333,
    longitude: 8.55,
    icao: "DAAP"
  },
  VXC: {
    iata: "VXC",
    name: "Lichinga Airport",
    city: "Lichinga",
    countryId: "MZ",
    timeZoneRegionName: "Africa/Maputo",
    latitude: -13.283333,
    longitude: 35.25,
    icao: "FQLC"
  },
  VXE: {
    iata: "VXE",
    name: "Cesaria Evora International Airport",
    city: "Sao Vicente",
    countryId: "CV",
    timeZoneRegionName: "Atlantic/Cape_Verde",
    latitude: 16.837258,
    longitude: -25.054359,
    icao: "GVSV"
  },
  VXO: {
    iata: "VXO",
    name: "Vaxjo Airport",
    city: "Vaxjo",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 56.925094,
    longitude: 14.732046,
    icao: "ESMX"
  },
  VYD: {
    iata: "VYD",
    name: "Vryheid Airport",
    city: "Vryheid",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -27.783333,
    longitude: 30.8,
    icao: "FAVY"
  },
  VYS: {
    iata: "VYS",
    name: "Illinois Valley Regional Airport",
    city: "Peru",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 41.333333,
    longitude: -89.133333,
    icao: "KVYS"
  },
  WAA: {
    iata: "WAA",
    name: "Wales Airport",
    city: "Wales",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 65.617222,
    longitude: -168.090833,
    icao: "PAIW"
  },
  WAC: {
    iata: "WAC",
    name: "Waca Airport",
    city: "Waca",
    countryId: "ET",
    timeZoneRegionName: "Africa/Addis_Ababa",
    latitude: 7.166667,
    longitude: 37.166667,
    icao: "HAWC"
  },
  WAE: {
    iata: "WAE",
    name: "Wadi Ad Dawasir Airport",
    city: "Wadi Ad Dawasir",
    countryId: "SA",
    timeZoneRegionName: "Asia/Riyadh",
    latitude: 20.498443,
    longitude: 45.204447,
    icao: "OEWD"
  },
  WAG: {
    iata: "WAG",
    name: "Wanganui Airport",
    city: "Wanganui",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -39.960921,
    longitude: 175.024443,
    icao: "NZWU"
  },
  WAH: {
    iata: "WAH",
    name: "Wahpeton Airport",
    city: "Wahpeton",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 46.266667,
    longitude: -96.6,
    icao: "KBWP"
  },
  WAI: {
    iata: "WAI",
    name: "Ambalabe Airport",
    city: "Antsohihy",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -14.89875,
    longitude: 47.993895,
    icao: "FMNW"
  },
  WAK: {
    iata: "WAK",
    name: "Ankazoabo Airport",
    city: "Ankazoabo",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -22.3,
    longitude: 44.533333,
    icao: "FMSZ"
  },
  WAL: {
    iata: "WAL",
    name: "Wallops Flight Facility",
    city: "Chincoteague",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 37.941166,
    longitude: -75.468061,
    icao: "KWAL"
  },
  WAM: {
    iata: "WAM",
    name: "Ambatondrazaka Airport",
    city: "Ambatondrazaka",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -17.8,
    longitude: 48.433333,
    icao: "FMMZ"
  },
  WAQ: {
    iata: "WAQ",
    name: "Antsalova Airport",
    city: "Antsalova",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -18.7,
    longitude: 44.616667,
    icao: "FMMG"
  },
  WAT: {
    iata: "WAT",
    name: "Waterford Airport",
    city: "Waterford",
    countryId: "IE",
    timeZoneRegionName: "Europe/Dublin",
    latitude: 52.188932,
    longitude: -7.081527,
    icao: "EIWF"
  },
  WAV: {
    iata: "WAV",
    name: "Kalkgurung Airport",
    city: "Wave Hill",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -17.483333,
    longitude: 130.95,
    icao: "YWAV"
  },
  WAW: {
    iata: "WAW",
    name: "Frederic Chopin Airport",
    city: "Warsaw",
    countryId: "PL",
    timeZoneRegionName: "Europe/Warsaw",
    latitude: 52.170906,
    longitude: 20.973289,
    icao: "EPWA"
  },
  WAY: {
    iata: "WAY",
    name: "Green County Airport",
    city: "Waynesburg",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.75,
    longitude: -77.583333,
    icao: "KWAY"
  },
  WBB: {
    iata: "WBB",
    name: "Stebbins Airport",
    city: "Stebbins",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 63.515411,
    longitude: -162.284634,
    icao: ""
  },
  WBD: {
    iata: "WBD",
    name: "Befandriana Airport",
    city: "Befandriana",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -15.2,
    longitude: 48.483333,
    icao: "FMNF"
  },
  WBG: {
    iata: "WBG",
    name: "Schleswig Airport",
    city: "Schleswig",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 54.45,
    longitude: 9.516667,
    icao: "ETNS"
  },
  WBM: {
    iata: "WBM",
    name: "Wapenamanda Airport",
    city: "Wapenamanda",
    countryId: "PG",
    timeZoneRegionName: "Pacific/Port_Moresby",
    latitude: -5.633084,
    longitude: 143.89102,
    icao: "AYWD"
  },
  WBO: {
    iata: "WBO",
    name: "Beroroha Airport",
    city: "Beroroha",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -21.6,
    longitude: 45.133333,
    icao: "FMSB"
  },
  WBR: {
    iata: "WBR",
    name: "Big Rapids Airport",
    city: "Big Rapids",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 43.7,
    longitude: -85.483333,
    icao: "KRQB"
  },
  WBW: {
    iata: "WBW",
    name: "Wyoming Valle Airport",
    city: "Wilkes-Barre",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.233333,
    longitude: -75.883333,
    icao: "KWBW"
  },
  WCH: {
    iata: "WCH",
    name: "Nuevo Chaiten Airport",
    city: "Chaiten",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -42.782222,
    longitude: -72.833889,
    icao: "SCTN"
  },
  WCR: {
    iata: "WCR",
    name: "Chandalar Airport",
    city: "Chandalar",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 67.505556,
    longitude: -148.5,
    icao: "PALR"
  },
  WDG: {
    iata: "WDG",
    name: "Enid Woodring Municipal Airport",
    city: "Enid",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.383604,
    longitude: -97.788232,
    icao: "KWDG"
  },
  WDH: {
    iata: "WDH",
    name: "Hosea Kutako International Airport",
    city: "Windhoek",
    countryId: "NA",
    timeZoneRegionName: "Africa/Windhoek",
    latitude: -22.487345,
    longitude: 17.463202,
    icao: "FYWH"
  },
  WDI: {
    iata: "WDI",
    name: "Wondai Airport",
    city: "Wondai",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -26.333333,
    longitude: 151.816667,
    icao: "YWND"
  },
  WDR: {
    iata: "WDR",
    name: "Winder Airport",
    city: "Winder",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 33.983333,
    longitude: -83.716667,
    icao: "KWDR"
  },
  WDS: {
    iata: "WDS",
    name: "Shiyan Wudangshan Airport",
    city: "Shiyan",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 32.589946,
    longitude: 110.906355,
    icao: "ZHSY"
  },
  WEA: {
    iata: "WEA",
    name: "Parker County Airport",
    city: "Weatherford",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 32.766667,
    longitude: -97.8,
    icao: "KWEA"
  },
  WEF: {
    iata: "WEF",
    name: "Weifang Airport",
    city: "Weifang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 36.641074,
    longitude: 119.113469,
    icao: "ZSWF"
  },
  WEH: {
    iata: "WEH",
    name: "Weihai Dashuibo Airport",
    city: "Weihai",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 37.186944,
    longitude: 122.228889,
    icao: "ZSWH"
  },
  WEI: {
    iata: "WEI",
    name: "Weipa Airport",
    city: "Weipa",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -12.681317,
    longitude: 141.924697,
    icao: "YBWP"
  },
  WEL: {
    iata: "WEL",
    name: "Welkom Airport",
    city: "Welkom",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -28,
    longitude: 26.75,
    icao: "FAWM"
  },
  WEW: {
    iata: "WEW",
    name: "Wee Waa Airport",
    city: "Wee Waa",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -30.233333,
    longitude: 149.433333,
    icao: "YWWA"
  },
  WFD: {
    iata: "WFD",
    name: "Manchester Woodford Airport",
    city: "Woodford",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 53.338056,
    longitude: -2.148889,
    icao: "EGCD"
  },
  WFI: {
    iata: "WFI",
    name: "Fianarantsoa Airport",
    city: "Fianarantsoa",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -21.441319,
    longitude: 47.110553,
    icao: "FMSF"
  },
  WFK: {
    iata: "WFK",
    name: "Frenchville Airport",
    city: "Frenchville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 47.35,
    longitude: -68.333333,
    icao: "KFVE"
  },
  WGA: {
    iata: "WGA",
    name: "Wagga Wagga Airport",
    city: "Wagga Wagga",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -35.159918,
    longitude: 147.466265,
    icao: "YSWG"
  },
  WGC: {
    iata: "WGC",
    name: "Warangal Airport",
    city: "Warangal",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 17.916667,
    longitude: 79.6,
    icao: "VOWA"
  },
  WGE: {
    iata: "WGE",
    name: "Walgett Airport",
    city: "Walgett",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -30.033333,
    longitude: 148.133333,
    icao: "YWLG"
  },
  WGN: {
    iata: "WGN",
    name: "Shaoyang Wugang Airport",
    city: "Shaoyang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 26.802,
    longitude: 110.642,
    icao: ""
  },
  WGO: {
    iata: "WGO",
    name: "Winchester Regional Airport",
    city: "Winchester",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.143356,
    longitude: -78.147094,
    icao: "KOKV"
  },
  WGP: {
    iata: "WGP",
    name: "Umbu Mehang Kunda Airport",
    city: "Waingapu",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -9.669213,
    longitude: 120.302005,
    icao: "WADW"
  },
  WGT: {
    iata: "WGT",
    name: "Wangaratta Airport",
    city: "Wangaratta",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -36.366667,
    longitude: 146.333333,
    icao: "YWGT"
  },
  WHA: {
    iata: "WHA",
    name: "Wuhu Xuanzhou Airport",
    city: "Wuhu",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 31.097724,
    longitude: 118.65323,
    icao: ""
  },
  WHF: {
    iata: "WHF",
    name: "Wadi Halfa Airport",
    city: "Wadi Halfa",
    countryId: "SD",
    timeZoneRegionName: "Africa/Khartoum",
    latitude: 21.75,
    longitude: 31.5,
    icao: "HSSW"
  },
  WHK: {
    iata: "WHK",
    name: "Whakatane Airport",
    city: "Whakatane",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -37.924676,
    longitude: 176.917483,
    icao: "NZWK"
  },
  WHP: {
    iata: "WHP",
    name: "Whiteman Airport",
    city: "Los Angeles",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 34.05,
    longitude: -118.25,
    icao: "KWHP"
  },
  WHS: {
    iata: "WHS",
    name: "Whalsay Airport",
    city: "Whalsay",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 60.376935,
    longitude: -0.921905,
    icao: "EGEH"
  },
  WIC: {
    iata: "WIC",
    name: "Wick Airport",
    city: "Wick",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 58.456944,
    longitude: -3.086667,
    icao: "EGPC"
  },
  WIE: {
    iata: "WIE",
    name: "Wiesbaden Army Airfield",
    city: "Wiesbaden",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 50.04957,
    longitude: 8.324533,
    icao: "ETOU"
  },
  WIL: {
    iata: "WIL",
    name: "Wilson Airport",
    city: "Nairobi",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: -1.318018,
    longitude: 36.813246,
    icao: "HKNW"
  },
  WIN: {
    iata: "WIN",
    name: "Winton Airport",
    city: "Winton",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -22.35,
    longitude: 143.066667,
    icao: "YWTN"
  },
  WIO: {
    iata: "WIO",
    name: "Wilcannia Airport",
    city: "Wilcannia",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -31.083333,
    longitude: 143.55,
    icao: "YWCA"
  },
  WIR: {
    iata: "WIR",
    name: "Wairoa Airport",
    city: "Wairoa",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -39.014772,
    longitude: 177.405358,
    icao: "NZWO"
  },
  WIU: {
    iata: "WIU",
    name: "Witu Airport",
    city: "Witu",
    countryId: "PG",
    timeZoneRegionName: "Pacific/Port_Moresby",
    latitude: -4.666667,
    longitude: 149.5,
    icao: "WITU"
  },
  WJF: {
    iata: "WJF",
    name: "General William J Fox Airfield",
    city: "Lancaster",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 34.740316,
    longitude: -118.218185,
    icao: "KWJF"
  },
  WJR: {
    iata: "WJR",
    name: "Wajir Airport",
    city: "Wajir",
    countryId: "KE",
    timeZoneRegionName: "Africa/Nairobi",
    latitude: 1.73306,
    longitude: 40.09167,
    icao: "HKWJ"
  },
  WJU: {
    iata: "WJU",
    name: "Wonju Airport",
    city: "Wonju",
    countryId: "KR",
    timeZoneRegionName: "Asia/Seoul",
    latitude: 37.441926,
    longitude: 127.965838,
    icao: "RKNW"
  },
  WKA: {
    iata: "WKA",
    name: "Wanaka Airport",
    city: "Wanaka",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -44.723358,
    longitude: 169.244242,
    icao: "NZWF"
  },
  WKB: {
    iata: "WKB",
    name: "Warracknabeal Airport",
    city: "Warracknabeal",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -36.15,
    longitude: 142.433333,
    icao: "YWKB"
  },
  WKF: {
    iata: "WKF",
    name: "Waterkloof Air Force Base",
    city: "Waterkloof",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -25.834892,
    longitude: 28.2225,
    icao: "FAWK"
  },
  WKI: {
    iata: "WKI",
    name: "Hwange Airport",
    city: "Hwange",
    countryId: "ZW",
    timeZoneRegionName: "Africa/Harare",
    latitude: -18.3625,
    longitude: 26.518333,
    icao: "FVWT"
  },
  WKJ: {
    iata: "WKJ",
    name: "Hokkaido Airport",
    city: "Wakkanai",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 45.399428,
    longitude: 141.797398,
    icao: "RJCW"
  },
  WLD: {
    iata: "WLD",
    name: "Strother Field",
    city: "Winfield",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 37.168594,
    longitude: -97.037597,
    icao: "KWLD"
  },
  WLE: {
    iata: "WLE",
    name: "Miles Airport",
    city: "Miles",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -26.809167,
    longitude: 150.165,
    icao: ""
  },
  WLG: {
    iata: "WLG",
    name: "Wellington International Airport",
    city: "Wellington",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -41.329036,
    longitude: 174.812163,
    icao: "NZWN"
  },
  WLH: {
    iata: "WLH",
    name: "Walaha Airport",
    city: "Walaha",
    countryId: "VU",
    timeZoneRegionName: "Pacific/Efate",
    latitude: -15.412913,
    longitude: 167.691593,
    icao: "NVSW"
  },
  WLK: {
    iata: "WLK",
    name: "Selawik Airport",
    city: "Selawik",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 66.602778,
    longitude: -159.983333,
    icao: "PASK"
  },
  WLP: {
    iata: "WLP",
    name: "West Angelas Airport",
    city: "West Angelas",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -23.135729,
    longitude: 118.70739,
    icao: "YANG"
  },
  WLS: {
    iata: "WLS",
    name: "Wallis Island Airport",
    city: "Wallis Island",
    countryId: "WF",
    timeZoneRegionName: "Pacific/Wallis",
    latitude: -13.233333,
    longitude: -176.166667,
    icao: "NLWW"
  },
  WLW: {
    iata: "WLW",
    name: "Glenn County Airport",
    city: "Willows",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 39.516399,
    longitude: -122.218002,
    icao: "KWLW"
  },
  WMA: {
    iata: "WMA",
    name: "Mandritsara Airport",
    city: "Mandritsara",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -15.833333,
    longitude: 48.833333,
    icao: "FMNX"
  },
  WMB: {
    iata: "WMB",
    name: "Warrnambool Airport",
    city: "Warrnambool",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -38.295,
    longitude: 142.448333,
    icao: "YWBL"
  },
  WMC: {
    iata: "WMC",
    name: "Winnemucca Municipal Airport",
    city: "Winnemucca",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 40.904331,
    longitude: -117.806942,
    icao: "KWMC"
  },
  WMD: {
    iata: "WMD",
    name: "Mandabe Airport",
    city: "Mandabe",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -21.033333,
    longitude: 44.95,
    icao: "FMSC"
  },
  WME: {
    iata: "WME",
    name: "Mount Keith Airport",
    city: "Mount Keith",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -27.284315,
    longitude: 120.550259,
    icao: "YMNE"
  },
  WMH: {
    iata: "WMH",
    name: "Mountain Home Airport",
    city: "Mountain Home",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.333333,
    longitude: -92.383333,
    icao: "KBPK"
  },
  WMI: {
    iata: "WMI",
    name: "Warsaw-Modlin Airport",
    city: "Modlin",
    countryId: "PL",
    timeZoneRegionName: "Europe/Warsaw",
    latitude: 52.451111,
    longitude: 20.651667,
    icao: "EPMO"
  },
  WML: {
    iata: "WML",
    name: "Malaimbandy Airport",
    city: "Malaimbandy",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -20.35,
    longitude: 45.55,
    icao: "FMMC"
  },
  WMN: {
    iata: "WMN",
    name: "Maroantsetra Airport",
    city: "Maroantsetra",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -15.436459,
    longitude: 49.690302,
    icao: "FMNR"
  },
  WMO: {
    iata: "WMO",
    name: "White Mountain Airport",
    city: "White Mountain",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 64.686944,
    longitude: -163.406667,
    icao: "PAWM"
  },
  WMR: {
    iata: "WMR",
    name: "Mananara Nord Airport",
    city: "Mananara",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -16.164107,
    longitude: 49.774969,
    icao: "FMNC"
  },
  WMT: {
    iata: "WMT",
    name: "Zunyi Maotai Airport",
    city: "Zunyi",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 27.96222,
    longitude: 106.435,
    icao: ""
  },
  WMX: {
    iata: "WMX",
    name: "Wamena Airport",
    city: "Wamena",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jayapura",
    latitude: -4.099906,
    longitude: 138.953592,
    icao: "WAJW"
  },
  WNH: {
    iata: "WNH",
    name: "Wenshan Puzhehei Airport",
    city: "Wenshan",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 23.566683,
    longitude: 104.330926,
    icao: "ZPWS"
  },
  WNI: {
    iata: "WNI",
    name: "Wangi Wangi Matahora Airport",
    city: "Wangiwangi Island",
    countryId: "ID",
    timeZoneRegionName: "Asia/Makassar",
    latitude: -5.290556,
    longitude: 123.635,
    icao: "WAWD"
  },
  WNN: {
    iata: "WNN",
    name: "Wunnummin Lake Airport",
    city: "Wunnummin Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 52.916667,
    longitude: -89.166667,
    icao: "CKL3"
  },
  WNP: {
    iata: "WNP",
    name: "Naga Airport",
    city: "Naga",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 13.587222,
    longitude: 123.27,
    icao: "RPUN"
  },
  WNR: {
    iata: "WNR",
    name: "Windorah Airport",
    city: "Windorah",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -25.416667,
    longitude: 142.666667,
    icao: "YWDH"
  },
  WNS: {
    iata: "WNS",
    name: "Nawabshah Airport",
    city: "Nawabshah",
    countryId: "PK",
    timeZoneRegionName: "Asia/Karachi",
    latitude: 26.219444,
    longitude: 68.392222,
    icao: "OPNH"
  },
  WNZ: {
    iata: "WNZ",
    name: "Wenzhou Longwan International Airport",
    city: "Wenzhou",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 27.91566,
    longitude: 120.847381,
    icao: "ZSWZ"
  },
  WOE: {
    iata: "WOE",
    name: "Woensdrecht Air Base",
    city: "Woensdrecht Ab",
    countryId: "NL",
    timeZoneRegionName: "Europe/Amsterdam",
    latitude: 51.449072,
    longitude: 4.342054,
    icao: "EHWO"
  },
  WOL: {
    iata: "WOL",
    name: "Illawara Airport",
    city: "Wollongong",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -34.561352,
    longitude: 150.788885,
    icao: "YWOL"
  },
  WOW: {
    iata: "WOW",
    name: "Willow Airport",
    city: "Willow",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 61.833333,
    longitude: -150.166667,
    icao: "PAUO"
  },
  WPA: {
    iata: "WPA",
    name: "Puerto Aisen Airport",
    city: "Puerto Aisen",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -45.4,
    longitude: -72.7,
    icao: "SCAS"
  },
  WPB: {
    iata: "WPB",
    name: "Port Berge Airport",
    city: "Port Berge",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -15.55,
    longitude: 47.666667,
    icao: "FMNG"
  },
  WPC: {
    iata: "WPC",
    name: "Pincher Creek Airport",
    city: "Pincher Creek",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 49.483333,
    longitude: -113.95,
    icao: "CZPC"
  },
  WPR: {
    iata: "WPR",
    name: "Captain F. Martinez Airport",
    city: "Porvenir",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -53.252626,
    longitude: -70.323942,
    icao: "SCFM"
  },
  WPU: {
    iata: "WPU",
    name: "Guardiamarina Zanartu Airport",
    city: "Puerto Williams",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -54.931099,
    longitude: -67.626297,
    icao: "SCGZ"
  },
  WRB: {
    iata: "WRB",
    name: "Robins Air Force Base",
    city: "Macon",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 32.636712,
    longitude: -83.58806,
    icao: "KWRB"
  },
  WRE: {
    iata: "WRE",
    name: "Whangarei Airport",
    city: "Whangarei",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -35.767422,
    longitude: 174.364026,
    icao: "NZWR"
  },
  WRG: {
    iata: "WRG",
    name: "Wrangell Airport",
    city: "Wrangell",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 56.484444,
    longitude: -132.366667,
    icao: "PAWG"
  },
  WRI: {
    iata: "WRI",
    name: "McGuire Air Force Base",
    city: "Trenton",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.014634,
    longitude: -74.592989,
    icao: "KWRI"
  },
  WRL: {
    iata: "WRL",
    name: "Worland Airport",
    city: "Worland",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 43.9675,
    longitude: -107.953056,
    icao: "KWRL"
  },
  WRN: {
    iata: "WRN",
    name: "Windarling Airport",
    city: "Windarling",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -30.032337,
    longitude: 119.386493,
    icao: "YWDG"
  },
  WRO: {
    iata: "WRO",
    name: "Wroclaw Airport",
    city: "Wroclaw",
    countryId: "PL",
    timeZoneRegionName: "Europe/Warsaw",
    latitude: 51.104822,
    longitude: 16.899403,
    icao: "EPWR"
  },
  WRY: {
    iata: "WRY",
    name: "Westray Airport",
    city: "Westray",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 59.35,
    longitude: -2.95,
    icao: "EGEW"
  },
  WRZ: {
    iata: "WRZ",
    name: "Weerawila Airport",
    city: "Weerawila",
    countryId: "LK",
    timeZoneRegionName: "Asia/Colombo",
    latitude: 6.254053,
    longitude: 81.234569,
    icao: "VCCW"
  },
  WSG: {
    iata: "WSG",
    name: "County Airport",
    city: "Washington",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.166667,
    longitude: -80.25,
    icao: "KAFJ"
  },
  WSH: {
    iata: "WSH",
    name: "Brookhaven Airport",
    city: "Shirley",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.821899,
    longitude: -72.8694,
    icao: "KHWV"
  },
  WSK: {
    iata: "WSK",
    name: "Chongqing Wushan Airport",
    city: "Wushan",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 31.068889,
    longitude: 109.709167,
    icao: ""
  },
  WSN: {
    iata: "WSN",
    name: "South Naknek Airport",
    city: "South Naknek",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 58.702779,
    longitude: -157.004018,
    icao: "PFWS"
  },
  WST: {
    iata: "WST",
    name: "Westerly State Airport",
    city: "Westerly",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.350194,
    longitude: -71.806897,
    icao: "KWST"
  },
  WSZ: {
    iata: "WSZ",
    name: "Westport Airport",
    city: "Westport",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -41.74002,
    longitude: 171.578577,
    icao: "NZWS"
  },
  WTA: {
    iata: "WTA",
    name: "Tambohorano Airport",
    city: "Tambohorano",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -17.483333,
    longitude: 43.966667,
    icao: "FMMU"
  },
  WTB: {
    iata: "WTB",
    name: "Toowoomba Wellcamp Airport",
    city: "Wellcamp",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -27.558611,
    longitude: 151.795,
    icao: "YBWW"
  },
  WTK: {
    iata: "WTK",
    name: "Noatak Airport",
    city: "Noatak",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 67.563056,
    longitude: -162.984167,
    icao: "PAWN"
  },
  WTL: {
    iata: "WTL",
    name: "Tuntutuliak Airport",
    city: "Tuntutuliak",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 60.35,
    longitude: -162.633333,
    icao: ""
  },
  WTN: {
    iata: "WTN",
    name: "Waddington RAF Station",
    city: "Waddington",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 53.166211,
    longitude: -0.523825,
    icao: "EGXW"
  },
  WTO: {
    iata: "WTO",
    name: "Wotho Airport",
    city: "Wotho",
    countryId: "MH",
    timeZoneRegionName: "Pacific/Majuro",
    latitude: 10.166667,
    longitude: 166.033333,
    icao: "CWTO"
  },
  WTS: {
    iata: "WTS",
    name: "Tsiroanomandidy Airport",
    city: "Tsiroanomandidy",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -18.757222,
    longitude: 46.054444,
    icao: "FMMX"
  },
  WUA: {
    iata: "WUA",
    name: "Wuhai Airport",
    city: "Wu Hai",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 39.791432,
    longitude: 106.801862,
    icao: ""
  },
  WUD: {
    iata: "WUD",
    name: "Wudinna Airport",
    city: "Wudinna",
    countryId: "AU",
    timeZoneRegionName: "Australia/Adelaide",
    latitude: -33.043301,
    longitude: 135.447006,
    icao: "YWUD"
  },
  WUH: {
    iata: "WUH",
    name: "Wuhan Tianhe International Airport",
    city: "Wuhan",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 30.776789,
    longitude: 114.217577,
    icao: "ZHHH"
  },
  WUI: {
    iata: "WUI",
    name: "Murrin Murrin Airport",
    city: "Murrin Murrin",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -28.710743,
    longitude: 121.886149,
    icao: "YMMI"
  },
  WUN: {
    iata: "WUN",
    name: "Wiluna Airport",
    city: "Wiluna",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -26.628151,
    longitude: 120.220082,
    icao: "YWLU"
  },
  WUS: {
    iata: "WUS",
    name: "Wuyishan Airport",
    city: "Wuyishan",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 27.701284,
    longitude: 118.000604,
    icao: "ZSWY"
  },
  WUT: {
    iata: "WUT",
    name: "Xinzhou Wutaishan Airport",
    city: "Xinzhou",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 38.59809,
    longitude: 112.98215,
    icao: ""
  },
  WUU: {
    iata: "WUU",
    name: "Wau Airport",
    city: "Wau",
    countryId: "SS",
    timeZoneRegionName: "Africa/Juba",
    latitude: 7.724391,
    longitude: 27.978742,
    icao: "HSWW"
  },
  WUX: {
    iata: "WUX",
    name: "Sunan Shuofang International Airport",
    city: "Wuxi",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 31.492889,
    longitude: 120.424374,
    icao: "ZSWX"
  },
  WUZ: {
    iata: "WUZ",
    name: "Wuzhou Xijiang Airport",
    city: "Wuzhou",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 23.403056,
    longitude: 111.099167,
    icao: "ZGWZ"
  },
  WVB: {
    iata: "WVB",
    name: "Rooikop Airport",
    city: "Walvis Bay",
    countryId: "NA",
    timeZoneRegionName: "Africa/Windhoek",
    latitude: -22.979712,
    longitude: 14.645329,
    icao: "FYWB"
  },
  WVI: {
    iata: "WVI",
    name: "Watsonville Municipal Airport",
    city: "Watsonville",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 36.935699,
    longitude: -121.790001,
    icao: "KWVI"
  },
  WVK: {
    iata: "WVK",
    name: "Manakara Airport",
    city: "Manakara",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -22.116667,
    longitude: 48.016667,
    icao: "FMSK"
  },
  WVL: {
    iata: "WVL",
    name: "Waterville Robert LaFleur Airport",
    city: "Waterville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 44.533186,
    longitude: -69.679746,
    icao: "KWVL"
  },
  WVN: {
    iata: "WVN",
    name: "Mariensiel Airport",
    city: "Wilhelmshaven",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 53.502219,
    longitude: 8.05223,
    icao: "EDWI"
  },
  WWA: {
    iata: "WWA",
    name: "Wasilla Airport",
    city: "Wasilla",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 61.57291,
    longitude: -149.504176,
    icao: "PAWS"
  },
  WWD: {
    iata: "WWD",
    name: "Cape May County Airport",
    city: "Wildwood",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.006389,
    longitude: -74.908889,
    icao: "KWWD"
  },
  WWI: {
    iata: "WWI",
    name: "Woodie Woodie Airport",
    city: "Woodie Woodie Mine",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -21.640958,
    longitude: 121.189207,
    icao: "YWWI"
  },
  WWK: {
    iata: "WWK",
    name: "Boram Airport",
    city: "Wewak",
    countryId: "PG",
    timeZoneRegionName: "Pacific/Port_Moresby",
    latitude: -3.580034,
    longitude: 143.669155,
    icao: "AYWK"
  },
  WWR: {
    iata: "WWR",
    name: "West Woodward Airport",
    city: "Woodward",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.436111,
    longitude: -99.526389,
    icao: "KWWR"
  },
  WWT: {
    iata: "WWT",
    name: "Newtok Airport",
    city: "Newtok",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 60.922778,
    longitude: -164.648611,
    icao: "PAEW"
  },
  WWY: {
    iata: "WWY",
    name: "West Wyalong Airport",
    city: "West Wyalong",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -33.933333,
    longitude: 147.25,
    icao: "YWWL"
  },
  WXN: {
    iata: "WXN",
    name: "Wuqiao Airport",
    city: "Wanxian",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 30.8017,
    longitude: 108.433,
    icao: "ZUWX"
  },
  WYA: {
    iata: "WYA",
    name: "Whyalla Airport",
    city: "Whyalla",
    countryId: "AU",
    timeZoneRegionName: "Australia/Adelaide",
    latitude: -33.052411,
    longitude: 137.521971,
    icao: "YWHA"
  },
  WYE: {
    iata: "WYE",
    name: "Yengema Airport",
    city: "Yengema",
    countryId: "SL",
    timeZoneRegionName: "Africa/Freetown",
    latitude: 8.616667,
    longitude: -11.058889,
    icao: "GFYE"
  },
  WYN: {
    iata: "WYN",
    name: "Wyndham Airport",
    city: "Wyndham",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -15.507222,
    longitude: 128.1375,
    icao: "YWYM"
  },
  WYS: {
    iata: "WYS",
    name: "Yellowstone Airport",
    city: "West Yellowstone",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 44.686667,
    longitude: -111.104722,
    icao: "KWYS"
  },
  WZA: {
    iata: "WZA",
    name: "Wa",
    city: "Wa",
    countryId: "GH",
    timeZoneRegionName: "Africa/Accra",
    latitude: 10.0844,
    longitude: -2.5067,
    icao: "DGLW"
  },
  XAI: {
    iata: "XAI",
    name: "Xinyang Minggang Airport",
    city: "Xinyang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 32.540556,
    longitude: 114.078889,
    icao: ""
  },
  XAP: {
    iata: "XAP",
    name: "Chapeco Airport",
    city: "Chapeco",
    countryId: "BR",
    timeZoneRegionName: "America/Sao_Paulo",
    latitude: -27.132448,
    longitude: -52.660374,
    icao: "SBCH"
  },
  XAR: {
    iata: "XAR",
    name: "Aribinda Airport",
    city: "Aribinda",
    countryId: "BF",
    timeZoneRegionName: "Africa/Ouagadougou",
    latitude: 14.233333,
    longitude: -0.866667,
    icao: "DFOY"
  },
  XAT: {
    iata: "XAT",
    name: "Antibes",
    city: "Antibes",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 43.58041799999999,
    longitude: 7.125102,
    icao: ""
  },
  XAU: {
    iata: "XAU",
    name: "Saul Airport",
    city: "Saul",
    countryId: "GF",
    timeZoneRegionName: "America/Cayenne",
    latitude: 3.616667,
    longitude: -53.2,
    icao: "SOOS"
  },
  XAX: {
    iata: "XAX",
    name: "Dorval Railway Station",
    city: "Dorval",
    countryId: "CA",
    timeZoneRegionName: "America/Montreal",
    latitude: 45.5088889,
    longitude: -73.5541667,
    icao: ""
  },
  XBE: {
    iata: "XBE",
    name: "Bearskin Lake Airport",
    city: "Bearskin Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 53.95,
    longitude: -90.983333,
    icao: "CNE3"
  },
  XBG: {
    iata: "XBG",
    name: "Bogande Airport",
    city: "Bogande",
    countryId: "BF",
    timeZoneRegionName: "Africa/Ouagadougou",
    latitude: 12.983333,
    longitude: -0.133333,
    icao: "DFEB"
  },
  XBJ: {
    iata: "XBJ",
    name: "Birjand Airport",
    city: "Birjand",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 32.899053,
    longitude: 59.25499,
    icao: "OIMB"
  },
  XBR: {
    iata: "XBR",
    name: "Brockville Airport",
    city: "Brockville",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 44.583333,
    longitude: -75.683333,
    icao: "CNL3"
  },
  XCG: {
    iata: "XCG",
    name: "Gare de Cagnes-sur-Mer",
    city: "Gare",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 43.6576629,
    longitude: 7.1484685,
    icao: ""
  },
  XCH: {
    iata: "XCH",
    name: "Christmas Island Airport",
    city: "Christmas Island",
    countryId: "CX",
    timeZoneRegionName: "Indian/Christmas",
    latitude: -10.5,
    longitude: 105.666667,
    icao: "YPXM"
  },
  XCL: {
    iata: "XCL",
    name: "Cluff Lake Airport",
    city: "Cluff Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Regina",
    latitude: 59,
    longitude: -107,
    icao: "CJS3"
  },
  XCM: {
    iata: "XCM",
    name: "Chatham Airport",
    city: "Chatham",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 42.3064,
    longitude: -82.081902,
    icao: "CNZ3"
  },
  XCR: {
    iata: "XCR",
    name: "Chalons Vatry Airport",
    city: "Chalons-en-Champagne",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 48.779595,
    longitude: 4.19097,
    icao: "LFOK"
  },
  XDB: {
    iata: "XDB",
    name: "Europe Railway Station",
    city: "Europe",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 50.62925,
    longitude: 3.057256,
    icao: ""
  },
  XDE: {
    iata: "XDE",
    name: "Diebougou Airport",
    city: "Diebougou",
    countryId: "BF",
    timeZoneRegionName: "Africa/Ouagadougou",
    latitude: 10.966667,
    longitude: -3.25,
    icao: "DFOU"
  },
  XDH: {
    iata: "XDH",
    name: "Jasper Railway Station",
    city: "Jasper",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 52.8761896,
    longitude: -118.0795881,
    icao: ""
  },
  XDJ: {
    iata: "XDJ",
    name: "Djibo Airport",
    city: "Djibo",
    countryId: "BF",
    timeZoneRegionName: "Africa/Ouagadougou",
    latitude: 14.1,
    longitude: -1.633333,
    icao: "DFCJ"
  },
  XDS: {
    iata: "XDS",
    name: "Ottawa Railway Station",
    city: "Ottawa",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 45.411572,
    longitude: -75.698194,
    icao: ""
  },
  XDV: {
    iata: "XDV",
    name: "Pr. George Railway",
    city: "Pr.",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 53.91848,
    longitude: -122.776584,
    icao: ""
  },
  XDW: {
    iata: "XDW",
    name: "Prince Rupert Railway Station",
    city: "Prince",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 54.306145,
    longitude: -130.310882,
    icao: ""
  },
  XDZ: {
    iata: "XDZ",
    name: "The Pas Railway Station",
    city: "The",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 53.97,
    longitude: -101.09,
    icao: ""
  },
  XEA: {
    iata: "XEA",
    name: "Pacific Central Station",
    city: "Vancouver",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 49.261226,
    longitude: -123.1139268,
    icao: ""
  },
  XED: {
    iata: "XED",
    name: "Marne/Chessy Rail Station",
    city: "Chessy",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 48.8704,
    longitude: 2.782799,
    icao: ""
  },
  XEF: {
    iata: "XEF",
    name: "Winnipeg Railway Station",
    city: "Winnipeg",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 49.886083,
    longitude: -97.152921,
    icao: ""
  },
  XER: {
    iata: "XER",
    name: "Strasbourg Bus Station",
    city: "Strasbourg",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 48.5844,
    longitude: 7.7486,
    icao: ""
  },
  XEV: {
    iata: "XEV",
    name: "Stockholm C Rail Station",
    city: "Stockholm",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 59.3327881,
    longitude: 18.0644881,
    icao: ""
  },
  XEW: {
    iata: "XEW",
    name: "Flemingsberg Railway Station",
    city: "Flemingsberg",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 59.217958,
    longitude: 17.945683,
    icao: ""
  },
  XFF: {
    iata: "XFF",
    name: "Calais-Frethun Rail Station",
    city: "Calais",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 50.95129,
    longitude: 1.858686,
    icao: ""
  },
  XFJ: {
    iata: "XFJ",
    name: "Eskilstuna C Rail Station",
    city: "Eskilstuna",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 59.3664682,
    longitude: 16.5084272,
    icao: ""
  },
  XFN: {
    iata: "XFN",
    name: "Xiangyang Airport",
    city: "Xiangyang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 32.150067,
    longitude: 112.290691,
    icao: "ZHXF"
  },
  XFP: {
    iata: "XFP",
    name: "Malmo C Railway Station",
    city: "Malmo",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 55.61,
    longitude: 13.004,
    icao: ""
  },
  XFW: {
    iata: "XFW",
    name: "Hamburg Finkenwerder Airport",
    city: "Finkenwerder",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 53.535278,
    longitude: 9.835556,
    icao: "EDHI"
  },
  XGA: {
    iata: "XGA",
    name: "Amilcar Cabral Airport",
    city: "Gaoua",
    countryId: "BF",
    timeZoneRegionName: "Africa/Ouagadougou",
    latitude: 10.383954,
    longitude: -3.163414,
    icao: "DFOG"
  },
  XGB: {
    iata: "XGB",
    name: "Gare Montparnasse",
    city: "Roissy-en-France",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 49.016666,
    longitude: 2.565278,
    icao: ""
  },
  XGC: {
    iata: "XGC",
    name: "Lund C Railway Station",
    city: "Lund",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 55.705278,
    longitude: 13.187222,
    icao: ""
  },
  XGG: {
    iata: "XGG",
    name: "Gorum-Gorum Airport",
    city: "Gorom-Gorom",
    countryId: "BF",
    timeZoneRegionName: "Africa/Ouagadougou",
    latitude: 14.433333,
    longitude: -0.233333,
    icao: "DFEG"
  },
  XGH: {
    iata: "XGH",
    name: "Flam Railway Station",
    city: "Flam",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 60.86292150000001,
    longitude: 7.114559300000001,
    icao: ""
  },
  XGJ: {
    iata: "XGJ",
    name: "Cobourg Railway Station",
    city: "Cobourg",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 43.9678916,
    longitude: -78.1706642,
    icao: ""
  },
  XGN: {
    iata: "XGN",
    name: "Xangongo Airport",
    city: "Xangongo",
    countryId: "AO",
    timeZoneRegionName: "Africa/Luanda",
    latitude: -16.75,
    longitude: 14.972222,
    icao: "FNXA"
  },
  XGR: {
    iata: "XGR",
    name: "Kangiqsualujjuaq Airport",
    city: "Kangiqsualujjuaq",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 58.5,
    longitude: -65.983333,
    icao: "CYLU"
  },
  XHJ: {
    iata: "XHJ",
    name: "Aachen Hbf Railway Station",
    city: "Aachen",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 50.7754385,
    longitude: 6.0815102,
    icao: ""
  },
  XHK: {
    iata: "XHK",
    name: "Valence TGV Railway Station",
    city: "Valence",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 44.933393,
    longitude: 4.89236,
    icao: ""
  },
  XIA: {
    iata: "XIA",
    name: "Guelph Railway Station",
    city: "Guelph",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 43.5444,
    longitude: -80.24689939999999,
    icao: ""
  },
  XIC: {
    iata: "XIC",
    name: "Xichang Airport",
    city: "Xichang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 27.981922,
    longitude: 102.187645,
    icao: "ZUXC"
  },
  XIL: {
    iata: "XIL",
    name: "Xilinhot Airport",
    city: "Xilinhot",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 43.918761,
    longitude: 115.95924,
    icao: "ZBXH"
  },
  XIT: {
    iata: "XIT",
    countryId: "DE",
    city: "Leipzig",
    icao: "",
    name: "Leipzig Halle Airport station",
    latitude: 51.4233,
    longitude: 12.2225,
    timeZoneRegionName: "Europe/Paris"
  },
  XIY: {
    iata: "XIY",
    name: "Xianyang International Airport",
    city: "Xian",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 34.438416,
    longitude: 108.760946,
    icao: "ZLXY"
  },
  XIZ: {
    iata: "XIZ",
    name: "Champagne-Ardenne TGV",
    city: "Reims",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 49.258329,
    longitude: 4.031696,
    icao: ""
  },
  XJD: {
    iata: "XJD",
    name: "Al Udeid Air Base",
    city: "Doha",
    countryId: "QA",
    timeZoneRegionName: "Asia/Qatar",
    latitude: 25.117222,
    longitude: 51.314722,
    icao: "OTBH"
  },
  XJY: {
    iata: "XJD",
    name: "Massy TGV station",
    city: "Paris",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 48.725862,
    longitude: 2.261339,
    icao: ""
  },
  XKA: {
    iata: "XKA",
    name: "Kantchari Airport",
    city: "Kantchari",
    countryId: "BF",
    timeZoneRegionName: "Africa/Ouagadougou",
    latitude: 12.483333,
    longitude: 1.516667,
    icao: "DFEL"
  },
  XKH: {
    iata: "XKH",
    name: "Xieng Khouang Airport",
    city: "Xieng Khouang",
    countryId: "LA",
    timeZoneRegionName: "Asia/Vientiane",
    latitude: 19.444328,
    longitude: 103.151796,
    icao: "VLXK"
  },
  XKL: {
    iata: "XKL",
    name: "Sentral Railway Station",
    city: "Kuala Lumpur",
    countryId: "MY",
    timeZoneRegionName: "Asia/Kuala_Lumpur",
    latitude: 3.139003,
    longitude: 101.686855,
    icao: ""
  },
  XKS: {
    iata: "XKS",
    name: "Kasabonika Airport",
    city: "Kasabonika",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 53.52,
    longitude: -88.646667,
    icao: "CYAQ"
  },
  XLB: {
    iata: "XLB",
    name: "Lac Brochet Airport",
    city: "Lac Brochet",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 58.615514,
    longitude: -101.465405,
    icao: "CZWH"
  },
  XLM: {
    iata: "XLM",
    name: "St Lambert Railway",
    city: "St",
    countryId: "CA",
    timeZoneRegionName: "America/Montreal",
    latitude: 45.5088889,
    longitude: -73.5541667,
    icao: ""
  },
  XLS: {
    iata: "XLS",
    name: "St. Louis Airport",
    city: "Saint Louis",
    countryId: "SN",
    timeZoneRegionName: "Africa/Dakar",
    latitude: 16.050278,
    longitude: -16.460278,
    icao: "GOSS"
  },
  XLV: {
    iata: "XLV",
    name: "Niagara Falls Railway Station",
    city: "Niagara",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 43.1088342,
    longitude: -79.063346,
    icao: ""
  },
  XLW: {
    iata: "XLW",
    name: "Lemwerder Airport",
    city: "Lemwerder",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 53.166667,
    longitude: 8.6,
    icao: "EDWD"
  },
  XMC: {
    iata: "XMC",
    name: "Mallacoota Airport",
    city: "Mallacoota",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -37.6,
    longitude: 149.716667,
    icao: "YMCO"
  },
  XMD: {
    iata: "XMD",
    name: "Madison Airport",
    city: "Madison",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 44,
    longitude: -97.116667,
    icao: "KMDS"
  },
  XMG: {
    iata: "XMG",
    name: "Mahendranagar Airport",
    city: "Mahendranagar",
    countryId: "NP",
    timeZoneRegionName: "Asia/Kathmandu",
    latitude: 28.966667,
    longitude: 80.2,
    icao: "VNMN"
  },
  XMH: {
    iata: "XMH",
    name: "Manihi Airport",
    city: "Manihi",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -14.437609,
    longitude: -146.070784,
    icao: "NTGI"
  },
  XMI: {
    iata: "XMI",
    name: "Masasi Airport",
    city: "Masasi",
    countryId: "TZ",
    timeZoneRegionName: "Africa/Dar_es_Salaam",
    latitude: -10.716667,
    longitude: 38.8,
    icao: "HTMI"
  },
  XMN: {
    iata: "XMN",
    name: "Xiamen Gaoqi International Airport",
    city: "Xiamen",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 24.543064,
    longitude: 118.134178,
    icao: "ZSAM"
  },
  XMP: {
    iata: "XMP",
    name: "Macmillan Pass Airport",
    city: "Macmillan Pass",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 62.866667,
    longitude: -135.916667,
    icao: "CFC4"
  },
  XMS: {
    iata: "XMS",
    name: "Macas Airport",
    city: "Macas",
    countryId: "EC",
    timeZoneRegionName: "America/Guayaquil",
    latitude: -2.316667,
    longitude: -78.133333,
    icao: "SEMC"
  },
  XMY: {
    iata: "XMY",
    name: "Yam Island Airport",
    city: "Yam Island",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -9.898765,
    longitude: 142.773115,
    icao: "YYMI"
  },
  XNA: {
    iata: "XNA",
    name: "Northwest Arkansas Regional Airport",
    city: "Bentonville",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 36.275259,
    longitude: -94.297109,
    icao: "KXNA"
  },
  XNB: {
    iata: "XNB",
    name: "Chelsea Tower Bus Station",
    city: "Dubai",
    countryId: "AE",
    timeZoneRegionName: "Asia/Dubai",
    latitude: 25.2644444,
    longitude: 55.3116667,
    icao: "OMDB"
  },
  XNH: {
    iata: "XNH",
    name: "Ali Air Base",
    city: "Nasiriyah",
    countryId: "IQ",
    timeZoneRegionName: "Asia/Baghdad",
    latitude: 30.935756,
    longitude: 46.090124,
    icao: "ORTL"
  },
  XNN: {
    iata: "XNN",
    name: "Xining Caojiabao Airport",
    city: "Xining",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 36.527506,
    longitude: 102.043002,
    icao: "ZLXN"
  },
  XNT: {
    iata: "XNT",
    name: "Xingtai Dalian Airport",
    city: "Xingtai",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 37.1,
    longitude: 114.5,
    icao: "ZBXT"
  },
  XNU: {
    iata: "XNU",
    name: "Nouna Airport",
    city: "Nouna",
    countryId: "BF",
    timeZoneRegionName: "Africa/Ouagadougou",
    latitude: 12.733333,
    longitude: -3.866667,
    icao: "DFON"
  },
  XOC: {
    iata: "XOC",
    name: "Atocha Railway Station",
    city: "Madrid",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 40.4058,
    longitude: -3.6908,
    icao: ""
  },
  XOP: {
    iata: "XOP",
    countryId: "FR",
    city: "Poitiers",
    icao: "",
    name: "Poitiers Railway station",
    latitude: 46.5822,
    longitude: 0.3331,
    timeZoneRegionName: "Europe/Paris"
  },
  XPA: {
    iata: "XPA",
    name: "Pama Airport",
    city: "Pama",
    countryId: "BF",
    timeZoneRegionName: "Africa/Ouagadougou",
    latitude: 11.25,
    longitude: 0.7,
    icao: "DFEP"
  },
  XPG: {
    iata: "XPG",
    name: "Gare du Nord Railway",
    city: "Gare",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 48.856614,
    longitude: 2.3522219,
    icao: ""
  },
  XPH: {
    iata: "XPH",
    name: "Port Hope Railway Station",
    city: "Port",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 43.9434985,
    longitude: -78.2988432,
    icao: ""
  },
  XPJ: {
    iata: "XPJ",
    name: "Montpellier Railway",
    city: "Montpellier",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 43.610769,
    longitude: 3.876716,
    icao: ""
  },
  XPK: {
    iata: "XPK",
    name: "Pukatawagan Airport",
    city: "Pukatawagan",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 55.766667,
    longitude: -101.233333,
    icao: "CZFG"
  },
  XPL: {
    iata: "XPL",
    name: "Comayagua International Airport",
    city: "Comayagua",
    countryId: "HN",
    timeZoneRegionName: "America/Tegucigalpa",
    latitude: 14.3825,
    longitude: -87.621111,
    icao: "MHPR"
  },
  XPP: {
    iata: "XPP",
    name: "Poplar River Airport",
    city: "Poplar River",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 53,
    longitude: -97.3,
    icao: "CZNG"
  },
  XPR: {
    iata: "XPR",
    name: "Pine Ridge Airport",
    city: "Pine Ridge",
    countryId: "US",
    timeZoneRegionName: "America/Denver",
    latitude: 43.016667,
    longitude: -102.516667,
    icao: "KIEN"
  },
  XQA: {
    iata: "XQA",
    name: "Santa Justa Railway Station",
    city: "Sevilla",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 37.3942,
    longitude: -5.9742,
    icao: ""
  },
  XQC: {
    iata: "XQC",
    name: "Balad Airbase",
    city: "Balad",
    countryId: "IQ",
    timeZoneRegionName: "Asia/Baghdad",
    latitude: 33.949337,
    longitude: 44.370403,
    icao: "ORBD"
  },
  XQE: {
    iata: "XQE",
    name: "Ebbsfleet International Rail Station",
    city: "Ebbsfleet",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.51,
    longitude: 0.06,
    icao: ""
  },
  XQP: {
    iata: "XQP",
    name: "La Managua Airport",
    city: "Quepos",
    countryId: "CR",
    timeZoneRegionName: "America/Costa_Rica",
    latitude: 9.443547,
    longitude: -84.129428,
    icao: "MRQP"
  },
  XQT: {
    iata: "XQT",
    name: "Trent Valley Rail Station",
    city: "Trent",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 53.281744,
    longitude: -4.5635223,
    icao: ""
  },
  XRF: {
    iata: "XRF",
    name: "Marseille Railway",
    city: "Marseille 02",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 43.296482,
    longitude: 5.36978,
    icao: ""
  },
  XRG: {
    iata: "XRG",
    name: "Trent Valley Rail Station",
    city: "Trent",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 53.281744,
    longitude: -4.5635223,
    icao: ""
  },
  XRH: {
    iata: "XRH",
    name: "Richmond Air Force Base",
    city: "Richmond",
    countryId: "AU",
    timeZoneRegionName: "Australia/Sydney",
    latitude: -33.604134,
    longitude: 150.790165,
    icao: "YSRI"
  },
  XRK: {
    iata: "XRK",
    name: "Paveletskiy Railway.",
    city: "Paveletskiy",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 55.755786,
    longitude: 37.617633,
    icao: ""
  },
  XRR: {
    iata: "XRR",
    name: "Ross River Airport",
    city: "Ross River",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 61.983333,
    longitude: -132.45,
    icao: "CYDM"
  },
  XRY: {
    iata: "XRY",
    name: "Jerez Airport",
    city: "Jerez De La Frontera",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 36.750614,
    longitude: -6.064535,
    icao: "LEJR"
  },
  XSB: {
    iata: "XSB",
    name: "Yas Island Airport",
    city: "Sir Bani Yas Island",
    countryId: "AE",
    timeZoneRegionName: "Asia/Dubai",
    latitude: 24.283973,
    longitude: 52.583875,
    icao: "OMBY"
  },
  XSC: {
    iata: "XSC",
    name: "South Caicos International Airport",
    city: "South Caicos",
    countryId: "TC",
    timeZoneRegionName: "America/Grand_Turk",
    latitude: 21.515833,
    longitude: -71.529722,
    icao: "MBSC"
  },
  XSD: {
    iata: "XSD",
    name: "Tonopah Test Range Airport",
    city: "Tonopah",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 37.794722,
    longitude: -116.778611,
    icao: "KTNX"
  },
  XSE: {
    iata: "XSE",
    name: "Sebba Airport",
    city: "Sebba",
    countryId: "BF",
    timeZoneRegionName: "Africa/Ouagadougou",
    latitude: 13.433333,
    longitude: 0.533333,
    icao: "DFES"
  },
  XSH: {
    iata: "XSH",
    name: "St-Pierre-Corps RailSt",
    city: "Tours",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 47.394144,
    longitude: 0.68484,
    icao: ""
  },
  XSI: {
    iata: "XSI",
    name: "South Indian Lake Airport",
    city: "South Indian Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 56.79474,
    longitude: -98.90753,
    icao: "CZSN"
  },
  XSP: {
    iata: "XSP",
    name: "Seletar Airport",
    city: "Singapore",
    countryId: "SG",
    timeZoneRegionName: "Asia/Singapore",
    latitude: 1.41769,
    longitude: 103.871122,
    icao: "WSSL"
  },
  XTG: {
    iata: "XTG",
    name: "Thargomindah Airport",
    city: "Thargomindah",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -27.987414,
    longitude: 143.815152,
    icao: "YTGM"
  },
  XTI: {
    iata: "XTI",
    name: "Madrid Chamartin Railway Station",
    city: "Madrid",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 40.4721,
    longitude: -3.68269,
    icao: ""
  },
  XTL: {
    iata: "XTL",
    name: "Tadoule Lake Airport",
    city: "Tadoule Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 58.707956,
    longitude: -98.513441,
    icao: "CYBQ"
  },
  XTO: {
    iata: "XTO",
    name: "Taroom Airport",
    city: "Taroom",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -25.802221,
    longitude: 149.898764,
    icao: "YTAM"
  },
  XTR: {
    iata: "XTR",
    name: "Tara Airport",
    city: "Tara",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -27.283333,
    longitude: 150.466667,
    icao: "YTAA"
  },
  XUK: {
    iata: "XUK",
    name: "Xuzhou Railway Station",
    city: "Jiuli",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 34.267222,
    longitude: 117.200556,
    icao: ""
  },
  XUZ: {
    iata: "XUZ",
    name: "Xuzhou Guanyin International Airport",
    city: "Xuzhou",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 34.055033,
    longitude: 117.554758,
    icao: "ZSXZ"
  },
  XWA: {
    iata: "XWA",
    countryId: "US",
    city: "Williston",
    icao: "",
    name: "Williston Basin International",
    latitude: 48.2597,
    longitude: -103.7506,
    timeZoneRegionName: "America/Chicago"
  },
  XWG: {
    iata: "XWG",
    name: "Strasbourg Railway Station",
    city: "Strasbourg",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 48.583148,
    longitude: 7.747882,
    icao: ""
  },
  XWK: {
    iata: "XWK",
    name: "Karlskrona RailwaySvc.",
    city: "Karlskrona",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 56.27,
    longitude: 15.27,
    icao: ""
  },
  XWL: {
    iata: "XWL",
    name: "Goteborg C Railway Station",
    city: "Goeteborg",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 57.6969943,
    longitude: 11.9865,
    icao: ""
  },
  XWR: {
    iata: "XWR",
    name: "Orebro C Railway Station",
    city: "Orebro",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 59.273755,
    longitude: 15.2075395,
    icao: ""
  },
  XXL: {
    iata: "XXL",
    name: "Lillehammer Railway Station",
    city: "Lillehammer",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 61.1152713,
    longitude: 10.4662306,
    icao: ""
  },
  XXQ: {
    iata: "XXQ",
    name: "Keleti Railway Station",
    city: "Budapest",
    countryId: "HU",
    timeZoneRegionName: "Europe/Budapest",
    latitude: 47.500278,
    longitude: 19.083889,
    icao: ""
  },
  XXZ: {
    iata: "XXZ",
    name: "Sundsvall C Rail Station",
    city: "Sundsvall",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 62.3908358,
    longitude: 17.3069157,
    icao: ""
  },
  XYB: {
    iata: "XYB",
    name: "Borlange Railway",
    city: "Borlaenge",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 60.4856047,
    longitude: 15.4363017,
    icao: ""
  },
  XYD: {
    iata: "XYD",
    name: "Lyon Part-Dieu",
    city: "Polliat",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 46.24,
    longitude: 5.15,
    icao: ""
  },
  XYE: {
    iata: "XYE",
    name: "Ye Airport",
    city: "Ye",
    countryId: "MM",
    timeZoneRegionName: "Asia/Yangon",
    latitude: 15.25,
    longitude: 97.85,
    icao: "VYYE"
  },
  XYG: {
    iata: "XYG",
    name: "Prague Main Railway Station",
    city: "Prague",
    countryId: "CZ",
    timeZoneRegionName: "Europe/Prague",
    latitude: 50.0878114,
    longitude: 14.4204598,
    icao: ""
  },
  XYH: {
    iata: "XYH",
    name: "Helsingborg Railway",
    city: "Helsingborg",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 56.2432,
    longitude: 12.8615092,
    icao: ""
  },
  XYJ: {
    iata: "XYJ",
    name: "Holesovice Railway Station",
    city: "Prague",
    countryId: "CZ",
    timeZoneRegionName: "Europe/Prague",
    latitude: 50.0878114,
    longitude: 14.4204598,
    icao: ""
  },
  XYL: {
    iata: "XYL",
    name: "Lyon Perrache RailwaySvc",
    city: "Lyon",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 45.764043,
    longitude: 4.835659,
    icao: ""
  },
  XYM: {
    iata: "XYM",
    name: "Falkenberg Railway",
    city: "Falkenberg",
    countryId: "SE",
    timeZoneRegionName: "Europe/Stockholm",
    latitude: 56.90273329999999,
    longitude: 12.4888013,
    icao: ""
  },
  XZI: {
    iata: "XZI",
    name: "Lorraine TGV Rail Station",
    city: "Metz",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 49.119666,
    longitude: 6.176905,
    icao: ""
  },
  XZN: {
    iata: "XZN",
    name: "Avignon Railway",
    city: "Avignon",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 43.949317,
    longitude: 4.805528,
    icao: ""
  },
  XZO: {
    iata: "XZO",
    name: "Oslo S Railway Station",
    city: "Oslo",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 59.9138688,
    longitude: 10.7522454,
    icao: ""
  },
  XZT: {
    iata: "XZT",
    name: "Trondheim S Rail Station",
    city: "Trondheim",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 63.4305149,
    longitude: 10.3950528,
    icao: ""
  },
  XZV: {
    iata: "XZV",
    name: "Toulon Railway Station",
    city: "Hyeres",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 43.120541,
    longitude: 6.128639,
    icao: ""
  },
  YAA: {
    iata: "YAA",
    name: "Anahim Lake Airport",
    city: "Anahim Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 52.45685,
    longitude: -125.307311,
    icao: "CAJ4"
  },
  YAB: {
    iata: "YAB",
    name: "Arctic Bay Airport",
    city: "Arctic Bay",
    countryId: "CA",
    timeZoneRegionName: "America/Iqaluit",
    latitude: 73.004915,
    longitude: -85.027525,
    icao: "CYAB"
  },
  YAC: {
    iata: "YAC",
    name: "Cat Lake Airport",
    city: "Cat Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 51.727298,
    longitude: -91.825289,
    icao: "CYAC"
  },
  YAG: {
    iata: "YAG",
    name: "Fort Frances Municipal Airport",
    city: "Fort Frances",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 48.652778,
    longitude: -93.447222,
    icao: "CYAG"
  },
  YAH: {
    iata: "YAH",
    name: "La Grande-4 Airport",
    city: "La Grande-4",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 53.754126,
    longitude: -73.678192,
    icao: "CYAH"
  },
  YAI: {
    iata: "YAI",
    name: "Chillan Airport",
    city: "Chillan",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -36.6,
    longitude: -72.116667,
    icao: "SCCH"
  },
  YAK: {
    iata: "YAK",
    name: "Yakutat Airport",
    city: "Yakutat",
    countryId: "US",
    timeZoneRegionName: "America/Anchorage",
    latitude: 59.509167,
    longitude: -139.659722,
    icao: "PAYA"
  },
  YAL: {
    iata: "YAL",
    name: "Alert Bay Airport",
    city: "Alert Bay",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 50.583333,
    longitude: -126.916667,
    icao: "CYAL"
  },
  YAM: {
    iata: "YAM",
    name: "Sault Ste. Marie Airport",
    city: "Sault Ste. Marie",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 46.485301,
    longitude: -84.499949,
    icao: "CYAM"
  },
  YAN: {
    iata: "YAN",
    name: "Yangambi Airport",
    city: "Yangambi",
    countryId: "CD",
    timeZoneRegionName: "Africa/Lubumbashi",
    latitude: 0.783333,
    longitude: 24.4,
    icao: "FZIR"
  },
  YAO: {
    iata: "YAO",
    name: "Yaounde Ville Airport",
    city: "Yaounde",
    countryId: "CM",
    timeZoneRegionName: "Africa/Douala",
    latitude: 3.835258,
    longitude: 11.52199,
    icao: "FKKY"
  },
  YAP: {
    iata: "YAP",
    name: "Yap International Airport",
    city: "Yap, Caroline Islands",
    countryId: "FM",
    timeZoneRegionName: "Pacific/Chuuk",
    latitude: 9.497715,
    longitude: 138.08673,
    icao: "PTYA"
  },
  YAR: {
    iata: "YAR",
    name: "La Grande-3 Airport",
    city: "La Grande-3",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 53.571406,
    longitude: -76.18887,
    icao: "CYAD"
  },
  YAS: {
    iata: "YAS",
    name: "Yasawa Island Airport",
    city: "Yasawa Island",
    countryId: "FJ",
    timeZoneRegionName: "Pacific/Fiji",
    latitude: -16.759281,
    longitude: 177.545155,
    icao: "NFSW"
  },
  YAT: {
    iata: "YAT",
    name: "Attawapiskat Airport",
    city: "Attawapiskat",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 52.941667,
    longitude: -82.4,
    icao: "CYAT"
  },
  YAW: {
    iata: "YAW",
    name: "Shearwater Airport",
    city: "Halifax",
    countryId: "CA",
    timeZoneRegionName: "America/Halifax",
    latitude: 44.866667,
    longitude: -63.616667,
    icao: "CYAW"
  },
  YAX: {
    iata: "YAX",
    name: "Wapekeka Airport",
    city: "Angling Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 53.849215,
    longitude: -89.579408,
    icao: "CKB6"
  },
  YAY: {
    iata: "YAY",
    name: "St. Anthony Airport",
    city: "Saint Anthony",
    countryId: "CA",
    timeZoneRegionName: "America/St_Johns",
    latitude: 51.366667,
    longitude: -55.583333,
    icao: "CYAY"
  },
  YAZ: {
    iata: "YAZ",
    name: "Tofino Long Beach Airport",
    city: "Tofino",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 49.078163,
    longitude: -125.768599,
    icao: "CYAZ"
  },
  YBB: {
    iata: "YBB",
    name: "Kugaaruk Airport",
    city: "Pelly Bay",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 68.538173,
    longitude: -89.791847,
    icao: "CYBB"
  },
  YBC: {
    iata: "YBC",
    name: "Baie-Comeau Airport",
    city: "Baie Comeau",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 49.13321,
    longitude: -68.198988,
    icao: "CYBC"
  },
  YBE: {
    iata: "YBE",
    name: "Uranium City Airport",
    city: "Uranium City",
    countryId: "CA",
    timeZoneRegionName: "America/Regina",
    latitude: 59.561401,
    longitude: -108.481003,
    icao: "CYBE"
  },
  YBG: {
    iata: "YBG",
    name: "Saguenay-Bagotville Airport",
    city: "La Baie",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 48.333417,
    longitude: -70.985892,
    icao: "CYBG"
  },
  YBH: {
    iata: "YBH",
    name: "Bull Harbour Seaplane Base",
    city: "Bull Harbour",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 50.917969,
    longitude: -127.937245,
    icao: "CYBH"
  },
  YBI: {
    iata: "YBI",
    name: "Black Tickle Airport",
    city: "Black Tickle",
    countryId: "CA",
    timeZoneRegionName: "America/Halifax",
    latitude: 53.468248,
    longitude: -55.785678,
    icao: "CCE4"
  },
  YBK: {
    iata: "YBK",
    name: "Baker Lake Airport",
    city: "Baker Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 64.3,
    longitude: -96.083333,
    icao: "CYBK"
  },
  YBL: {
    iata: "YBL",
    name: "Campbell River Airport",
    city: "Campbell River",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 49.951726,
    longitude: -125.268126,
    icao: "CYBL"
  },
  YBM: {
    iata: "YBM",
    name: "Bronson Creek Airport",
    city: "Bronson Creek",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 56.7,
    longitude: -131,
    icao: "CAB5"
  },
  YBP: {
    iata: "YBP",
    name: "Yibin Caiba Airport",
    city: "Yibin",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 28.801665,
    longitude: 104.551835,
    icao: "ZUYB"
  },
  YBR: {
    iata: "YBR",
    name: "Brandon Municipal Airport",
    city: "Brandon",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 49.908687,
    longitude: -99.946773,
    icao: "CYBR"
  },
  YBT: {
    iata: "YBT",
    name: "Brochet Airport",
    city: "Brochet",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 57.888469,
    longitude: -101.678994,
    icao: "CYBT"
  },
  YBV: {
    iata: "YBV",
    name: "Berens River Airport",
    city: "Berens River",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 52.358695,
    longitude: -97.021411,
    icao: "CYBV"
  },
  YBX: {
    iata: "YBX",
    name: "Blanc Sablon Airport",
    city: "Blanc Sablon",
    countryId: "CA",
    timeZoneRegionName: "America/Blanc-Sablon",
    latitude: 51.433333,
    longitude: -57.216667,
    icao: "CYBX"
  },
  YBY: {
    iata: "YBY",
    name: "Bonnyville Airport",
    city: "Bonnyville",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 54.304758,
    longitude: -110.750772,
    icao: "CYBF"
  },
  YBZ: {
    iata: "YBZ",
    name: "Toronto Downtown",
    city: "Toronto",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 43.653524,
    longitude: -79.3839069,
    icao: ""
  },
  YCA: {
    iata: "YCA",
    name: "Courtenay Airport",
    city: "Courtenay",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 49.683333,
    longitude: -124.983333,
    icao: "CAH3"
  },
  YCB: {
    iata: "YCB",
    name: "Cambridge Bay Airport",
    city: "Cambridge Bay",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 69.1,
    longitude: -105.133333,
    icao: "CYCB"
  },
  YCC: {
    iata: "YCC",
    name: "Cornwall Regional Airport",
    city: "Cornwall",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 45.1,
    longitude: -74.566667,
    icao: "CYCC"
  },
  YCD: {
    iata: "YCD",
    name: "Nanaimo Airport",
    city: "Nanaimo",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 49.053158,
    longitude: -123.872995,
    icao: "CYCD"
  },
  YCE: {
    iata: "YCE",
    name: "Centralia Airport",
    city: "Centralia",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 43.283333,
    longitude: -81.483333,
    icao: "CYCE"
  },
  YCG: {
    iata: "YCG",
    name: "Castlegar Airport",
    city: "Castlegar",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 49.295556,
    longitude: -117.632222,
    icao: "CYCG"
  },
  YCH: {
    iata: "YCH",
    name: "Miramichi Airport",
    city: "Miramichi",
    countryId: "CA",
    timeZoneRegionName: "America/Halifax",
    latitude: 47.012714,
    longitude: -65.437869,
    icao: "CYCH"
  },
  YCK: {
    iata: "YCK",
    name: "Colville Lake Airport",
    city: "Colville Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 67.039932,
    longitude: -126.090471,
    icao: "CEB3"
  },
  YCL: {
    iata: "YCL",
    name: "Charlo Airport",
    city: "Charlo",
    countryId: "CA",
    timeZoneRegionName: "America/Halifax",
    latitude: 47.990927,
    longitude: -66.328812,
    icao: "CYCL"
  },
  YCM: {
    iata: "YCM",
    name: "St. Catharines Airport",
    city: "Saint Catharines",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 43.2,
    longitude: -79.166667,
    icao: "CYSN"
  },
  YCN: {
    iata: "YCN",
    name: "Cochrane Airport",
    city: "Cochrane",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 49.106018,
    longitude: -81.012895,
    icao: "CYCN"
  },
  YCO: {
    iata: "YCO",
    name: "Kugluktuk Airport",
    city: "Kugluktuk/Coppermine",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 67.833333,
    longitude: -115.083333,
    icao: "CYCO"
  },
  YCQ: {
    iata: "YCQ",
    name: "Chetwynd Airport",
    city: "Chetwynd",
    countryId: "CA",
    timeZoneRegionName: "America/Dawson_Creek",
    latitude: 55.683333,
    longitude: -121.633333,
    icao: "CYCQ"
  },
  YCR: {
    iata: "YCR",
    name: "Charlie Sinclair Memorial Airport",
    city: "Cross Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 54.6106,
    longitude: -97.760803,
    icao: "CYCR"
  },
  YCS: {
    iata: "YCS",
    name: "Chesterfield Inlet Airport",
    city: "Chesterfield Inlet",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 63.333333,
    longitude: -90.716667,
    icao: "CYCS"
  },
  YCT: {
    iata: "YCT",
    name: "Coronation Airport",
    city: "Coronation",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 52.1,
    longitude: -111.416667,
    icao: "CYCT"
  },
  YCU: {
    iata: "YCU",
    name: "Yuncheng Airport",
    city: "Yuncheng",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 35.114987,
    longitude: 111.037051,
    icao: "ZBYC"
  },
  YCW: {
    iata: "YCW",
    name: "Chilliwack Airport",
    city: "Chilliwack",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 49.166667,
    longitude: -121.9,
    icao: "CYCW"
  },
  YCY: {
    iata: "YCY",
    name: "Clyde River Airport",
    city: "Clyde River",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 70.416667,
    longitude: -68.5,
    icao: "CYCY"
  },
  YCZ: {
    iata: "YCZ",
    name: "Fairmount Springs Airport",
    city: "Fairmount Springs",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 50.331944,
    longitude: -115.873611,
    icao: "CYCZ"
  },
  YDA: {
    iata: "YDA",
    name: "Dawson City Airport",
    city: "Dawson City",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 64.045478,
    longitude: -139.117063,
    icao: "CYDA"
  },
  YDB: {
    iata: "YDB",
    name: "Burwash Landings Airport",
    city: "Burwash Landings",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 61.35,
    longitude: -139.016667,
    icao: "CYDB"
  },
  YDC: {
    iata: "YDC",
    name: "Industrial Airport",
    city: "Drayton Valley",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 53.2,
    longitude: -114.966667,
    icao: "CER3"
  },
  YDF: {
    iata: "YDF",
    name: "Deer Lake Regional Airport",
    city: "Deer Lake",
    countryId: "CA",
    timeZoneRegionName: "America/St_Johns",
    latitude: 49.21027,
    longitude: -57.399727,
    icao: "CYDF"
  },
  YDG: {
    iata: "YDG",
    name: "Annapolis Regional Airport",
    city: "Digby",
    countryId: "CA",
    timeZoneRegionName: "America/Halifax",
    latitude: 44.545998,
    longitude: -65.785564,
    icao: "CYID"
  },
  YDI: {
    iata: "YDI",
    name: "Davis Inlet Airport",
    city: "Davis Inlet",
    countryId: "CA",
    timeZoneRegionName: "America/Halifax",
    latitude: 55.933333,
    longitude: -60.95,
    icao: "CCB4"
  },
  YDJ: {
    iata: "YDJ",
    name: "Hatchet Lake Airport",
    city: "Hatchet Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Regina",
    latitude: 58.660556,
    longitude: -102.539444,
    icao: "CJL2"
  },
  YDL: {
    iata: "YDL",
    name: "Dease Lake Airport",
    city: "Dease Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 58.424632,
    longitude: -130.025156,
    icao: "CYDL"
  },
  YDN: {
    iata: "YDN",
    name: "Lt. W.G. (Billy) Barker Airport",
    city: "Dauphin",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 51.1008,
    longitude: -100.052002,
    icao: "CYDN"
  },
  YDO: {
    iata: "YDO",
    name: "St. Felicien Airport",
    city: "Dolbeau",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 48.778541,
    longitude: -72.374972,
    icao: "CYDO"
  },
  YDP: {
    iata: "YDP",
    name: "Nain Airport",
    city: "Nain",
    countryId: "CA",
    timeZoneRegionName: "America/Halifax",
    latitude: 56.533333,
    longitude: -61.666667,
    icao: "CYDP"
  },
  YDQ: {
    iata: "YDQ",
    name: "Dawson Creek Airport",
    city: "Dawson Creek",
    countryId: "CA",
    timeZoneRegionName: "America/Dawson_Creek",
    latitude: 55.733333,
    longitude: -120.183333,
    icao: "CYDQ"
  },
  YDT: {
    iata: "YDT",
    name: "Boundary Bay Airport",
    city: "Vancouver",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 49.077573,
    longitude: -123.006123,
    icao: "CZBB"
  },
  YDU: {
    iata: "YDU",
    name: "Kasba Lake Airport",
    city: "Kasba Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 60.290278,
    longitude: -102.503333,
    icao: "CJL8"
  },
  YDV: {
    iata: "YDV",
    name: "Bloodvein Airport",
    city: "Bloodvein",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 51.75,
    longitude: -96.733333,
    icao: "CZTA"
  },
  YEC: {
    iata: "YEC",
    name: "Yecheon Airport",
    city: "Yecheon",
    countryId: "KR",
    timeZoneRegionName: "Asia/Seoul",
    latitude: 36.631563,
    longitude: 128.370356,
    icao: "RKTY"
  },
  YEG: {
    iata: "YEG",
    name: "Edmonton International Airport",
    city: "Edmonton",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 53.307375,
    longitude: -113.584047,
    icao: "CYEG"
  },
  YEI: {
    iata: "YEI",
    name: "Yenisehir Airport",
    city: "Bursa",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 40.255767,
    longitude: 29.544743,
    icao: "LTBR"
  },
  YEK: {
    iata: "YEK",
    name: "Arviat Airport",
    city: "Arviat",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 61.116667,
    longitude: -94.05,
    icao: "CYEK"
  },
  YEL: {
    iata: "YEL",
    name: "Elliot Lake Municipal Airport",
    city: "Elliot Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 46.352222,
    longitude: -82.563056,
    icao: "CYEL"
  },
  YEM: {
    iata: "YEM",
    name: "Manitoulin East Municipal Airport",
    city: "Manitowaning",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 45.842778,
    longitude: -81.858056,
    icao: "CYEM"
  },
  YEN: {
    iata: "YEN",
    name: "Estevan Regional Airport",
    city: "Estevan",
    countryId: "CA",
    timeZoneRegionName: "America/Regina",
    latitude: 49.207544,
    longitude: -102.962821,
    icao: "CYEN"
  },
  YEO: {
    iata: "YEO",
    name: "Yeovilton Airport",
    city: "Yeovilton",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.016667,
    longitude: -2.55,
    icao: "EGDY"
  },
  YER: {
    iata: "YER",
    name: "Fort Severn Airport",
    city: "Fort Severn",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 56.017702,
    longitude: -87.677509,
    icao: "CYER"
  },
  YET: {
    iata: "YET",
    name: "Edson Airport",
    city: "Edson",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 53.583333,
    longitude: -116.466667,
    icao: "CYET"
  },
  YEU: {
    iata: "YEU",
    name: "Eureka Airport",
    city: "Eureka",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 80,
    longitude: -85.933333,
    icao: "CYEU"
  },
  YEV: {
    iata: "YEV",
    name: "Inuvik Mike Zubko Airport",
    city: "Inuvik",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 68.306649,
    longitude: -133.49767,
    icao: "CYEV"
  },
  YEY: {
    iata: "YEY",
    name: "Amos/Magny Airport",
    city: "Amos",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 48.558741,
    longitude: -78.241714,
    icao: "CYEY"
  },
  YFA: {
    iata: "YFA",
    name: "Fort Albany Airport",
    city: "Fort Albany",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 52.241667,
    longitude: -81.591667,
    icao: "CYFA"
  },
  YFB: {
    iata: "YFB",
    name: "Iqaluit Airport",
    city: "Iqaluit",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 63.75175,
    longitude: -68.536586,
    icao: "CYFB"
  },
  YFC: {
    iata: "YFC",
    name: "Fredericton International Airport",
    city: "Fredericton",
    countryId: "CA",
    timeZoneRegionName: "America/Halifax",
    latitude: 45.873161,
    longitude: -66.52978,
    icao: "CYFC"
  },
  YFH: {
    iata: "YFH",
    name: "Fort Hope Airport",
    city: "Fort Hope",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 51.559345,
    longitude: -87.897958,
    icao: "CYFH"
  },
  YFJ: {
    iata: "YFJ",
    name: "Wekweeti Airport",
    city: "Snare Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 64.190556,
    longitude: -114.075556,
    icao: "CFJ2"
  },
  YFO: {
    iata: "YFO",
    name: "Flin Flon Airport",
    city: "Flin Flon",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 54.683333,
    longitude: -101.683333,
    icao: "CYFO"
  },
  YFR: {
    iata: "YFR",
    name: "Fort Resolution Airport",
    city: "Fort Resolution",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 61.176132,
    longitude: -113.684434,
    icao: "CYFR"
  },
  YFS: {
    iata: "YFS",
    name: "Fort Simpson Airport",
    city: "Fort Simpson",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 61.75,
    longitude: -121.233333,
    icao: "CYFS"
  },
  YFX: {
    iata: "YFX",
    name: "Fox Harbour Airport",
    city: "Fox Harbour",
    countryId: "CA",
    timeZoneRegionName: "America/St_Johns",
    latitude: 52.370953,
    longitude: -55.676069,
    icao: "CCK4"
  },
  YGB: {
    iata: "YGB",
    name: "Gillies Bay Airport",
    city: "Gillies Bay",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 49.7,
    longitude: -124.533333,
    icao: "CYGB"
  },
  YGC: {
    iata: "YGC",
    name: "Grande Cache Airport",
    city: "Grande Cache",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 53.916667,
    longitude: -118.866667,
    icao: "CEQ5"
  },
  YGH: {
    iata: "YGH",
    name: "Fort Good Hope Airport",
    city: "Fort Good Hope",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 66.266667,
    longitude: -128.65,
    icao: "CYGH"
  },
  YGJ: {
    iata: "YGJ",
    name: "Miho Airport",
    city: "Yonago",
    countryId: "JP",
    timeZoneRegionName: "Asia/Tokyo",
    latitude: 35.500651,
    longitude: 133.244477,
    icao: "RJOH"
  },
  YGK: {
    iata: "YGK",
    name: "Kingston/Norman Rogers Airport",
    city: "Kingston",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 44.219512,
    longitude: -76.59366,
    icao: "CYGK"
  },
  YGL: {
    iata: "YGL",
    name: "La Grande Airport",
    city: "La Grande",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 53.629722,
    longitude: -77.706389,
    icao: "CYGL"
  },
  YGM: {
    iata: "YGM",
    name: "Gimli Industrial Park Airport",
    city: "Gimli",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 50.628055,
    longitude: -97.043336,
    icao: "CYGM"
  },
  YGO: {
    iata: "YGO",
    name: "Gods Lake Narrows Airport",
    city: "Gods Lake Narrows",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 54.557701,
    longitude: -94.491173,
    icao: "CYGO"
  },
  YGP: {
    iata: "YGP",
    name: "Michel-Pouliot Gaspe Airport",
    city: "Gaspe",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 48.77638,
    longitude: -64.475971,
    icao: "CYGP"
  },
  YGQ: {
    iata: "YGQ",
    name: "Greenstone Regional Airport",
    city: "Geraldton",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 49.778301,
    longitude: -86.9394,
    icao: "CYGQ"
  },
  YGR: {
    iata: "YGR",
    name: "Iles De La Madeleine Airport",
    city: "Iles De La Madeleine",
    countryId: "CA",
    timeZoneRegionName: "America/Halifax",
    latitude: 47.366667,
    longitude: -61.9,
    icao: "CYGR"
  },
  YGT: {
    iata: "YGT",
    name: "Igloolik Airport",
    city: "Igloolik",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 69.4,
    longitude: -81.816667,
    icao: "CYGT"
  },
  YGV: {
    iata: "YGV",
    name: "Havre St. Pierre Airport",
    city: "Havre St. Pierre",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 50.25,
    longitude: -63.583333,
    icao: "CYGV"
  },
  YGW: {
    iata: "YGW",
    name: "Kuujjuarapik Airport",
    city: "Kuujjuarapik",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 55.279167,
    longitude: -77.766667,
    icao: "CYGW"
  },
  YGX: {
    iata: "YGX",
    name: "Gillam Airport",
    city: "Gillam",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 56.35,
    longitude: -94.7,
    icao: "CYGX"
  },
  YGZ: {
    iata: "YGZ",
    name: "Grise Fiord Airport",
    city: "Grise Fiord",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 76.417778,
    longitude: -82.957222,
    icao: "CYGZ"
  },
  YHB: {
    iata: "YHB",
    name: "Hudson Bay Airport",
    city: "Hudson Bay",
    countryId: "CA",
    timeZoneRegionName: "America/Regina",
    latitude: 52.866667,
    longitude: -102.416667,
    icao: "CYHB"
  },
  YHD: {
    iata: "YHD",
    name: "Dryden Regional Airport",
    city: "Dryden",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 49.830601,
    longitude: -92.747061,
    icao: "CYHD"
  },
  YHE: {
    iata: "YHE",
    name: "Hope Airport",
    city: "Hope",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 49.416667,
    longitude: -121.416667,
    icao: "CYHE"
  },
  YHF: {
    iata: "YHF",
    name: "Rene Fontaine Municipal Airport",
    city: "Hearst",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 49.714199,
    longitude: -83.686096,
    icao: "CYHF"
  },
  YHG: {
    iata: "YHG",
    name: "Charlottetown Airport",
    city: "Charlottetown",
    countryId: "CA",
    timeZoneRegionName: "America/St_Johns",
    latitude: 52.765459,
    longitude: -56.118263,
    icao: "CCH4"
  },
  YHI: {
    iata: "YHI",
    name: "Ulukhaktok Airport",
    city: "Ulukhaktok",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 70.762802,
    longitude: -117.806,
    icao: "CYHI"
  },
  YHK: {
    iata: "YHK",
    name: "Gjoa Haven Airport",
    city: "Gjoa Haven",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 68.633333,
    longitude: -95.95,
    icao: "CYHK"
  },
  YHM: {
    iata: "YHM",
    name: "John C. Munro Hamilton Airport",
    city: "Hamilton",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 43.173646,
    longitude: -79.934225,
    icao: "CYHM"
  },
  YHN: {
    iata: "YHN",
    name: "Hornepayne Municipal Airport",
    city: "Hornepayne",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 49.188723,
    longitude: -84.76461,
    icao: "CYHN"
  },
  YHO: {
    iata: "YHO",
    name: "Hopedale Airport",
    city: "Hopedale",
    countryId: "CA",
    timeZoneRegionName: "America/Halifax",
    latitude: 55.448333,
    longitude: -60.229444,
    icao: "CYHO"
  },
  YHP: {
    iata: "YHP",
    name: "Poplar Hill Airport",
    city: "Poplar Hill",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 52.083333,
    longitude: -94.3,
    icao: ""
  },
  YHR: {
    iata: "YHR",
    name: "Chevery Airport",
    city: "Chevery",
    countryId: "CA",
    timeZoneRegionName: "America/Blanc-Sablon",
    latitude: 50.5,
    longitude: -59.5,
    icao: "CYHR"
  },
  YHS: {
    iata: "YHS",
    name: "Sechelt Airport",
    city: "Sechelt",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 49.466667,
    longitude: -123.75,
    icao: "CAP3"
  },
  YHT: {
    iata: "YHT",
    name: "Haines Junction Airport",
    city: "Haines Junction",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 60.75,
    longitude: -137.5,
    icao: "CYHT"
  },
  YHU: {
    iata: "YHU",
    name: "St. Hubert Airport",
    city: "Montreal",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 45.516318,
    longitude: -73.420789,
    icao: "CYHU"
  },
  YHY: {
    iata: "YHY",
    name: "Merlyn Carter Airport",
    city: "Hay River",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 60.839699,
    longitude: -115.782997,
    icao: "CYHY"
  },
  YHZ: {
    iata: "YHZ",
    name: "Halifax Stanfield International Airport",
    city: "Halifax",
    countryId: "CA",
    timeZoneRegionName: "America/Halifax",
    latitude: 44.88496,
    longitude: -63.514253,
    icao: "CYHZ"
  },
  YIA: {
    iata: "YIA",
    name: "New Yogyakarta International Airport",
    city: "Yogyakarta",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jakarta",
    latitude: -7.905099,
    longitude: 110.056623,
    icao: "WAHI"
  },
  YIB: {
    iata: "YIB",
    name: "Atikokan Airport",
    city: "Atikokan",
    countryId: "CA",
    timeZoneRegionName: "America/Atikokan",
    latitude: 48.75,
    longitude: -91.616667,
    icao: "CYIB"
  },
  YIC: {
    iata: "YIC",
    name: "Yichun Mingyueshan Airport",
    city: "Yichun",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 27.803333,
    longitude: 114.308056,
    icao: ""
  },
  YIE: {
    iata: "YIE",
    name: "Arxan Yiershi Airport",
    city: "Arxan",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 47.310556,
    longitude: 119.911944,
    icao: "ZBES"
  },
  YIF: {
    iata: "YIF",
    name: "Pakuashipi Airport",
    city: "Pakuashipi",
    countryId: "CA",
    timeZoneRegionName: "America/Blanc-Sablon",
    latitude: 51.216667,
    longitude: -58.666667,
    icao: "CYIF"
  },
  YIH: {
    iata: "YIH",
    name: "Yichang Sanxia Airport",
    city: "Yichang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 30.556472,
    longitude: 111.479944,
    icao: "ZHYC"
  },
  YIK: {
    iata: "YIK",
    name: "Ivujivik Airport",
    city: "Ivujivik",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 62.417339,
    longitude: -77.92529,
    icao: "CYIK"
  },
  YIN: {
    iata: "YIN",
    name: "Yining Airport",
    city: "Yining",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 43.951998,
    longitude: 81.331444,
    icao: "ZWYN"
  },
  YIO: {
    iata: "YIO",
    name: "Pond Inlet Airport",
    city: "Pond Inlet",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 72.683333,
    longitude: -78,
    icao: "CYIO"
  },
  YIP: {
    iata: "YIP",
    name: "Willow Run Airport",
    city: "Detroit",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.233333,
    longitude: -83.533333,
    icao: "KYIP"
  },
  YIU: {
    iata: "YIU",
    name: "Yiwu Railway Station",
    city: "Yiwu",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 29.380833,
    longitude: 120.037778,
    icao: ""
  },
  YIV: {
    iata: "YIV",
    name: "Island Lake Airport",
    city: "Island Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 53.856785,
    longitude: -94.653043,
    icao: "CYIV"
  },
  YIW: {
    iata: "YIW",
    name: "Yiwu Airport",
    city: "Yiwu",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 29.344722,
    longitude: 120.032222,
    icao: "ZSYW"
  },
  YJA: {
    iata: "YJA",
    name: "Jasper Airport",
    city: "Jasper",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 52.992122,
    longitude: -118.057523,
    icao: "CEC4"
  },
  YJD: {
    iata: "YJD",
    name: "Franca Railway Station",
    city: "Barcelona",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 41.390205,
    longitude: 2.154007,
    icao: ""
  },
  YJF: {
    iata: "YJF",
    name: "Fort Liard Airport",
    city: "Fort Liard",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 60.25,
    longitude: -123.466667,
    icao: "CYJF"
  },
  YJH: {
    iata: "YJH",
    name: "San Sebastian Railway Station",
    city: "San Sebastian",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 43.3208116,
    longitude: -1.9844474,
    icao: ""
  },
  YJN: {
    iata: "YJN",
    name: "Saint Jean Airport",
    city: "Saint Jean",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 45.29758,
    longitude: -73.281293,
    icao: "CYJN"
  },
  YJT: {
    iata: "YJT",
    name: "Stephenville Airport",
    city: "Stephenville",
    countryId: "CA",
    timeZoneRegionName: "America/St_Johns",
    latitude: 48.54372,
    longitude: -58.552972,
    icao: "CYJT"
  },
  YJV: {
    iata: "YJV",
    name: "Valencia Railway Station",
    city: "Manises",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 39.4907322,
    longitude: -0.4558824,
    icao: ""
  },
  YKA: {
    iata: "YKA",
    name: "Kamloops Airport",
    city: "Kamloops",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 50.705447,
    longitude: -120.442023,
    icao: "CYKA"
  },
  YKC: {
    iata: "YKC",
    name: "Collins Bay Airport",
    city: "Collins Bay",
    countryId: "CA",
    timeZoneRegionName: "America/Regina",
    latitude: 58.23561,
    longitude: -103.677213,
    icao: "CYKC"
  },
  YKD: {
    iata: "YKD",
    name: "Kincardine Airport",
    city: "Kincardine",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 44.201389,
    longitude: -81.606667,
    icao: "CNS7"
  },
  YKE: {
    iata: "YKE",
    name: "Knee Lake Airport",
    city: "Knee Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 53.05,
    longitude: -94.666667,
    icao: "CJT3"
  },
  YKF: {
    iata: "YKF",
    name: "Region of Waterloo International Airport",
    city: "Kitchener",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 43.458978,
    longitude: -80.385056,
    icao: "CYKF"
  },
  YKG: {
    iata: "YKG",
    name: "Kangirsuk Airport",
    city: "Kangirsuk",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 60.023082,
    longitude: -70.004602,
    icao: "CYAS"
  },
  YKH: {
    iata: "YKH",
    name: "Yingkou Lanqi Airport",
    city: "Yingkou",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 40.540006,
    longitude: 122.355426,
    icao: ""
  },
  YKJ: {
    iata: "YKJ",
    name: "Key Lake Airport",
    city: "Key Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Regina",
    latitude: 57.256287,
    longitude: -105.618634,
    icao: "CYKJ"
  },
  YKL: {
    iata: "YKL",
    name: "Schefferville Airport",
    city: "Schefferville",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 54.805294,
    longitude: -66.805282,
    icao: "CYKL"
  },
  YKM: {
    iata: "YKM",
    name: "Yakima Air Terminal",
    city: "Yakima",
    countryId: "US",
    timeZoneRegionName: "America/Los_Angeles",
    latitude: 46.566944,
    longitude: -120.537778,
    icao: "KYKM"
  },
  YKN: {
    iata: "YKN",
    name: "Chan Gurney Airport",
    city: "Yankton",
    countryId: "US",
    timeZoneRegionName: "America/Chicago",
    latitude: 42.916944,
    longitude: -97.386389,
    icao: "KYKN"
  },
  YKO: {
    iata: "YKO",
    name: "Hakkari Yuksekova Selahaddin Eyyubi Airport",
    city: "Yuksekova",
    countryId: "TR",
    timeZoneRegionName: "Europe/Istanbul",
    latitude: 37.545243,
    longitude: 44.255164,
    icao: "LTCW"
  },
  YKQ: {
    iata: "YKQ",
    name: "Waskaganish Airport",
    city: "Waskaganish",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 51.4875,
    longitude: -78.75,
    icao: "CYKQ"
  },
  YKS: {
    iata: "YKS",
    name: "Yakutsk Airport",
    city: "Yakutsk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yakutsk",
    latitude: 62.085607,
    longitude: 129.750067,
    icao: "UEEE"
  },
  YKU: {
    iata: "YKU",
    name: "Chisasibi Airport",
    city: "Chisasibi",
    countryId: "CA",
    timeZoneRegionName: "America/Montreal",
    latitude: 53.8055992,
    longitude: -78.9169006,
    icao: "CSU2"
  },
  YKX: {
    iata: "YKX",
    name: "Kirkland Lake Airport",
    city: "Kirkland Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 48.210279,
    longitude: -79.98139,
    icao: "CYKX"
  },
  YKY: {
    iata: "YKY",
    name: "Kindersley Regional Airport",
    city: "Kindersley",
    countryId: "CA",
    timeZoneRegionName: "America/Regina",
    latitude: 51.517662,
    longitude: -109.175262,
    icao: "CYKY"
  },
  YKZ: {
    iata: "YKZ",
    name: "Buttonville Municipal Airport",
    city: "Toronto",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 43.861308,
    longitude: -79.367734,
    icao: "CYKZ"
  },
  YLB: {
    iata: "YLB",
    name: "Lac Biche Airport",
    city: "Lac Biche",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 54.766667,
    longitude: -112.016667,
    icao: "CYLB"
  },
  YLC: {
    iata: "YLC",
    name: "Kimmirut Airport",
    city: "Kimmirut/Lake Harbour",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 62.85,
    longitude: -69.883333,
    icao: "CYLC"
  },
  YLD: {
    iata: "YLD",
    name: "Chapleau Airport",
    city: "Chapleau",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 47.819444,
    longitude: -83.352778,
    icao: "CYLD"
  },
  YLE: {
    iata: "YLE",
    name: "Whati Airport",
    city: "Whati/Lac La Martre",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 63.132944,
    longitude: -117.243177,
    icao: "CEM3"
  },
  YLH: {
    iata: "YLH",
    name: "Lansdowne House Airport",
    city: "Lansdowne House",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 52.195593,
    longitude: -87.934193,
    icao: "CYLH"
  },
  YLI: {
    iata: "YLI",
    name: "Ylivieska Airport",
    city: "Ylivieska",
    countryId: "FI",
    timeZoneRegionName: "Europe/Helsinki",
    latitude: 64.054444,
    longitude: 24.728889,
    icao: "EFYL"
  },
  YLJ: {
    iata: "YLJ",
    name: "Meadow Lake Airport",
    city: "Meadow Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Regina",
    latitude: 54.126525,
    longitude: -108.511841,
    icao: "CYLJ"
  },
  YLL: {
    iata: "YLL",
    name: "Lloydminster Airport",
    city: "Lloydminster",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 53.31297,
    longitude: -110.072718,
    icao: "CYLL"
  },
  YLQ: {
    iata: "YLQ",
    name: "La Tuque Airport",
    city: "La Tuque",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 47.409698,
    longitude: -72.788902,
    icao: "CYLQ"
  },
  YLR: {
    iata: "YLR",
    name: "Leaf Rapids Airport",
    city: "Leaf Rapids",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 56.513336,
    longitude: -99.985274,
    icao: "CYLR"
  },
  YLS: {
    iata: "YLS",
    name: "Lebel-Sur-Quevillon Airport",
    city: "Lebel-Sur-Quevillon",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 49.033333,
    longitude: -77.016667,
    icao: "CSH4"
  },
  YLT: {
    iata: "YLT",
    name: "Alert Airport",
    city: "Alert",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 82.516667,
    longitude: -62.283333,
    icao: "CYLT"
  },
  YLW: {
    iata: "YLW",
    name: "Kelowna International Airport",
    city: "Kelowna",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 49.951542,
    longitude: -119.381396,
    icao: "CYLW"
  },
  YLX: {
    iata: "YLX",
    name: "Yulin Fumian Airport",
    city: "Yulin",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 22.438056,
    longitude: 110.120833,
    icao: ""
  },
  YLY: {
    iata: "YLY",
    name: "Langley Regional Airport",
    city: "Langley",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 49.100833,
    longitude: -122.630833,
    icao: "CYNJ"
  },
  YMA: {
    iata: "YMA",
    name: "Mayo Airport",
    city: "Mayo",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 63.616389,
    longitude: -135.873611,
    icao: "CYMA"
  },
  YMB: {
    iata: "YMB",
    name: "Merritt Airport",
    city: "Merritt",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 50.116667,
    longitude: -120.75,
    icao: "CAD5"
  },
  YME: {
    iata: "YME",
    name: "Matane Airport",
    city: "Matane",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 48.833333,
    longitude: -67.516667,
    icao: "CYME"
  },
  YMG: {
    iata: "YMG",
    name: "Manitouwadge Airport",
    city: "Manitouwadge",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 49.083333,
    longitude: -85.866667,
    icao: "CYMG"
  },
  YMH: {
    iata: "YMH",
    name: "Mary's Harbour Airport",
    city: "Mary's Harbour",
    countryId: "CA",
    timeZoneRegionName: "America/St_Johns",
    latitude: 52.303039,
    longitude: -55.847787,
    icao: "CYMH"
  },
  YMJ: {
    iata: "YMJ",
    name: "C.M. McEwen Airport",
    city: "Moose Jaw",
    countryId: "CA",
    timeZoneRegionName: "America/Regina",
    latitude: 50.330287,
    longitude: -105.556196,
    icao: "CJS4"
  },
  YMK: {
    iata: "YMK",
    name: "Mys Kamennyy Airport",
    city: "Mys Kamennyy",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yekaterinburg",
    latitude: 68.46843,
    longitude: 73.595732,
    icao: "USDK"
  },
  YML: {
    iata: "YML",
    name: "Charlevoix Airport",
    city: "Murray Bay",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 47.65,
    longitude: -70.166667,
    icao: "CYML"
  },
  YMM: {
    iata: "YMM",
    name: "Fort McMurray International Airport",
    city: "Fort McMurray",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 56.656589,
    longitude: -111.223952,
    icao: "CYMM"
  },
  YMN: {
    iata: "YMN",
    name: "Makkovik Airport",
    city: "Makkovik",
    countryId: "CA",
    timeZoneRegionName: "America/Halifax",
    latitude: 55.166667,
    longitude: -59.166667,
    icao: "CYFT"
  },
  YMO: {
    iata: "YMO",
    name: "Moosonee Airport",
    city: "Moosonee",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 51.291111,
    longitude: -80.604167,
    icao: "CYMO"
  },
  YMS: {
    iata: "YMS",
    name: "Yurimaguas Airport",
    city: "Yurimaguas",
    countryId: "PE",
    timeZoneRegionName: "America/Lima",
    latitude: -5.9,
    longitude: -76.1,
    icao: "SPMS"
  },
  YMT: {
    iata: "YMT",
    name: "Chibougamau Airport",
    city: "Chibougamau",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 49.916667,
    longitude: -74.366667,
    icao: "CYMT"
  },
  YMW: {
    iata: "YMW",
    name: "Maniwaki Airport",
    city: "Maniwaki",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 46.383333,
    longitude: -75.966667,
    icao: "CYMW"
  },
  YMX: {
    iata: "YMX",
    name: "Mirabel International Airport",
    city: "Montreal",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 45.680615,
    longitude: -74.024407,
    icao: "CYMX"
  },
  YMY: {
    iata: "YMY",
    name: "Downtown Railway Station",
    city: "Montreal",
    countryId: "CA",
    timeZoneRegionName: "America/Montreal",
    latitude: 45.5088889,
    longitude: -73.5541667,
    icao: ""
  },
  YNA: {
    iata: "YNA",
    name: "Natashquan Airport",
    city: "Natashquan",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 50.183333,
    longitude: -61.8,
    icao: "CYNA"
  },
  YNB: {
    iata: "YNB",
    name: "Yanbu Airport",
    city: "Yanbu",
    countryId: "SA",
    timeZoneRegionName: "Asia/Riyadh",
    latitude: 24.140733,
    longitude: 38.063019,
    icao: "OEYN"
  },
  YNC: {
    iata: "YNC",
    name: "Wemindji Airport",
    city: "Wemindji",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 53,
    longitude: -78.816667,
    icao: "CYNC"
  },
  YND: {
    iata: "YND",
    name: "Gatineau Airport",
    city: "Gatineau",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 45.520631,
    longitude: -75.562827,
    icao: "CYND"
  },
  YNE: {
    iata: "YNE",
    name: "Norway House Airport",
    city: "Norway House",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 53.954167,
    longitude: -97.845833,
    icao: "CYNE"
  },
  YNG: {
    iata: "YNG",
    name: "Youngstown-Warren Regional Airport",
    city: "Youngstown",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.256111,
    longitude: -80.669722,
    icao: "KYNG"
  },
  YNH: {
    iata: "YNH",
    name: "Hudson's Hope Airport",
    city: "Hudson's Hope",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 56,
    longitude: -121.9,
    icao: "CYNH"
  },
  YNJ: {
    iata: "YNJ",
    name: "Yanji Chaoyangchuan Airport",
    city: "Yanji",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 42.885662,
    longitude: 129.439369,
    icao: "ZYYJ"
  },
  YNL: {
    iata: "YNL",
    name: "Points North Landing Airport",
    city: "Points North Landing",
    countryId: "CA",
    timeZoneRegionName: "America/Regina",
    latitude: 58.275,
    longitude: -104.081111,
    icao: "CYNL"
  },
  YNM: {
    iata: "YNM",
    name: "Matagami Airport",
    city: "Matagami",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 49.75,
    longitude: -77.8,
    icao: "CYNM"
  },
  YNO: {
    iata: "YNO",
    name: "North Spirit Lake Airport",
    city: "North Spirit Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 52.490673,
    longitude: -92.975029,
    icao: ""
  },
  YNP: {
    iata: "YNP",
    name: "Natuashish Airport",
    city: "Natuashish",
    countryId: "CA",
    timeZoneRegionName: "America/Halifax",
    latitude: 55.913889,
    longitude: -61.184444,
    icao: ""
  },
  YNS: {
    iata: "YNS",
    name: "Nemiscau Airport",
    city: "Nemiscau",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 51.691056,
    longitude: -76.135564,
    icao: "CYHH"
  },
  YNT: {
    iata: "YNT",
    name: "Penglai International Airport",
    city: "Yantai",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 37.657222,
    longitude: 120.987222,
    icao: "ZSYT"
  },
  YNY: {
    iata: "YNY",
    name: "Yangyang Airport",
    city: "Yangyang",
    countryId: "KR",
    timeZoneRegionName: "Asia/Seoul",
    latitude: 38.059459,
    longitude: 128.663985,
    icao: "RKNY"
  },
  YNZ: {
    iata: "YNZ",
    name: "Yancheng Nanyang International Airport",
    city: "Yancheng",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 33.431217,
    longitude: 120.204406,
    icao: "ZSYN"
  },
  YOA: {
    iata: "YOA",
    name: "Ekati Airport",
    city: "Ekati",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 64.699444,
    longitude: -110.614444,
    icao: "CYOA"
  },
  YOC: {
    iata: "YOC",
    name: "Old Crow Airport",
    city: "Old Crow",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 67.568133,
    longitude: -139.849179,
    icao: "CYOC"
  },
  YOD: {
    iata: "YOD",
    name: "R.W. McNair Airport",
    city: "Cold Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 54.404999,
    longitude: -110.278999,
    icao: "CEN5"
  },
  YOG: {
    iata: "YOG",
    name: "Ogoki Airport",
    city: "Ogoki",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 51.666667,
    longitude: -85.916667,
    icao: "CNT3"
  },
  YOH: {
    iata: "YOH",
    name: "Oxford House Airport",
    city: "Oxford House",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 54.934241,
    longitude: -95.276677,
    icao: "CYOH"
  },
  YOJ: {
    iata: "YOJ",
    name: "High Level Airport",
    city: "High Level",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 58.621399,
    longitude: -117.165001,
    icao: "CYOJ"
  },
  YOL: {
    iata: "YOL",
    name: "Yola Airport",
    city: "Yola",
    countryId: "NG",
    timeZoneRegionName: "Africa/Lagos",
    latitude: 9.267332,
    longitude: 12.426414,
    icao: "DNYO"
  },
  YON: {
    iata: "YON",
    name: "Yongphulla Airport",
    city: "Trashigang",
    countryId: "BT",
    timeZoneRegionName: "Asia/Thimphu",
    latitude: 27.256389,
    longitude: 91.514444,
    icao: "VQTY"
  },
  YOO: {
    iata: "YOO",
    name: "Oshawa Municipal Airport",
    city: "Oshawa",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 43.916667,
    longitude: -78.9,
    icao: "CYOO"
  },
  YOP: {
    iata: "YOP",
    name: "Rainbow Lake Airport",
    city: "Rainbow Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 58.494372,
    longitude: -119.413406,
    icao: "CYOP"
  },
  YOS: {
    iata: "YOS",
    name: "Billy Bishop Regional Airport",
    city: "Owen Sound",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 44.590278,
    longitude: -80.8375,
    icao: "CYOS"
  },
  YOW: {
    iata: "YOW",
    name: "Ottawa/Macdonald-Cartier International Airport",
    city: "Ottawa",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 45.320833,
    longitude: -75.672778,
    icao: "CYOW"
  },
  YPA: {
    iata: "YPA",
    name: "Glass Field",
    city: "Prince Albert",
    countryId: "CA",
    timeZoneRegionName: "America/Regina",
    latitude: 53.21585,
    longitude: -105.676601,
    icao: "CYPA"
  },
  YPC: {
    iata: "YPC",
    name: "Nora A. Ruben Airport",
    city: "Paulatuk",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 69.360838,
    longitude: -124.07547,
    icao: "CYPC"
  },
  YPD: {
    iata: "YPD",
    name: "Parry Sound Airport",
    city: "Parry Sound",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 45.255391,
    longitude: -79.827109,
    icao: "CNK4"
  },
  YPE: {
    iata: "YPE",
    name: "Peace River Airport",
    city: "Peace River",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 56.231854,
    longitude: -117.442556,
    icao: "CYPE"
  },
  YPF: {
    iata: "YPF",
    name: "Esquimalt Airport",
    city: "Esquimalt",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 48.433333,
    longitude: -123.4,
    icao: "CYPF"
  },
  YPG: {
    iata: "YPG",
    name: "Southport Airport",
    city: "Portage La Prarie",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 49.903099,
    longitude: -98.273817,
    icao: "CYPG"
  },
  YPH: {
    iata: "YPH",
    name: "Inukjuak Airport",
    city: "Inukjuak",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 58.433333,
    longitude: -78.166667,
    icao: "CYPH"
  },
  YPJ: {
    iata: "YPJ",
    name: "Aupaluk Airport",
    city: "Aupaluk",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 59.3,
    longitude: -69.666667,
    icao: "CYLA"
  },
  YPL: {
    iata: "YPL",
    name: "Pickle Lake Airport",
    city: "Pickle Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Atikokan",
    latitude: 51.44646,
    longitude: -90.21415,
    icao: "CYPL"
  },
  YPM: {
    iata: "YPM",
    name: "Pikangikum Airport",
    city: "Pikangikum",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 51.817377,
    longitude: -93.972869,
    icao: "CYPM"
  },
  YPN: {
    iata: "YPN",
    name: "Port-Menier Airport",
    city: "Port-Menier",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 49.837066,
    longitude: -64.291116,
    icao: "CYPN"
  },
  YPO: {
    iata: "YPO",
    name: "Peawanuk Airport",
    city: "Peawanuk",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 54.983333,
    longitude: -85.433333,
    icao: "CYPO"
  },
  YPQ: {
    iata: "YPQ",
    name: "Peterborough Airport",
    city: "Peterborough",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 44.233199,
    longitude: -78.357789,
    icao: "CYPQ"
  },
  YPR: {
    iata: "YPR",
    name: "Digby Island Airport",
    city: "Prince Rupert",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 54.287222,
    longitude: -130.440833,
    icao: "CYPR"
  },
  YPS: {
    iata: "YPS",
    name: "Port Hawkesbury Airport",
    city: "Port Hawkesbury",
    countryId: "CA",
    timeZoneRegionName: "America/Halifax",
    latitude: 45.616667,
    longitude: -61.35,
    icao: "CYPD"
  },
  YPW: {
    iata: "YPW",
    name: "Powell River Airport",
    city: "Powell River",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 49.816667,
    longitude: -124.5,
    icao: "CYPW"
  },
  YPX: {
    iata: "YPX",
    name: "Puvirnituq Airport",
    city: "Povungnituk",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 60.033333,
    longitude: -77.166667,
    icao: "CYPX"
  },
  YPY: {
    iata: "YPY",
    name: "Fort Chipewyan Airport",
    city: "Fort Chipewyan",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 58.767989,
    longitude: -111.114062,
    icao: "CYPY"
  },
  YPZ: {
    iata: "YPZ",
    name: "Burns Lake Airport",
    city: "Burns Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 54.233333,
    longitude: -125.766667,
    icao: "CYPZ"
  },
  YQA: {
    iata: "YQA",
    name: "Muskoka Airport",
    city: "Muskoka",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 44.976497,
    longitude: -79.306808,
    icao: "CYQA"
  },
  YQB: {
    iata: "YQB",
    name: "Quebec City Jean Lesage International Airport",
    city: "Quebec",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 46.792037,
    longitude: -71.383388,
    icao: "CYQB"
  },
  YQC: {
    iata: "YQC",
    name: "Quaqtaq Airport",
    city: "Quaqtaq",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 61.333333,
    longitude: -69.633333,
    icao: "CYHA"
  },
  YQD: {
    iata: "YQD",
    name: "The Pas Airport",
    city: "The Pas",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 53.966667,
    longitude: -101.1,
    icao: "CYQD"
  },
  YQF: {
    iata: "YQF",
    name: "Red Deer Regional Airport",
    city: "Red Deer",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 52.176944,
    longitude: -113.893333,
    icao: "CYQF"
  },
  YQG: {
    iata: "YQG",
    name: "Windsor International Airport",
    city: "Windsor",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 42.266386,
    longitude: -82.95919,
    icao: "CYQG"
  },
  YQH: {
    iata: "YQH",
    name: "Watson Lake Airport",
    city: "Watson Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 60.123611,
    longitude: -128.825,
    icao: "CYQH"
  },
  YQI: {
    iata: "YQI",
    name: "Yarmouth Airport",
    city: "Yarmouth",
    countryId: "CA",
    timeZoneRegionName: "America/Halifax",
    latitude: 43.833333,
    longitude: -66.083333,
    icao: "CYQI"
  },
  YQK: {
    iata: "YQK",
    name: "Kenora Airport",
    city: "Kenora",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 49.7875,
    longitude: -94.358333,
    icao: "CYQK"
  },
  YQL: {
    iata: "YQL",
    name: "Lethbridge Airport",
    city: "Lethbridge",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 49.631944,
    longitude: -112.791667,
    icao: "CYQL"
  },
  YQM: {
    iata: "YQM",
    name: "Greater Moncton International Airport",
    city: "Moncton",
    countryId: "CA",
    timeZoneRegionName: "America/Halifax",
    latitude: 46.113609,
    longitude: -64.686106,
    icao: "CYQM"
  },
  YQN: {
    iata: "YQN",
    name: "Nakina Airport",
    city: "Nakina",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 50.182993,
    longitude: -86.699242,
    icao: "CYQN"
  },
  YQQ: {
    iata: "YQQ",
    name: "Comox Airport",
    city: "Comox",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 49.705865,
    longitude: -124.907815,
    icao: "CYQQ"
  },
  YQR: {
    iata: "YQR",
    name: "Regina International Airport",
    city: "Regina",
    countryId: "CA",
    timeZoneRegionName: "America/Regina",
    latitude: 50.433326,
    longitude: -104.65519,
    icao: "CYQR"
  },
  YQS: {
    iata: "YQS",
    name: "Pembroke Area Municipal Airport",
    city: "Saint Thomas",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 42.783333,
    longitude: -81.2,
    icao: "CYQS"
  },
  YQT: {
    iata: "YQT",
    name: "Thunder Bay International Airport",
    city: "Thunder Bay",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 48.371841,
    longitude: -89.31167,
    icao: "CYQT"
  },
  YQU: {
    iata: "YQU",
    name: "Grande Prairie Airport",
    city: "Grande Prairie",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 55.177076,
    longitude: -118.873603,
    icao: "CYQU"
  },
  YQV: {
    iata: "YQV",
    name: "Yorkton Municipal Airport",
    city: "Yorkton",
    countryId: "CA",
    timeZoneRegionName: "America/Regina",
    latitude: 51.264097,
    longitude: -102.459351,
    icao: "CYQV"
  },
  YQW: {
    iata: "YQW",
    name: "Cameron McIntosh Airport",
    city: "North Battleford",
    countryId: "CA",
    timeZoneRegionName: "America/Regina",
    latitude: 52.769199,
    longitude: -108.244003,
    icao: "CYQW"
  },
  YQX: {
    iata: "YQX",
    name: "Gander International Airport",
    city: "Gander",
    countryId: "CA",
    timeZoneRegionName: "America/St_Johns",
    latitude: 48.946243,
    longitude: -54.570223,
    icao: "CYQX"
  },
  YQY: {
    iata: "YQY",
    name: "Sydney Airport",
    city: "Sydney",
    countryId: "CA",
    timeZoneRegionName: "America/Halifax",
    latitude: 46.166667,
    longitude: -60.05,
    icao: "CYQY"
  },
  YQZ: {
    iata: "YQZ",
    name: "Quesnel Airport",
    city: "Quesnel",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 53.026667,
    longitude: -122.509722,
    icao: "CYQZ"
  },
  YRA: {
    iata: "YRA",
    name: "Gameti Rae Lakes Airport",
    city: "Rae Lakes",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 64.116888,
    longitude: -117.311732,
    icao: "CEV4"
  },
  YRB: {
    iata: "YRB",
    name: "Resolute Bay Airport",
    city: "Resolute",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 74.716667,
    longitude: -94.966667,
    icao: "CYRB"
  },
  YRF: {
    iata: "YRF",
    name: "Cartwright Airport",
    city: "Cartwright",
    countryId: "CA",
    timeZoneRegionName: "America/Halifax",
    latitude: 53.682606,
    longitude: -57.03828,
    icao: "CYCA"
  },
  YRG: {
    iata: "YRG",
    name: "Rigolet Airport",
    city: "Rigolet",
    countryId: "CA",
    timeZoneRegionName: "America/Halifax",
    latitude: 54.333333,
    longitude: -58.416667,
    icao: "CCZ2"
  },
  YRI: {
    iata: "YRI",
    name: "Riviere-du-Loup Airport",
    city: "Riviere-du-Loup",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 47.833333,
    longitude: -69.533333,
    icao: "CYRI"
  },
  YRJ: {
    iata: "YRJ",
    name: "Roberval Airport",
    city: "Roberval",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 48.522342,
    longitude: -72.267327,
    icao: "CYRJ"
  },
  YRL: {
    iata: "YRL",
    name: "Red Lake Airport",
    city: "Red Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 51.068762,
    longitude: -93.800059,
    icao: "CYRL"
  },
  YRM: {
    iata: "YRM",
    name: "Rocky Mountain House Airport",
    city: "Rocky Mountain House",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 52.366667,
    longitude: -114.916667,
    icao: "CYRM"
  },
  YRO: {
    iata: "YRO",
    name: "Rockcliffe Airport",
    city: "Ottawa",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 45.4603,
    longitude: -75.646103,
    icao: "CYRO"
  },
  YRQ: {
    iata: "YRQ",
    name: "Trois-Rivieres Airport",
    city: "Trois-Rivieres",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 46.362201,
    longitude: -72.675591,
    icao: "CYRQ"
  },
  YRS: {
    iata: "YRS",
    name: "Red Sucker Lake Airport",
    city: "Red Sucker Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 54.167569,
    longitude: -93.557619,
    icao: "CYRS"
  },
  YRT: {
    iata: "YRT",
    name: "Rankin Inlet Airport",
    city: "Rankin Inlet",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 62.80998,
    longitude: -92.100187,
    icao: "CYRT"
  },
  YRV: {
    iata: "YRV",
    name: "Revelstoke Airport",
    city: "Revelstoke",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 51,
    longitude: -118.166667,
    icao: "CYRV"
  },
  YSB: {
    iata: "YSB",
    name: "Sudbury Airport",
    city: "Sudbury",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 46.622961,
    longitude: -80.795924,
    icao: "CYSB"
  },
  YSC: {
    iata: "YSC",
    name: "Sherbrooke Airport",
    city: "Sherbrooke",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 45.416667,
    longitude: -71.9,
    icao: "CYSC"
  },
  YSD: {
    iata: "YSD",
    name: "Suffield CFB Heliport",
    city: "Suffield",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 50.275541,
    longitude: -111.183701,
    icao: "CYSD"
  },
  YSE: {
    iata: "YSE",
    name: "Squamish Airport",
    city: "Squamish",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 49.781667,
    longitude: -123.161944,
    icao: "CYSE"
  },
  YSF: {
    iata: "YSF",
    name: "Stony Rapids Airport",
    city: "Stony Rapids",
    countryId: "CA",
    timeZoneRegionName: "America/Regina",
    latitude: 59.251162,
    longitude: -105.836574,
    icao: "CYSF"
  },
  YSG: {
    iata: "YSG",
    name: "Lutselke Airport",
    city: "Lutselke/Snowdrift",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 62.418611,
    longitude: -110.075556,
    icao: "CYLK"
  },
  YSH: {
    iata: "YSH",
    name: "Montague Airport",
    city: "Smith Falls",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 44.94829,
    longitude: -75.939592,
    icao: "CYSH"
  },
  YSJ: {
    iata: "YSJ",
    name: "Saint John Airport",
    city: "Saint John",
    countryId: "CA",
    timeZoneRegionName: "America/Halifax",
    latitude: 45.32948,
    longitude: -65.890201,
    icao: "CYSJ"
  },
  YSK: {
    iata: "YSK",
    name: "Sanikiluaq Airport",
    city: "Sanikiluaq",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 56.55,
    longitude: -79.216667,
    icao: "CYSK"
  },
  YSL: {
    iata: "YSL",
    name: "St Leonard Airport",
    city: "St Leonard",
    countryId: "CA",
    timeZoneRegionName: "America/Halifax",
    latitude: 47.156841,
    longitude: -67.835866,
    icao: "CYSL"
  },
  YSM: {
    iata: "YSM",
    name: "Fort Smith Airport",
    city: "Fort Smith",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 60.016667,
    longitude: -111.966667,
    icao: "CYSM"
  },
  YSN: {
    iata: "YSN",
    name: "Salmon Arm Airport",
    city: "Salmon Arm",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 50.683333,
    longitude: -119.233333,
    icao: "CZAM"
  },
  YSO: {
    iata: "YSO",
    name: "Postville Airport",
    city: "Postville",
    countryId: "CA",
    timeZoneRegionName: "America/Halifax",
    latitude: 54.916667,
    longitude: -59.966667,
    icao: "CCD4"
  },
  YSP: {
    iata: "YSP",
    name: "Marathon Airport",
    city: "Marathon",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 48.75,
    longitude: -86.35,
    icao: "CYSP"
  },
  YSQ: {
    iata: "YSQ",
    name: "Songyuan Chaganhu Airport",
    city: "Songyuan",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 44.93056,
    longitude: 124.55083,
    icao: ""
  },
  YSR: {
    iata: "YSR",
    name: "Nanisivik Airport",
    city: "Nanisivik",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 73.75,
    longitude: -84.5,
    icao: "CYSR"
  },
  YST: {
    iata: "YST",
    name: "St. Theresa Point Airport",
    city: "St. Theresa Point",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 53.846127,
    longitude: -94.851598,
    icao: "CYST"
  },
  YSU: {
    iata: "YSU",
    name: "Summerside Airport",
    city: "Summerside",
    countryId: "CA",
    timeZoneRegionName: "America/Halifax",
    latitude: 46.44059,
    longitude: -63.833612,
    icao: "CYSU"
  },
  YSY: {
    iata: "YSY",
    name: "Sachs Harbour Airport",
    city: "Sachs Harbour",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 71.991445,
    longitude: -125.241046,
    icao: "CYSY"
  },
  YTA: {
    iata: "YTA",
    name: "Pembroke And Area Airport",
    city: "Pembroke",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 45.861667,
    longitude: -77.249444,
    icao: "CYTA"
  },
  YTD: {
    iata: "YTD",
    name: "Thicket Portage Airport",
    city: "Thicket Portage",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 55.316667,
    longitude: -97.7,
    icao: "CZLQ"
  },
  YTE: {
    iata: "YTE",
    name: "Cape Dorset Airport",
    city: "Cape Dorset",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 64.233333,
    longitude: -76.533333,
    icao: "CYTE"
  },
  YTF: {
    iata: "YTF",
    name: "Alma Airport",
    city: "Alma",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 48.509654,
    longitude: -71.642714,
    icao: "CYTF"
  },
  YTH: {
    iata: "YTH",
    name: "Thompson Airport",
    city: "Thompson",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 55.797532,
    longitude: -97.8605,
    icao: "CYTH"
  },
  YTJ: {
    iata: "YTJ",
    name: "Terrace Bay Airport",
    city: "Terrace Bay",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 48.75,
    longitude: -87.166667,
    icao: "CYTJ"
  },
  YTL: {
    iata: "YTL",
    name: "Big Trout Airport",
    city: "Big Trout",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 53.815942,
    longitude: -89.889516,
    icao: "CYTL"
  },
  YTM: {
    iata: "YTM",
    name: "Mont-Tremblant International Airport",
    city: "La Macaza",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 46.405758,
    longitude: -74.780056,
    icao: "CYFJ"
  },
  YTQ: {
    iata: "YTQ",
    name: "Tasiujuaq Airport",
    city: "Tasiujuaq",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 58.6678,
    longitude: -69.956328,
    icao: "CYTQ"
  },
  YTR: {
    iata: "YTR",
    name: "Trenton Airport",
    city: "Trenton",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 44.1,
    longitude: -77.583333,
    icao: "CYTR"
  },
  YTS: {
    iata: "YTS",
    name: "Timmins Victor M. Power Airport",
    city: "Timmins",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 48.566371,
    longitude: -81.371642,
    icao: "CYTS"
  },
  YTT: {
    iata: "YTT",
    name: "Tisdale Airport",
    city: "Tisdale",
    countryId: "CA",
    timeZoneRegionName: "America/Regina",
    latitude: 52.85,
    longitude: -104.066667,
    icao: "CJY3"
  },
  YTW: {
    iata: "YTW",
    name: "Yutian Wanfang Airport",
    city: "Yutian",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 36.8086,
    longitude: 81.7831,
    icao: ""
  },
  YTX: {
    iata: "YTX",
    name: "Telegraph Creek Airport",
    city: "Telegraph Creek",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 57.9,
    longitude: -131.15,
    icao: "CBM5"
  },
  YTY: {
    iata: "YTY",
    name: "Yangzhou Taizhou Airport",
    city: "Yangzhou",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 32.563057,
    longitude: 119.720278,
    icao: "ZSYA"
  },
  YTZ: {
    iata: "YTZ",
    name: "Billy Bishop Toronto City Airport",
    city: "Toronto",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 43.627499,
    longitude: -79.396202,
    icao: "CYTZ"
  },
  YUB: {
    iata: "YUB",
    name: "James Gruben Airport",
    city: "Tuktoyaktuk",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 69.433296,
    longitude: -133.026001,
    icao: "CYUB"
  },
  YUD: {
    iata: "YUD",
    name: "Umiujaq Airport",
    city: "Umiujaq",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 56.536111,
    longitude: -76.518333,
    icao: "CYMU"
  },
  YUE: {
    iata: "YUE",
    name: "Yuendumu Airport",
    city: "Yuendumu",
    countryId: "AU",
    timeZoneRegionName: "Australia/Darwin",
    latitude: -22.266667,
    longitude: 131.816667,
    icao: "YYND"
  },
  YUL: {
    iata: "YUL",
    name: "Montreal-Pierre Elliott Trudeau International Airport",
    city: "Montreal",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 45.457715,
    longitude: -73.749906,
    icao: "CYUL"
  },
  YUM: {
    iata: "YUM",
    name: "Yuma International Airport",
    city: "Yuma",
    countryId: "US",
    timeZoneRegionName: "America/Phoenix",
    latitude: 32.668605,
    longitude: -114.599263,
    icao: "KNYL"
  },
  YUS: {
    iata: "YUS",
    name: "Yushu Batang Airport",
    city: "Yushu",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 32.839468,
    longitude: 97.037791,
    icao: "ZLYS"
  },
  YUT: {
    iata: "YUT",
    name: "Repulse Bay Airport",
    city: "Repulse Bay",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 66.524844,
    longitude: -86.228593,
    icao: "CYUT"
  },
  YUX: {
    iata: "YUX",
    name: "Hall Beach Airport",
    city: "Hall Beach",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 68.783333,
    longitude: -81.25,
    icao: "CYUX"
  },
  YUY: {
    iata: "YUY",
    name: "Rouyn-Noranda Airport",
    city: "Rouyn",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 48.211769,
    longitude: -78.828967,
    icao: "CYUY"
  },
  YVB: {
    iata: "YVB",
    name: "Bonaventure Airport",
    city: "Bonaventure",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 48.069083,
    longitude: -65.458079,
    icao: "CYVB"
  },
  YVC: {
    iata: "YVC",
    name: "Barber Field",
    city: "La Ronge",
    countryId: "CA",
    timeZoneRegionName: "America/Regina",
    latitude: 55.151395,
    longitude: -105.262097,
    icao: "CYVC"
  },
  YVE: {
    iata: "YVE",
    name: "Vernon Airport",
    city: "Vernon",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 50.25,
    longitude: -119.333333,
    icao: "CYVK"
  },
  YVG: {
    iata: "YVG",
    name: "Vermilion Airport",
    city: "Vermilion",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 53.355538,
    longitude: -110.829385,
    icao: "CYVG"
  },
  YVM: {
    iata: "YVM",
    name: "Qikiqtarjuaq Airport",
    city: "Qikiqtarkuaq",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 67.545832,
    longitude: -64.031386,
    icao: "CYVM"
  },
  YVO: {
    iata: "YVO",
    name: "Val-d'Or Airport",
    city: "Val D'Or",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 48.052603,
    longitude: -77.788583,
    icao: "CYVO"
  },
  YVP: {
    iata: "YVP",
    name: "Kuujjuaq Airport",
    city: "Kuujjuaq",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 58.100237,
    longitude: -68.41798,
    icao: "CYVP"
  },
  YVQ: {
    iata: "YVQ",
    name: "Norman Wells Airport",
    city: "Norman Wells",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 65.277854,
    longitude: -126.793375,
    icao: "CYVQ"
  },
  YVR: {
    iata: "YVR",
    name: "Vancouver International Airport",
    city: "Vancouver",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 49.194697,
    longitude: -123.179191,
    icao: "CYVR"
  },
  YVT: {
    iata: "YVT",
    name: "Buffalo Narrows Airport",
    city: "Buffalo Narrows",
    countryId: "CA",
    timeZoneRegionName: "America/Regina",
    latitude: 55.866667,
    longitude: -108.466667,
    icao: "CYVT"
  },
  YVV: {
    iata: "YVV",
    name: "Wiarton Airport",
    city: "Wiarton",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 44.666667,
    longitude: -81.166667,
    icao: "CYVV"
  },
  YVZ: {
    iata: "YVZ",
    name: "Deer Lake Airport",
    city: "Deer Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 52.666667,
    longitude: -94.5,
    icao: "CYVZ"
  },
  YWA: {
    iata: "YWA",
    name: "Petawawa Airport",
    city: "Petawawa",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 45.9,
    longitude: -77.283333,
    icao: "CYWA"
  },
  YWB: {
    iata: "YWB",
    name: "Kangiqsujuaq Airport",
    city: "Kangiqsujuaq",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 61.6,
    longitude: -71.95,
    icao: "CYKG"
  },
  YWG: {
    iata: "YWG",
    name: "Winnipeg James Armstrong Richardson International Airport",
    city: "Winnipeg",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 49.905756,
    longitude: -97.223716,
    icao: "CYWG"
  },
  YWJ: {
    iata: "YWJ",
    name: "Deline Airport",
    city: "Deline",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 65.166667,
    longitude: -123.5,
    icao: "CYWJ"
  },
  YWK: {
    iata: "YWK",
    name: "Wabush Airport",
    city: "Wabush",
    countryId: "CA",
    timeZoneRegionName: "America/Halifax",
    latitude: 52.926315,
    longitude: -66.873999,
    icao: "CYWK"
  },
  YWL: {
    iata: "YWL",
    name: "Williams Lake Airport",
    city: "Williams Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 52.184722,
    longitude: -122.044444,
    icao: "CYWL"
  },
  YWM: {
    iata: "YWM",
    name: "Williams Harbour Airport",
    city: "Williams Harbour",
    countryId: "CA",
    timeZoneRegionName: "America/St_Johns",
    latitude: 52.566879,
    longitude: -55.784262,
    icao: "CCA6"
  },
  YWO: {
    iata: "YWO",
    name: "Lupin Airport",
    city: "Lupin",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 65.758333,
    longitude: -111.25,
    icao: "CYWO"
  },
  YWP: {
    iata: "YWP",
    name: "Webequie Airport",
    city: "Webequie",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 52.959722,
    longitude: -87.368889,
    icao: "CYWP"
  },
  YWR: {
    iata: "YWR",
    name: "White River Sea Plane Base",
    city: "White River",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 48.626896,
    longitude: -85.223249,
    icao: "CYWR"
  },
  YWY: {
    iata: "YWY",
    name: "Wrigley Airport",
    city: "Wrigley",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 63.210556,
    longitude: -123.438611,
    icao: "CYWY"
  },
  YXC: {
    iata: "YXC",
    name: "Canadian Rockies International Airport",
    city: "Cranbrook",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 49.614368,
    longitude: -115.787024,
    icao: "CYXC"
  },
  YXE: {
    iata: "YXE",
    name: "Saskatoon International Airport",
    city: "Saskatoon",
    countryId: "CA",
    timeZoneRegionName: "America/Regina",
    latitude: 52.169703,
    longitude: -106.690366,
    icao: "CYXE"
  },
  YXH: {
    iata: "YXH",
    name: "Medicine Hat Regional Airport",
    city: "Medicine Hat",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 50.021131,
    longitude: -110.724628,
    icao: "CYXH"
  },
  YXJ: {
    iata: "YXJ",
    name: "North Peace Regional Airport",
    city: "Fort St. John",
    countryId: "CA",
    timeZoneRegionName: "America/Dawson_Creek",
    latitude: 56.244836,
    longitude: -120.735081,
    icao: "CYXJ"
  },
  YXK: {
    iata: "YXK",
    name: "Rimouski Airport",
    city: "Rimouski",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 48.475399,
    longitude: -68.50508,
    icao: "CYXK"
  },
  YXL: {
    iata: "YXL",
    name: "Sioux Lookout Airport",
    city: "Sioux Lookout",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 50.115209,
    longitude: -91.902998,
    icao: "CYXL"
  },
  YXN: {
    iata: "YXN",
    name: "Whale Cove Airport",
    city: "Whale Cove",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 62.233333,
    longitude: -92.6,
    icao: "CYXN"
  },
  YXP: {
    iata: "YXP",
    name: "Pangnirtung Airport",
    city: "Pangnirtung",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 66.133333,
    longitude: -65.733333,
    icao: "CYXP"
  },
  YXQ: {
    iata: "YXQ",
    name: "Beaver Creek Airport",
    city: "Beaver Creek",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 62,
    longitude: -141,
    icao: "CYXQ"
  },
  YXR: {
    iata: "YXR",
    name: "Earlton Airport",
    city: "Earlton",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 47.697222,
    longitude: -79.851944,
    icao: "CYXR"
  },
  YXS: {
    iata: "YXS",
    name: "Prince George Airport",
    city: "Prince George",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 53.88381,
    longitude: -122.673956,
    icao: "CYXS"
  },
  YXT: {
    iata: "YXT",
    name: "Northwest Regional Airport",
    city: "Terrace",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 54.472026,
    longitude: -128.576548,
    icao: "CYXT"
  },
  YXU: {
    iata: "YXU",
    name: "London International Airport",
    city: "London",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 43.028018,
    longitude: -81.149651,
    icao: "CYXU"
  },
  YXX: {
    iata: "YXX",
    name: "Abbotsford Airport",
    city: "Vancouver",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 49.025556,
    longitude: -122.361944,
    icao: "CYXX"
  },
  YXY: {
    iata: "YXY",
    name: "Whitehorse Airport",
    city: "Whitehorse",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 60.716667,
    longitude: -135.066667,
    icao: "CYXY"
  },
  YXZ: {
    iata: "YXZ",
    name: "Wawa Airport",
    city: "Wawa",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 47.9625,
    longitude: -84.785833,
    icao: "CYXZ"
  },
  YYA: {
    iata: "YYA",
    name: "Yueyang Sanhe Airport",
    city: "Yueyang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 29.312778,
    longitude: 113.281667,
    icao: ""
  },
  YYB: {
    iata: "YYB",
    name: "Jack Garland Airport",
    city: "North Bay",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 46.356824,
    longitude: -79.42725,
    icao: "CYYB"
  },
  YYC: {
    iata: "YYC",
    name: "Calgary International Airport",
    city: "Calgary",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 51.131394,
    longitude: -114.010551,
    icao: "CYYC"
  },
  YYD: {
    iata: "YYD",
    name: "Smithers Airport",
    city: "Smithers",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 54.825556,
    longitude: -127.180278,
    icao: "CYYD"
  },
  YYE: {
    iata: "YYE",
    name: "Northern Rockies Regional Airport",
    city: "Fort Nelson",
    countryId: "CA",
    timeZoneRegionName: "America/Dawson_Creek",
    latitude: 58.838433,
    longitude: -122.581682,
    icao: "CYYE"
  },
  YYF: {
    iata: "YYF",
    name: "Penticton Airport",
    city: "Penticton",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 49.464722,
    longitude: -119.6,
    icao: "CYYF"
  },
  YYG: {
    iata: "YYG",
    name: "Charlottetown Airport",
    city: "Charlottetown",
    countryId: "CA",
    timeZoneRegionName: "America/Halifax",
    latitude: 46.285898,
    longitude: -63.131736,
    icao: "CYYG"
  },
  YYH: {
    iata: "YYH",
    name: "Taloyoak Airport",
    city: "Taloyoak",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 69.533333,
    longitude: -93.516667,
    icao: "CYYH"
  },
  YYJ: {
    iata: "YYJ",
    name: "Victoria International Airport",
    city: "Victoria",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 48.640267,
    longitude: -123.430963,
    icao: "CYYJ"
  },
  YYL: {
    iata: "YYL",
    name: "Lynn Lake Airport",
    city: "Lynn Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 56.859407,
    longitude: -101.07025,
    icao: "CYYL"
  },
  YYM: {
    iata: "YYM",
    name: "Cowley Airport",
    city: "Cowley",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 49.866667,
    longitude: -114.166667,
    icao: "CYYM"
  },
  YYN: {
    iata: "YYN",
    name: "Swift Current Airport",
    city: "Swift Current",
    countryId: "CA",
    timeZoneRegionName: "America/Regina",
    latitude: 50.286404,
    longitude: -107.693625,
    icao: "CYYN"
  },
  YYQ: {
    iata: "YYQ",
    name: "Churchill Airport",
    city: "Churchill",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 58.748191,
    longitude: -94.074497,
    icao: "CYYQ"
  },
  YYR: {
    iata: "YYR",
    name: "Goose Bay Airport",
    city: "Goose Bay",
    countryId: "CA",
    timeZoneRegionName: "America/Halifax",
    latitude: 53.313533,
    longitude: -60.412399,
    icao: "CYYR"
  },
  YYT: {
    iata: "YYT",
    name: "St. John's International Airport",
    city: "St. John's",
    countryId: "CA",
    timeZoneRegionName: "America/St_Johns",
    latitude: 47.612818,
    longitude: -52.743339,
    icao: "CYYT"
  },
  YYU: {
    iata: "YYU",
    name: "Kapuskasing Airport",
    city: "Kapuskasing",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 49.41389,
    longitude: -82.467499,
    icao: "CYYU"
  },
  YYW: {
    iata: "YYW",
    name: "Armstrong Airport",
    city: "Armstrong",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 50.295562,
    longitude: -88.914238,
    icao: "CYYW"
  },
  YYY: {
    iata: "YYY",
    name: "Mont Joli Airport",
    city: "Mont Joli",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 48.609058,
    longitude: -68.209342,
    icao: "CYYY"
  },
  YYZ: {
    iata: "YYZ",
    name: "Pearson International Airport",
    city: "Toronto",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 43.681585,
    longitude: -79.61146,
    icao: "CYYZ"
  },
  YZE: {
    iata: "YZE",
    name: "Manitoulin Airport",
    city: "Gore Bay",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 45.885278,
    longitude: -82.567778,
    icao: "CYZE"
  },
  YZF: {
    iata: "YZF",
    name: "Yellowknife Airport",
    city: "Yellowknife",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 62.470869,
    longitude: -114.4375,
    icao: "CYZF"
  },
  YZG: {
    iata: "YZG",
    name: "Salluit Airport",
    city: "Salluit",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 62.2,
    longitude: -75.633333,
    icao: "CYZG"
  },
  YZH: {
    iata: "YZH",
    name: "Slave Lake Airport",
    city: "Slave Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 55.293229,
    longitude: -114.777224,
    icao: "CYZH"
  },
  YZP: {
    iata: "YZP",
    name: "Sandspit Airport",
    city: "Sandspit",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 53.254289,
    longitude: -131.814301,
    icao: "CYZP"
  },
  YZR: {
    iata: "YZR",
    name: "Sarnia Airport",
    city: "Sarnia",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 42.997222,
    longitude: -82.311111,
    icao: "CYZR"
  },
  YZS: {
    iata: "YZS",
    name: "Coral Harbour Airport",
    city: "Coral Harbour",
    countryId: "CA",
    timeZoneRegionName: "America/Atikokan",
    latitude: 64.18834,
    longitude: -83.354157,
    icao: "CYZS"
  },
  YZT: {
    iata: "YZT",
    name: "Port Hardy Airport",
    city: "Port Hardy",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 50.680556,
    longitude: -127.363889,
    icao: "CYZT"
  },
  YZU: {
    iata: "YZU",
    name: "Whitecourt Airport",
    city: "Whitecourt",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 54.140492,
    longitude: -115.784721,
    icao: "CYZU"
  },
  YZV: {
    iata: "YZV",
    name: "Sept-Iles Airport",
    city: "Sept-Iles",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 50.21751,
    longitude: -66.264036,
    icao: "CYZV"
  },
  YZW: {
    iata: "YZW",
    name: "Teslin Airport",
    city: "Teslin",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 60.166667,
    longitude: -132.716667,
    icao: "CYZW"
  },
  YZX: {
    iata: "YZX",
    name: "Greenwood Airport",
    city: "Greenwood",
    countryId: "CA",
    timeZoneRegionName: "America/Halifax",
    latitude: 44.984444,
    longitude: -64.916944,
    icao: "CYZX"
  },
  YZZ: {
    iata: "YZZ",
    name: "Trail Airport",
    city: "Trail",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 49.055614,
    longitude: -117.609222,
    icao: "CAD4"
  },
  ZAC: {
    iata: "ZAC",
    name: "York Landing Airport",
    city: "York Landing",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 56.089515,
    longitude: -96.091921,
    icao: "CZAC"
  },
  ZAD: {
    iata: "ZAD",
    name: "Zadar Airport",
    city: "Zadar",
    countryId: "HR",
    timeZoneRegionName: "Europe/Zagreb",
    latitude: 44.097778,
    longitude: 15.356667,
    icao: "LDZD"
  },
  ZAG: {
    iata: "ZAG",
    name: "Franjo Tudman Airport",
    city: "Zagreb",
    countryId: "HR",
    timeZoneRegionName: "Europe/Zagreb",
    latitude: 45.733242,
    longitude: 16.061519,
    icao: "LDZA"
  },
  ZAH: {
    iata: "ZAH",
    name: "Zahedan Airport",
    city: "Zahedan",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 29.475755,
    longitude: 60.900328,
    icao: "OIZH"
  },
  ZAJ: {
    iata: "ZAJ",
    name: "Zaranj Airport",
    city: "Zaranj",
    countryId: "AF",
    timeZoneRegionName: "Asia/Kabul",
    latitude: 30.968253,
    longitude: 61.867076,
    icao: "OAZJ"
  },
  ZAL: {
    iata: "ZAL",
    name: "Pichoy Airport",
    city: "Valdivia",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -39.650002,
    longitude: -73.086098,
    icao: "SCVD"
  },
  ZAM: {
    iata: "ZAM",
    name: "Zamboanga International Airport",
    city: "Zamboanga",
    countryId: "PH",
    timeZoneRegionName: "Asia/Manila",
    latitude: 6.919294,
    longitude: 122.062259,
    icao: "RPMZ"
  },
  ZAO: {
    iata: "ZAO",
    name: "Laberandie Airport",
    city: "Cahors",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 44.351398,
    longitude: 1.47528,
    icao: "LFCC"
  },
  ZAQ: {
    iata: "ZAQ",
    name: "Nuremberg Hbf Railway Station",
    city: "Nuremberg",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 41.56166,
    longitude: 46.664787,
    icao: ""
  },
  ZAR: {
    iata: "ZAR",
    name: "Zaria Airport",
    city: "Zaria",
    countryId: "NG",
    timeZoneRegionName: "Africa/Lagos",
    latitude: 11,
    longitude: 7.666667,
    icao: "DNZA"
  },
  ZAT: {
    iata: "ZAT",
    name: "Zhaotong Airport",
    city: "Zhaotong",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 27.316667,
    longitude: 103.8,
    icao: "ZPZT"
  },
  ZAZ: {
    iata: "ZAZ",
    name: "Zaragoza Airport",
    city: "Zaragoza",
    countryId: "ES",
    timeZoneRegionName: "Europe/Madrid",
    latitude: 41.663862,
    longitude: -1.007466,
    icao: "LEZG"
  },
  ZBA: {
    iata: "ZBA",
    countryId: "CH",
    city: "Basel Badischer",
    icao: "",
    name: "Basel Badischer Railway Station",
    latitude: 46.8333,
    longitude: 8.3333,
    timeZoneRegionName: "Europe/Zurich"
  },
  ZBE: {
    iata: "ZBE",
    name: "Dolni Benesov Airport",
    city: "Zabreh",
    countryId: "CZ",
    timeZoneRegionName: "Europe/Prague",
    latitude: 49.928299,
    longitude: 18.0783,
    icao: "LKZA"
  },
  ZBF: {
    iata: "ZBF",
    name: "Bathurst Airport",
    city: "Bathurst",
    countryId: "CA",
    timeZoneRegionName: "America/Halifax",
    latitude: 47.629167,
    longitude: -65.739444,
    icao: "CZBF"
  },
  ZBL: {
    iata: "ZBL",
    name: "Biloela Airport",
    city: "Biloela",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -24.4,
    longitude: 150.516667,
    icao: "YBLE"
  },
  ZBM: {
    iata: "ZBM",
    name: "Roland-Desourdy Airport",
    city: "Bromont",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 45.290798,
    longitude: -72.741402,
    icao: "CZBM"
  },
  ZBO: {
    iata: "ZBO",
    name: "Bowen Airport",
    city: "Bowen",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -20.016667,
    longitude: 148.216667,
    icao: "YBWN"
  },
  ZBP: {
    iata: "ZBP",
    name: "Baltimore Railway",
    city: "Baltimore",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.2903848,
    longitude: -76.6121893,
    icao: ""
  },
  ZBR: {
    iata: "ZBR",
    name: "Konarak Airport",
    city: "Chah Bahar",
    countryId: "IR",
    timeZoneRegionName: "Asia/Tehran",
    latitude: 25.4433,
    longitude: 60.382099,
    icao: "OIZC"
  },
  ZBY: {
    iata: "ZBY",
    name: "Sayaboury Airport",
    city: "Sayaboury",
    countryId: "LA",
    timeZoneRegionName: "Asia/Vientiane",
    latitude: 19.25,
    longitude: 101.7,
    icao: "VLSB"
  },
  ZCL: {
    iata: "ZCL",
    name: "La Calera Airport",
    city: "Zacatecas",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 22.8985,
    longitude: -102.685335,
    icao: "MMZC"
  },
  ZCO: {
    iata: "ZCO",
    name: "Temuco Airport",
    city: "Temuco",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -38.925151,
    longitude: -72.651197,
    icao: "SCTC"
  },
  ZDH: {
    iata: "ZDH",
    name: "Basel SBB station",
    city: "Courrendlin",
    countryId: "CH",
    timeZoneRegionName: "Europe/Zurich",
    latitude: 47.3251,
    longitude: 7.3523,
    icao: ""
  },
  ZDJ: {
    iata: "ZDJ",
    name: "Bern Railway Station",
    city: "Bern",
    countryId: "CH",
    timeZoneRegionName: "Europe/Zurich",
    latitude: 46.9479222,
    longitude: 7.4446085,
    icao: ""
  },
  ZDU: {
    iata: "ZDU",
    name: "Dundee Railway Station",
    city: "Dundee",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 56.4614282,
    longitude: -2.9681109,
    icao: ""
  },
  ZDY: {
    iata: "ZDY",
    name: "Delma Island Airport",
    city: "Delma Island",
    countryId: "AE",
    timeZoneRegionName: "Asia/Dubai",
    latitude: 24.508333,
    longitude: 52.335278,
    icao: "OMDL"
  },
  ZEC: {
    iata: "ZEC",
    name: "Secunda Airport",
    city: "Secunda",
    countryId: "ZA",
    timeZoneRegionName: "Africa/Johannesburg",
    latitude: -27,
    longitude: 28,
    icao: "FASC"
  },
  ZEL: {
    iata: "ZEL",
    name: "Campbell Island Airport",
    city: "Bella Bella",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 52.185001,
    longitude: -128.156994,
    icao: "CBBC"
  },
  ZEM: {
    iata: "ZEM",
    name: "East Main Airport",
    city: "East Main",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 52.25,
    longitude: -78.516667,
    icao: "CZEM"
  },
  ZEP: {
    iata: "ZEP",
    name: "Victoria Railway",
    city: "Victoria",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.51,
    longitude: 0.06,
    icao: ""
  },
  ZER: {
    iata: "ZER",
    name: "Ziro Airport",
    city: "Ziro",
    countryId: "IN",
    timeZoneRegionName: "Asia/Kolkata",
    latitude: 27.588301,
    longitude: 93.828102,
    icao: "VEZO"
  },
  ZEU: {
    iata: "ZEU",
    name: "Goettingen Railway Station",
    city: "Goettingen",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 51.536713887934,
    longitude: 9.92678249829,
    icao: ""
  },
  ZFA: {
    iata: "ZFA",
    name: "Faro Airport",
    city: "Faro",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 62.207504,
    longitude: -133.375835,
    icao: "CZFA"
  },
  ZFD: {
    iata: "ZFD",
    name: "Fond Du Lac Airport",
    city: "Fond Du Lac",
    countryId: "CA",
    timeZoneRegionName: "America/Regina",
    latitude: 59.334211,
    longitude: -107.181191,
    icao: "CZFD"
  },
  ZFJ: {
    iata: "ZFJ",
    name: "Rennes Railway Station",
    city: "Rennes",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 48.1025,
    longitude: -1.6727,
    icao: ""
  },
  ZFL: {
    iata: "ZFL",
    name: "Tianma Airport",
    city: "Zhaosu",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 43.088333,
    longitude: 81.224444,
    icao: ""
  },
  ZFM: {
    iata: "ZFM",
    name: "Fort Mcpherson Airport",
    city: "Fort McPherson",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 67.407527,
    longitude: -134.862082,
    icao: "CZFM"
  },
  ZFN: {
    iata: "ZFN",
    name: "Tulita Airport",
    city: "Tulita/Fort Norman",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 64.916667,
    longitude: -125.566667,
    icao: "CZFN"
  },
  ZFQ: {
    iata: "ZFQ",
    name: "Bordeaux-Saint-Jean station",
    city: "Bordeaux",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 44.8256,
    longitude: -0.5556,
    icao: ""
  },
  ZFV: {
    iata: "ZFV",
    name: "Philadelphia Railway Station",
    city: "Takoradi",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.95578,
    longitude: -75.181968,
    icao: ""
  },
  ZFW: {
    iata: "ZFW",
    name: "Fairview Airport",
    city: "Fairview",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 56.066667,
    longitude: -118.383333,
    icao: "CEB5"
  },
  ZGF: {
    iata: "ZGF",
    name: "Grand Forks Airport",
    city: "Grand Forks",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 49.016667,
    longitude: -118.433333,
    icao: "CZGF"
  },
  ZGG: {
    iata: "ZGG",
    name: "Glasgow Central Railway Station",
    city: "Huadong",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 23.387861,
    longitude: 113.29734,
    icao: ""
  },
  ZGH: {
    iata: "ZGH",
    name: "Copenhagen Central Station",
    city: "Copenhagen",
    countryId: "DK",
    timeZoneRegionName: "Europe/Copenhagen",
    latitude: 55.6728941844,
    longitude: 12.5649674141,
    icao: ""
  },
  ZGI: {
    iata: "ZGI",
    name: "Gods River Airport",
    city: "Gods River",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 54.839143,
    longitude: -94.079654,
    icao: "CZGI"
  },
  ZGL: {
    iata: "ZGL",
    name: "South Galway Airport",
    city: "South Galway",
    countryId: "AU",
    timeZoneRegionName: "Australia/Brisbane",
    latitude: -25.683333,
    longitude: 142.116667,
    icao: "YSGW"
  },
  ZGM: {
    iata: "ZGM",
    name: "Ngoma Airport",
    city: "Ngoma",
    countryId: "ZM",
    timeZoneRegionName: "Africa/Lusaka",
    latitude: -15.958333,
    longitude: 25.934444,
    icao: "FLNA"
  },
  ZGR: {
    iata: "ZGR",
    name: "Little Grand Rapids Airport",
    city: "Little Grand Rapids",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 52.045012,
    longitude: -95.466191,
    icao: "CZGR"
  },
  ZGS: {
    iata: "ZGS",
    name: "La Romaine Airport",
    city: "La Romaine",
    countryId: "CA",
    timeZoneRegionName: "America/Blanc-Sablon",
    latitude: 50.259701,
    longitude: -60.679401,
    icao: ""
  },
  ZGU: {
    iata: "ZGU",
    name: "Gaua Island Airport",
    city: "Gaua",
    countryId: "VU",
    timeZoneRegionName: "Pacific/Efate",
    latitude: -14.220086,
    longitude: 167.588279,
    icao: "NVSQ"
  },
  ZHA: {
    iata: "ZHA",
    name: "Zhanjiang Airport",
    city: "Zhanjiang",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 21.214727,
    longitude: 110.362715,
    icao: "ZGZJ"
  },
  ZHM: {
    iata: "ZHM",
    name: "Shamshernagar Airport",
    city: "Shamshernagar",
    countryId: "BD",
    timeZoneRegionName: "Asia/Dhaka",
    latitude: 24.398611,
    longitude: 91.921111,
    icao: "VGSH"
  },
  ZHP: {
    iata: "ZHP",
    name: "High Prairie Airport",
    city: "High Prairie",
    countryId: "CA",
    timeZoneRegionName: "America/Edmonton",
    latitude: 55.4,
    longitude: -116.483333,
    icao: "CZHP"
  },
  ZHT: {
    iata: "ZHT",
    countryId: "CH",
    city: "Geneve",
    icao: "",
    name: "Geneva Railway Station",
    latitude: 46.1983922,
    longitude: 6.1422961,
    timeZoneRegionName: "Europe/Zurich"
  },
  ZHY: {
    iata: "ZHY",
    name: "Xiangshan Airport",
    city: "Zhongwei",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 37.573125,
    longitude: 105.154454,
    icao: "ZLZW"
  },
  ZIA: {
    iata: "ZIA",
    name: "Zhukovsky International Airport",
    city: "Zhukovsky",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 55.55254,
    longitude: 38.150407,
    icao: "UUBW"
  },
  ZIC: {
    iata: "ZIC",
    name: "Victoria Airport",
    city: "Victoria",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -38.216667,
    longitude: -72.333333,
    icao: "SCTO"
  },
  ZIG: {
    iata: "ZIG",
    name: "Ziguinchor Airport",
    city: "Ziguinchor",
    countryId: "SN",
    timeZoneRegionName: "Africa/Dakar",
    latitude: 12.556111,
    longitude: -16.275833,
    icao: "GOGG"
  },
  ZIH: {
    iata: "ZIH",
    name: "Ixtapa/Zihuatanejo Internacional Airport",
    city: "Ixtapa/Zihuatanejo",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 17.606782,
    longitude: -101.464062,
    icao: "MMZH"
  },
  ZIV: {
    iata: "ZIV",
    name: "Inverness Railway Station",
    city: "Inverness",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 57.4766949,
    longitude: -4.2314535,
    icao: ""
  },
  ZIX: {
    iata: "ZIX",
    name: "Zhigansk Airport",
    city: "Zhigansk",
    countryId: "RU",
    timeZoneRegionName: "Asia/Yakutsk",
    latitude: 66.796667,
    longitude: 123.361389,
    icao: "UEVV"
  },
  ZJG: {
    iata: "ZJG",
    name: "Jenpeg Airport",
    city: "Jenpeg",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 54.519444,
    longitude: -98.046111,
    icao: "CZJG"
  },
  ZJN: {
    iata: "ZJN",
    name: "Swan River Airport",
    city: "Swan River",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 52.116667,
    longitude: -101.233333,
    icao: "CZJN"
  },
  ZKB: {
    iata: "ZKB",
    name: "Kasaba Bay Airport",
    city: "Kasaba Bay",
    countryId: "ZM",
    timeZoneRegionName: "Africa/Lusaka",
    latitude: -8.522222,
    longitude: 30.659722,
    icao: "FLKY"
  },
  ZKD: {
    iata: "ZKD",
    name: "Moscow Leningradsky Railway Station",
    city: "Moscow",
    countryId: "RU",
    timeZoneRegionName: "Europe/Moscow",
    latitude: 55.755786,
    longitude: 37.617633,
    icao: ""
  },
  ZKE: {
    iata: "ZKE",
    name: "Kashechewan Airport",
    city: "Kaschechewan",
    countryId: "CA",
    timeZoneRegionName: "America/Toronto",
    latitude: 52.333333,
    longitude: -81.333333,
    icao: "CZKE"
  },
  ZKP: {
    iata: "ZKP",
    name: "Zyryanka Airport",
    city: "Zyryanka",
    countryId: "RU",
    timeZoneRegionName: "Asia/Srednekolymsk",
    latitude: 65.738333,
    longitude: 150.707778,
    icao: "UESU"
  },
  ZLN: {
    iata: "ZLN",
    name: "Le Mans Railway Station",
    city: "Le Mans",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 48.00611,
    longitude: 0.199556,
    icao: ""
  },
  ZLO: {
    iata: "ZLO",
    name: "Manzanillo Airport",
    city: "Manzanillo",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 19.145585,
    longitude: -104.561721,
    icao: "MMZO"
  },
  ZLS: {
    iata: "ZLS",
    name: "Liverpool St Rail Station",
    city: "Woolwich",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 51.51,
    longitude: 0.06,
    icao: ""
  },
  ZLT: {
    iata: "ZLT",
    name: "La Tabatiere Airport",
    city: "La Tabatiere",
    countryId: "CA",
    timeZoneRegionName: "America/Blanc-Sablon",
    latitude: 50.828055,
    longitude: -58.97601,
    icao: ""
  },
  ZLX: {
    iata: "ZLX",
    name: "Zalingei Airport",
    city: "Zalingei",
    countryId: "SD",
    timeZoneRegionName: "Africa/Khartoum",
    latitude: 12.937955,
    longitude: 23.506332,
    icao: "HSZA"
  },
  ZLY: {
    iata: "ZLY",
    name: "Albany Railway Station",
    city: "Baitang",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 32.8399,
    longitude: 97.0379,
    icao: ""
  },
  ZMB: {
    iata: "ZMB",
    countryId: "DE",
    city: "Hamburg",
    icao: "",
    name: "Hamburg Central Station",
    latitude: 53.5528,
    longitude: 10.0064,
    timeZoneRegionName: "Europe/Paris"
  },
  ZMH: {
    iata: "ZMH",
    name: "South Cariboo Regional Airport",
    city: "108 Mile Ranch",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 51.736099,
    longitude: -121.333,
    icao: "CZML"
  },
  ZMI: {
    iata: "ZMI",
    name: "Mergellina Railway",
    city: "Mergellina",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 40.8400969,
    longitude: 14.2516357,
    icao: ""
  },
  ZMM: {
    iata: "ZMM",
    name: "Zamora Airport",
    city: "Zamora",
    countryId: "MX",
    timeZoneRegionName: "America/Mexico_City",
    latitude: 19.983333,
    longitude: -102.266667,
    icao: "MMZM"
  },
  ZMS: {
    iata: "ZMS",
    name: "S.M. Novella Rail.Svc",
    city: "Saynshand",
    countryId: "IT",
    timeZoneRegionName: "Europe/Rome",
    latitude: 45.13128,
    longitude: 110.17072,
    icao: ""
  },
  ZMT: {
    iata: "ZMT",
    name: "Masset Airport",
    city: "Masset",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 54.022225,
    longitude: -132.117758,
    icao: "CZMT"
  },
  ZMU: {
    iata: "ZMU",
    name: "Munich Central Station",
    city: "Munich",
    countryId: "DE",
    timeZoneRegionName: "Europe/Paris",
    latitude: 48.1408,
    longitude: 11.555,
    icao: ""
  },
  ZNA: {
    iata: "ZNA",
    name: "Nanaimo Harbour Water Airport",
    city: "Nanaimo",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 49.166667,
    longitude: -123.933333,
    icao: "CAC8"
  },
  ZND: {
    iata: "ZND",
    name: "Zinder Airport",
    city: "Zinder",
    countryId: "NE",
    timeZoneRegionName: "Africa/Niamey",
    latitude: 13.779444,
    longitude: 8.983056,
    icao: "DRZR"
  },
  ZNE: {
    iata: "ZNE",
    name: "Newman Airport",
    city: "Newman",
    countryId: "AU",
    timeZoneRegionName: "Australia/Perth",
    latitude: -23.416517,
    longitude: 119.801372,
    icao: "YNWM"
  },
  ZNZ: {
    iata: "ZNZ",
    name: "Zanzibar International Airport",
    city: "Zanzibar",
    countryId: "TZ",
    timeZoneRegionName: "Africa/Dar_es_Salaam",
    latitude: -6.218466,
    longitude: 39.221185,
    icao: "HTZA"
  },
  ZOS: {
    iata: "ZOS",
    name: "Canal Bajo Airport",
    city: "Osorno",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -40.607778,
    longitude: -73.055556,
    icao: "SCJO"
  },
  ZPB: {
    iata: "ZPB",
    name: "Sachigo Lake Airport",
    city: "Sachigo Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 53.890556,
    longitude: -92.195278,
    icao: "CZPB"
  },
  ZPC: {
    iata: "ZPC",
    name: "Pucon Airport",
    city: "Pucon",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -39.763889,
    longitude: -71.633333,
    icao: "SCPC"
  },
  ZPH: {
    iata: "ZPH",
    name: "Zephyrhills Airport",
    city: "Zephyrhills",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 28.233333,
    longitude: -82.183333,
    icao: "KZPH"
  },
  ZPO: {
    iata: "ZPO",
    name: "Pine House Airport",
    city: "Pine House",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 55.516667,
    longitude: -106.583333,
    icao: "CZPO"
  },
  ZPY: {
    iata: "ZPY",
    name: "Siegburg Railway Station",
    city: "Siegburg",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 50.7998473,
    longitude: 7.2074514,
    icao: ""
  },
  ZQN: {
    iata: "ZQN",
    name: "Queenstown Airport",
    city: "Queenstown",
    countryId: "NZ",
    timeZoneRegionName: "Pacific/Auckland",
    latitude: -45.022039,
    longitude: 168.739104,
    icao: "NZQN"
  },
  ZQW: {
    iata: "ZQW",
    name: "Zweibrucken Airport",
    city: "Zweibrucken",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 49.215161,
    longitude: 7.399708,
    icao: "EDRZ"
  },
  ZQZ: {
    iata: "ZQZ",
    name: "Zhangjiakou Ningyuan Airport",
    city: "Zhangjiakou",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 40.739228,
    longitude: 114.931455,
    icao: "ZBZJ"
  },
  ZRB: {
    iata: "ZRB",
    name: "Frankfurt Hbf Railway Station",
    city: "Frankfurt",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 50.1071439,
    longitude: 8.6637837,
    icao: ""
  },
  ZRH: {
    iata: "ZRH",
    name: "Zurich Airport",
    city: "Zurich",
    countryId: "CH",
    timeZoneRegionName: "Europe/Zurich",
    latitude: 47.450604,
    longitude: 8.561746,
    icao: "LSZH"
  },
  ZRI: {
    iata: "ZRI",
    name: "Stevanus Rumbewas Airport",
    city: "Serui",
    countryId: "ID",
    timeZoneRegionName: "Asia/Jayapura",
    latitude: -1.82842,
    longitude: 136.062402,
    icao: "WABO"
  },
  ZRJ: {
    iata: "ZRJ",
    name: "Weagamow Airport",
    city: "Round Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 52.9436,
    longitude: -91.312798,
    icao: "CZRJ"
  },
  ZRL: {
    iata: "ZRL",
    name: "Lancaster Railway",
    city: "Lancaster",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.0378755,
    longitude: -76.3055144,
    icao: ""
  },
  ZRP: {
    iata: "ZRP",
    name: "Pennsylvania Railroad Station",
    city: "Pennsylvania",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.7503,
    longitude: 73.9931,
    icao: ""
  },
  ZRT: {
    iata: "ZRT",
    name: "Hartford Railway",
    city: "Hartford",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.7637111,
    longitude: -72.6850932,
    icao: ""
  },
  ZRV: {
    iata: "ZRV",
    name: "Providence Railway",
    city: "Providence",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.8239891,
    longitude: -71.4128343,
    icao: ""
  },
  ZRZ: {
    iata: "ZRZ",
    name: "New Carrolton RR",
    city: "New",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 38.8951118,
    longitude: -77.0363658,
    icao: ""
  },
  ZSA: {
    iata: "ZSA",
    name: "San Salvador Airport",
    city: "San Salvador",
    countryId: "BS",
    timeZoneRegionName: "America/Nassau",
    latitude: 24.06,
    longitude: -74.533056,
    icao: "MYSM"
  },
  ZSB: {
    iata: "ZSB",
    countryId: "AT",
    city: "Salzburg",
    icao: "",
    name: "Salzburg Central Station",
    latitude: 47.8131,
    longitude: 13.0467,
    timeZoneRegionName: "Europe/Vienna"
  },
  ZSE: {
    iata: "ZSE",
    name: "Pierrefonds Airport",
    city: "Saint Pierre de la Reunion",
    countryId: "RE",
    timeZoneRegionName: "Indian/Reunion",
    latitude: -21.320944,
    longitude: 55.426878,
    icao: "FMEP"
  },
  ZSF: {
    iata: "ZSF",
    name: "Springfield Railway Station",
    city: "Zhanggang",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 25.93123,
    longitude: 119.66923,
    icao: ""
  },
  ZSJ: {
    iata: "ZSJ",
    name: "Sandy Lake Airport",
    city: "Sandy Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 53.033333,
    longitude: -93.233333,
    icao: "CZSJ"
  },
  ZSS: {
    iata: "ZSS",
    name: "Sassandra Airport",
    city: "Sassandra",
    countryId: "CI",
    timeZoneRegionName: "Africa/Abidjan",
    latitude: 4.924444,
    longitude: -6.135556,
    icao: "DISS"
  },
  ZST: {
    iata: "ZST",
    name: "Stewart Airport",
    city: "Stewart",
    countryId: "CA",
    timeZoneRegionName: "America/Vancouver",
    latitude: 55.933333,
    longitude: -129.983333,
    icao: "CZST"
  },
  ZTA: {
    iata: "ZTA",
    name: "Tureira Airport",
    city: "Tureira",
    countryId: "PF",
    timeZoneRegionName: "Pacific/Tahiti",
    latitude: -20.78342,
    longitude: -138.567728,
    icao: "NTGY"
  },
  ZTB: {
    iata: "ZTB",
    name: "Tete-a-la Baleine Airport",
    city: "Tete-A-La Baleine",
    countryId: "CA",
    timeZoneRegionName: "America/Blanc-Sablon",
    latitude: 50.716667,
    longitude: -59.333333,
    icao: ""
  },
  ZTD: {
    iata: "ZTD",
    name: "Schenectady Railway",
    city: "Schenectady",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.8142432,
    longitude: -73.9395687,
    icao: ""
  },
  ZTE: {
    iata: "ZTE",
    name: "Rochester NY Railway",
    city: "Rochester",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 43.161,
    longitude: -77.611,
    icao: ""
  },
  ZTF: {
    iata: "ZTF",
    name: "Stamford Railway Station",
    city: "Stamford",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 52.6478488,
    longitude: -0.4802146,
    icao: ""
  },
  ZTH: {
    iata: "ZTH",
    name: "Zakinthos Airport",
    city: "Zakinthos",
    countryId: "GR",
    timeZoneRegionName: "Europe/Athens",
    latitude: 37.753505,
    longitude: 20.884711,
    icao: "LGZA"
  },
  ZTJ: {
    iata: "ZTJ",
    name: "Princeton JT Railway",
    city: "Princeton",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.3487181,
    longitude: -74.6590472,
    icao: ""
  },
  ZTM: {
    iata: "ZTM",
    name: "Shamattawa Airport",
    city: "Shamattawa",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 55.858506,
    longitude: -92.080354,
    icao: "CZTM"
  },
  ZTO: {
    iata: "ZTO",
    name: "Boston South Railway",
    city: "Boston",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.3584308,
    longitude: -71.0597732,
    icao: ""
  },
  ZTU: {
    iata: "ZTU",
    name: "Zaqatala Airport",
    city: "Zaqatala",
    countryId: "AZ",
    timeZoneRegionName: "Asia/Baku",
    latitude: 41.56166,
    longitude: 46.664789,
    icao: "UBBY"
  },
  ZTY: {
    iata: "ZTY",
    name: "Boston BKBAY Railway",
    city: "Boston",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.3584308,
    longitude: -71.0597732,
    icao: ""
  },
  ZUA: {
    iata: "ZUA",
    name: "Utica N Railway",
    city: "Gar",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 32.103817,
    longitude: 80.054276,
    icao: ""
  },
  ZUC: {
    iata: "ZUC",
    name: "Ignace Municipal Airport",
    city: "Ignace",
    countryId: "CA",
    timeZoneRegionName: "America/Winnipeg",
    latitude: 49.429699,
    longitude: -91.717796,
    icao: "CZUC"
  },
  ZUD: {
    iata: "ZUD",
    name: "Ancud Airport",
    city: "Ancud",
    countryId: "CL",
    timeZoneRegionName: "America/Santiago",
    latitude: -41.904251,
    longitude: -73.796571,
    icao: "SCAC"
  },
  ZUG: {
    iata: "ZUG",
    name: "Harrisburg Railway",
    city: "Harrisburg",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.2731911,
    longitude: -76.8867008,
    icao: ""
  },
  ZUH: {
    iata: "ZUH",
    name: "Zhuhai Jinwan Airport",
    city: "Zhuhai",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 22.011788,
    longitude: 113.370601,
    icao: "ZGSD"
  },
  ZUL: {
    iata: "ZUL",
    name: "Zilfi Airport",
    city: "Zilfi",
    countryId: "SA",
    timeZoneRegionName: "Asia/Riyadh",
    latitude: 26.25,
    longitude: 44.833333,
    icao: "OEZL"
  },
  ZUM: {
    iata: "ZUM",
    name: "Churchill Falls Airport",
    city: "Churchill Falls",
    countryId: "CA",
    timeZoneRegionName: "America/Halifax",
    latitude: 53.562778,
    longitude: -64.109167,
    icao: "CZUM"
  },
  ZVA: {
    iata: "ZVA",
    name: "Miandrivazo Airport",
    city: "Miandrivazo",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -19.5,
    longitude: 45.466667,
    icao: "FMMN"
  },
  ZVE: {
    iata: "ZVE",
    name: "New Haven Railway",
    city: "New Haven",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 41.3081527,
    longitude: -72.9281577,
    icao: ""
  },
  ZVJ: {
    iata: "ZVJ",
    name: "Abu Dhabi EK Bus Station",
    city: "Abu Dhabi",
    countryId: "AE",
    timeZoneRegionName: "Asia/Dubai",
    latitude: 24.4764,
    longitude: 54.3459,
    icao: ""
  },
  ZVK: {
    iata: "ZVK",
    name: "Savannakhet Airport",
    city: "Savannakhet",
    countryId: "LA",
    timeZoneRegionName: "Asia/Vientiane",
    latitude: 16.553611,
    longitude: 104.7625,
    icao: "VLSK"
  },
  ZVM: {
    iata: "ZVM",
    name: "Messe-BF Railway Servi",
    city: "Messe-BF",
    countryId: "DE",
    timeZoneRegionName: "Europe/Berlin",
    latitude: 52.3720683,
    longitude: 9.7356861,
    icao: ""
  },
  ZVR: {
    iata: "ZVR",
    countryId: "DE",
    city: "Hannover",
    icao: "",
    name: "Hannover Main railway station",
    latitude: 52.3775,
    longitude: 9.7415,
    timeZoneRegionName: "Europe/Paris"
  },
  ZWA: {
    iata: "ZWA",
    name: "Andapa Airport",
    city: "Andapa",
    countryId: "MG",
    timeZoneRegionName: "Indian/Antananarivo",
    latitude: -14.65,
    longitude: 49.616667,
    icao: "FMND"
  },
  ZWC: {
    iata: "ZWC",
    name: "Stavanger Railway Station",
    city: "Qiemo",
    countryId: "NO",
    timeZoneRegionName: "Europe/Oslo",
    latitude: 38.13333,
    longitude: 85.53333,
    icao: ""
  },
  ZWE: {
    iata: "ZWE",
    name: "Antwerp Central Railway Station",
    city: "Mauschbach",
    countryId: "BE",
    timeZoneRegionName: "Europe/Brussels",
    latitude: 49.21516,
    longitude: 7.399708,
    icao: ""
  },
  ZWI: {
    iata: "ZWI",
    name: "Wilmington Railway",
    city: "Mulsen",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 50.730556,
    longitude: 12.544444,
    icao: ""
  },
  ZWL: {
    iata: "ZWL",
    name: "Wollaston Lake Airport",
    city: "Wollaston Lake",
    countryId: "CA",
    timeZoneRegionName: "America/Regina",
    latitude: 58.106931,
    longitude: -103.172471,
    icao: "CZWL"
  },
  ZWS: {
    iata: "ZWS",
    name: "Stuttgart Central Station",
    city: "Stuttgart",
    countryId: "DE",
    timeZoneRegionName: "Europe/Paris",
    latitude: 48.7846,
    longitude: 9.1823,
    icao: ""
  },
  ZWU: {
    iata: "ZWU",
    name: "Washington Union Railway Station",
    city: "Washington, D.C.",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 38.8951118,
    longitude: -77.0363658,
    icao: ""
  },
  ZXA: {
    iata: "ZXA",
    name: "Aberdeen Railway Station",
    city: "Aberdeen",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 57.1474915,
    longitude: -2.095397,
    icao: ""
  },
  ZXE: {
    iata: "ZXE",
    name: "Waverley Railway Station",
    city: "Edinburgh",
    countryId: "GB",
    timeZoneRegionName: "Europe/London",
    latitude: 55.9501755,
    longitude: -3.1875359,
    icao: ""
  },
  ZXS: {
    iata: "ZXS",
    name: "Exchangest Railway",
    city: "Buffalo",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 42.8864468,
    longitude: -78.8783689,
    icao: ""
  },
  ZYA: {
    iata: "ZYA",
    name: "Amsterdam Centraal Railway Station",
    city: "Amsterdam",
    countryId: "NL",
    timeZoneRegionName: "Europe/Amsterdam",
    latitude: 52.3730556,
    longitude: 4.8922222,
    icao: ""
  },
  ZYI: {
    iata: "ZYI",
    name: "Zunyi Xinzhou Airport",
    city: "Zunyi",
    countryId: "CN",
    timeZoneRegionName: "Asia/Shanghai",
    latitude: 27.589673,
    longitude: 106.999823,
    icao: "ZUZY"
  },
  ZYL: {
    iata: "ZYL",
    name: "Osmani International Airport",
    city: "Sylhet",
    countryId: "BD",
    timeZoneRegionName: "Asia/Dhaka",
    latitude: 24.9632,
    longitude: 91.866798,
    icao: "VGSY"
  },
  ZYN: {
    iata: "ZYN",
    name: "Railway",
    city: "Nimes",
    countryId: "FR",
    timeZoneRegionName: "Europe/Paris",
    latitude: 43.836699,
    longitude: 4.360054,
    icao: ""
  },
  ZYP: {
    iata: "ZYP",
    name: "Penn Railway Station",
    city: "New York City",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 40.7143528,
    longitude: -74.0059731,
    icao: ""
  },
  ZYQ: {
    iata: "ZYQ",
    name: "Syracuse Railway",
    city: "Syracuse",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 43.0481221,
    longitude: -76.1474244,
    icao: ""
  },
  ZYR: {
    iata: "ZYR",
    name: "Brussels-South railway station",
    city: "Brussels",
    countryId: "BE",
    timeZoneRegionName: "Europe/Brussels",
    latitude: 50.4592,
    longitude: 4.4538,
    icao: ""
  },
  ZYZ: {
    iata: "ZYZ",
    name: "Berchem Railway",
    city: "Antwerpen",
    countryId: "BE",
    timeZoneRegionName: "Europe/Brussels",
    latitude: 51.21992,
    longitude: 4.39625,
    icao: ""
  },
  ZZO: {
    iata: "ZZO",
    name: "Zonalnoye Airport",
    city: "Tymovskoye",
    countryId: "RU",
    timeZoneRegionName: "Asia/Sakhalin",
    latitude: 50.666668,
    longitude: 142.75,
    icao: "UHSO"
  },
  ZZU: {
    iata: "ZZU",
    name: "Mzuzu Airport",
    city: "Mzuzu",
    countryId: "MW",
    timeZoneRegionName: "Africa/Blantyre",
    latitude: -11.442778,
    longitude: 34.012778,
    icao: "FWUU"
  },
  ZZV: {
    iata: "ZZV",
    name: "Zanesville Municipal Airport",
    city: "Zanesville",
    countryId: "US",
    timeZoneRegionName: "America/New_York",
    latitude: 39.947413,
    longitude: -82.890474,
    icao: "KZZV"
  }
};
function getAirport(iata) {
  return airports[iata];
}
__name(getAirport, "getAirport");
function getRandomAirport() {
  const airportsArray = Object.values(airports);
  return airportsArray[Math.floor(Math.random() * (airportsArray.length - 1))];
}
__name(getRandomAirport, "getRandomAirport");
function getAirportOrThrow(iata) {
  const airport = getAirport(iata);
  if (airport === void 0) {
    throw new Error(`Airport ${iata} not found`);
  }
  return airport;
}
__name(getAirportOrThrow, "getAirportOrThrow");
function getAllAirports() {
  return airports;
}
__name(getAllAirports, "getAllAirports");
function findAirportBy(query, keys = [
  "name"
]) {
  return Object.values(airports).filter((airport) => Object.values(_.pick(airport, keys)).some((val) => typeof val === "string" && val.toLowerCase().includes(query.toLowerCase())));
}
__name(findAirportBy, "findAirportBy");
export {
  findAirportBy,
  getAirport,
  getAirportOrThrow,
  getAllAirports,
  getRandomAirport
};
//# sourceMappingURL=index.js.map